import * as Y from "react";
import w, { useRef as Q, useCallback as _e, useEffect as he, useState as te, useMemo as q, useLayoutEffect as ai, createContext as Le, useContext as xe, forwardRef as Xa, Fragment as $e, isValidElement as Q4, cloneElement as q4, createElement as oc, useId as je, useReducer as Dn, useSyncExternalStore as X4, createRef as ra, Component as ed } from "react";
import * as Fr from "react-dom";
import td, { createPortal as sc, flushSync as ct, findDOMNode as nd } from "react-dom";
var Fa = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function S1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $o = { exports: {} }, Cr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l2;
function ad() {
  if (l2) return Cr;
  l2 = 1;
  var e = w, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var d, p = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (d in l) a.call(l, d) && !i.hasOwnProperty(d) && (p[d] = l[d]);
    if (s && s.defaultProps) for (d in l = s.defaultProps, l) p[d] === void 0 && (p[d] = l[d]);
    return { $$typeof: t, type: s, key: f, ref: h, props: p, _owner: n.current };
  }
  return Cr.Fragment = r, Cr.jsx = o, Cr.jsxs = o, Cr;
}
var vr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u2;
function rd() {
  return u2 || (u2 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = w, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, C = "@@iterator";
    function g(T) {
      if (T === null || typeof T != "object")
        return null;
      var J = m && T[m] || T[C];
      return typeof J == "function" ? J : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(T) {
      {
        for (var J = arguments.length, ie = new Array(J > 1 ? J - 1 : 0), ve = 1; ve < J; ve++)
          ie[ve - 1] = arguments[ve];
        y("error", T, ie);
      }
    }
    function y(T, J, ie) {
      {
        var ve = v.ReactDebugCurrentFrame, Ke = ve.getStackAddendum();
        Ke !== "" && (J += "%s", ie = ie.concat([Ke]));
        var Ue = ie.map(function(Be) {
          return String(Be);
        });
        Ue.unshift("Warning: " + J), Function.prototype.apply.call(console[T], console, Ue);
      }
    }
    var x = !1, S = !1, _ = !1, M = !1, I = !1, L;
    L = Symbol.for("react.module.reference");
    function D(T) {
      return !!(typeof T == "string" || typeof T == "function" || T === a || T === i || I || T === n || T === c || T === d || M || T === h || x || S || _ || typeof T == "object" && T !== null && (T.$$typeof === f || T.$$typeof === p || T.$$typeof === o || T.$$typeof === s || T.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      T.$$typeof === L || T.getModuleId !== void 0));
    }
    function A(T, J, ie) {
      var ve = T.displayName;
      if (ve)
        return ve;
      var Ke = J.displayName || J.name || "";
      return Ke !== "" ? ie + "(" + Ke + ")" : ie;
    }
    function B(T) {
      return T.displayName || "Context";
    }
    function U(T) {
      if (T == null)
        return null;
      if (typeof T.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof T == "function")
        return T.displayName || T.name || null;
      if (typeof T == "string")
        return T;
      switch (T) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case n:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case s:
            var J = T;
            return B(J) + ".Consumer";
          case o:
            var ie = T;
            return B(ie._context) + ".Provider";
          case l:
            return A(T, T.render, "ForwardRef");
          case p:
            var ve = T.displayName || null;
            return ve !== null ? ve : U(T.type) || "Memo";
          case f: {
            var Ke = T, Ue = Ke._payload, Be = Ke._init;
            try {
              return U(Be(Ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, K = 0, Z, V, O, j, N, E, G;
    function R() {
    }
    R.__reactDisabledLog = !0;
    function $() {
      {
        if (K === 0) {
          Z = console.log, V = console.info, O = console.warn, j = console.error, N = console.group, E = console.groupCollapsed, G = console.groupEnd;
          var T = {
            configurable: !0,
            enumerable: !0,
            value: R,
            writable: !0
          };
          Object.defineProperties(console, {
            info: T,
            log: T,
            warn: T,
            error: T,
            group: T,
            groupCollapsed: T,
            groupEnd: T
          });
        }
        K++;
      }
    }
    function W() {
      {
        if (K--, K === 0) {
          var T = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, T, {
              value: Z
            }),
            info: H({}, T, {
              value: V
            }),
            warn: H({}, T, {
              value: O
            }),
            error: H({}, T, {
              value: j
            }),
            group: H({}, T, {
              value: N
            }),
            groupCollapsed: H({}, T, {
              value: E
            }),
            groupEnd: H({}, T, {
              value: G
            })
          });
        }
        K < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var re = v.ReactCurrentDispatcher, ae;
    function de(T, J, ie) {
      {
        if (ae === void 0)
          try {
            throw Error();
          } catch (Ke) {
            var ve = Ke.stack.trim().match(/\n( *(at )?)/);
            ae = ve && ve[1] || "";
          }
        return `
` + ae + T;
      }
    }
    var ge = !1, Je;
    {
      var Se = typeof WeakMap == "function" ? WeakMap : Map;
      Je = new Se();
    }
    function fe(T, J) {
      if (!T || ge)
        return "";
      {
        var ie = Je.get(T);
        if (ie !== void 0)
          return ie;
      }
      var ve;
      ge = !0;
      var Ke = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ue;
      Ue = re.current, re.current = null, $();
      try {
        if (J) {
          var Be = function() {
            throw Error();
          };
          if (Object.defineProperty(Be.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Be, []);
            } catch (Pt) {
              ve = Pt;
            }
            Reflect.construct(T, [], Be);
          } else {
            try {
              Be.call();
            } catch (Pt) {
              ve = Pt;
            }
            T.call(Be.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Pt) {
            ve = Pt;
          }
          T();
        }
      } catch (Pt) {
        if (Pt && ve && typeof Pt.stack == "string") {
          for (var Ie = Pt.stack.split(`
`), xt = ve.stack.split(`
`), it = Ie.length - 1, ut = xt.length - 1; it >= 1 && ut >= 0 && Ie[it] !== xt[ut]; )
            ut--;
          for (; it >= 1 && ut >= 0; it--, ut--)
            if (Ie[it] !== xt[ut]) {
              if (it !== 1 || ut !== 1)
                do
                  if (it--, ut--, ut < 0 || Ie[it] !== xt[ut]) {
                    var Bt = `
` + Ie[it].replace(" at new ", " at ");
                    return T.displayName && Bt.includes("<anonymous>") && (Bt = Bt.replace("<anonymous>", T.displayName)), typeof T == "function" && Je.set(T, Bt), Bt;
                  }
                while (it >= 1 && ut >= 0);
              break;
            }
        }
      } finally {
        ge = !1, re.current = Ue, W(), Error.prepareStackTrace = Ke;
      }
      var Ea = T ? T.displayName || T.name : "", qn = Ea ? de(Ea) : "";
      return typeof T == "function" && Je.set(T, qn), qn;
    }
    function De(T, J, ie) {
      return fe(T, !1);
    }
    function le(T) {
      var J = T.prototype;
      return !!(J && J.isReactComponent);
    }
    function ke(T, J, ie) {
      if (T == null)
        return "";
      if (typeof T == "function")
        return fe(T, le(T));
      if (typeof T == "string")
        return de(T);
      switch (T) {
        case c:
          return de("Suspense");
        case d:
          return de("SuspenseList");
      }
      if (typeof T == "object")
        switch (T.$$typeof) {
          case l:
            return De(T.render);
          case p:
            return ke(T.type, J, ie);
          case f: {
            var ve = T, Ke = ve._payload, Ue = ve._init;
            try {
              return ke(Ue(Ke), J, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var nt = Object.prototype.hasOwnProperty, tn = {}, Qn = v.ReactDebugCurrentFrame;
    function Ma(T) {
      if (T) {
        var J = T._owner, ie = ke(T.type, T._source, J ? J.type : null);
        Qn.setExtraStackFrame(ie);
      } else
        Qn.setExtraStackFrame(null);
    }
    function Sn(T, J, ie, ve, Ke) {
      {
        var Ue = Function.call.bind(nt);
        for (var Be in T)
          if (Ue(T, Be)) {
            var Ie = void 0;
            try {
              if (typeof T[Be] != "function") {
                var xt = Error((ve || "React class") + ": " + ie + " type `" + Be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof T[Be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xt.name = "Invariant Violation", xt;
              }
              Ie = T[Be](J, Be, ve, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (it) {
              Ie = it;
            }
            Ie && !(Ie instanceof Error) && (Ma(Ke), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ve || "React class", ie, Be, typeof Ie), Ma(null)), Ie instanceof Error && !(Ie.message in tn) && (tn[Ie.message] = !0, Ma(Ke), b("Failed %s type: %s", ie, Ie.message), Ma(null));
          }
      }
    }
    var ka = Array.isArray;
    function Pa(T) {
      return ka(T);
    }
    function Pi(T) {
      {
        var J = typeof Symbol == "function" && Symbol.toStringTag, ie = J && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return ie;
      }
    }
    function fr(T) {
      try {
        return hr(T), !1;
      } catch {
        return !0;
      }
    }
    function hr(T) {
      return "" + T;
    }
    function mr(T) {
      if (fr(T))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pi(T)), hr(T);
    }
    var gr = v.ReactCurrentOwner, Ti = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Xl, e2;
    function N4(T) {
      if (nt.call(T, "ref")) {
        var J = Object.getOwnPropertyDescriptor(T, "ref").get;
        if (J && J.isReactWarning)
          return !1;
      }
      return T.ref !== void 0;
    }
    function R4(T) {
      if (nt.call(T, "key")) {
        var J = Object.getOwnPropertyDescriptor(T, "key").get;
        if (J && J.isReactWarning)
          return !1;
      }
      return T.key !== void 0;
    }
    function O4(T, J) {
      typeof T.ref == "string" && gr.current;
    }
    function B4(T, J) {
      {
        var ie = function() {
          Xl || (Xl = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
        };
        ie.isReactWarning = !0, Object.defineProperty(T, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function j4(T, J) {
      {
        var ie = function() {
          e2 || (e2 = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
        };
        ie.isReactWarning = !0, Object.defineProperty(T, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var H4 = function(T, J, ie, ve, Ke, Ue, Be) {
      var Ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: T,
        key: J,
        ref: ie,
        props: Be,
        // Record the component responsible for creating this element.
        _owner: Ue
      };
      return Ie._store = {}, Object.defineProperty(Ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ve
      }), Object.defineProperty(Ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ke
      }), Object.freeze && (Object.freeze(Ie.props), Object.freeze(Ie)), Ie;
    };
    function F4(T, J, ie, ve, Ke) {
      {
        var Ue, Be = {}, Ie = null, xt = null;
        ie !== void 0 && (mr(ie), Ie = "" + ie), R4(J) && (mr(J.key), Ie = "" + J.key), N4(J) && (xt = J.ref, O4(J, Ke));
        for (Ue in J)
          nt.call(J, Ue) && !Ti.hasOwnProperty(Ue) && (Be[Ue] = J[Ue]);
        if (T && T.defaultProps) {
          var it = T.defaultProps;
          for (Ue in it)
            Be[Ue] === void 0 && (Be[Ue] = it[Ue]);
        }
        if (Ie || xt) {
          var ut = typeof T == "function" ? T.displayName || T.name || "Unknown" : T;
          Ie && B4(Be, ut), xt && j4(Be, ut);
        }
        return H4(T, Ie, xt, Ke, ve, gr.current, Be);
      }
    }
    var go = v.ReactCurrentOwner, t2 = v.ReactDebugCurrentFrame;
    function Ta(T) {
      if (T) {
        var J = T._owner, ie = ke(T.type, T._source, J ? J.type : null);
        t2.setExtraStackFrame(ie);
      } else
        t2.setExtraStackFrame(null);
    }
    var Co;
    Co = !1;
    function vo(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function n2() {
      {
        if (go.current) {
          var T = U(go.current.type);
          if (T)
            return `

Check the render method of \`` + T + "`.";
        }
        return "";
      }
    }
    function G4(T) {
      return "";
    }
    var a2 = {};
    function V4(T) {
      {
        var J = n2();
        if (!J) {
          var ie = typeof T == "string" ? T : T.displayName || T.name;
          ie && (J = `

Check the top-level render call using <` + ie + ">.");
        }
        return J;
      }
    }
    function r2(T, J) {
      {
        if (!T._store || T._store.validated || T.key != null)
          return;
        T._store.validated = !0;
        var ie = V4(J);
        if (a2[ie])
          return;
        a2[ie] = !0;
        var ve = "";
        T && T._owner && T._owner !== go.current && (ve = " It was passed a child from " + U(T._owner.type) + "."), Ta(T), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, ve), Ta(null);
      }
    }
    function i2(T, J) {
      {
        if (typeof T != "object")
          return;
        if (Pa(T))
          for (var ie = 0; ie < T.length; ie++) {
            var ve = T[ie];
            vo(ve) && r2(ve, J);
          }
        else if (vo(T))
          T._store && (T._store.validated = !0);
        else if (T) {
          var Ke = g(T);
          if (typeof Ke == "function" && Ke !== T.entries)
            for (var Ue = Ke.call(T), Be; !(Be = Ue.next()).done; )
              vo(Be.value) && r2(Be.value, J);
        }
      }
    }
    function K4(T) {
      {
        var J = T.type;
        if (J == null || typeof J == "string")
          return;
        var ie;
        if (typeof J == "function")
          ie = J.propTypes;
        else if (typeof J == "object" && (J.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        J.$$typeof === p))
          ie = J.propTypes;
        else
          return;
        if (ie) {
          var ve = U(J);
          Sn(ie, T.props, "prop", ve, T);
        } else if (J.PropTypes !== void 0 && !Co) {
          Co = !0;
          var Ke = U(J);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ke || "Unknown");
        }
        typeof J.getDefaultProps == "function" && !J.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function z4(T) {
      {
        for (var J = Object.keys(T.props), ie = 0; ie < J.length; ie++) {
          var ve = J[ie];
          if (ve !== "children" && ve !== "key") {
            Ta(T), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ve), Ta(null);
            break;
          }
        }
        T.ref !== null && (Ta(T), b("Invalid attribute `ref` supplied to `React.Fragment`."), Ta(null));
      }
    }
    var o2 = {};
    function s2(T, J, ie, ve, Ke, Ue) {
      {
        var Be = D(T);
        if (!Be) {
          var Ie = "";
          (T === void 0 || typeof T == "object" && T !== null && Object.keys(T).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xt = G4();
          xt ? Ie += xt : Ie += n2();
          var it;
          T === null ? it = "null" : Pa(T) ? it = "array" : T !== void 0 && T.$$typeof === t ? (it = "<" + (U(T.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : it = typeof T, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", it, Ie);
        }
        var ut = F4(T, J, ie, Ke, Ue);
        if (ut == null)
          return ut;
        if (Be) {
          var Bt = J.children;
          if (Bt !== void 0)
            if (ve)
              if (Pa(Bt)) {
                for (var Ea = 0; Ea < Bt.length; Ea++)
                  i2(Bt[Ea], T);
                Object.freeze && Object.freeze(Bt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              i2(Bt, T);
        }
        if (nt.call(J, "key")) {
          var qn = U(T), Pt = Object.keys(J).filter(function(J4) {
            return J4 !== "key";
          }), bo = Pt.length > 0 ? "{key: someKey, " + Pt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!o2[qn + bo]) {
            var $4 = Pt.length > 0 ? "{" + Pt.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, bo, qn, $4, qn), o2[qn + bo] = !0;
          }
        }
        return T === a ? z4(ut) : K4(ut), ut;
      }
    }
    function U4(T, J, ie) {
      return s2(T, J, ie, !0);
    }
    function Z4(T, J, ie) {
      return s2(T, J, ie, !1);
    }
    var Y4 = Z4, W4 = U4;
    vr.Fragment = a, vr.jsx = Y4, vr.jsxs = W4;
  }()), vr;
}
process.env.NODE_ENV === "production" ? $o.exports = ad() : $o.exports = rd();
var u = $o.exports;
const lc = typeof document < "u" ? w.useLayoutEffect : () => {
};
function id(e) {
  const t = Q(null);
  return lc(() => {
    t.current = e;
  }, [
    e
  ]), _e((...r) => {
    const a = t.current;
    return a == null ? void 0 : a(...r);
  }, []);
}
const ri = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, ta = (e) => e && "window" in e && e.window === e ? e : ri(e).defaultView || window;
function od(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function sd(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function uc(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const ld = uc(function() {
  return sd(/^Mac/i);
}), ud = uc(function() {
  return od(/Android/i);
});
function cd(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : ud() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class dd {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function cc(e) {
  let t = Q({
    isFocused: !1,
    observer: null
  });
  lc(() => {
    const a = t.current;
    return () => {
      a.observer && (a.observer.disconnect(), a.observer = null);
    };
  }, []);
  let r = id((a) => {
    e == null || e(a);
  });
  return _e((a) => {
    if (a.target instanceof HTMLButtonElement || a.target instanceof HTMLInputElement || a.target instanceof HTMLTextAreaElement || a.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let n = a.target, i = (o) => {
        t.current.isFocused = !1, n.disabled && r(new dd("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      n.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && n.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = n === document.activeElement ? null : document.activeElement;
          n.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), n.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(n, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function pd(e) {
  let { isDisabled: t, onFocus: r, onBlur: a, onFocusChange: n } = e;
  const i = _e((l) => {
    if (l.target === l.currentTarget)
      return a && a(l), n && n(!1), !0;
  }, [
    a,
    n
  ]), o = cc(i), s = _e((l) => {
    const c = ri(l.target);
    l.target === l.currentTarget && c.activeElement === l.target && (r && r(l), n && n(!0), o(l));
  }, [
    n,
    r,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || n || a) ? s : void 0,
      onBlur: !t && (a || n) ? i : void 0
    }
  };
}
let ii = null, Jo = /* @__PURE__ */ new Set(), Ir = /* @__PURE__ */ new Map(), ca = !1, Qo = !1;
const fd = {
  Tab: !0,
  Escape: !0
};
function Ns(e, t) {
  for (let r of Jo) r(e, t);
}
function hd(e) {
  return !(e.metaKey || !ld() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Wi(e) {
  ca = !0, hd(e) && (ii = "keyboard", Ns("keyboard", e));
}
function jt(e) {
  ii = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (ca = !0, Ns("pointer", e));
}
function dc(e) {
  cd(e) && (ca = !0, ii = "virtual");
}
function pc(e) {
  e.target === window || e.target === document || (!ca && !Qo && (ii = "virtual", Ns("virtual", e)), ca = !1, Qo = !1);
}
function fc() {
  ca = !1, Qo = !0;
}
function qo(e) {
  if (typeof window > "u" || Ir.get(ta(e))) return;
  const t = ta(e), r = ri(e);
  let a = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    ca = !0, a.apply(this, arguments);
  }, r.addEventListener("keydown", Wi, !0), r.addEventListener("keyup", Wi, !0), r.addEventListener("click", dc, !0), t.addEventListener("focus", pc, !0), t.addEventListener("blur", fc, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", jt, !0), r.addEventListener("pointermove", jt, !0), r.addEventListener("pointerup", jt, !0)) : (r.addEventListener("mousedown", jt, !0), r.addEventListener("mousemove", jt, !0), r.addEventListener("mouseup", jt, !0)), t.addEventListener("beforeunload", () => {
    hc(e);
  }, {
    once: !0
  }), Ir.set(t, {
    focus: a
  });
}
const hc = (e, t) => {
  const r = ta(e), a = ri(e);
  t && a.removeEventListener("DOMContentLoaded", t), Ir.has(r) && (r.HTMLElement.prototype.focus = Ir.get(r).focus, a.removeEventListener("keydown", Wi, !0), a.removeEventListener("keyup", Wi, !0), a.removeEventListener("click", dc, !0), r.removeEventListener("focus", pc, !0), r.removeEventListener("blur", fc, !1), typeof PointerEvent < "u" ? (a.removeEventListener("pointerdown", jt, !0), a.removeEventListener("pointermove", jt, !0), a.removeEventListener("pointerup", jt, !0)) : (a.removeEventListener("mousedown", jt, !0), a.removeEventListener("mousemove", jt, !0), a.removeEventListener("mouseup", jt, !0)), Ir.delete(r));
};
function md(e) {
  const t = ri(e);
  let r;
  return t.readyState !== "loading" ? qo(e) : (r = () => {
    qo(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => hc(e, r);
}
typeof document < "u" && md();
function mc() {
  return ii !== "pointer";
}
const gd = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Cd(e, t, r) {
  var a;
  const n = typeof window < "u" ? ta(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? ta(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? ta(r == null ? void 0 : r.target).HTMLElement : HTMLElement, s = typeof window < "u" ? ta(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || (r == null ? void 0 : r.target) instanceof n && !gd.has(r == null || (a = r.target) === null || a === void 0 ? void 0 : a.type) || (r == null ? void 0 : r.target) instanceof i || (r == null ? void 0 : r.target) instanceof o && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof s && !fd[r.key]);
}
function vd(e, t, r) {
  qo(), he(() => {
    let a = (n, i) => {
      Cd(!!(r != null && r.isTextInput), n, i) && e(mc());
    };
    return Jo.add(a), () => {
      Jo.delete(a);
    };
  }, t);
}
function bd(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: a, onFocusWithinChange: n } = e, i = Q({
    isFocusWithin: !1
  }), o = _e((c) => {
    i.current.isFocusWithin && !c.currentTarget.contains(c.relatedTarget) && (i.current.isFocusWithin = !1, r && r(c), n && n(!1));
  }, [
    r,
    n,
    i
  ]), s = cc(o), l = _e((c) => {
    !i.current.isFocusWithin && document.activeElement === c.target && (a && a(c), n && n(!0), i.current.isFocusWithin = !0, s(c));
  }, [
    a,
    n,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: l,
      onBlur: o
    }
  };
}
let $i = !1, yo = 0;
function Xo() {
  $i = !0, setTimeout(() => {
    $i = !1;
  }, 50);
}
function c2(e) {
  e.pointerType === "touch" && Xo();
}
function yd() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", c2) : document.addEventListener("touchend", Xo), yo++, () => {
      yo--, !(yo > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", c2) : document.removeEventListener("touchend", Xo));
    };
}
function _t(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: a, isDisabled: n } = e, [i, o] = te(!1), s = Q({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  he(yd, []);
  let { hoverProps: l, triggerHoverEnd: c } = q(() => {
    let d = (h, m) => {
      if (s.pointerType = m, n || m === "touch" || s.isHovered || !h.currentTarget.contains(h.target)) return;
      s.isHovered = !0;
      let C = h.currentTarget;
      s.target = C, t && t({
        type: "hoverstart",
        target: C,
        pointerType: m
      }), r && r(!0), o(!0);
    }, p = (h, m) => {
      if (s.pointerType = "", s.target = null, m === "touch" || !s.isHovered) return;
      s.isHovered = !1;
      let C = h.currentTarget;
      a && a({
        type: "hoverend",
        target: C,
        pointerType: m
      }), r && r(!1), o(!1);
    }, f = {};
    return typeof PointerEvent < "u" ? (f.onPointerEnter = (h) => {
      $i && h.pointerType === "mouse" || d(h, h.pointerType);
    }, f.onPointerLeave = (h) => {
      !n && h.currentTarget.contains(h.target) && p(h, h.pointerType);
    }) : (f.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, f.onMouseEnter = (h) => {
      !s.ignoreEmulatedMouseEvents && !$i && d(h, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, f.onMouseLeave = (h) => {
      !n && h.currentTarget.contains(h.target) && p(h, "mouse");
    }), {
      hoverProps: f,
      triggerHoverEnd: p
    };
  }, [
    t,
    r,
    a,
    n,
    s
  ]);
  return he(() => {
    n && c({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    n
  ]), {
    hoverProps: l,
    isHovered: i
  };
}
function bt(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: a } = e, n = Q({
    isFocused: !1,
    isFocusVisible: t || mc()
  }), [i, o] = te(!1), [s, l] = te(() => n.current.isFocused && n.current.isFocusVisible), c = _e(() => l(n.current.isFocused && n.current.isFocusVisible), []), d = _e((h) => {
    n.current.isFocused = h, o(h), c();
  }, [
    c
  ]);
  vd((h) => {
    n.current.isFocusVisible = h, c();
  }, [], {
    isTextInput: r
  });
  let { focusProps: p } = pd({
    isDisabled: a,
    onFocusChange: d
  }), { focusWithinProps: f } = bd({
    isDisabled: !a,
    onFocusWithinChange: d
  });
  return {
    isFocused: i,
    isFocusVisible: s,
    focusProps: a ? f : p
  };
}
var wd = Object.defineProperty, Sd = (e, t, r) => t in e ? wd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, wo = (e, t, r) => (Sd(e, typeof t != "symbol" ? t + "" : t, r), r);
let _d = class {
  constructor() {
    wo(this, "current", this.detect()), wo(this, "handoffState", "pending"), wo(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, ia = new _d();
function zt(e) {
  return ia.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function oi(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Rt() {
  let e = [], t = { addEventListener(r, a, n, i) {
    return r.addEventListener(a, n, i), t.add(() => r.removeEventListener(a, n, i));
  }, requestAnimationFrame(...r) {
    let a = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(a));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let a = setTimeout(...r);
    return t.add(() => clearTimeout(a));
  }, microTask(...r) {
    let a = { current: !0 };
    return oi(() => {
      a.current && r[0]();
    }), t.add(() => {
      a.current = !1;
    });
  }, style(r, a, n) {
    let i = r.style.getPropertyValue(a);
    return Object.assign(r.style, { [a]: n }), this.add(() => {
      Object.assign(r.style, { [a]: i });
    });
  }, group(r) {
    let a = Rt();
    return r(a), this.add(() => a.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let a = e.indexOf(r);
      if (a >= 0) for (let n of e.splice(a, 1)) n();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
function Ut() {
  let [e] = te(Rt);
  return he(() => () => e.dispose(), [e]), e;
}
let ye = (e, t) => {
  ia.isServer ? he(e, t) : ai(e, t);
};
function Ct(e) {
  let t = Q(e);
  return ye(() => {
    t.current = e;
  }, [e]), t;
}
let F = function(e) {
  let t = Ct(e);
  return w.useCallback((...r) => t.current(...r), [t]);
};
function xd(e) {
  let t = e.width / 2, r = e.height / 2;
  return { top: e.clientY - r, right: e.clientX + t, bottom: e.clientY + r, left: e.clientX - t };
}
function Md(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function Xt({ disabled: e = !1 } = {}) {
  let t = Q(null), [r, a] = te(!1), n = Ut(), i = F(() => {
    t.current = null, a(!1), n.dispose();
  }), o = F((s) => {
    if (n.dispose(), t.current === null) {
      t.current = s.currentTarget, a(!0);
      {
        let l = zt(s.currentTarget);
        n.addEventListener(l, "pointerup", i, !1), n.addEventListener(l, "pointermove", (c) => {
          if (t.current) {
            let d = xd(c);
            a(Md(d, t.current.getBoundingClientRect()));
          }
        }, !1), n.addEventListener(l, "pointercancel", i, !1);
      }
    }
  });
  return { pressed: r, pressProps: e ? {} : { onPointerDown: o, onPointerUp: i, onClick: i } };
}
let gc = Le(void 0);
function Lt() {
  return xe(gc);
}
function Cc({ value: e, children: t }) {
  return w.createElement(gc.Provider, { value: e }, t);
}
function es(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function Ee(e, t, ...r) {
  if (e in t) {
    let n = t[e];
    return typeof n == "function" ? n(...r) : n;
  }
  let a = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((n) => `"${n}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(a, Ee), a;
}
var pt = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(pt || {}), Hn = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Hn || {});
function me() {
  let e = Pd();
  return _e((t) => kd({ mergeRefs: e, ...t }), [e]);
}
function kd({ ourProps: e, theirProps: t, slot: r, defaultTag: a, features: n, visible: i = !0, name: o, mergeRefs: s }) {
  s = s ?? Td;
  let l = vc(t, e);
  if (i) return Ei(l, r, a, o, s);
  let c = n ?? 0;
  if (c & 2) {
    let { static: d = !1, ...p } = l;
    if (d) return Ei(p, r, a, o, s);
  }
  if (c & 1) {
    let { unmount: d = !0, ...p } = l;
    return Ee(d ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Ei({ ...p, hidden: !0, style: { display: "none" } }, r, a, o, s);
    } });
  }
  return Ei(l, r, a, o, s);
}
function Ei(e, t = {}, r, a, n) {
  let { as: i = r, children: o, refName: s = "ref", ...l } = So(e, ["unmount", "static"]), c = e.ref !== void 0 ? { [s]: e.ref } : {}, d = typeof o == "function" ? o(t) : o;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t)), l["aria-labelledby"] && l["aria-labelledby"] === l.id && (l["aria-labelledby"] = void 0);
  let p = {};
  if (t) {
    let f = !1, h = [];
    for (let [m, C] of Object.entries(t)) typeof C == "boolean" && (f = !0), C === !0 && h.push(m.replace(/([A-Z])/g, (g) => `-${g.toLowerCase()}`));
    if (f) {
      p["data-headlessui-state"] = h.join(" ");
      for (let m of h) p[`data-${m}`] = "";
    }
  }
  if (i === $e && (Object.keys(On(l)).length > 0 || Object.keys(On(p)).length > 0)) if (!Q4(d) || Array.isArray(d) && d.length > 1) {
    if (Object.keys(On(l)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${a} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(On(l)).concat(Object.keys(On(p))).map((f) => `  - ${f}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((f) => `  - ${f}`).join(`
`)].join(`
`));
  } else {
    let f = d.props, h = f == null ? void 0 : f.className, m = typeof h == "function" ? (...v) => es(h(...v), l.className) : es(h, l.className), C = m ? { className: m } : {}, g = vc(d.props, On(So(l, ["ref"])));
    for (let v in p) v in g && delete p[v];
    return q4(d, Object.assign({}, g, p, c, { ref: n(Ed(d), c.ref) }, C));
  }
  return oc(i, Object.assign({}, So(l, ["ref"]), i !== $e && c, i !== $e && p), d);
}
function Pd() {
  let e = Q([]), t = _e((r) => {
    for (let a of e.current) a != null && (typeof a == "function" ? a(r) : a.current = r);
  }, []);
  return (...r) => {
    if (!r.every((a) => a == null)) return e.current = r, t;
  };
}
function Td(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e) r != null && (typeof r == "function" ? r(t) : r.current = t);
  };
}
function vc(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let a of e) for (let n in a) n.startsWith("on") && typeof a[n] == "function" ? (r[n] != null || (r[n] = []), r[n].push(a[n])) : t[n] = a[n];
  if (t.disabled || t["aria-disabled"]) for (let a in r) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(a) && (r[a] = [(n) => {
    var i;
    return (i = n == null ? void 0 : n.preventDefault) == null ? void 0 : i.call(n);
  }]);
  for (let a in r) Object.assign(t, { [a](n, ...i) {
    let o = r[a];
    for (let s of o) {
      if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
      s(n, ...i);
    }
  } });
  return t;
}
function et(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let a of e) for (let n in a) n.startsWith("on") && typeof a[n] == "function" ? (r[n] != null || (r[n] = []), r[n].push(a[n])) : t[n] = a[n];
  for (let a in r) Object.assign(t, { [a](...n) {
    let i = r[a];
    for (let o of i) o == null || o(...n);
  } });
  return t;
}
function pe(e) {
  var t;
  return Object.assign(Xa(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function On(e) {
  let t = Object.assign({}, e);
  for (let r in t) t[r] === void 0 && delete t[r];
  return t;
}
function So(e, t = []) {
  let r = Object.assign({}, e);
  for (let a of t) a in r && delete r[a];
  return r;
}
function Ed(e) {
  return w.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
let Dd = "button";
function Id(e, t) {
  var r;
  let a = Lt(), { disabled: n = a || !1, autoFocus: i = !1, ...o } = e, { isFocusVisible: s, focusProps: l } = bt({ autoFocus: i }), { isHovered: c, hoverProps: d } = _t({ isDisabled: n }), { pressed: p, pressProps: f } = Xt({ disabled: n }), h = et({ ref: t, type: (r = o.type) != null ? r : "button", disabled: n || void 0, autoFocus: i }, l, d, f), m = q(() => ({ disabled: n, hover: c, focus: s, active: p, autofocus: i }), [n, c, s, p, i]);
  return me()({ ourProps: h, theirProps: o, slot: m, defaultTag: Dd, name: "Button" });
}
let bc = pe(Id);
function si(e, t, r) {
  let [a, n] = te(r), i = e !== void 0, o = Q(i), s = Q(!1), l = Q(!1);
  return i && !o.current && !s.current ? (s.current = !0, o.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && o.current && !l.current && (l.current = !0, o.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : a, F((c) => (i || n(c), t == null ? void 0 : t(c)))];
}
function li(e) {
  let [t] = te(e);
  return t;
}
function yc(e = {}, t = null, r = []) {
  for (let [a, n] of Object.entries(e)) Sc(r, wc(t, a), n);
  return r;
}
function wc(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Sc(e, t, r) {
  if (Array.isArray(r)) for (let [a, n] of r.entries()) Sc(e, wc(t, a.toString()), n);
  else r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : yc(r, t, e);
}
function _1(e) {
  var t, r;
  let a = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (a) {
    for (let n of a.elements) if (n !== e && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
      n.click();
      return;
    }
    (r = a.requestSubmit) == null || r.call(a);
  }
}
let Ld = "span";
var $t = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($t || {});
function Ad(e, t) {
  var r;
  let { features: a = 1, ...n } = e, i = { ref: t, "aria-hidden": (a & 2) === 2 ? !0 : (r = n["aria-hidden"]) != null ? r : void 0, hidden: (a & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(a & 4) === 4 && (a & 2) !== 2 && { display: "none" } } };
  return me()({ ourProps: i, theirProps: n, slot: {}, defaultTag: Ld, name: "Hidden" });
}
let Jt = pe(Ad), _c = Le(null);
function Nd(e) {
  let [t, r] = te(null);
  return w.createElement(_c.Provider, { value: { target: t } }, e.children, w.createElement(Jt, { features: $t.Hidden, ref: r }));
}
function Rd({ children: e }) {
  let t = xe(_c);
  if (!t) return w.createElement(w.Fragment, null, e);
  let { target: r } = t;
  return r ? sc(w.createElement(w.Fragment, null, e), r) : null;
}
function ui({ data: e, form: t, disabled: r, onReset: a, overrides: n }) {
  let [i, o] = te(null), s = Ut();
  return he(() => {
    if (a && i) return s.addEventListener(i, "reset", a);
  }, [i, t, a]), w.createElement(Rd, null, w.createElement(Od, { setForm: o, formId: t }), yc(e).map(([l, c]) => w.createElement(Jt, { features: $t.Hidden, ...On({ key: l, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: r, name: l, value: c, ...n }) })));
}
function Od({ setForm: e, formId: t }) {
  return he(() => {
    if (t) {
      let r = document.getElementById(t);
      r && e(r);
    }
  }, [e, t]), t ? null : w.createElement(Jt, { features: $t.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (r) => {
    if (!r) return;
    let a = r.closest("form");
    a && e(a);
  } });
}
let xc = Le(void 0);
function In() {
  return xe(xc);
}
function Bd({ id: e, children: t }) {
  return w.createElement(xc.Provider, { value: e }, t);
}
function bn(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let a = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return a && jd(r) ? !1 : a;
}
function jd(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let Mc = Symbol();
function Rs(e, t = !0) {
  return Object.assign(e, { [Mc]: t });
}
function we(...e) {
  let t = Q(e);
  he(() => {
    t.current = e;
  }, [e]);
  let r = F((a) => {
    for (let n of t.current) n != null && (typeof n == "function" ? n(a) : n.current = a);
  });
  return e.every((a) => a == null || (a == null ? void 0 : a[Mc])) ? void 0 : r;
}
let x1 = Le(null);
x1.displayName = "DescriptionContext";
function kc() {
  let e = xe(x1);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, kc), t;
  }
  return e;
}
function Wn() {
  var e, t;
  return (t = (e = xe(x1)) == null ? void 0 : e.value) != null ? t : void 0;
}
function er() {
  let [e, t] = te([]);
  return [e.length > 0 ? e.join(" ") : void 0, q(() => function(r) {
    let a = F((i) => (t((o) => [...o, i]), () => t((o) => {
      let s = o.slice(), l = s.indexOf(i);
      return l !== -1 && s.splice(l, 1), s;
    }))), n = q(() => ({ register: a, slot: r.slot, name: r.name, props: r.props, value: r.value }), [a, r.slot, r.name, r.props, r.value]);
    return w.createElement(x1.Provider, { value: n }, r.children);
  }, [t])];
}
let Hd = "p";
function Fd(e, t) {
  let r = je(), a = Lt(), { id: n = `headlessui-description-${r}`, ...i } = e, o = kc(), s = we(t);
  ye(() => o.register(n), [n, o.register]);
  let l = a || !1, c = q(() => ({ ...o.slot, disabled: l }), [o.slot, l]), d = { ref: s, ...o.props, id: n };
  return me()({ ourProps: d, theirProps: i, slot: c, defaultTag: Hd, name: o.name || "Description" });
}
let Gd = pe(Fd), ci = Object.assign(Gd, {});
var X = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(X || {});
let M1 = Le(null);
M1.displayName = "LabelContext";
function Os() {
  let e = xe(M1);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Os), t;
  }
  return e;
}
function en(e) {
  var t, r, a;
  let n = (r = (t = xe(M1)) == null ? void 0 : t.value) != null ? r : void 0;
  return ((a = e == null ? void 0 : e.length) != null ? a : 0) > 0 ? [n, ...e].filter(Boolean).join(" ") : n;
}
function Ln({ inherit: e = !1 } = {}) {
  let t = en(), [r, a] = te([]), n = e ? [t, ...r].filter(Boolean) : r;
  return [n.length > 0 ? n.join(" ") : void 0, q(() => function(i) {
    let o = F((l) => (a((c) => [...c, l]), () => a((c) => {
      let d = c.slice(), p = d.indexOf(l);
      return p !== -1 && d.splice(p, 1), d;
    }))), s = q(() => ({ register: o, slot: i.slot, name: i.name, props: i.props, value: i.value }), [o, i.slot, i.name, i.props, i.value]);
    return w.createElement(M1.Provider, { value: s }, i.children);
  }, [a])];
}
let Vd = "label";
function Kd(e, t) {
  var r;
  let a = je(), n = Os(), i = In(), o = Lt(), { id: s = `headlessui-label-${a}`, htmlFor: l = i ?? ((r = n.props) == null ? void 0 : r.htmlFor), passive: c = !1, ...d } = e, p = we(t);
  ye(() => n.register(s), [s, n.register]);
  let f = F((g) => {
    let v = g.currentTarget;
    if (v instanceof HTMLLabelElement && g.preventDefault(), n.props && "onClick" in n.props && typeof n.props.onClick == "function" && n.props.onClick(g), v instanceof HTMLLabelElement) {
      let b = document.getElementById(v.htmlFor);
      if (b) {
        let y = b.getAttribute("disabled");
        if (y === "true" || y === "") return;
        let x = b.getAttribute("aria-disabled");
        if (x === "true" || x === "") return;
        (b instanceof HTMLInputElement && (b.type === "radio" || b.type === "checkbox") || b.role === "radio" || b.role === "checkbox" || b.role === "switch") && b.click(), b.focus({ preventScroll: !0 });
      }
    }
  }), h = o || !1, m = q(() => ({ ...n.slot, disabled: h }), [n.slot, h]), C = { ref: p, ...n.props, id: s, htmlFor: l, onClick: f };
  return c && ("onClick" in C && (delete C.htmlFor, delete C.onClick), "onClick" in d && delete d.onClick), me()({ ourProps: C, theirProps: d, slot: m, defaultTag: l ? Vd : "div", name: n.name || "Label" });
}
let zd = pe(Kd), tr = Object.assign(zd, {}), Ud = "span";
function Zd(e, t) {
  let r = je(), a = In(), n = Lt(), { id: i = a || `headlessui-checkbox-${r}`, disabled: o = n || !1, autoFocus: s = !1, checked: l, defaultChecked: c, onChange: d, name: p, value: f, form: h, indeterminate: m = !1, ...C } = e, g = li(c), [v, b] = si(l, d, g ?? !1), y = en(), x = Wn(), S = Ut(), [_, M] = te(!1), I = F(() => {
    M(!0), b == null || b(!v), S.nextFrame(() => {
      M(!1);
    });
  }), L = F((G) => {
    if (bn(G.currentTarget)) return G.preventDefault();
    G.preventDefault(), I();
  }), D = F((G) => {
    G.key === X.Space ? (G.preventDefault(), I()) : G.key === X.Enter && _1(G.currentTarget);
  }), A = F((G) => G.preventDefault()), { isFocusVisible: B, focusProps: U } = bt({ autoFocus: s }), { isHovered: H, hoverProps: K } = _t({ isDisabled: o }), { pressed: Z, pressProps: V } = Xt({ disabled: o }), O = et({ ref: t, id: i, role: "checkbox", "aria-checked": m ? "mixed" : v ? "true" : "false", "aria-labelledby": y, "aria-describedby": x, "aria-disabled": o ? !0 : void 0, indeterminate: m ? "true" : void 0, tabIndex: o ? void 0 : 0, onKeyUp: o ? void 0 : D, onKeyPress: o ? void 0 : A, onClick: o ? void 0 : L }, U, K, V), j = q(() => ({ checked: v, disabled: o, hover: H, focus: B, active: Z, indeterminate: m, changing: _, autofocus: s }), [v, m, o, H, B, Z, _, s]), N = _e(() => {
    if (g !== void 0) return b == null ? void 0 : b(g);
  }, [b, g]), E = me();
  return w.createElement(w.Fragment, null, p != null && w.createElement(ui, { disabled: o, data: { [p]: f || "on" }, overrides: { type: "checkbox", checked: v }, form: h, onReset: N }), E({ ourProps: O, theirProps: C, slot: j, defaultTag: Ud, name: "Checkbox" }));
}
let Yd = pe(Zd), Pc = Le(() => {
});
function Tc() {
  return xe(Pc);
}
function Bs({ value: e, children: t }) {
  return w.createElement(Pc.Provider, { value: e }, t);
}
function Wd(e, t) {
  let r = Tc();
  return w.createElement(bc, { ref: t, ...et({ onClick: r }, e) });
}
let $d = pe(Wd);
function Da(e, t, r) {
  let a = r.initialDeps ?? [], n;
  return () => {
    var i, o, s, l;
    let c;
    r.key && ((i = r.debug) != null && i.call(r)) && (c = Date.now());
    const d = e();
    if (!(d.length !== a.length || d.some((h, m) => a[m] !== h)))
      return n;
    a = d;
    let f;
    if (r.key && ((o = r.debug) != null && o.call(r)) && (f = Date.now()), n = t(...d), r.key && ((s = r.debug) != null && s.call(r))) {
      const h = Math.round((Date.now() - c) * 100) / 100, m = Math.round((Date.now() - f) * 100) / 100, C = m / 16, g = (v, b) => {
        for (v = String(v); v.length < b; )
          v = " " + v;
        return v;
      };
      console.info(
        `%c⏱ ${g(m, 5)} /${g(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * C, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (l = r == null ? void 0 : r.onChange) == null || l.call(r, n), n;
  };
}
function _o(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Jd = (e, t) => Math.abs(e - t) < 1, Qd = (e, t, r) => {
  let a;
  return function(...n) {
    e.clearTimeout(a), a = e.setTimeout(() => t.apply(this, n), r);
  };
}, qd = (e) => e, Xd = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), r = Math.min(e.endIndex + e.overscan, e.count - 1), a = [];
  for (let n = t; n <= r; n++)
    a.push(n);
  return a;
}, e6 = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  const n = (o) => {
    const { width: s, height: l } = o;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (n(r.getBoundingClientRect()), !a.ResizeObserver)
    return () => {
    };
  const i = new a.ResizeObserver((o) => {
    const s = o[0];
    if (s != null && s.borderBoxSize) {
      const l = s.borderBoxSize[0];
      if (l) {
        n({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    n(r.getBoundingClientRect());
  });
  return i.observe(r, { box: "border-box" }), () => {
    i.unobserve(r);
  };
}, d2 = {
  passive: !0
}, t6 = typeof window > "u" ? !0 : "onscrollend" in window, n6 = (e, t) => {
  const r = e.scrollElement;
  if (!r)
    return;
  const a = e.targetWindow;
  if (!a)
    return;
  let n = 0;
  const i = e.options.useScrollendEvent && t6 ? () => {
  } : Qd(
    a,
    () => {
      t(n, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (c) => () => {
    const { horizontal: d, isRtl: p } = e.options;
    n = d ? r.scrollLeft * (p && -1 || 1) : r.scrollTop, i(), t(n, c);
  }, s = o(!0), l = o(!1);
  return l(), r.addEventListener("scroll", s, d2), r.addEventListener("scrollend", l, d2), () => {
    r.removeEventListener("scroll", s), r.removeEventListener("scrollend", l);
  };
}, a6 = (e, t, r) => {
  if (t != null && t.borderBoxSize) {
    const a = t.borderBoxSize[0];
    if (a)
      return Math.round(
        a[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, r6 = (e, {
  adjustments: t = 0,
  behavior: r
}, a) => {
  var n, i;
  const o = e + t;
  (i = (n = a.scrollElement) == null ? void 0 : n.scrollTo) == null || i.call(n, {
    [a.options.horizontal ? "left" : "top"]: o,
    behavior: r
  });
};
class i6 {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const a = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((n) => {
        n.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var n;
          (n = a()) == null || n.disconnect(), r = null;
        },
        observe: (n) => {
          var i;
          return (i = a()) == null ? void 0 : i.observe(n, { box: "border-box" });
        },
        unobserve: (n) => {
          var i;
          return (i = a()) == null ? void 0 : i.unobserve(n);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([a, n]) => {
        typeof n > "u" && delete r[a];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: qd,
        rangeExtractor: Xd,
        onChange: () => {
        },
        measureElement: a6,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !0,
        ...r
      };
    }, this.notify = (r) => {
      var a, n;
      (n = (a = this.options).onChange) == null || n.call(a, this, r);
    }, this.maybeNotify = Da(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const a = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== a) {
        if (this.cleanup(), !a) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = a, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((n) => {
          this.observer.observe(n);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (n) => {
            this.scrollRect = n, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (n, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < n ? "forward" : "backward" : null, this.scrollOffset = n, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, a) => {
      const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let o = a - 1; o >= 0; o--) {
        const s = r[o];
        if (n.has(s.lane))
          continue;
        const l = i.get(
          s.lane
        );
        if (l == null || s.end > l.end ? i.set(s.lane, s) : s.end < l.end && n.set(s.lane, !0), n.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = Da(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, a, n, i, o) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: a,
        scrollMargin: n,
        getItemKey: i,
        enabled: o
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Da(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: a, scrollMargin: n, getItemKey: i, enabled: o }, s) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let d = l; d < r; d++) {
          const p = i(d), f = this.options.lanes === 1 ? c[d - 1] : this.getFurthestMeasurement(c, d), h = f ? f.end + this.options.gap : a + n, m = s.get(p), C = typeof m == "number" ? m : this.options.estimateSize(d), g = h + C, v = f ? f.lane : d % this.options.lanes;
          c[d] = {
            index: d,
            start: h,
            size: C,
            end: g,
            key: p,
            lane: v
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Da(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (r, a, n) => this.range = r.length > 0 && a > 0 ? o6({
        measurements: r,
        outerSize: a,
        scrollOffset: n
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Da(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, a, n, i) => a === null ? [] : r({
        startIndex: a.startIndex,
        endIndex: a.endIndex,
        overscan: n,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const a = this.options.indexAttribute, n = r.getAttribute(a);
      return n ? parseInt(n, 10) : (console.warn(
        `Missing attribute name '${a}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, a) => {
      const n = this.indexFromElement(r), i = this.measurementsCache[n];
      if (!i)
        return;
      const o = i.key, s = this.elementsCache.get(o);
      s !== r && (s && this.observer.unobserve(s), this.observer.observe(r), this.elementsCache.set(o, r)), r.isConnected && this.resizeItem(n, this.options.measureElement(r, a, this));
    }, this.resizeItem = (r, a) => {
      const n = this.measurementsCache[r];
      if (!n)
        return;
      const i = this.itemSizeCache.get(n.key) ?? n.size, o = a - i;
      o !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(n, o, this) : n.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", o), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(n.index), this.itemSizeCache = new Map(this.itemSizeCache.set(n.key, a)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((a, n) => {
          a.isConnected || (this.observer.unobserve(a), this.elementsCache.delete(n));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = Da(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, a) => {
        const n = [];
        for (let i = 0, o = r.length; i < o; i++) {
          const s = r[i], l = a[s];
          n.push(l);
        }
        return n;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const a = this.getMeasurements();
      if (a.length !== 0)
        return _o(
          a[Ec(
            0,
            a.length - 1,
            (n) => _o(a[n]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, a) => {
      const n = this.getSize(), i = this.getScrollOffset();
      a === "auto" && r >= i + n && (a = "end"), a === "end" && (r -= n);
      const o = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[o] : this.scrollElement[o] : 0) - n;
      return Math.max(Math.min(l, r), 0);
    }, this.getOffsetForIndex = (r, a = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const n = this.measurementsCache[r];
      if (!n)
        return;
      const i = this.getSize(), o = this.getScrollOffset();
      if (a === "auto")
        if (n.end >= o + i - this.options.scrollPaddingEnd)
          a = "end";
        else if (n.start <= o + this.options.scrollPaddingStart)
          a = "start";
        else
          return [o, a];
      const s = n.start - this.options.scrollPaddingStart + (n.size - i) / 2;
      switch (a) {
        case "center":
          return [this.getOffsetForAlignment(s, a), a];
        case "end":
          return [
            this.getOffsetForAlignment(
              n.end + this.options.scrollPaddingEnd,
              a
            ),
            a
          ];
        default:
          return [
            this.getOffsetForAlignment(
              n.start - this.options.scrollPaddingStart,
              a
            ),
            a
          ];
      }
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: a = "start", behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, a), {
        adjustments: void 0,
        behavior: n
      });
    }, this.scrollToIndex = (r, { align: a = "auto", behavior: n } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(r, a);
      if (!i) return;
      const [o, s] = i;
      this._scrollToOffset(o, { adjustments: void 0, behavior: n }), n !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [c] = _o(
            this.getOffsetForIndex(r, s)
          );
          Jd(c, this.getScrollOffset()) || this.scrollToIndex(r, { align: s, behavior: n });
        } else
          this.scrollToIndex(r, { align: s, behavior: n });
      }));
    }, this.scrollBy = (r, { behavior: a } = {}) => {
      this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: a
      });
    }, this.getTotalSize = () => {
      var r;
      const a = this.getMeasurements();
      let n;
      return a.length === 0 ? n = this.options.paddingStart : n = this.options.lanes === 1 ? ((r = a[a.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...a.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        n - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: a,
      behavior: n
    }) => {
      this.options.scrollToFn(r, { behavior: n, adjustments: a }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const Ec = (e, t, r, a) => {
  for (; e <= t; ) {
    const n = (e + t) / 2 | 0, i = r(n);
    if (i < a)
      e = n + 1;
    else if (i > a)
      t = n - 1;
    else
      return n;
  }
  return e > 0 ? e - 1 : 0;
};
function o6({
  measurements: e,
  outerSize: t,
  scrollOffset: r
}) {
  const a = e.length - 1, i = Ec(0, a, (s) => e[s].start, r);
  let o = i;
  for (; o < a && e[o].end < r + t; )
    o++;
  return { startIndex: i, endIndex: o };
}
const p2 = typeof document < "u" ? Y.useLayoutEffect : Y.useEffect;
function s6(e) {
  const t = Y.useReducer(() => ({}), {})[1], r = {
    ...e,
    onChange: (n, i) => {
      var o;
      i ? ct(t) : t(), (o = e.onChange) == null || o.call(e, n, i);
    }
  }, [a] = Y.useState(
    () => new i6(r)
  );
  return a.setOptions(r), p2(() => a._didMount(), []), p2(() => a._willUpdate()), a;
}
function l6(e) {
  return s6({
    observeElementRect: e6,
    observeElementOffset: n6,
    scrollToFn: r6,
    ...e
  });
}
function u6(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function js(e = u6) {
  return _e((t, r) => {
    if (typeof e == "string") {
      let a = e;
      return (t == null ? void 0 : t[a]) === (r == null ? void 0 : r[a]);
    }
    return e(t, r);
  }, [e]);
}
function c6(e) {
  if (e === null) return { width: 0, height: 0 };
  let { width: t, height: r } = e.getBoundingClientRect();
  return { width: t, height: r };
}
function Gr(e, t = !1) {
  let [r, a] = Dn(() => ({}), {}), n = q(() => c6(e), [e, r]);
  return ye(() => {
    if (!e) return;
    let i = new ResizeObserver(a);
    return i.observe(e), () => {
      i.disconnect();
    };
  }, [e]), t ? { width: `${n.width}px`, height: `${n.height}px` } : n;
}
let d6 = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let r = super.get(t);
    return r === void 0 && (r = this.factory(t), this.set(t, r)), r;
  }
};
function Dc(e, t) {
  let r = e(), a = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(n) {
    return a.add(n), () => a.delete(n);
  }, dispatch(n, ...i) {
    let o = t[n].call(r, ...i);
    o && (r = o, a.forEach((s) => s()));
  } };
}
function Ic(e) {
  return X4(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let p6 = new d6(() => Dc(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1) return this;
  let r = this.slice();
  return r.splice(t, 1), r;
} }));
function nr(e, t) {
  let r = p6.get(t), a = je(), n = Ic(r);
  if (ye(() => {
    if (e) return r.dispatch("ADD", a), () => r.dispatch("REMOVE", a);
  }, [r, e]), !e) return !1;
  let i = n.indexOf(a), o = n.length;
  return i === -1 && (i = o, o += 1), i === o - 1;
}
let ts = /* @__PURE__ */ new Map(), Lr = /* @__PURE__ */ new Map();
function f2(e) {
  var t;
  let r = (t = Lr.get(e)) != null ? t : 0;
  return Lr.set(e, r + 1), r !== 0 ? () => h2(e) : (ts.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => h2(e));
}
function h2(e) {
  var t;
  let r = (t = Lr.get(e)) != null ? t : 1;
  if (r === 1 ? Lr.delete(e) : Lr.set(e, r - 1), r !== 1) return;
  let a = ts.get(e);
  a && (a["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", a["aria-hidden"]), e.inert = a.inert, ts.delete(e));
}
function k1(e, { allowed: t, disallowed: r } = {}) {
  let a = nr(e, "inert-others");
  ye(() => {
    var n, i;
    if (!a) return;
    let o = Rt();
    for (let l of (n = r == null ? void 0 : r()) != null ? n : []) l && o.add(f2(l));
    let s = (i = t == null ? void 0 : t()) != null ? i : [];
    for (let l of s) {
      if (!l) continue;
      let c = zt(l);
      if (!c) continue;
      let d = l.parentElement;
      for (; d && d !== c.body; ) {
        for (let p of d.children) s.some((f) => p.contains(f)) || o.add(f2(p));
        d = d.parentElement;
      }
    }
    return o.dispose;
  }, [a, t, r]);
}
function di(e, t, r) {
  let a = Ct((n) => {
    let i = n.getBoundingClientRect();
    i.x === 0 && i.y === 0 && i.width === 0 && i.height === 0 && r();
  });
  he(() => {
    if (!e) return;
    let n = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!n) return;
    let i = Rt();
    if (typeof ResizeObserver < "u") {
      let o = new ResizeObserver(() => a.current(n));
      o.observe(n), i.add(() => o.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let o = new IntersectionObserver(() => a.current(n));
      o.observe(n), i.add(() => o.disconnect());
    }
    return () => i.dispose();
  }, [t, a, e]);
}
let Ji = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), f6 = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ne = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(Ne || {}), Ht = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Ht || {}), h6 = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(h6 || {});
function pi(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ji)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function m6(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(f6)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var fi = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(fi || {});
function hi(e, t = 0) {
  var r;
  return e === ((r = zt(e)) == null ? void 0 : r.body) ? !1 : Ee(t, { 0() {
    return e.matches(Ji);
  }, 1() {
    let a = e;
    for (; a !== null; ) {
      if (a.matches(Ji)) return !0;
      a = a.parentElement;
    }
    return !1;
  } });
}
function Lc(e) {
  let t = zt(e);
  Rt().nextFrame(() => {
    t && !hi(t.activeElement, 0) && cn(e);
  });
}
var g6 = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(g6 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function cn(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let C6 = ["textarea", "input"].join(",");
function v6(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, C6)) != null ? r : !1;
}
function ln(e, t = (r) => r) {
  return e.slice().sort((r, a) => {
    let n = t(r), i = t(a);
    if (n === null || i === null) return 0;
    let o = n.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ac(e, t) {
  return ot(pi(), t, { relativeTo: e });
}
function ot(e, t, { sorted: r = !0, relativeTo: a = null, skipElements: n = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, o = Array.isArray(e) ? r ? ln(e) : e : t & 64 ? m6(e) : pi(e);
  n.length > 0 && o.length > 1 && (o = o.filter((h) => !n.some((m) => m != null && "current" in m ? (m == null ? void 0 : m.current) === h : m === h))), a = a ?? i.activeElement;
  let s = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, o.indexOf(a)) - 1;
    if (t & 4) return Math.max(0, o.indexOf(a)) + 1;
    if (t & 8) return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = t & 32 ? { preventScroll: !0 } : {}, d = 0, p = o.length, f;
  do {
    if (d >= p || d + p <= 0) return 0;
    let h = l + d;
    if (t & 16) h = (h + p) % p;
    else {
      if (h < 0) return 3;
      if (h >= p) return 1;
    }
    f = o[h], f == null || f.focus(c), d += s;
  } while (f !== i.activeElement);
  return t & 6 && v6(f) && f.select(), 2;
}
function Nc() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function b6() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Rc() {
  return Nc() || b6();
}
function br(e, t, r, a) {
  let n = Ct(r);
  he(() => {
    if (!e) return;
    function i(o) {
      n.current(o);
    }
    return document.addEventListener(t, i, a), () => document.removeEventListener(t, i, a);
  }, [e, t, a]);
}
function Oc(e, t, r, a) {
  let n = Ct(r);
  he(() => {
    if (!e) return;
    function i(o) {
      n.current(o);
    }
    return window.addEventListener(t, i, a), () => window.removeEventListener(t, i, a);
  }, [e, t, a]);
}
const m2 = 30;
function mi(e, t, r) {
  let a = nr(e, "outside-click"), n = Ct(r), i = _e(function(l, c) {
    if (l.defaultPrevented) return;
    let d = c(l);
    if (d === null || !d.getRootNode().contains(d) || !d.isConnected) return;
    let p = function f(h) {
      return typeof h == "function" ? f(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(t);
    for (let f of p) if (f !== null && (f.contains(d) || l.composed && l.composedPath().includes(f))) return;
    return !hi(d, fi.Loose) && d.tabIndex !== -1 && l.preventDefault(), n.current(l, d);
  }, [n, t]), o = Q(null);
  br(a, "pointerdown", (l) => {
    var c, d;
    o.current = ((d = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : d[0]) || l.target;
  }, !0), br(a, "mousedown", (l) => {
    var c, d;
    o.current = ((d = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : d[0]) || l.target;
  }, !0), br(a, "click", (l) => {
    Rc() || o.current && (i(l, () => o.current), o.current = null);
  }, !0);
  let s = Q({ x: 0, y: 0 });
  br(a, "touchstart", (l) => {
    s.current.x = l.touches[0].clientX, s.current.y = l.touches[0].clientY;
  }, !0), br(a, "touchend", (l) => {
    let c = { x: l.changedTouches[0].clientX, y: l.changedTouches[0].clientY };
    if (!(Math.abs(c.x - s.current.x) >= m2 || Math.abs(c.y - s.current.y) >= m2)) return i(l, () => l.target instanceof HTMLElement ? l.target : null);
  }, !0), Oc(a, "blur", (l) => i(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Zt(...e) {
  return q(() => zt(...e), [...e]);
}
function P1(e, t, r, a) {
  let n = Ct(r);
  he(() => {
    e = e ?? window;
    function i(o) {
      n.current(o);
    }
    return e.addEventListener(t, i, a), () => e.removeEventListener(t, i, a);
  }, [e, t, a]);
}
function Bc(e) {
  let t = Q({ value: "", selectionStart: null, selectionEnd: null });
  return P1(e, "blur", (r) => {
    let a = r.target;
    a instanceof HTMLInputElement && (t.current = { value: a.value, selectionStart: a.selectionStart, selectionEnd: a.selectionEnd });
  }), F(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== t.current.value) e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: r, selectionEnd: a } = t.current;
        r !== null && a !== null && e.setSelectionRange(r, a);
      }
      t.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function Ca(e, t) {
  return q(() => {
    var r;
    if (e.type) return e.type;
    let a = (r = e.as) != null ? r : "button";
    if (typeof a == "string" && a.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type")) return "button";
  }, [e.type, e.as, t]);
}
function y6() {
  let e;
  return { before({ doc: t }) {
    var r;
    let a = t.documentElement, n = (r = t.defaultView) != null ? r : window;
    e = Math.max(0, n.innerWidth - a.clientWidth);
  }, after({ doc: t, d: r }) {
    let a = t.documentElement, n = Math.max(0, a.clientWidth - a.offsetWidth), i = Math.max(0, e - n);
    r.style(a, "paddingRight", `${i}px`);
  } };
}
function w6() {
  return Nc() ? { before({ doc: e, d: t, meta: r }) {
    function a(n) {
      return r.containers.flatMap((i) => i()).some((i) => i.contains(n));
    }
    t.microTask(() => {
      var n;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = Rt();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let i = (n = window.scrollY) != null ? n : window.pageYOffset, o = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement) try {
          let l = s.target.closest("a");
          if (!l) return;
          let { hash: c } = new URL(l.href), d = e.querySelector(c);
          d && !a(d) && (o = d);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement) if (a(s.target)) {
          let l = s.target;
          for (; l.parentElement && a(l.parentElement); ) l = l.parentElement;
          t.style(l, "overscrollBehavior", "contain");
        } else t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement) {
          if (s.target.tagName === "INPUT") return;
          if (a(s.target)) {
            let l = s.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); ) l = l.parentElement;
            l.dataset.headlessuiPortal === "" && s.preventDefault();
          } else s.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var s;
        let l = (s = window.scrollY) != null ? s : window.pageYOffset;
        i !== l && window.scrollTo(0, i), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
      });
    });
  } } : {};
}
function S6() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function _6(e) {
  let t = {};
  for (let r of e) Object.assign(t, r(t));
  return t;
}
let na = Dc(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let a = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: Rt(), meta: /* @__PURE__ */ new Set() };
  return a.count++, a.meta.add(t), this.set(e, a), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let a = { doc: e, d: t, meta: _6(r) }, n = [w6(), y6(), S6()];
  n.forEach(({ before: i }) => i == null ? void 0 : i(a)), n.forEach(({ after: i }) => i == null ? void 0 : i(a));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
na.subscribe(() => {
  let e = na.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e) t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let a = t.get(r.doc) === "hidden", n = r.count !== 0;
    (n && !a || !n && a) && na.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && na.dispatch("TEARDOWN", r);
  }
});
function x6(e, t, r = () => ({ containers: [] })) {
  let a = Ic(na), n = t ? a.get(t) : void 0, i = n ? n.count > 0 : !1;
  return ye(() => {
    if (!(!t || !e)) return na.dispatch("PUSH", t, r), () => na.dispatch("POP", t, r);
  }, [e, t]), i;
}
function gi(e, t, r = () => [document.body]) {
  let a = nr(e, "scroll-lock");
  x6(a, t, (n) => {
    var i;
    return { containers: [...(i = n.containers) != null ? i : [], r] };
  });
}
function g2(e) {
  return [e.screenX, e.screenY];
}
function Hs() {
  let e = Q([-1, -1]);
  return { wasMoved(t) {
    let r = g2(t);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(t) {
    e.current = g2(t);
  } };
}
function M6(e = 0) {
  let [t, r] = te(e), a = _e((l) => r(l), [t]), n = _e((l) => r((c) => c | l), [t]), i = _e((l) => (t & l) === l, [t]), o = _e((l) => r((c) => c & ~l), [r]), s = _e((l) => r((c) => c ^ l), [r]);
  return { flags: t, setFlag: a, addFlag: n, hasFlag: i, removeFlag: o, toggleFlag: s };
}
var C2, v2;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((C2 = process == null ? void 0 : process.env) == null ? void 0 : C2.NODE_ENV) === "test" && typeof ((v2 = Element == null ? void 0 : Element.prototype) == null ? void 0 : v2.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var k6 = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(k6 || {});
function va(e) {
  let t = {};
  for (let r in e) e[r] === !0 && (t[`data-${r}`] = "");
  return t;
}
function ba(e, t, r, a) {
  let [n, i] = te(r), { hasFlag: o, addFlag: s, removeFlag: l } = M6(e && n ? 3 : 0), c = Q(!1), d = Q(!1), p = Ut();
  return ye(() => {
    var f;
    if (e) {
      if (r && i(!0), !t) {
        r && s(3);
        return;
      }
      return (f = a == null ? void 0 : a.start) == null || f.call(a, r), P6(t, { inFlight: c, prepare() {
        d.current ? d.current = !1 : d.current = c.current, c.current = !0, !d.current && (r ? (s(3), l(4)) : (s(4), l(2)));
      }, run() {
        d.current ? r ? (l(3), s(4)) : (l(4), s(3)) : r ? l(1) : s(1);
      }, done() {
        var h;
        d.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (c.current = !1, l(7), r || i(!1), (h = a == null ? void 0 : a.end) == null || h.call(a, r));
      } });
    }
  }, [e, r, t, p]), e ? [n, { closed: o(1), enter: o(2), leave: o(4), transition: o(2) || o(4) }] : [r, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function P6(e, { prepare: t, run: r, done: a, inFlight: n }) {
  let i = Rt();
  return E6(e, { prepare: t, inFlight: n }), i.nextFrame(() => {
    r(), i.requestAnimationFrame(() => {
      i.add(T6(e, a));
    });
  }), i.dispose;
}
function T6(e, t) {
  var r, a;
  let n = Rt();
  if (!e) return n.dispose;
  let i = !1;
  n.add(() => {
    i = !0;
  });
  let o = (a = (r = e.getAnimations) == null ? void 0 : r.call(e).filter((s) => s instanceof CSSTransition)) != null ? a : [];
  return o.length === 0 ? (t(), n.dispose) : (Promise.allSettled(o.map((s) => s.finished)).then(() => {
    i || t();
  }), n.dispose);
}
function E6(e, { inFlight: t, prepare: r }) {
  if (t != null && t.current) {
    r();
    return;
  }
  let a = e.style.transition;
  e.style.transition = "none", r(), e.offsetHeight, e.style.transition = a;
}
function jc(e, { container: t, accept: r, walk: a }) {
  let n = Q(r), i = Q(a);
  he(() => {
    n.current = r, i.current = a;
  }, [r, a]), ye(() => {
    if (!t || !e) return;
    let o = zt(t);
    if (!o) return;
    let s = n.current, l = i.current, c = Object.assign((p) => s(p), { acceptNode: s }), d = o.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, c, !1);
    for (; d.nextNode(); ) l(d.currentNode);
  }, [t, e, n, i]);
}
function Vr(e, t) {
  let r = Q([]), a = F(e);
  he(() => {
    let n = [...r.current];
    for (let [i, o] of t.entries()) if (r.current[i] !== o) {
      let s = a(t, n);
      return r.current = t, s;
    }
  }, [a, ...t]);
}
function T1() {
  return typeof window < "u";
}
function ar(e) {
  return Hc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Nt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yn(e) {
  var t;
  return (t = (Hc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Hc(e) {
  return T1() ? e instanceof Node || e instanceof Nt(e).Node : !1;
}
function St(e) {
  return T1() ? e instanceof Element || e instanceof Nt(e).Element : !1;
}
function Cn(e) {
  return T1() ? e instanceof HTMLElement || e instanceof Nt(e).HTMLElement : !1;
}
function b2(e) {
  return !T1() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Nt(e).ShadowRoot;
}
function Ci(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: a,
    display: n
  } = Qt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + r) && !["inline", "contents"].includes(n);
}
function D6(e) {
  return ["table", "td", "th"].includes(ar(e));
}
function E1(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Fs(e) {
  const t = Gs(), r = St(e) ? Qt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((a) => r[a] ? r[a] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((a) => (r.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (r.contain || "").includes(a));
}
function I6(e) {
  let t = Un(e);
  for (; Cn(t) && !Ga(t); ) {
    if (Fs(t))
      return t;
    if (E1(t))
      return null;
    t = Un(t);
  }
  return null;
}
function Gs() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ga(e) {
  return ["html", "body", "#document"].includes(ar(e));
}
function Qt(e) {
  return Nt(e).getComputedStyle(e);
}
function D1(e) {
  return St(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Un(e) {
  if (ar(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    b2(e) && e.host || // Fallback.
    yn(e)
  );
  return b2(t) ? t.host : t;
}
function Fc(e) {
  const t = Un(e);
  return Ga(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Cn(t) && Ci(t) ? t : Fc(t);
}
function Kr(e, t, r) {
  var a;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const n = Fc(e), i = n === ((a = e.ownerDocument) == null ? void 0 : a.body), o = Nt(n);
  if (i) {
    const s = ns(o);
    return t.concat(o, o.visualViewport || [], Ci(n) ? n : [], s && r ? Kr(s) : []);
  }
  return t.concat(n, Kr(n, [], r));
}
function ns(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function L6() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: r,
      version: a
    } = t;
    return r + "/" + a;
  }).join(" ") : navigator.userAgent;
}
const da = Math.min, yt = Math.max, zr = Math.round, Di = Math.floor, dn = (e) => ({
  x: e,
  y: e
}), A6 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, N6 = {
  start: "end",
  end: "start"
};
function y2(e, t, r) {
  return yt(e, da(t, r));
}
function rr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Zn(e) {
  return e.split("-")[0];
}
function vi(e) {
  return e.split("-")[1];
}
function Gc(e) {
  return e === "x" ? "y" : "x";
}
function Vc(e) {
  return e === "y" ? "height" : "width";
}
function pa(e) {
  return ["top", "bottom"].includes(Zn(e)) ? "y" : "x";
}
function Kc(e) {
  return Gc(pa(e));
}
function R6(e, t, r) {
  r === void 0 && (r = !1);
  const a = vi(e), n = Kc(e), i = Vc(n);
  let o = n === "x" ? a === (r ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = Qi(o)), [o, Qi(o)];
}
function O6(e) {
  const t = Qi(e);
  return [as(e), t, as(t)];
}
function as(e) {
  return e.replace(/start|end/g, (t) => N6[t]);
}
function B6(e, t, r) {
  const a = ["left", "right"], n = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? n : a : t ? a : n;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function j6(e, t, r, a) {
  const n = vi(e);
  let i = B6(Zn(e), r === "start", a);
  return n && (i = i.map((o) => o + "-" + n), t && (i = i.concat(i.map(as)))), i;
}
function Qi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => A6[t]);
}
function H6(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function F6(e) {
  return typeof e != "number" ? H6(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function qi(e) {
  const {
    x: t,
    y: r,
    width: a,
    height: n
  } = e;
  return {
    width: a,
    height: n,
    top: r,
    left: t,
    right: t + a,
    bottom: r + n,
    x: t,
    y: r
  };
}
function w2(e, t, r) {
  let {
    reference: a,
    floating: n
  } = e;
  const i = pa(t), o = Kc(t), s = Vc(o), l = Zn(t), c = i === "y", d = a.x + a.width / 2 - n.width / 2, p = a.y + a.height / 2 - n.height / 2, f = a[s] / 2 - n[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: a.y - n.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: a.y + a.height
      };
      break;
    case "right":
      h = {
        x: a.x + a.width,
        y: p
      };
      break;
    case "left":
      h = {
        x: a.x - n.width,
        y: p
      };
      break;
    default:
      h = {
        x: a.x,
        y: a.y
      };
  }
  switch (vi(t)) {
    case "start":
      h[o] -= f * (r && c ? -1 : 1);
      break;
    case "end":
      h[o] += f * (r && c ? -1 : 1);
      break;
  }
  return h;
}
const G6 = async (e, t, r) => {
  const {
    placement: a = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let c = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: d,
    y: p
  } = w2(c, a, l), f = a, h = {}, m = 0;
  for (let C = 0; C < s.length; C++) {
    const {
      name: g,
      fn: v
    } = s[C], {
      x: b,
      y,
      data: x,
      reset: S
    } = await v({
      x: d,
      y: p,
      initialPlacement: a,
      placement: f,
      strategy: n,
      middlewareData: h,
      rects: c,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = b ?? d, p = y ?? p, h = {
      ...h,
      [g]: {
        ...h[g],
        ...x
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : S.rects), {
      x: d,
      y: p
    } = w2(c, f, l)), C = -1);
  }
  return {
    x: d,
    y: p,
    placement: f,
    strategy: n,
    middlewareData: h
  };
};
async function I1(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: a,
    y: n,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: p = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = rr(t, e), m = F6(h), g = s[f ? p === "floating" ? "reference" : "floating" : p], v = qi(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(g))) == null || r ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), b = p === "floating" ? {
    x: a,
    y: n,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), x = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = qi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: y,
    strategy: l
  }) : b);
  return {
    top: (v.top - S.top + m.top) / x.y,
    bottom: (S.bottom - v.bottom + m.bottom) / x.y,
    left: (v.left - S.left + m.left) / x.x,
    right: (S.right - v.right + m.right) / x.x
  };
}
const V6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: n,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: p = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: C = !0,
        ...g
      } = rr(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const v = Zn(n), b = pa(s), y = Zn(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (y || !C ? [Qi(s)] : O6(s)), _ = m !== "none";
      !f && _ && S.push(...j6(s, C, m, x));
      const M = [s, ...S], I = await I1(t, g), L = [];
      let D = ((a = i.flip) == null ? void 0 : a.overflows) || [];
      if (d && L.push(I[v]), p) {
        const H = R6(n, o, x);
        L.push(I[H[0]], I[H[1]]);
      }
      if (D = [...D, {
        placement: n,
        overflows: L
      }], !L.every((H) => H <= 0)) {
        var A, B;
        const H = (((A = i.flip) == null ? void 0 : A.index) || 0) + 1, K = M[H];
        if (K)
          return {
            data: {
              index: H,
              overflows: D
            },
            reset: {
              placement: K
            }
          };
        let Z = (B = D.filter((V) => V.overflows[0] <= 0).sort((V, O) => V.overflows[1] - O.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!Z)
          switch (h) {
            case "bestFit": {
              var U;
              const V = (U = D.filter((O) => {
                if (_) {
                  const j = pa(O.placement);
                  return j === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((j) => j > 0).reduce((j, N) => j + N, 0)]).sort((O, j) => O[1] - j[1])[0]) == null ? void 0 : U[0];
              V && (Z = V);
              break;
            }
            case "initialPlacement":
              Z = s;
              break;
          }
        if (n !== Z)
          return {
            reset: {
              placement: Z
            }
          };
      }
      return {};
    }
  };
};
async function K6(e, t) {
  const {
    placement: r,
    platform: a,
    elements: n
  } = e, i = await (a.isRTL == null ? void 0 : a.isRTL(n.floating)), o = Zn(r), s = vi(r), l = pa(r) === "y", c = ["left", "top"].includes(o) ? -1 : 1, d = i && l ? -1 : 1, p = rr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: p.mainAxis || 0,
    crossAxis: p.crossAxis || 0,
    alignmentAxis: p.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * d,
    y: f * c
  } : {
    x: f * c,
    y: h * d
  };
}
const z6 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, a;
      const {
        x: n,
        y: i,
        placement: o,
        middlewareData: s
      } = t, l = await K6(t, e);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (a = s.arrow) != null && a.alignmentOffset ? {} : {
        x: n + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, U6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: a,
        placement: n
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: v,
              y: b
            } = g;
            return {
              x: v,
              y: b
            };
          }
        },
        ...l
      } = rr(e, t), c = {
        x: r,
        y: a
      }, d = await I1(t, l), p = pa(Zn(n)), f = Gc(p);
      let h = c[f], m = c[p];
      if (i) {
        const g = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", b = h + d[g], y = h - d[v];
        h = y2(b, h, y);
      }
      if (o) {
        const g = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", b = m + d[g], y = m - d[v];
        m = y2(b, m, y);
      }
      const C = s.fn({
        ...t,
        [f]: h,
        [p]: m
      });
      return {
        ...C,
        data: {
          x: C.x - r,
          y: C.y - a,
          enabled: {
            [f]: i,
            [p]: o
          }
        }
      };
    }
  };
}, Z6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: n,
        rects: i,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = rr(e, t), d = await I1(t, c), p = Zn(n), f = vi(n), h = pa(n) === "y", {
        width: m,
        height: C
      } = i.floating;
      let g, v;
      p === "top" || p === "bottom" ? (g = p, v = f === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = p, g = f === "end" ? "top" : "bottom");
      const b = C - d.top - d.bottom, y = m - d.left - d.right, x = da(C - d[g], b), S = da(m - d[v], y), _ = !t.middlewareData.shift;
      let M = x, I = S;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (I = y), (a = t.middlewareData.shift) != null && a.enabled.y && (M = b), _ && !f) {
        const D = yt(d.left, 0), A = yt(d.right, 0), B = yt(d.top, 0), U = yt(d.bottom, 0);
        h ? I = m - 2 * (D !== 0 || A !== 0 ? D + A : yt(d.left, d.right)) : M = C - 2 * (B !== 0 || U !== 0 ? B + U : yt(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: I,
        availableHeight: M
      });
      const L = await o.getDimensions(s.floating);
      return m !== L.width || C !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function zc(e) {
  const t = Qt(e);
  let r = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const n = Cn(e), i = n ? e.offsetWidth : r, o = n ? e.offsetHeight : a, s = zr(r) !== i || zr(a) !== o;
  return s && (r = i, a = o), {
    width: r,
    height: a,
    $: s
  };
}
function Vs(e) {
  return St(e) ? e : e.contextElement;
}
function ja(e) {
  const t = Vs(e);
  if (!Cn(t))
    return dn(1);
  const r = t.getBoundingClientRect(), {
    width: a,
    height: n,
    $: i
  } = zc(t);
  let o = (i ? zr(r.width) : r.width) / a, s = (i ? zr(r.height) : r.height) / n;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const Y6 = /* @__PURE__ */ dn(0);
function Uc(e) {
  const t = Nt(e);
  return !Gs() || !t.visualViewport ? Y6 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function W6(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Nt(e) ? !1 : t;
}
function fa(e, t, r, a) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), i = Vs(e);
  let o = dn(1);
  t && (a ? St(a) && (o = ja(a)) : o = ja(e));
  const s = W6(i, r, a) ? Uc(i) : dn(0);
  let l = (n.left + s.x) / o.x, c = (n.top + s.y) / o.y, d = n.width / o.x, p = n.height / o.y;
  if (i) {
    const f = Nt(i), h = a && St(a) ? Nt(a) : a;
    let m = f, C = ns(m);
    for (; C && a && h !== m; ) {
      const g = ja(C), v = C.getBoundingClientRect(), b = Qt(C), y = v.left + (C.clientLeft + parseFloat(b.paddingLeft)) * g.x, x = v.top + (C.clientTop + parseFloat(b.paddingTop)) * g.y;
      l *= g.x, c *= g.y, d *= g.x, p *= g.y, l += y, c += x, m = Nt(C), C = ns(m);
    }
  }
  return qi({
    width: d,
    height: p,
    x: l,
    y: c
  });
}
function Ks(e, t) {
  const r = D1(e).scrollLeft;
  return t ? t.left + r : fa(yn(e)).left + r;
}
function Zc(e, t, r) {
  r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), n = a.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Ks(e, a)
  )), i = a.top + t.scrollTop;
  return {
    x: n,
    y: i
  };
}
function $6(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: a,
    strategy: n
  } = e;
  const i = n === "fixed", o = yn(a), s = t ? E1(t.floating) : !1;
  if (a === o || s && i)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = dn(1);
  const d = dn(0), p = Cn(a);
  if ((p || !p && !i) && ((ar(a) !== "body" || Ci(o)) && (l = D1(a)), Cn(a))) {
    const h = fa(a);
    c = ja(a), d.x = h.x + a.clientLeft, d.y = h.y + a.clientTop;
  }
  const f = o && !p && !i ? Zc(o, l, !0) : dn(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - l.scrollLeft * c.x + d.x + f.x,
    y: r.y * c.y - l.scrollTop * c.y + d.y + f.y
  };
}
function J6(e) {
  return Array.from(e.getClientRects());
}
function Q6(e) {
  const t = yn(e), r = D1(e), a = e.ownerDocument.body, n = yt(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), i = yt(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let o = -r.scrollLeft + Ks(e);
  const s = -r.scrollTop;
  return Qt(a).direction === "rtl" && (o += yt(t.clientWidth, a.clientWidth) - n), {
    width: n,
    height: i,
    x: o,
    y: s
  };
}
function q6(e, t) {
  const r = Nt(e), a = yn(e), n = r.visualViewport;
  let i = a.clientWidth, o = a.clientHeight, s = 0, l = 0;
  if (n) {
    i = n.width, o = n.height;
    const c = Gs();
    (!c || c && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function X6(e, t) {
  const r = fa(e, !0, t === "fixed"), a = r.top + e.clientTop, n = r.left + e.clientLeft, i = Cn(e) ? ja(e) : dn(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, l = n * i.x, c = a * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function S2(e, t, r) {
  let a;
  if (t === "viewport")
    a = q6(e, r);
  else if (t === "document")
    a = Q6(yn(e));
  else if (St(t))
    a = X6(t, r);
  else {
    const n = Uc(e);
    a = {
      x: t.x - n.x,
      y: t.y - n.y,
      width: t.width,
      height: t.height
    };
  }
  return qi(a);
}
function Yc(e, t) {
  const r = Un(e);
  return r === t || !St(r) || Ga(r) ? !1 : Qt(r).position === "fixed" || Yc(r, t);
}
function e7(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let a = Kr(e, [], !1).filter((s) => St(s) && ar(s) !== "body"), n = null;
  const i = Qt(e).position === "fixed";
  let o = i ? Un(e) : e;
  for (; St(o) && !Ga(o); ) {
    const s = Qt(o), l = Fs(o);
    !l && s.position === "fixed" && (n = null), (i ? !l && !n : !l && s.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || Ci(o) && !l && Yc(e, o)) ? a = a.filter((d) => d !== o) : n = s, o = Un(o);
  }
  return t.set(e, a), a;
}
function t7(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: a,
    strategy: n
  } = e;
  const o = [...r === "clippingAncestors" ? E1(t) ? [] : e7(t, this._c) : [].concat(r), a], s = o[0], l = o.reduce((c, d) => {
    const p = S2(t, d, n);
    return c.top = yt(p.top, c.top), c.right = da(p.right, c.right), c.bottom = da(p.bottom, c.bottom), c.left = yt(p.left, c.left), c;
  }, S2(t, s, n));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function n7(e) {
  const {
    width: t,
    height: r
  } = zc(e);
  return {
    width: t,
    height: r
  };
}
function a7(e, t, r) {
  const a = Cn(t), n = yn(t), i = r === "fixed", o = fa(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = dn(0);
  if (a || !a && !i)
    if ((ar(t) !== "body" || Ci(n)) && (s = D1(t)), a) {
      const f = fa(t, !0, i, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else n && (l.x = Ks(n));
  const c = n && !a && !i ? Zc(n, s) : dn(0), d = o.left + s.scrollLeft - l.x - c.x, p = o.top + s.scrollTop - l.y - c.y;
  return {
    x: d,
    y: p,
    width: o.width,
    height: o.height
  };
}
function xo(e) {
  return Qt(e).position === "static";
}
function _2(e, t) {
  if (!Cn(e) || Qt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return yn(e) === r && (r = r.ownerDocument.body), r;
}
function Wc(e, t) {
  const r = Nt(e);
  if (E1(e))
    return r;
  if (!Cn(e)) {
    let n = Un(e);
    for (; n && !Ga(n); ) {
      if (St(n) && !xo(n))
        return n;
      n = Un(n);
    }
    return r;
  }
  let a = _2(e, t);
  for (; a && D6(a) && xo(a); )
    a = _2(a, t);
  return a && Ga(a) && xo(a) && !Fs(a) ? r : a || I6(e) || r;
}
const r7 = async function(e) {
  const t = this.getOffsetParent || Wc, r = this.getDimensions, a = await r(e.floating);
  return {
    reference: a7(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function i7(e) {
  return Qt(e).direction === "rtl";
}
const o7 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: $6,
  getDocumentElement: yn,
  getClippingRect: t7,
  getOffsetParent: Wc,
  getElementRects: r7,
  getClientRects: J6,
  getDimensions: n7,
  getScale: ja,
  isElement: St,
  isRTL: i7
};
function $c(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function s7(e, t) {
  let r = null, a;
  const n = yn(e);
  function i() {
    var s;
    clearTimeout(a), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: d,
      top: p,
      width: f,
      height: h
    } = c;
    if (s || t(), !f || !h)
      return;
    const m = Di(p), C = Di(n.clientWidth - (d + f)), g = Di(n.clientHeight - (p + h)), v = Di(d), y = {
      rootMargin: -m + "px " + -C + "px " + -g + "px " + -v + "px",
      threshold: yt(0, da(1, l)) || 1
    };
    let x = !0;
    function S(_) {
      const M = _[0].intersectionRatio;
      if (M !== l) {
        if (!x)
          return o();
        M ? o(!1, M) : a = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      M === 1 && !$c(c, e.getBoundingClientRect()) && o(), x = !1;
    }
    try {
      r = new IntersectionObserver(S, {
        ...y,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(S, y);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function l7(e, t, r, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = a, c = Vs(e), d = n || i ? [...c ? Kr(c) : [], ...Kr(t)] : [];
  d.forEach((v) => {
    n && v.addEventListener("scroll", r, {
      passive: !0
    }), i && v.addEventListener("resize", r);
  });
  const p = c && s ? s7(c, r) : null;
  let f = -1, h = null;
  o && (h = new ResizeObserver((v) => {
    let [b] = v;
    b && b.target === c && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = h) == null || y.observe(t);
    })), r();
  }), c && !l && h.observe(c), h.observe(t));
  let m, C = l ? fa(e) : null;
  l && g();
  function g() {
    const v = fa(e);
    C && !$c(C, v) && r(), C = v, m = requestAnimationFrame(g);
  }
  return r(), () => {
    var v;
    d.forEach((b) => {
      n && b.removeEventListener("scroll", r), i && b.removeEventListener("resize", r);
    }), p == null || p(), (v = h) == null || v.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const Mo = I1, u7 = z6, c7 = U6, d7 = V6, p7 = Z6, f7 = (e, t, r) => {
  const a = /* @__PURE__ */ new Map(), n = {
    platform: o7,
    ...r
  }, i = {
    ...n.platform,
    _c: a
  };
  return G6(e, t, {
    ...n,
    platform: i
  });
};
var ji = typeof document < "u" ? ai : he;
function Xi(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, a, n;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (a = r; a-- !== 0; )
        if (!Xi(e[a], t[a]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), r = n.length, r !== Object.keys(t).length)
      return !1;
    for (a = r; a-- !== 0; )
      if (!{}.hasOwnProperty.call(t, n[a]))
        return !1;
    for (a = r; a-- !== 0; ) {
      const i = n[a];
      if (!(i === "_owner" && e.$$typeof) && !Xi(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Jc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function x2(e, t) {
  const r = Jc(e);
  return Math.round(t * r) / r;
}
function ko(e) {
  const t = Y.useRef(e);
  return ji(() => {
    t.current = e;
  }), t;
}
function h7(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: n,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [d, p] = Y.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = Y.useState(a);
  Xi(f, a) || h(a);
  const [m, C] = Y.useState(null), [g, v] = Y.useState(null), b = Y.useCallback((O) => {
    O !== _.current && (_.current = O, C(O));
  }, []), y = Y.useCallback((O) => {
    O !== M.current && (M.current = O, v(O));
  }, []), x = i || m, S = o || g, _ = Y.useRef(null), M = Y.useRef(null), I = Y.useRef(d), L = l != null, D = ko(l), A = ko(n), B = ko(c), U = Y.useCallback(() => {
    if (!_.current || !M.current)
      return;
    const O = {
      placement: t,
      strategy: r,
      middleware: f
    };
    A.current && (O.platform = A.current), f7(_.current, M.current, O).then((j) => {
      const N = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      H.current && !Xi(I.current, N) && (I.current = N, Fr.flushSync(() => {
        p(N);
      }));
    });
  }, [f, t, r, A, B]);
  ji(() => {
    c === !1 && I.current.isPositioned && (I.current.isPositioned = !1, p((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [c]);
  const H = Y.useRef(!1);
  ji(() => (H.current = !0, () => {
    H.current = !1;
  }), []), ji(() => {
    if (x && (_.current = x), S && (M.current = S), x && S) {
      if (D.current)
        return D.current(x, S, U);
      U();
    }
  }, [x, S, U, D, L]);
  const K = Y.useMemo(() => ({
    reference: _,
    floating: M,
    setReference: b,
    setFloating: y
  }), [b, y]), Z = Y.useMemo(() => ({
    reference: x,
    floating: S
  }), [x, S]), V = Y.useMemo(() => {
    const O = {
      position: r,
      left: 0,
      top: 0
    };
    if (!Z.floating)
      return O;
    const j = x2(Z.floating, d.x), N = x2(Z.floating, d.y);
    return s ? {
      ...O,
      transform: "translate(" + j + "px, " + N + "px)",
      ...Jc(Z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: j,
      top: N
    };
  }, [r, s, Z.floating, d.x, d.y]);
  return Y.useMemo(() => ({
    ...d,
    update: U,
    refs: K,
    elements: Z,
    floatingStyles: V
  }), [d, U, K, Z, V]);
}
const Qc = (e, t) => ({
  ...u7(e),
  options: [e, t]
}), m7 = (e, t) => ({
  ...c7(e),
  options: [e, t]
}), g7 = (e, t) => ({
  ...d7(e),
  options: [e, t]
}), C7 = (e, t) => ({
  ...p7(e),
  options: [e, t]
}), qc = {
  ...Y
}, v7 = qc.useInsertionEffect, b7 = v7 || ((e) => e());
function Xc(e) {
  const t = Y.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return b7(() => {
    t.current = e;
  }), Y.useCallback(function() {
    for (var r = arguments.length, a = new Array(r), n = 0; n < r; n++)
      a[n] = arguments[n];
    return t.current == null ? void 0 : t.current(...a);
  }, []);
}
var rs = typeof document < "u" ? ai : he;
let M2 = !1, y7 = 0;
const k2 = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + y7++
);
function w7() {
  const [e, t] = Y.useState(() => M2 ? k2() : void 0);
  return rs(() => {
    e == null && t(k2());
  }, []), Y.useEffect(() => {
    M2 = !0;
  }, []), e;
}
const S7 = qc.useId, _7 = S7 || w7;
let Ur;
process.env.NODE_ENV !== "production" && (Ur = /* @__PURE__ */ new Set());
function x7() {
  for (var e, t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  const n = "Floating UI: " + r.join(" ");
  if (!((e = Ur) != null && e.has(n))) {
    var i;
    (i = Ur) == null || i.add(n), console.warn(n);
  }
}
function M7() {
  for (var e, t = arguments.length, r = new Array(t), a = 0; a < t; a++)
    r[a] = arguments[a];
  const n = "Floating UI: " + r.join(" ");
  if (!((e = Ur) != null && e.has(n))) {
    var i;
    (i = Ur) == null || i.add(n), console.error(n);
  }
}
function k7() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      var a;
      (a = e.get(t)) == null || a.forEach((n) => n(r));
    },
    on(t, r) {
      e.set(t, [...e.get(t) || [], r]);
    },
    off(t, r) {
      var a;
      e.set(t, ((a = e.get(t)) == null ? void 0 : a.filter((n) => n !== r)) || []);
    }
  };
}
const P7 = /* @__PURE__ */ Y.createContext(null), T7 = /* @__PURE__ */ Y.createContext(null), E7 = () => {
  var e;
  return ((e = Y.useContext(P7)) == null ? void 0 : e.id) || null;
}, D7 = () => Y.useContext(T7), I7 = "data-floating-ui-focusable";
function L7(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: a
  } = e, n = _7(), i = Y.useRef({}), [o] = Y.useState(() => k7()), s = E7() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = a.reference;
    h && !St(h) && M7("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = Y.useState(a.reference), d = Xc((h, m, C) => {
    i.current.openEvent = h ? m : void 0, o.emit("openchange", {
      open: h,
      event: m,
      reason: C,
      nested: s
    }), r == null || r(h, m, C);
  }), p = Y.useMemo(() => ({
    setPositionReference: c
  }), []), f = Y.useMemo(() => ({
    reference: l || a.reference || null,
    floating: a.floating || null,
    domReference: a.reference
  }), [l, a.reference, a.floating]);
  return Y.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: d,
    elements: f,
    events: o,
    floatingId: n,
    refs: p
  }), [t, d, f, o, n, p]);
}
function A7(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, r = L7({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), a = e.rootContext || r, n = a.elements, [i, o] = Y.useState(null), [s, l] = Y.useState(null), d = (n == null ? void 0 : n.domReference) || i, p = Y.useRef(null), f = D7();
  rs(() => {
    d && (p.current = d);
  }, [d]);
  const h = h7({
    ...e,
    elements: {
      ...n,
      ...s && {
        reference: s
      }
    }
  }), m = Y.useCallback((y) => {
    const x = St(y) ? {
      getBoundingClientRect: () => y.getBoundingClientRect(),
      contextElement: y
    } : y;
    l(x), h.refs.setReference(x);
  }, [h.refs]), C = Y.useCallback((y) => {
    (St(y) || y === null) && (p.current = y, o(y)), (St(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    y !== null && !St(y)) && h.refs.setReference(y);
  }, [h.refs]), g = Y.useMemo(() => ({
    ...h.refs,
    setReference: C,
    setPositionReference: m,
    domReference: p
  }), [h.refs, C, m]), v = Y.useMemo(() => ({
    ...h.elements,
    domReference: d
  }), [h.elements, d]), b = Y.useMemo(() => ({
    ...h,
    ...a,
    refs: g,
    elements: v,
    nodeId: t
  }), [h, g, v, t, a]);
  return rs(() => {
    a.dataRef.current.floatingContext = b;
    const y = f == null ? void 0 : f.nodesRef.current.find((x) => x.id === t);
    y && (y.context = b);
  }), Y.useMemo(() => ({
    ...h,
    context: b,
    refs: g,
    elements: v
  }), [h, g, v, b]);
}
const P2 = "active", T2 = "selected";
function Po(e, t, r) {
  const a = /* @__PURE__ */ new Map(), n = r === "item";
  let i = e;
  if (n && e) {
    const {
      [P2]: o,
      [T2]: s,
      ...l
    } = e;
    i = l;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1,
      [I7]: ""
    },
    ...i,
    ...t.map((o) => {
      const s = o ? o[r] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((o, s) => (s && Object.entries(s).forEach((l) => {
      let [c, d] = l;
      if (!(n && [P2, T2].includes(c)))
        if (c.indexOf("on") === 0) {
          if (a.has(c) || a.set(c, []), typeof d == "function") {
            var p;
            (p = a.get(c)) == null || p.push(d), o[c] = function() {
              for (var f, h = arguments.length, m = new Array(h), C = 0; C < h; C++)
                m[C] = arguments[C];
              return (f = a.get(c)) == null ? void 0 : f.map((g) => g(...m)).find((g) => g !== void 0);
            };
          }
        } else
          o[c] = d;
    }), o), {})
  };
}
function N7(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), r = e.map((s) => s == null ? void 0 : s.floating), a = e.map((s) => s == null ? void 0 : s.item), n = Y.useCallback(
    (s) => Po(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = Y.useCallback(
    (s) => Po(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  ), o = Y.useCallback(
    (s) => Po(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    a
  );
  return Y.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: i,
    getItemProps: o
  }), [n, i, o]);
}
function E2(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const R7 = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: r,
      overflowRef: a,
      onFallbackChange: n,
      offset: i = 0,
      index: o = 0,
      minItemsVisible: s = 4,
      referenceOverflowThreshold: l = 0,
      scrollRef: c,
      ...d
    } = rr(e, t), {
      rects: p,
      elements: {
        floating: f
      }
    } = t, h = r.current[o], m = (c == null ? void 0 : c.current) || f, C = f.clientTop || m.clientTop, g = f.clientTop !== 0, v = m.clientTop !== 0, b = f === m;
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || x7('`placement` side must be "bottom" when using the `inner`', "middleware.")), !h)
      return {};
    const y = {
      ...t,
      ...await Qc(-h.offsetTop - f.clientTop - p.reference.height / 2 - h.offsetHeight / 2 - i).fn(t)
    }, x = await Mo(E2(y, m.scrollHeight + C + f.clientTop), d), S = await Mo(y, {
      ...d,
      elementContext: "reference"
    }), _ = yt(0, x.top), M = y.y + _, D = (m.scrollHeight > m.clientHeight ? (A) => A : zr)(yt(0, m.scrollHeight + (g && b || v ? C * 2 : 0) - _ - yt(0, x.bottom)));
    if (m.style.maxHeight = D + "px", m.scrollTop = _, n) {
      const A = m.offsetHeight < h.offsetHeight * da(s, r.current.length) - 1 || S.top >= -l || S.bottom >= -l;
      Fr.flushSync(() => n(A));
    }
    return a && (a.current = await Mo(E2({
      ...y,
      y: M
    }, m.offsetHeight + C + f.clientTop), d)), {
      y: M
    };
  }
});
function O7(e, t) {
  const {
    open: r,
    elements: a
  } = e, {
    enabled: n = !0,
    overflowRef: i,
    scrollRef: o,
    onChange: s
  } = t, l = Xc(s), c = Y.useRef(!1), d = Y.useRef(null), p = Y.useRef(null);
  Y.useEffect(() => {
    if (!n) return;
    function h(C) {
      if (C.ctrlKey || !m || i.current == null)
        return;
      const g = C.deltaY, v = i.current.top >= -0.5, b = i.current.bottom >= -0.5, y = m.scrollHeight - m.clientHeight, x = g < 0 ? -1 : 1, S = g < 0 ? "max" : "min";
      m.scrollHeight <= m.clientHeight || (!v && g > 0 || !b && g < 0 ? (C.preventDefault(), Fr.flushSync(() => {
        l((_) => _ + Math[S](g, y * x));
      })) : /firefox/i.test(L6()) && (m.scrollTop += g));
    }
    const m = (o == null ? void 0 : o.current) || a.floating;
    if (r && m)
      return m.addEventListener("wheel", h), requestAnimationFrame(() => {
        d.current = m.scrollTop, i.current != null && (p.current = {
          ...i.current
        });
      }), () => {
        d.current = null, p.current = null, m.removeEventListener("wheel", h);
      };
  }, [n, r, a.floating, i, o, l]);
  const f = Y.useMemo(() => ({
    onKeyDown() {
      c.current = !0;
    },
    onWheel() {
      c.current = !1;
    },
    onPointerMove() {
      c.current = !1;
    },
    onScroll() {
      const h = (o == null ? void 0 : o.current) || a.floating;
      if (!(!i.current || !h || !c.current)) {
        if (d.current !== null) {
          const m = h.scrollTop - d.current;
          (i.current.bottom < -0.5 && m < -1 || i.current.top < -0.5 && m > 1) && Fr.flushSync(() => l((C) => C + m));
        }
        requestAnimationFrame(() => {
          d.current = h.scrollTop;
        });
      }
    }
  }), [a.floating, l, i, o]);
  return Y.useMemo(() => n ? {
    floating: f
  } : {}, [n, f]);
}
let ir = Le({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
ir.displayName = "FloatingContext";
let zs = Le(null);
zs.displayName = "PlacementContext";
function L1(e) {
  return q(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function A1() {
  return xe(ir).setReference;
}
function e3() {
  return xe(ir).getReferenceProps;
}
function N1() {
  let { getFloatingProps: e, slot: t } = xe(ir);
  return _e((...r) => Object.assign({}, e(...r), { "data-anchor": t.anchor }), [e, t]);
}
function R1(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = xe(zs), r = q(() => e, [JSON.stringify(e, (n, i) => {
    var o;
    return (o = i == null ? void 0 : i.outerHTML) != null ? o : i;
  })]);
  ye(() => {
    t == null || t(r ?? null);
  }, [t, r]);
  let a = xe(ir);
  return q(() => [a.setFloating, e ? a.styles : {}], [a.setFloating, e, a.styles]);
}
let D2 = 4;
function O1({ children: e, enabled: t = !0 }) {
  let [r, a] = te(null), [n, i] = te(0), o = Q(null), [s, l] = te(null);
  B7(s);
  let c = t && r !== null && s !== null, { to: d = "bottom", gap: p = 0, offset: f = 0, padding: h = 0, inner: m } = j7(r, s), [C, g = "center"] = d.split(" ");
  ye(() => {
    c && i(0);
  }, [c]);
  let { refs: v, floatingStyles: b, context: y } = A7({ open: c, placement: C === "selection" ? g === "center" ? "bottom" : `bottom-${g}` : g === "center" ? `${C}` : `${C}-${g}`, strategy: "absolute", transform: !1, middleware: [Qc({ mainAxis: C === "selection" ? 0 : p, crossAxis: f }), m7({ padding: h }), C !== "selection" && g7({ padding: h }), C === "selection" && m ? R7({ ...m, padding: h, overflowRef: o, offset: n, minItemsVisible: D2, referenceOverflowThreshold: h, onFallbackChange(A) {
    var B, U;
    if (!A) return;
    let H = y.elements.floating;
    if (!H) return;
    let K = parseFloat(getComputedStyle(H).scrollPaddingBottom) || 0, Z = Math.min(D2, H.childElementCount), V = 0, O = 0;
    for (let j of (U = (B = y.elements.floating) == null ? void 0 : B.childNodes) != null ? U : []) if (j instanceof HTMLElement) {
      let N = j.offsetTop, E = N + j.clientHeight + K, G = H.scrollTop, R = G + H.clientHeight;
      if (N >= G && E <= R) Z--;
      else {
        O = Math.max(0, Math.min(E, R) - Math.max(N, G)), V = j.clientHeight;
        break;
      }
    }
    Z >= 1 && i((j) => {
      let N = V * Z - O + K;
      return j >= N ? j : N;
    });
  } }) : null, C7({ padding: h, apply({ availableWidth: A, availableHeight: B, elements: U }) {
    Object.assign(U.floating.style, { overflow: "auto", maxWidth: `${A}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${B}px)` });
  } })].filter(Boolean), whileElementsMounted: l7 }), [x = C, S = g] = y.placement.split("-");
  C === "selection" && (x = "selection");
  let _ = q(() => ({ anchor: [x, S].filter(Boolean).join(" ") }), [x, S]), M = O7(y, { overflowRef: o, onChange: i }), { getReferenceProps: I, getFloatingProps: L } = N7([M]), D = F((A) => {
    l(A), v.setFloating(A);
  });
  return Y.createElement(zs.Provider, { value: a }, Y.createElement(ir.Provider, { value: { setFloating: D, setReference: v.setReference, styles: b, getReferenceProps: I, getFloatingProps: L, slot: _ } }, e));
}
function B7(e) {
  ye(() => {
    if (!e) return;
    let t = new MutationObserver(() => {
      let r = window.getComputedStyle(e).maxHeight, a = parseFloat(r);
      if (isNaN(a)) return;
      let n = parseInt(r);
      isNaN(n) || a !== n && (e.style.maxHeight = `${Math.ceil(a)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function j7(e, t) {
  var r, a, n;
  let i = To((r = e == null ? void 0 : e.gap) != null ? r : "var(--anchor-gap, 0)", t), o = To((a = e == null ? void 0 : e.offset) != null ? a : "var(--anchor-offset, 0)", t), s = To((n = e == null ? void 0 : e.padding) != null ? n : "var(--anchor-padding, 0)", t);
  return { ...e, gap: i, offset: o, padding: s };
}
function To(e, t, r = void 0) {
  let a = Ut(), n = F((l, c) => {
    if (l == null) return [r, null];
    if (typeof l == "number") return [l, null];
    if (typeof l == "string") {
      if (!c) return [r, null];
      let d = I2(l, c);
      return [d, (p) => {
        let f = t3(l);
        {
          let h = f.map((m) => window.getComputedStyle(c).getPropertyValue(m));
          a.requestAnimationFrame(function m() {
            a.nextFrame(m);
            let C = !1;
            for (let [v, b] of f.entries()) {
              let y = window.getComputedStyle(c).getPropertyValue(b);
              if (h[v] !== y) {
                h[v] = y, C = !0;
                break;
              }
            }
            if (!C) return;
            let g = I2(l, c);
            d !== g && (p(g), d = g);
          });
        }
        return a.dispose;
      }];
    }
    return [r, null];
  }), i = q(() => n(e, t)[0], [e, t]), [o = i, s] = te();
  return ye(() => {
    let [l, c] = n(e, t);
    if (s(l), !!c) return c(s);
  }, [e, t]), o;
}
function t3(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let r = t[1].indexOf(",");
    if (r === -1) return [t[1]];
    let a = t[1].slice(0, r).trim(), n = t[1].slice(r + 1).trim();
    return n ? [a, ...t3(n)] : [a];
  }
  return [];
}
function I2(e, t) {
  let r = document.createElement("div");
  t.appendChild(r), r.style.setProperty("margin-top", "0px", "important"), r.style.setProperty("margin-top", e, "important");
  let a = parseFloat(window.getComputedStyle(r).marginTop) || 0;
  return t.removeChild(r), a;
}
function H7({ children: e, freeze: t }) {
  let r = e1(t, e);
  return w.createElement(w.Fragment, null, r);
}
function e1(e, t) {
  let [r, a] = te(t);
  return !e && r !== t && a(t), e ? r : t;
}
let B1 = Le(null);
B1.displayName = "OpenClosedContext";
var He = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(He || {});
function wn() {
  return xe(B1);
}
function or({ value: e, children: t }) {
  return w.createElement(B1.Provider, { value: e }, t);
}
function Us({ children: e }) {
  return w.createElement(B1.Provider, { value: null }, e);
}
function F7(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let rn = [];
F7(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || rn[0] === t.target) return;
    let r = t.target;
    r = r.closest(Ji), rn.unshift(r ?? t.target), rn = rn.filter((a) => a != null && a.isConnected), rn.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function G7(e) {
  throw new Error("Unexpected object: " + e);
}
var Ce = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Ce || {});
function Vn(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0) return null;
  let a = t.resolveActiveIndex(), n = a ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < r.length; ++i) if (!t.resolveDisabled(r[i], i, r)) return i;
      return a;
    }
    case 1: {
      n === -1 && (n = r.length);
      for (let i = n - 1; i >= 0; --i) if (!t.resolveDisabled(r[i], i, r)) return i;
      return a;
    }
    case 2: {
      for (let i = n + 1; i < r.length; ++i) if (!t.resolveDisabled(r[i], i, r)) return i;
      return a;
    }
    case 3: {
      for (let i = r.length - 1; i >= 0; --i) if (!t.resolveDisabled(r[i], i, r)) return i;
      return a;
    }
    case 4: {
      for (let i = 0; i < r.length; ++i) if (t.resolveId(r[i], i, r) === e.id) return i;
      return a;
    }
    case 5:
      return null;
    default:
      G7(e);
  }
}
var Zs = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(Zs || {});
function n3(e) {
  let t = F(e), r = Q(!1);
  he(() => (r.current = !1, () => {
    r.current = !0, oi(() => {
      r.current && t();
    });
  }), [t]);
}
function V7() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in Y ? ((t) => t.useSyncExternalStore)(Y)(() => () => {
  }, () => !1, () => !e) : !1;
}
function bi() {
  let e = V7(), [t, r] = Y.useState(ia.isHandoffComplete);
  return t && ia.isHandoffComplete === !1 && r(!1), Y.useEffect(() => {
    t !== !0 && r(!0);
  }, [t]), Y.useEffect(() => ia.handoff(), []), e ? !1 : t;
}
let a3 = Le(!1);
function K7() {
  return xe(a3);
}
function L2(e) {
  return w.createElement(a3.Provider, { value: e.force }, e.children);
}
function z7(e) {
  let t = K7(), r = xe(i3), a = Zt(e), [n, i] = te(() => {
    var o;
    if (!t && r !== null) return (o = r.current) != null ? o : null;
    if (ia.isServer) return null;
    let s = a == null ? void 0 : a.getElementById("headlessui-portal-root");
    if (s) return s;
    if (a === null) return null;
    let l = a.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), a.body.appendChild(l);
  });
  return he(() => {
    n !== null && (a != null && a.body.contains(n) || a == null || a.body.appendChild(n));
  }, [n, a]), he(() => {
    t || r !== null && i(r.current);
  }, [r, i, t]), n;
}
let r3 = $e, U7 = pe(function(e, t) {
  let r = e, a = Q(null), n = we(Rs((p) => {
    a.current = p;
  }), t), i = Zt(a), o = z7(a), [s] = te(() => {
    var p;
    return ia.isServer ? null : (p = i == null ? void 0 : i.createElement("div")) != null ? p : null;
  }), l = xe(is), c = bi();
  ye(() => {
    !o || !s || o.contains(s) || (s.setAttribute("data-headlessui-portal", ""), o.appendChild(s));
  }, [o, s]), ye(() => {
    if (s && l) return l.register(s);
  }, [l, s]), n3(() => {
    var p;
    !o || !s || (s instanceof Node && o.contains(s) && o.removeChild(s), o.childNodes.length <= 0 && ((p = o.parentElement) == null || p.removeChild(o)));
  });
  let d = me();
  return c ? !o || !s ? null : sc(d({ ourProps: { ref: n }, theirProps: r, slot: {}, defaultTag: r3, name: "Portal" }), s) : null;
});
function Z7(e, t) {
  let r = we(t), { enabled: a = !0, ...n } = e, i = me();
  return a ? w.createElement(U7, { ...n, ref: r }) : i({ ourProps: { ref: r }, theirProps: n, slot: {}, defaultTag: r3, name: "Portal" });
}
let Y7 = $e, i3 = Le(null);
function W7(e, t) {
  let { target: r, ...a } = e, n = { ref: we(t) }, i = me();
  return w.createElement(i3.Provider, { value: r }, i({ ourProps: n, theirProps: a, defaultTag: Y7, name: "Popover.Group" }));
}
let is = Le(null);
function o3() {
  let e = xe(is), t = Q([]), r = F((i) => (t.current.push(i), e && e.register(i), () => a(i))), a = F((i) => {
    let o = t.current.indexOf(i);
    o !== -1 && t.current.splice(o, 1), e && e.unregister(i);
  }), n = q(() => ({ register: r, unregister: a, portals: t }), [r, a, t]);
  return [t, q(() => function({ children: i }) {
    return w.createElement(is.Provider, { value: n }, i);
  }, [n])];
}
let $7 = pe(Z7), s3 = pe(W7), sr = Object.assign($7, { Group: s3 });
var J7 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(J7 || {}), Q7 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Q7 || {}), q7 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(q7 || {}), X7 = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(X7 || {});
function Eo(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, a = t(e.options.slice()), n = a.length > 0 && a[0].dataRef.current.order !== null ? a.sort((o, s) => o.dataRef.current.order - s.dataRef.current.order) : ln(a, (o) => o.dataRef.current.domRef.current), i = r ? n.indexOf(r) : null;
  return i === -1 && (i = null), { options: n, activeOptionIndex: i };
}
let e8 = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, 0(e) {
  var t, r;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0) return e;
  if ((r = e.dataRef.current) != null && r.value) {
    let a = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (a !== -1) return { ...e, activeOptionIndex: a, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, 3(e, t) {
  return e.isTyping === t.isTyping ? e : { ...e, isTyping: t.isTyping };
}, 2(e, t) {
  var r, a, n, i;
  if ((r = e.dataRef.current) != null && r.disabled || e.optionsElement && !((a = e.dataRef.current) != null && a.optionsPropsRef.current.static) && e.comboboxState === 1) return e;
  if (e.virtual) {
    let { options: c, disabled: d } = e.virtual, p = t.focus === Ce.Specific ? t.idx : Vn(t, { resolveItems: () => c, resolveActiveIndex: () => {
      var h, m;
      return (m = (h = e.activeOptionIndex) != null ? h : c.findIndex((C) => !d(C))) != null ? m : null;
    }, resolveDisabled: d, resolveId() {
      throw new Error("Function not implemented.");
    } }), f = (n = t.trigger) != null ? n : 2;
    return e.activeOptionIndex === p && e.activationTrigger === f ? e : { ...e, activeOptionIndex: p, activationTrigger: f, isTyping: !1, __demoMode: !1 };
  }
  let o = Eo(e);
  if (o.activeOptionIndex === null) {
    let c = o.options.findIndex((d) => !d.dataRef.current.disabled);
    c !== -1 && (o.activeOptionIndex = c);
  }
  let s = t.focus === Ce.Specific ? t.idx : Vn(t, { resolveItems: () => o.options, resolveActiveIndex: () => o.activeOptionIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled }), l = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === s && e.activationTrigger === l ? e : { ...e, ...o, isTyping: !1, activeOptionIndex: s, activationTrigger: l, __demoMode: !1 };
}, 4: (e, t) => {
  var r, a, n;
  if ((r = e.dataRef.current) != null && r.virtual) return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, o = Eo(e, (l) => (l.push(i), l));
  e.activeOptionIndex === null && (a = e.dataRef.current) != null && a.isSelected(t.payload.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(i));
  let s = { ...e, ...o, activationTrigger: 2 };
  return (n = e.dataRef.current) != null && n.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 5: (e, t) => {
  var r;
  if ((r = e.dataRef.current) != null && r.virtual) return { ...e, options: e.options.filter((n) => n.id !== t.id) };
  let a = Eo(e, (n) => {
    let i = n.findIndex((o) => o.id === t.id);
    return i !== -1 && n.splice(i, 1), n;
  });
  return { ...e, ...a, activationTrigger: 2 };
}, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var r, a;
  if (e.virtual === null) return { ...e, virtual: { options: t.options, disabled: (r = t.disabled) != null ? r : () => !1 } };
  if (e.virtual.options === t.options && e.virtual.disabled === t.disabled) return e;
  let n = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let i = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    i !== -1 ? n = i : n = null;
  }
  return { ...e, activeOptionIndex: n, virtual: { options: t.options, disabled: (a = t.disabled) != null ? a : () => !1 } };
}, 8: (e, t) => e.inputElement === t.element ? e : { ...e, inputElement: t.element }, 9: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 10: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, Ys = Le(null);
Ys.displayName = "ComboboxActionsContext";
function yi(e) {
  let t = xe(Ys);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, yi), r;
  }
  return t;
}
let l3 = Le(null);
function t8(e) {
  let t = lr("VirtualProvider"), { options: r } = t.virtual, [a, n] = q(() => {
    let c = t.optionsElement;
    if (!c) return [0, 0];
    let d = window.getComputedStyle(c);
    return [parseFloat(d.paddingBlockStart || d.paddingTop), parseFloat(d.paddingBlockEnd || d.paddingBottom)];
  }, [t.optionsElement]), i = l6({ enabled: r.length !== 0, scrollPaddingStart: a, scrollPaddingEnd: n, count: r.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return t.optionsElement;
  }, overscan: 12 }), [o, s] = te(0);
  ye(() => {
    s((c) => c + 1);
  }, [r]);
  let l = i.getVirtualItems();
  return l.length === 0 ? null : w.createElement(l3.Provider, { value: i }, w.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (c) => {
    c && t.activationTrigger !== 0 && t.activeOptionIndex !== null && r.length > t.activeOptionIndex && i.scrollToIndex(t.activeOptionIndex);
  } }, l.map((c) => {
    var d;
    return w.createElement($e, { key: c.key }, w.cloneElement((d = e.children) == null ? void 0 : d.call(e, { ...e.slot, option: r[c.index] }), { key: `${o}-${c.key}`, "data-index": c.index, "aria-setsize": r.length, "aria-posinset": c.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${c.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Zr = Le(null);
Zr.displayName = "ComboboxDataContext";
function lr(e) {
  let t = xe(Zr);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, lr), r;
  }
  return t;
}
function n8(e, t) {
  return Ee(t.type, e8, e, t);
}
let a8 = $e;
function r8(e, t) {
  var r, a;
  let n = Lt(), { value: i, defaultValue: o, onChange: s, form: l, name: c, by: d, disabled: p = n || !1, onClose: f, __demoMode: h = !1, multiple: m = !1, immediate: C = !1, virtual: g = null, nullable: v, ...b } = e, y = li(o), [x = m ? [] : void 0, S] = si(i, s, y), [_, M] = Dn(n8, { dataRef: ra(), comboboxState: h ? 0 : 1, isTyping: !1, options: [], virtual: g ? { options: g.options, disabled: (r = g.disabled) != null ? r : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: h }), I = Q(!1), L = Q({ static: !1, hold: !1 }), D = js(d), A = F((le) => g ? d === null ? g.options.indexOf(le) : g.options.findIndex((ke) => D(ke, le)) : _.options.findIndex((ke) => D(ke.dataRef.current.value, le))), B = _e((le) => Ee(H.mode, { 1: () => x.some((ke) => D(ke, le)), 0: () => D(x, le) }), [x]), U = F((le) => _.activeOptionIndex === A(le)), H = q(() => ({ ..._, immediate: C, optionsPropsRef: L, value: x, defaultValue: y, disabled: p, mode: m ? 1 : 0, virtual: g ? _.virtual : null, get activeOptionIndex() {
    if (I.current && _.activeOptionIndex === null && (g ? g.options.length > 0 : _.options.length > 0)) {
      if (g) {
        let ke = g.options.findIndex((nt) => {
          var tn, Qn;
          return !((Qn = (tn = g.disabled) == null ? void 0 : tn.call(g, nt)) != null && Qn);
        });
        if (ke !== -1) return ke;
      }
      let le = _.options.findIndex((ke) => !ke.dataRef.current.disabled);
      if (le !== -1) return le;
    }
    return _.activeOptionIndex;
  }, calculateIndex: A, compare: D, isSelected: B, isActive: U }), [x, y, p, m, h, _, g]);
  ye(() => {
    var le;
    g && M({ type: 7, options: g.options, disabled: (le = g.disabled) != null ? le : null });
  }, [g, g == null ? void 0 : g.options, g == null ? void 0 : g.disabled]), ye(() => {
    _.dataRef.current = H;
  }, [H]);
  let K = H.comboboxState === 0;
  mi(K, [H.buttonElement, H.inputElement, H.optionsElement], () => de.closeCombobox());
  let Z = q(() => {
    var le, ke, nt;
    return { open: H.comboboxState === 0, disabled: p, activeIndex: H.activeOptionIndex, activeOption: H.activeOptionIndex === null ? null : H.virtual ? H.virtual.options[(le = H.activeOptionIndex) != null ? le : 0] : (nt = (ke = H.options[H.activeOptionIndex]) == null ? void 0 : ke.dataRef.current.value) != null ? nt : null, value: x };
  }, [H, p, x]), V = F(() => {
    if (H.activeOptionIndex !== null) {
      if (de.setIsTyping(!1), H.virtual) R(H.virtual.options[H.activeOptionIndex]);
      else {
        let { dataRef: le } = H.options[H.activeOptionIndex];
        R(le.current.value);
      }
      de.goToOption(Ce.Specific, H.activeOptionIndex);
    }
  }), O = F(() => {
    M({ type: 0 }), I.current = !0;
  }), j = F(() => {
    M({ type: 1 }), I.current = !1, f == null || f();
  }), N = F((le) => {
    M({ type: 3, isTyping: le });
  }), E = F((le, ke, nt) => (I.current = !1, le === Ce.Specific ? M({ type: 2, focus: Ce.Specific, idx: ke, trigger: nt }) : M({ type: 2, focus: le, trigger: nt }))), G = F((le, ke) => (M({ type: 4, payload: { id: le, dataRef: ke } }), () => {
    H.isActive(ke.current.value) && (I.current = !0), M({ type: 5, id: le });
  })), R = F((le) => Ee(H.mode, { 0() {
    return S == null ? void 0 : S(le);
  }, 1() {
    let ke = H.value.slice(), nt = ke.findIndex((tn) => D(tn, le));
    return nt === -1 ? ke.push(le) : ke.splice(nt, 1), S == null ? void 0 : S(ke);
  } })), $ = F((le) => {
    M({ type: 6, trigger: le });
  }), W = F((le) => {
    M({ type: 8, element: le });
  }), re = F((le) => {
    M({ type: 9, element: le });
  }), ae = F((le) => {
    M({ type: 10, element: le });
  }), de = q(() => ({ onChange: R, registerOption: G, goToOption: E, setIsTyping: N, closeCombobox: j, openCombobox: O, setActivationTrigger: $, selectActiveOption: V, setInputElement: W, setButtonElement: re, setOptionsElement: ae }), []), [ge, Je] = Ln(), Se = t === null ? {} : { ref: t }, fe = _e(() => {
    if (y !== void 0) return S == null ? void 0 : S(y);
  }, [S, y]), De = me();
  return w.createElement(Je, { value: ge, props: { htmlFor: (a = H.inputElement) == null ? void 0 : a.id }, slot: { open: H.comboboxState === 0, disabled: p } }, w.createElement(O1, null, w.createElement(Ys.Provider, { value: de }, w.createElement(Zr.Provider, { value: H }, w.createElement(or, { value: Ee(H.comboboxState, { 0: He.Open, 1: He.Closed }) }, c != null && w.createElement(ui, { disabled: p, data: x != null ? { [c]: x } : {}, form: l, onReset: fe }), De({ ourProps: Se, theirProps: b, slot: Z, defaultTag: a8, name: "Combobox" }))))));
}
let i8 = "input";
function o8(e, t) {
  var r, a, n, i, o;
  let s = lr("Combobox.Input"), l = yi("Combobox.Input"), c = je(), d = In(), { id: p = d || `headlessui-combobox-input-${c}`, onChange: f, displayValue: h, disabled: m = s.disabled || !1, autoFocus: C = !1, type: g = "text", ...v } = e, b = Q(null), y = we(b, t, A1(), l.setInputElement), x = Zt(s.inputElement), S = Ut(), _ = F(() => {
    l.onChange(null), s.optionsElement && (s.optionsElement.scrollTop = 0), l.goToOption(Ce.Nothing);
  }), M = q(() => {
    var R;
    return typeof h == "function" && s.value !== void 0 ? (R = h(s.value)) != null ? R : "" : typeof s.value == "string" ? s.value : "";
  }, [s.value, h]);
  Vr(([R, $], [W, re]) => {
    if (s.isTyping) return;
    let ae = b.current;
    ae && ((re === 0 && $ === 1 || R !== W) && (ae.value = R), requestAnimationFrame(() => {
      if (s.isTyping || !ae || (x == null ? void 0 : x.activeElement) !== ae) return;
      let { selectionStart: de, selectionEnd: ge } = ae;
      Math.abs((ge ?? 0) - (de ?? 0)) === 0 && de === 0 && ae.setSelectionRange(ae.value.length, ae.value.length);
    }));
  }, [M, s.comboboxState, x, s.isTyping]), Vr(([R], [$]) => {
    if (R === 0 && $ === 1) {
      if (s.isTyping) return;
      let W = b.current;
      if (!W) return;
      let re = W.value, { selectionStart: ae, selectionEnd: de, selectionDirection: ge } = W;
      W.value = "", W.value = re, ge !== null ? W.setSelectionRange(ae, de, ge) : W.setSelectionRange(ae, de);
    }
  }, [s.comboboxState]);
  let I = Q(!1), L = F(() => {
    I.current = !0;
  }), D = F(() => {
    S.nextFrame(() => {
      I.current = !1;
    });
  }), A = F((R) => {
    switch (l.setIsTyping(!0), R.key) {
      case X.Enter:
        if (s.comboboxState !== 0 || I.current) return;
        if (R.preventDefault(), R.stopPropagation(), s.activeOptionIndex === null) {
          l.closeCombobox();
          return;
        }
        l.selectActiveOption(), s.mode === 0 && l.closeCombobox();
        break;
      case X.ArrowDown:
        return R.preventDefault(), R.stopPropagation(), Ee(s.comboboxState, { 0: () => l.goToOption(Ce.Next), 1: () => l.openCombobox() });
      case X.ArrowUp:
        return R.preventDefault(), R.stopPropagation(), Ee(s.comboboxState, { 0: () => l.goToOption(Ce.Previous), 1: () => {
          ct(() => l.openCombobox()), s.value || l.goToOption(Ce.Last);
        } });
      case X.Home:
        if (R.shiftKey) break;
        return R.preventDefault(), R.stopPropagation(), l.goToOption(Ce.First);
      case X.PageUp:
        return R.preventDefault(), R.stopPropagation(), l.goToOption(Ce.First);
      case X.End:
        if (R.shiftKey) break;
        return R.preventDefault(), R.stopPropagation(), l.goToOption(Ce.Last);
      case X.PageDown:
        return R.preventDefault(), R.stopPropagation(), l.goToOption(Ce.Last);
      case X.Escape:
        return s.comboboxState !== 0 ? void 0 : (R.preventDefault(), s.optionsElement && !s.optionsPropsRef.current.static && R.stopPropagation(), s.mode === 0 && s.value === null && _(), l.closeCombobox());
      case X.Tab:
        if (s.comboboxState !== 0) return;
        s.mode === 0 && s.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
        break;
    }
  }), B = F((R) => {
    f == null || f(R), s.mode === 0 && R.target.value === "" && _(), l.openCombobox();
  }), U = F((R) => {
    var $, W, re;
    let ae = ($ = R.relatedTarget) != null ? $ : rn.find((de) => de !== R.currentTarget);
    if (!((W = s.optionsElement) != null && W.contains(ae)) && !((re = s.buttonElement) != null && re.contains(ae)) && s.comboboxState === 0) return R.preventDefault(), s.mode === 0 && s.value === null && _(), l.closeCombobox();
  }), H = F((R) => {
    var $, W, re;
    let ae = ($ = R.relatedTarget) != null ? $ : rn.find((de) => de !== R.currentTarget);
    (W = s.buttonElement) != null && W.contains(ae) || (re = s.optionsElement) != null && re.contains(ae) || s.disabled || s.immediate && s.comboboxState !== 0 && S.microTask(() => {
      ct(() => l.openCombobox()), l.setActivationTrigger(1);
    });
  }), K = en(), Z = Wn(), { isFocused: V, focusProps: O } = bt({ autoFocus: C }), { isHovered: j, hoverProps: N } = _t({ isDisabled: m }), E = q(() => ({ open: s.comboboxState === 0, disabled: m, hover: j, focus: V, autofocus: C }), [s, j, V, C, m]), G = et({ ref: y, id: p, role: "combobox", type: g, "aria-controls": (r = s.optionsElement) == null ? void 0 : r.id, "aria-expanded": s.comboboxState === 0, "aria-activedescendant": s.activeOptionIndex === null ? void 0 : s.virtual ? (a = s.options.find((R) => !R.dataRef.current.disabled && s.compare(R.dataRef.current.value, s.virtual.options[s.activeOptionIndex]))) == null ? void 0 : a.id : (n = s.options[s.activeOptionIndex]) == null ? void 0 : n.id, "aria-labelledby": K, "aria-describedby": Z, "aria-autocomplete": "list", defaultValue: (o = (i = e.defaultValue) != null ? i : s.defaultValue !== void 0 ? h == null ? void 0 : h(s.defaultValue) : null) != null ? o : s.defaultValue, disabled: m || void 0, autoFocus: C, onCompositionStart: L, onCompositionEnd: D, onKeyDown: A, onChange: B, onFocus: H, onBlur: U }, O, N);
  return me()({ ourProps: G, theirProps: v, slot: E, defaultTag: i8, name: "Combobox.Input" });
}
let s8 = "button";
function l8(e, t) {
  var r;
  let a = lr("Combobox.Button"), n = yi("Combobox.Button"), i = we(t, n.setButtonElement), o = je(), { id: s = `headlessui-combobox-button-${o}`, disabled: l = a.disabled || !1, autoFocus: c = !1, ...d } = e, p = Bc(a.inputElement), f = F((M) => {
    switch (M.key) {
      case X.Space:
      case X.Enter:
        M.preventDefault(), M.stopPropagation(), a.comboboxState === 1 && ct(() => n.openCombobox()), p();
        return;
      case X.ArrowDown:
        M.preventDefault(), M.stopPropagation(), a.comboboxState === 1 && (ct(() => n.openCombobox()), a.value || n.goToOption(Ce.First)), p();
        return;
      case X.ArrowUp:
        M.preventDefault(), M.stopPropagation(), a.comboboxState === 1 && (ct(() => n.openCombobox()), a.value || n.goToOption(Ce.Last)), p();
        return;
      case X.Escape:
        if (a.comboboxState !== 0) return;
        M.preventDefault(), a.optionsElement && !a.optionsPropsRef.current.static && M.stopPropagation(), ct(() => n.closeCombobox()), p();
        return;
      default:
        return;
    }
  }), h = F((M) => {
    M.preventDefault(), !bn(M.currentTarget) && (M.button === Zs.Left && (a.comboboxState === 0 ? n.closeCombobox() : n.openCombobox()), p());
  }), m = en([s]), { isFocusVisible: C, focusProps: g } = bt({ autoFocus: c }), { isHovered: v, hoverProps: b } = _t({ isDisabled: l }), { pressed: y, pressProps: x } = Xt({ disabled: l }), S = q(() => ({ open: a.comboboxState === 0, active: y || a.comboboxState === 0, disabled: l, value: a.value, hover: v, focus: C }), [a, v, C, y, l]), _ = et({ ref: i, id: s, type: Ca(e, a.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (r = a.optionsElement) == null ? void 0 : r.id, "aria-expanded": a.comboboxState === 0, "aria-labelledby": m, disabled: l || void 0, autoFocus: c, onMouseDown: h, onKeyDown: f }, g, b, x);
  return me()({ ourProps: _, theirProps: d, slot: S, defaultTag: s8, name: "Combobox.Button" });
}
let u8 = "div", c8 = pt.RenderStrategy | pt.Static;
function d8(e, t) {
  var r, a, n;
  let i = je(), { id: o = `headlessui-combobox-options-${i}`, hold: s = !1, anchor: l, portal: c = !1, modal: d = !0, transition: p = !1, ...f } = e, h = lr("Combobox.Options"), m = yi("Combobox.Options"), C = L1(l);
  C && (c = !0);
  let [g, v] = R1(C), [b, y] = te(null), x = N1(), S = we(t, C ? g : null, m.setOptionsElement, y), _ = Zt(h.optionsElement), M = wn(), [I, L] = ba(p, b, M !== null ? (M & He.Open) === He.Open : h.comboboxState === 0);
  di(I, h.inputElement, m.closeCombobox);
  let D = h.__demoMode ? !1 : d && h.comboboxState === 0;
  gi(D, _);
  let A = h.__demoMode ? !1 : d && h.comboboxState === 0;
  k1(A, { allowed: _e(() => [h.inputElement, h.buttonElement, h.optionsElement], [h.inputElement, h.buttonElement, h.optionsElement]) }), ye(() => {
    var G;
    h.optionsPropsRef.current.static = (G = e.static) != null ? G : !1;
  }, [h.optionsPropsRef, e.static]), ye(() => {
    h.optionsPropsRef.current.hold = s;
  }, [h.optionsPropsRef, s]), jc(h.comboboxState === 0, { container: h.optionsElement, accept(G) {
    return G.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : G.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(G) {
    G.setAttribute("role", "none");
  } });
  let B = en([(r = h.buttonElement) == null ? void 0 : r.id]), U = q(() => ({ open: h.comboboxState === 0, option: void 0 }), [h.comboboxState]), H = F(() => {
    m.setActivationTrigger(0);
  }), K = F((G) => {
    G.preventDefault(), m.setActivationTrigger(0);
  }), Z = et(C ? x() : {}, { "aria-labelledby": B, role: "listbox", "aria-multiselectable": h.mode === 1 ? !0 : void 0, id: o, ref: S, style: { ...f.style, ...v, "--input-width": Gr(h.inputElement, !0).width, "--button-width": Gr(h.buttonElement, !0).width }, onWheel: h.activationTrigger === 0 ? void 0 : H, onMouseDown: K, ...va(L) }), V = I && h.comboboxState === 1, O = e1(V, (a = h.virtual) == null ? void 0 : a.options), j = e1(V, h.value), N = F((G) => h.compare(j, G));
  if (h.virtual) {
    if (O === void 0) throw new Error("Missing `options` in virtual mode");
    Object.assign(f, { children: w.createElement(Zr.Provider, { value: O !== h.virtual.options ? { ...h, virtual: { ...h.virtual, options: O } } : h }, w.createElement(t8, { slot: U }, f.children)) });
  }
  let E = me();
  return w.createElement(sr, { enabled: c ? e.static || I : !1 }, w.createElement(Zr.Provider, { value: h.mode === 1 ? h : { ...h, isSelected: N } }, E({ ourProps: Z, theirProps: { ...f, children: w.createElement(H7, { freeze: V }, typeof f.children == "function" ? (n = f.children) == null ? void 0 : n.call(f, U) : f.children) }, slot: U, defaultTag: u8, features: c8, visible: I, name: "Combobox.Options" })));
}
let p8 = "div";
function f8(e, t) {
  var r, a, n, i;
  let o = lr("Combobox.Option"), s = yi("Combobox.Option"), l = je(), { id: c = `headlessui-combobox-option-${l}`, value: d, disabled: p = (n = (a = (r = o.virtual) == null ? void 0 : r.disabled) == null ? void 0 : a.call(r, d)) != null ? n : !1, order: f = null, ...h } = e, m = Bc(o.inputElement), C = o.virtual ? o.activeOptionIndex === o.calculateIndex(d) : o.activeOptionIndex === null ? !1 : ((i = o.options[o.activeOptionIndex]) == null ? void 0 : i.id) === c, g = o.isSelected(d), v = Q(null), b = Ct({ disabled: p, value: d, domRef: v, order: f }), y = xe(l3), x = we(t, v, y ? y.measureElement : null), S = F(() => {
    s.setIsTyping(!1), s.onChange(d);
  });
  ye(() => s.registerOption(c, b), [b, c]);
  let _ = Q(!(o.virtual || o.__demoMode));
  ye(() => {
    if (!o.virtual && !o.__demoMode) return Rt().requestAnimationFrame(() => {
      _.current = !0;
    });
  }, [o.virtual, o.__demoMode]), ye(() => {
    if (_.current && o.comboboxState === 0 && C && o.activationTrigger !== 0) return Rt().requestAnimationFrame(() => {
      var K, Z;
      (Z = (K = v.current) == null ? void 0 : K.scrollIntoView) == null || Z.call(K, { block: "nearest" });
    });
  }, [v, C, o.comboboxState, o.activationTrigger, o.activeOptionIndex]);
  let M = F((K) => {
    K.preventDefault(), K.button === Zs.Left && (p || (S(), Rc() || requestAnimationFrame(() => m()), o.mode === 0 && s.closeCombobox()));
  }), I = F(() => {
    if (p) return s.goToOption(Ce.Nothing);
    let K = o.calculateIndex(d);
    s.goToOption(Ce.Specific, K);
  }), L = Hs(), D = F((K) => L.update(K)), A = F((K) => {
    if (!L.wasMoved(K) || p || C) return;
    let Z = o.calculateIndex(d);
    s.goToOption(Ce.Specific, Z, 0);
  }), B = F((K) => {
    L.wasMoved(K) && (p || C && (o.optionsPropsRef.current.hold || s.goToOption(Ce.Nothing)));
  }), U = q(() => ({ active: C, focus: C, selected: g, disabled: p }), [C, g, p]), H = { id: c, ref: x, role: "option", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, "aria-selected": g, disabled: void 0, onMouseDown: M, onFocus: I, onPointerEnter: D, onMouseEnter: D, onPointerMove: A, onMouseMove: A, onPointerLeave: B, onMouseLeave: B };
  return me()({ ourProps: H, theirProps: h, slot: U, defaultTag: p8, name: "Combobox.Option" });
}
let h8 = pe(r8), wi = pe(l8), Ws = pe(o8), u3 = tr, j1 = pe(d8), H1 = pe(f8), $s = Object.assign(h8, { Input: Ws, Button: wi, Label: u3, Options: j1, Option: H1 }), m8 = $e;
function g8(e, t) {
  let { ...r } = e, a = !1, { isFocusVisible: n, focusProps: i } = bt(), { isHovered: o, hoverProps: s } = _t({ isDisabled: a }), { pressed: l, pressProps: c } = Xt({ disabled: a }), d = et({ ref: t }, i, s, c), p = q(() => ({ hover: o, focus: n, active: l }), [o, n, l]);
  return me()({ ourProps: d, theirProps: r, slot: p, defaultTag: m8, name: "DataInteractive" });
}
let C8 = pe(g8);
function v8(e, t = typeof document < "u" ? document.defaultView : null, r) {
  let a = nr(e, "escape");
  P1(t, "keydown", (n) => {
    a && (n.defaultPrevented || n.key === X.Escape && r(n));
  });
}
function b8() {
  var e;
  let [t] = te(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [r, a] = te((e = t == null ? void 0 : t.matches) != null ? e : !1);
  return ye(() => {
    if (!t) return;
    function n(i) {
      a(i.matches);
    }
    return t.addEventListener("change", n), () => t.removeEventListener("change", n);
  }, [t]), r;
}
function c3({ defaultContainers: e = [], portals: t, mainTreeNode: r } = {}) {
  let a = Zt(r), n = F(() => {
    var i, o;
    let s = [];
    for (let l of e) l !== null && (l instanceof HTMLElement ? s.push(l) : "current" in l && l.current instanceof HTMLElement && s.push(l.current));
    if (t != null && t.current) for (let l of t.current) s.push(l);
    for (let l of (i = a == null ? void 0 : a.querySelectorAll("html > *, body > *")) != null ? i : []) l !== document.body && l !== document.head && l instanceof HTMLElement && l.id !== "headlessui-portal-root" && (r && (l.contains(r) || l.contains((o = r == null ? void 0 : r.getRootNode()) == null ? void 0 : o.host)) || s.some((c) => l.contains(c)) || s.push(l));
    return s;
  });
  return { resolveContainers: n, contains: F((i) => n().some((o) => o.contains(i))) };
}
let d3 = Le(null);
function t1({ children: e, node: t }) {
  let [r, a] = te(null), n = Js(t ?? r);
  return w.createElement(d3.Provider, { value: n }, e, n === null && w.createElement(Jt, { features: $t.Hidden, ref: (i) => {
    var o, s;
    if (i) {
      for (let l of (s = (o = zt(i)) == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? s : []) if (l !== document.body && l !== document.head && l instanceof HTMLElement && l != null && l.contains(i)) {
        a(l);
        break;
      }
    }
  } }));
}
function Js(e = null) {
  var t;
  return (t = xe(d3)) != null ? t : e;
}
function F1() {
  let e = Q(!1);
  return ye(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var At = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(At || {});
function Qs() {
  let e = Q(0);
  return Oc(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function p3(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.current) r.current instanceof HTMLElement && t.add(r.current);
  return t;
}
let y8 = "div";
var kn = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(kn || {});
function w8(e, t) {
  let r = Q(null), a = we(r, t), { initialFocus: n, initialFocusFallback: i, containers: o, features: s = 15, ...l } = e;
  bi() || (s = 0);
  let c = Zt(r);
  x8(s, { ownerDocument: c });
  let d = M8(s, { ownerDocument: c, container: r, initialFocus: n, initialFocusFallback: i });
  k8(s, { ownerDocument: c, container: r, containers: o, previousActiveElement: d });
  let p = Qs(), f = F((b) => {
    let y = r.current;
    y && ((x) => x())(() => {
      Ee(p.current, { [At.Forwards]: () => {
        ot(y, Ne.First, { skipElements: [b.relatedTarget, i] });
      }, [At.Backwards]: () => {
        ot(y, Ne.Last, { skipElements: [b.relatedTarget, i] });
      } });
    });
  }), h = nr(!!(s & 2), "focus-trap#tab-lock"), m = Ut(), C = Q(!1), g = { ref: a, onKeyDown(b) {
    b.key == "Tab" && (C.current = !0, m.requestAnimationFrame(() => {
      C.current = !1;
    }));
  }, onBlur(b) {
    if (!(s & 4)) return;
    let y = p3(o);
    r.current instanceof HTMLElement && y.add(r.current);
    let x = b.relatedTarget;
    x instanceof HTMLElement && x.dataset.headlessuiFocusGuard !== "true" && (f3(y, x) || (C.current ? ot(r.current, Ee(p.current, { [At.Forwards]: () => Ne.Next, [At.Backwards]: () => Ne.Previous }) | Ne.WrapAround, { relativeTo: b.target }) : b.target instanceof HTMLElement && cn(b.target)));
  } }, v = me();
  return w.createElement(w.Fragment, null, h && w.createElement(Jt, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: f, features: $t.Focusable }), v({ ourProps: g, theirProps: l, defaultTag: y8, name: "FocusTrap" }), h && w.createElement(Jt, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: f, features: $t.Focusable }));
}
let S8 = pe(w8), qs = Object.assign(S8, { features: kn });
function _8(e = !0) {
  let t = Q(rn.slice());
  return Vr(([r], [a]) => {
    a === !0 && r === !1 && oi(() => {
      t.current.splice(0);
    }), a === !1 && r === !0 && (t.current = rn.slice());
  }, [e, rn, t]), F(() => {
    var r;
    return (r = t.current.find((a) => a != null && a.isConnected)) != null ? r : null;
  });
}
function x8(e, { ownerDocument: t }) {
  let r = !!(e & 8), a = _8(r);
  Vr(() => {
    r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && cn(a());
  }, [r]), n3(() => {
    r && cn(a());
  });
}
function M8(e, { ownerDocument: t, container: r, initialFocus: a, initialFocusFallback: n }) {
  let i = Q(null), o = nr(!!(e & 1), "focus-trap#initial-focus"), s = F1();
  return Vr(() => {
    if (e === 0) return;
    if (!o) {
      n != null && n.current && cn(n.current);
      return;
    }
    let l = r.current;
    l && oi(() => {
      if (!s.current) return;
      let c = t == null ? void 0 : t.activeElement;
      if (a != null && a.current) {
        if ((a == null ? void 0 : a.current) === c) {
          i.current = c;
          return;
        }
      } else if (l.contains(c)) {
        i.current = c;
        return;
      }
      if (a != null && a.current) cn(a.current);
      else {
        if (e & 16) {
          if (ot(l, Ne.First | Ne.AutoFocus) !== Ht.Error) return;
        } else if (ot(l, Ne.First) !== Ht.Error) return;
        if (n != null && n.current && (cn(n.current), (t == null ? void 0 : t.activeElement) === n.current)) return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      i.current = t == null ? void 0 : t.activeElement;
    });
  }, [n, o, e]), i;
}
function k8(e, { ownerDocument: t, container: r, containers: a, previousActiveElement: n }) {
  let i = F1(), o = !!(e & 4);
  P1(t == null ? void 0 : t.defaultView, "focus", (s) => {
    if (!o || !i.current) return;
    let l = p3(a);
    r.current instanceof HTMLElement && l.add(r.current);
    let c = n.current;
    if (!c) return;
    let d = s.target;
    d && d instanceof HTMLElement ? f3(l, d) ? (n.current = d, cn(d)) : (s.preventDefault(), s.stopPropagation(), cn(c)) : cn(n.current);
  }, !0);
}
function f3(e, t) {
  for (let r of e) if (r.contains(t)) return !0;
  return !1;
}
function h3(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : g3) !== $e || w.Children.count(e.children) === 1;
}
let G1 = Le(null);
G1.displayName = "TransitionContext";
var P8 = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(P8 || {});
function T8() {
  let e = xe(G1);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function E8() {
  let e = xe(V1);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let V1 = Le(null);
V1.displayName = "NestingContext";
function K1(e) {
  return "children" in e ? K1(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function m3(e, t) {
  let r = Ct(e), a = Q([]), n = F1(), i = Ut(), o = F((h, m = Hn.Hidden) => {
    let C = a.current.findIndex(({ el: g }) => g === h);
    C !== -1 && (Ee(m, { [Hn.Unmount]() {
      a.current.splice(C, 1);
    }, [Hn.Hidden]() {
      a.current[C].state = "hidden";
    } }), i.microTask(() => {
      var g;
      !K1(a) && n.current && ((g = r.current) == null || g.call(r));
    }));
  }), s = F((h) => {
    let m = a.current.find(({ el: C }) => C === h);
    return m ? m.state !== "visible" && (m.state = "visible") : a.current.push({ el: h, state: "visible" }), () => o(h, Hn.Unmount);
  }), l = Q([]), c = Q(Promise.resolve()), d = Q({ enter: [], leave: [] }), p = F((h, m, C) => {
    l.current.splice(0), t && (t.chains.current[m] = t.chains.current[m].filter(([g]) => g !== h)), t == null || t.chains.current[m].push([h, new Promise((g) => {
      l.current.push(g);
    })]), t == null || t.chains.current[m].push([h, new Promise((g) => {
      Promise.all(d.current[m].map(([v, b]) => b)).then(() => g());
    })]), m === "enter" ? c.current = c.current.then(() => t == null ? void 0 : t.wait.current).then(() => C(m)) : C(m);
  }), f = F((h, m, C) => {
    Promise.all(d.current[m].splice(0).map(([g, v]) => v)).then(() => {
      var g;
      (g = l.current.shift()) == null || g();
    }).then(() => C(m));
  });
  return q(() => ({ children: a, register: s, unregister: o, onStart: p, onStop: f, wait: c, chains: d }), [s, o, a, p, f, d, c]);
}
let g3 = $e, C3 = pt.RenderStrategy;
function D8(e, t) {
  var r, a;
  let { transition: n = !0, beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: l, enter: c, enterFrom: d, enterTo: p, entered: f, leave: h, leaveFrom: m, leaveTo: C, ...g } = e, [v, b] = te(null), y = Q(null), x = h3(e), S = we(...x ? [y, t, b] : t === null ? [] : [t]), _ = (r = g.unmount) == null || r ? Hn.Unmount : Hn.Hidden, { show: M, appear: I, initial: L } = T8(), [D, A] = te(M ? "visible" : "hidden"), B = E8(), { register: U, unregister: H } = B;
  ye(() => U(y), [U, y]), ye(() => {
    if (_ === Hn.Hidden && y.current) {
      if (M && D !== "visible") {
        A("visible");
        return;
      }
      return Ee(D, { hidden: () => H(y), visible: () => U(y) });
    }
  }, [D, y, U, H, M, _]);
  let K = bi();
  ye(() => {
    if (x && K && D === "visible" && y.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [y, D, K, x]);
  let Z = L && !I, V = I && M && L, O = Q(!1), j = m3(() => {
    O.current || (A("hidden"), H(y));
  }, B), N = F((ae) => {
    O.current = !0;
    let de = ae ? "enter" : "leave";
    j.onStart(y, de, (ge) => {
      ge === "enter" ? i == null || i() : ge === "leave" && (s == null || s());
    });
  }), E = F((ae) => {
    let de = ae ? "enter" : "leave";
    O.current = !1, j.onStop(y, de, (ge) => {
      ge === "enter" ? o == null || o() : ge === "leave" && (l == null || l());
    }), de === "leave" && !K1(j) && (A("hidden"), H(y));
  });
  he(() => {
    x && n || (N(M), E(M));
  }, [M, x, n]);
  let G = !(!n || !x || !K || Z), [, R] = ba(G, v, M, { start: N, end: E }), $ = On({ ref: S, className: ((a = es(g.className, V && c, V && d, R.enter && c, R.enter && R.closed && d, R.enter && !R.closed && p, R.leave && h, R.leave && !R.closed && m, R.leave && R.closed && C, !R.transition && M && f)) == null ? void 0 : a.trim()) || void 0, ...va(R) }), W = 0;
  D === "visible" && (W |= He.Open), D === "hidden" && (W |= He.Closed), R.enter && (W |= He.Opening), R.leave && (W |= He.Closing);
  let re = me();
  return w.createElement(V1.Provider, { value: j }, w.createElement(or, { value: W }, re({ ourProps: $, theirProps: g, defaultTag: g3, features: C3, visible: D === "visible", name: "Transition.Child" })));
}
function I8(e, t) {
  let { show: r, appear: a = !1, unmount: n = !0, ...i } = e, o = Q(null), s = h3(e), l = we(...s ? [o, t] : t === null ? [] : [t]);
  bi();
  let c = wn();
  if (r === void 0 && c !== null && (r = (c & He.Open) === He.Open), r === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [d, p] = te(r ? "visible" : "hidden"), f = m3(() => {
    r || p("hidden");
  }), [h, m] = te(!0), C = Q([r]);
  ye(() => {
    h !== !1 && C.current[C.current.length - 1] !== r && (C.current.push(r), m(!1));
  }, [C, r]);
  let g = q(() => ({ show: r, appear: a, initial: h }), [r, a, h]);
  ye(() => {
    r ? p("visible") : !K1(f) && o.current !== null && p("hidden");
  }, [r, f]);
  let v = { unmount: n }, b = F(() => {
    var S;
    h && m(!1), (S = e.beforeEnter) == null || S.call(e);
  }), y = F(() => {
    var S;
    h && m(!1), (S = e.beforeLeave) == null || S.call(e);
  }), x = me();
  return w.createElement(V1.Provider, { value: f }, w.createElement(G1.Provider, { value: g }, x({ ourProps: { ...v, as: $e, children: w.createElement(v3, { ref: l, ...v, ...i, beforeEnter: b, beforeLeave: y }) }, theirProps: {}, defaultTag: $e, features: C3, visible: d === "visible", name: "Transition" })));
}
function L8(e, t) {
  let r = xe(G1) !== null, a = wn() !== null;
  return w.createElement(w.Fragment, null, !r && a ? w.createElement(os, { ref: t, ...e }) : w.createElement(v3, { ref: t, ...e }));
}
let os = pe(I8), v3 = pe(D8), z1 = pe(L8), Kn = Object.assign(os, { Child: z1, Root: os });
var A8 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(A8 || {}), N8 = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(N8 || {});
let R8 = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, Xs = Le(null);
Xs.displayName = "DialogContext";
function U1(e) {
  let t = xe(Xs);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, U1), r;
  }
  return t;
}
function O8(e, t) {
  return Ee(t.type, R8, e, t);
}
let A2 = pe(function(e, t) {
  let r = je(), { id: a = `headlessui-dialog-${r}`, open: n, onClose: i, initialFocus: o, role: s = "dialog", autoFocus: l = !0, __demoMode: c = !1, unmount: d = !1, ...p } = e, f = Q(!1);
  s = function() {
    return s === "dialog" || s === "alertdialog" ? s : (f.current || (f.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = wn();
  n === void 0 && h !== null && (n = (h & He.Open) === He.Open);
  let m = Q(null), C = we(m, t), g = Zt(m), v = n ? 0 : 1, [b, y] = Dn(O8, { titleId: null, descriptionId: null, panelRef: ra() }), x = F(() => i(!1)), S = F((E) => y({ type: 0, id: E })), _ = bi() ? v === 0 : !1, [M, I] = o3(), L = { get current() {
    var E;
    return (E = b.panelRef.current) != null ? E : m.current;
  } }, D = Js(), { resolveContainers: A } = c3({ mainTreeNode: D, portals: M, defaultContainers: [L] }), B = h !== null ? (h & He.Closing) === He.Closing : !1;
  k1(c || B ? !1 : _, { allowed: F(() => {
    var E, G;
    return [(G = (E = m.current) == null ? void 0 : E.closest("[data-headlessui-portal]")) != null ? G : null];
  }), disallowed: F(() => {
    var E;
    return [(E = D == null ? void 0 : D.closest("body > *:not(#headlessui-portal-root)")) != null ? E : null];
  }) }), mi(_, A, (E) => {
    E.preventDefault(), x();
  }), v8(_, g == null ? void 0 : g.defaultView, (E) => {
    E.preventDefault(), E.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), x();
  }), gi(c || B ? !1 : _, g, A), di(_, m, x);
  let [U, H] = er(), K = q(() => [{ dialogState: v, close: x, setTitleId: S, unmount: d }, b], [v, b, x, S, d]), Z = q(() => ({ open: v === 0 }), [v]), V = { ref: C, id: a, role: s, tabIndex: -1, "aria-modal": c ? void 0 : v === 0 ? !0 : void 0, "aria-labelledby": b.titleId, "aria-describedby": U, unmount: d }, O = !b8(), j = kn.None;
  _ && !c && (j |= kn.RestoreFocus, j |= kn.TabLock, l && (j |= kn.AutoFocus), O && (j |= kn.InitialFocus));
  let N = me();
  return w.createElement(Us, null, w.createElement(L2, { force: !0 }, w.createElement(sr, null, w.createElement(Xs.Provider, { value: K }, w.createElement(s3, { target: m }, w.createElement(L2, { force: !1 }, w.createElement(H, { slot: Z }, w.createElement(I, null, w.createElement(qs, { initialFocus: o, initialFocusFallback: m, containers: A, features: j }, w.createElement(Bs, { value: x }, N({ ourProps: V, theirProps: p, slot: Z, defaultTag: B8, features: j8, visible: v === 0, name: "Dialog" })))))))))));
}), B8 = "div", j8 = pt.RenderStrategy | pt.Static;
function H8(e, t) {
  let { transition: r = !1, open: a, ...n } = e, i = wn(), o = e.hasOwnProperty("open") || i !== null, s = e.hasOwnProperty("onClose");
  if (!o && !s) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!o) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!s) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (a !== void 0 || r) && !n.static ? w.createElement(t1, null, w.createElement(Kn, { show: a, transition: r, unmount: n.unmount }, w.createElement(A2, { ref: t, ...n }))) : w.createElement(t1, null, w.createElement(A2, { ref: t, open: a, ...n }));
}
let F8 = "div";
function G8(e, t) {
  let r = je(), { id: a = `headlessui-dialog-panel-${r}`, transition: n = !1, ...i } = e, [{ dialogState: o, unmount: s }, l] = U1("Dialog.Panel"), c = we(t, l.panelRef), d = q(() => ({ open: o === 0 }), [o]), p = F((g) => {
    g.stopPropagation();
  }), f = { ref: c, id: a, onClick: p }, h = n ? z1 : $e, m = n ? { unmount: s } : {}, C = me();
  return w.createElement(h, { ...m }, C({ ourProps: f, theirProps: i, slot: d, defaultTag: F8, name: "Dialog.Panel" }));
}
let V8 = "div";
function K8(e, t) {
  let { transition: r = !1, ...a } = e, [{ dialogState: n, unmount: i }] = U1("Dialog.Backdrop"), o = q(() => ({ open: n === 0 }), [n]), s = { ref: t, "aria-hidden": !0 }, l = r ? z1 : $e, c = r ? { unmount: i } : {}, d = me();
  return w.createElement(l, { ...c }, d({ ourProps: s, theirProps: a, slot: o, defaultTag: V8, name: "Dialog.Backdrop" }));
}
let z8 = "h2";
function U8(e, t) {
  let r = je(), { id: a = `headlessui-dialog-title-${r}`, ...n } = e, [{ dialogState: i, setTitleId: o }] = U1("Dialog.Title"), s = we(t);
  he(() => (o(a), () => o(null)), [a, o]);
  let l = q(() => ({ open: i === 0 }), [i]), c = { ref: s, id: a };
  return me()({ ourProps: c, theirProps: n, slot: l, defaultTag: z8, name: "Dialog.Title" });
}
let Z8 = pe(H8), b3 = pe(G8), Y8 = pe(K8), y3 = pe(U8), W8 = ci, ss = Object.assign(Z8, { Panel: b3, Title: y3, Description: ci });
var N2;
let $8 = (N2 = w.startTransition) != null ? N2 : function(e) {
  e();
};
var J8 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(J8 || {}), Q8 = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(Q8 || {});
let q8 = { 0: (e) => ({ ...e, disclosureState: Ee(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
}, 4(e, t) {
  return e.buttonElement === t.element ? e : { ...e, buttonElement: t.element };
}, 5(e, t) {
  return e.panelElement === t.element ? e : { ...e, panelElement: t.element };
} }, el = Le(null);
el.displayName = "DisclosureContext";
function tl(e) {
  let t = xe(el);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, tl), r;
  }
  return t;
}
let nl = Le(null);
nl.displayName = "DisclosureAPIContext";
function w3(e) {
  let t = xe(nl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, w3), r;
  }
  return t;
}
let al = Le(null);
al.displayName = "DisclosurePanelContext";
function X8() {
  return xe(al);
}
function e9(e, t) {
  return Ee(t.type, q8, e, t);
}
let t9 = $e;
function n9(e, t) {
  let { defaultOpen: r = !1, ...a } = e, n = Q(null), i = we(t, Rs((C) => {
    n.current = C;
  }, e.as === void 0 || e.as === $e)), o = Dn(e9, { disclosureState: r ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: s, buttonId: l }, c] = o, d = F((C) => {
    c({ type: 1 });
    let g = zt(n);
    if (!g || !l) return;
    let v = C ? C instanceof HTMLElement ? C : C.current instanceof HTMLElement ? C.current : g.getElementById(l) : g.getElementById(l);
    v == null || v.focus();
  }), p = q(() => ({ close: d }), [d]), f = q(() => ({ open: s === 0, close: d }), [s, d]), h = { ref: i }, m = me();
  return w.createElement(el.Provider, { value: o }, w.createElement(nl.Provider, { value: p }, w.createElement(Bs, { value: d }, w.createElement(or, { value: Ee(s, { 0: He.Open, 1: He.Closed }) }, m({ ourProps: h, theirProps: a, slot: f, defaultTag: t9, name: "Disclosure" })))));
}
let a9 = "button";
function r9(e, t) {
  let r = je(), { id: a = `headlessui-disclosure-button-${r}`, disabled: n = !1, autoFocus: i = !1, ...o } = e, [s, l] = tl("Disclosure.Button"), c = X8(), d = c === null ? !1 : c === s.panelId, p = Q(null), f = we(p, t, F((L) => {
    if (!d) return l({ type: 4, element: L });
  }));
  he(() => {
    if (!d) return l({ type: 2, buttonId: a }), () => {
      l({ type: 2, buttonId: null });
    };
  }, [a, l, d]);
  let h = F((L) => {
    var D;
    if (d) {
      if (s.disclosureState === 1) return;
      switch (L.key) {
        case X.Space:
        case X.Enter:
          L.preventDefault(), L.stopPropagation(), l({ type: 0 }), (D = s.buttonElement) == null || D.focus();
          break;
      }
    } else switch (L.key) {
      case X.Space:
      case X.Enter:
        L.preventDefault(), L.stopPropagation(), l({ type: 0 });
        break;
    }
  }), m = F((L) => {
    switch (L.key) {
      case X.Space:
        L.preventDefault();
        break;
    }
  }), C = F((L) => {
    var D;
    bn(L.currentTarget) || n || (d ? (l({ type: 0 }), (D = s.buttonElement) == null || D.focus()) : l({ type: 0 }));
  }), { isFocusVisible: g, focusProps: v } = bt({ autoFocus: i }), { isHovered: b, hoverProps: y } = _t({ isDisabled: n }), { pressed: x, pressProps: S } = Xt({ disabled: n }), _ = q(() => ({ open: s.disclosureState === 0, hover: b, active: x, disabled: n, focus: g, autofocus: i }), [s, b, x, g, n, i]), M = Ca(e, s.buttonElement), I = et(d ? { ref: f, type: M, disabled: n || void 0, autoFocus: i, onKeyDown: h, onClick: C } : { ref: f, id: a, type: M, "aria-expanded": s.disclosureState === 0, "aria-controls": s.panelElement ? s.panelId : void 0, disabled: n || void 0, autoFocus: i, onKeyDown: h, onKeyUp: m, onClick: C }, v, y, S);
  return me()({ ourProps: I, theirProps: o, slot: _, defaultTag: a9, name: "Disclosure.Button" });
}
let i9 = "div", o9 = pt.RenderStrategy | pt.Static;
function s9(e, t) {
  let r = je(), { id: a = `headlessui-disclosure-panel-${r}`, transition: n = !1, ...i } = e, [o, s] = tl("Disclosure.Panel"), { close: l } = w3("Disclosure.Panel"), [c, d] = te(null), p = we(t, F((b) => {
    $8(() => s({ type: 5, element: b }));
  }), d);
  he(() => (s({ type: 3, panelId: a }), () => {
    s({ type: 3, panelId: null });
  }), [a, s]);
  let f = wn(), [h, m] = ba(n, c, f !== null ? (f & He.Open) === He.Open : o.disclosureState === 0), C = q(() => ({ open: o.disclosureState === 0, close: l }), [o.disclosureState, l]), g = { ref: p, id: a, ...va(m) }, v = me();
  return w.createElement(Us, null, w.createElement(al.Provider, { value: o.panelId }, v({ ourProps: g, theirProps: i, slot: C, defaultTag: i9, features: o9, visible: h, name: "Disclosure.Panel" })));
}
let l9 = pe(n9), S3 = pe(r9), _3 = pe(s9), u9 = Object.assign(l9, { Button: S3, Panel: _3 }), c9 = "div";
function d9(e, t) {
  let r = `headlessui-control-${je()}`, [a, n] = Ln(), [i, o] = er(), s = Lt(), { disabled: l = s || !1, ...c } = e, d = q(() => ({ disabled: l }), [l]), p = { ref: t, disabled: l || void 0, "aria-disabled": l || void 0 }, f = me();
  return w.createElement(Cc, { value: l }, w.createElement(n, { value: a }, w.createElement(o, { value: i }, w.createElement(Bd, { id: r }, f({ ourProps: p, theirProps: { ...c, children: w.createElement(Nd, null, typeof c.children == "function" ? c.children(d) : c.children) }, slot: d, defaultTag: c9, name: "Field" })))));
}
let Z1 = pe(d9);
function p9(e) {
  let t = typeof e == "string" ? e : void 0, [r, a] = te(t);
  return [t ?? r, _e((n) => {
    t || n instanceof HTMLElement && a(n.tagName.toLowerCase());
  }, [t])];
}
let R2 = "fieldset";
function f9(e, t) {
  var r;
  let a = Lt(), { disabled: n = a || !1, ...i } = e, [o, s] = p9((r = e.as) != null ? r : R2), l = we(t, s), [c, d] = Ln(), p = q(() => ({ disabled: n }), [n]), f = o === "fieldset" ? { ref: l, "aria-labelledby": c, disabled: n || void 0 } : { ref: l, role: "group", "aria-labelledby": c, "aria-disabled": n || void 0 }, h = me();
  return w.createElement(Cc, { value: n }, w.createElement(d, null, h({ ourProps: f, theirProps: i, slot: p, defaultTag: R2, name: "Fieldset" })));
}
let h9 = pe(f9), m9 = "input";
function g9(e, t) {
  let r = je(), a = In(), n = Lt(), { id: i = a || `headlessui-input-${r}`, disabled: o = n || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, d = en(), p = Wn(), { isFocused: f, focusProps: h } = bt({ autoFocus: s }), { isHovered: m, hoverProps: C } = _t({ isDisabled: o }), g = et({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": p, "aria-invalid": l ? "" : void 0, disabled: o || void 0, autoFocus: s }, h, C), v = q(() => ({ disabled: o, invalid: l, hover: m, focus: f, autofocus: s }), [o, l, m, f, s]);
  return me()({ ourProps: g, theirProps: c, slot: v, defaultTag: m9, name: "Input" });
}
let C9 = pe(g9);
function v9(e, t) {
  return w.createElement(tr, { as: "div", ref: t, ...e });
}
let b9 = pe(v9);
function x3(e, t) {
  let r = Q({ left: 0, top: 0 });
  if (ye(() => {
    if (!t) return;
    let n = t.getBoundingClientRect();
    n && (r.current = n);
  }, [e, t]), t == null || !e || t === document.activeElement) return !1;
  let a = t.getBoundingClientRect();
  return a.top !== r.current.top || a.left !== r.current.left;
}
let O2 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function B2(e) {
  var t, r;
  let a = (t = e.innerText) != null ? t : "", n = e.cloneNode(!0);
  if (!(n instanceof HTMLElement)) return a;
  let i = !1;
  for (let s of n.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) s.remove(), i = !0;
  let o = i ? (r = n.innerText) != null ? r : "" : a;
  return O2.test(o) && (o = o.replace(O2, "")), o;
}
function y9(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let a = r.split(" ").map((n) => {
      let i = document.getElementById(n);
      if (i) {
        let o = i.getAttribute("aria-label");
        return typeof o == "string" ? o.trim() : B2(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (a.length > 0) return a.join(", ");
  }
  return B2(e).trim();
}
function M3(e) {
  let t = Q(""), r = Q("");
  return F(() => {
    let a = e.current;
    if (!a) return "";
    let n = a.innerText;
    if (t.current === n) return r.current;
    let i = y9(a).trim().toLowerCase();
    return t.current = n, r.current = i, i;
  });
}
var w9 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(w9 || {}), S9 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(S9 || {}), _9 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(_9 || {}), x9 = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetOptionsElement = 8] = "SetOptionsElement", e))(x9 || {});
function Do(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, a = ln(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), n = r ? a.indexOf(r) : null;
  return n === -1 && (n = null), { options: a, activeOptionIndex: n };
}
let M9 = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0) return e;
  let t = e.activeOptionIndex, { isSelected: r } = e.dataRef.current, a = e.options.findIndex((n) => r(n.dataRef.current.value));
  return a !== -1 && (t = a), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var r, a, n, i, o;
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let s = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === Ce.Nothing) return { ...s, activeOptionIndex: null };
  if (t.focus === Ce.Specific) return { ...s, activeOptionIndex: e.options.findIndex((d) => d.id === t.id) };
  if (t.focus === Ce.Previous) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let p = e.options[d].dataRef.current.domRef, f = Vn(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (f !== null) {
        let h = e.options[f].dataRef.current.domRef;
        if (((a = p.current) == null ? void 0 : a.previousElementSibling) === h.current || ((n = h.current) == null ? void 0 : n.previousElementSibling) === null) return { ...s, activeOptionIndex: f };
      }
    }
  } else if (t.focus === Ce.Next) {
    let d = e.activeOptionIndex;
    if (d !== null) {
      let p = e.options[d].dataRef.current.domRef, f = Vn(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (f !== null) {
        let h = e.options[f].dataRef.current.domRef;
        if (((i = p.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null) return { ...s, activeOptionIndex: f };
      }
    }
  }
  let l = Do(e), c = Vn(t, { resolveItems: () => l.options, resolveActiveIndex: () => l.activeOptionIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled });
  return { ...s, ...l, activeOptionIndex: c };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let r = e.searchQuery !== "" ? 0 : 1, a = e.searchQuery + t.value.toLowerCase(), n = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((o) => {
    var s;
    return !o.dataRef.current.disabled && ((s = o.dataRef.current.textValue) == null ? void 0 : s.startsWith(a));
  }), i = n ? e.options.indexOf(n) : -1;
  return i === -1 || i === e.activeOptionIndex ? { ...e, searchQuery: a } : { ...e, searchQuery: a, activeOptionIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let r = { id: t.id, dataRef: t.dataRef }, a = Do(e, (n) => [...n, r]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(r)), { ...e, ...a };
}, 6: (e, t) => {
  let r = Do(e, (a) => {
    let n = a.findIndex((i) => i.id === t.id);
    return n !== -1 && a.splice(n, 1), a;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, rl = Le(null);
rl.displayName = "ListboxActionsContext";
function Y1(e) {
  let t = xe(rl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Y1), r;
  }
  return t;
}
let W1 = Le(null);
W1.displayName = "ListboxDataContext";
function Si(e) {
  let t = xe(W1);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Si), r;
  }
  return t;
}
function k9(e, t) {
  return Ee(t.type, M9, e, t);
}
let P9 = $e;
function T9(e, t) {
  var r;
  let a = Lt(), { value: n, defaultValue: i, form: o, name: s, onChange: l, by: c, invalid: d = !1, disabled: p = a || !1, horizontal: f = !1, multiple: h = !1, __demoMode: m = !1, ...C } = e;
  const g = f ? "horizontal" : "vertical";
  let v = we(t), b = li(i), [y = h ? [] : void 0, x] = si(n, l, b), [S, _] = Dn(k9, { dataRef: ra(), listboxState: m ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, buttonElement: null, optionsElement: null, __demoMode: m }), M = Q({ static: !1, hold: !1 }), I = Q(/* @__PURE__ */ new Map()), L = js(c), D = _e((fe) => Ee(A.mode, { 1: () => y.some((De) => L(De, fe)), 0: () => L(y, fe) }), [y]), A = q(() => ({ ...S, value: y, disabled: p, invalid: d, mode: h ? 1 : 0, orientation: g, compare: L, isSelected: D, optionsPropsRef: M, listRef: I }), [y, p, d, h, S, I]);
  ye(() => {
    S.dataRef.current = A;
  }, [A]);
  let B = A.listboxState === 0;
  mi(B, [A.buttonElement, A.optionsElement], (fe, De) => {
    var le;
    _({ type: 1 }), hi(De, fi.Loose) || (fe.preventDefault(), (le = A.buttonElement) == null || le.focus());
  });
  let U = q(() => ({ open: A.listboxState === 0, disabled: p, invalid: d, value: y }), [A, p, y, d]), H = F((fe) => {
    let De = A.options.find((le) => le.id === fe);
    De && E(De.dataRef.current.value);
  }), K = F(() => {
    if (A.activeOptionIndex !== null) {
      let { dataRef: fe, id: De } = A.options[A.activeOptionIndex];
      E(fe.current.value), _({ type: 2, focus: Ce.Specific, id: De });
    }
  }), Z = F(() => _({ type: 0 })), V = F(() => _({ type: 1 })), O = Ut(), j = F((fe, De, le) => {
    O.dispose(), O.microTask(() => fe === Ce.Specific ? _({ type: 2, focus: Ce.Specific, id: De, trigger: le }) : _({ type: 2, focus: fe, trigger: le }));
  }), N = F((fe, De) => (_({ type: 5, id: fe, dataRef: De }), () => _({ type: 6, id: fe }))), E = F((fe) => Ee(A.mode, { 0() {
    return x == null ? void 0 : x(fe);
  }, 1() {
    let De = A.value.slice(), le = De.findIndex((ke) => L(ke, fe));
    return le === -1 ? De.push(fe) : De.splice(le, 1), x == null ? void 0 : x(De);
  } })), G = F((fe) => _({ type: 3, value: fe })), R = F(() => _({ type: 4 })), $ = F((fe) => {
    _({ type: 7, element: fe });
  }), W = F((fe) => {
    _({ type: 8, element: fe });
  }), re = q(() => ({ onChange: E, registerOption: N, goToOption: j, closeListbox: V, openListbox: Z, selectActiveOption: K, selectOption: H, search: G, clearSearch: R, setButtonElement: $, setOptionsElement: W }), []), [ae, de] = Ln({ inherit: !0 }), ge = { ref: v }, Je = _e(() => {
    if (b !== void 0) return x == null ? void 0 : x(b);
  }, [x, b]), Se = me();
  return w.createElement(de, { value: ae, props: { htmlFor: (r = A.buttonElement) == null ? void 0 : r.id }, slot: { open: A.listboxState === 0, disabled: p } }, w.createElement(O1, null, w.createElement(rl.Provider, { value: re }, w.createElement(W1.Provider, { value: A }, w.createElement(or, { value: Ee(A.listboxState, { 0: He.Open, 1: He.Closed }) }, s != null && y != null && w.createElement(ui, { disabled: p, data: { [s]: y }, form: o, onReset: Je }), Se({ ourProps: ge, theirProps: C, slot: U, defaultTag: P9, name: "Listbox" }))))));
}
let E9 = "button";
function D9(e, t) {
  var r;
  let a = Si("Listbox.Button"), n = Y1("Listbox.Button"), i = je(), o = In(), { id: s = o || `headlessui-listbox-button-${i}`, disabled: l = a.disabled || !1, autoFocus: c = !1, ...d } = e, p = we(t, A1(), n.setButtonElement), f = e3(), h = F((A) => {
    switch (A.key) {
      case X.Enter:
        _1(A.currentTarget);
        break;
      case X.Space:
      case X.ArrowDown:
        A.preventDefault(), ct(() => n.openListbox()), a.value || n.goToOption(Ce.First);
        break;
      case X.ArrowUp:
        A.preventDefault(), ct(() => n.openListbox()), a.value || n.goToOption(Ce.Last);
        break;
    }
  }), m = F((A) => {
    switch (A.key) {
      case X.Space:
        A.preventDefault();
        break;
    }
  }), C = F((A) => {
    var B;
    if (bn(A.currentTarget)) return A.preventDefault();
    a.listboxState === 0 ? (ct(() => n.closeListbox()), (B = a.buttonElement) == null || B.focus({ preventScroll: !0 })) : (A.preventDefault(), n.openListbox());
  }), g = F((A) => A.preventDefault()), v = en([s]), b = Wn(), { isFocusVisible: y, focusProps: x } = bt({ autoFocus: c }), { isHovered: S, hoverProps: _ } = _t({ isDisabled: l }), { pressed: M, pressProps: I } = Xt({ disabled: l }), L = q(() => ({ open: a.listboxState === 0, active: M || a.listboxState === 0, disabled: l, invalid: a.invalid, value: a.value, hover: S, focus: y, autofocus: c }), [a.listboxState, a.value, l, S, y, M, a.invalid, c]), D = et(f(), { ref: p, id: s, type: Ca(e, a.buttonElement), "aria-haspopup": "listbox", "aria-controls": (r = a.optionsElement) == null ? void 0 : r.id, "aria-expanded": a.listboxState === 0, "aria-labelledby": v, "aria-describedby": b, disabled: l || void 0, autoFocus: c, onKeyDown: h, onKeyUp: m, onKeyPress: g, onClick: C }, x, _, I);
  return me()({ ourProps: D, theirProps: d, slot: L, defaultTag: E9, name: "Listbox.Button" });
}
let k3 = Le(!1), I9 = "div", L9 = pt.RenderStrategy | pt.Static;
function A9(e, t) {
  var r, a;
  let n = je(), { id: i = `headlessui-listbox-options-${n}`, anchor: o, portal: s = !1, modal: l = !0, transition: c = !1, ...d } = e, p = L1(o), [f, h] = te(null);
  p && (s = !0);
  let m = Si("Listbox.Options"), C = Y1("Listbox.Options"), g = Zt(m.optionsElement), v = wn(), [b, y] = ba(c, f, v !== null ? (v & He.Open) === He.Open : m.listboxState === 0);
  di(b, m.buttonElement, C.closeListbox);
  let x = m.__demoMode ? !1 : l && m.listboxState === 0;
  gi(x, g);
  let S = m.__demoMode ? !1 : l && m.listboxState === 0;
  k1(S, { allowed: _e(() => [m.buttonElement, m.optionsElement], [m.buttonElement, m.optionsElement]) });
  let _ = m.listboxState !== 0, M = x3(_, m.buttonElement) ? !1 : b, I = b && m.listboxState === 1, L = e1(I, m.value), D = F((R) => m.compare(L, R)), A = q(() => {
    var R;
    if (p == null || !((R = p == null ? void 0 : p.to) != null && R.includes("selection"))) return null;
    let $ = m.options.findIndex((W) => D(W.dataRef.current.value));
    return $ === -1 && ($ = 0), $;
  }, [p, m.options]), B = (() => {
    if (p == null) return;
    if (A === null) return { ...p, inner: void 0 };
    let R = Array.from(m.listRef.current.values());
    return { ...p, inner: { listRef: { current: R }, index: A } };
  })(), [U, H] = R1(B), K = N1(), Z = we(t, p ? U : null, C.setOptionsElement, h), V = Ut();
  he(() => {
    var R;
    let $ = m.optionsElement;
    $ && m.listboxState === 0 && $ !== ((R = zt($)) == null ? void 0 : R.activeElement) && ($ == null || $.focus({ preventScroll: !0 }));
  }, [m.listboxState, m.optionsElement]);
  let O = F((R) => {
    var $, W;
    switch (V.dispose(), R.key) {
      case X.Space:
        if (m.searchQuery !== "") return R.preventDefault(), R.stopPropagation(), C.search(R.key);
      case X.Enter:
        if (R.preventDefault(), R.stopPropagation(), m.activeOptionIndex !== null) {
          let { dataRef: re } = m.options[m.activeOptionIndex];
          C.onChange(re.current.value);
        }
        m.mode === 0 && (ct(() => C.closeListbox()), ($ = m.buttonElement) == null || $.focus({ preventScroll: !0 }));
        break;
      case Ee(m.orientation, { vertical: X.ArrowDown, horizontal: X.ArrowRight }):
        return R.preventDefault(), R.stopPropagation(), C.goToOption(Ce.Next);
      case Ee(m.orientation, { vertical: X.ArrowUp, horizontal: X.ArrowLeft }):
        return R.preventDefault(), R.stopPropagation(), C.goToOption(Ce.Previous);
      case X.Home:
      case X.PageUp:
        return R.preventDefault(), R.stopPropagation(), C.goToOption(Ce.First);
      case X.End:
      case X.PageDown:
        return R.preventDefault(), R.stopPropagation(), C.goToOption(Ce.Last);
      case X.Escape:
        R.preventDefault(), R.stopPropagation(), ct(() => C.closeListbox()), (W = m.buttonElement) == null || W.focus({ preventScroll: !0 });
        return;
      case X.Tab:
        R.preventDefault(), R.stopPropagation(), ct(() => C.closeListbox()), Ac(m.buttonElement, R.shiftKey ? Ne.Previous : Ne.Next);
        break;
      default:
        R.key.length === 1 && (C.search(R.key), V.setTimeout(() => C.clearSearch(), 350));
        break;
    }
  }), j = (r = m.buttonElement) == null ? void 0 : r.id, N = q(() => ({ open: m.listboxState === 0 }), [m.listboxState]), E = et(p ? K() : {}, { id: i, ref: Z, "aria-activedescendant": m.activeOptionIndex === null || (a = m.options[m.activeOptionIndex]) == null ? void 0 : a.id, "aria-multiselectable": m.mode === 1 ? !0 : void 0, "aria-labelledby": j, "aria-orientation": m.orientation, onKeyDown: O, role: "listbox", tabIndex: m.listboxState === 0 ? 0 : void 0, style: { ...d.style, ...H, "--button-width": Gr(m.buttonElement, !0).width }, ...va(y) }), G = me();
  return w.createElement(sr, { enabled: s ? e.static || b : !1 }, w.createElement(W1.Provider, { value: m.mode === 1 ? m : { ...m, isSelected: D } }, G({ ourProps: E, theirProps: d, slot: N, defaultTag: I9, features: L9, visible: M, name: "Listbox.Options" })));
}
let N9 = "div";
function R9(e, t) {
  let r = je(), { id: a = `headlessui-listbox-option-${r}`, disabled: n = !1, value: i, ...o } = e, s = xe(k3) === !0, l = Si("Listbox.Option"), c = Y1("Listbox.Option"), d = l.activeOptionIndex !== null ? l.options[l.activeOptionIndex].id === a : !1, p = l.isSelected(i), f = Q(null), h = M3(f), m = Ct({ disabled: n, value: i, domRef: f, get textValue() {
    return h();
  } }), C = we(t, f, (L) => {
    L ? l.listRef.current.set(a, L) : l.listRef.current.delete(a);
  });
  ye(() => {
    if (!l.__demoMode && l.listboxState === 0 && d && l.activationTrigger !== 0) return Rt().requestAnimationFrame(() => {
      var L, D;
      (D = (L = f.current) == null ? void 0 : L.scrollIntoView) == null || D.call(L, { block: "nearest" });
    });
  }, [f, d, l.__demoMode, l.listboxState, l.activationTrigger, l.activeOptionIndex]), ye(() => {
    if (!s) return c.registerOption(a, m);
  }, [m, a, s]);
  let g = F((L) => {
    var D;
    if (n) return L.preventDefault();
    c.onChange(i), l.mode === 0 && (ct(() => c.closeListbox()), (D = l.buttonElement) == null || D.focus({ preventScroll: !0 }));
  }), v = F(() => {
    if (n) return c.goToOption(Ce.Nothing);
    c.goToOption(Ce.Specific, a);
  }), b = Hs(), y = F((L) => {
    b.update(L), !n && (d || c.goToOption(Ce.Specific, a, 0));
  }), x = F((L) => {
    b.wasMoved(L) && (n || d || c.goToOption(Ce.Specific, a, 0));
  }), S = F((L) => {
    b.wasMoved(L) && (n || d && c.goToOption(Ce.Nothing));
  }), _ = q(() => ({ active: d, focus: d, selected: p, disabled: n, selectedOption: p && s }), [d, p, n, s]), M = s ? {} : { id: a, ref: C, role: "option", tabIndex: n === !0 ? void 0 : -1, "aria-disabled": n === !0 ? !0 : void 0, "aria-selected": p, disabled: void 0, onClick: g, onFocus: v, onPointerEnter: y, onMouseEnter: y, onPointerMove: x, onMouseMove: x, onPointerLeave: S, onMouseLeave: S }, I = me();
  return !p && s ? null : I({ ourProps: M, theirProps: o, slot: _, defaultTag: N9, name: "Listbox.Option" });
}
let O9 = $e;
function B9(e, t) {
  let { options: r, placeholder: a, ...n } = e, i = { ref: we(t) }, o = Si("ListboxSelectedOption"), s = q(() => ({}), []), l = o.value === void 0 || o.value === null || o.mode === 1 && Array.isArray(o.value) && o.value.length === 0, c = me();
  return w.createElement(k3.Provider, { value: !0 }, c({ ourProps: i, theirProps: { ...n, children: w.createElement(w.Fragment, null, a && l ? a : r) }, slot: s, defaultTag: O9, name: "ListboxSelectedOption" }));
}
let j9 = pe(T9), Yr = pe(D9), P3 = tr, $1 = pe(A9), il = pe(R9), T3 = pe(B9), ol = Object.assign(j9, { Button: Yr, Label: P3, Options: $1, Option: il, SelectedOption: T3 });
var H9 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(H9 || {}), F9 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(F9 || {}), G9 = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(G9 || {});
function Io(e, t = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, a = ln(t(e.items.slice()), (i) => i.dataRef.current.domRef.current), n = r ? a.indexOf(r) : null;
  return n === -1 && (n = null), { items: a, activeItemIndex: n };
}
let V9 = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, t) => {
  var r, a, n, i, o;
  if (e.menuState === 1) return e;
  let s = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === Ce.Nothing) return { ...s, activeItemIndex: null };
  if (t.focus === Ce.Specific) return { ...s, activeItemIndex: e.items.findIndex((d) => d.id === t.id) };
  if (t.focus === Ce.Previous) {
    let d = e.activeItemIndex;
    if (d !== null) {
      let p = e.items[d].dataRef.current.domRef, f = Vn(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (f !== null) {
        let h = e.items[f].dataRef.current.domRef;
        if (((a = p.current) == null ? void 0 : a.previousElementSibling) === h.current || ((n = h.current) == null ? void 0 : n.previousElementSibling) === null) return { ...s, activeItemIndex: f };
      }
    }
  } else if (t.focus === Ce.Next) {
    let d = e.activeItemIndex;
    if (d !== null) {
      let p = e.items[d].dataRef.current.domRef, f = Vn(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (f !== null) {
        let h = e.items[f].dataRef.current.domRef;
        if (((i = p.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null) return { ...s, activeItemIndex: f };
      }
    }
  }
  let l = Io(e), c = Vn(t, { resolveItems: () => l.items, resolveActiveIndex: () => l.activeItemIndex, resolveId: (d) => d.id, resolveDisabled: (d) => d.dataRef.current.disabled });
  return { ...s, ...l, activeItemIndex: c };
}, 3: (e, t) => {
  let r = e.searchQuery !== "" ? 0 : 1, a = e.searchQuery + t.value.toLowerCase(), n = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((o) => {
    var s;
    return ((s = o.dataRef.current.textValue) == null ? void 0 : s.startsWith(a)) && !o.dataRef.current.disabled;
  }), i = n ? e.items.indexOf(n) : -1;
  return i === -1 || i === e.activeItemIndex ? { ...e, searchQuery: a } : { ...e, searchQuery: a, activeItemIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, t) => {
  let r = Io(e, (a) => [...a, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...r };
}, 6: (e, t) => {
  let r = Io(e, (a) => {
    let n = a.findIndex((i) => i.id === t.id);
    return n !== -1 && a.splice(n, 1), a;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.itemsElement === t.element ? e : { ...e, itemsElement: t.element } }, sl = Le(null);
sl.displayName = "MenuContext";
function J1(e) {
  let t = xe(sl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, J1), r;
  }
  return t;
}
function K9(e, t) {
  return Ee(t.type, V9, e, t);
}
let z9 = $e;
function U9(e, t) {
  let { __demoMode: r = !1, ...a } = e, n = Dn(K9, { __demoMode: r, menuState: r ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: i, itemsElement: o, buttonElement: s }, l] = n, c = we(t);
  mi(i === 0, [s, o], (m, C) => {
    l({ type: 1 }), hi(C, fi.Loose) || (m.preventDefault(), s == null || s.focus());
  });
  let d = F(() => {
    l({ type: 1 });
  }), p = q(() => ({ open: i === 0, close: d }), [i, d]), f = { ref: c }, h = me();
  return w.createElement(O1, null, w.createElement(sl.Provider, { value: n }, w.createElement(or, { value: Ee(i, { 0: He.Open, 1: He.Closed }) }, h({ ourProps: f, theirProps: a, slot: p, defaultTag: z9, name: "Menu" }))));
}
let Z9 = "button";
function Y9(e, t) {
  var r;
  let a = je(), { id: n = `headlessui-menu-button-${a}`, disabled: i = !1, autoFocus: o = !1, ...s } = e, [l, c] = J1("Menu.Button"), d = e3(), p = we(t, A1(), F((M) => c({ type: 7, element: M }))), f = F((M) => {
    switch (M.key) {
      case X.Space:
      case X.Enter:
      case X.ArrowDown:
        M.preventDefault(), M.stopPropagation(), ct(() => c({ type: 0 })), c({ type: 2, focus: Ce.First });
        break;
      case X.ArrowUp:
        M.preventDefault(), M.stopPropagation(), ct(() => c({ type: 0 })), c({ type: 2, focus: Ce.Last });
        break;
    }
  }), h = F((M) => {
    switch (M.key) {
      case X.Space:
        M.preventDefault();
        break;
    }
  }), m = F((M) => {
    var I;
    if (bn(M.currentTarget)) return M.preventDefault();
    i || (l.menuState === 0 ? (ct(() => c({ type: 1 })), (I = l.buttonElement) == null || I.focus({ preventScroll: !0 })) : (M.preventDefault(), c({ type: 0 })));
  }), { isFocusVisible: C, focusProps: g } = bt({ autoFocus: o }), { isHovered: v, hoverProps: b } = _t({ isDisabled: i }), { pressed: y, pressProps: x } = Xt({ disabled: i }), S = q(() => ({ open: l.menuState === 0, active: y || l.menuState === 0, disabled: i, hover: v, focus: C, autofocus: o }), [l, v, C, y, i, o]), _ = et(d(), { ref: p, id: n, type: Ca(e, l.buttonElement), "aria-haspopup": "menu", "aria-controls": (r = l.itemsElement) == null ? void 0 : r.id, "aria-expanded": l.menuState === 0, disabled: i || void 0, autoFocus: o, onKeyDown: f, onKeyUp: h, onClick: m }, g, b, x);
  return me()({ ourProps: _, theirProps: s, slot: S, defaultTag: Z9, name: "Menu.Button" });
}
let W9 = "div", $9 = pt.RenderStrategy | pt.Static;
function J9(e, t) {
  var r, a;
  let n = je(), { id: i = `headlessui-menu-items-${n}`, anchor: o, portal: s = !1, modal: l = !0, transition: c = !1, ...d } = e, p = L1(o), [f, h] = J1("Menu.Items"), [m, C] = R1(p), g = N1(), [v, b] = te(null), y = we(t, p ? m : null, F((O) => h({ type: 8, element: O })), b), x = Zt(f.itemsElement);
  p && (s = !0);
  let S = wn(), [_, M] = ba(c, v, S !== null ? (S & He.Open) === He.Open : f.menuState === 0);
  di(_, f.buttonElement, () => {
    h({ type: 1 });
  });
  let I = f.__demoMode ? !1 : l && f.menuState === 0;
  gi(I, x);
  let L = f.__demoMode ? !1 : l && f.menuState === 0;
  k1(L, { allowed: _e(() => [f.buttonElement, f.itemsElement], [f.buttonElement, f.itemsElement]) });
  let D = f.menuState !== 0, A = x3(D, f.buttonElement) ? !1 : _;
  he(() => {
    let O = f.itemsElement;
    O && f.menuState === 0 && O !== (x == null ? void 0 : x.activeElement) && O.focus({ preventScroll: !0 });
  }, [f.menuState, f.itemsElement, x]), jc(f.menuState === 0, { container: f.itemsElement, accept(O) {
    return O.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : O.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(O) {
    O.setAttribute("role", "none");
  } });
  let B = Ut(), U = F((O) => {
    var j, N, E;
    switch (B.dispose(), O.key) {
      case X.Space:
        if (f.searchQuery !== "") return O.preventDefault(), O.stopPropagation(), h({ type: 3, value: O.key });
      case X.Enter:
        if (O.preventDefault(), O.stopPropagation(), h({ type: 1 }), f.activeItemIndex !== null) {
          let { dataRef: G } = f.items[f.activeItemIndex];
          (N = (j = G.current) == null ? void 0 : j.domRef.current) == null || N.click();
        }
        Lc(f.buttonElement);
        break;
      case X.ArrowDown:
        return O.preventDefault(), O.stopPropagation(), h({ type: 2, focus: Ce.Next });
      case X.ArrowUp:
        return O.preventDefault(), O.stopPropagation(), h({ type: 2, focus: Ce.Previous });
      case X.Home:
      case X.PageUp:
        return O.preventDefault(), O.stopPropagation(), h({ type: 2, focus: Ce.First });
      case X.End:
      case X.PageDown:
        return O.preventDefault(), O.stopPropagation(), h({ type: 2, focus: Ce.Last });
      case X.Escape:
        O.preventDefault(), O.stopPropagation(), ct(() => h({ type: 1 })), (E = f.buttonElement) == null || E.focus({ preventScroll: !0 });
        break;
      case X.Tab:
        O.preventDefault(), O.stopPropagation(), ct(() => h({ type: 1 })), Ac(f.buttonElement, O.shiftKey ? Ne.Previous : Ne.Next);
        break;
      default:
        O.key.length === 1 && (h({ type: 3, value: O.key }), B.setTimeout(() => h({ type: 4 }), 350));
        break;
    }
  }), H = F((O) => {
    switch (O.key) {
      case X.Space:
        O.preventDefault();
        break;
    }
  }), K = q(() => ({ open: f.menuState === 0 }), [f.menuState]), Z = et(p ? g() : {}, { "aria-activedescendant": f.activeItemIndex === null || (r = f.items[f.activeItemIndex]) == null ? void 0 : r.id, "aria-labelledby": (a = f.buttonElement) == null ? void 0 : a.id, id: i, onKeyDown: U, onKeyUp: H, role: "menu", tabIndex: f.menuState === 0 ? 0 : void 0, ref: y, style: { ...d.style, ...C, "--button-width": Gr(f.buttonElement, !0).width }, ...va(M) }), V = me();
  return w.createElement(sr, { enabled: s ? e.static || _ : !1 }, V({ ourProps: Z, theirProps: d, slot: K, defaultTag: W9, features: $9, visible: A, name: "Menu.Items" }));
}
let Q9 = $e;
function q9(e, t) {
  let r = je(), { id: a = `headlessui-menu-item-${r}`, disabled: n = !1, ...i } = e, [o, s] = J1("Menu.Item"), l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === a : !1, c = Q(null), d = we(t, c);
  ye(() => {
    if (!o.__demoMode && o.menuState === 0 && l && o.activationTrigger !== 0) return Rt().requestAnimationFrame(() => {
      var A, B;
      (B = (A = c.current) == null ? void 0 : A.scrollIntoView) == null || B.call(A, { block: "nearest" });
    });
  }, [o.__demoMode, c, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  let p = M3(c), f = Q({ disabled: n, domRef: c, get textValue() {
    return p();
  } });
  ye(() => {
    f.current.disabled = n;
  }, [f, n]), ye(() => (s({ type: 5, id: a, dataRef: f }), () => s({ type: 6, id: a })), [f, a]);
  let h = F(() => {
    s({ type: 1 });
  }), m = F((A) => {
    if (n) return A.preventDefault();
    s({ type: 1 }), Lc(o.buttonElement);
  }), C = F(() => {
    if (n) return s({ type: 2, focus: Ce.Nothing });
    s({ type: 2, focus: Ce.Specific, id: a });
  }), g = Hs(), v = F((A) => {
    g.update(A), !n && (l || s({ type: 2, focus: Ce.Specific, id: a, trigger: 0 }));
  }), b = F((A) => {
    g.wasMoved(A) && (n || l || s({ type: 2, focus: Ce.Specific, id: a, trigger: 0 }));
  }), y = F((A) => {
    g.wasMoved(A) && (n || l && s({ type: 2, focus: Ce.Nothing }));
  }), [x, S] = Ln(), [_, M] = er(), I = q(() => ({ active: l, focus: l, disabled: n, close: h }), [l, n, h]), L = { id: a, ref: d, role: "menuitem", tabIndex: n === !0 ? void 0 : -1, "aria-disabled": n === !0 ? !0 : void 0, "aria-labelledby": x, "aria-describedby": _, disabled: void 0, onClick: m, onFocus: C, onPointerEnter: v, onMouseEnter: v, onPointerMove: b, onMouseMove: b, onPointerLeave: y, onMouseLeave: y }, D = me();
  return w.createElement(S, null, w.createElement(M, null, D({ ourProps: L, theirProps: i, slot: I, defaultTag: Q9, name: "Menu.Item" })));
}
let X9 = "div";
function ep(e, t) {
  let [r, a] = Ln(), n = e, i = { ref: t, "aria-labelledby": r, role: "group" }, o = me();
  return w.createElement(a, null, o({ ourProps: i, theirProps: n, slot: {}, defaultTag: X9, name: "Menu.Section" }));
}
let tp = "header";
function np(e, t) {
  let r = je(), { id: a = `headlessui-menu-heading-${r}`, ...n } = e, i = Os();
  ye(() => i.register(a), [a, i.register]);
  let o = { id: a, ref: t, role: "presentation", ...i.props };
  return me()({ ourProps: o, theirProps: n, slot: {}, defaultTag: tp, name: "Menu.Heading" });
}
let ap = "div";
function rp(e, t) {
  let r = e, a = { ref: t, role: "separator" };
  return me()({ ourProps: a, theirProps: r, slot: {}, defaultTag: ap, name: "Menu.Separator" });
}
let ip = pe(U9), ll = pe(Y9), ul = pe(J9), cl = pe(q9), E3 = pe(ep), D3 = pe(np), I3 = pe(rp), L3 = Object.assign(ip, { Button: ll, Items: ul, Item: cl, Section: E3, Heading: D3, Separator: I3 });
var op = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(op || {}), sp = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(sp || {});
let lp = { 0: (e) => ({ ...e, popoverState: Ee(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, dl = Le(null);
dl.displayName = "PopoverContext";
function Q1(e) {
  let t = xe(dl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Q1), r;
  }
  return t;
}
let q1 = Le(null);
q1.displayName = "PopoverAPIContext";
function pl(e) {
  let t = xe(q1);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, pl), r;
  }
  return t;
}
let fl = Le(null);
fl.displayName = "PopoverGroupContext";
function A3() {
  return xe(fl);
}
let X1 = Le(null);
X1.displayName = "PopoverPanelContext";
function up() {
  return xe(X1);
}
function cp(e, t) {
  return Ee(t.type, lp, e, t);
}
let dp = "div";
function pp(e, t) {
  var r;
  let { __demoMode: a = !1, ...n } = e, i = Q(null), o = we(t, Rs((j) => {
    i.current = j;
  })), s = Q([]), l = Dn(cp, { __demoMode: a, popoverState: a ? 0 : 1, buttons: s, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: ra(), afterPanelSentinel: ra(), afterButtonSentinel: ra() }), [{ popoverState: c, button: d, buttonId: p, panel: f, panelId: h, beforePanelSentinel: m, afterPanelSentinel: C, afterButtonSentinel: g }, v] = l, b = Zt((r = i.current) != null ? r : d), y = q(() => {
    if (!d || !f) return !1;
    for (let W of document.querySelectorAll("body > *")) if (Number(W == null ? void 0 : W.contains(d)) ^ Number(W == null ? void 0 : W.contains(f))) return !0;
    let j = pi(), N = j.indexOf(d), E = (N + j.length - 1) % j.length, G = (N + 1) % j.length, R = j[E], $ = j[G];
    return !f.contains(R) && !f.contains($);
  }, [d, f]), x = Ct(p), S = Ct(h), _ = q(() => ({ buttonId: x, panelId: S, close: () => v({ type: 1 }) }), [x, S, v]), M = A3(), I = M == null ? void 0 : M.registerPopover, L = F(() => {
    var j;
    return (j = M == null ? void 0 : M.isFocusWithinPopoverGroup()) != null ? j : (b == null ? void 0 : b.activeElement) && ((d == null ? void 0 : d.contains(b.activeElement)) || (f == null ? void 0 : f.contains(b.activeElement)));
  });
  he(() => I == null ? void 0 : I(_), [I, _]);
  let [D, A] = o3(), B = Js(d), U = c3({ mainTreeNode: B, portals: D, defaultContainers: [d, f] });
  P1(b == null ? void 0 : b.defaultView, "focus", (j) => {
    var N, E, G, R, $, W;
    j.target !== window && j.target instanceof HTMLElement && c === 0 && (L() || d && f && (U.contains(j.target) || (E = (N = m.current) == null ? void 0 : N.contains) != null && E.call(N, j.target) || (R = (G = C.current) == null ? void 0 : G.contains) != null && R.call(G, j.target) || (W = ($ = g.current) == null ? void 0 : $.contains) != null && W.call($, j.target) || v({ type: 1 })));
  }, !0), mi(c === 0, U.resolveContainers, (j, N) => {
    v({ type: 1 }), hi(N, fi.Loose) || (j.preventDefault(), d == null || d.focus());
  });
  let H = F((j) => {
    v({ type: 1 });
    let N = j ? j instanceof HTMLElement ? j : "current" in j && j.current instanceof HTMLElement ? j.current : d : d;
    N == null || N.focus();
  }), K = q(() => ({ close: H, isPortalled: y }), [H, y]), Z = q(() => ({ open: c === 0, close: H }), [c, H]), V = { ref: o }, O = me();
  return w.createElement(t1, { node: B }, w.createElement(O1, null, w.createElement(X1.Provider, { value: null }, w.createElement(dl.Provider, { value: l }, w.createElement(q1.Provider, { value: K }, w.createElement(Bs, { value: H }, w.createElement(or, { value: Ee(c, { 0: He.Open, 1: He.Closed }) }, w.createElement(A, null, O({ ourProps: V, theirProps: n, slot: Z, defaultTag: dp, name: "Popover" })))))))));
}
let fp = "button";
function hp(e, t) {
  let r = je(), { id: a = `headlessui-popover-button-${r}`, disabled: n = !1, autoFocus: i = !1, ...o } = e, [s, l] = Q1("Popover.Button"), { isPortalled: c } = pl("Popover.Button"), d = Q(null), p = `headlessui-focus-sentinel-${je()}`, f = A3(), h = f == null ? void 0 : f.closeOthers, m = up() !== null;
  he(() => {
    if (!m) return l({ type: 3, buttonId: a }), () => {
      l({ type: 3, buttonId: null });
    };
  }, [m, a, l]);
  let [C] = te(() => Symbol()), g = we(d, t, A1(), F((N) => {
    if (!m) {
      if (N) s.buttons.current.push(C);
      else {
        let E = s.buttons.current.indexOf(C);
        E !== -1 && s.buttons.current.splice(E, 1);
      }
      s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), N && l({ type: 2, button: N });
    }
  })), v = we(d, t), b = Zt(d), y = F((N) => {
    var E, G, R;
    if (m) {
      if (s.popoverState === 1) return;
      switch (N.key) {
        case X.Space:
        case X.Enter:
          N.preventDefault(), (G = (E = N.target).click) == null || G.call(E), l({ type: 1 }), (R = s.button) == null || R.focus();
          break;
      }
    } else switch (N.key) {
      case X.Space:
      case X.Enter:
        N.preventDefault(), N.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 });
        break;
      case X.Escape:
        if (s.popoverState !== 0) return h == null ? void 0 : h(s.buttonId);
        if (!d.current || b != null && b.activeElement && !d.current.contains(b.activeElement)) return;
        N.preventDefault(), N.stopPropagation(), l({ type: 1 });
        break;
    }
  }), x = F((N) => {
    m || N.key === X.Space && N.preventDefault();
  }), S = F((N) => {
    var E, G;
    bn(N.currentTarget) || n || (m ? (l({ type: 1 }), (E = s.button) == null || E.focus()) : (N.preventDefault(), N.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 }), (G = s.button) == null || G.focus()));
  }), _ = F((N) => {
    N.preventDefault(), N.stopPropagation();
  }), { isFocusVisible: M, focusProps: I } = bt({ autoFocus: i }), { isHovered: L, hoverProps: D } = _t({ isDisabled: n }), { pressed: A, pressProps: B } = Xt({ disabled: n }), U = s.popoverState === 0, H = q(() => ({ open: U, active: A || U, disabled: n, hover: L, focus: M, autofocus: i }), [U, L, M, A, n, i]), K = Ca(e, s.button), Z = et(m ? { ref: v, type: K, onKeyDown: y, onClick: S, disabled: n || void 0, autoFocus: i } : { ref: g, id: s.buttonId, type: K, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, disabled: n || void 0, autoFocus: i, onKeyDown: y, onKeyUp: x, onClick: S, onMouseDown: _ }, I, D, B), V = Qs(), O = F(() => {
    let N = s.panel;
    if (!N) return;
    function E() {
      Ee(V.current, { [At.Forwards]: () => ot(N, Ne.First), [At.Backwards]: () => ot(N, Ne.Last) }) === Ht.Error && ot(pi().filter((G) => G.dataset.headlessuiFocusGuard !== "true"), Ee(V.current, { [At.Forwards]: Ne.Next, [At.Backwards]: Ne.Previous }), { relativeTo: s.button });
    }
    E();
  }), j = me();
  return w.createElement(w.Fragment, null, j({ ourProps: Z, theirProps: o, slot: H, defaultTag: fp, name: "Popover.Button" }), U && !m && c && w.createElement(Jt, { id: p, ref: s.afterButtonSentinel, features: $t.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: O }));
}
let mp = "div", gp = pt.RenderStrategy | pt.Static;
function N3(e, t) {
  let r = je(), { id: a = `headlessui-popover-backdrop-${r}`, transition: n = !1, ...i } = e, [{ popoverState: o }, s] = Q1("Popover.Backdrop"), [l, c] = te(null), d = we(t, c), p = wn(), [f, h] = ba(n, l, p !== null ? (p & He.Open) === He.Open : o === 0), m = F((v) => {
    if (bn(v.currentTarget)) return v.preventDefault();
    s({ type: 1 });
  }), C = q(() => ({ open: o === 0 }), [o]), g = { ref: d, id: a, "aria-hidden": !0, onClick: m, ...va(h) };
  return me()({ ourProps: g, theirProps: i, slot: C, defaultTag: mp, features: gp, visible: f, name: "Popover.Backdrop" });
}
let Cp = "div", vp = pt.RenderStrategy | pt.Static;
function bp(e, t) {
  let r = je(), { id: a = `headlessui-popover-panel-${r}`, focus: n = !1, anchor: i, portal: o = !1, modal: s = !1, transition: l = !1, ...c } = e, [d, p] = Q1("Popover.Panel"), { close: f, isPortalled: h } = pl("Popover.Panel"), m = `headlessui-focus-sentinel-before-${r}`, C = `headlessui-focus-sentinel-after-${r}`, g = Q(null), v = L1(i), [b, y] = R1(v), x = N1();
  v && (o = !0);
  let [S, _] = te(null), M = we(g, t, v ? b : null, F((N) => p({ type: 4, panel: N })), _), I = Zt(g);
  ye(() => (p({ type: 5, panelId: a }), () => {
    p({ type: 5, panelId: null });
  }), [a, p]);
  let L = wn(), [D, A] = ba(l, S, L !== null ? (L & He.Open) === He.Open : d.popoverState === 0);
  di(D, d.button, () => {
    p({ type: 1 });
  });
  let B = d.__demoMode ? !1 : s && D;
  gi(B, I);
  let U = F((N) => {
    var E;
    switch (N.key) {
      case X.Escape:
        if (d.popoverState !== 0 || !g.current || I != null && I.activeElement && !g.current.contains(I.activeElement)) return;
        N.preventDefault(), N.stopPropagation(), p({ type: 1 }), (E = d.button) == null || E.focus();
        break;
    }
  });
  he(() => {
    var N;
    e.static || d.popoverState === 1 && ((N = e.unmount) == null || N) && p({ type: 4, panel: null });
  }, [d.popoverState, e.unmount, e.static, p]), he(() => {
    if (d.__demoMode || !n || d.popoverState !== 0 || !g.current) return;
    let N = I == null ? void 0 : I.activeElement;
    g.current.contains(N) || ot(g.current, Ne.First);
  }, [d.__demoMode, n, g.current, d.popoverState]);
  let H = q(() => ({ open: d.popoverState === 0, close: f }), [d.popoverState, f]), K = et(v ? x() : {}, { ref: M, id: a, onKeyDown: U, onBlur: n && d.popoverState === 0 ? (N) => {
    var E, G, R, $, W;
    let re = N.relatedTarget;
    re && g.current && ((E = g.current) != null && E.contains(re) || (p({ type: 1 }), ((R = (G = d.beforePanelSentinel.current) == null ? void 0 : G.contains) != null && R.call(G, re) || (W = ($ = d.afterPanelSentinel.current) == null ? void 0 : $.contains) != null && W.call($, re)) && re.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...c.style, ...y, "--button-width": Gr(d.button, !0).width }, ...va(A) }), Z = Qs(), V = F(() => {
    let N = g.current;
    if (!N) return;
    function E() {
      Ee(Z.current, { [At.Forwards]: () => {
        var G;
        ot(N, Ne.First) === Ht.Error && ((G = d.afterPanelSentinel.current) == null || G.focus());
      }, [At.Backwards]: () => {
        var G;
        (G = d.button) == null || G.focus({ preventScroll: !0 });
      } });
    }
    E();
  }), O = F(() => {
    let N = g.current;
    if (!N) return;
    function E() {
      Ee(Z.current, { [At.Forwards]: () => {
        if (!d.button) return;
        let G = pi(), R = G.indexOf(d.button), $ = G.slice(0, R + 1), W = [...G.slice(R + 1), ...$];
        for (let re of W.slice()) if (re.dataset.headlessuiFocusGuard === "true" || S != null && S.contains(re)) {
          let ae = W.indexOf(re);
          ae !== -1 && W.splice(ae, 1);
        }
        ot(W, Ne.First, { sorted: !1 });
      }, [At.Backwards]: () => {
        var G;
        ot(N, Ne.Previous) === Ht.Error && ((G = d.button) == null || G.focus());
      } });
    }
    E();
  }), j = me();
  return w.createElement(Us, null, w.createElement(X1.Provider, { value: a }, w.createElement(q1.Provider, { value: { close: f, isPortalled: h } }, w.createElement(sr, { enabled: o ? e.static || D : !1 }, D && h && w.createElement(Jt, { id: m, ref: d.beforePanelSentinel, features: $t.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: V }), j({ ourProps: K, theirProps: c, slot: H, defaultTag: Cp, features: vp, visible: D, name: "Popover.Panel" }), D && h && w.createElement(Jt, { id: C, ref: d.afterPanelSentinel, features: $t.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: O })))));
}
let yp = "div";
function wp(e, t) {
  let r = Q(null), a = we(r, t), [n, i] = te([]), o = F((C) => {
    i((g) => {
      let v = g.indexOf(C);
      if (v !== -1) {
        let b = g.slice();
        return b.splice(v, 1), b;
      }
      return g;
    });
  }), s = F((C) => (i((g) => [...g, C]), () => o(C))), l = F(() => {
    var C;
    let g = zt(r);
    if (!g) return !1;
    let v = g.activeElement;
    return (C = r.current) != null && C.contains(v) ? !0 : n.some((b) => {
      var y, x;
      return ((y = g.getElementById(b.buttonId.current)) == null ? void 0 : y.contains(v)) || ((x = g.getElementById(b.panelId.current)) == null ? void 0 : x.contains(v));
    });
  }), c = F((C) => {
    for (let g of n) g.buttonId.current !== C && g.close();
  }), d = q(() => ({ registerPopover: s, unregisterPopover: o, isFocusWithinPopoverGroup: l, closeOthers: c }), [s, o, l, c]), p = q(() => ({}), []), f = e, h = { ref: a }, m = me();
  return w.createElement(t1, null, w.createElement(fl.Provider, { value: d }, m({ ourProps: h, theirProps: f, slot: p, defaultTag: yp, name: "Popover.Group" })));
}
let Sp = pe(pp), eo = pe(hp), R3 = pe(N3), O3 = pe(N3), to = pe(bp), B3 = pe(wp), hl = Object.assign(Sp, { Button: eo, Backdrop: O3, Overlay: R3, Panel: to, Group: B3 });
var _p = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(_p || {});
let xp = { 0(e, t) {
  let r = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: ln(r, (a) => a.element.current) };
}, 1(e, t) {
  let r = e.options.slice(), a = e.options.findIndex((n) => n.id === t.id);
  return a === -1 ? e : (r.splice(a, 1), { ...e, options: r });
} }, ml = Le(null);
ml.displayName = "RadioGroupDataContext";
function gl(e) {
  let t = xe(ml);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, gl), r;
  }
  return t;
}
let Cl = Le(null);
Cl.displayName = "RadioGroupActionsContext";
function vl(e) {
  let t = xe(Cl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, vl), r;
  }
  return t;
}
function Mp(e, t) {
  return Ee(t.type, xp, e, t);
}
let kp = "div";
function Pp(e, t) {
  let r = je(), a = Lt(), { id: n = `headlessui-radiogroup-${r}`, value: i, form: o, name: s, onChange: l, by: c, disabled: d = a || !1, defaultValue: p, ...f } = e, h = js(c), [m, C] = Dn(Mp, { options: [] }), g = m.options, [v, b] = Ln(), [y, x] = er(), S = Q(null), _ = we(S, t), M = li(p), [I, L] = si(i, l, M), D = q(() => g.find((E) => !E.propsRef.current.disabled), [g]), A = q(() => g.some((E) => h(E.propsRef.current.value, I)), [g, I]), B = F((E) => {
    var G;
    if (d || h(E, I)) return !1;
    let R = (G = g.find(($) => h($.propsRef.current.value, E))) == null ? void 0 : G.propsRef.current;
    return R != null && R.disabled ? !1 : (L == null || L(E), !0);
  }), U = F((E) => {
    let G = S.current;
    if (!G) return;
    let R = zt(G), $ = g.filter((W) => W.propsRef.current.disabled === !1).map((W) => W.element.current);
    switch (E.key) {
      case X.Enter:
        _1(E.currentTarget);
        break;
      case X.ArrowLeft:
      case X.ArrowUp:
        if (E.preventDefault(), E.stopPropagation(), ot($, Ne.Previous | Ne.WrapAround) === Ht.Success) {
          let W = g.find((re) => re.element.current === (R == null ? void 0 : R.activeElement));
          W && B(W.propsRef.current.value);
        }
        break;
      case X.ArrowRight:
      case X.ArrowDown:
        if (E.preventDefault(), E.stopPropagation(), ot($, Ne.Next | Ne.WrapAround) === Ht.Success) {
          let W = g.find((re) => re.element.current === (R == null ? void 0 : R.activeElement));
          W && B(W.propsRef.current.value);
        }
        break;
      case X.Space:
        {
          E.preventDefault(), E.stopPropagation();
          let W = g.find((re) => re.element.current === (R == null ? void 0 : R.activeElement));
          W && B(W.propsRef.current.value);
        }
        break;
    }
  }), H = F((E) => (C({ type: 0, ...E }), () => C({ type: 1, id: E.id }))), K = q(() => ({ value: I, firstOption: D, containsCheckedOption: A, disabled: d, compare: h, ...m }), [I, D, A, d, h, m]), Z = q(() => ({ registerOption: H, change: B }), [H, B]), V = { ref: _, id: n, role: "radiogroup", "aria-labelledby": v, "aria-describedby": y, onKeyDown: U }, O = q(() => ({ value: I }), [I]), j = _e(() => {
    if (M !== void 0) return B(M);
  }, [B, M]), N = me();
  return w.createElement(x, { name: "RadioGroup.Description" }, w.createElement(b, { name: "RadioGroup.Label" }, w.createElement(Cl.Provider, { value: Z }, w.createElement(ml.Provider, { value: K }, s != null && w.createElement(ui, { disabled: d, data: { [s]: I || "on" }, overrides: { type: "radio", checked: I != null }, form: o, onReset: j }), N({ ourProps: V, theirProps: f, slot: O, defaultTag: kp, name: "RadioGroup" })))));
}
let Tp = "div";
function Ep(e, t) {
  var r;
  let a = gl("RadioGroup.Option"), n = vl("RadioGroup.Option"), i = je(), { id: o = `headlessui-radiogroup-option-${i}`, value: s, disabled: l = a.disabled || !1, autoFocus: c = !1, ...d } = e, p = Q(null), f = we(p, t), [h, m] = Ln(), [C, g] = er(), v = Ct({ value: s, disabled: l });
  ye(() => n.registerOption({ id: o, element: p, propsRef: v }), [o, n, p, v]);
  let b = F((B) => {
    var U;
    if (bn(B.currentTarget)) return B.preventDefault();
    n.change(s) && ((U = p.current) == null || U.focus());
  }), y = ((r = a.firstOption) == null ? void 0 : r.id) === o, { isFocusVisible: x, focusProps: S } = bt({ autoFocus: c }), { isHovered: _, hoverProps: M } = _t({ isDisabled: l }), I = a.compare(a.value, s), L = et({ ref: f, id: o, role: "radio", "aria-checked": I ? "true" : "false", "aria-labelledby": h, "aria-describedby": C, "aria-disabled": l ? !0 : void 0, tabIndex: l ? -1 : I || !a.containsCheckedOption && y ? 0 : -1, onClick: l ? void 0 : b, autoFocus: c }, S, M), D = q(() => ({ checked: I, disabled: l, active: x, hover: _, focus: x, autofocus: c }), [I, l, _, x, c]), A = me();
  return w.createElement(g, { name: "RadioGroup.Description" }, w.createElement(m, { name: "RadioGroup.Label" }, A({ ourProps: L, theirProps: d, slot: D, defaultTag: Tp, name: "RadioGroup.Option" })));
}
let Dp = "span";
function Ip(e, t) {
  var r;
  let a = gl("Radio"), n = vl("Radio"), i = je(), o = In(), s = Lt(), { id: l = o || `headlessui-radio-${i}`, value: c, disabled: d = a.disabled || s || !1, autoFocus: p = !1, ...f } = e, h = Q(null), m = we(h, t), C = en(), g = Wn(), v = Ct({ value: c, disabled: d });
  ye(() => n.registerOption({ id: l, element: h, propsRef: v }), [l, n, h, v]);
  let b = F((A) => {
    var B;
    if (bn(A.currentTarget)) return A.preventDefault();
    n.change(c) && ((B = h.current) == null || B.focus());
  }), { isFocusVisible: y, focusProps: x } = bt({ autoFocus: p }), { isHovered: S, hoverProps: _ } = _t({ isDisabled: d }), M = ((r = a.firstOption) == null ? void 0 : r.id) === l, I = a.compare(a.value, c), L = et({ ref: m, id: l, role: "radio", "aria-checked": I ? "true" : "false", "aria-labelledby": C, "aria-describedby": g, "aria-disabled": d ? !0 : void 0, tabIndex: d ? -1 : I || !a.containsCheckedOption && M ? 0 : -1, autoFocus: p, onClick: d ? void 0 : b }, x, _), D = q(() => ({ checked: I, disabled: d, hover: S, focus: y, autofocus: p }), [I, d, S, y, p]);
  return me()({ ourProps: L, theirProps: f, slot: D, defaultTag: Dp, name: "Radio" });
}
let Lp = pe(Pp), j3 = pe(Ep), H3 = pe(Ip), F3 = tr, G3 = ci, Ap = Object.assign(Lp, { Option: j3, Radio: H3, Label: F3, Description: G3 }), Np = "select";
function Rp(e, t) {
  let r = je(), a = In(), n = Lt(), { id: i = a || `headlessui-select-${r}`, disabled: o = n || !1, invalid: s = !1, autoFocus: l = !1, ...c } = e, d = en(), p = Wn(), { isFocusVisible: f, focusProps: h } = bt({ autoFocus: l }), { isHovered: m, hoverProps: C } = _t({ isDisabled: o }), { pressed: g, pressProps: v } = Xt({ disabled: o }), b = et({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": p, "aria-invalid": s ? "" : void 0, disabled: o || void 0, autoFocus: l }, h, C, v), y = q(() => ({ disabled: o, invalid: s, hover: m, focus: f, active: g, autofocus: l }), [o, s, m, f, g, l]);
  return me()({ ourProps: b, theirProps: c, slot: y, defaultTag: Np, name: "Select" });
}
let Op = pe(Rp), bl = Le(null);
bl.displayName = "GroupContext";
let Bp = $e;
function jp(e) {
  var t;
  let [r, a] = te(null), [n, i] = Ln(), [o, s] = er(), l = q(() => ({ switch: r, setSwitch: a }), [r, a]), c = {}, d = e, p = me();
  return w.createElement(s, { name: "Switch.Description", value: o }, w.createElement(i, { name: "Switch.Label", value: n, props: { htmlFor: (t = l.switch) == null ? void 0 : t.id, onClick(f) {
    r && (f.currentTarget instanceof HTMLLabelElement && f.preventDefault(), r.click(), r.focus({ preventScroll: !0 }));
  } } }, w.createElement(bl.Provider, { value: l }, p({ ourProps: c, theirProps: d, slot: {}, defaultTag: Bp, name: "Switch.Group" }))));
}
let Hp = "button";
function Fp(e, t) {
  var r;
  let a = je(), n = In(), i = Lt(), { id: o = n || `headlessui-switch-${a}`, disabled: s = i || !1, checked: l, defaultChecked: c, onChange: d, name: p, value: f, form: h, autoFocus: m = !1, ...C } = e, g = xe(bl), [v, b] = te(null), y = Q(null), x = we(y, t, g === null ? null : g.setSwitch, b), S = li(c), [_, M] = si(l, d, S ?? !1), I = Ut(), [L, D] = te(!1), A = F(() => {
    D(!0), M == null || M(!_), I.nextFrame(() => {
      D(!1);
    });
  }), B = F((ae) => {
    if (bn(ae.currentTarget)) return ae.preventDefault();
    ae.preventDefault(), A();
  }), U = F((ae) => {
    ae.key === X.Space ? (ae.preventDefault(), A()) : ae.key === X.Enter && _1(ae.currentTarget);
  }), H = F((ae) => ae.preventDefault()), K = en(), Z = Wn(), { isFocusVisible: V, focusProps: O } = bt({ autoFocus: m }), { isHovered: j, hoverProps: N } = _t({ isDisabled: s }), { pressed: E, pressProps: G } = Xt({ disabled: s }), R = q(() => ({ checked: _, disabled: s, hover: j, focus: V, active: E, autofocus: m, changing: L }), [_, j, V, E, s, L, m]), $ = et({ id: o, ref: x, role: "switch", type: Ca(e, v), tabIndex: e.tabIndex === -1 ? 0 : (r = e.tabIndex) != null ? r : 0, "aria-checked": _, "aria-labelledby": K, "aria-describedby": Z, disabled: s || void 0, autoFocus: m, onClick: B, onKeyUp: U, onKeyPress: H }, O, N, G), W = _e(() => {
    if (S !== void 0) return M == null ? void 0 : M(S);
  }, [M, S]), re = me();
  return w.createElement(w.Fragment, null, p != null && w.createElement(ui, { disabled: s, data: { [p]: f || "on" }, overrides: { type: "checkbox", checked: _ }, form: h, onReset: W }), re({ ourProps: $, theirProps: C, slot: R, defaultTag: Hp, name: "Switch" }));
}
let Gp = pe(Fp), V3 = jp, K3 = tr, z3 = ci, U3 = Object.assign(Gp, { Group: V3, Label: K3, Description: z3 });
function Vp({ onFocus: e }) {
  let [t, r] = te(!0), a = F1();
  return t ? w.createElement(Jt, { as: "button", type: "button", features: $t.Focusable, onFocus: (n) => {
    n.preventDefault();
    let i, o = 50;
    function s() {
      if (o-- <= 0) {
        i && cancelAnimationFrame(i);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(i), !a.current) return;
        r(!1);
        return;
      }
      i = requestAnimationFrame(s);
    }
    i = requestAnimationFrame(s);
  } }) : null;
}
const Z3 = Y.createContext(null);
function Kp() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var r;
    let a = this.groups.get(e);
    a || (a = /* @__PURE__ */ new Map(), this.groups.set(e, a));
    let n = (r = a.get(t)) != null ? r : 0;
    a.set(t, n + 1);
    let i = Array.from(a.keys()).indexOf(t);
    function o() {
      let s = a.get(t);
      s > 1 ? a.set(t, s - 1) : a.delete(t);
    }
    return [i, o];
  } };
}
function zp({ children: e }) {
  let t = Y.useRef(Kp());
  return Y.createElement(Z3.Provider, { value: t }, e);
}
function Y3(e) {
  let t = Y.useContext(Z3);
  if (!t) throw new Error("You must wrap your component in a <StableCollection>");
  let r = Y.useId(), [a, n] = t.current.get(e, r);
  return Y.useEffect(() => n, []), a;
}
var Up = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Up || {}), Zp = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(Zp || {}), Yp = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(Yp || {});
let Wp = { 0(e, t) {
  var r;
  let a = ln(e.tabs, (d) => d.current), n = ln(e.panels, (d) => d.current), i = a.filter((d) => {
    var p;
    return !((p = d.current) != null && p.hasAttribute("disabled"));
  }), o = { ...e, tabs: a, panels: n };
  if (t.index < 0 || t.index > a.length - 1) {
    let d = Ee(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => Ee(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (i.length === 0) return o;
    let p = Ee(d, { 0: () => a.indexOf(i[0]), 1: () => a.indexOf(i[i.length - 1]) });
    return { ...o, selectedIndex: p === -1 ? e.selectedIndex : p };
  }
  let s = a.slice(0, t.index), l = [...a.slice(t.index), ...s].find((d) => i.includes(d));
  if (!l) return o;
  let c = (r = a.indexOf(l)) != null ? r : e.selectedIndex;
  return c === -1 && (c = e.selectedIndex), { ...o, selectedIndex: c };
}, 1(e, t) {
  if (e.tabs.includes(t.tab)) return e;
  let r = e.tabs[e.selectedIndex], a = ln([...e.tabs, t.tab], (i) => i.current), n = e.selectedIndex;
  return e.info.current.isControlled || (n = a.indexOf(r), n === -1 && (n = e.selectedIndex)), { ...e, tabs: a, selectedIndex: n };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((r) => r !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: ln([...e.panels, t.panel], (r) => r.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((r) => r !== t.panel) };
} }, yl = Le(null);
yl.displayName = "TabsDataContext";
function Va(e) {
  let t = xe(yl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Va), r;
  }
  return t;
}
let wl = Le(null);
wl.displayName = "TabsActionsContext";
function Sl(e) {
  let t = xe(wl);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Sl), r;
  }
  return t;
}
function $p(e, t) {
  return Ee(t.type, Wp, e, t);
}
let Jp = "div";
function Qp(e, t) {
  let { defaultIndex: r = 0, vertical: a = !1, manual: n = !1, onChange: i, selectedIndex: o = null, ...s } = e;
  const l = a ? "vertical" : "horizontal", c = n ? "manual" : "auto";
  let d = o !== null, p = Ct({ isControlled: d }), f = we(t), [h, m] = Dn($p, { info: p, selectedIndex: o ?? r, tabs: [], panels: [] }), C = q(() => ({ selectedIndex: h.selectedIndex }), [h.selectedIndex]), g = Ct(i || (() => {
  })), v = Ct(h.tabs), b = q(() => ({ orientation: l, activation: c, ...h }), [l, c, h]), y = F((D) => (m({ type: 1, tab: D }), () => m({ type: 2, tab: D }))), x = F((D) => (m({ type: 3, panel: D }), () => m({ type: 4, panel: D }))), S = F((D) => {
    _.current !== D && g.current(D), d || m({ type: 0, index: D });
  }), _ = Ct(d ? e.selectedIndex : h.selectedIndex), M = q(() => ({ registerTab: y, registerPanel: x, change: S }), []);
  ye(() => {
    m({ type: 0, index: o ?? r });
  }, [o]), ye(() => {
    if (_.current === void 0 || h.tabs.length <= 0) return;
    let D = ln(h.tabs, (A) => A.current);
    D.some((A, B) => h.tabs[B] !== A) && S(D.indexOf(h.tabs[_.current]));
  });
  let I = { ref: f }, L = me();
  return w.createElement(zp, null, w.createElement(wl.Provider, { value: M }, w.createElement(yl.Provider, { value: b }, b.tabs.length <= 0 && w.createElement(Vp, { onFocus: () => {
    var D, A;
    for (let B of v.current) if (((D = B.current) == null ? void 0 : D.tabIndex) === 0) return (A = B.current) == null || A.focus(), !0;
    return !1;
  } }), L({ ourProps: I, theirProps: s, slot: C, defaultTag: Jp, name: "Tabs" }))));
}
let qp = "div";
function Xp(e, t) {
  let { orientation: r, selectedIndex: a } = Va("Tab.List"), n = we(t), i = q(() => ({ selectedIndex: a }), [a]), o = e, s = { ref: n, role: "tablist", "aria-orientation": r };
  return me()({ ourProps: s, theirProps: o, slot: i, defaultTag: qp, name: "Tabs.List" });
}
let ef = "button";
function tf(e, t) {
  var r, a;
  let n = je(), { id: i = `headlessui-tabs-tab-${n}`, disabled: o = !1, autoFocus: s = !1, ...l } = e, { orientation: c, activation: d, selectedIndex: p, tabs: f, panels: h } = Va("Tab"), m = Sl("Tab"), C = Va("Tab"), [g, v] = te(null), b = Q(null), y = we(b, t, v);
  ye(() => m.registerTab(b), [m, b]);
  let x = Y3("tabs"), S = f.indexOf(b);
  S === -1 && (S = x);
  let _ = S === p, M = F((N) => {
    var E;
    let G = N();
    if (G === Ht.Success && d === "auto") {
      let R = (E = zt(b)) == null ? void 0 : E.activeElement, $ = C.tabs.findIndex((W) => W.current === R);
      $ !== -1 && m.change($);
    }
    return G;
  }), I = F((N) => {
    let E = f.map((G) => G.current).filter(Boolean);
    if (N.key === X.Space || N.key === X.Enter) {
      N.preventDefault(), N.stopPropagation(), m.change(S);
      return;
    }
    switch (N.key) {
      case X.Home:
      case X.PageUp:
        return N.preventDefault(), N.stopPropagation(), M(() => ot(E, Ne.First));
      case X.End:
      case X.PageDown:
        return N.preventDefault(), N.stopPropagation(), M(() => ot(E, Ne.Last));
    }
    if (M(() => Ee(c, { vertical() {
      return N.key === X.ArrowUp ? ot(E, Ne.Previous | Ne.WrapAround) : N.key === X.ArrowDown ? ot(E, Ne.Next | Ne.WrapAround) : Ht.Error;
    }, horizontal() {
      return N.key === X.ArrowLeft ? ot(E, Ne.Previous | Ne.WrapAround) : N.key === X.ArrowRight ? ot(E, Ne.Next | Ne.WrapAround) : Ht.Error;
    } })) === Ht.Success) return N.preventDefault();
  }), L = Q(!1), D = F(() => {
    var N;
    L.current || (L.current = !0, (N = b.current) == null || N.focus({ preventScroll: !0 }), m.change(S), oi(() => {
      L.current = !1;
    }));
  }), A = F((N) => {
    N.preventDefault();
  }), { isFocusVisible: B, focusProps: U } = bt({ autoFocus: s }), { isHovered: H, hoverProps: K } = _t({ isDisabled: o }), { pressed: Z, pressProps: V } = Xt({ disabled: o }), O = q(() => ({ selected: _, hover: H, active: Z, focus: B, autofocus: s, disabled: o }), [_, H, B, Z, s, o]), j = et({ ref: y, onKeyDown: I, onMouseDown: A, onClick: D, id: i, role: "tab", type: Ca(e, g), "aria-controls": (a = (r = h[S]) == null ? void 0 : r.current) == null ? void 0 : a.id, "aria-selected": _, tabIndex: _ ? 0 : -1, disabled: o || void 0, autoFocus: s }, U, K, V);
  return me()({ ourProps: j, theirProps: l, slot: O, defaultTag: ef, name: "Tabs.Tab" });
}
let nf = "div";
function af(e, t) {
  let { selectedIndex: r } = Va("Tab.Panels"), a = we(t), n = q(() => ({ selectedIndex: r }), [r]), i = e, o = { ref: a };
  return me()({ ourProps: o, theirProps: i, slot: n, defaultTag: nf, name: "Tabs.Panels" });
}
let rf = "div", of = pt.RenderStrategy | pt.Static;
function sf(e, t) {
  var r, a, n, i;
  let o = je(), { id: s = `headlessui-tabs-panel-${o}`, tabIndex: l = 0, ...c } = e, { selectedIndex: d, tabs: p, panels: f } = Va("Tab.Panel"), h = Sl("Tab.Panel"), m = Q(null), C = we(m, t);
  ye(() => h.registerPanel(m), [h, m]);
  let g = Y3("panels"), v = f.indexOf(m);
  v === -1 && (v = g);
  let b = v === d, { isFocusVisible: y, focusProps: x } = bt(), S = q(() => ({ selected: b, focus: y }), [b, y]), _ = et({ ref: C, id: s, role: "tabpanel", "aria-labelledby": (a = (r = p[v]) == null ? void 0 : r.current) == null ? void 0 : a.id, tabIndex: b ? l : -1 }, x), M = me();
  return !b && ((n = c.unmount) == null || n) && !((i = c.static) != null && i) ? w.createElement(Jt, { "aria-hidden": "true", ..._ }) : M({ ourProps: _, theirProps: c, slot: S, defaultTag: rf, features: of, visible: b, name: "Tabs.Panel" });
}
let lf = pe(tf), W3 = pe(Qp), $3 = pe(Xp), J3 = pe(af), Q3 = pe(sf), uf = Object.assign(lf, { Group: W3, List: $3, Panels: J3, Panel: Q3 }), cf = "textarea";
function df(e, t) {
  let r = je(), a = In(), n = Lt(), { id: i = a || `headlessui-textarea-${r}`, disabled: o = n || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, d = en(), p = Wn(), { isFocused: f, focusProps: h } = bt({ autoFocus: s }), { isHovered: m, hoverProps: C } = _t({ isDisabled: o }), g = et({ ref: t, id: i, "aria-labelledby": d, "aria-describedby": p, "aria-invalid": l ? "" : void 0, disabled: o || void 0, autoFocus: s }, h, C), v = q(() => ({ disabled: o, invalid: l, hover: m, focus: f, autofocus: s }), [o, l, m, f, s]);
  return me()({ ourProps: g, theirProps: c, slot: v, defaultTag: cf, name: "Textarea" });
}
let pf = pe(df);
const px = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: bc,
  Checkbox: Yd,
  CloseButton: $d,
  Combobox: $s,
  ComboboxButton: wi,
  ComboboxInput: Ws,
  ComboboxLabel: u3,
  ComboboxOption: H1,
  ComboboxOptions: j1,
  DataInteractive: C8,
  Description: ci,
  Dialog: ss,
  DialogBackdrop: Y8,
  DialogDescription: W8,
  DialogPanel: b3,
  DialogTitle: y3,
  Disclosure: u9,
  DisclosureButton: S3,
  DisclosurePanel: _3,
  Field: Z1,
  Fieldset: h9,
  FocusTrap: qs,
  FocusTrapFeatures: kn,
  Input: C9,
  Label: tr,
  Legend: b9,
  Listbox: ol,
  ListboxButton: Yr,
  ListboxLabel: P3,
  ListboxOption: il,
  ListboxOptions: $1,
  ListboxSelectedOption: T3,
  Menu: L3,
  MenuButton: ll,
  MenuHeading: D3,
  MenuItem: cl,
  MenuItems: ul,
  MenuSection: E3,
  MenuSeparator: I3,
  Popover: hl,
  PopoverBackdrop: O3,
  PopoverButton: eo,
  PopoverGroup: B3,
  PopoverOverlay: R3,
  PopoverPanel: to,
  Portal: sr,
  Radio: H3,
  RadioGroup: Ap,
  RadioGroupDescription: G3,
  RadioGroupLabel: F3,
  RadioGroupOption: j3,
  Select: Op,
  Switch: U3,
  SwitchDescription: z3,
  SwitchGroup: V3,
  SwitchLabel: K3,
  Tab: uf,
  TabGroup: W3,
  TabList: $3,
  TabPanel: Q3,
  TabPanels: J3,
  Textarea: pf,
  Transition: Kn,
  TransitionChild: z1,
  useClose: Tc
}, Symbol.toStringTag, { value: "Module" })), _l = "-", ff = (e) => {
  const t = mf(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: a
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(_l);
      return s[0] === "" && s.length !== 1 && s.shift(), q3(s, t) || hf(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = r[o] || [];
      return s && a[o] ? [...l, ...a[o]] : l;
    }
  };
}, q3 = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], a = t.nextPart.get(r), n = a ? q3(e.slice(1), a) : void 0;
  if (n)
    return n;
  if (t.validators.length === 0)
    return;
  const i = e.join(_l);
  return (o = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, j2 = /^\[(.+)\]$/, hf = (e) => {
  if (j2.test(e)) {
    const t = j2.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, mf = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, a = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Cf(Object.entries(e.classGroups), r).forEach(([i, o]) => {
    ls(o, a, i, t);
  }), a;
}, ls = (e, t, r, a) => {
  e.forEach((n) => {
    if (typeof n == "string") {
      const i = n === "" ? t : H2(t, n);
      i.classGroupId = r;
      return;
    }
    if (typeof n == "function") {
      if (gf(n)) {
        ls(n(a), t, r, a);
        return;
      }
      t.validators.push({
        validator: n,
        classGroupId: r
      });
      return;
    }
    Object.entries(n).forEach(([i, o]) => {
      ls(o, H2(t, i), r, a);
    });
  });
}, H2 = (e, t) => {
  let r = e;
  return t.split(_l).forEach((a) => {
    r.nextPart.has(a) || r.nextPart.set(a, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(a);
  }), r;
}, gf = (e) => e.isThemeGetter, Cf = (e, t) => t ? e.map(([r, a]) => {
  const n = a.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [r, n];
}) : e, vf = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  const n = (i, o) => {
    r.set(i, o), t++, t > e && (t = 0, a = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = r.get(i);
      if (o !== void 0)
        return o;
      if ((o = a.get(i)) !== void 0)
        return n(i, o), o;
    },
    set(i, o) {
      r.has(i) ? r.set(i, o) : n(i, o);
    }
  };
}, X3 = "!", bf = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, a = t.length === 1, n = t[0], i = t.length, o = (s) => {
    const l = [];
    let c = 0, d = 0, p;
    for (let g = 0; g < s.length; g++) {
      let v = s[g];
      if (c === 0) {
        if (v === n && (a || s.slice(g, g + i) === t)) {
          l.push(s.slice(d, g)), d = g + i;
          continue;
        }
        if (v === "/") {
          p = g;
          continue;
        }
      }
      v === "[" ? c++ : v === "]" && c--;
    }
    const f = l.length === 0 ? s : s.substring(d), h = f.startsWith(X3), m = h ? f.substring(1) : f, C = p && p > d ? p - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: C
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: o
  }) : o;
}, yf = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((a) => {
    a[0] === "[" ? (t.push(...r.sort(), a), r = []) : r.push(a);
  }), t.push(...r.sort()), t;
}, wf = (e) => ({
  cache: vf(e.cacheSize),
  parseClassName: bf(e),
  ...ff(e)
}), Sf = /\s+/, _f = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: a,
    getConflictingClassGroupIds: n
  } = t, i = [], o = e.trim().split(Sf);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: d,
      hasImportantModifier: p,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = r(c);
    let m = !!h, C = a(m ? f.substring(0, h) : f);
    if (!C) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (C = a(f), !C) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const g = yf(d).join(":"), v = p ? g + X3 : g, b = v + C;
    if (i.includes(b))
      continue;
    i.push(b);
    const y = n(C, m);
    for (let x = 0; x < y.length; ++x) {
      const S = y[x];
      i.push(v + S);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function n1() {
  let e = 0, t, r, a = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = e0(t)) && (a && (a += " "), a += r);
  return a;
}
const e0 = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let a = 0; a < e.length; a++)
    e[a] && (t = e0(e[a])) && (r && (r += " "), r += t);
  return r;
};
function F2(e, ...t) {
  let r, a, n, i = o;
  function o(l) {
    const c = t.reduce((d, p) => p(d), e());
    return r = wf(c), a = r.cache.get, n = r.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = a(l);
    if (c)
      return c;
    const d = _f(l, r);
    return n(l, d), d;
  }
  return function() {
    return i(n1.apply(null, arguments));
  };
}
const Qe = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, t0 = /^\[(?:([a-z-]+):)?(.+)\]$/i, xf = /^\d+\/\d+$/, Mf = /* @__PURE__ */ new Set(["px", "full", "screen"]), kf = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Pf = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Tf = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Ef = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Df = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, _n = (e) => Ha(e) || Mf.has(e) || xf.test(e), An = (e) => ur(e, "length", jf), Ha = (e) => !!e && !Number.isNaN(Number(e)), Lo = (e) => ur(e, "number", Ha), yr = (e) => !!e && Number.isInteger(Number(e)), If = (e) => e.endsWith("%") && Ha(e.slice(0, -1)), Me = (e) => t0.test(e), Nn = (e) => kf.test(e), Lf = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Af = (e) => ur(e, Lf, n0), Nf = (e) => ur(e, "position", n0), Rf = /* @__PURE__ */ new Set(["image", "url"]), Of = (e) => ur(e, Rf, Ff), Bf = (e) => ur(e, "", Hf), wr = () => !0, ur = (e, t, r) => {
  const a = t0.exec(e);
  return a ? a[1] ? typeof t == "string" ? a[1] === t : t.has(a[1]) : r(a[2]) : !1;
}, jf = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Pf.test(e) && !Tf.test(e)
), n0 = () => !1, Hf = (e) => Ef.test(e), Ff = (e) => Df.test(e), G2 = () => {
  const e = Qe("colors"), t = Qe("spacing"), r = Qe("blur"), a = Qe("brightness"), n = Qe("borderColor"), i = Qe("borderRadius"), o = Qe("borderSpacing"), s = Qe("borderWidth"), l = Qe("contrast"), c = Qe("grayscale"), d = Qe("hueRotate"), p = Qe("invert"), f = Qe("gap"), h = Qe("gradientColorStops"), m = Qe("gradientColorStopPositions"), C = Qe("inset"), g = Qe("margin"), v = Qe("opacity"), b = Qe("padding"), y = Qe("saturate"), x = Qe("scale"), S = Qe("sepia"), _ = Qe("skew"), M = Qe("space"), I = Qe("translate"), L = () => ["auto", "contain", "none"], D = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", Me, t], B = () => [Me, t], U = () => ["", _n, An], H = () => ["auto", Ha, Me], K = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], Z = () => ["solid", "dashed", "dotted", "double", "none"], V = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], O = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", Me], N = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], E = () => [Ha, Me];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [wr],
      spacing: [_n, An],
      blur: ["none", "", Nn, Me],
      brightness: E(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Nn, Me],
      borderSpacing: B(),
      borderWidth: U(),
      contrast: E(),
      grayscale: j(),
      hueRotate: E(),
      invert: j(),
      gap: B(),
      gradientColorStops: [e],
      gradientColorStopPositions: [If, An],
      inset: A(),
      margin: A(),
      opacity: E(),
      padding: B(),
      saturate: E(),
      scale: E(),
      sepia: j(),
      skew: E(),
      space: B(),
      translate: B()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Me]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Nn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...K(), Me]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: L()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": L()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": L()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [C]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [C]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [C]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [C]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [C]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [C]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [C]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [C]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [C]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", yr, Me]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Me]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", yr, Me]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [wr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", yr, Me]
        }, Me]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": H()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": H()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [wr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [yr, Me]
        }, Me]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": H()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": H()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...O()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...O(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...O(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [b]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [b]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [b]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [b]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [b]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [b]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [b]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [b]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [b]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [M]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [M]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Me, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Me, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Me, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Nn]
        }, Nn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Me, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Me, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Nn, An]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Lo]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [wr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Me]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ha, Lo]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _n, Me]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Me]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Me]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", _n, An]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _n, Me]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: B()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Me]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Me]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...K(), Nf]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Af]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Of]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Z(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [n]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [n]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [n]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [n]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [n]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [n]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [n]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [n]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [n]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [n]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...Z()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_n, Me]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [_n, An]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [_n, An]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Nn, Bf]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [wr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...V(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [a]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Nn, Me]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [a]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Me]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: E()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Me]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: E()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Me]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [yr, Me]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [I]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [I]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [_]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [_]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Me]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Me]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": B()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": B()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": B()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": B()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": B()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": B()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": B()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": B()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": B()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": B()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": B()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": B()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": B()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": B()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": B()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": B()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": B()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": B()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Me]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [_n, An, Lo]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Gf = (e, {
  cacheSize: t,
  prefix: r,
  separator: a,
  experimentalParseClassName: n,
  extend: i = {},
  override: o = {}
}) => {
  Er(e, "cacheSize", t), Er(e, "prefix", r), Er(e, "separator", a), Er(e, "experimentalParseClassName", n);
  for (const s in o)
    Vf(e[s], o[s]);
  for (const s in i)
    Kf(e[s], i[s]);
  return e;
}, Er = (e, t, r) => {
  r !== void 0 && (e[t] = r);
}, Vf = (e, t) => {
  if (t)
    for (const r in t)
      Er(e, r, t[r]);
}, Kf = (e, t) => {
  if (t)
    for (const r in t) {
      const a = t[r];
      a !== void 0 && (e[r] = (e[r] || []).concat(a));
    }
}, zf = (e, ...t) => typeof e == "function" ? F2(G2, e, ...t) : F2(() => Gf(G2(), e), ...t), z = zf({
  prefix: "ui-"
});
function _i(e) {
  return /* @__PURE__ */ u.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "19", height: "16", ...e, children: /* @__PURE__ */ u.jsx("path", { d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" }) });
}
var Uf = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.big = "big", e))(Uf || {});
function fx({
  opened: e,
  onClose: t,
  children: r,
  title: a,
  size: n = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: s,
  className: l,
  contentClassName: c,
  isCentered: d,
  dialogClassName: p,
  backdropClassName: f,
  dialogContentClassName: h,
  dialogContentWrapperClassName: m,
  dialogContentWrapper1ClassName: C,
  titleClassName: g,
  closeIconWrapperClassName: v,
  closeIconClassName: b,
  ...y
}) {
  return /* @__PURE__ */ u.jsx(Kn.Root, { afterEnter: s, show: e, as: $e, children: /* @__PURE__ */ u.jsxs(
    ss,
    {
      className: z("ui-relative ui-z-10", p),
      onClose: i ? () => {
      } : t,
      children: [
        /* @__PURE__ */ u.jsx(
          Kn.Child,
          {
            as: $e,
            enter: "ui-ease-out ui-duration-300",
            enterFrom: "ui-opacity-0",
            enterTo: "ui-opacity-100",
            leave: "ui-ease-in ui-duration-200",
            leaveFrom: "ui-opacity-100",
            leaveTo: "ui-opacity-0",
            children: /* @__PURE__ */ u.jsx(
              "div",
              {
                className: z(
                  "ui-fixed ui-inset-0 ui-bg-darkblue/40 ui-bg-opacity-75 ui-transition-opacity",
                  f
                )
              }
            )
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: z(
              "ui-fixed ui-inset-0 ui-z-10 ui-overflow-y-auto",
              m
            ),
            children: /* @__PURE__ */ u.jsx(
              "div",
              {
                id: "modal-background",
                className: z(
                  "ui-flex ui-min-h-full ui-w-full ui-items-end ui-justify-center lg:ui-p-4 ui-text-center sm:ui-items-center sm:ui-p-0",
                  C
                ),
                children: /* @__PURE__ */ u.jsx(
                  Kn.Child,
                  {
                    as: $e,
                    enter: "ui-ease-out ui-duration-300",
                    enterFrom: "ui-opacity-0 ui-translate-y-4 sm:ui-translate-y-0 sm:ui-scale-95",
                    enterTo: "ui-opacity-100 ui-translate-y-0 sm:ui-scale-100",
                    leave: "ui-ease-in ui-duration-200",
                    leaveFrom: "ui-opacity-100 ui-translate-y-0 sm:ui-scale-100",
                    leaveTo: "ui-opacity-0 ui-translate-y-4 sm:ui-translate-y-0 sm:ui-scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ u.jsxs(
                      ss.Panel,
                      {
                        className: z(
                          "ui-relative ui-w-full",
                          n === "small" ? "ui-max-w-2xl" : n === "medium" ? "ui-max-w-4xl" : "ui-max-w-7xl",
                          "ui-transform ui-rounded-lg ui-bg-white ui-text-left ui-shadow-xl ui-transition-all sm:ui-my-8",
                          l
                        ),
                        ...y,
                        children: [
                          /* @__PURE__ */ u.jsxs(
                            "div",
                            {
                              className: z(
                                "ui-w-full ui-p-6 lg:ui-p-10 lg:ui-pb-0 ui-flex ui-items-start",
                                d ? "ui-justify-center" : "ui-justify-between",
                                h
                              ),
                              children: [
                                /* @__PURE__ */ u.jsx(
                                  "h3",
                                  {
                                    className: z(d ? "ui-px-6 lg:ui-px-10" : "", g),
                                    children: a
                                  }
                                ),
                                /* @__PURE__ */ u.jsx(
                                  "button",
                                  {
                                    className: z(
                                      "ui-focus-ring ui-rounded-full",
                                      d && "ui-absolute ui-top-6 lg:ui-top-10 ui-right-6 lg:ui-right-10",
                                      v
                                    ),
                                    disabled: i,
                                    onClick: t,
                                    children: /* @__PURE__ */ u.jsx(
                                      _i,
                                      {
                                        className: z(
                                          "ui-cursor-pointer",
                                          i && "ui-fill-gray ui-pointer-events-none",
                                          b
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ u.jsx(
                            "div",
                            {
                              className: z(
                                "ui-bg-white ui-p-6 lg:ui-p-10 ui-rounded-lg",
                                c
                              ),
                              children: r
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const a1 = ({ small: e = !1, type: t = "light", className: r, style: a }) => /* @__PURE__ */ u.jsxs("div", { role: "status", className: r, style: a, children: [
  /* @__PURE__ */ u.jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: `${e ? "ui-w-5 ui-h-5" : "ui-w-8 ui-h-8"} ui-animate-spin ${t === "light" ? "ui-fill-blue ui-text-white" : "ui-fill-white ui-text-darkblue"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ u.jsx("span", { className: "ui-sr-only", children: "Loading..." })
] });
function hx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      fill: "white",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 5C9 4.44772 8.55228 4 8 4C7.44771 4 7 4.44772 7 5V7H5C4.44772 7 4 7.44772 4 8C4 8.55229 4.44772 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55228 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55228 12 8C12 7.44771 11.5523 7 11 7H9V5Z"
        }
      )
    }
  );
}
function mx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "43",
      height: "36",
      viewBox: "0 0 43 36",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            stroke: "none",
            d: "M19.8215 35.0926L1.23971 16.2129C0.965302 15.8379 0.820312 15.3926 0.820312 14.9249V2.66362C0.820312 2.08549 1.04176 1.5421 1.44386 1.13356C1.84682 0.725 2.38163 0.5 2.94977 0.5H15.0176C15.6891 0.50088 16.3284 0.82857 16.7276 1.37656L27.2326 12.0505C25.0306 13.9778 23.7678 16.7746 23.7678 19.7251C23.7678 23.7767 26.1355 27.4293 29.8 29.0305C29.6392 29.2038 29.494 29.3552 29.3566 29.4948C26.7197 32.1732 23.4226 34.1089 19.822 35.0925L19.8215 35.0926ZM10.6579 6.44148C9.59225 6.44236 8.59058 6.86431 7.83736 7.6296C7.08415 8.3949 6.66886 9.41263 6.66799 10.4953C6.66799 11.5776 7.08267 12.596 7.83565 13.3628C8.57766 14.1175 9.60538 14.5509 10.6553 14.5518C11.7235 14.5518 12.7273 14.1302 13.4818 13.3645C14.2361 12.5971 14.6511 11.5773 14.6503 10.4927C14.6494 9.42597 14.2229 8.38176 13.48 7.62787C12.7262 6.86282 11.7239 6.44149 10.6578 6.44149L10.6579 6.44148Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            stroke: "none",
            clipRule: "evenodd",
            d: "M34.3106 11.0938C29.5693 11.0938 25.8008 14.8622 25.8008 19.6036C25.8008 24.345 29.5693 28.1135 34.3106 28.1135C39.0521 28.1135 42.8205 24.345 42.8205 19.6036C42.8205 14.8622 39.0521 11.0938 34.3106 11.0938ZM39.1734 20.8193H35.5264V24.4664H33.0949V20.8193H29.4479V18.388H33.0949V14.7409H35.5264V18.388H39.1734V20.8193Z"
          }
        )
      ]
    }
  );
}
const Zf = (e) => /* @__PURE__ */ u.jsxs(
  "svg",
  {
    version: "1.1",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 210.2",
    ...e,
    children: [
      /* @__PURE__ */ u.jsx(
        "path",
        {
          id: "XMLID_34_",
          d: `M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9
	C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2
	c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7
	c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2
	C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z
	 M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2
	c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8
	c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4
	l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5
	l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z
	`
        }
      ),
      /* @__PURE__ */ u.jsx("g", {}),
      /* @__PURE__ */ u.jsx("g", {}),
      /* @__PURE__ */ u.jsx("g", {}),
      /* @__PURE__ */ u.jsx("g", {}),
      /* @__PURE__ */ u.jsx("g", {}),
      /* @__PURE__ */ u.jsx("g", {})
    ]
  }
);
function a0(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15",
      height: "9",
      viewBox: "0 0 15 9",
      fill: "none",
      stroke: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M1.5 1.5L7.5 7.5L13.5 1.5",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function gx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "17",
      height: "10",
      viewBox: "0 0 17 10",
      fill: "#142C63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M7.89997 0.550032C7.99302 0.455547 8.10394 0.380513 8.22626 0.329296C8.34858 0.27808 8.47987 0.251704 8.61248 0.251704C8.74509 0.251704 8.87637 0.27808 8.99869 0.329296C9.12101 0.380513 9.23193 0.455547 9.32498 0.550032L16.456 7.79603C16.5938 7.9366 16.687 8.1147 16.724 8.30802C16.761 8.50134 16.7401 8.70129 16.664 8.8828C16.5879 9.06432 16.4599 9.21933 16.296 9.32841C16.1322 9.4375 15.9398 9.49581 15.743 9.49603H1.48098C1.28414 9.49581 1.09175 9.4375 0.927914 9.32841C0.764074 9.21933 0.636071 9.06432 0.559942 8.8828C0.483812 8.70129 0.462944 8.50134 0.49995 8.30802C0.536956 8.1147 0.630192 7.9366 0.767975 7.79603L7.89997 0.550032Z" })
    }
  );
}
function Yf(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "#393939",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.306 5.49756L6.27959 1.52696C6.57347 1.23307 6.57347 0.757853 6.27959 0.467093C5.98571 0.176333 5.51051 0.176333 5.21663 0.467093L0.714683 4.96606C0.430183 5.25057 0.423933 5.70703 0.692793 6.00092L5.2135 10.5312C5.36044 10.6781 5.55427 10.75 5.74498 10.75C5.93569 10.75 6.12952 10.6781 6.27646 10.5312C6.57034 10.2373 6.57034 9.76204 6.27646 9.47128L2.306 5.49756Z"
        }
      )
    }
  );
}
function r0(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "7",
      height: "11",
      viewBox: "0 0 7 11",
      fill: "#393939",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.69414 5.49755L0.720417 1.52696C0.426528 1.23307 0.426528 0.757853 0.720417 0.467093C1.01431 0.176333 1.48953 0.176333 1.78341 0.467093L6.2855 4.96605C6.57001 5.25056 6.57626 5.70702 6.30739 6.00091L1.78654 10.5311C1.6396 10.6781 1.44576 10.75 1.25504 10.75C1.06433 10.75 0.870488 10.6781 0.723538 10.5311C0.429648 10.2373 0.429648 9.76203 0.723538 9.47127L4.69414 5.49755Z"
        }
      )
    }
  );
}
function Cx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M13.5 8.5H2.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        /* @__PURE__ */ u.jsx("path", { d: "M7 4L2.5 8.5L7 13", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
      ]
    }
  );
}
function vx(e) {
  return /* @__PURE__ */ u.jsx("svg", { width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ u.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.04185 0.956942L6.67606 0.306247C6.9446 0.0307302 7.37885 0.0307302 7.64453 0.306247L13.1982 6.00133C13.4667 6.27684 13.4667 6.72238 13.1982 6.99496L7.64453 12.693C7.37599 12.9685 6.94174 12.9685 6.67606 12.693L6.04185 12.0423C5.77045 11.7638 5.77617 11.3095 6.05328 11.0369L9.49577 7.67205H1.28524C0.90529 7.67205 0.599609 7.35842 0.599609 6.96859V6.03065C0.599609 5.64082 0.90529 5.3272 1.28524 5.3272H9.49577L6.05328 1.96233C5.77331 1.68974 5.7676 1.23542 6.04185 0.956967V0.956942Z",
      fill: "white"
    }
  ) });
}
function bx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "16",
      height: "14",
      viewBox: "0 0 16 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M14.0002 1.5C14.0002 0.946875 14.4471 0.5 15.0002 0.5C15.5533 0.5 16.0002 0.946875 16.0002 1.5V6.5C16.0002 8.15625 14.6564 9.5 13.0002 9.5H3.41582L5.70957 11.7937C6.1002 12.1844 6.1002 12.8188 5.70957 13.2094C5.31895 13.6 4.68457 13.6 4.29395 13.2094L0.293945 9.20938C-0.0966797 8.81875 -0.0966797 8.18437 0.293945 7.79375L4.29395 3.79375C4.68457 3.40312 5.31895 3.40312 5.70957 3.79375C6.1002 4.18437 6.1002 4.81875 5.70957 5.20937L3.41582 7.5H13.0002C13.5533 7.5 14.0002 7.05312 14.0002 6.5V1.5Z",
          fill: "white"
        }
      )
    }
  );
}
function yx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      ...e,
      width: "63",
      height: "60",
      viewBox: "0 0 63 60",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M41.7732 27.5558C42.1021 27.0626 41.6089 26.5694 41.1157 26.5694H32.4019V12.9236C32.4019 12.2661 31.4154 11.9372 31.0865 12.5947L21.5509 31.6662C21.222 31.9952 21.5509 32.6527 22.2084 32.6527H30.9222V46.134C30.9222 46.9562 31.9087 47.1205 32.2376 46.463L41.7732 27.5558Z",
            fill: "#64748B"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M60.6977 24.3826H60.6974L57.3533 24.3823C54.9442 12.1595 44.0877 3.28823 31.5387 3.28823C19.0504 3.28823 8.26021 12.1596 5.88206 24.3823H2.53906C3.12658 20.9711 4.30145 17.7216 6.0308 14.7238C7.72275 11.7909 9.89129 9.18962 12.4762 6.99228C15.0791 4.77958 18.0153 3.05289 21.2029 1.86015C24.5017 0.62585 27.9792 0 31.5387 0C35.099 0 38.5835 0.62585 41.8954 1.86015C45.0974 3.0535 48.0497 4.78019 50.6704 6.99227C53.2754 9.19117 55.4619 11.7924 57.1692 14.7238C58.9165 17.724 60.1037 20.9736 60.6976 24.3823L60.6977 24.3826Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.95353 31.5234L0.00080061 26.1681H7.90625L3.95353 31.5234Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.55229 35.9572H2.55259L5.89669 35.9575C8.30578 48.1804 19.1623 57.0516 31.7112 57.0516C44.1996 57.0516 54.9898 48.1803 57.3679 35.9575H60.7109C60.1234 39.3688 58.9485 42.6182 57.2192 45.616C55.5272 48.549 53.3587 51.1502 50.7738 53.3476C48.1708 55.5603 45.2347 57.287 42.047 58.4797C38.7482 59.714 35.2708 60.3398 31.7112 60.3398C28.1509 60.3398 24.6664 59.714 21.3546 58.4797C18.1526 57.2864 15.2003 55.5597 12.5796 53.3476C9.97456 51.1487 7.78802 48.5474 6.08075 45.616C4.33342 42.6159 3.14629 39.3663 2.55235 35.9575L2.55229 35.9572Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.2965 28.8164L63.2492 34.1717H55.3438L59.2965 28.8164Z"
          }
        )
      ]
    }
  );
}
function wx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "60",
      height: "60",
      viewBox: "0 0 60 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M39.6209 27.4562C39.9498 26.963 39.4566 26.4698 38.9633 26.4698H30.2495V12.824C30.2495 12.1665 29.2631 11.8375 28.9342 12.495L19.3986 31.5666C19.0696 31.8956 19.3986 32.5531 20.0561 32.5531H28.7699V46.0344C28.7699 46.8566 29.7564 47.0209 30.0853 46.3634L39.6209 27.4562Z",
            fill: "#64748B"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.429 0C45.7054 0 59.0224 13.1525 59.0224 29.429C59.0224 45.7054 45.7054 59.0224 29.429 59.0224C13.1525 59.0224 0 45.7054 0 29.429C0 13.1525 13.1525 0 29.429 0ZM29.429 3.28828C14.9611 3.28828 3.28839 14.961 3.28839 29.4289C3.28839 43.8967 14.9611 55.7339 29.429 55.7339C43.8968 55.7339 55.734 43.8967 55.734 29.4289C55.734 14.961 43.8968 3.28828 29.429 3.28828Z",
            fill: "#CBD5E1"
          }
        )
      ]
    }
  );
}
function Sx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.869867 10.956C0.869867 5.18211 5.55026 0.501719 11.3242 0.501719C17.0981 0.501719 21.7785 5.18211 21.7785 10.956C21.7785 16.7299 17.0981 21.4103 11.3242 21.4103C5.55026 21.4103 0.869867 16.7299 0.869867 10.956Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.63731 9.6693L13.0481 5.91566C13.8419 5.3615 14.3015 5.67518 14.0717 6.6162L13.0794 10.6312L14.8029 11.0599C15.5863 11.2586 15.6803 11.7918 15.0223 12.2519L9.61151 16.0055C8.81766 16.5597 8.35805 16.246 8.58785 15.305L9.58017 11.29L7.85667 10.8613C7.07325 10.6626 6.97925 10.1293 7.63731 9.6693Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Wf(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "24",
      height: "10",
      viewBox: "0 0 24 10",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M4.75347 9.9973C8.35951 9.9973 10.1625 7.57135 11.9656 5.14539H0V9.9973H4.75347Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M19.1778 0.293716C15.5717 0.293716 13.7687 2.71967 11.9657 5.14562H23.9312V0.293716H19.1778Z" })
      ]
    }
  );
}
function _x(e) {
  return /* @__PURE__ */ u.jsxs("svg", { width: "22", height: "24", viewBox: "0 0 22 24", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ u.jsx("path", { d: "M21.1719 17.2391C20.5266 16.1234 19.75 14.0016 19.75 10.25V9.47344C19.75 4.62813 15.8563 0.657819 11.0657 0.625007H11C9.85057 0.623567 8.71211 0.84891 7.64986 1.28813C6.58761 1.72735 5.62245 2.37181 4.80965 3.18461C3.99685 3.99741 3.35238 4.96258 2.91317 6.02483C2.47395 7.08707 2.2486 8.22554 2.25004 9.37501V10.25C2.25004 14.0016 1.47348 16.1234 0.828168 17.2391C0.66867 17.5047 0.583501 17.8082 0.581576 18.118C0.579652 18.4278 0.661044 18.7325 0.817231 19C0.970367 19.2675 1.19184 19.4895 1.45898 19.6432C1.72612 19.797 2.02933 19.877 2.33754 19.875H19.6625C19.9708 19.877 20.274 19.797 20.5411 19.6432C20.8082 19.4895 21.0297 19.2675 21.1829 19C21.339 18.7325 21.4204 18.4278 21.4185 18.118C21.4166 17.8082 21.3314 17.5047 21.1719 17.2391Z" }),
    /* @__PURE__ */ u.jsx("path", { d: "M14.4893 21.625H7.48926C7.25719 21.625 7.03464 21.7172 6.87054 21.8813C6.70645 22.0454 6.61426 22.2679 6.61426 22.5C6.61426 22.7321 6.70645 22.9546 6.87054 23.1187C7.03464 23.2828 7.25719 23.375 7.48926 23.375H14.4893C14.7213 23.375 14.9439 23.2828 15.108 23.1187C15.2721 22.9546 15.3643 22.7321 15.3643 22.5C15.3643 22.2679 15.2721 22.0454 15.108 21.8813C14.9439 21.7172 14.7213 21.625 14.4893 21.625Z" })
  ] });
}
function xx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "20",
      height: "24",
      viewBox: "0 0 20 24",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.56799 23.3918H15.222C16.1299 23.3918 16.8683 22.6533 16.8683 21.7455V8.73633H2.92188V21.7455C2.92188 22.6534 3.66036 23.3918 4.5682 23.3918H4.56799ZM12.5703 12.1425C12.5703 11.8395 12.816 11.5938 13.1191 11.5938C13.4222 11.5938 13.6679 11.8395 13.6679 12.1425V18.897C13.6679 19.2001 13.4222 19.4458 13.1191 19.4458C12.816 19.4458 12.5703 19.2001 12.5703 18.897V12.1425ZM6.42969 12.1425C6.42969 11.8395 6.67548 11.5938 6.97849 11.5938C7.2815 11.5938 7.52729 11.8395 7.52729 12.1425V18.897C7.52729 19.2001 7.28153 19.4458 6.97849 19.4458C6.67548 19.4458 6.42969 19.2001 6.42969 18.897V12.1425Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.0161 5.22538C19.0161 4.62019 18.5238 4.12782 17.9186 4.12782H13.6663V2.97832C13.6663 1.76787 12.6816 0.783203 11.4712 0.783203H8.31644C7.10598 0.783203 6.12134 1.76787 6.12134 2.97832V4.12782H1.86904C1.26385 4.12782 0.771484 4.62015 0.771484 5.22538V7.64003H19.0164L19.0161 5.22538ZM12.5683 4.12792H7.21875V2.97842C7.21875 2.37322 7.71107 1.88086 8.3163 1.88086H11.471C12.0762 1.88086 12.5686 2.3732 12.5686 2.97842L12.5683 4.12792Z"
          }
        )
      ]
    }
  );
}
function Mx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.98859 0C4.04487 0 0 4.04486 0 8.98859C0 13.9323 4.04487 17.9772 8.98859 17.9772C13.9323 17.9772 17.9772 13.9323 17.9772 8.98859C17.9772 4.04487 13.9323 0 8.98859 0ZM8.98859 2.24715C10.4717 2.24715 11.82 2.71902 12.9211 3.50552L3.50555 12.9211C2.71906 11.8199 2.24718 10.4716 2.24718 8.98855C2.24718 5.25829 5.2584 2.24711 8.98862 2.24711L8.98859 2.24715ZM14.4716 5.05608C15.2581 6.15721 15.73 7.5055 15.73 8.98859C15.73 12.7188 12.7188 15.73 8.98855 15.73C7.50546 15.73 6.15718 15.2582 5.05605 14.4717L14.4716 5.05608Z"
        }
      )
    }
  );
}
function kx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.35742 15.5V4.91504H15.1816V15.5H6.35742ZM0.181641 15.5V4.91504H5.47656V15.5H0.181641ZM0.181641 4.03125V0.5H15.1816V4.03125H0.181641Z"
        }
      )
    }
  );
}
function Px(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "19",
      height: "28",
      viewBox: "0 0 19 21",
      fill: "#ACB7D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.51767 13.8557C4.2928 13.8557 4.07714 13.945 3.91814 14.104C3.75913 14.2631 3.6698 14.4787 3.6698 14.7036C3.6698 14.9284 3.75913 15.1441 3.91814 15.3031C4.07715 15.4621 4.29281 15.5514 4.51767 15.5514H14.1269C14.3517 15.5514 14.5674 15.4621 14.7264 15.3031C14.8854 15.1441 14.9747 14.9284 14.9747 14.7036C14.9747 14.4787 14.8854 14.263 14.7264 14.104C14.5674 13.945 14.3517 13.8557 14.1269 13.8557H4.51767ZM3.6698 10.1816C3.6698 10.6496 4.04965 11.0295 4.51767 11.0295H14.1269C14.3517 11.0295 14.5674 10.9401 14.7264 10.7811C14.8854 10.6221 14.9747 10.4065 14.9747 10.1816C14.9747 9.95673 14.8854 9.74107 14.7264 9.58207C14.5674 9.42306 14.3517 9.33373 14.1269 9.33373H4.51767C4.2928 9.33373 4.07714 9.42306 3.91814 9.58207C3.75913 9.74108 3.6698 9.95674 3.6698 10.1816ZM4.51767 4.81176C4.2928 4.81176 4.07714 4.90109 3.91814 5.0601C3.75913 5.21911 3.6698 5.43477 3.6698 5.65963C3.6698 5.8845 3.75913 6.10016 3.91814 6.25916C4.07715 6.41817 4.29281 6.5075 4.51767 6.5075H14.1269C14.3517 6.5075 14.5674 6.41817 14.7264 6.25916C14.8854 6.10015 14.9747 5.88449 14.9747 5.65963C14.9747 5.43476 14.8854 5.2191 14.7264 5.0601C14.5674 4.90109 14.3517 4.81176 14.1269 4.81176H4.51767ZM15.8226 0.298828C16.4671 0.298748 17.0877 0.543348 17.5588 0.983198C18.0299 1.42305 18.3165 2.02534 18.3606 2.66835L18.3662 2.84245V18.1018C18.366 18.7462 18.1213 19.3664 17.6815 19.8373C17.2416 20.3082 16.6395 20.5946 15.9967 20.6387L15.8226 20.6443H2.82193C2.17741 20.6444 1.55688 20.3998 1.08577 19.96C0.61466 19.5201 0.32809 18.9178 0.28397 18.2748L0.27832 18.1018V2.84245C0.27824 2.19793 0.52284 1.5774 0.96269 1.10629C1.40254 0.635178 2.00483 0.348608 2.64784 0.304488L2.82194 0.298838L15.8226 0.298828Z"
        }
      )
    }
  );
}
function $f(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "#CBD5E1",
      stroke: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M0.535394 0.862247C0.535394 0.75915 0.619218 0.675638 0.721353 0.675638H19.443C19.5455 0.675638 19.6292 0.759223 19.6292 0.862247V13.4278C19.6292 13.5308 19.5455 13.6144 19.443 13.6144H0.721353C0.619218 13.6144 0.535394 13.5309 0.535394 13.4278V0.862247ZM0.721353 14.2511H19.443C19.8964 14.2511 20.2646 13.8816 20.2646 13.4278V0.862247C20.2646 0.408374 19.8964 0.0389313 19.443 0.0389313H0.721353C0.26825 0.0389313 -0.1 0.408403 -0.1 0.862247V13.4278C-0.1 13.8816 0.26825 14.2511 0.721353 14.2511ZM17.3582 8.55702C17.3582 8.38228 17.2172 8.23931 17.0414 8.23931C16.866 8.23931 16.7251 8.38248 16.7251 8.55702V11.8459C16.7251 12.0206 16.8662 12.1633 17.0414 12.1633C17.217 12.1633 17.3582 12.0208 17.3582 11.8459V8.55702ZM16.1986 8.55702C16.1986 8.38218 16.0571 8.23931 15.8817 8.23931C15.7066 8.23931 15.5651 8.38228 15.5651 8.55702V11.8459C15.5651 12.0208 15.7067 12.1633 15.8817 12.1633C16.0569 12.1633 16.1986 12.0209 16.1986 11.8459V8.55702ZM15.0389 8.55702C15.0389 8.38199 14.8969 8.23931 14.7217 8.23931C14.5466 8.23931 14.4052 8.38228 14.4052 8.55702V11.8459C14.4052 12.0208 14.5468 12.1633 14.7217 12.1633C14.8967 12.1633 15.0389 12.0211 15.0389 11.8459V8.55702ZM13.879 8.55702C13.879 8.38199 13.7369 8.23931 13.5618 8.23931C13.3866 8.23931 13.2452 8.38228 13.2452 8.55702V11.8459C13.2452 12.0208 13.3868 12.1633 13.5618 12.1633C13.7367 12.1633 13.879 12.0211 13.879 11.8459V8.55702ZM12.719 8.55702C12.719 8.38209 12.5774 8.23931 12.4018 8.23931C12.2269 8.23931 12.0855 8.38238 12.0855 8.55702V11.8459C12.0855 12.0207 12.227 12.1633 12.4018 12.1633C12.5772 12.1633 12.719 12.021 12.719 11.8459V8.55702ZM11.5593 8.55702C11.5593 8.38199 11.4173 8.23931 11.2421 8.23931C11.0674 8.23931 10.9256 8.38218 10.9256 8.55702V11.8459C10.9256 12.0209 11.0676 12.1633 11.2421 12.1633C11.4171 12.1633 11.5593 12.0211 11.5593 11.8459V8.55702ZM10.3994 8.55702C10.3994 8.38209 10.2574 8.23931 10.0825 8.23931C9.90752 8.23931 9.76559 8.38209 9.76559 8.55702V11.8459C9.76559 12.021 9.90771 12.1633 10.0825 12.1633C10.2572 12.1633 10.3994 12.021 10.3994 11.8459V8.55702ZM9.2394 8.55702C9.2394 8.38209 9.09746 8.23931 8.92251 8.23931C8.74755 8.23931 8.60561 8.38209 8.60561 8.55702V11.8459C8.60561 12.021 8.74774 12.1633 8.92251 12.1633C9.09727 12.1633 9.2394 12.021 9.2394 11.8459V8.55702ZM8.07942 8.55702C8.07942 8.38218 7.93791 8.23931 7.76253 8.23931C7.58738 8.23931 7.44596 8.38228 7.44596 8.55702V11.8459C7.44596 12.0208 7.58757 12.1633 7.76253 12.1633C7.93772 12.1633 8.07942 12.0209 8.07942 11.8459V8.55702ZM6.91977 8.55702C6.91977 8.38218 6.77826 8.23931 6.60288 8.23931C6.42792 8.23931 6.28599 8.38209 6.28599 8.55702V11.8459C6.28599 12.021 6.42812 12.1633 6.60288 12.1633C6.77806 12.1633 6.91977 12.0209 6.91977 11.8459V8.55702ZM5.7598 8.55702C5.7598 8.38218 5.61828 8.23931 5.44291 8.23931C5.26795 8.23931 5.12602 8.38209 5.12602 8.55702V11.8459C5.12602 12.021 5.26814 12.1633 5.44291 12.1633C5.61809 12.1633 5.7598 12.0209 5.7598 11.8459V8.55702ZM4.59982 8.55702C4.59982 8.38218 4.45831 8.23931 4.28293 8.23931C4.10778 8.23931 3.96636 8.38228 3.96636 8.55702V11.8459C3.96636 12.0208 4.10797 12.1633 4.28293 12.1633C4.45812 12.1633 4.59982 12.0209 4.59982 11.8459V8.55702ZM3.43985 8.55702C3.43985 8.38218 3.29833 8.23931 3.12296 8.23931C2.94761 8.23931 2.80671 8.38248 2.80671 8.55702V11.8459C2.80671 12.0206 2.94781 12.1633 3.12296 12.1633C3.29814 12.1633 3.43985 12.0209 3.43985 11.8459V8.55702Z",
          strokeWidth: "0.2"
        }
      )
    }
  );
}
function Tx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2505 0.456055L19.5374 3.60469L10.7068 6.77941L2.83755 3.65222L11.2505 0.456055ZM1.72305 4.28464L9.99009 7.57033L8.83806 9.69065L0.5 6.48277L1.72305 4.28464ZM2.24525 8.21085L8.90716 10.7799C8.96625 10.8025 9.01829 10.813 9.07738 10.813C9.25659 10.813 9.47687 10.7178 9.56552 10.5515L10.3072 9.2786V18.8893L2.2452 15.6045L2.24525 8.21085ZM20.1598 15.5903L11.2022 18.9163V8.906L12.5145 10.7952C12.6085 10.9314 12.7633 11.0085 12.923 11.0085C12.9821 11.0085 13.0302 10.9975 13.0886 10.9759L20.1605 8.25098L20.1598 15.5903ZM13.1075 9.90308L11.4807 7.56424L20.7486 4.2319L22 6.48301L13.1075 9.90308Z"
        }
      )
    }
  );
}
function Ex(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      viewBox: "0 0 24 24",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M4 6h16M4 12h16M4 18h16" })
    }
  );
}
function Jf(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.9039 2.72621H18.3769V1.35165C18.3769 0.59564 17.7813 0 17.0253 0C16.2693 0 15.6736 0.59564 15.6736 1.35165V2.72621H12.3518V1.35165C12.3518 0.59564 11.7561 0 11.0001 0C10.2441 0 9.64848 0.59564 9.64848 1.35165V2.72621H6.32663V1.35165C6.32663 0.59564 5.73099 0 4.97498 0C4.21897 0 3.62333 0.59564 3.62333 1.35165V2.72621H3.09642C1.46986 2.72621 0.141113 4.05495 0.141113 5.68151V18.8086C0.141113 20.4351 1.46985 21.7639 3.09642 21.7639H18.9039C20.5304 21.7639 21.8592 20.4351 21.8592 18.8086V5.68151C21.8592 4.05495 20.5304 2.72621 18.9039 2.72621H18.9039ZM18.9039 19.7937H3.0964C2.54658 19.7937 2.1113 19.3584 2.1113 18.8086V8.79719H19.889V18.8086C19.889 19.3584 19.4537 19.7937 18.9039 19.7937Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 10.767H4.53961C4.33343 10.767 4.15015 10.9502 4.15015 11.1564V12.8975C4.15015 13.1037 4.33343 13.287 4.53961 13.287H7.26582C7.472 13.287 7.65528 13.1037 7.65528 12.8975V11.1564C7.65528 10.9502 7.472 10.767 7.26582 10.767Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 10.767H9.62554C9.41936 10.767 9.23608 10.9502 9.23608 11.1564V12.8975C9.23608 13.1037 9.41936 13.287 9.62554 13.287H12.3747C12.5809 13.287 12.7641 13.1037 12.7641 12.8975V11.1564C12.7641 10.9502 12.5809 10.767 12.3747 10.767Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 10.767H14.7347C14.5285 10.767 14.3452 10.9502 14.3452 11.1564V12.8975C14.3452 13.1037 14.5285 13.287 14.7347 13.287H17.4609C17.6671 13.287 17.8504 13.1037 17.8504 12.8975V11.1564C17.8733 10.9502 17.69 10.767 17.4838 10.767H17.4838Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 15.281H4.53961C4.33343 15.281 4.15015 15.4643 4.15015 15.6705V17.4116C4.15015 17.6178 4.33343 17.801 4.53961 17.801H7.26582C7.472 17.801 7.65528 17.6178 7.65528 17.4116V15.6705C7.65528 15.4643 7.472 15.281 7.26582 15.281Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 15.281H9.62554C9.41936 15.281 9.23608 15.4643 9.23608 15.6705V17.4116C9.23608 17.6178 9.41936 17.801 9.62554 17.801H12.3747C12.5809 17.801 12.7641 17.6178 12.7641 17.4116V15.6705C12.7641 15.4643 12.5809 15.281 12.3747 15.281Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 15.281H14.7347C14.5285 15.281 14.3452 15.4643 14.3452 15.6705V17.4116C14.3452 17.6178 14.5285 17.801 14.7347 17.801H17.4609C17.6671 17.801 17.8504 17.6178 17.8504 17.4116V15.6705C17.8733 15.4643 17.69 15.281 17.4838 15.281H17.4838Z"
          }
        )
      ]
    }
  );
}
function Dx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "39",
      height: "41",
      viewBox: "0 0 39 41",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          stroke: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75104 30.9259C3.49183 32.3519 4.57216 33.6915 6.04127 33.7345L7.29422 33.7776C8.3314 33.8208 9.2387 34.5122 9.49796 35.506L9.84369 36.7159C10.2325 38.0988 11.7881 38.8333 13.1277 38.2715L14.2945 37.7962C15.2451 37.4073 16.3685 37.6234 17.06 38.4011L17.8811 39.3518C18.8318 40.432 20.5602 40.432 21.5108 39.3087L22.3319 38.358C23.0234 37.5804 24.1037 37.3208 25.0543 37.71L26.2211 38.1853C27.5605 38.7471 29.0731 38.0126 29.4619 36.5866L29.8077 35.3766C30.0669 34.3829 30.9745 33.6483 32.0114 33.6049L33.2644 33.5184C34.6904 33.4319 35.7706 32.0924 35.5115 30.6663L35.2954 29.4564C35.1227 28.4192 35.598 27.4255 36.5053 26.907L37.5856 26.302C38.8385 25.6106 39.2277 23.9253 38.3632 22.7585L37.6286 21.7647C37.0237 20.9437 37.0237 19.7769 37.6286 18.9561L38.3632 17.919C39.1843 16.7522 38.7954 15.0669 37.5421 14.4189L36.4618 13.814C35.5542 13.3386 35.0358 12.3014 35.2088 11.3077L35.425 10.0978C35.6842 8.67181 34.6038 7.33225 33.1348 7.28918L31.8818 7.24609C30.8446 7.20298 29.9373 6.51153 29.6781 5.51779L29.3324 4.30787C28.9435 2.92494 27.3879 2.19043 26.0483 2.75225L24.7089 3.22728C23.7582 3.61611 22.6348 3.39999 21.9433 2.62233L21.1222 1.67168C20.1716 0.634518 18.4863 0.634518 17.5357 1.75819L16.7146 2.70885C16.0231 3.4865 14.9428 3.74601 13.9922 3.3569L12.8254 2.88156C11.4859 2.31971 9.97333 3.05427 9.5845 4.48031L9.23878 5.69024C8.97954 6.68402 8.07199 7.41855 7.03505 7.46199L5.78207 7.5485C4.35608 7.635 3.27581 8.97448 3.53499 10.4005L3.75111 11.6105C3.92384 12.6476 3.44847 13.6414 2.54119 14.1599L1.46091 14.7648C0.207928 15.4563 -0.181202 17.1415 0.683258 18.3083L1.4178 19.3021C2.02277 20.1232 2.02277 21.29 1.4178 22.1107L0.683258 23.1478C-0.137842 24.3146 0.250988 25.9999 1.50435 26.6479L2.58465 27.2529C3.49224 27.7282 4.01062 28.7654 3.83761 29.7591L3.75104 30.9259ZM13.6897 17.5736L17.1033 20.9871L25.2702 12.8634L28.8138 16.4069L17.1034 28.1172L10.1464 21.1601L13.6897 17.5736Z"
        }
      )
    }
  );
}
function Ix(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "m220.605 223.843 17.572 42.263c1.826 4.391-.047 9.413-4.275 11.588l-13.193 6.788c-2.356 1.212-4.842 1.366-7.33.452-2.487-.913-4.273-2.643-5.295-5.088l-19.792-47.344zm110.586 127.108 153.707 133.211c.703-2.038 1.104-4.217 1.104-6.491v-252.776c0-2.264-.391-4.425-1.08-6.444zm-74.592 37.883 213.02-183.599c-1.179-.212-2.377-.344-3.618-.344h-53.133c.598 18.815-11.841 36.455-30.734 41.517-17.189 4.606-35.09-2.386-44.868-16.468-29.454-11.333-64.949-14.304-97.498-12.101l16.876 40.589c5.806 13.965-.155 30.137-13.593 37.051l-13.193 6.788c-7.32 3.766-15.646 4.279-23.373 1.442-7.712-2.832-13.686-8.571-16.853-16.148l-21.111-50.499c-26.019 2.978-51.466-10.005-64.611-32.171h-57.91c-.038 0-.071 0-.109 0zm6.491 20.821 52.789-45.501 153.683 133.178c-1.151.212-2.344.34-3.561.34h-420.002c-.019 0-.028 0-.047 0l152.037-133.461 52.001 45.393c1.882 1.651 4.222 2.467 6.571 2.467 2.331-.001 4.647-.807 6.529-2.416zm-80.299-58.704-154.632 135.72c-1.368-2.708-2.161-5.76-2.161-9v-252.776c0-3.222.783-6.25 2.142-8.953zm239.163-192.676 31.43 8.421c5.027 1.347 10.196-1.669 11.53-6.692 1.337-5.03-1.674-10.191-6.695-11.536l-31.43-8.421c-5.027-1.347-10.196 1.669-11.53 6.692-1.338 5.03 1.673 10.191 6.695 11.536zm-15.133-92.75 23.008-23.008c3.676-3.676 3.703-9.65.03-13.338-3.668-3.683-9.651-3.711-13.332-.03l-23.008 23.008c-3.676 3.676-3.703 9.65-.03 13.338 3.668 3.683 9.651 3.711 13.332.03zm27.627 42.348 29.795-7.984c5.058-1.355 8.059-6.553 6.704-11.611s-6.553-8.059-11.611-6.704l-29.796 7.984c-5.058 1.355-8.059 6.553-6.704 11.611 1.356 5.058 6.554 8.059 11.612 6.704zm-58.589 31.999c1.124-.144 2.252-.364 3.377-.666 13.58-3.639 21.639-17.597 18-31.177s-17.597-21.638-31.177-18c-1.126.302-2.213.675-3.258 1.112l-16.31-60.871c-3.062-11.428-14.918-18.273-26.346-15.211-10.645 2.852-17.458 13.431-15.653 24.3l-.001.001c-19.951 27.108-53.807 53.739-95.437 73.025l23.036 85.971c45.714-4.068 88.418 2.246 119.251 15.747h.001c3.916 10.071 14.952 15.841 25.616 12.984 11.382-3.05 18.261-14.965 15.211-26.346zm-162.663 65.251-40.352 10.812c-24.519 6.57-49.955-8.116-56.525-32.634v-.001c-6.57-24.518 8.116-49.955 32.635-56.525l40.352-10.812c7.963 29.72 15.924 59.44 23.89 89.16z",
          fillRule: "evenodd"
        }
      )
    }
  );
}
function Lx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx("path", { d: "m305.617 219.523-15.899-15.631-33.724 22.375-30.764-20.132-183.555 180.456 194.225.117c-2.664-11.357-4.078-23.191-4.078-35.349.001-55.673 29.555-104.567 73.795-131.836z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m333.964 205.721c16.358-5.898 33.983-9.121 52.349-9.121 41.351 0 80.177 16.121 109.326 45.394 5.976 6.002 11.391 12.417 16.238 19.171l.123-204.927-197.083 130.757z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m.196 58.92-.196 326.637 199.549-196.18z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m489.696 35.165-471.371-.283 237.682 152.555z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m386.582 225.601c-69.344 0-125.759 56.415-125.759 125.759s56.415 125.759 125.759 125.759c33.583 0 65.11-13.089 88.777-36.856 23.628-23.73 36.641-55.303 36.641-88.904 0-33.6-13.013-65.173-36.641-88.902-23.667-23.767-55.195-36.856-88.777-36.856zm53.931 140.748h-107.864v-29.98h107.865v29.98z" })
      ] })
    }
  );
}
function Qf(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M22.3346 26.8581C22.5382 26.7636 22.7637 26.7709 22.9673 26.8727L24.4946 27.6363V24.8218H20.5601V27.68L22.3346 26.8581Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M37.2945 37.92C36.8218 37.6727 36.2909 37.6291 35.8109 37.8036L25.7164 41.4254C25.2218 41.7018 24.6473 41.8545 24.0436 41.8545H17.9564C17.5564 41.8545 17.2291 41.5273 17.2291 41.1273C17.2291 40.7273 17.5564 40.4 17.9564 40.4H24.0436C24.3855 40.4 24.72 40.3127 25.0036 40.1673C25.04 40.1454 25.0764 40.1236 25.1127 40.1018C25.5418 39.8327 25.8545 39.4109 25.9345 38.9236C26.0218 38.3854 25.8764 37.8691 25.5345 37.4691C25.1927 37.0691 24.6982 36.8436 24.1745 36.8436H19.6291C18.2982 36.8436 16.9673 36.3636 15.8836 35.4982C14.1091 34.08 10.4364 32.1891 5.58545 35.1491V43.9782C6.82909 43.9854 9.43272 44.2109 13.0545 45.6291C16.4509 46.96 20.0655 47.2654 23.5127 46.5163C27.0473 45.7454 32.3345 44.1818 37.3964 41.0763C37.7964 40.8291 38.0945 40.4145 38.2036 39.9345C38.3927 39.1345 38.0145 38.3054 37.2945 37.92Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M19.6293 35.3746H24.1748C25.1275 35.3746 26.022 35.7891 26.6402 36.5164C27.2584 37.2436 27.5202 38.2036 27.3675 39.1491C27.3602 39.2 27.3529 39.2436 27.3384 39.2946L32.3129 37.5127V26.0218C32.3129 25.36 31.7748 24.8291 31.1202 24.8291H25.942V28.8218C25.942 29.0764 25.8111 29.3091 25.6002 29.44C25.4839 29.5127 25.3529 29.5491 25.2148 29.5491C25.1057 29.5491 24.9893 29.52 24.8875 29.4691L22.6184 28.3346L20.1239 29.4836C19.8984 29.5855 19.6366 29.5709 19.4257 29.4327C19.2148 29.3018 19.0911 29.0691 19.0911 28.8218V24.8291H13.9129C13.2511 24.8291 12.7202 25.3673 12.7202 26.0218V32.3418C14.4657 32.7491 15.8548 33.6073 16.7857 34.3564C17.6293 35.0255 18.6111 35.3746 19.6293 35.3746Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M4.13102 32.7419L1.0183 32.6982L0.981934 45.8764L4.08739 45.9201L4.13102 45.8764V32.7419Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M25.782 10.9455C25.2147 10.611 24.5674 10.4219 23.8911 10.4219C21.8329 10.4219 20.1602 12.0946 20.1602 14.1528C20.1602 16.211 21.8329 17.8837 23.8911 17.8837C24.9529 17.8837 25.942 17.4255 26.6402 16.6619C26.0292 16.4873 25.4765 16.1382 25.0692 15.6437C24.0583 14.4219 24.182 12.5528 25.3456 11.3819L25.782 10.9455Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M32.3783 5.76718C32.4874 6.03627 32.4292 6.349 32.2183 6.55991L26.371 12.4072C25.731 13.0472 25.651 14.0581 26.1892 14.7126C26.4946 15.0835 26.9237 15.3017 27.3965 15.3235C27.8692 15.3526 28.3201 15.1708 28.6546 14.8363L33.5055 9.98536C33.7892 9.70173 34.2474 9.70173 34.531 9.98536C35.5201 10.9599 36.8292 11.4545 38.2183 11.469C39.5055 11.4472 40.7128 10.9526 41.6437 10.0726V1.09082H29.0401C27.8183 1.09082 26.6619 1.57082 25.7965 2.43627L22.9092 5.32355H31.7092C32.0001 5.31627 32.2692 5.49809 32.3783 5.76718Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M14.0222 15.6434C14.8456 15.6434 15.5131 14.9759 15.5131 14.1525C15.5131 13.3291 14.8456 12.6616 14.0222 12.6616C13.1988 12.6616 12.5312 13.3291 12.5312 14.1525C12.5312 14.9759 13.1988 15.6434 14.0222 15.6434Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M43.1055 1.09082H47.0255V9.64355H43.1055V1.09082Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M34.0584 11.4983L29.6875 15.8692C29.3384 16.2183 28.902 16.4655 28.4366 16.6183C27.5347 18.2765 25.7966 19.3383 23.8911 19.3383C21.0329 19.3383 18.7057 17.011 18.7057 14.1528C18.7057 11.2946 21.0329 8.96736 23.8911 8.96736C24.9457 8.96736 25.9711 9.29463 26.8293 9.891L29.9493 6.771H9.82565C9.55656 6.771 9.33838 6.98918 9.33838 7.25827V21.0328C9.33838 21.3019 9.55656 21.5201 9.82565 21.5201H37.9638C38.2329 21.5201 38.4511 21.3019 38.4511 21.0328V12.9019C38.3784 12.9019 38.3129 12.9165 38.2402 12.9165C36.7057 12.9165 35.2438 12.4437 34.0584 11.4983ZM14.022 17.0983C12.4002 17.0983 11.0766 15.7746 11.0766 14.1528C11.0766 12.531 12.4002 11.2074 14.022 11.2074C15.6438 11.2074 16.9675 12.531 16.9675 14.1528C16.9675 15.7746 15.6438 17.0983 14.022 17.0983Z" })
      ]
    }
  );
}
function Ax(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "19",
      height: "18",
      viewBox: "0 0 512 512",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "currentColor",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M475.312 148.688L379.312 52.688C374.736 48.112 367.872 46.768 361.872 49.216C355.888 51.696 352 57.536 352 64V112H112C85.488 112 64 133.488 64 160C64 186.512 85.488 208 112 208H352V256C352 262.464 355.888 268.304 361.872 270.784C367.888 273.264 374.752 271.872 379.312 267.312L475.312 171.312C481.568 165.072 481.568 154.928 475.312 148.688Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M400 304H160V256C160 249.536 156.112 243.696 150.128 241.216C144.144 238.736 137.28 240.096 132.688 244.688L36.6881 340.688C30.4481 346.928 30.4481 357.072 36.6881 363.312L132.688 459.312C137.248 463.872 144.112 465.264 150.128 462.784C156.112 460.304 160 454.464 160 448V400H400C426.512 400 448 378.512 448 352C448 325.488 426.512 304 400 304Z" })
      ]
    }
  );
}
function qf(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "13",
      height: "10",
      viewBox: "0 0 13 10",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "white",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.39016 9.4496L0.189285 5.24872C-0.063095 4.99635 -0.063095 4.58713 0.189285 4.33472L1.10326 3.42073C1.35564 3.16832 1.76487 3.16832 2.01725 3.42073L4.84717 6.25063L10.9085 0.189285C11.1609 -0.063095 11.5701 -0.063095 11.8225 0.189285L12.7365 1.10327C12.9889 1.35565 12.9889 1.76487 12.7365 2.01727L5.30415 9.44963C5.05174 9.70201 4.64254 9.70201 4.39016 9.4496Z"
        }
      )
    }
  );
}
function Xf(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
        }
      )
    }
  );
}
function Nx({ isSelected: e, ...t }) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      fill: "#CBD5E1",
      children: e ? /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
        }
      ) : /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
          fill: "transparent",
          stroke: "#CBD5E1",
          strokeWidth: "2"
        }
      )
    }
  );
}
function eh(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "16",
      height: "13",
      viewBox: "0 0 16 13",
      fill: "none",
      stroke: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function Rx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: "2",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { id: "Icon", children: [
        /* @__PURE__ */ u.jsx("path", { d: "m16.75 2.5v2c0 .69-.56 1.25-1.25 1.25h-7c-.332 0-.649-.132-.884-.366-.234-.235-.366-.552-.366-.884v-2c0-.69.56-1.25 1.25-1.25h7c.332 0 .649.132.884.366.234.235.366.552.366.884z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m17.75 2.759c1.678.128 3 1.53 3 3.241v13.5c0 .862-.342 1.689-.952 2.298-.609.61-1.436.952-2.298.952h-11c-.862 0-1.689-.342-2.298-.952-.61-.609-.952-1.436-.952-2.298v-13.5c0-1.711 1.322-3.113 3-3.241v1.741c0 .597.237 1.169.659 1.591s.994.659 1.591.659h7c1.243 0 2.25-1.007 2.25-2.25zm-4.75 7.991h4c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75s.336.75.75.75zm0 6h4c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4c-.414 0-.75.336-.75.75s.336.75.75.75zm0 2.5h1.571c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.571c-.414 0-.75.336-.75.75s.336.75.75.75zm0-6h1.571c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.571c-.414 0-.75.336-.75.75s.336.75.75.75zm-2.25 3.25c0-.332-.132-.649-.366-.884-.235-.234-.552-.366-.884-.366h-2c-.332 0-.649.132-.884.366-.234.235-.366.552-.366.884v2c0 .332.132.649.366.884.235.234.552.366.884.366h2c.332 0 .649-.132.884-.366.234-.235.366-.552.366-.884zm-3 .25h1.5v1.5h-1.5zm-1.28-5.22 1 1c.293.293.767.293 1.06 0l2-2c.293-.292.293-.768 0-1.06-.292-.293-.768-.293-1.06 0l-1.47 1.469-.47-.469c-.292-.293-.768-.293-1.06 0-.293.292-.293.768 0 1.06z" })
      ] })
    }
  );
}
function Ox(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "9",
      height: "5",
      viewBox: "0 0 9 5",
      fill: "CurrentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.54022 0.210728C8.297 -0.0324822 7.90225 -0.0324822 7.65841 0.210728L4.79847 3.07067C4.55214 3.30702 4.163 3.30702 3.91667 3.07067L1.05673 0.210728C0.809153 -0.0287422 0.414402 -0.0218822 0.174922 0.226318C-0.0583075 0.467658 -0.0583075 0.850568 0.174922 1.09253L3.03424 3.95247C3.7645 4.68336 4.94939 4.68336 5.68028 3.95247V3.95247L8.54022 1.09253C8.78343 0.848688 8.78343 0.453938 8.54022 0.210718V0.210728Z"
        }
      )
    }
  );
}
function Bx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M14.032 7.58875C14.032 11.0105 11.2581 13.7844 7.83631 13.7844C4.41453 13.7844 1.64062 11.0105 1.64062 7.58875C1.64062 4.16697 4.41453 1.39307 7.83631 1.39307C11.2581 1.39307 14.032 4.16697 14.032 7.58875Z",
          stroke: "CurrentColor",
          strokeWidth: "1.5"
        }
      )
    }
  );
}
function th(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1719 0C4.92404 0 0.671875 4.25216 0.671875 9.5C0.671875 14.7478 4.92404 19 10.1719 19C15.4197 19 19.6719 14.7478 19.6719 9.5C19.6719 4.25216 15.4197 0 10.1719 0ZM12.5788 12.9392L10.1719 10.5322L7.7649 12.9392C7.48173 13.2224 7.01586 13.2224 6.7327 12.9392C6.5911 12.7976 6.51803 12.6103 6.51803 12.4231C6.51803 12.2358 6.59111 12.0486 6.7327 11.907L9.13966 9.5L6.7327 7.09303C6.5911 6.95144 6.51803 6.76418 6.51803 6.57692C6.51803 6.38966 6.59111 6.2024 6.7327 6.06081C7.01586 5.77764 7.48173 5.77764 7.7649 6.06081L10.1719 8.46778L12.5788 6.06081C12.862 5.77764 13.3279 5.77764 13.6111 6.06081C13.8942 6.34398 13.8942 6.80985 13.6111 7.09302L11.2041 9.49999L13.6111 11.907C13.8942 12.1901 13.8942 12.656 13.6111 12.9392C13.3279 13.2269 12.862 13.2269 12.5788 12.9392V12.9392Z"
        }
      )
    }
  );
}
function jx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "26",
      height: "20",
      viewBox: "0 0 26 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#00A0FF",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M23.7148 0.859375H2.28516C1.02771 0.859375 0 1.88257 0 3.14453V16.8555C0 18.1179 1.02837 19.1406 2.28516 19.1406H23.7148C24.9723 19.1406 26 18.1174 26 16.8555V3.14453C26 1.88226 24.9718 0.859375 23.7148 0.859375ZM23.3639 2.38281C22.6251 3.12407 13.9468 11.8307 13.5903 12.1884C13.2925 12.4871 12.7077 12.4873 12.4097 12.1884L2.63605 2.38281H23.3639ZM1.52344 16.5754V3.42459L8.07752 10L1.52344 16.5754ZM2.63605 17.6172L9.15302 11.079L11.3308 13.2639C12.2232 14.1592 13.7772 14.1588 14.6693 13.2639L16.847 11.0791L23.3639 17.6172H2.63605ZM24.4766 16.5754L17.9225 10L24.4766 3.42459V16.5754Z" })
    }
  );
}
function Hx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "CurrentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M10 0.25C8.3067 0.249871 6.64255 0.690745 5.17141 1.52921C3.70026 2.36768 2.47285 3.57483 1.61001 5.03182C0.747172 6.4888 0.278662 8.14538 0.250606 9.83846C0.222551 11.5315 0.635918 13.2027 1.45001 14.6875L0.653133 17.5C0.578795 17.7563 0.574616 18.0278 0.641033 18.2863C0.70745 18.5447 0.842028 18.7806 1.03072 18.9693C1.21941 19.158 1.45529 19.2926 1.71374 19.359C1.97219 19.4254 2.24373 19.4212 2.50001 19.3469L5.31251 18.55C6.6159 19.2644 8.06537 19.6713 9.55012 19.7397C11.0349 19.8081 12.5156 19.5361 13.8791 18.9445C15.2427 18.353 16.4529 17.4575 17.4174 16.3266C18.3818 15.1956 19.0749 13.8592 19.4437 12.4193C19.8125 10.9795 19.8473 9.47439 19.5453 8.01906C19.2433 6.56374 18.6126 5.19672 17.7014 4.02249C16.7901 2.84826 15.6225 1.8979 14.2877 1.24406C12.9529 0.590223 11.4863 0.250206 10 0.25V0.25Z",
          fillOpacity: "0.3"
        }
      )
    }
  );
}
function Fx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Composant_127_2",
      "data-name": "Composant 127 – 2",
      xmlns: "http://www.w3.org/2000/svg",
      width: "35",
      height: "35",
      viewBox: "0 0 35 35",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { id: "Groupe_3402", "data-name": "Groupe 3402", transform: "translate(-863 -1502)", children: [
        /* @__PURE__ */ u.jsx(
          "circle",
          {
            id: "Ellipse_2975",
            "data-name": "Ellipse 2975",
            cx: "17.5",
            cy: "17.5",
            r: "17.5",
            transform: "translate(863 1502)",
            fill: "#f1f4f8"
          }
        ),
        /* @__PURE__ */ u.jsxs("g", { id: "Groupe_2819", "data-name": "Groupe 2819", transform: "translate(493.176 1350.037)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22384",
              "data-name": "Tracé 22384",
              d: "M383.587,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z",
              fill: "rgba(96,96,96,0.51)"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22385",
              "data-name": "Tracé 22385",
              d: "M407.84,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z",
              transform: "translate(-17.928)",
              fill: "rgba(96,96,96,0.51)"
            }
          )
        ] })
      ] })
    }
  );
}
function Gx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Composant_127_3",
      "data-name": "Composant 127 – 3",
      xmlns: "http://www.w3.org/2000/svg",
      width: "35",
      height: "35",
      viewBox: "0 0 35 35",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { id: "Groupe_3402", "data-name": "Groupe 3402", transform: "translate(-863 -1502)", children: [
        /* @__PURE__ */ u.jsx(
          "circle",
          {
            id: "Ellipse_2975",
            "data-name": "Ellipse 2975",
            cx: "17.5",
            cy: "17.5",
            r: "17.5",
            transform: "translate(863 1502)",
            fill: "#f1f4f8"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Soustraction_3",
            "data-name": "Soustraction 3",
            d: "M15,14H0L2.706,8.949h9.588L15,14ZM11.752,7.938h-8.5L7.5,0l4.252,7.937Z",
            transform: "translate(873 1511)",
            fill: "rgba(96,96,96,0.51)"
          }
        )
      ] })
    }
  );
}
function Vx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx("path", { d: "m256 0c-63.411 0-115 51.589-115 115s51.589 115 115 115 115-51.589 115-115-51.589-115-115-115zm40 130h-25v25c0 8.284-6.716 15-15 15s-15-6.716-15-15v-25h-25c-8.284 0-15-6.716-15-15s6.716-15 15-15h25v-25c0-8.284 6.716-15 15-15s15 6.716 15 15v25h25c8.284 0 15 6.716 15 15s-6.716 15-15 15z" }),
        /* @__PURE__ */ u.jsxs("g", { children: [
          /* @__PURE__ */ u.jsxs("g", { children: [
            /* @__PURE__ */ u.jsx("path", { d: "m317.869 420.196c-15.513 16.482-37.502 26.804-61.869 26.804s-46.356-10.322-61.869-26.804c-25.848 15.831-43.131 44.336-43.131 76.804 0 8.284 6.716 15 15 15h180c8.284 0 15-6.716 15-15 0-32.468-17.283-60.973-43.131-76.804z" }),
            /* @__PURE__ */ u.jsx("path", { d: "m256 417c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" })
          ] }),
          /* @__PURE__ */ u.jsx("path", { d: "m407 382c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" }),
          /* @__PURE__ */ u.jsxs("g", { children: [
            /* @__PURE__ */ u.jsxs("g", { children: [
              /* @__PURE__ */ u.jsx("path", { d: "m468.869 385.196c-15.513 16.482-37.502 26.804-61.869 26.804s-46.356-10.322-61.869-26.804c-4.341 2.659-8.433 5.682-12.249 9.015l.656.402c17.194 10.532 31.583 25.338 41.611 42.818 7.033 12.26 11.81 25.682 14.161 39.569h107.69c8.284 0 15-6.716 15-15 0-32.468-17.283-60.973-43.131-76.804z" }),
              /* @__PURE__ */ u.jsx("path", { d: "m178.462 394.612.656-.402c-3.816-3.332-7.909-6.356-12.249-9.015-15.513 16.483-37.502 26.805-61.869 26.805s-46.356-10.322-61.869-26.804c-25.848 15.831-43.131 44.336-43.131 76.804 0 8.284 6.716 15 15 15h107.69c2.351-13.887 7.127-27.309 14.161-39.569 10.028-17.481 24.417-32.286 41.611-42.819z" })
            ] }),
            /* @__PURE__ */ u.jsx("path", { d: "m105 382c-30.376 0-55-24.624-55-55v-30c0-30.376 24.624-55 55-55 30.376 0 55 24.624 55 55v30c0 30.376-24.624 55-55 55z" })
          ] })
        ] })
      ] })
    }
  );
}
const Kx = (e) => /* @__PURE__ */ u.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "#CBD5E1",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ u.jsx("path", { d: "M23.4823 66.0459C19.3311 66.0511 15.3515 67.7027 12.4166 70.6385C9.48175 73.5743 7.83132 77.5545 7.82745 81.7057C7.83132 85.8564 9.48191 89.836 12.4169 92.7711C15.352 95.7061 19.3316 97.3567 23.4823 97.3605C27.6331 97.3567 31.6127 95.7061 34.5478 92.7711C37.4828 89.836 39.1334 85.8564 39.1372 81.7057C39.1334 77.5545 37.4829 73.5743 34.548 70.6385C31.6132 67.7027 27.6335 66.0511 23.4823 66.0459ZM133.076 66.0459C128.924 66.0498 124.943 67.7009 122.007 70.6368C119.072 73.5727 117.42 77.5536 117.417 81.7057C117.422 85.8568 119.073 89.8365 122.009 92.7714C124.945 95.7062 128.925 97.3567 133.076 97.3605C137.231 97.3631 141.217 95.7154 144.157 92.7797C147.098 89.8439 148.752 85.8606 148.756 81.7057C148.752 77.5502 147.098 73.5664 144.158 70.6299C141.218 67.6934 137.232 66.0446 133.076 66.0459ZM140.904 105.188H125.244C123.194 105.184 121.162 105.584 119.266 106.364C117.37 107.145 115.647 108.292 114.194 109.739C119.151 112.436 123.4 116.268 126.593 120.921C129.786 125.574 131.833 130.917 132.565 136.512H148.756C150.828 136.505 152.813 135.674 154.273 134.204C155.734 132.733 156.551 130.743 156.544 128.67V120.843C156.54 116.695 154.892 112.717 151.96 109.783C149.028 106.848 145.052 105.196 140.904 105.188ZM103.349 66.7322C96.2703 72.03 87.6609 74.8816 78.8197 74.8566C69.6392 74.8806 60.7197 71.8034 53.507 66.1238C51.7824 69.7766 50.8912 73.7671 50.8979 77.8065C50.896 81.4054 51.6034 84.9694 52.9797 88.2947C54.3561 91.62 56.3743 94.6414 58.9191 97.1862C61.4639 99.731 64.4853 101.749 67.8106 103.126C71.1359 104.502 74.6999 105.209 78.2988 105.207C81.8981 105.206 85.4618 104.495 88.7862 103.116C92.1106 101.736 95.1305 99.7148 97.6731 97.1673C100.216 94.6197 102.231 91.5959 103.604 88.2688C104.977 84.9417 105.681 81.3766 105.675 77.7773C105.681 73.9687 104.888 70.2012 103.349 66.7177V66.7322ZM97.0642 113.03H95.0343C89.8146 115.575 84.0866 116.907 78.2793 116.924C72.4709 116.903 66.742 115.572 61.5194 113.03H59.4896C52.0166 113.033 44.8505 116.002 39.5663 121.287C34.2821 126.571 31.3124 133.737 31.3098 141.21V148.258C31.3111 151.372 32.5485 154.358 34.7501 156.559C36.9517 158.761 39.9374 159.998 43.051 160H113.503C116.616 159.998 119.602 158.761 121.804 156.559C124.005 154.358 125.243 151.372 125.244 148.258V141.21C125.245 133.734 122.277 126.564 116.993 121.277C111.708 115.99 104.54 113.018 97.0642 113.015V113.03ZM31.3098 105.188H15.6549C11.5041 105.192 7.52451 106.842 4.58949 109.777C1.65446 112.712 0.00387263 116.692 6.07017e-06 120.843V128.67C-0.00127527 129.699 0.200312 130.717 0.593225 131.667C0.986137 132.618 1.56265 133.481 2.28975 134.208C3.01686 134.935 3.88025 135.512 4.8305 135.905C5.78075 136.297 6.79918 136.499 7.82745 136.498H23.9448C24.688 130.902 26.7413 125.562 29.9378 120.909C33.1343 116.257 37.3836 112.425 42.3403 109.725C40.8898 108.281 39.1691 107.137 37.2764 106.359C35.3838 105.58 33.3563 105.183 31.3098 105.188Z" }),
      /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M78.8196 0C59.621 0 44.3652 14.954 44.3652 33.7681C44.364 36.1518 44.6136 38.529 45.11 40.8604C48.3812 56.2038 62.1084 67.5555 78.8196 67.5555C95.5308 67.5555 109.209 56.2622 112.515 40.9578C113.021 38.6013 113.275 36.1977 113.274 33.7875C113.274 14.9539 98.0183 0 78.8196 0ZM98.5099 38.592H59.1293V28.944H98.5099V38.592Z"
        }
      )
    ]
  }
);
function zx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15",
      height: "17",
      viewBox: "0 0 15 17",
      fill: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.3613 1.63892H12.5419V0H10.903V1.63892H4.3473V0H2.70838V1.63892H1.88892C0.97932 1.63892 0.25 2.37643 0.25 3.27784V14.7502C0.25 15.6516 0.97932 16.3892 1.88892 16.3892H13.3613C14.2627 16.3892 15.0002 15.6517 15.0002 14.7502V3.27784C15.0002 2.37644 14.2627 1.63892 13.3613 1.63892H13.3613ZM7.62513 4.09729C8.98543 4.09729 10.0835 5.19536 10.0835 6.55566C10.0835 7.91596 8.98543 9.01403 7.62513 9.01403C6.26483 9.01403 5.16676 7.91596 5.16676 6.55566C5.16676 5.19536 6.26483 4.09729 7.62513 4.09729ZM12.5419 13.9308H2.70838V13.1113C2.70838 11.4724 5.98621 10.571 7.62513 10.571C9.26405 10.571 12.5419 11.4724 12.5419 13.1113V13.9308Z"
        }
      )
    }
  );
}
function Ux(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "18",
      height: "28",
      viewBox: "0 0 15 16",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.8003 14.1178C14.8809 14.2272 14.9288 14.3572 14.9386 14.4927C14.9484 14.6283 14.9196 14.7638 14.8556 14.8837C14.7924 15.0028 14.6981 15.1026 14.5828 15.1724C14.4675 15.2423 14.3354 15.2796 14.2006 15.2805H0.915116C0.780298 15.2796 0.648229 15.2423 0.532917 15.1724C0.417596 15.1026 0.323321 15.0028 0.260071 14.8837C0.196071 14.7638 0.167306 14.6283 0.177094 14.4927C0.186893 14.3572 0.234845 14.2272 0.315422 14.1178C1.34697 12.6424 2.8055 11.5185 4.49481 10.8971C3.50454 10.2391 2.75237 9.27969 2.3496 8.16087C1.94683 7.04204 1.91487 5.82324 2.25844 4.68484C2.60202 3.54643 3.30287 2.54891 4.2573 1.8399C5.21172 1.13088 6.36899 0.748043 7.55785 0.748043C8.74671 0.748043 9.90397 1.13088 10.8584 1.8399C11.8128 2.54892 12.5137 3.54643 12.8573 4.68484C13.2008 5.82325 13.1689 7.04204 12.7661 8.16087C12.3633 9.27969 11.6112 10.2391 10.6209 10.8971C12.3102 11.5185 13.7687 12.6424 14.8003 14.1178Z"
        }
      )
    }
  );
}
function Zx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.8579 16.6084H14.4205V7.80825L10.3589 3.80801H4.67102V1.40806C4.67102 0.967118 5.03578 0.608398 5.48413 0.608398H13.6084L17.671 4.60864V15.8078C17.671 16.2492 17.3063 16.6084 16.8579 16.6084L16.8579 16.6084Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5131 20.6088H1.46049C1.02448 20.6088 0.671021 20.2554 0.671021 19.8193V5.60881C0.671021 5.17279 1.02448 4.81934 1.46049 4.81934H9.35523L13.3026 8.7667V19.8193C13.3026 20.2554 12.9491 20.6088 12.5131 20.6088Z"
          }
        )
      ]
    }
  );
}
const Yx = (e) => /* @__PURE__ */ u.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.974 25.974",
    fill: "#CBD5E1",
    ...e,
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        d: "M8.973 11.146v9.558a.998.998 0 0 1-.668.943c-.566.199-1.249.304-1.976.304-2.091 0-4.34-.858-4.34-2.742V6.979c-.047-.84.246-2.324 1.653-3.127.653-.373 4.082-2.578 5.804-3.692a1.002 1.002 0 0 1 1.543.84v1.448a1 1 0 0 1-1.938.347c-1.556 1-3.848 2.468-4.417 2.793-.512.293-.623.831-.645 1.123 0 .328.071.586.199.727.355.387 1.538.146 2.829-.629 1.24-.744 7.356-4.816 7.417-4.857a1 1 0 0 1 1.555.833v.114c0 .334-.167.646-.444.832 0 0-4.246 2.834-4.622 3.075-1.439.926-1.95 2.062-1.95 4.34zM23.989 6.32v12.982a1 1 0 0 1-.468.846s-5.83 4.528-7.013 5.247c-.622.379-1.414.579-2.289.579-2.079 0-4.23-1.125-4.23-3.006V10.559c0-.004.003-.008.003-.013.02-.732.191-1.777 1.552-2.781.816-.602 5.676-3.916 5.882-4.056a.999.999 0 0 1 1.563.826v1.448a1 1 0 0 1-1.92.392c-1.551 1.061-3.828 2.624-4.338 2.999-.644.476-.73.79-.741 1.193.002.299.083.527.247.677.51.467 1.883.271 3.237-.541 1.002-.602 5.32-3.936 6.898-5.17.303-.234.711-.277 1.055-.11s.562.514.562.897zm-2 4.456-5 3.879v2l5-3.879v-2z"
      }
    )
  }
), Wx = (e) => /* @__PURE__ */ u.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "#CBD5E1",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ u.jsx("path", { d: "M79.6239 18.5188C78.7887 17.9806 77.8162 17.6944 76.8226 17.6944C75.8291 17.6944 74.8565 17.9806 74.0213 18.5188C73.4614 19.0666 39.298 41.6462 32.0158 45.5048C24.7336 49.9032 17.9186 50.9625 16.2591 48.7633C15.7396 48.2518 15.2844 46.685 15.2119 45.1383V44.7919C15.1856 43.5414 15.4967 42.3068 16.1127 41.2181C16.7286 40.1294 17.6266 39.2268 18.7121 38.6053C21.8618 36.8854 29.6716 31.9877 37.268 27.2712C40.4902 25.2573 40.893 25.0599 43.3902 23.4851C43.7243 24.836 44.5594 26.0094 45.7263 26.7677C46.9033 27.5341 48.3216 27.8395 49.7097 27.6256C51.0923 27.4141 52.3469 26.6964 53.23 25.6117C54.1084 24.5384 54.541 23.1686 54.4383 21.7853V13.5405C54.4456 12.7557 54.2806 11.9789 53.955 11.2648C53.6313 10.5449 53.1543 9.90433 52.5574 9.3879C51.959 8.86545 51.2558 8.47683 50.4951 8.24804C49.7328 8.0152 48.93 7.94522 48.1389 8.04262C47.3273 8.16116 46.551 8.45382 45.8632 8.90054C45.8632 8.90054 38.7784 13.2787 31.1619 18.0113C23.5454 22.744 15.0509 27.9519 13.1296 29.0071C13.0128 29.0555 12.896 29.1118 12.7792 29.1723C5.7427 33.4336 4.28058 40.3936 4.03086 44.2965C4.03086 44.4778 4.03086 44.6268 4.03086 44.8161C3.98971 45.6211 3.98971 46.4277 4.03086 47.2328V119.036C4.03086 129.468 16.4243 134.486 28.1974 134.486C31.999 134.496 35.779 133.916 39.4027 132.766C41.6421 131.667 43.2492 129.468 43.2492 127.268V69.5264C43.2492 56.8833 46.0686 50.9423 54.4504 45.9962C56.6898 44.8967 80.1838 28.9789 80.1838 28.9789C81.3035 27.8794 82.4555 25.648 82.4555 24.0006V23.4971C82.4543 22.4933 82.1928 21.507 81.6965 20.6344C81.2002 19.7619 80.4861 19.0329 79.6239 18.5188ZM127.232 45.5048V43.2574C127.232 40.5104 126.145 38.859 123.905 37.7595C122.226 36.6599 119.475 37.1754 117.783 38.275C108.821 44.8725 84.6989 63.5009 79.1164 66.7996C71.2744 71.1979 63.8874 72.2975 61.0882 69.5466C59.9684 68.447 60.0409 67.4159 60.0409 65.7645C60.0473 64.9468 60.1652 64.1337 60.3914 63.3478C60.7055 62.3892 61.3459 61.2131 63.7143 59.3966C63.827 59.312 63.7706 59.316 63.8874 59.2274C67.9152 56.5731 80.3207 48.288 88.3964 42.8989C88.8601 44.1092 89.7339 45.1184 90.8654 45.7505C92.0069 46.3906 93.3343 46.6168 94.6233 46.391C95.9073 46.1716 97.075 45.5123 97.9261 44.5261C98.7692 43.5492 99.2375 42.3043 99.2472 41.0139V32.7771C99.2545 31.9923 99.0895 31.2155 98.7639 30.5014C98.4377 29.7841 97.961 29.1454 97.3662 28.6285C96.7681 28.1048 96.0649 27.7148 95.304 27.4846C94.5416 27.2517 93.7386 27.1831 92.9477 27.2832C92.0585 27.4268 91.2162 27.7803 90.4908 28.3144C90.4908 28.3144 62.2965 46.9347 57.4148 50.1287C57.3544 50.1891 57.294 50.2455 57.2376 50.3059C53.1857 53.2905 50.7932 56.843 49.7097 60.0934C49.1117 61.9235 48.8178 63.8393 48.8397 65.7645V67.4884C48.8397 67.6575 48.8397 67.8267 48.8397 67.9959V134.486C48.8397 144.934 61.0922 151 72.2934 151C77.3362 151 81.8835 149.937 85.2426 147.738C91.965 143.887 124.453 119.048 124.453 119.048C126.133 117.948 127.272 116.397 127.272 114.75V113.493C118.125 113.56 109.321 110.008 102.78 103.613C99.563 100.475 97.0104 96.722 95.2736 92.5773C93.5369 88.4326 92.6514 83.9809 92.6699 79.4871C92.6517 74.9939 93.5374 70.5429 95.2741 66.3989C97.0109 62.2549 99.5633 58.5025 102.78 55.3648C109.313 48.9856 118.101 45.4423 127.232 45.5048Z" }),
      /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M127.232 51.5464C111.347 51.5464 98.7236 63.9197 98.7236 79.487C98.7236 95.0543 111.347 107.432 127.232 107.432C143.118 107.432 155.741 95.0583 155.741 79.487C155.741 63.9156 143.118 51.5464 127.232 51.5464ZM143.524 83.4785H110.94V75.4955H143.524V83.4785Z"
        }
      )
    ]
  }
);
function $x(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M47.3023 41.7056L28.0718 34.9731C28.0718 41.1191 28.0188 41.0759 28.213 41.6566C28.4798 42.4883 29.1115 43.1808 29.957 43.5045C50.9118 51.5651 49.4385 51.0884 50.2193 51.0884C51.0001 51.0884 49.5033 51.5729 70.4797 43.5045C71.6037 43.0729 72.3668 41.994 72.3668 40.7581V35.2948L53.0108 41.7488C51.1531 42.3687 49.1443 42.353 47.3003 41.7056H47.3023Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M84.188 43.7144C84.188 46.3274 81.01 47.6397 79.166 45.7958C78.6325 45.2641 78.3029 44.5265 78.3029 43.7144V27.1145C69.385 30.0865 62.2759 32.4562 51.1491 36.1658C50.5273 36.3718 49.8603 36.3679 49.2463 36.1501C17.3099 24.9724 19.6797 25.9022 18.9715 25.4334C17.0176 24.0366 17.4629 21.0353 19.7012 20.2525C49.7073 9.75357 49.4954 9.74768 50.2193 9.74768C50.902 9.74768 50.7607 9.76534 80.1881 19.5758C79.9605 20.692 79.8409 21.8474 79.8409 23.0303C79.8409 27.4068 81.4828 31.3989 84.186 34.4258C84.188 36.925 84.188 39.9793 84.188 43.7144Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M81.9204 23.9131C81.9204 23.3265 81.9204 22.738 81.9204 22.1515C81.9381 22.0475 81.9596 21.9435 81.9753 21.8395C82.0695 21.1922 82.1225 20.535 82.2617 19.8975C83.0464 16.286 84.9022 13.3258 87.8447 11.0993C91.5053 8.32741 95.6268 7.40737 100.121 8.34506C103.719 9.09443 106.644 10.9796 108.88 13.8888C111.295 17.0275 112.301 20.6037 111.923 24.5388C111.617 27.7266 110.379 30.5416 108.254 32.9447C105.926 35.5792 103.022 37.2192 99.556 37.8372C98.9891 37.9372 98.4163 37.9941 97.8454 38.0706H96.0838C96.0073 38.0549 95.9328 38.0274 95.8563 38.0216C93.5042 37.8548 91.3032 37.1819 89.2944 35.952C85.3985 33.5646 82.9994 30.1218 82.1578 25.6197C82.0519 25.0567 82.0008 24.4819 81.9243 23.9131H81.9204ZM94.693 25.4648C94.5635 25.3431 94.4929 25.2784 94.4242 25.2097C93.4473 24.2348 92.4724 23.2579 91.4954 22.2849C91.3777 22.1671 91.2561 22.0534 91.1266 21.9494C90.2635 21.2491 88.9335 21.3825 88.2214 22.2378C87.4622 23.15 87.5387 24.3329 88.4234 25.2215C89.9437 26.7457 91.468 28.268 92.9903 29.7883C94.0241 30.8221 95.2599 30.8221 96.2957 29.7883C99.3422 26.7438 102.387 23.6992 105.429 20.6547C105.561 20.5233 105.686 20.3859 105.8 20.2388C106.657 19.1206 106.106 17.4002 104.76 16.9804C103.862 16.7019 103.113 16.9569 102.463 17.6082C99.9386 20.1368 97.4119 22.6595 94.8872 25.1882C94.8127 25.2627 94.7616 25.3647 94.693 25.4667V25.4648Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M96.9586 40.148C94.5104 40.148 92.18 39.634 90.0751 38.7062V43.7144C90.0751 48.5833 86.1144 52.5439 81.2455 52.5439C78.1127 52.5439 75.3545 50.904 73.7871 48.4362C72.9769 48.8972 74.3227 48.3361 53.3914 56.3869C51.3846 57.1598 49.1286 57.1873 47.0493 56.3869L27.8443 48.9992C24.4329 47.6868 22.1848 44.4167 22.1848 40.7581V32.9172L17.7553 31.3635C14.2184 30.1277 11.8427 26.7791 11.8427 23.0303H2.9445C1.32022 23.0303 0 24.3505 0 25.9748V89.514C0 91.1403 1.32022 92.4585 2.9445 92.4585H29.549V98.3887H20.6723C19.048 98.3887 17.7278 99.7089 17.7278 101.333C17.7278 102.957 19.048 104.276 20.6723 104.276H79.7683C81.3926 104.276 82.7109 102.959 82.7109 101.333C82.7109 99.707 81.3926 98.3887 79.7683 98.3887H70.8917V92.4585H97.4961C99.1204 92.4585 100.439 91.1403 100.439 89.514V39.7949C99.3146 40.0264 98.1514 40.148 96.9586 40.148ZM19.2109 83.5818C14.3223 83.5818 10.3577 79.6173 10.3577 74.7287C10.3577 69.8402 14.3223 65.8756 19.2109 65.8756C24.0994 65.8756 28.064 69.8402 28.064 74.7287C28.064 79.6173 24.1014 83.5818 19.2109 83.5818ZM85.6789 83.5818H38.4001C36.7759 83.5818 35.4576 82.2636 35.4576 80.6373C35.4576 79.0111 36.7759 77.6948 38.4001 77.6948H85.6789C87.3032 77.6948 88.6214 79.0131 88.6214 80.6373C88.6214 82.2616 87.3032 83.5818 85.6789 83.5818ZM85.6789 71.7627H38.4001C36.7759 71.7627 35.4576 70.4444 35.4576 68.8201C35.4576 67.1958 36.7759 65.8756 38.4001 65.8756H85.6789C87.3032 65.8756 88.6214 67.1939 88.6214 68.8201C88.6214 70.4464 87.3032 71.7627 85.6789 71.7627Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M58.0916 72.6376V76.8179C58.0916 77.4712 58.7781 77.8949 59.3608 77.6026L63.5411 75.5114C64.1885 75.1878 64.1885 74.2658 63.5411 73.9421L59.3608 71.8509C58.7781 71.5586 58.0916 71.9843 58.0916 72.6356V72.6376Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M16.5823 72.6376V76.8179C16.5823 77.4712 17.2689 77.8949 17.8515 77.6026L22.0319 75.5114C22.6792 75.1878 22.6792 74.2658 22.0319 73.9421L17.8515 71.8509C17.2689 71.5586 16.5823 71.9843 16.5823 72.6356V72.6376Z" })
      ]
    }
  );
}
function Jx(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "27",
      height: "27",
      viewBox: "0 0 22 15",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            stroke: "none",
            d: "M21.5274 3.9381L11.281 0.605099C11.2592 0.597779 11.2353 0.597779 11.2134 0.605099L0.914657 3.88727C0.869307 3.90189 0.838397 3.94375 0.837897 3.99127C0.837397 4.03894 0.867477 4.08131 0.912327 4.09676L3.42849 4.95894V7.94639C3.00603 8.1361 2.7115 8.55956 2.7115 9.05265C2.7115 9.54571 3.00637 9.96951 3.42849 10.1589L2.76696 14.419H4.97214L4.42093 10.1589C4.84339 9.96935 5.13791 9.54572 5.13791 9.05265C5.13791 8.55956 4.84337 8.13611 4.42093 7.94639V5.29882L11.1761 7.61348C11.1876 7.61747 11.1997 7.61946 11.2117 7.61946C11.2237 7.61946 11.2358 7.61763 11.2472 7.61365L21.5285 4.14757C21.5737 4.13229 21.6038 4.08992 21.6034 4.04258C21.6029 3.99473 21.5724 3.95286 21.5273 3.93808L21.5274 3.9381Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2104 8.17106C11.1375 8.17106 11.0658 8.15876 10.9968 8.13517L5.61523 6.29135V10.2296C5.61523 11.3359 8.15747 12.2326 11.2937 12.2326C14.4298 12.2326 16.972 11.3359 16.972 10.2296L16.9719 6.26562L11.4232 8.13621C11.3549 8.15962 11.283 8.1711 11.2104 8.1711L11.2104 8.17106Z"
          }
        )
      ]
    }
  );
}
const Qx = (e) => /* @__PURE__ */ u.jsxs(
  "svg",
  {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "#CBD5E1",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#clip0_28602_6922)", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M160.005 67.3016C160.006 67.4815 159.95 67.6571 159.847 67.8037C159.744 67.9502 159.597 68.0603 159.429 68.1184L80.2103 95.0747C80.1214 95.102 80.029 95.116 79.936 95.1163C79.8426 95.1171 79.7498 95.1014 79.6617 95.0701L27.6115 77.0746V97.6633C29.2566 98.4071 30.6537 99.6152 31.6342 101.142C32.6148 102.669 33.1372 104.449 33.1383 106.269C33.1372 108.088 32.6148 109.869 31.6342 111.396C30.6537 112.922 29.2566 114.131 27.6115 114.874L31.8583 148.005H14.8617L19.9589 114.874C18.3149 114.129 16.9192 112.921 15.9395 111.394C14.9598 109.868 14.4379 108.088 14.4366 106.269C14.4368 104.45 14.9582 102.669 15.938 101.143C16.9178 99.6156 18.3142 98.4073 19.9589 97.6633V74.426L0.571459 67.7215C0.403251 67.6619 0.257738 67.5506 0.155276 67.4034C0.0528133 67.2561 -0.0014712 67.0801 3.03298e-05 66.9002C0.00200043 66.7202 0.0600201 66.5453 0.165851 66.4004C0.271681 66.2555 0.419981 66.1479 0.589763 66.0927L41.7783 52.8452C43.4158 59.9957 47.0542 66.5207 52.2606 71.6436C59.6742 78.9495 69.6438 83.0085 80.0046 82.9393C90.3638 83.0073 100.332 78.9484 107.744 71.6436C112.925 66.5495 116.553 60.0648 118.199 52.956L159.419 66.4895C159.59 66.5451 159.738 66.6536 159.843 66.7995C159.948 66.9454 160.005 67.1212 160.005 67.3016Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M79.9223 99.4074C79.3625 99.4059 78.8067 99.3123 78.2766 99.1305L36.8092 84.7895V115.437C36.8092 124.038 56.3978 131.015 80.5623 131.015C104.727 131.015 124.315 124.038 124.315 115.437V84.5911L81.5635 99.1351C81.0352 99.3172 80.4806 99.4092 79.9223 99.4074Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80.0045 12C61.9748 12 47.648 26.1749 47.648 44.009C47.6467 46.2685 47.8812 48.5219 48.3474 50.7319C51.4194 65.276 64.3108 76.0179 80.0045 76.0179C95.6983 76.0179 108.544 65.3129 111.648 50.8057C112.123 48.572 112.362 46.2936 112.361 44.009C112.357 26.1749 98.0297 12 80.0045 12ZM98.496 48.5817H61.5131V39.4362H98.496V48.5817Z"
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_28602_6922", children: /* @__PURE__ */ u.jsx("rect", { width: "160", height: "136", fill: "white", transform: "translate(0 12)" }) }) })
    ]
  }
);
function nh(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "19",
      height: "15",
      viewBox: "0 0 19 15",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.0035 0.218132H1.88928C0.84752 0.218132 0 1.06565 0 2.10741V12.1836C0 13.2254 0.84752 14.0729 1.88928 14.0729H17.0035C18.0453 14.0729 18.8928 13.2254 18.8928 12.1836V2.10741C18.8928 1.06565 18.0453 0.218132 17.0035 0.218132ZM15.744 4.62646H3.14879C2.80074 4.62646 2.51903 4.34476 2.51903 3.9967C2.51903 3.64865 2.80074 3.36694 3.14879 3.36694H15.744C16.0921 3.36694 16.3738 3.64865 16.3738 3.9967C16.3738 4.34476 16.0921 4.62646 15.744 4.62646ZM6.92737 10.9241H3.1488V7.14551H6.92737V10.9241Z"
        }
      )
    }
  );
}
function qx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "19",
      height: "28",
      viewBox: "0 0 19 19",
      fill: "#ACB7D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2301 7.70151V0.805664H16.1408C17.2245 0.805664 18.1111 1.69227 18.1111 2.7759V7.7015L10.2301 7.70151ZM10.2301 9.67175H18.1111V16.5676C18.1111 17.6512 17.2245 18.5378 16.1408 18.5378H10.2301V9.67175ZM8.25988 18.5378H2.34915C1.26552 18.5378 0.378906 17.6512 0.378906 16.5676V2.77591C0.378906 1.69228 1.26552 0.805674 2.34915 0.805674H8.25988V18.5378Z"
        }
      )
    }
  );
}
function Xx(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "#253661",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.606 2.90772C1.13495 4.37914 0.308594 6.37461 0.308594 8.45517C0.308774 10.5359 1.13533 12.5314 2.60673 14.0026C4.07797 15.4739 6.07344 16.3004 8.1542 16.3004C10.2349 16.3004 12.2304 15.4739 13.7016 14.0026C15.1729 12.5314 15.9996 10.5359 15.9996 8.45517C15.9998 6.37446 15.1735 4.37899 13.7022 2.90772C12.7284 1.93379 11.5154 1.2333 10.185 0.87684C8.85459 0.52022 7.4538 0.52022 6.12337 0.87684C4.79297 1.2333 3.57985 1.93379 2.60594 2.90772H2.606ZM4.08614 4.38787L4.08632 4.38804C5.03674 3.4393 6.28922 2.85316 7.62657 2.73076C8.9639 2.60854 10.302 2.95788 11.4087 3.71857L3.41696 11.7131C2.65463 10.606 2.30401 9.2672 2.42586 7.92858C2.54752 6.59018 3.13422 5.33636 4.08368 4.38525L4.08614 4.38787ZM12.2222 12.5239C11.2716 13.4725 10.0191 14.0588 8.68177 14.181C7.34441 14.3032 6.00637 13.9539 4.8996 13.1934L12.889 5.19607C13.6513 6.30316 14.002 7.64195 13.8802 8.98055C13.7585 10.319 13.1718 11.5728 12.2223 12.5239L12.2222 12.5239Z"
        }
      )
    }
  );
}
function eM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "white",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "white",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { id: "Icon", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Vector",
            d: "M7 2.46948H16.5L21 6.96948V19.4695",
            fill: "none",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Vector_2",
            d: "M3 20.9695V6.96948C3 6.14105 3.67157 5.46948 4.5 5.46948H14.2515C14.4106 5.46948 14.5632 5.53269 14.6757 5.64522L17.8243 8.79374C17.9368 8.90627 18 9.05888 18 9.21801V20.9695C18 21.7979 17.3284 22.4695 16.5 22.4695H4.5C3.67157 22.4695 3 21.7979 3 20.9695Z",
            strokeWidth: "1.5",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Vector_3",
            d: "M14 8.86948V5.82303C14 5.62777 14.1583 5.46948 14.3536 5.46948C14.4473 5.46948 14.5372 5.50673 14.6036 5.57303L17.8964 8.86593C17.9628 8.93223 18 9.02216 18 9.11593C18 9.31119 17.8417 9.46948 17.6464 9.46948H14.6C14.2686 9.46948 14 9.20085 14 8.86948Z",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] })
    }
  );
}
function tM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.8519 10.2206V0.866211H8.9426V10.3189L5.94167 7.31566L3.88501 9.37464L10.3481 15.8378L16.8939 9.29391L14.8351 7.23741L11.8519 10.2206Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4646 15.7612V17.9567H3.29433V15.7612H0.38501V20.866H20.3742V15.7612H17.4646Z"
          }
        )
      ]
    }
  );
}
function ah(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "18",
      height: "4",
      viewBox: "0 0 18 4",
      fill: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("circle", { cx: "2.50928", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "9.06396", cy: "2.03174", r: "1.90771" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "15.6187", cy: "2.03174", r: "1.90771" })
      ]
    }
  );
}
function nM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "20",
      height: "10",
      viewBox: "0 0 20 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.2254 0.899587C12.5915 1.2657 12.5915 1.8593 12.2254 2.22541L5.35041 9.10041C4.9843 9.46653 4.3907 9.46653 4.02459 9.10041L0.587087 5.66291C0.220971 5.2968 0.220971 4.7032 0.587087 4.33709C0.953204 3.97097 1.5468 3.97097 1.91291 4.33709L4.6875 7.11167L10.8996 0.899587C11.2657 0.533471 11.8593 0.533471 12.2254 0.899587Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4129 0.899587C19.779 1.2657 19.779 1.8593 19.4129 2.22541L12.5379 9.10041C12.1718 9.46653 11.5782 9.46653 11.2121 9.10041L9.38396 7.27229C9.01785 6.90617 9.01785 6.31258 9.38396 5.94646C9.75008 5.58035 10.3437 5.58035 10.7098 5.94646L11.875 7.11167L18.0871 0.899587C18.4532 0.533471 19.0468 0.533471 19.4129 0.899587Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function aM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      fill: "#D9D9D9",
      width: "15",
      height: "25",
      viewBox: "0 0 15 25",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("circle", { cx: "2.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "2.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "2.5", cy: "22.4942", r: "2.5" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "12.5", cy: "2.4942", r: "2.5" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "12.5", cy: "12.4942", r: "2.5" }),
        /* @__PURE__ */ u.jsx("circle", { cx: "12.5", cy: "22.4942", r: "2.5" })
      ]
    }
  );
}
function rM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 512 512",
      width: "512",
      height: "512",
      fill: "#CBD5E1",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M488.432,0H23.568A22.916,22.916,0,0,0,.679,22.89v7.667L220.3,181.894a63.26,63.26,0,0,0,71.4,0L511.321,30.557V22.89A22.916,22.916,0,0,0,488.432,0Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M256,208.962a78.932,78.932,0,0,1-44.805-13.85L.679,50.05V321.965a22.751,22.751,0,0,0,4.046,12.973l131.5-148.376a8.026,8.026,0,0,1,12.014,10.646L18,344.165a22.863,22.863,0,0,0,5.573.689H130.947L112.7,326.6a30.705,30.705,0,1,1,43.424-43.424l59.093,59.093a30.3,30.3,0,0,1,37.96-20.159,30.3,30.3,0,0,1,43.543-22.5,24.191,24.191,0,0,1,6.519-12.805,28.045,28.045,0,0,1,39.661,0l52.675,52.675q2.614,2.614,5.084,5.372h87.778a22.863,22.863,0,0,0,5.573-.689L363.761,197.208a8.026,8.026,0,0,1,12.014-10.646l131.5,148.376a22.751,22.751,0,0,0,4.046-12.973V50.05L300.805,195.112A78.932,78.932,0,0,1,256,208.962Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M414.5,399.466a127.192,127.192,0,0,0-30.284-48.634l-52.675-52.675a11.991,11.991,0,0,0-16.96,0c-1.848,1.848-2.649,5.1-2.2,8.91a19.38,19.38,0,0,0,4.338,10.123c9.063,9.05-4.709,20.519-12.429,10.36l-11.012-10.874a14.283,14.283,0,1,0-20.245,20.154l3.377,3.377a8.026,8.026,0,0,1-11.351,11.35l-10.67-10.5a14.283,14.283,0,1,0-20.264,20.135s3.824,3.862,4.024,4.117a8.022,8.022,0,0,1-.6,10.555c-.018.018-.032.037-.05.055a8.027,8.027,0,0,1-10.741.551c-.21-.171-13.918-13.859-13.918-13.859l-68.079-68.078a14.653,14.653,0,1,0-20.722,20.724L244.209,435.415a11.156,11.156,0,0,1-11.86,18.314l-52.89-20.153A23.034,23.034,0,0,0,155,438.807a3.758,3.758,0,0,0,.831,5.942l62.9,34.943A215.75,215.75,0,0,0,294.953,505l69.936,7,68.879-68.879L414.616,399.8Z" })
      ]
    }
  );
}
function iM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { id: "_x32__x2C__message_x2C__Email_x2C__mail_x2C__open", children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx("path", { d: "m16 219.855v269.882l178.304-145.554z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m25.032 495.273h461.937l-230.969-188.546z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m496 489.737v-269.882l-178.304 124.328z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m252.838 296.4c1.84-1.502 4.483-1.502 6.323 0l50.48 41.208 183.067-127.649-236.708-193.232-236.708 193.232 183.067 127.649z" })
      ] }) }) })
    }
  );
}
function oM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.4753 8.47342C15.6279 8.27888 15.6086 8.00028 15.4304 7.82891C15.2521 7.65754 14.9731 7.6492 14.7849 7.80946L6.15544 15.1533L1.5985 13.3905C1.3327 13.2886 1.11625 13.0887 0.994021 12.8316C0.871542 12.5748 0.852573 12.2805 0.940996 12.01C1.02944 11.7395 1.21859 11.5135 1.46909 11.3785L20.3875 0.777433C20.5866 0.670209 20.8181 0.638952 21.0385 0.689664C21.2591 0.740155 21.4536 0.869374 21.586 1.05279C21.7185 1.23645 21.7796 1.46178 21.7583 1.6871L20.0988 18.9911C20.065 19.351 19.8635 19.6738 19.5552 19.8621C19.2466 20.0504 18.8675 20.0821 18.5321 19.9473L12.9861 17.7993L9.50435 21.0629C9.33211 21.2239 9.1036 21.3109 8.86793 21.3049C8.63202 21.2991 8.40813 21.2007 8.24424 21.0314C8.08011 20.8619 7.98935 20.6347 7.99097 20.3989V17.836L15.4753 8.47342Z"
        }
      )
    }
  );
}
function sM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "189",
      height: "176",
      id: "Layer_1",
      viewBox: "0 0 65 65",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("circle", { cx: "32.5", cy: "32.5", fill: "#eaebf0", r: "32" }) }),
        /* @__PURE__ */ u.jsxs("g", { children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "m49.1 22.9v1.2h-8.1c-1.1 0-2.1.7-2.3 1.5s-1.3 1.5-2.3 1.5h-16.1c-1.5 0-3 .9-3.3 2.1l-4.5 17.3c-.1.5 0 1 .2 1.3-.5-.5-.8-1.3-.8-2.1v-26.4c0-1.7 1.4-3.1 3.1-3.1h11.3c1.1 0 1.9.9 1.9 1.9s.9 1.9 1.9 1.9h16.1c1.6.1 2.9 1.3 2.9 2.9z",
              fill: "#cccbdd"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "m12.7 48.5c-.2 0-.4-.1-.5-.2-.7-.7-1-1.6-1-2.6v-26.4c0-2.1 1.7-3.9 3.9-3.9h11.3c1.5 0 2.7 1.2 2.7 2.7 0 .7.5 1.2 1.2 1.2h16.1c1.9 0 3.5 1.6 3.5 3.5v1.2c0 .4-.3.8-.8.8h-8.1c-.8 0-1.5.5-1.6.9-.3 1.1-1.6 2-3.1 2h-16c-1.3 0-2.4.8-2.6 1.5l-4.5 17.3c-.1.3 0 .5.1.7.2.3.1.8-.2 1-.1.3-.2.3-.4.3zm2.3-31.6c-1.3 0-2.4 1.1-2.4 2.4v23.6l3.6-13.9c.4-1.5 2.2-2.7 4-2.7h16.1c.8 0 1.5-.5 1.6-.9.3-1.1 1.6-2 3-2h7.3v-.5c0-1.1-.9-2-2-2h-16c-1.5 0-2.7-1.2-2.7-2.7 0-.7-.5-1.2-1.2-1.2h-11.3z",
              fill: "#47769d"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsxs("g", { children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "m54.8 26.5-5.2 20c-.3 1.3-2 2.4-3.7 2.4h-30.9c-.1 0-.2 0-.3 0-.9-.1-1.6-.4-2-1-.3-.4-.3-.8-.2-1.3l4.5-17.5c.3-1.2 1.8-2.1 3.3-2.1h16.1c1.1 0 2.1-.7 2.3-1.5s1.3-1.5 2.3-1.5h11.3c1.8.1 2.9 1.2 2.5 2.5z",
              fill: "#f5fdff"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "m45.9 49.6h-30.9c-.1 0-.3 0-.4 0-1.1-.1-2-.6-2.5-1.4-.4-.6-.5-1.2-.3-1.9l4.4-17.3c.4-1.5 2.2-2.7 4-2.7h16.1c.8 0 1.5-.5 1.6-.9.3-1.1 1.6-2 3-2h11.3c1.2 0 2.2.4 2.8 1.2.5.6.6 1.3.4 2.1l-5.2 20c-.2 1.6-2.2 2.9-4.3 2.9zm-25.6-21.8c-1.3 0-2.4.8-2.6 1.5l-4.5 17.3c-.1.3 0 .5.1.7.2.4.8.6 1.4.7h.3 30.9c1.4 0 2.8-.8 3-1.8l5.2-20c.1-.3 0-.6-.2-.8-.3-.4-.9-.6-1.6-.6h-11.3c-.8 0-1.5.5-1.6.9-.3 1.1-1.6 2-3.1 2h-16z",
              fill: "#47769d"
            }
          )
        ] })
      ] })
    }
  );
}
function lM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "189",
      height: "176",
      viewBox: "0 0 189 176",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M99.0519 149.787C135.246 149.787 164.588 120.445 164.588 84.1219C164.588 47.799 135.116 18.4563 99.0519 18.4563C62.8583 18.4563 33.5156 47.799 33.5156 84.1219C33.5156 120.445 62.8583 149.787 99.0519 149.787Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M184.143 119.506C186.466 119.506 188.349 117.613 188.349 115.3C188.349 112.971 186.466 111.094 184.143 111.094C181.82 111.094 179.938 112.971 179.938 115.3C179.938 117.613 181.82 119.506 184.143 119.506Z",
            fill: "#DAE1EB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.0418 22.7514C27.3641 22.7514 29.2477 20.8587 29.2477 18.5455C29.2477 16.2172 27.3641 14.3396 25.0418 14.3396C22.7181 14.3396 20.8359 16.2172 20.8359 18.5455C20.8359 20.8587 22.7181 22.7514 25.0418 22.7514Z",
            fill: "#DAE1EB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.31291 112.939C12.627 112.939 16.1239 109.439 16.1239 105.128C16.1239 100.817 12.627 97.3169 8.31291 97.3169C3.99886 97.3169 0.501953 100.817 0.501953 105.128C0.501953 109.439 3.99886 112.939 8.31291 112.939Z",
            fill: "#DAE1EB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M158.973 17.4765C158.251 17.4765 157.674 16.8946 157.674 16.1724V1.66641C157.674 0.944124 158.251 0.372314 158.973 0.372314C159.694 0.372314 160.271 0.944124 160.271 1.66641V16.1724C160.271 16.8946 159.694 17.4765 158.973 17.4765Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M169.508 28.5819C169.508 27.8597 170.086 27.2878 170.807 27.2878H185.311C186.032 27.2878 186.609 27.8597 186.609 28.5819C186.609 29.3042 186.032 29.8861 185.311 29.8861H170.807C170.086 29.8861 169.508 29.3042 169.508 28.5819Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M168.357 19.202C167.852 18.7005 167.852 17.8377 168.357 17.3261L178.676 7.08367C179.181 6.57205 180.047 6.57205 180.552 7.08367C181.057 7.58526 181.057 8.44799 180.552 8.95961L170.305 19.202C169.728 19.7137 168.863 19.7137 168.357 19.202Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsx("g", { filter: "url(#filter0_d_10697_6855)", children: /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M155.556 31.0478V137.172C155.556 140.292 153.857 142.89 151.82 142.89H46.2848C44.2462 143.016 42.5488 140.419 42.5488 137.298V31.0478C42.5488 27.8193 44.2462 25.3484 46.2848 25.3484H151.82C153.942 25.3484 155.556 27.9456 155.556 31.0478Z",
            fill: "url(#paint0_linear_10697_6855)"
          }
        ) }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M155.556 30.095V36.9146H42.5488V30.095C42.5488 27.4063 44.2462 25.3484 46.2848 25.3484H151.82C153.942 25.3484 155.556 27.5114 155.556 30.095Z",
            fill: "url(#paint1_linear_10697_6855)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M48.9235 33.1296C49.8173 33.1296 50.5428 32.4085 50.5428 31.5073C50.5428 30.606 49.8173 29.885 48.9235 29.885C48.0283 29.885 47.3027 30.606 47.3027 31.5073C47.3027 32.4085 48.0282 33.1296 48.9235 33.1296Z",
            fill: "#F9FAFB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M54.0016 33.1296C54.8969 33.1296 55.6224 32.4085 55.6224 31.5073C55.6224 30.606 54.8969 29.885 54.0016 29.885C53.1064 29.885 52.3809 30.606 52.3809 31.5073C52.3809 32.4085 53.1064 33.1296 54.0016 33.1296Z",
            fill: "#F9FAFB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.1872 33.1296C60.0824 33.1296 60.808 32.4085 60.808 31.5073C60.808 30.606 60.0824 29.885 59.1872 29.885C58.2919 29.885 57.5664 30.606 57.5664 31.5073C57.5664 32.4085 58.2919 33.1296 59.1872 33.1296Z",
            fill: "#F9FAFB"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 100.231C66.5195 99.324 67.2546 98.5889 68.1615 98.5889H129.944C130.851 98.5889 131.586 99.324 131.586 100.231C131.586 101.138 130.851 101.873 129.944 101.873H68.1615C67.2546 101.873 66.5195 101.138 66.5195 100.231Z",
            fill: "#D5DDEA"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 110.514C66.5195 109.608 67.2546 108.873 68.1615 108.873H129.944C130.851 108.873 131.586 109.608 131.586 110.514C131.586 111.421 130.851 112.156 129.944 112.156H68.1615C67.2546 112.156 66.5195 111.421 66.5195 110.514Z",
            fill: "#D5DDEA"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5195 120.799C66.5195 119.892 67.2546 119.157 68.1615 119.157H129.944C130.851 119.157 131.586 119.892 131.586 120.799C131.586 121.705 130.851 122.441 129.944 122.441H68.1615C67.2546 122.441 66.5195 121.705 66.5195 120.799Z",
            fill: "#D5DDEA"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M82.7083 60.385C84.5238 60.385 85.996 58.9153 85.996 57.0998C85.996 55.2843 84.5238 53.8022 82.7083 53.8022C80.894 53.8022 79.4219 55.2843 79.4219 57.0998C79.4219 58.9153 80.894 60.385 82.7083 60.385Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.4 60.385C117.215 60.385 118.686 58.9153 118.686 57.0998C118.686 55.2843 117.215 53.8022 115.4 53.8022C113.584 53.8022 112.113 55.2843 112.113 57.0998C112.113 58.9153 113.584 60.385 115.4 60.385Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M104.384 81.9734H94.0792C92.481 81.9734 91.1484 80.6395 91.1484 79.034C91.1484 77.4408 92.481 76.1069 94.0792 76.1069H104.295C105.895 76.1069 107.227 77.4408 107.227 79.034C107.316 80.6395 105.984 81.9734 104.384 81.9734Z",
            fill: "#989FB0"
          }
        ),
        /* @__PURE__ */ u.jsxs("defs", { children: [
          /* @__PURE__ */ u.jsxs(
            "filter",
            {
              id: "filter0_d_10697_6855",
              x: "20.5488",
              y: "14.3484",
              width: "157.006",
              height: "161.546",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB",
              children: [
                /* @__PURE__ */ u.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                /* @__PURE__ */ u.jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                  }
                ),
                /* @__PURE__ */ u.jsx("feOffset", { dy: "11" }),
                /* @__PURE__ */ u.jsx("feGaussianBlur", { stdDeviation: "11" }),
                /* @__PURE__ */ u.jsx(
                  "feColorMatrix",
                  {
                    type: "matrix",
                    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.270588 0"
                  }
                ),
                /* @__PURE__ */ u.jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_10697_6855" }),
                /* @__PURE__ */ u.jsx(
                  "feBlend",
                  {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_10697_6855",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_10697_6855",
              x1: "99.0165",
              y1: "22.6255",
              x2: "99.0165",
              y2: "144.159",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#FDFEFF" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "0.9964", stopColor: "#ECF0F5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_10697_6855",
              x1: "43.6352",
              y1: "31.0472",
              x2: "156.229",
              y2: "31.0472",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#00A0FF" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#46BAFF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function uM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "428.067px",
      y: "428.067px",
      viewBox: "0 0 428.067 428.067",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M285.376,0c-0.142-0.001-0.284,0-0.426,0.003c-9.726-0.167-17.746,7.583-17.912,17.309
			c-0.003,0.183-0.003,0.366-0.001,0.549v41.142h36V17.861C303.092,8.052,295.185,0.056,285.376,0z`
          }
        ) }) }),
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M327.35,44.003h-8.313v23.222c0.084,4.211-3.261,7.694-7.473,7.778c-0.102,0.002-0.203,0.002-0.305,0h-52.622
			c-4.132,0.068-7.536-3.225-7.605-7.357c-0.002-0.14-0.001-0.281,0.005-0.421V44.003h-136v23.222
			c-0.136,4.421-3.823,7.9-8.245,7.778h-52.62c-4.379,0.113-8.02-3.344-8.134-7.723c0-0.018-0.001-0.037-0.001-0.055V44.003h-7.455
			C20.59,44.094,6.049,58.699,6.037,76.691v34.312h354V76.691C359.959,58.671,345.37,44.082,327.35,44.003z`
          }
        ) }) }),
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("path", { d: "M80.483,0.003c-10.097,0-18.446,7.763-18.446,17.858v41.142h37V17.861C99.037,7.766,90.579,0.003,80.483,0.003z" }) }) }),
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M6.037,127.003v218.913c0,17.941,14.6,33.087,32.545,33.087h148.231c-12.607-21.159-19.283-45.322-19.327-69.952
			c0-74.6,60.728-135.566,135.327-135.566c19.766,0.048,39.288,4.375,57.224,12.683v-59.165H6.037z`
          }
        ) }) }),
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M302.737,189.485c-65.883,0.001-119.29,53.41-119.289,119.293s53.41,119.29,119.293,119.289
			c65.882-0.001,119.289-53.409,119.289-119.291C421.956,242.923,368.59,189.558,302.737,189.485z M349.847,327.003h-53.622
			c-4.493-0.081-8.114-3.707-8.188-8.2v-70.16c0-4.418,3.582-8,8-8s8,3.582,8,8v62.36h45.81c4.418,0,8,3.582,8,8
			S354.265,327.003,349.847,327.003z`
          }
        ) }) })
      ]
    }
  );
}
function cM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      fill: "#F04438",
      width: "21",
      height: "21",
      viewBox: "0 0 21 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.7436 20.08C16.2886 20.08 20.7836 15.5849 20.7836 10.04C20.7836 4.49506 16.2886 0 10.7436 0C5.19867 0 0.703613 4.49506 0.703613 10.04C0.703613 15.5849 5.19867 20.08 10.7436 20.08Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.166 3.59497L11.8445 12.3002H9.02518L8.70368 3.59497H12.166ZM10.4348 16.455C9.95671 16.455 9.54762 16.287 9.20758 15.9511C8.86753 15.6151 8.69957 15.2061 8.70369 14.7238C8.69957 14.2539 8.86753 13.852 9.20758 13.5182C9.54763 13.1843 9.95672 13.0174 10.4348 13.0174C10.8882 13.0174 11.2891 13.1843 11.6374 13.5182C11.9857 13.8521 12.1619 14.2539 12.166 14.7238C12.1619 15.2061 11.9857 15.6152 11.6374 15.9511C11.2891 16.287 10.8882 16.455 10.4348 16.455Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function dM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: [
        /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#clip0_301_2)", children: [
          /* @__PURE__ */ u.jsx("path", { d: "M12 8.13763C9.86904 8.13763 8.13763 9.86904 8.13763 12C8.13763 14.131 9.86904 15.8624 12 15.8624C14.131 15.8624 15.8624 14.131 15.8624 12C15.8624 9.86904 14.131 8.13763 12 8.13763ZM11.707 10.8546C11.2275 10.8546 10.828 11.2542 10.828 11.7336H9.54939C9.57603 10.535 10.535 9.57604 11.707 9.57604V10.8546Z" }),
          /* @__PURE__ */ u.jsx("path", { d: "M23.7203 11.2009C22.4151 9.57605 17.7536 4.27527 12 4.27527C6.24639 4.27527 1.58491 9.57605 0.279689 11.2009C-0.0932297 11.6537 -0.0932297 12.3197 0.279689 12.7991C1.58491 14.424 6.24639 19.7248 12 19.7248C17.7536 19.7248 22.4151 14.424 23.7203 12.7991C24.0932 12.3463 24.0932 11.6804 23.7203 11.2009ZM12 17.5938C8.9101 17.5938 6.40622 15.0899 6.40622 12C6.40622 8.91012 8.9101 6.40623 12 6.40623C15.0899 6.40623 17.5938 8.91012 17.5938 12C17.5938 15.0899 15.0899 17.5938 12 17.5938Z" })
        ] }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_301_2", children: /* @__PURE__ */ u.jsx("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  );
}
function pM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "12",
      height: "23",
      viewBox: "0 0 12 23",
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M11.1133 12.5947L11.7148 8.6416H7.89062V6.06348C7.89062 4.94629 8.40625 3.91504 10.125 3.91504H11.8867V0.520508C11.8867 0.520508 10.2969 0.219727 8.79297 0.219727C5.65625 0.219727 3.59375 2.15332 3.59375 5.59082V8.6416H0.0703125V12.5947H3.59375V22.2197H7.89062V12.5947H11.1133Z" })
    }
  );
}
function fM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.7608 0.608398H1.19002C0.382658 0.608398 -0.0247321 1.588 0.547328 2.16007L7.55151 9.16531V16.9692C7.55151 17.2658 7.69622 17.5438 7.93921 17.7139L10.969 19.834C11.5667 20.2524 12.3992 19.8283 12.3992 19.0893V9.16531L19.4035 2.16007C19.9744 1.58915 19.5698 0.608398 18.7608 0.608398Z"
        }
      )
    }
  );
}
function hM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 19",
      fill: "#ACB7D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.00462 13.1546H15.6384V18.1335C15.6384 18.6023 15.2623 18.981 14.7962 18.981H7.8468C7.38068 18.981 7.00461 18.6023 7.00461 18.1335L7.00462 13.1546ZM21.0702 0.0185547C21.7191 0.0185547 22.1243 0.725675 21.8012 1.28978L19.1872 5.84501H3.45578L0.844472 1.28978C0.518722 0.725675 0.923922 0.0185547 1.57278 0.0185547H21.0702H21.0702ZM4.43038 7.53998H18.2126L15.9641 11.4596H6.67886L4.43038 7.53998Z"
        }
      )
    }
  );
}
function rh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M-0.000106812 4.07082C-0.000106812 2.90389 0.339278 1.90757 1.05149 1.19147L2.29012 2.43686C0.911525 3.81801 2.11547 8.11214 6.04069 12.0625C9.96591 16.0129 14.2392 17.2222 15.6165 15.8386L16.8552 17.084C14.5315 19.4203 9.23883 17.7627 4.80825 13.3067C1.73521 10.2156 -0.000106812 6.70857 -0.000106812 4.07082Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M7.81099 18.1573C6.65039 18.1573 5.65949 17.8161 4.94604 17.1L6.18467 15.8546C7.56079 17.2382 11.8316 16.0277 15.7605 12.0786C19.6894 8.1294 20.8909 3.83527 19.5148 2.45163L20.7534 1.20624C23.0783 3.5426 21.4285 8.86418 16.9967 13.319C13.9224 16.4138 10.4344 18.1573 7.81099 18.1573Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M17.4053 11.5363C16.6534 9.35934 15.1175 7.03294 13.08 4.98551C8.64939 0.529482 3.35672 -1.12939 1.03305 1.20822C0.868316 1.37511 1.01076 1.78733 1.35262 2.13106C1.69448 2.47479 2.10447 2.61677 2.26921 2.45113C3.64656 1.06749 7.91736 2.27802 11.8451 6.22842C13.703 8.09651 15.0878 10.1826 15.7554 12.1129C16.34 13.8054 16.2831 15.1704 15.6018 15.8553C15.4358 16.021 15.5795 16.4344 15.9201 16.7769C16.2608 17.1194 16.672 17.2639 16.838 17.097C18.0283 15.9002 18.2302 13.9225 17.4053 11.5363Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M20.751 1.20826C19.5582 0.00894456 17.5937 -0.194055 15.218 0.636625C13.0541 1.39134 10.7391 2.93687 8.70281 4.9843C4.27223 9.43909 2.62237 14.7607 4.94604 17.0983C5.11202 17.2639 5.522 17.1207 5.86387 16.7782C6.20573 16.4357 6.34817 16.0223 6.18219 15.8554C4.80236 14.4717 6.01002 10.1776 9.93896 6.22721C11.7969 4.35912 13.8716 2.96676 15.7915 2.29549C17.4748 1.70891 18.8323 1.76495 19.5148 2.44992C19.6795 2.61556 20.0908 2.47234 20.4314 2.12861C20.772 1.78488 20.9157 1.3739 20.751 1.20826Z" })
      ]
    }
  );
}
function mM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      viewBox: "-135.4 209.8 604.3 125.4",
      width: "159",
      height: "42",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m67.2 244.4h.2c1.2 0 1.9.9 1.9 2.1v53.9c0 .9-.7 1.9-1.9 1.9-.9 0-1.9-.7-1.9-1.9v-54.1c0-1 .7-1.9 1.7-1.9zm-51.3 2.8h35.3c1.2 0 1.9 1.2 1.9 2.1s-.7 1.9-1.9 1.9h-33.4v22.5h30.2c.9 0 1.9.7 1.9 1.9 0 .9-.7 1.9-1.9 1.9h-29.9v23.2c-.2 1.2-1.2 2.1-2.3 2.1-1.2 0-2.1-.9-2.1-2.1v-51.3h.2a2 2 0 0 1 2-2.2zm102.5 16.7c0-1.2-.9-1.9-1.9-1.9-1.2 0-1.9.9-1.9 1.9v22.5c0 7.7-6.3 13.7-14 13.5-8.2 0-12.9-5.3-12.9-13.7v-22.3c0-1.2-.9-1.9-1.9-1.9-.9 0-1.9.9-1.9 1.9v23c0 9.5 6.1 16.5 16.1 16.5 6.1.2 11.9-3 14.7-8.4v5.8c0 1.2.9 1.9 1.9 1.9 1.2 0 1.9-.9 1.9-1.9h-.2v-36.9zm35.5.3c0 .9-.9 1.6-1.9 1.6h-12.9v25.8c0 5.8 3.3 7.9 8.2 7.9 1.6 0 3.3-.2 4.7-.7.9 0 1.6.7 1.6 1.6 0 .7-.5 1.4-1.2 1.6-1.9.7-4 .9-5.8.9-6.1 0-11.2-3.5-11.2-10.9v-26.2h-4.4c-.9 0-1.9-.9-1.9-1.9 0-.9.9-1.6 1.9-1.6h4.4v-11.1c0-.9.7-1.9 1.6-1.9h.2c.9 0 1.9.9 1.9 1.9v11.1h12.9c1 0 1.9.9 1.9 1.9zm30 1.6c.9 0 1.9-.7 1.9-1.6s-.9-1.9-1.9-1.9h-12.9v-11.1c0-.9-.9-1.9-1.9-1.9h-.2c-.9 0-1.6.9-1.6 1.9v11.1h-4.4c-.9 0-1.9.7-1.9 1.6s.9 1.9 1.9 1.9h4.4v26.2c0 7.4 5.1 10.9 11.2 10.9 1.9 0 4-.2 5.8-.9.7-.2 1.2-.9 1.2-1.6 0-.9-.7-1.6-1.6-1.6-1.4.5-3 .7-4.7.7-4.9 0-8.2-2.1-8.2-7.9v-25.8zm8.9 16.5c0-11.8 8.2-21.1 19.2-21.1 11.5 0 18.7 9.3 18.7 21.1 0 .9-.9 1.9-1.9 1.9h-31.8c.7 10 8 15.8 15.9 15.8 4.9 0 9.8-2.1 13.1-5.6.2-.2.7-.5 1.2-.5.9 0 1.9.9 1.9 1.9 0 .5-.2.9-.7 1.4-4 4.4-9.8 6.7-15.7 6.5-10.8 0-19.9-8.4-19.9-21.1zm53.1-8.4c2.6-6.7 8.9-11.6 16.1-12.1 1.2 0 2.1.9 2.1 2.3 0 .9-.7 2.1-1.9 2.1h-.2c-8.7.9-16.1 7.2-16.1 20.2v14.9c-.2 1.2-.9 1.9-2.1 1.9-.9 0-1.9-.9-1.9-1.9v-37.2c.2-1.2.9-1.9 2.1-1.9.9 0 1.9.9 1.9 1.9zm79.9-14.2c-2.8 0-5.1 1.9-5.8 4.6l-6.8 21.6-6.8-21.6c-.7-2.8-3.3-4.9-6.3-4.9h-.7c-3 0-5.6 1.9-6.3 4.9l-6.8 21.4-6.5-21.6c-.7-2.6-3-4.6-5.8-4.6h-.2c-3 0-5.4 2.6-5.4 5.6 0 .9.2 1.9.5 2.8l10.5 30c.7 3 3.3 5.1 6.5 5.3h.5c3 0 5.6-2.1 6.5-5.1l6.8-21.4 6.8 21.4c.7 3 3.5 5.1 6.5 5.1h.5c3.3 0 6.1-2.1 6.8-5.3l10.5-30.2c.2-.7.5-1.6.5-2.3v-.2c-.1-3.1-2.4-5.5-5.5-5.5zm16.4 2.1c4.4-1.4 8.9-2.3 13.6-2.1 6.5 0 11.2 1.9 14.7 4.9 3.3 3.7 4.9 8.6 4.7 13.5v19c0 3.3-2.6 5.8-5.8 5.8-3 0-5.6-2.1-5.8-5.1-3.3 3.5-8 5.6-12.9 5.3-7.7 0-14.5-4.6-14.5-13 0-9.3 7-13.7 17.1-13.7 3.5 0 7 .5 10.3 1.6v-.7c0-5.1-3-7.7-9.1-7.7-2.8 0-5.6.2-8.4 1.2-.5.2-1.2.2-1.6.2-2.8.2-5.1-1.9-5.1-4.6-.2-2 .9-3.9 2.8-4.6zm69 1.9c.7-2.6 3-4.2 5.6-4.2 3.3 0 5.8 2.6 5.8 5.6v.2c0 .9-.2 1.9-.7 2.8l-12.6 30c-1.2 3-4 4.9-7 5.1h-.7c-3.3-.2-5.8-2.3-6.8-5.3l-13.1-30c-.5-.9-.7-1.9-.7-2.8.2-3.3 2.8-5.6 5.8-5.6 2.8 0 5.1 1.9 5.8 4.4l9.1 24.4zm16.2 19.5c.5 11.6 10.5 20.7 22.2 20 5.4 0 10.5-1.6 14.7-5.1 1.2-.9 1.6-2.1 1.6-3.5v-.2c0-2.6-2.1-4.6-4.7-4.6-.9 0-2.1.2-2.8.9-2.6 1.9-5.6 3-8.7 2.8-5.1.2-9.6-3.3-10.3-8.4h24.1c3-.2 5.4-2.8 5.1-5.8v-.9c0-10.5-9.1-19.3-20.3-19-12.4 0-21.1 10-21.1 22.1v1.7z",
            fill: "#10112b"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m196.7 280.4c.7-8.8 7-15.6 15-15.6 9.1 0 14 7.4 14.5 15.6zm167 7c0 4.6-4 7.4-9.6 7.2-3.7 0-6.5-1.9-6.5-5.1v-.2c0-3.5 3.3-5.8 8.4-5.8 2.6 0 5.4.7 7.7 1.6zm84.7-18.4c-4.9 0-8.2 3.5-9.1 9.1h18c-.7-5.4-4-9.1-8.9-9.1z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m-46.7 217.7c52.6-7.9 18.9 36.9 2.6 49.5 11.2 8.6 22.7 20.7 27.6 34.4 9.1 25.1-13.3 28.8-30.2 22.5-18.5-6.5-34.8-20.4-45.6-36.7-3 0-6.3-.5-9.4-1.4 6.1 17.2 8.7 34.8 7 49.2 0-29-13.8-57.8-33.7-81.8-7-8.4.2-14.6 6.5-6.5 4.3 5.9 8.2 12 11.7 18.3 6.9-23.6 40.5-44.2 63.5-47.5zm-7.5 42.7c10.3-6.3 41.6-39.9 12.4-36.9-16.8 1.9-37.2 17.4-45.6 27.4 11.7-1.4 23.6 3.7 33.2 9.5zm-29 26.1c9.4 10.5 22.2 20.7 36 24.4 8 2.1 16.8 1.2 13.6-10.2-3.3-10.5-11.7-19.7-19.9-26.7-2.3 1.6-4.9 3.3-7.5 4.4-7 3.9-14.5 6.7-22.2 8.1z",
            fill: "#eba12a"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m-87.7 258.3c8-.7 16.6 3.5 23.2 7.7-6.3 3-13.3 4.9-20.6 5.3-10.7.1-12.9-12-2.6-13z",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
function gM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "39",
      height: "37",
      viewBox: "0 0 39 37",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.4811 0.50007H2.11624C0.938396 0.50007 0.00390625 1.43427 0.00390625 2.6124V10.899C0.00390625 12.0768 0.978866 13.0113 2.11624 13.0113H14.5055V11.4271C14.5055 8.90872 16.5365 6.8777 19.0549 6.8777C20.2736 6.8777 21.4109 7.36506 22.2637 8.21817C23.1169 9.07134 23.6042 10.2086 23.6042 11.427V13.0112H36.4403C37.6181 13.0112 38.5526 12.0363 38.5526 10.8989V2.61233C38.5931 1.47496 37.6589 0.5 36.4808 0.5L36.4811 0.50007Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31.0351 20.078C30.2633 20.078 29.5728 20.4843 29.2073 21.0935V21.053C29.2073 19.8752 28.2323 18.9001 27.0544 18.9001C26.2826 18.9001 25.5921 19.3064 25.2266 19.9156V19.8751C25.2266 18.6972 24.2516 17.7222 23.0737 17.7222C22.3018 17.7222 21.6114 18.1286 21.2458 18.7377L21.2456 11.4261C21.2456 10.8574 21.0019 10.2887 20.5956 9.8824C20.1892 9.47609 19.6614 9.23242 19.0519 9.23242C17.8741 9.23242 16.899 10.2074 16.899 11.3853V25.5212C16.899 25.643 16.8177 25.7649 16.6959 25.8057C16.574 25.8462 16.4522 25.8462 16.3709 25.7244L14.1775 23.531C13.4465 22.8 12.2683 22.6778 11.4155 23.2873C10.8873 23.6123 10.5623 24.181 10.4813 24.7902C10.4 25.3994 10.5626 26.0089 10.9686 26.4963L16.4525 33.1175C17.9962 34.9861 20.2709 36.0421 22.7079 36.0421H26.12C28.0291 36.0421 29.8165 35.3111 31.157 33.9705C32.4974 32.6301 33.2285 30.8427 33.2285 28.9335V22.1905C33.188 21.0531 32.213 20.0784 31.0352 20.0784L31.0351 20.078Z"
          }
        )
      ]
    }
  );
}
function CM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "40",
      height: "31",
      viewBox: "0 0 40 31",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.5932 21.2188H16.1055V30.919L24.5932 26.6752V21.2188ZM18.5307 28.13L17.3182 28.9788L17.3179 22.4312H18.5304L18.5307 28.13Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.98047 4.84961L16.1058 20.0059H24.5935L36.7188 4.84961H3.98047ZM18.5308 17.5808H17.197L9.31589 7.27468H18.531L18.5308 17.5808Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.949219 -0.000976562H39.7495V3.63662H0.949219L0.949219 -0.000976562Z"
          }
        )
      ]
    }
  );
}
function vM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      viewBox: "0 0 1000 148",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("g", { clipPath: "url(#clip0_1_2)", children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M65.2627 67.3465H111.133C112.42 74.9933 113.048 82.7363 113.01 90.4904C113.01 118.43 91.2908 146.786 59.0076 146.786C27.5236 146.786 -0.207335 119.264 0.00116826 81.1078C0.209671 41.0751 30.4079 15.2207 70.4752 15.2207C74.7969 15.2751 79.1124 15.5651 83.4025 16.0895L96.9552 59.0412L91.3256 60.9177L76.9128 47.7472C64.4287 36.4881 55.88 32.7698 47.3748 32.7698C35.6987 32.7698 26.316 41.3184 26.316 58.2072C26.316 89.8997 49.0429 122.635 74.098 122.635C85.9827 122.635 91.8208 118.291 95.9908 113.877L65.2627 73.6016V67.3465ZM232.17 92.7839C232.17 123.191 208.817 147.203 176.708 147.203C144.598 147.203 121.22 123.225 121.22 92.7839C121.22 62.3425 144.572 38.3646 176.682 38.3646C208.791 38.3646 232.17 62.3077 232.17 92.7839ZM194.813 86.9458C186.716 62.3077 176.082 47.5387 163.363 51.7088C150.645 55.8789 150.645 74.0186 158.568 98.622C166.699 123.225 177.333 138.029 190.052 133.859C202.771 129.689 202.771 111.549 194.847 86.9458H194.813ZM339.027 99.6645L341.529 108.005C338.193 126.561 324.224 146.786 296.284 146.786C264.792 146.786 240.188 120.306 240.188 82.1503C240.188 41.0752 270.43 15.2555 307.752 15.2555C312.076 15.2427 316.396 15.533 320.679 16.1242L334.232 59.0759L328.602 60.9524L314.216 47.8167C301.914 36.7661 294.408 32.596 285.859 32.596C274.183 32.596 266.468 41.3531 266.468 58.2419C266.468 89.9344 283.983 118.499 309.628 118.499C325.483 118.43 334.067 109.673 339.036 99.6645H339.027ZM460.585 128.021L462.67 134.693C460.304 138.343 457.061 141.342 453.239 143.418C449.417 145.494 445.135 146.58 440.786 146.578C423.48 146.578 416.391 136.361 411.387 122.6C406.591 135.527 395.54 146.786 375.524 146.786C357.593 146.786 347.793 134.902 347.793 121.974C347.793 104.043 362.562 91.3244 394.289 74.8527C390.328 67.3465 381.362 63.802 371.771 63.802C360.095 63.5935 347.168 68.5976 340.496 77.5632L338.202 70.4741C343.206 56.9214 359.921 38.9901 386.575 38.9901C410.553 38.9901 426.816 53.5853 434.357 76.7292L448.744 120.932C450.829 127.604 454.165 129.481 456.875 129.481C458.253 129.471 459.578 128.951 460.593 128.021H460.585ZM401.587 95.3207L397.243 82.185C385.359 91.1507 379.52 102.618 379.52 110.958C379.52 121.801 384.942 126.805 392.448 126.805C405.305 126.77 408.051 114.677 401.587 95.3207ZM547.783 71.0996L542.361 72.9762C531.068 67.7636 526.932 67.3465 517.55 67.3465C513.741 67.4754 509.991 68.3244 506.499 69.8486V126.144C506.499 131.983 509.418 136.361 517.133 138.655V144.91H464.764V138.655C471.644 136.361 472.27 131.983 472.27 126.144V66.0955C472.27 55.2533 469.142 51.5003 458.091 46.9132V40.6581H506.082L505.213 63.385H505.63L509.592 58.1724C517.515 47.7472 527.523 40.2411 537.323 40.2411H538.191L547.783 71.0996ZM653.919 138.655V144.91H610.959L611.168 131.357H610.125C607.052 135.866 602.905 139.539 598.057 142.045C593.21 144.551 587.815 145.81 582.359 145.709C558.59 145.709 543.786 125.727 543.786 99.8383C543.786 65.8523 566.722 41.2489 604.252 41.2489C607.171 41.2489 610.09 41.4574 610.09 41.4574V32.9435C610.09 23.7694 605.503 20.6418 597.997 20.0163V14.3867L642.408 0H644.285V126.144C644.285 131.983 646.995 136.361 653.885 138.655H653.919ZM610.125 110.715V56.0874C607.682 55.0722 605.055 54.5752 602.41 54.6278C590.109 54.6278 574.888 64.0105 574.888 90.2471C574.888 114.642 584.271 127.986 596.989 127.986C601.75 128.021 610.09 125.727 610.09 110.715H610.125ZM714.802 138.655V144.91H661.426V138.655C668.297 136.361 670.982 131.983 670.982 126.144V32.9435C670.982 23.7694 666.404 20.6418 658.897 20.0163V14.3867L703.291 0H705.168V126.144C705.176 131.983 707.887 136.361 714.768 138.655H714.802ZM823.641 95.4945L825.935 102.584C822.39 126.978 802.582 146.786 776.728 146.786C743.576 146.786 722.308 121.974 722.308 90.6989C722.308 62.134 742.29 39.1986 770.473 39.1986C790.906 39.1986 806.092 51.7088 812.382 68.5975L757.754 105.503C765.469 113.634 776.311 119.264 788.821 119.264C805.883 119.264 818.837 107.379 823.606 95.4945H823.641ZM743.784 71.9336C743.784 81.1078 746.912 90.6989 752.333 98.8653L761.498 90.1081C767.753 84.27 772.966 77.8065 772.966 68.8408C772.966 61.9602 768.379 53.8286 759.205 53.8286C750.63 53.7938 743.749 60.2574 743.749 71.9336H743.784ZM884.072 78.8142C904.297 89.0309 912.429 99.039 912.429 113.009C912.429 129.897 898.876 146.786 869.859 146.786C854.43 146.786 845.464 144.284 837.958 141.157L828.159 110.75L833.58 109.082L838.375 113.669C853.144 127.639 865.898 136.813 875.732 136.813C883.03 136.813 887.026 132.226 887.026 127.43C887.026 122.843 886.157 117.422 873.682 111.167L855.125 101.784C838.862 93.4442 831.147 83.2275 831.147 71.5514C831.147 51.5698 848.661 39.8589 871.18 39.8589C886.4 39.8589 894.949 41.9439 894.949 41.9439L903.498 68.4238L898.077 70.0919L894.741 67.1728C877.435 51.952 871.388 48.8245 864.091 48.8245C858.878 48.8245 854.534 52.1605 854.534 56.7476C854.534 60.0837 855.16 64.2537 865.585 69.4663L884.072 78.8142ZM971.644 79.0227C991.625 89.4479 1000 99.0043 1000 113.009C1000 129.897 986.447 146.786 957.431 146.786C942.001 146.786 933.036 144.284 925.53 141.157L915.73 110.75L921.151 109.082L925.947 113.669C940.716 127.639 953.469 136.813 963.303 136.813C970.601 136.813 974.597 132.226 974.597 127.43C974.597 122.843 973.729 117.631 961.253 111.167L942.696 101.611C926.433 93.2704 918.718 83.2623 918.718 71.5861C918.718 51.6045 936.233 39.8936 958.751 39.8936C973.972 39.8936 982.52 41.9787 982.52 41.9787L991.069 68.4586L985.648 70.1266L982.312 67.2075C965.006 51.9868 958.96 48.8592 951.662 48.8592C946.449 48.8592 942.106 52.1953 942.106 56.7824C942.106 60.1184 942.731 64.08 953.156 69.5011L971.644 79.0227Z",
            fill: "#1C1B18"
          }
        ) }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_1_2", children: /* @__PURE__ */ u.jsx("rect", { width: "1000", height: "148", fill: "white" }) }) })
      ]
    }
  );
}
function ih(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "56",
      height: "59",
      viewBox: "0 0 56 59",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 58.165C43.464 58.165 56 45.181 56 29.165C56 27.12 55.817 25.101 55.464 23.137H27.512L47.768 45.165C26.4 63.072 0.073 17.275 13.577 8.73C15.863 7.283 19.133 7.127 23.385 8.263L24.03 8.443C24.248 8.506 24.468 8.573 24.69 8.643L25.365 8.861L25.708 8.978L26.404 9.226C26.757 9.354 27.114 9.491 27.477 9.634L28.211 9.93L28.959 10.246C29.211 10.354 29.466 10.466 29.722 10.581L30.5 10.935L31.293 11.309L32.1 11.702L32.923 12.115L33.339 12.328L34.183 12.77L35.043 13.23L35.916 13.711L36.805 14.211L37.255 14.468L38.165 14.997L39.09 15.545C39.246 15.638 39.402 15.731 39.558 15.826L40.985 16.699L41.955 17.305L42.939 17.931L43.938 18.576L44.952 19.24L45.98 19.924L47.023 20.627L48.616 21.718L49.154 22.091L38.543 1.11C36.197 0.207001 33.228 0.038 30.418 0.00699997L28.95 0H28C12.536 0 0 13.149 0 29.165C0 45.181 12.536 58.165 28 58.165Z"
        }
      )
    }
  );
}
function bM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "25",
      height: "25",
      viewBox: "0 0 25 25",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ u.jsxs("g", { "clip-path": "url(#clip0_16011_9270)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M24.2663 12.7765C24.2663 11.9608 24.2001 11.1406 24.059 10.3381H12.7402V14.9591H19.222C18.953 16.4495 18.0888 17.7679 16.8233 18.6056V21.604H20.6903C22.9611 19.514 24.2663 16.4274 24.2663 12.7765Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M12.74 24.5008C15.9764 24.5008 18.7058 23.4382 20.6944 21.6039L16.8274 18.6055C15.7516 19.3375 14.3626 19.752 12.7444 19.752C9.61376 19.752 6.95934 17.6399 6.00693 14.8003H2.01648V17.8912C4.05359 21.9434 8.20278 24.5008 12.74 24.5008Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M6.00277 14.8002C5.50011 13.3099 5.50011 11.696 6.00277 10.2057V7.11475H2.01674C0.314734 10.5055 0.314734 14.5004 2.01674 17.8912L6.00277 14.8002Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M12.74 5.24966C14.4508 5.2232 16.1043 5.86697 17.3433 7.04867L20.7694 3.62262C18.6 1.5855 15.7207 0.465534 12.74 0.500809C8.20277 0.500809 4.05359 3.05822 2.01648 7.11481L6.00252 10.2058C6.95052 7.36173 9.60935 5.24966 12.74 5.24966Z",
              fill: "#EA4335"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_16011_9270", children: /* @__PURE__ */ u.jsx("rect", { width: "24", height: "24", fill: "white", transform: "translate(0.5 0.5)" }) }) })
      ]
    }
  );
}
function yM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 22",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.869867 10.9274C0.869867 5.15351 5.55026 0.473122 11.3242 0.473122C17.0981 0.473122 21.7785 5.15351 21.7785 10.9274C21.7785 16.7013 17.0981 21.3817 11.3242 21.3817C5.55026 21.3817 0.869867 16.7013 0.869867 10.9274Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1975 12.8669C10.9228 12.8669 10.6604 12.7501 10.4774 12.5465C10.2946 12.3431 10.2057 12.0701 10.2336 11.7977C10.2613 11.252 10.523 10.826 10.7376 10.5647C11.0523 10.1809 11.4523 9.92014 11.6096 9.82584C12.057 9.56003 12.2495 9.17438 12.1378 8.76777C12.0212 8.34333 11.6082 8.02326 11.1771 8.02326C10.9567 8.02326 10.6358 8.10724 10.3595 8.50733C10.1919 8.81736 9.86876 9.01224 9.51626 9.01584L9.50642 9.0159C9.15736 9.0159 8.83386 8.82687 8.66216 8.52261C8.4886 8.21505 8.49618 7.83743 8.68195 7.53708C9.19944 6.6402 10.1639 6.08301 11.199 6.08301C11.4528 6.08301 11.7063 6.11655 11.9526 6.18262C13.2208 6.52213 14.1071 7.67682 14.108 8.99063C14.108 9.95065 13.5643 10.8563 12.6537 11.4134C12.4017 11.5674 12.3087 11.8271 12.2187 12.0783C12.0798 12.4661 11.9362 12.8669 11.1975 12.8669ZM11.1975 15.7748C10.663 15.7748 10.2282 15.34 10.2282 14.8055C10.2282 14.2711 10.663 13.8362 11.1975 13.8362C11.7319 13.8362 12.1667 14.271 12.1667 14.8055C12.1667 15.34 11.7319 15.7748 11.1975 15.7748Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function wM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      fill: "#000000",
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24px",
      height: "24px",
      viewBox: "0 0 495.398 495.398",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
  v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
  c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
  c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z`
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
  c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
  c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z`
          }
        )
      ] }) }) })
    }
  );
}
function oh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "26",
      height: "22",
      viewBox: "0 0 26 22",
      fill: "#CBD5E1",
      stroke: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M7.62919 4.03262V19.4089H14.3212C20.3975 19.4089 23.0326 15.9768 23.0326 11.1231C23.0326 6.47761 20.3975 2.87352 14.3212 2.87352H8.78829C8.14535 2.87352 7.62919 3.39874 7.62919 4.03262Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M2.73866 21.7997H13.5509C17.3649 21.7997 20.3397 20.8565 22.3619 19.0428C24.3859 17.2276 25.4412 14.5533 25.4412 11.1229C25.4412 9.1476 25.0571 6.48868 23.3725 4.32192C21.6842 2.15039 18.704 0.491309 13.5509 0.491309H2.73866C1.72355 0.491309 0.9 1.31485 0.9 2.32997V19.961C0.9 20.9762 1.72355 21.7997 2.73866 21.7997ZM1.67955 2.32997C1.67955 1.74225 2.15095 1.27086 2.73866 1.27086H13.5509C15.6357 1.27086 18.4163 1.59408 20.6727 2.98558C22.9212 4.37219 24.6617 6.82698 24.6617 11.1229C24.6617 14.3254 23.6728 16.7946 21.7996 18.4647C19.9246 20.1364 17.1491 21.0202 13.5509 21.0202H2.73866C2.15095 21.0202 1.67955 20.5488 1.67955 19.961V2.32997Z",
            strokeWidth: "0.2"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M9.9854 9.04946C10.2208 9.04946 10.4382 9.08568 10.6464 9.15813C10.8547 9.23057 11.0268 9.34829 11.1807 9.49318C11.3256 9.64712 11.4433 9.83729 11.5339 10.0546C11.6154 10.281 11.6607 10.5436 11.6607 10.8515C11.6607 11.1232 11.6244 11.3677 11.5611 11.5941C11.4886 11.8204 11.389 12.0197 11.2532 12.1827C11.1173 12.3457 10.9453 12.4724 10.737 12.5721C10.5287 12.6626 10.2842 12.7169 10.0035 12.7169H8.41879V9.04041H9.9854V9.04946ZM9.93106 12.0468C10.0488 12.0468 10.1575 12.0287 10.2752 11.9925C10.3838 11.9563 10.4834 11.8929 10.5649 11.8023C10.6464 11.7118 10.7189 11.6031 10.7732 11.4582C10.8276 11.3133 10.8547 11.1503 10.8547 10.9421C10.8547 10.761 10.8366 10.5889 10.8004 10.444C10.7642 10.2991 10.7008 10.1633 10.6193 10.0637C10.5378 9.96407 10.4291 9.87351 10.2933 9.81918C10.1575 9.76485 9.99445 9.73768 9.79523 9.73768H9.21568V12.0559H9.93106V12.0468Z",
            fill: "white",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M14.9314 9.04946V9.72862H12.9935V10.5165H14.7775V11.1413H12.9935V12.0378H14.9767V12.7169H12.1876V9.04041H14.9314V9.04946Z",
            fill: "white",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M17.7008 9.04926L19.0773 12.7258H18.2351L17.9544 11.9108H16.5779L16.2882 12.7258H15.4732L16.8587 9.04926H17.7008ZM17.7461 11.3041L17.2843 9.95482H17.2752L16.7953 11.3041H17.7461Z",
            fill: "white",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M20.3893 9.04926V12.0466H22.1823V12.7258H19.5834V9.04926H20.3893Z",
            fill: "white",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M4.60354 12.5799C5.53877 12.5799 6.29693 11.8217 6.29693 10.8865C6.29693 9.95125 5.53877 9.1931 4.60354 9.1931C3.66832 9.1931 2.91016 9.95125 2.91016 10.8865C2.91016 11.8217 3.66832 12.5799 4.60354 12.5799Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M5.87874 19.4088C4.45703 19.4088 3.31603 18.2588 3.31603 16.8461V14.8449C3.31603 14.1385 3.88653 13.559 4.60192 13.559C5.30825 13.559 5.8878 14.1295 5.8878 14.8449V19.4088H5.87874Z",
            stroke: "none"
          }
        )
      ]
    }
  );
}
function SM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "#F04438",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 0.759766C3.13428 0.759766 0 3.89518 0 7.75977C0 11.6266 3.13428 14.7598 7 14.7598C10.8657 14.7598 14 11.6266 14 7.75977C14 3.89518 10.8657 0.759766 7 0.759766ZM7 3.86461C7.65473 3.86461 8.18548 4.39537 8.18548 5.05009C8.18548 5.70482 7.65472 6.23557 7 6.23557C6.34527 6.23557 5.81452 5.70481 5.81452 5.05009C5.81452 4.39536 6.34528 3.86461 7 3.86461ZM8.58065 11.034C8.58065 11.221 8.42899 11.3727 8.24194 11.3727H5.75807C5.57102 11.3727 5.41936 11.221 5.41936 11.034V10.3565C5.41936 10.1695 5.57102 10.0178 5.75807 10.0178H6.09678V8.21139H5.75807C5.57102 8.21139 5.41936 8.05973 5.41936 7.87268V7.19526C5.41936 7.00821 5.57102 6.85655 5.75807 6.85655H7.56452C7.75157 6.85655 7.90323 7.00821 7.90323 7.19526V10.0178H8.24194C8.42899 10.0178 8.58065 10.1695 8.58065 10.3565V11.034Z"
        }
      )
    }
  );
}
function _M(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M10 5.27832C7.25 5.27832 5.05859 7.5127 5.05859 10.2197C5.05859 12.9697 7.25 15.1611 10 15.1611C12.707 15.1611 14.9414 12.9697 14.9414 10.2197C14.9414 7.5127 12.707 5.27832 10 5.27832ZM10 13.4424C8.23828 13.4424 6.77734 12.0244 6.77734 10.2197C6.77734 8.45801 8.19531 7.04004 10 7.04004C11.7617 7.04004 13.1797 8.45801 13.1797 10.2197C13.1797 12.0244 11.7617 13.4424 10 13.4424ZM16.2734 5.10645C16.2734 4.46191 15.7578 3.94629 15.1133 3.94629C14.4688 3.94629 13.9531 4.46191 13.9531 5.10645C13.9531 5.75098 14.4688 6.2666 15.1133 6.2666C15.7578 6.2666 16.2734 5.75098 16.2734 5.10645ZM19.5391 6.2666C19.4531 4.71973 19.1094 3.34473 17.9922 2.22754C16.875 1.11035 15.5 0.766602 13.9531 0.680664C12.3633 0.594727 7.59375 0.594727 6.00391 0.680664C4.45703 0.766602 3.125 1.11035 1.96484 2.22754C0.847656 3.34473 0.503906 4.71973 0.417969 6.2666C0.332031 7.85645 0.332031 12.626 0.417969 14.2158C0.503906 15.7627 0.847656 17.0947 1.96484 18.2549C3.125 19.3721 4.45703 19.7158 6.00391 19.8018C7.59375 19.8877 12.3633 19.8877 13.9531 19.8018C15.5 19.7158 16.875 19.3721 17.9922 18.2549C19.1094 17.0947 19.4531 15.7627 19.5391 14.2158C19.625 12.626 19.625 7.85645 19.5391 6.2666ZM17.4766 15.8916C17.1758 16.751 16.4883 17.3955 15.6719 17.7393C14.3828 18.2549 11.375 18.126 10 18.126C8.58203 18.126 5.57422 18.2549 4.32812 17.7393C3.46875 17.3955 2.82422 16.751 2.48047 15.8916C1.96484 14.6455 2.09375 11.6377 2.09375 10.2197C2.09375 8.84473 1.96484 5.83691 2.48047 4.54785C2.82422 3.73145 3.46875 3.08691 4.32812 2.74316C5.57422 2.22754 8.58203 2.35645 10 2.35645C11.375 2.35645 14.3828 2.22754 15.6719 2.74316C16.4883 3.04395 17.1328 3.73145 17.4766 4.54785C17.9922 5.83691 17.8633 8.84473 17.8633 10.2197C17.8633 11.6377 17.9922 14.6455 17.4766 15.8916Z" })
    }
  );
}
function xM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M108.626 9.37702C106.207 6.23306 103.044 4.19437 99.1534 3.38398C94.2932 2.36994 89.8362 3.36489 85.8797 6.36247C83.5185 8.15084 81.8066 10.3741 80.7331 12.9962C80.3577 13.9084 80.0627 14.8694 79.8421 15.8771C79.6936 16.5666 79.6342 17.2772 79.5324 17.9773C79.5175 18.0897 79.4942 18.2022 79.4751 18.3146V20.2197C79.4878 20.3088 79.4985 20.3957 79.5091 20.4848C79.5748 21.0131 79.6299 21.5413 79.7275 22.0653C79.8866 22.916 80.0967 23.7306 80.3597 24.5113C81.5923 28.1984 83.9683 31.1068 87.4453 33.2389C89.6176 34.569 91.9958 35.2967 94.5415 35.477C94.6242 35.4833 94.7048 35.5109 94.7854 35.5279H96.6927C97.3079 35.4452 97.9294 35.3836 98.5425 35.2754C99.6965 35.0697 100.791 34.7599 101.829 34.3463C104.164 33.415 106.205 31.9575 107.949 29.9846C110.246 27.3858 111.585 24.3416 111.916 20.8943C112.325 16.6387 111.239 12.7713 108.626 9.37702ZM105.299 16.2441C105.178 16.4032 105.04 16.5538 104.898 16.6938C103.473 18.1216 102.047 19.5472 100.619 20.9728C98.7546 22.8396 96.8878 24.7065 95.0209 26.5733C93.9008 27.6913 92.5665 27.6913 91.4464 26.5733C90.759 25.886 90.0695 25.1987 89.3821 24.5113C88.4232 23.5545 87.4644 22.5957 86.5076 21.6346C86.1597 21.2846 85.9264 20.8921 85.8118 20.4848C85.6124 19.7805 85.7694 19.0338 86.2892 18.408C87.0592 17.4851 88.4976 17.3409 89.431 18.0961C89.571 18.2107 89.7025 18.3337 89.8298 18.4589C90.8884 19.5132 91.9427 20.5697 92.997 21.624C93.0713 21.6962 93.1477 21.7662 93.2877 21.8977C93.3641 21.7874 93.4171 21.6792 93.4998 21.5965C94.9912 20.103 96.4847 18.6095 97.9803 17.116C99.2171 15.8771 100.454 14.6403 101.691 13.4014C102.393 12.6971 103.205 12.4192 104.177 12.7225C105.632 13.1744 106.226 15.037 105.299 16.2441Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M61.0972 101.248V94.4592H40.7315V101.248H27.1543V108.036H74.6743V101.248H61.0972Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M95.738 37.7766C87.3351 37.7766 80.2409 32.1803 77.9816 24.5113H48.6104C47.503 24.5113 46.5972 23.6055 46.5972 22.4981C46.5972 21.9444 46.8242 21.4416 47.1891 21.0767C47.554 20.7119 48.0567 20.4849 48.6104 20.4849H77.2667C77.2391 20.0818 77.2264 19.6745 77.2264 19.265C77.2264 17.0651 77.6103 14.9543 78.3147 12.9962H13.5772C6.09063 12.9962 0 19.0868 0 26.5734V74.0934C0 81.5821 6.09063 87.6706 13.5772 87.6706H88.2515C95.738 87.6706 101.829 81.5821 101.829 74.0934V36.7499C99.9215 37.416 97.8722 37.7766 95.738 37.7766ZM26.0893 20.4849C27.201 20.4849 28.1025 21.3865 28.1025 22.4981C28.1025 23.6097 27.201 24.5113 26.0893 24.5113C24.9777 24.5113 24.0761 23.6097 24.0761 22.4981C24.0761 21.3865 24.9777 20.4849 26.0893 20.4849ZM18.3291 20.4849C19.4408 20.4849 20.3423 21.3865 20.3423 22.4981C20.3423 23.6097 19.4408 24.5113 18.3291 24.5113C17.2175 24.5113 16.3159 23.6097 16.3159 22.4981C16.3159 21.3865 17.2175 20.4849 18.3291 20.4849ZM8.55564 22.4981C8.55564 21.3865 9.4573 20.4849 10.5689 20.4849C11.6806 20.4849 12.5822 21.3865 12.5822 22.4981C12.5822 23.6097 11.6806 24.5113 10.5689 24.5113C9.4573 24.5113 8.55564 23.6097 8.55564 22.4981ZM27.1543 72.5087C18.5349 72.5087 11.5469 65.5207 11.5469 56.9035C11.5469 48.2862 18.5349 41.2961 27.1543 41.2961C35.7737 41.2961 42.7596 48.2841 42.7596 56.9035C42.7596 65.5228 35.7737 72.5087 27.1543 72.5087ZM86.3443 71.745C85.8733 72.2159 85.2242 72.5087 84.5093 72.5087H55.9378C54.508 72.5087 53.3391 71.3398 53.3391 69.9121C53.3391 69.1972 53.6318 68.548 54.1028 68.0792C54.5737 67.6082 55.2229 67.3154 55.9378 67.3154H84.5093C85.9391 67.3154 87.108 68.4843 87.108 69.9121C87.108 70.627 86.8152 71.2761 86.3443 71.745ZM86.3443 58.7364C85.8733 59.2073 85.2242 59.5001 84.5093 59.5001H55.9378C54.508 59.5001 53.3391 58.3312 53.3391 56.9035C53.3391 56.1885 53.6318 55.5394 54.1028 55.0684C54.5737 54.5975 55.2229 54.3047 55.9378 54.3047H84.5093C85.9391 54.3047 87.108 55.4736 87.108 56.9035C87.108 57.6184 86.8152 58.2675 86.3443 58.7364ZM86.3443 45.7256C85.8733 46.1966 85.2242 46.4894 84.5093 46.4894H55.9378C54.508 46.4894 53.3391 45.3204 53.3391 43.8927C53.3391 43.1799 53.6318 42.5308 54.1028 42.0598C54.5737 41.5889 55.2229 41.2961 55.9378 41.2961H84.5093C85.9391 41.2961 87.108 42.465 87.108 43.8927C87.108 44.6055 86.8152 45.2547 86.3443 45.7256Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M22.6653 53.331V60.4717C22.6653 61.5854 23.8384 62.311 24.8355 61.8124L31.9763 58.2421C33.0815 57.6905 33.0815 56.1122 31.9763 55.5606L24.8355 51.9902C23.8384 51.4917 22.6653 52.2172 22.6653 53.331Z" })
      ]
    }
  );
}
function MM(e) {
  return /* @__PURE__ */ u.jsxs("svg", { height: "16", width: "16", viewBox: "0 0 74 74", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ u.jsx("path", { d: "m17.56 30.32h-10.58a3.649 3.649 0 0 0 -3.64 3.65v34.38a3.649 3.649 0 0 0 3.64 3.65h10.58a3.658 3.658 0 0 0 3.65-3.65v-34.38a3.658 3.658 0 0 0 -3.65-3.65z" }),
    /* @__PURE__ */ u.jsx("path", { d: "m69.09 42.29a6.231 6.231 0 0 0 -1.82-4.4 3 3 0 0 0 -.32-.3 6.081 6.081 0 0 0 -2.36-11.68h-21.7c.12-.21.23-.4.33-.59a14.353 14.353 0 0 0 1.48-3.22 20.85 20.85 0 0 0 .87-4.82 17.74 17.74 0 0 0 -4.6-12.99 6.772 6.772 0 0 0 -4.77-2.29 4.923 4.923 0 0 0 -5.08 4.36.66.66 0 0 0 -.01.14v8.76l-5.8 14.7a9.425 9.425 0 0 1 -2.1 3.19v33.88a33.044 33.044 0 0 0 4.36.89 12.466 12.466 0 0 0 1.65.11h29.41a5.522 5.522 0 0 0 3.88-1.6 5.464 5.464 0 0 0 1.6-3.87 5.407 5.407 0 0 0 -1.36-3.6 6.283 6.283 0 0 0 2.7-11 6.245 6.245 0 0 0 3.64-5.67z" })
  ] });
}
function sh(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function kM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M18.25 0.594727H1.70703C0.976562 0.594727 0.375 1.23926 0.375 2.0127V18.4697C0.375 19.2432 0.976562 19.8447 1.70703 19.8447H18.25C18.9805 19.8447 19.625 19.2432 19.625 18.4697V2.0127C19.625 1.23926 18.9805 0.594727 18.25 0.594727ZM6.17578 17.0947H3.33984V7.94238H6.17578V17.0947ZM4.75781 6.65332C3.8125 6.65332 3.08203 5.92285 3.08203 5.02051C3.08203 4.11816 3.8125 3.34473 4.75781 3.34473C5.66016 3.34473 6.39062 4.11816 6.39062 5.02051C6.39062 5.92285 5.66016 6.65332 4.75781 6.65332ZM16.875 17.0947H13.9961V12.626C13.9961 11.5947 13.9961 10.2197 12.5352 10.2197C11.0312 10.2197 10.8164 11.3799 10.8164 12.583V17.0947H7.98047V7.94238H10.6875V9.18848H10.7305C11.1172 8.45801 12.0625 7.68457 13.4375 7.68457C16.3164 7.68457 16.875 9.61816 16.875 12.0674V17.0947Z" })
    }
  );
}
function PM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      fill: "#CBD5E1",
      height: "512",
      viewBox: "0 0 24 24",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "m16.19 2h-8.38c-3.64 0-5.81 2.17-5.81 5.81v8.38c0 3.64 2.17 5.81 5.81 5.81h8.38c3.64 0 5.81-2.17 5.81-5.81v-8.38c0-3.64-2.17-5.81-5.81-5.81zm-6.22 12.9-2.25 2.25c-.15.15-.34.22-.53.22s-.39-.07-.53-.22l-.75-.75c-.3-.29-.3-.77 0-1.06.29-.29.76-.29 1.06 0l.22.22 1.72-1.72c.29-.29.76-.29 1.06 0 .29.29.29.77 0 1.06zm0-7-2.25 2.25c-.15.15-.34.22-.53.22s-.39-.07-.53-.22l-.75-.75c-.3-.29-.3-.77 0-1.06.29-.29.76-.29 1.06 0l.22.22 1.72-1.72c.29-.29.76-.29 1.06 0 .29.29.29.77 0 1.06zm7.59 8.72h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25c.42 0 .75.34.75.75s-.33.75-.75.75zm0-7h-5.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.25c.42 0 .75.34.75.75s-.33.75-.75.75z" })
    }
  );
}
function TM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      className: "-ui-ml-1 ui-mr-3 ui-h-7 ui-w-7 ui-animate-spin ui-text-gray",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("circle", { className: "ui-opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            className: "ui-opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
}
function EM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M15 2.5C12.3487 2.50298 9.80694 3.5575 7.93222 5.43222C6.0575 7.30694 5.00298 9.84875 5 12.5C5 16.5688 7.95375 19.9475 11.0825 23.5238C12.0725 24.6562 13.0975 25.8275 14.01 27.0125C14.1268 27.164 14.2767 27.2866 14.4484 27.3711C14.62 27.4555 14.8087 27.4993 15 27.4993C15.1913 27.4993 15.38 27.4555 15.5516 27.3711C15.7233 27.2866 15.8732 27.164 15.99 27.0125C16.9025 25.8275 17.9275 24.6562 18.9175 23.5238C22.0462 19.9475 25 16.5688 25 12.5C24.997 9.84875 23.9425 7.30694 22.0678 5.43222C20.1931 3.5575 17.6513 2.50298 15 2.5ZM15 16.25C14.2583 16.25 13.5333 16.0301 12.9166 15.618C12.2999 15.206 11.8193 14.6203 11.5355 13.9351C11.2516 13.2498 11.1774 12.4958 11.3221 11.7684C11.4667 11.041 11.8239 10.3728 12.3483 9.84835C12.8728 9.3239 13.541 8.96675 14.2684 8.82206C14.9958 8.67736 15.7498 8.75162 16.4351 9.03545C17.1203 9.31928 17.706 9.79993 18.118 10.4166C18.5301 11.0333 18.75 11.7583 18.75 12.5C18.75 13.4946 18.3549 14.4484 17.6517 15.1517C16.9484 15.8549 15.9946 16.25 15 16.25Z", fill: "#142D63" })
    }
  );
}
function DM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.75435 1.875L9 1.875C9.62132 1.875 10.125 2.37868 10.125 3C10.125 3.62132 9.62132 4.125 9 4.125H7.8C6.94136 4.125 6.36504 4.12588 5.92122 4.16214C5.49053 4.19733 5.28461 4.26015 5.14877 4.32936C4.79597 4.50913 4.50913 4.79596 4.32936 5.14877C4.26015 5.28461 4.19733 5.49053 4.16214 5.92122C4.12588 6.36504 4.125 6.94136 4.125 7.8V16.2C4.125 17.0586 4.12588 17.635 4.16214 18.0788C4.19733 18.5095 4.26015 18.7154 4.32936 18.8512C4.50913 19.204 4.79596 19.4909 5.14877 19.6706C5.28461 19.7399 5.49053 19.8027 5.92122 19.8379C6.36504 19.8741 6.94136 19.875 7.8 19.875H9C9.62132 19.875 10.125 20.3787 10.125 21C10.125 21.6213 9.62132 22.125 9 22.125H7.75432C6.9531 22.125 6.28434 22.125 5.738 22.0804C5.16817 22.0338 4.63318 21.9332 4.12729 21.6754C3.35112 21.2799 2.72008 20.6489 2.3246 19.8727C2.06683 19.3668 1.96617 18.8318 1.91961 18.262C1.87497 17.7157 1.87498 17.0469 1.875 16.2457V7.75435C1.87498 6.95312 1.87497 6.28435 1.91961 5.738C1.96617 5.16817 2.06683 4.63318 2.3246 4.12729C2.72008 3.35112 3.35112 2.72008 4.12729 2.3246C4.63318 2.06683 5.16817 1.96617 5.738 1.91961C6.28435 1.87497 6.95312 1.87498 7.75435 1.875ZM15.2045 6.20451C15.6438 5.76517 16.3562 5.76517 16.7955 6.20451L21.7955 11.2045C22.2348 11.6438 22.2348 12.3562 21.7955 12.7955L16.7955 17.7955C16.3562 18.2348 15.6438 18.2348 15.2045 17.7955C14.7652 17.3562 14.7652 16.6438 15.2045 16.2045L18.284 13.125H9C8.37868 13.125 7.875 12.6213 7.875 12C7.875 11.3787 8.37868 10.875 9 10.875H18.284L15.2045 7.7955C14.7652 7.35616 14.7652 6.64385 15.2045 6.20451Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function IM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.68787 22.6607L2.68807 22.6609L0.95896 20.9318C0.82491 20.7952 0.75 20.6117 0.75 20.4204C0.75 20.2293 0.82491 20.0457 0.95896 19.9091L10.1154 10.7286C10.252 10.5947 10.4356 10.5198 10.6268 10.5198C10.818 10.5198 11.0017 10.5948 11.1383 10.7286L12.8915 12.4818C13.0254 12.6184 13.1003 12.802 13.1003 12.9933C13.1003 13.1844 13.0254 13.368 12.8915 13.5046L3.71068 22.6607C3.57409 22.7947 3.39045 22.8696 3.19935 22.8696C3.00808 22.8696 2.82445 22.7947 2.68786 22.6607L2.68787 22.6607ZM14.8398 18.0293V13.456H16.301V18.0293H14.8398ZM13.4517 11.8975L11.7228 10.1686C11.5889 10.032 11.5139 9.84838 11.5139 9.65712C11.5139 9.46586 11.5889 9.28239 11.7228 9.14584V9.14568L13.9144 6.95413C14.051 6.82028 14.2346 6.74538 14.4259 6.74538C14.617 6.74538 14.8007 6.82029 14.9372 6.95413L16.6663 8.68317C16.8002 8.81976 16.8751 9.00334 16.8751 9.19445C16.8751 9.38575 16.8002 9.56937 16.6663 9.70592H16.6662L14.4745 11.8975C14.3379 12.0313 14.1545 12.1064 13.9632 12.1064C13.7719 12.1064 13.5883 12.0313 13.4517 11.8975ZM13.4517 11.8975L14.4517 12.8975L13.4517 11.8975ZM18.1761 11.5566V10.0954H22.7543V11.5566H18.1761ZM5.61024 8.78058V7.31939H10.1885V8.78058H5.61024ZM16.0892 6.50058L19.4298 3.16007L20.4629 4.19319L17.1223 7.5337L16.0892 6.50058ZM12.0636 5.43952V0.866211H13.5248V5.43952H12.0636Z",
          fill: "#00A0FF"
        }
      )
    }
  );
}
function LM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsxs("g", { "clip-path": "url(#clip0_58020_24302)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M2.99992 9.35547C3.81898 9.95024 4.58378 10.5047 5.34792 11.0604C8.17293 13.1146 10.9979 15.1696 13.8229 17.2245C14.6102 17.7974 15.3797 17.8034 16.1637 17.2344C19.6886 14.6753 23.2123 12.1137 26.7366 9.55395C26.8081 9.50168 26.8822 9.45272 26.9834 9.38193C26.99 9.48646 26.9986 9.56387 26.9986 9.64062C26.9986 13.5215 27.0006 17.4024 26.9986 21.2834C26.9979 22.7759 25.983 23.7934 24.4905 23.7934C18.1663 23.7961 11.8428 23.7954 5.51861 23.7934C4.01084 23.7941 3.00124 22.7786 3.00058 21.2688C2.99926 17.3958 2.99992 13.5229 2.99992 9.65054C2.99992 9.57115 2.99992 9.49176 2.99992 9.35613V9.35547Z",
              fill: "#142D63"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M4.29004 7.23333C4.6043 7.15857 4.91789 7.07785 5.23413 7.01236C5.34462 6.98986 5.46371 7.00375 5.57882 7.00375C11.8607 7.00375 18.1418 7.00442 24.4237 7.00177C24.8736 7.00177 25.3043 7.05867 25.7264 7.29949C25.6589 7.35638 25.6086 7.40402 25.5524 7.44504C22.4422 9.70703 19.332 11.9684 16.2212 14.2304C15.3665 14.8516 14.6367 14.8509 13.7806 14.229C10.6764 11.9723 7.57221 9.71563 4.46867 7.45893C4.40979 7.41593 4.35355 7.37028 4.29599 7.32529C4.29401 7.29486 4.29202 7.26376 4.29004 7.23333Z",
              fill: "#142D63"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_58020_24302", children: /* @__PURE__ */ u.jsx("rect", { width: "24", height: "16.7959", fill: "white", transform: "translate(3 7)" }) }) })
      ]
    }
  );
}
function AM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "22",
      height: "28",
      viewBox: "0 0 22 26",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M5.93798 8.12999C6.02798 8.54399 6.16598 8.81199 6.32698 8.97899C6.70998 11.645 9.10298 13.917 11.025 13.822C13.47 13.702 15.203 11.067 15.592 8.97899C15.753 8.81299 15.908 8.45799 16.001 8.04099C16.105 7.56199 16.217 6.83999 15.929 6.45799C15.912 6.43799 15.802 6.33699 15.783 6.31999C16.058 5.32799 16.662 3.55799 15.158 1.96699C14.343 1.10499 13.211 0.671994 12.188 0.329994C9.16798 -0.679006 7.03598 0.735994 6.05198 3.08899C5.98098 3.25599 5.52198 4.31299 6.07798 6.31999C6.02398 6.35599 5.97498 6.40199 5.93398 6.45799C5.64498 6.83899 5.83298 7.65099 5.93798 8.12999Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M21.557 22.792C21.473 20.957 21.369 18.049 19.766 15.67C19.766 15.67 19.309 15.047 18.225 14.633C18.225 14.633 15.871 13.916 14.787 13.141L14.292 13.48L14.347 16.698L11.375 24.632C11.31 24.806 11.144 24.921 10.959 24.921C10.774 24.921 10.608 24.806 10.543 24.632L7.57197 16.698C7.57197 16.698 7.62697 13.49 7.62597 13.48C7.63297 13.507 7.12997 13.141 7.12997 13.141C6.04797 13.916 3.69297 14.633 3.69297 14.633C2.60897 15.047 2.15197 15.67 2.15197 15.67C0.549971 18.049 0.443971 20.957 0.359971 22.792C0.301971 24.06 0.567971 24.533 0.901971 24.668C5.04797 26.332 16.867 26.332 21.014 24.668C21.35 24.534 21.614 24.06 21.557 22.792Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M11.0649 14.847L10.9309 14.85C10.4989 14.85 10.0629 14.766 9.63495 14.618L10.8129 16.421L9.75595 17.441L10.8439 24.048C10.8529 24.105 10.9019 24.146 10.9599 24.146C11.0169 24.146 11.0659 24.105 11.0759 24.048L12.1639 17.441L11.1059 16.421L12.2669 14.645C11.8879 14.756 11.4869 14.83 11.0649 14.847Z" })
      ]
    }
  );
}
function NM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M11.9998 2.25C10.6876 2.25155 9.38914 2.51772 8.18215 3.03258C6.97516 3.54744 5.88439 4.30042 4.97507 5.24649C4.06576 6.19257 3.35657 7.3123 2.88992 8.53874C2.42327 9.76518 2.20874 11.0731 2.25916 12.3844C2.45604 17.5125 6.66541 21.6469 11.8029 21.75C13.5245 21.7835 15.2243 21.3605 16.7294 20.524C18.2345 19.6875 19.4912 18.4673 20.3717 16.9875C20.4085 16.926 20.427 16.8552 20.4248 16.7836C20.4227 16.7119 20.4001 16.6423 20.3596 16.5831C20.3192 16.5239 20.2626 16.4776 20.1966 16.4496C20.1306 16.4215 20.058 16.413 19.9873 16.425C19.7025 16.4753 19.4139 16.5004 19.1248 16.5C17.4092 16.5 16.4529 15.75 15.9467 15.1219C15.8298 14.9731 15.7233 14.8165 15.6279 14.6531C15.174 15.2749 14.5683 15.7698 13.8685 16.0906C13.1687 16.4114 12.3983 16.5474 11.631 16.4854C10.8637 16.4234 10.1252 16.1657 9.48592 15.7368C8.84668 15.3078 8.32817 14.7221 7.97995 14.0356C7.63173 13.349 7.46545 12.5846 7.49701 11.8155C7.52858 11.0463 7.75693 10.2981 8.16023 9.64243C8.56353 8.98673 9.1283 8.44545 9.80053 8.07035C10.4728 7.69526 11.23 7.49888 11.9998 7.5C13.1086 7.49662 14.1787 7.90792 14.9998 8.65313V8.27813C14.9967 8.08351 15.0676 7.89496 15.1981 7.75055C15.3286 7.60613 15.509 7.51659 15.7029 7.5C15.8053 7.49359 15.9079 7.50824 16.0043 7.54305C16.1008 7.57786 16.1891 7.63209 16.2638 7.70238C16.3385 7.77268 16.398 7.85754 16.4386 7.95173C16.4791 8.04592 16.5 8.14744 16.4998 8.25V12C16.4998 13.3687 16.9592 15 19.1248 15C21.2904 15 21.7123 13.4813 21.7498 12.1406V12C21.7473 9.4149 20.7193 6.93639 18.8913 5.10845C17.0634 3.28051 14.5849 2.25248 11.9998 2.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M11.9998 15C13.6566 15 14.9998 13.6569 14.9998 12C14.9998 10.3431 13.6566 9 11.9998 9C10.3429 9 8.99979 10.3431 8.99979 12C8.99979 13.6569 10.3429 15 11.9998 15Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
function RM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      viewBox: "0 0 159 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M157.185 6.45665C154.539 3.83737 150.28 3.83737 147.634 6.45665C145.544 9.20821 145.544 13.0445 147.634 15.7961C150.28 18.3889 154.539 18.3889 157.185 15.7961C159.275 13.0445 159.275 9.2082 157.185 6.45665ZM154.564 13.9965C153.532 15.2135 151.707 15.3458 150.49 14.314C150.384 14.2081 150.278 14.1023 150.172 13.9965C149.14 12.2239 149.14 10.0279 150.172 8.2288C151.204 7.01176 153.03 6.87947 154.247 7.93775C154.353 8.04358 154.458 8.12298 154.538 8.2288C155.596 10.0279 155.596 12.1974 154.564 13.9965H154.564ZM130.358 5.37147C129.22 4.81585 127.977 4.55129 126.707 4.55129C125.04 4.36609 123.399 5.00107 122.235 6.19164C121.653 6.98537 121.336 7.91138 121.309 8.86384H124.458C124.511 8.44055 124.669 8.04366 124.908 7.72618C125.357 7.30289 125.939 7.09122 126.548 7.14412C127.104 7.11768 127.633 7.2235 128.135 7.43517C128.506 7.64682 128.717 8.07012 128.664 8.49346C128.664 8.91678 128.373 9.31364 127.95 9.41945C127.553 9.5782 127.13 9.65758 126.707 9.71048L125.595 9.84279C124.59 9.92215 123.611 10.2132 122.712 10.663C121.521 11.3244 120.833 12.6208 120.912 13.9966C120.86 15.0284 121.256 16.0338 122.024 16.7482C122.817 17.3831 123.823 17.7271 124.855 17.7271C131.972 18.0446 131.892 13.9966 131.945 13.1235V8.44056C132.13 7.19706 131.495 5.95356 130.358 5.37148V5.37147ZM128.718 12.4622C128.797 13.3089 128.453 14.1555 127.792 14.7111C127.21 15.108 126.522 15.3197 125.834 15.3197C125.41 15.3197 125.014 15.1874 124.696 14.9492C124.352 14.6318 124.167 14.182 124.22 13.7057C124.193 13.1501 124.484 12.5945 124.987 12.33C125.463 12.0919 125.966 11.9596 126.495 11.8802L127.236 11.7479C127.527 11.695 127.818 11.6156 128.109 11.5363C128.321 11.4569 128.532 11.3511 128.744 11.2188L128.718 12.4622V12.4622ZM114.14 7.32901C114.828 7.27608 115.489 7.56711 115.939 8.09627C116.203 8.46666 116.362 8.88997 116.442 9.33976H119.96C119.934 7.88461 119.246 6.50882 118.108 5.60925C116.891 4.86847 115.489 4.49806 114.06 4.57742C112.367 4.47159 110.7 5.13302 109.51 6.35008C108.346 7.72586 107.737 9.4985 107.869 11.3241C107.79 12.9909 108.319 14.6312 109.351 15.9276C110.542 17.1976 112.261 17.859 114.008 17.7003C115.86 17.8325 117.632 17.0124 118.796 15.5573C119.431 14.7635 119.828 13.7846 119.934 12.7527H116.415C116.362 13.3348 116.151 13.8904 115.807 14.3667C115.357 14.8164 114.722 15.0545 114.087 14.9752C113.055 15.0281 112.103 14.3931 111.785 13.4142C111.547 12.6998 111.415 11.959 111.441 11.2182C111.415 10.451 111.521 9.65724 111.785 8.91644C112.103 7.9375 113.082 7.27607 114.14 7.32901ZM106.865 4.60459C99.6417 4.60459 100.091 10.9808 100.091 10.9808V17.4629H103.372V11.3777C103.319 10.6104 103.452 9.86959 103.743 9.15526C104.298 8.2557 105.33 7.77948 106.388 7.91176H106.785H107.341V4.57812H107.05L106.865 4.60459H106.865ZM94.878 14.0765C94.7457 14.2617 94.6134 14.4204 94.4283 14.5791C93.8991 14.9495 93.2377 15.1348 92.6027 15.0818C91.9942 15.1083 91.3857 14.976 90.8565 14.6585C89.9834 14.0765 89.4807 13.0976 89.5336 12.0657H98.582C98.6085 11.2455 98.582 10.3989 98.4762 9.57872C98.3439 8.65271 98 7.77963 97.4708 7.01236C96.9417 6.21863 96.2009 5.55721 95.3278 5.18681C94.4018 4.78993 93.4229 4.57827 92.4175 4.60475C90.7507 4.55182 89.1632 5.16034 87.9727 6.32448C86.7556 7.6738 86.1206 9.47289 86.2529 11.2984C86.0942 13.1505 86.782 15.0025 88.1578 16.2724C89.4014 17.2778 90.9359 17.8334 92.5498 17.807C94.296 17.9128 96.0157 17.2514 97.2327 15.9814C97.7619 15.4523 98.1588 14.8173 98.3704 14.1029L94.878 14.0765L94.878 14.0765ZM90.4864 7.96243C91.0155 7.45973 91.7034 7.22165 92.4178 7.24809C93.1321 7.22163 93.7935 7.45974 94.3492 7.90953C94.9048 8.41222 95.2223 9.12656 95.2223 9.86736H89.6133C89.6927 9.17949 90.0102 8.51804 90.4864 7.96243H90.4864ZM84.9558 17.4628H82.019V9.92245C82.1513 8.75831 81.3046 7.72648 80.167 7.62066C80.0612 7.62066 79.9289 7.59419 79.8231 7.62066C78.606 7.59419 77.6006 8.54665 77.5477 9.76371C77.5477 9.81661 77.5477 9.89599 77.5477 9.94891V17.4628H74.5581V9.92245C74.6903 8.78479 73.8702 7.75296 72.7325 7.62066C72.6267 7.62066 72.4944 7.59419 72.3886 7.62066C71.1715 7.56774 70.1661 8.5202 70.1132 9.71078C70.1132 9.79014 70.1132 9.86953 70.1132 9.94891V17.4628H67.0971V10.0018C66.9119 7.17088 69.0549 4.7368 71.8859 4.55158C72.0446 4.55158 72.2034 4.55158 72.3357 4.55158C73.7908 4.52512 75.1666 5.1601 76.0662 6.29777C76.9921 5.18656 78.3415 4.55158 79.7966 4.55158C83.0509 4.55158 84.9823 6.80047 84.9823 10.0018V17.4628H84.9558ZM145.066 0.713866C145.066 0.713866 141.785 0.369905 141.785 3.01564V6.50803C141.441 5.92597 140.938 5.44974 140.356 5.13224C139.748 4.78829 139.06 4.62957 138.346 4.62957C136.838 4.57664 135.382 5.26453 134.43 6.45512C133.372 7.93672 132.869 9.73582 132.975 11.5349C132.895 13.1753 133.425 14.7892 134.456 16.0591C135.726 17.2497 137.393 17.8582 139.113 17.7524C145.145 17.7524 145.066 12.5932 145.066 12.5932V0.713886V0.713866ZM141.15 14.0767C140.673 14.7646 139.88 15.1615 139.06 15.1085C138.239 15.1615 137.446 14.7646 136.996 14.0767C136.493 13.2036 136.255 12.2247 136.308 11.2458C136.282 10.3198 136.52 9.39375 136.969 8.57359C137.419 7.85923 138.213 7.43593 139.06 7.48881C139.668 7.48881 140.25 7.70048 140.7 8.09735C141.547 8.99689 141.97 10.2139 141.864 11.4574C141.891 12.3834 141.652 13.283 141.15 14.0503L141.15 14.0767ZM70.4052 38.2292C70.4052 38.6526 70.2465 39.0759 69.929 39.367C69.638 39.6844 69.2147 39.8432 68.7649 39.8432H67.1245V28.4665C66.9922 26.7203 67.733 25.0271 69.1088 23.9423C70.3523 23.0427 71.8604 22.593 73.3949 22.6988C75.0088 22.6724 76.5698 23.3073 77.681 24.4714C78.7657 25.7943 79.2949 27.4875 79.2156 29.2073C79.2949 30.927 78.7922 32.6468 77.7868 34.049C76.9137 35.2131 75.5115 35.8745 74.0564 35.8481C73.342 35.8745 72.6012 35.7158 71.9397 35.4248C71.2783 35.1073 70.7492 34.5781 70.4052 33.9431V38.2028L70.4052 38.2292ZM75.8823 29.3689C75.9352 28.3635 75.6971 27.3846 75.168 26.538C74.6917 25.8765 73.898 25.5061 73.1043 25.5326C72.3106 25.5061 71.5433 25.8765 71.0671 26.538C70.5644 27.3846 70.3262 28.39 70.4056 29.3689C70.3262 30.3214 70.5908 31.2738 71.12 32.0675C71.5962 32.729 72.3899 33.0994 73.1837 33.0729C73.9774 33.0994 74.7181 32.729 75.168 32.0675C75.6971 31.2738 75.9352 30.3214 75.8823 29.3689ZM100.882 34.815V33.9948C100.38 34.8415 99.5595 35.45 98.607 35.6617C97.6546 35.8733 96.6492 35.794 95.7496 35.4235C94.7178 35.0002 93.8447 34.2594 93.2626 33.307C92.5219 32.09 92.1779 30.6612 92.2573 29.259C92.1779 27.5657 92.6541 25.8989 93.6066 24.4967C94.6649 23.2267 96.2788 22.5653 97.9191 22.6711C99.4272 22.5389 100.935 22.9886 102.126 23.9146C103.475 25.0258 104.216 26.7191 104.057 28.4653V35.159C104.163 38.2545 101.729 40.8209 98.66 40.9267C98.4218 40.9267 98.1573 40.9267 97.9191 40.9002C95.3793 40.9796 93.1568 39.2863 92.5219 36.8258H95.9613C96.5169 37.7518 97.6017 38.2545 98.6864 38.0693C99.242 37.937 99.7447 37.5931 100.115 37.1433C100.591 36.4819 100.856 35.6881 100.856 34.8679M95.4309 29.3926C95.4309 31.5886 96.0659 32.7792 97.3094 33.0173C98.3412 33.3348 99.426 32.9908 100.087 32.1442C100.431 31.668 100.643 31.0859 100.696 30.5038C100.802 29.7631 100.802 29.0222 100.696 28.2814C100.59 27.5671 100.326 26.9056 99.9022 26.3236C99.4789 25.7415 98.8175 25.424 98.1031 25.477C97.1772 25.3976 96.3305 25.9003 95.9337 26.7205C95.5368 27.5671 95.3516 28.4931 95.3516 29.4191M89.4797 23.5707C88.342 23.0151 87.0985 22.7505 85.8286 22.7505C84.1618 22.5653 82.5214 23.2003 81.3573 24.3908C80.7752 25.1846 80.4577 26.1106 80.4313 27.0895H83.6062C83.6591 26.6662 83.8178 26.2693 84.0559 25.9518C84.5057 25.5285 85.0878 25.3169 85.6963 25.3698C86.2519 25.3433 86.781 25.4491 87.2838 25.6608C87.6541 25.8725 87.8658 26.2958 87.8129 26.7191C87.8129 27.1424 87.5218 27.5393 87.0985 27.6451C86.7017 27.8039 86.2783 27.8832 85.8551 27.9362L84.7438 28.0685C83.7385 28.1478 82.7595 28.4388 81.86 28.8886C80.6694 29.55 79.9815 30.8464 80.0609 32.2222C80.008 33.2541 80.4048 34.2595 81.1721 34.9738C81.9658 35.6088 82.9712 35.9527 84.0031 35.9527C91.1201 36.2702 91.0407 32.2222 91.0936 31.3492V26.6662C91.2259 25.4227 90.5909 24.2057 89.5062 23.5971M87.8934 30.7162C87.9728 31.5628 87.6288 32.4094 86.9674 32.965C86.3853 33.3619 85.6974 33.5735 85.0095 33.5735C84.5862 33.5735 84.1894 33.4412 83.8719 33.2032C83.528 32.8856 83.3427 32.4359 83.3957 31.9596C83.3692 31.404 83.6602 30.8484 84.1629 30.5839C84.6391 30.3458 85.1418 30.2135 85.671 30.1341L86.4118 30.0018C86.7028 29.9489 86.9939 29.8695 87.2849 29.7902C87.4965 29.7108 87.7082 29.6049 87.9199 29.4727L87.8934 30.7162L87.8934 30.7162ZM116.466 24.6325C113.821 22.0131 109.561 22.0131 106.915 24.6325C104.825 27.384 104.825 31.2203 106.915 33.9719C109.587 36.5647 113.794 36.5647 116.466 33.9719C118.556 31.1939 118.556 27.384 116.466 24.6325ZM113.873 32.1697C112.841 33.3868 111.015 33.5191 109.798 32.4872C109.693 32.3814 109.587 32.2755 109.481 32.1697C108.449 30.3971 108.449 28.2011 109.481 26.4285C110.513 25.2114 112.338 25.0791 113.555 26.111C113.661 26.2168 113.767 26.3226 113.873 26.4285C114.878 28.2011 114.878 30.3706 113.873 32.1697",
            fill: "#0A0080"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57.5967 21.0042C57.5967 31.4813 44.8178 39.9741 29.0757 39.9741C13.3336 39.9741 0.554688 31.4813 0.554688 21.0042C0.554688 10.5271 13.3336 2.00781 29.0757 2.00781C44.8178 2.03428 57.5967 10.5271 57.5967 21.0042Z",
            fill: "#00BCFF"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57.0384 20.1843C49.2334 18.9144 39.4971 23.0947 38.333 23.5444L37.698 23.809L37.9626 23.174C38.4124 21.9041 38.677 18.3588 38.5182 15.7395C38.333 13.0938 39.3384 10.5539 39.7882 9.38976L39.8675 9.12519C40.2379 8.11982 40.6877 8.11982 41.2169 8.22564C41.4021 8.22564 41.5873 8.33146 41.7725 8.33146C42.5927 8.33146 43.598 7.96104 44.3124 7.59066C44.6828 7.40545 45.0267 7.22025 45.4765 7.22025C45.7411 7.14087 46.0321 7.14087 46.2173 7.03505C46.4819 6.95566 46.7729 6.84984 47.0375 6.84984C48.0429 6.77046 48.7572 6.58528 48.7572 5.84445C48.7572 5.76509 48.7572 5.57989 48.572 5.47404C48.3868 5.39469 48.1222 5.28884 47.3021 5.47404H47.2227C46.8523 5.57989 46.0321 5.73863 46.7729 5.10366C46.7729 4.99784 46.8523 4.99784 46.8523 4.99784C47.1169 4.81261 47.4079 4.36283 47.5931 4.09827C47.6725 4.01889 47.7783 3.83368 47.6725 3.64849C47.5931 3.0929 46.7729 2.56374 45.8469 2.00814C45.6617 1.92878 45.4765 1.74358 45.2913 1.63773C44.8415 1.26735 43.7568 0.447161 43.2805 0.896951C42.6456 1.45254 40.185 3.80724 38.7299 5.44759C37.407 6.95568 36.3223 8.64894 35.4492 10.4481L35.0788 11.2682C34.2586 13.0938 32.9886 15.8982 31.7187 18.8879L31.1631 20.2373C31.0837 20.4225 31.0837 20.5018 30.9779 20.687C29.8931 23.1476 28.438 26.2166 29.4434 27.857C29.8931 28.5713 30.7927 29.0476 32.1685 29.1269C40.6083 29.8413 42.6985 29.6825 47.6196 29.0211C48.5191 28.9417 49.3393 28.7565 50.2653 28.5713C50.6357 28.492 50.9796 28.3862 51.35 28.3862C51.6146 28.3862 51.7998 28.3862 52.0909 28.4655C52.5406 28.6507 52.7258 28.9153 52.911 29.2857L53.0962 29.5503L53.3608 29.2857C54.8953 27.566 55.9801 25.661 56.6415 23.6502C56.9061 22.4597 57.0119 21.2955 57.0913 20.74V20.105H57.0384L57.0384 20.1843ZM26.2433 20.1858C26.0581 19.7361 25.7935 19.2863 25.6877 18.8365C24.4178 15.741 23.1478 12.9365 22.3276 11.1109L21.9572 10.3701C20.9519 8.28 19.9729 6.63965 18.6765 5.3697C17.2214 3.83517 14.7873 1.37466 14.1259 0.819028C13.5703 0.369248 12.4855 1.26881 12.1416 1.55984C11.9564 1.63922 11.7712 1.82441 11.586 1.93026C10.6864 2.48585 9.86622 3.01501 9.76039 3.57061C9.76039 3.75579 9.76039 3.94099 9.83976 4.02038C9.91913 4.20558 10.1043 4.47013 10.2895 4.65536C10.3689 4.73471 10.4747 4.73471 10.5541 4.84056H10.6599C11.3743 5.47552 11.2949 5.66075 11.2155 5.58137C10.8451 5.39614 10.5806 5.31678 10.316 5.31678H10.2366C9.33707 5.13158 9.04604 5.2374 8.8873 5.31678C8.7021 5.39614 8.7021 5.58137 8.7021 5.68719C8.7021 6.40153 9.52228 6.58673 10.5277 6.69258C10.7922 6.69258 11.0833 6.77194 11.3478 6.87776C11.6124 6.98358 11.7976 7.06299 12.0886 7.06299C12.4591 7.14235 12.9088 7.24817 13.2528 7.43337C13.9936 7.80378 14.9725 8.25356 15.7927 8.14774C15.9779 8.14774 16.1631 8.14774 16.3483 8.06833C16.9039 7.989 17.3537 7.989 17.6976 8.9679L17.777 9.23249C18.2267 10.3966 19.2321 12.963 19.0469 15.5822C18.8617 18.2015 19.1263 21.7468 19.6025 23.0168L19.8671 23.6517L19.2321 23.3872C18.2268 22.9374 8.88731 18.8365 1.16176 20.1064H0.976562V21.4558C1.24113 23.9957 2.32589 26.5356 4.33664 28.8109L4.52184 29.0755L4.70704 28.8109C4.89224 28.5463 5.07745 28.4405 5.34202 28.2553C5.97699 28.0701 6.3474 28.1495 7.16758 28.3347C8.06713 28.5199 8.99314 28.7051 9.81331 28.7845C12.5384 29.1549 14.364 29.3401 16.7981 29.3401C18.8882 29.3401 21.4281 29.1549 25.238 28.8903C26.5873 28.8109 27.5133 28.3347 27.9631 27.6204C28.9684 25.9006 27.5927 22.9109 26.4285 20.3446C26.3492 20.4504 26.3492 20.2917 26.2433 20.1858L26.2433 20.1858Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M52.4899 30.1871C52.3047 30.2665 52.2254 30.4517 52.0402 30.5575L51.9343 30.6369C51.7491 30.7163 51.6698 30.9015 51.4846 31.0073C51.2994 31.1925 51.1142 31.2719 50.929 31.4571C50.7438 31.5365 50.5585 31.7216 50.4792 31.8274L50.3998 31.9333C50.2146 32.0127 50.0294 32.1979 49.95 32.3037C49.95 32.3037 49.8706 32.3037 49.8706 32.4096C49.6854 32.4889 49.5002 32.6741 49.315 32.7799C49.1298 32.8858 48.9446 33.0445 48.7594 33.1503L48.6801 33.2297L48.1244 33.4943C48.1244 33.4943 48.0451 33.4943 48.0451 33.5737C47.5953 33.8382 47.2249 34.0234 46.7751 34.3144C46.6958 34.3144 46.6958 34.3938 46.6958 34.3938L46.1401 34.6584C46.0343 34.6584 46.0343 34.7378 46.0343 34.7378C45.5845 34.923 45.1348 35.1875 44.685 35.3728C44.6056 35.3728 44.6056 35.4521 44.4998 35.4521C44.3146 35.558 44.1294 35.6374 43.9442 35.6374C43.8648 35.6374 43.8648 35.7167 43.759 35.7167C43.5738 35.7961 43.3092 35.9019 43.0446 35.9813C42.7801 36.0607 42.5949 36.1665 42.3038 36.2459C42.2245 36.2459 42.2245 36.2459 42.1186 36.3252C41.9334 36.431 41.7482 36.431 41.563 36.5104C41.4572 36.5104 41.4572 36.5898 41.3778 36.5898C41.1926 36.6692 40.928 36.6692 40.7428 36.775H40.6634C40.3989 36.8809 40.2137 36.9602 39.9226 36.9602C39.8433 36.9602 39.8433 36.9602 39.7374 37.0396C39.5522 37.1189 39.367 37.1189 39.1025 37.2248C39.0231 37.2248 38.9173 37.2248 38.9173 37.3306C38.7321 37.41 38.4675 37.41 38.2823 37.5158H38.0971C37.8325 37.5952 37.5415 37.5952 37.2769 37.701H37.0917C36.9065 37.8068 36.6419 37.8068 36.4567 37.8068C36.3774 37.8068 36.2715 37.8068 36.1922 37.8862C36.007 37.8862 35.7424 37.9656 35.5572 37.9656H35.372C35.1074 38.045 34.8164 38.045 34.5518 38.045H34.3666C34.1814 38.045 33.9168 38.1244 33.6258 38.1244H33.3612C33.176 38.1244 32.9114 38.2301 32.7262 38.2301H32.4617C32.1971 38.2301 31.9061 38.3095 31.6415 38.3095H26.7469C26.4823 38.3095 26.1913 38.3095 25.9267 38.2301H25.8473C25.5827 38.2301 25.2917 38.2301 25.0271 38.1244H24.7626C24.5774 38.1244 24.3128 38.1244 24.1276 38.045H23.863C23.5984 38.045 23.3074 37.9656 23.0428 37.9656H22.9634C22.6989 37.9656 22.5137 37.8862 22.2226 37.8862H21.9581C21.7729 37.8862 21.5083 37.8068 21.3231 37.8068H21.1643C20.8998 37.701 20.6087 37.701 20.3442 37.6216H20.2648C20.0796 37.5422 19.815 37.5422 19.6298 37.4364C19.5504 37.4364 19.4446 37.4364 19.3652 37.3571C19.18 37.2512 18.9948 37.2512 18.8096 37.1718C18.7303 37.1718 18.7303 37.1718 18.6244 37.0925C18.3599 37.0131 18.0688 37.0131 17.8836 36.9073H17.6984C17.5132 36.8015 17.2487 36.8015 17.0635 36.7221C16.9576 36.7221 16.8783 36.6427 16.8783 36.6427C16.6931 36.5633 16.5079 36.5633 16.3227 36.4575C16.2433 36.4575 16.2433 36.4575 16.1375 36.3517C15.8729 36.2723 15.6877 36.1665 15.3966 36.0871C15.3173 36.0871 15.3173 36.0871 15.2114 36.0077C15.0262 35.9019 14.841 35.8225 14.6558 35.8225C14.5765 35.8225 14.4706 35.7431 14.4706 35.7431C14.2854 35.6638 14.1002 35.558 13.915 35.558C13.8357 35.558 13.8357 35.558 13.7298 35.4521C13.5446 35.3728 13.2801 35.2669 13.0155 35.1875C12.9361 35.1875 12.9361 35.1082 12.8303 35.1082L12.2747 34.8436C12.1953 34.8436 12.1953 34.7642 12.0895 34.7642L11.5339 34.4996C11.5339 34.4996 11.4281 34.4996 11.4281 34.4203C11.2429 34.3409 10.9783 34.2351 10.7931 34.0499C10.7137 34.0499 10.7137 33.9705 10.6079 33.9705C10.4227 33.8911 10.2375 33.7853 10.1581 33.7059C10.0523 33.7059 10.0523 33.6266 9.97291 33.6266L9.4173 33.362C9.4173 33.362 9.33793 33.362 9.33793 33.2562C9.15273 33.1768 8.96754 32.9916 8.78234 32.8858C8.67651 32.8858 8.67651 32.7799 8.59714 32.7799C8.41193 32.7006 8.33257 32.5947 8.14737 32.5153C8.068 32.5153 8.068 32.436 7.96216 32.436C7.77697 32.3302 7.59176 32.2508 7.51239 32.0656C7.51239 32.0656 7.43302 32.0656 7.43302 31.9862C7.24782 31.8804 7.06261 31.7216 6.87743 31.6158C6.79806 31.6158 6.79805 31.5364 6.79805 31.5364C6.71869 31.4306 6.53347 31.3512 6.42764 31.1661C6.34828 31.1661 6.34828 31.0867 6.24244 31.0867C6.05723 30.9808 5.97787 30.8221 5.79267 30.7163C5.60746 30.5311 5.42227 30.4517 5.3429 30.2665C5.26353 30.2665 5.26353 30.1871 5.26353 30.1871L4.81375 29.7373L4.73438 29.6315C4.91958 29.3669 4.99895 29.2611 5.10477 29.1817C5.47518 28.9965 5.66038 29.1024 6.4541 29.2876C7.35365 29.4728 8.27966 29.658 9.17921 29.7373C14.0738 30.3723 16.2698 30.5575 24.8155 29.8167C26.4559 29.6315 27.5406 29.0759 28.0962 28.097C28.1756 28.0176 28.1756 27.9118 28.2814 27.7266C28.3872 27.8059 28.3872 27.9118 28.4666 28.097C29.0222 29.1024 30.1863 29.6315 31.7473 29.8167C40.293 30.5311 42.4626 30.3723 47.3572 29.7373C48.2567 29.6315 49.1827 29.4728 50.0823 29.2876C50.9025 29.1024 51.0877 29.1024 51.4316 29.1817C51.6168 29.2876 51.6962 29.3669 51.9872 29.9225C52.5957 30.0813 52.5957 30.0813 52.4899 30.1871C52.4899 30.0813 52.4899 30.0813 52.4899 30.1871L52.4899 30.1871ZM53.2305 11.563L53.4157 11.7482C53.6009 11.9335 53.6803 12.1187 53.8655 12.3038C53.9448 12.4097 53.9448 12.4097 53.9448 12.489C54.0242 12.5684 54.13 12.6743 54.13 12.7536C54.2094 12.8595 54.2094 12.8595 54.2094 12.9388C54.3153 13.0182 54.3946 13.1241 54.3946 13.2034C54.474 13.3092 54.474 13.3092 54.474 13.3886C54.6592 13.759 54.9238 14.0236 55.109 14.394C55.109 14.4734 55.2148 14.4734 55.2148 14.5792C55.2942 14.685 55.2942 14.7644 55.4 14.8438C55.4 14.9232 55.4794 14.9232 55.4794 15.029C55.5587 15.1348 55.5587 15.2142 55.6646 15.2936C55.6646 15.3729 55.7439 15.3729 55.7439 15.4788C55.8233 15.664 55.9291 15.9285 56.0085 16.1137C56.0085 16.1931 56.0085 16.1931 56.1143 16.1931C56.1143 16.2725 56.1937 16.3783 56.1937 16.4577C56.1937 16.537 56.2731 16.6429 56.2731 16.6429C56.2731 16.7223 56.3525 16.8281 56.3525 16.9075C56.3525 16.9868 56.4318 17.0927 56.4318 17.0927C56.4318 17.172 56.5377 17.2779 56.5377 17.3573C56.5377 17.4366 56.5377 17.5425 56.617 17.5425C56.6964 17.7276 56.6964 17.9128 56.6964 18.0981C56.6964 18.1774 56.6964 18.2833 56.7758 18.2833C56.7758 18.3626 56.7758 18.4684 56.8552 18.5478V19.1034C54.3153 18.733 50.3202 18.733 44.6054 20.294C42.6211 21.1142 40.7956 21.6433 38.8906 22.4635C39.261 20.638 39.3404 17.8335 39.1552 15.7434C38.97 13.3886 39.896 11.034 40.4252 9.73753L40.5045 9.47294C40.6104 9.28776 40.6104 9.10255 40.7691 9.02319H41.0337C41.2189 9.02319 41.4835 9.10254 41.6687 9.10254C42.8592 9.20837 44.2086 8.46759 44.579 8.28238C44.8435 8.09717 45.2139 8.01779 45.5843 7.91197C45.8489 7.83259 46.14 7.72676 46.4839 7.6474C46.6691 7.56802 46.8543 7.56802 47.1189 7.56802C47.3834 7.56802 47.7538 7.48866 48.1242 7.38281C50.135 8.65274 51.8547 10.0285 53.2305 11.5631L53.2305 11.563ZM43.6012 1.03057C43.8658 0.845356 44.5008 1.10995 45.321 1.74493C45.5062 1.93011 45.6914 2.00947 45.8766 2.11531C46.4322 2.4857 47.5169 3.1207 47.5963 3.57048C47.5963 3.64986 47.5963 3.75568 47.5169 3.83504V3.91442C47.3317 4.17901 47.0672 4.65523 46.882 4.73461L46.6968 4.91981C46.3264 5.29022 45.7972 5.66062 45.612 5.66062C45.0564 5.58124 44.7125 5.47541 44.2627 5.29021C44.5272 4.20546 44.8976 4.47003 45.612 4.84044C45.612 4.65523 45.5326 4.57585 45.5326 4.39066L46.0882 4.12609L45.4533 4.04671C45.3739 3.59694 45.3739 3.22653 45.3739 2.77677C45.1887 3.04133 45.1887 3.33237 45.1093 3.51757C45.0299 3.70277 44.8447 3.88798 44.7389 3.96734L44.3685 3.59695C44.1833 3.41174 43.9187 3.22654 43.7335 3.14717C43.7335 3.22655 43.6542 3.22655 43.6542 3.22655C44.2891 4.1261 44.2891 4.31131 43.5748 5.13147C42.9398 5.84583 42.3048 6.40141 41.6698 7.03641C42.1196 7.30098 42.6752 7.11577 43.3102 6.48081C44.1304 5.58126 44.1304 5.58126 45.2151 6.03103L45.4003 6.11042C45.8501 6.2956 46.1147 6.03103 46.5644 5.84582C46.829 5.76646 47.1994 5.58126 47.464 5.58126H47.5698C48.2048 5.47543 48.5752 5.47543 48.6546 5.58126C48.6546 5.58126 48.734 5.66062 48.734 5.76646C48.734 6.21626 48.3636 6.40142 47.1994 6.50726C46.9348 6.50726 46.6438 6.58665 46.2999 6.69247C46.0353 6.77183 45.8501 6.87768 45.5591 6.87768C45.1093 6.9835 44.7389 7.06288 44.395 7.32745C43.6541 7.69784 42.7546 8.06825 42.0402 8.06825C41.855 8.06825 41.6698 8.06825 41.5905 7.98889C40.9555 7.90951 40.4263 7.90951 39.9501 9.07364L39.8707 9.33821C39.421 10.6081 38.4156 13.1481 38.5214 15.7938C38.7066 18.4396 38.4156 21.9848 37.9658 23.1489L37.3308 24.3395L38.5214 23.7839C38.6008 23.6781 48.9721 19.1539 57.0416 20.4238V20.7942C56.9622 21.535 56.8564 22.6198 56.5918 23.7045C56.0362 25.7153 54.9514 27.6202 53.4169 29.2606C53.2317 28.8108 52.9671 28.5198 52.4115 28.361C52.1469 28.2552 51.8559 28.1758 51.5913 28.1758C51.221 28.1758 50.7712 28.2552 50.4272 28.361C49.5277 28.5462 48.7075 28.7314 47.7815 28.8108C42.9662 29.4458 40.7967 29.631 32.3304 28.8902C31.0604 28.8108 30.2402 28.3346 29.7905 27.6996C28.8909 26.1651 30.2402 23.1489 31.325 20.7149C31.5896 20.0799 31.8806 19.4449 32.1452 18.8893C33.4945 15.5292 34.8703 12.5395 35.6905 10.7934L35.8757 10.423C36.881 8.33284 37.86 6.79831 39.0505 5.42253C40.5057 3.9409 42.9662 1.55974 43.6012 1.03061L43.6012 1.03057ZM29.0778 2.67188C32.7024 2.67188 36.1683 3.12165 39.2374 3.94184C38.867 4.31224 38.6024 4.5768 38.3378 4.94723C36.9356 6.50819 35.7979 8.28084 34.9778 10.2122L34.7926 10.5826C33.9724 12.4082 32.5172 15.3979 31.2473 18.758C31.0621 19.3136 30.7975 19.8427 30.5065 20.4777C29.8715 21.827 29.2365 23.3086 28.8661 24.7373C28.4957 23.2822 27.7814 21.827 27.2258 20.4777L26.485 18.758C25.1356 15.3979 23.7598 12.4082 22.9397 10.5826L22.7545 10.2122C21.7491 8.04272 20.6643 6.40237 19.3944 4.94723C19.1298 4.68264 18.8388 4.39162 18.5742 4.04768C21.7226 3.12167 25.2415 2.67189 29.0778 2.67189L29.0778 2.67188ZM9.07532 5.66402C9.15469 5.58464 9.63091 5.58464 10.1601 5.66402H10.3453L11.1655 5.92858C11.6152 6.19317 11.8798 6.37836 12.3296 6.19317C12.4089 6.19317 12.5148 6.11381 12.5148 6.11381C13.5995 5.7434 13.5995 5.7434 14.4197 6.56358C15.0547 7.27794 15.5838 7.38376 16.0601 7.11918C15.4251 6.48422 14.7107 5.84924 14.1551 5.21426C13.4408 4.39408 13.4408 4.1295 14.0758 3.30932C14.0758 3.2035 13.9964 3.2035 13.9964 3.2035C13.8112 3.3887 13.5466 3.46806 13.3614 3.65327L12.991 4.02366C12.8058 3.83848 12.6206 3.7591 12.6206 3.57389C12.5412 3.38869 12.5412 3.12412 12.356 2.85955C12.356 3.22994 12.2767 3.67973 12.2767 4.12949L11.6417 4.3147L12.1973 4.57926L12.1179 4.94968C12.7529 4.49991 13.2027 4.23531 13.4672 5.39943C13.0175 5.58464 12.5677 5.58464 12.1179 5.76985C11.9327 5.84921 11.3771 5.39943 10.9273 5.02904C10.9273 4.94968 10.848 4.94968 10.848 4.94968L10.5834 4.68511C10.3982 4.49991 10.3188 4.23533 10.213 4.12951V4.05013C10.1336 3.97075 10.1336 3.86492 10.1336 3.78556C10.213 3.33579 11.3242 2.59498 11.8533 2.33039C12.0386 2.25101 12.2238 2.06583 12.4089 1.96C13.1498 1.32502 13.8641 0.954607 14.1287 1.2192C14.7637 1.77479 17.1184 4.12951 18.6793 5.66404C19.8699 6.93398 20.8488 8.57433 21.8542 10.6645L22.0394 11.0349C22.8596 12.8604 24.3147 15.8501 25.5847 19.1044C25.7699 19.66 26.0345 20.295 26.4049 20.9299C27.4896 23.3904 28.8654 26.3801 27.9394 27.9147C27.569 28.629 26.6695 28.9994 25.3995 29.1052C16.9596 29.846 14.8695 29.6608 9.94841 29.0258C9.04886 28.9465 8.22868 28.7613 7.30268 28.5761C6.4825 28.3909 6.03273 28.3115 5.31839 28.4967C4.94799 28.5761 4.76278 28.8671 4.57759 29.1317C2.75203 26.9622 1.5879 24.5016 1.29688 21.8559V20.6653C9.39283 19.316 19.182 23.8402 19.2879 23.946L20.4784 24.5016L20.0287 23.3111C19.5789 22.1205 19.2879 18.5752 19.4731 15.9559C19.6583 13.3366 18.6529 10.7703 18.1237 9.50033L18.0444 9.23574C17.5946 8.04516 17.039 8.04516 16.404 8.15099C16.2188 8.15099 16.0336 8.23038 15.9543 8.23038C15.2134 8.23038 14.2345 7.85996 13.5995 7.51602C13.2291 7.33081 12.7794 7.14561 12.409 7.06622C12.1444 6.98686 11.9592 6.98686 11.6946 6.88101C11.43 6.80166 11.139 6.69583 10.7951 6.69583C9.60448 6.51062 9.26053 6.32541 9.26053 5.95502C8.99597 5.74338 8.99597 5.664 9.07533 5.664L9.07532 5.66402ZM9.81435 7.46096C9.99955 7.54034 10.2641 7.54034 10.4493 7.54034C10.6345 7.54034 10.8991 7.6197 11.0843 7.6197C11.3489 7.69906 11.6399 7.8049 11.9839 7.88427C12.3543 7.96365 12.6188 8.06947 12.9892 8.25466C13.3596 8.43987 14.709 9.15423 15.8995 9.07484C16.0848 9.07484 16.3493 9.07484 16.5345 8.99548H16.7991C16.7991 8.99548 16.8785 9.07484 17.0637 9.44526L17.143 9.70983C17.5928 10.9798 18.5982 13.3345 18.413 15.7156C18.2278 17.8058 18.3072 20.6102 18.6776 22.4358C15.9525 21.2452 8.14756 18.4408 1.24219 19.5255C1.32156 18.8111 1.42739 18.1761 1.61259 17.4354V17.356C1.61259 17.2502 1.69196 17.1708 1.69196 17.0914C1.69196 17.012 1.77133 16.9062 1.77133 16.8269V16.7475C1.95653 16.1919 2.2211 15.5834 2.51213 15.0277C2.51213 15.0277 2.51213 14.9484 2.5915 14.9484C2.5915 14.9484 2.5915 14.869 2.67087 14.869C2.75024 14.7896 2.75024 14.6838 2.85607 14.6044C4.17893 11.8264 6.63947 9.4717 9.81435 7.46094V7.46096ZM49.3165 6.82611C49.5017 6.56154 49.6869 6.27049 49.6869 5.92654C49.6869 5.55616 49.5017 5.2122 49.2371 4.92117C48.9726 4.73597 48.6815 4.6566 48.3376 4.6566C48.3376 4.6566 48.3376 4.55078 48.4434 4.55078C48.6286 4.28621 48.708 3.9158 48.6286 3.54541C48.4434 2.64586 47.2793 1.90504 46.4591 1.3759C46.2739 1.29652 46.0887 1.19069 46.0093 1.11133C44.369 -0.238001 43.4694 -0.079251 43.0196 0.291149C42.5699 0.661539 41.4851 1.7463 40.2945 2.93687C36.8286 2.03733 33.0187 1.48172 29.1295 1.48172C25.0551 1.48172 21.1394 2.03734 17.5941 3.01625C16.4035 1.82568 15.2394 0.740919 14.7632 0.291149C14.3134 -0.079261 13.308 -0.343841 11.7735 1.11133C11.6941 1.19069 11.5089 1.29653 11.3237 1.3759C10.5036 1.82568 9.31298 2.56648 9.15424 3.54541C9.07487 3.9158 9.15424 4.28621 9.33944 4.55078C9.33944 4.55078 9.33944 4.6566 9.44527 4.6566C9.07487 4.6566 8.81029 4.73598 8.54572 4.92117C8.28115 5.18576 8.09595 5.47677 8.09595 5.92654C8.09595 6.48216 8.28115 6.74673 8.54572 7.0113C3.28071 10.3714 0 15.1866 0 20.3723V21.5628C0 32.6484 11.3502 41.644 29.0766 41.644C46.8824 41.644 58.1533 32.6484 58.1533 21.5628V20.4781C58.1268 15.1072 54.7667 10.292 49.3165 6.8261V6.82611Z",
            fill: "#0A0080"
          }
        )
      ]
    }
  );
}
function OM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M80.4585 20.8837C80.4585 20.2687 80.4585 19.6516 80.4585 19.0365C80.477 18.9275 80.4996 18.8185 80.5161 18.7094C80.6148 18.0306 80.6704 17.3415 80.8164 16.673C81.6392 12.886 83.5852 9.78194 86.6707 7.44722C90.5091 4.54064 94.8309 3.5759 99.5436 4.55915C103.316 5.34494 106.383 7.32174 108.728 10.3723C111.26 13.6635 112.316 17.4135 111.919 21.5399C111.598 24.8826 110.3 27.8344 108.072 30.3543C105.63 33.1168 102.586 34.8365 98.9511 35.4845C98.3567 35.5894 97.756 35.649 97.1574 35.7293H95.3102C95.23 35.7128 95.1518 35.684 95.0716 35.6778C92.6052 35.503 90.2972 34.7974 88.1908 33.5077C84.1056 31.0043 81.5899 27.3942 80.7074 22.6733C80.5963 22.083 80.5428 21.4802 80.4626 20.8837H80.4585ZM93.8518 22.5108C93.716 22.3833 93.642 22.3154 93.57 22.2434C92.5456 21.2211 91.5232 20.1967 90.4989 19.1764C90.3754 19.053 90.2479 18.9336 90.1121 18.8246C89.207 18.0903 87.8123 18.2301 87.0656 19.127C86.2696 20.0835 86.3498 21.3239 87.2775 22.2557C88.8717 23.8541 90.47 25.4503 92.0663 27.0445C93.1503 28.1286 94.4463 28.1286 95.5324 27.0445C98.7269 23.852 101.919 20.6595 105.11 17.467C105.248 17.3292 105.379 17.1852 105.499 17.0309C106.398 15.8584 105.82 14.0544 104.408 13.6142C103.466 13.3221 102.681 13.5895 102 14.2724C99.3523 16.9239 96.7028 19.5693 94.0554 22.2208C93.9772 22.2989 93.9238 22.4059 93.8518 22.5129V22.5108Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M79.463 26.0387H24.6844C23.7752 26.0387 23.0388 26.7751 23.0388 27.6843V93.5091C23.0388 94.4183 22.3023 95.1548 21.3931 95.1548H14.8107C13.9015 95.1548 13.165 94.4183 13.165 93.5091V17.8106C13.165 16.9014 13.9015 16.165 14.8107 16.165H78.6073C78.3892 17.2799 78.2761 18.4298 78.2761 19.6084C78.2761 21.8753 78.6957 24.0434 79.463 26.0387Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M11.5193 12.8737H74.0529C74.9621 12.8737 75.6985 12.1373 75.6985 11.2281V4.64562C75.6985 3.73642 74.9621 3 74.0529 3H1.64562C0.736415 3 0 3.73642 0 4.64562V80.3442C0 81.2534 0.736415 81.9898 1.64562 81.9898H8.2281C9.13731 81.9898 9.87372 81.2534 9.87372 80.3442V14.5193C9.87372 13.6101 10.6101 12.8737 11.5193 12.8737Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M96.2256 37.5581C96.0282 37.5581 95.8286 37.5539 95.6332 37.5478C95.5715 37.5539 95.5077 37.5581 95.4439 37.5581H67.4684C66.5612 37.5581 65.8228 36.8216 65.8228 35.9124C65.8228 35.4578 66.0079 35.0464 66.3062 34.7482C66.6045 34.4519 67.0158 34.2668 67.4684 34.2668H85.8644C83.9884 32.94 82.3798 31.2615 81.1333 29.33H27.9735C27.0664 29.33 26.3279 30.0664 26.3279 30.9756V40.8493C26.3279 41.7585 27.0664 42.4949 27.9735 42.4949H100.381C101.29 42.4949 102.026 41.7585 102.026 40.8493V36.6015C100.208 37.2207 98.2559 37.5581 96.2256 37.5581ZM34.0747 37.0767C33.7764 37.3729 33.365 37.5581 32.9104 37.5581C32.4558 37.5581 32.0464 37.3729 31.7482 37.0767C31.4499 36.7784 31.2647 36.367 31.2647 35.9124C31.2647 35.4578 31.4499 35.0464 31.7482 34.7482C32.0464 34.4519 32.4578 34.2668 32.9104 34.2668C33.8196 34.2668 34.556 35.0032 34.556 35.9124C34.556 36.367 34.3709 36.7784 34.0747 37.0767ZM40.6572 37.0767C40.3589 37.3729 39.9474 37.5581 39.4928 37.5581C39.0382 37.5581 38.6289 37.3729 38.3306 37.0767C38.0324 36.7784 37.8472 36.367 37.8472 35.9124C37.8472 35.4578 38.0324 35.0464 38.3306 34.7482C38.6289 34.4519 39.0403 34.2668 39.4928 34.2668C40.4021 34.2668 41.1385 35.0032 41.1385 35.9124C41.1385 36.367 40.9534 36.7784 40.6572 37.0767ZM47.2396 37.0767C46.9414 37.3729 46.5299 37.5581 46.0753 37.5581C45.6207 37.5581 45.2114 37.3729 44.9131 37.0767C44.6149 36.7784 44.4297 36.367 44.4297 35.9124C44.4297 35.4578 44.6149 35.0464 44.9131 34.7482C45.2114 34.4519 45.6228 34.2668 46.0753 34.2668C46.9845 34.2668 47.7209 35.0032 47.7209 35.9124C47.7209 36.367 47.5358 36.7784 47.2396 37.0767Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M100.381 45.7861H27.9735C27.0664 45.7861 26.3279 46.5225 26.3279 47.4318V106.674C26.3279 107.583 27.0664 108.32 27.9735 108.32H100.381C101.29 108.32 102.026 107.583 102.026 106.674V47.4318C102.026 46.5225 101.29 45.7861 100.381 45.7861ZM48.0439 92.1865C39.6862 92.1865 32.9104 85.4106 32.9104 77.0529C32.9104 68.6952 39.6862 61.9194 48.0439 61.9194C56.4016 61.9194 63.1754 68.6952 63.1754 77.0529C63.1754 85.4106 56.4016 92.1865 48.0439 92.1865ZM94.2344 91.4459C93.7778 91.9026 93.1484 92.1865 92.4572 92.1865H71.8972C70.5107 92.1865 69.3794 91.053 69.3794 89.6687C69.3794 88.9754 69.6612 88.346 70.1179 87.8914C70.5745 87.4347 71.204 87.1509 71.8972 87.1509H92.4572C93.8416 87.1509 94.975 88.2843 94.975 89.6687C94.975 90.3619 94.6911 90.9913 94.2344 91.4459ZM94.2344 79.0503C93.7778 79.507 93.1484 79.7908 92.4572 79.7908H71.8972C70.5107 79.7908 69.3794 78.6574 69.3794 77.271C69.3794 76.5798 69.6612 75.9504 70.1179 75.4937C70.5745 75.037 71.204 74.7532 71.8972 74.7532H92.4572C93.8416 74.7532 94.975 75.8866 94.975 77.271C94.975 77.9642 94.6911 78.5936 94.2344 79.0503ZM94.2344 66.6526C93.7778 67.1093 93.1484 67.3931 92.4572 67.3931H71.8972C70.5107 67.3931 69.3794 66.2597 69.3794 64.8753C69.3794 64.1842 69.6612 63.5547 70.1179 63.0981C70.5745 62.6414 71.204 62.3575 71.8972 62.3575H92.4572C93.8416 62.3575 94.975 63.491 94.975 64.8753C94.975 65.5665 94.6911 66.1959 94.2344 66.6526Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M43.7734 73.5909V80.5149C43.7734 81.5948 44.911 82.2983 45.8778 81.8149L52.8018 78.353C53.8735 77.8181 53.8735 76.2877 52.8018 75.7529L45.8778 72.2909C44.911 71.8075 43.7734 72.511 43.7734 73.5909Z" })
      ]
    }
  );
}
function lh(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "931.999",
      height: "931.999",
      viewBox: "0 0 931.999 931.999",
      fill: "#CBD5E1",
      stroke: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          id: "Exclusion_3",
          "data-name": "Exclusion 3",
          d: "M466,931.5a472.963,472.963,0,0,1-47.595-2.4,466.666,466.666,0,0,1-46.22-7.054c-15-3.069-30.006-6.928-44.611-11.471-14.441-4.492-28.83-9.758-42.768-15.653-13.808-5.84-27.5-12.435-40.691-19.6-13.1-7.115-26.011-14.96-38.38-23.317A468.069,468.069,0,0,1,80,726.266c-8.357-12.369-16.2-25.282-23.317-38.38-7.167-13.193-13.762-26.883-19.6-40.691-5.9-13.938-11.162-28.327-15.653-42.768-4.543-14.605-8.4-29.614-11.471-44.611A466.67,466.67,0,0,1,2.9,513.595a472.483,472.483,0,0,1,0-95.189,466.668,466.668,0,0,1,7.054-46.22c3.069-15,6.928-30.006,11.471-44.611,4.492-14.441,9.758-28.83,15.653-42.768,5.84-13.808,12.435-27.5,19.6-40.691C63.8,231.017,71.644,218.1,80,205.735A468.069,468.069,0,0,1,205.735,80c12.369-8.357,25.282-16.2,38.38-23.317,13.193-7.167,26.883-13.762,40.691-19.6,13.938-5.9,28.327-11.162,42.768-15.653,14.605-4.543,29.614-8.4,44.611-11.471A466.668,466.668,0,0,1,418.406,2.9a472.483,472.483,0,0,1,95.189,0,466.67,466.67,0,0,1,46.22,7.054c15,3.069,30.006,6.928,44.611,11.471,14.441,4.492,28.83,9.758,42.768,15.653,13.808,5.84,27.5,12.435,40.691,19.6C700.983,63.8,713.9,71.644,726.266,80A468.069,468.069,0,0,1,852,205.735c8.357,12.369,16.2,25.282,23.317,38.38,7.167,13.193,13.762,26.883,19.6,40.691,5.9,13.938,11.162,28.327,15.653,42.768,4.543,14.605,8.4,29.614,11.471,44.611a466.666,466.666,0,0,1,7.054,46.22,472.43,472.43,0,0,1,0,95.189,466.667,466.667,0,0,1-7.054,46.22c-3.069,15-6.928,30.006-11.471,44.611-4.492,14.441-9.758,28.83-15.653,42.768-5.84,13.808-12.435,27.5-19.6,40.691-7.115,13.1-14.96,26.011-23.317,38.38A468.07,468.07,0,0,1,726.266,852c-12.369,8.357-25.282,16.2-38.38,23.317-13.193,7.167-26.883,13.762-40.691,19.6-13.938,5.9-28.327,11.162-42.768,15.653-14.605,4.543-29.614,8.4-44.611,11.471a466.667,466.667,0,0,1-46.22,7.054A472.963,472.963,0,0,1,466,931.5ZM591.545,364.758a80.927,80.927,0,0,1,15.924,1.594,83.7,83.7,0,0,1,15.106,4.568A85.8,85.8,0,0,1,648.74,387.7,83.147,83.147,0,0,1,659,399.281a78.754,78.754,0,0,1,7.845,13.276,72.539,72.539,0,0,1,6.849,30.37v218.92H766V442.927a167.974,167.974,0,0,0-11.76-62.213,180.051,180.051,0,0,0-33.721-53.795,170.406,170.406,0,0,0-112.982-56.757c-5.238-.42-10.266-.624-15.369-.624a174.2,174.2,0,0,0-69.106,14.241,173.135,173.135,0,0,0-57.581,40.436,175.252,175.252,0,0,0-57.425-40.359,171.956,171.956,0,0,0-68.64-14.319C243.794,269.539,166,347.321,166,442.927v218.92h92.308V442.927a71.8,71.8,0,0,1,5.875-28.312,78.778,78.778,0,0,1,6.832-12.631,83.117,83.117,0,0,1,8.974-11.238A84.939,84.939,0,0,1,303,373.58a81.077,81.077,0,0,1,13.354-5.362,76.388,76.388,0,0,1,14.133-2.838c2.655-.2,5.4-.416,7.891-.416a81.331,81.331,0,0,1,15.895,1.576,83.049,83.049,0,0,1,15.03,4.524,84.18,84.18,0,0,1,25.931,16.664,81.736,81.736,0,0,1,10.135,11.526A78.109,78.109,0,0,1,413.1,412.5a73.5,73.5,0,0,1,6.742,30.425v218.92h92.777V442.927a73.82,73.82,0,0,1,5.666-28.257,79.5,79.5,0,0,1,6.623-12.661,82.439,82.439,0,0,1,8.74-11.289A83.346,83.346,0,0,1,544.2,381.1a81.81,81.81,0,0,1,12.055-7.662,76.21,76.21,0,0,1,27.4-8.261C586.31,364.969,589.052,364.758,591.545,364.758Z",
          transform: "translate(-0.001 -0.001)",
          strokeWidth: "1"
        }
      )
    }
  );
}
function BM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "159",
      height: "42",
      enableBackground: "new 0 0 2500 738.6",
      viewBox: "0 0 2500 738.6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "m1057.4 241.2c-137.3 0-248.7 111.7-248.7 248.7s111.7 248.7 248.7 248.7 248.7-111.7 248.7-248.7-111.4-248.7-248.7-248.7zm0 379.7c-72.1 0-130.8-58.7-130.8-130.8s58.7-130.8 130.8-130.8 130.8 58.7 130.8 130.8-58.7 130.8-130.8 130.8z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m1884.7 155.1c42.8 0 77.6-34.7 77.6-77.6s-34.8-77.5-77.6-77.5-77.6 34.7-77.6 77.6 34.8 77.5 77.6 77.5z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m549.6 241.4c-6.5-.5-12.7-.8-19.1-.8-60 0-116.9 24.6-157.7 68-40.8-43.2-97.5-68-156.9-68-119 .1-215.9 96.7-215.9 215.7v272.2h116.3v-268.9c0-49.4 40.6-94.9 88.4-99.8 3.4-.3 6.7-.5 9.8-.5 53.8 0 97.7 43.9 98 97.7v271.4h118.9v-269.3c0-49.1 40.3-94.6 88.4-99.5 3.4-.3 6.7-.5 9.8-.5 53.8 0 98 43.7 98.2 97.2v272.2h118.9v-268.9c0-54.5-20.2-107.1-56.6-147.6-36.3-40.8-86.2-65.9-140.5-70.6z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m1489.1 11.6h-118.9v717.4h118.9zm227.6 0h-118.9v717.4h118.9zm227.5 241.5h-118.9v475.7h118.9z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m2500 478.8c0-63.1-24.6-122.5-69-167.8-44.7-45.2-103.7-70.3-166.5-70.3h-3.1c-65.1.8-126.7 26.6-172.7 72.9s-71.9 107.5-72.6 172.9c-.8 66.7 24.8 129.8 72.1 177.6s109.9 74.2 176.6 74.2h.3c87.4 0 169.3-46.8 214.1-122l5.7-9.6-98.2-48.3-4.9 8c-24.8 40.6-67.4 64.6-114.7 64.6-60.5 0-112.7-40.3-128.8-97.7h361.7zm-240.2-130.1c54.3 0 102.9 35.7 120 86.3h-239.7c16.8-50.6 65.4-86.3 119.7-86.3z" })
      ]
    }
  );
}
function jM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.5",
      height: "19.875",
      viewBox: "0 0 28.5 19.875",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { transform: "translate(-1376.759 -16.413)", children: /* @__PURE__ */ u.jsxs("g", { transform: "translate(1377.009 16.663)", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1348.956,462h-7.45a6.115,6.115,0,0,0,7.45,7.092Z",
            transform: "translate(-1321.396 -461.999)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1341.3,461.749h7.907v7.538l-.191.046a6.363,6.363,0,0,1-7.754-7.382Zm7.407.5h-6.99a5.865,5.865,0,0,0,6.99,6.642Z",
            transform: "translate(-1321.396 -461.999)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M894.4,687.154h7.45a6.115,6.115,0,0,0-7.45-7.092Z",
            transform: "translate(-894.396 -669.194)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M902.053,687.4h-7.907v-7.538l.191-.046a6.365,6.365,0,0,1,7.755,7.382Zm-7.407-.5h6.99a5.864,5.864,0,0,0-6.99-6.642Z",
            transform: "translate(-894.396 -669.194)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "circle",
          {
            cx: "3.853",
            cy: "3.853",
            r: "3.853",
            transform: "translate(9.946 5.127)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M3.853-.25a4.1,4.1,0,1,1-4.1,4.1A4.108,4.108,0,0,1,3.853-.25Zm0,7.707a3.6,3.6,0,1,0-3.6-3.6A3.607,3.607,0,0,0,3.853,7.457Z",
            transform: "translate(9.946 5.127)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M912.079,478.29H895.955V463.668H920.4v7.567a6.306,6.306,0,0,1,1.559.707V462H894.4v17.96h17.935A7.464,7.464,0,0,1,912.079,478.29Z",
            transform: "translate(-894.396 -461.999)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M912.657,480.209H894.146v-18.46h28.059v10.645l-.383-.241a6.063,6.063,0,0,0-1.5-.679l-.179-.053v-7.5H896.205V478.04H912.32l.009.241a7.229,7.229,0,0,0,.243,1.613Zm-18.011-.5h17.366a7.733,7.733,0,0,1-.169-1.169H895.705V463.418h24.941v7.633a6.538,6.538,0,0,1,1.059.456v-9.258H894.646Z",
            transform: "translate(-894.396 -461.999)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1324.349,672.157a4.53,4.53,0,1,0,4.53,4.53A4.529,4.529,0,0,0,1324.349,672.157Zm2.336,5.218h-4.671V676h4.671Z",
            transform: "translate(-1300.878 -661.841)",
            fill: "#b5c3d5"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1324.349,671.907a4.78,4.78,0,1,1-4.779,4.78A4.785,4.785,0,0,1,1324.349,671.907Zm0,9.059a4.28,4.28,0,1,0-4.279-4.28A4.284,4.284,0,0,0,1324.349,680.966Zm-2.585-5.218h5.171v1.877h-5.171Zm4.671.5h-4.171v.877h4.171Z",
            transform: "translate(-1300.878 -661.841)",
            fill: "#b5c3d5"
          }
        )
      ] }) })
    }
  );
}
function HM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.501",
      height: "19.993",
      viewBox: "0 0 28.501 19.993",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { transform: "translate(-1365.793 -6.208)", children: /* @__PURE__ */ u.jsxs("g", { transform: "translate(1366.044 6.458)", children: [
        /* @__PURE__ */ u.jsx("g", { transform: "translate(18.113 10.469)", children: /* @__PURE__ */ u.jsxs("g", { transform: "translate(0)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M1294.017,246.759c-.564-3.762-5.946-4.28-8.082-1.652-.107-.224-.213-.449-.315-.675a.607.607,0,0,0-.829-.217.62.62,0,0,0-.217.829c.248.553.517,1.1.788,1.637a.535.535,0,0,0,.274.268.7.7,0,0,0,.562.132,14.655,14.655,0,0,1,1.475-.16c.777-.046.781-1.259,0-1.212-.223.013-.446.033-.669.055,1.678-1.768,5.429-1.444,5.843,1.318C1292.963,247.853,1294.131,247.524,1294.017,246.759Z",
              transform: "translate(-1284.501 -243.468)",
              fill: "#00a0ff"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M1293.339,247.771h0a.725.725,0,0,1-.739-.653,2.694,2.694,0,0,0-2.869-2.2,3.741,3.741,0,0,0-1.955.541.772.772,0,0,1,.731.791.872.872,0,0,1-.819.921,14.307,14.307,0,0,0-1.45.157,1.1,1.1,0,0,1-.177.014.92.92,0,0,1-.556-.178.794.794,0,0,1-.367-.372c-.277-.553-.545-1.095-.792-1.646a.849.849,0,0,1,.755-1.261.793.793,0,0,1,.748.444c.047.1.1.212.152.331a5.2,5.2,0,0,1,3.695-1.443,4.326,4.326,0,0,1,4.569,3.5.879.879,0,0,1-.2.715A.966.966,0,0,1,1293.339,247.771Zm-3.608-3.354a3.764,3.764,0,0,1,2.158.64,2.893,2.893,0,0,1,1.205,1.986.229.229,0,0,0,.245.227.473.473,0,0,0,.343-.161.377.377,0,0,0,.087-.315,3.843,3.843,0,0,0-4.075-3.078,4.585,4.585,0,0,0-3.566,1.547l-.249.306-.171-.356c-.128-.266-.229-.482-.318-.681a.314.314,0,0,0-.292-.149.369.369,0,0,0-.183.045.389.389,0,0,0-.116.511c.243.542.509,1.079.784,1.627a.29.29,0,0,0,.147.149l.035.015.029.024a.456.456,0,0,0,.361.077,14.8,14.8,0,0,1,1.5-.163.37.37,0,0,0,.349-.406.287.287,0,0,0-.291-.308h-.029c-.2.012-.412.03-.658.055l-.671.068.464-.489A4.053,4.053,0,0,1,1289.731,244.418Z",
              transform: "translate(-1284.501 -243.468)",
              fill: "#00a0ff"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M1300.009,347.246c.108.224.213.449.315.675a.608.608,0,0,0,.829.217.62.62,0,0,0,.218-.829c-.248-.553-.517-1.095-.788-1.637a.538.538,0,0,0-.275-.268.7.7,0,0,0-.562-.132,14.646,14.646,0,0,1-1.476.16c-.777.047-.781,1.259,0,1.212.224-.013.446-.033.669-.055-1.678,1.768-5.43,1.443-5.844-1.318-.116-.771-1.284-.442-1.169.322C1292.492,349.356,1297.873,349.874,1300.009,347.246Z",
              transform: "translate(-1291.556 -339.861)",
              fill: "#00a0ff"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M1296.25,349.136h0a4.326,4.326,0,0,1-4.569-3.5.879.879,0,0,1,.2-.715.966.966,0,0,1,.722-.334.725.725,0,0,1,.739.653,2.694,2.694,0,0,0,2.869,2.2,3.742,3.742,0,0,0,1.955-.541.772.772,0,0,1-.731-.791.872.872,0,0,1,.819-.921,14.3,14.3,0,0,0,1.451-.157.965.965,0,0,1,.733.163.8.8,0,0,1,.367.371c.289.578.548,1.1.793,1.646a.849.849,0,0,1-.755,1.261.793.793,0,0,1-.748-.444c-.048-.106-.1-.215-.152-.331A5.2,5.2,0,0,1,1296.25,349.136Zm-3.645-4.053a.473.473,0,0,0-.343.161.376.376,0,0,0-.087.314,3.843,3.843,0,0,0,4.074,3.078h0a4.585,4.585,0,0,0,3.565-1.547l.249-.306.171.355c.124.258.225.474.318.681a.314.314,0,0,0,.292.149.369.369,0,0,0,.183-.045.39.39,0,0,0,.116-.512c-.241-.537-.5-1.055-.783-1.627a.292.292,0,0,0-.147-.149l-.035-.015-.029-.024a.457.457,0,0,0-.361-.077,14.791,14.791,0,0,1-1.5.163.371.371,0,0,0-.349.407.287.287,0,0,0,.291.308h.029c.2-.012.408-.029.659-.055l.67-.068-.464.488a4.053,4.053,0,0,1-2.908,1.173,3.764,3.764,0,0,1-2.158-.64,2.893,2.893,0,0,1-1.206-1.986A.229.229,0,0,0,1292.6,345.082Z",
              transform: "translate(-1291.556 -339.861)",
              fill: "#00a0ff"
            }
          )
        ] }) }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1331.552,30h-7.443a6.109,6.109,0,0,0,7.443,7.085Z",
            transform: "translate(-1303.95 -30)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1323.9,29.75h7.9v7.532l-.191.046a6.359,6.359,0,0,1-7.748-7.375Zm7.4.5h-6.983a5.859,5.859,0,0,0,6.983,6.635Z",
            transform: "translate(-1303.95 -30)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M877,255.148h7.443A6.109,6.109,0,0,0,877,248.063Z",
            transform: "translate(-877 -237.205)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M884.65,255.4h-7.9v-7.532l.191-.046a6.359,6.359,0,0,1,7.748,7.375Zm-7.4-.5h6.983a5.859,5.859,0,0,0-6.983-6.635Z",
            transform: "translate(-877 -237.205)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx("circle", { cx: "3.85", cy: "3.85", r: "3.85", transform: "translate(9.968 5.122)", fill: "#00a0ff" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M3.85-.25a4.1,4.1,0,1,1-4.1,4.1A4.1,4.1,0,0,1,3.85-.25Zm0,7.7a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,3.85,7.449Z",
            transform: "translate(9.968 5.122)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M894.711,46.276H878.562V31.667h24.479v7.56a6.318,6.318,0,0,1,1.562.707V30H877V47.943h17.963A7.44,7.44,0,0,1,894.711,46.276Z",
            transform: "translate(-877 -30)",
            fill: "#00a0ff"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M895.289,48.193H876.75V29.75h28.1V40.386l-.383-.24a6.071,6.071,0,0,0-1.5-.679l-.179-.053v-7.5H878.812V46.026h16.14l.009.241a7.2,7.2,0,0,0,.244,1.611Zm-18.039-.5h17.393a7.718,7.718,0,0,1-.17-1.167H878.312V31.417h24.979v7.626a6.551,6.551,0,0,1,1.062.456V30.25h-27.1Z",
            transform: "translate(-877 -30)",
            fill: "#00a0ff"
          }
        )
      ] }) })
    }
  );
}
function FM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "28.16",
      height: "18.511",
      viewBox: "0 0 28.16 18.511",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { transform: "translate(-1365.792 -6.141)", children: /* @__PURE__ */ u.jsxs("g", { transform: "translate(1366.044 6.458)", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1331.552,30h-7.443a6.109,6.109,0,0,0,7.443,7.085Z",
            transform: "translate(-1303.95 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1323.9,29.75h7.9v7.532l-.191.046a6.359,6.359,0,0,1-7.748-7.375Zm7.4.5h-6.983a5.859,5.859,0,0,0,6.983,6.635Z",
            transform: "translate(-1303.95 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M877,255.148h7.443A6.109,6.109,0,0,0,877,248.063Z",
            transform: "translate(-877 -237.205)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M884.65,255.4h-7.9v-7.532l.191-.046a6.359,6.359,0,0,1,7.748,7.375Zm-7.4-.5h6.983a5.859,5.859,0,0,0-6.983-6.635Z",
            transform: "translate(-877 -237.205)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx("circle", { cx: "3.85", cy: "3.85", r: "3.85", transform: "translate(9.968 5.122)", fill: "#35e190" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M3.85-.25a4.1,4.1,0,1,1-4.1,4.1A4.1,4.1,0,0,1,3.85-.25Zm0,7.7a3.6,3.6,0,1,0-3.6-3.6A3.6,3.6,0,0,0,3.85,7.449Z",
            transform: "translate(9.968 5.122)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M878.562,46.276V31.667h24.479c.2,2.75-.71,9.324,1.562-1.667H877l.076,17.575Z",
            transform: "translate(-877 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M876.828,48.123l-.079-18.373h28.16l-.062.3c-.467,2.258-.811,3.832-1.053,4.812-.118.477-.213.82-.29,1.047s-.163.479-.4.479a.274.274,0,0,1-.2-.084c-.149-.153-.154-.467-.113-2,.021-.794.045-1.684.012-2.386H878.812V46.389Zm.423-17.873.072,16.776.988-.864V31.417h24.962l.017.232c.054.754.027,1.77,0,2.667,0,.175-.01.361-.014.543.236-.946.575-2.486,1.016-4.609Z",
            transform: "translate(-877 -30)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M878.5,45.981V31.637h23.492A20.627,20.627,0,0,0,903.49,30H877V47.618Z",
            transform: "translate(904.602 47.943) rotate(180)",
            fill: "#35e190"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M876.75,48.261V29.75H903.8l-.06.3c-.016.078-.045.224-1.566,1.763l-.073.074H878.749V46.078Zm.5-18.011V46.974l1-1.091v-14.5h23.638c.4-.405.814-.84,1.083-1.137Z",
            transform: "translate(904.602 47.943) rotate(180)",
            fill: "#35e190"
          }
        )
      ] }) })
    }
  );
}
function GM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "26",
      height: "18",
      viewBox: "0 0 26 18",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.69935 12.4767H0.977051V5.5008H5.69935L12.7833 0V17.9775L5.69935 12.4767ZM20.0553 10.3608L16.2753 14.1408L15.2142 13.0806C15.0648 12.9429 15.0648 12.7062 15.2142 12.5568L18.7206 9.0252L15.2025 5.5071C15.0522 5.3703 15.0522 5.1327 15.2025 4.9833L16.2627 3.9222L20.0553 7.7157L23.8362 3.9348L24.8964 4.9959C25.0458 5.1327 25.0458 5.3703 24.8964 5.5197L21.3783 9.0378L24.8964 12.5568C25.0458 12.7062 25.0458 12.9429 24.909 13.0932L23.8488 14.1534L20.0553 10.3608Z"
        }
      )
    }
  );
}
function VM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Layer_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 512 512",
      width: "512",
      height: "512",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx("path", { d: "M347,182c-90.981,0-165,74.019-165,165s74.019,165,165,165s165-74.019,165-165S437.981,182,347,182z M347,332   c24.814,0,45,20.186,45,45c0,19.53-12.578,36.024-30,42.237V452h-30v-32.763c-17.422-6.213-30-22.707-30-42.237h30   c0,8.276,6.724,15,15,15s15-6.724,15-15s-6.724-15-15-15c-24.814,0-45-20.186-45-45c0-19.53,12.578-36.024,30-42.237V242h30v32.763   c17.422,6.213,30,22.707,30,42.237h-30c0-8.276-6.724-15-15-15s-15,6.724-15,15S338.724,332,347,332z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M167,182c92.52,0,165-39.536,165-90S259.52,0,167,0S0,41.536,0,92S74.48,182,167,182z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M0,337.559V362c0,50.464,74.48,90,167,90c5.248,0,10.333-0.483,15.5-0.736c-11.506-18.091-20.087-38.165-25.14-59.625   C90.455,389.792,32.362,369.233,0,337.559z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M152.721,361.236C152.377,356.518,152,351.805,152,347c0-15.637,2.049-30.771,5.543-45.353   C90.555,299.832,32.391,279.262,0,247.559V272C0,319.787,67.262,357.342,152.721,361.236z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M167,272c0.016,0,0.029-0.002,0.046-0.002c9.893-23.644,24.274-44.958,42.133-62.816C195.632,210.894,181.632,212,167,212   c-71.217,0-133.074-21.237-167-54.441V182C0,232.464,74.48,272,167,272z" })
      ] })
    }
  );
}
function KM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "40",
      height: "44",
      viewBox: "0 0 40 44",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.7534 10.8353C28.7534 16.3019 24.3217 20.7339 18.8548 20.7339C13.3885 20.7339 8.95703 16.3022 8.95703 10.8353C8.95703 5.36877 13.3888 0.9375 18.8548 0.9375C24.3214 0.9375 28.7534 5.36892 28.7534 10.8353Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.0426 43.63H0.90625C0.90625 33.7153 8.94069 25.6816 18.8546 25.6816C21.994 25.6816 24.9453 26.4901 27.5123 27.9106C24.8301 29.5717 23.0448 32.5395 23.0448 35.9266C23.0448 39.1103 24.6238 41.9262 27.0422 43.6302L27.0426 43.63Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.4844 28.9473H34.4601V42.9371H30.4844V28.9473Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.4688 33.9492H39.4586V37.925H25.4688V33.9492Z"
          }
        )
      ]
    }
  );
}
function zM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M22.5747 19.6343C22.5747 19.7121 22.5747 19.7898 22.5747 19.8676C22.5747 21.1663 22.576 22.4644 22.5747 23.7631C22.5727 25.6276 21.2113 26.9962 19.3449 26.9976C14.9763 27.0008 10.6078 27.0008 6.23926 26.9976C4.62302 26.9962 3.35826 25.9758 3.05513 24.4308C3.01463 24.2243 3.00287 24.0088 3.00287 23.7977C3.00026 17.9338 2.9983 12.0699 3.00222 6.20602C3.00352 4.63748 4.00501 3.38447 5.50104 3.06828C5.72251 3.0219 5.95377 3.00295 6.18111 3.00295C10.615 2.99969 15.0488 2.99969 19.4827 3.00034C21.2864 3.00034 22.6662 4.37355 22.674 6.17271C22.6766 6.81815 22.6707 7.46295 22.6773 8.1084C22.6786 8.25539 22.6466 8.33705 22.4996 8.40434C21.9613 8.65193 21.4909 9.00079 21.0715 9.4215C19.5206 10.977 17.9795 12.5429 16.4077 14.0775C15.4558 15.0071 14.7934 16.0694 14.5589 17.3942C14.4341 18.0998 14.2165 18.7903 14.1042 19.4972C13.8697 20.9716 15.0567 22.3475 16.539 22.2174C17.7998 22.107 19.0666 21.9111 20.2399 21.3662C20.9591 21.0324 21.5961 20.5855 22.135 20.0021C22.2598 19.8669 22.3866 19.7336 22.512 19.5997C22.5329 19.6115 22.5532 19.6232 22.5741 19.635L22.5747 19.6343ZM12.7035 8.52585C14.3034 8.52585 15.9033 8.52715 17.5032 8.52519C18.0337 8.52454 18.3904 8.2776 18.5119 7.83989C18.7151 7.10821 18.2754 6.52025 17.5157 6.51895C15.2873 6.51633 13.0589 6.51829 10.8306 6.51829C9.86761 6.51829 8.90402 6.51372 7.94107 6.52025C7.31261 6.52417 6.82983 7.11475 6.93697 7.72949C7.02451 8.23187 7.3897 8.52323 7.95283 8.52454C9.5364 8.52781 11.12 8.52585 12.7035 8.52585ZM10.7469 10.6334C9.84083 10.6334 8.93472 10.6327 8.02861 10.6347C7.91494 10.6347 7.798 10.6366 7.6889 10.6628C7.19044 10.783 6.86641 11.2403 6.91867 11.7368C6.97682 12.2868 7.33025 12.6291 7.89207 12.6376C8.71652 12.6507 9.54097 12.6422 10.3654 12.6422C11.41 12.6422 12.4553 12.6448 13.4999 12.6409C14.0173 12.6389 14.3675 12.3946 14.4935 11.9674C14.7078 11.2403 14.2701 10.6392 13.5136 10.6347C12.5912 10.6288 11.6687 10.6334 10.7463 10.6327L10.7469 10.6334Z",
            fill: "#142D63"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M23.9767 10.2354C24.8528 10.236 25.6008 10.7025 25.913 11.4825C26.2482 12.3207 26.1103 13.0987 25.4753 13.7416C23.8291 15.4087 22.1756 17.0701 20.5025 18.7105C20.0171 19.1867 19.4279 19.5258 18.7406 19.6695C18.0148 19.821 17.2936 19.9974 16.5697 20.1601C16.2117 20.2405 15.9739 20.0072 16.0549 19.6499C16.2385 18.8392 16.4247 18.0284 16.6194 17.2203C16.735 16.7408 16.9859 16.3292 17.3308 15.983C19.047 14.2583 20.7658 12.5356 22.4898 10.8187C22.8962 10.4144 23.4044 10.2341 23.9767 10.2354Z",
            fill: "#142D63"
          }
        )
      ]
    }
  );
}
function UM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsxs(
          "linearGradient",
          {
            id: "linear-gradient",
            x1: "0.5",
            x2: "0.5",
            y2: "1",
            gradientUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ u.jsx("stop", { offset: "0", stopColor: "#b5f292" }),
              /* @__PURE__ */ u.jsx("stop", { offset: "0.962", stopColor: "#a6de85" }),
              /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#ace68a" })
            ]
          }
        ) }),
        /* @__PURE__ */ u.jsxs("g", { id: "Groupe_3467", "data-name": "Groupe 3467", transform: "translate(-491.43 -1137.43)", children: [
          /* @__PURE__ */ u.jsx(
            "circle",
            {
              id: "Ellipse_3010",
              "data-name": "Ellipse 3010",
              cx: "9",
              cy: "9",
              r: "9",
              transform: "translate(491.43 1137.43)",
              fill: "#ace68a"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Icon_awesome-bell",
              "data-name": "Icon awesome-bell",
              d: "M3.624,8.284A1.035,1.035,0,0,0,4.659,7.248H2.589A1.035,1.035,0,0,0,3.624,8.284ZM7.109,5.862a3.01,3.01,0,0,1-.9-2.5A2.555,2.555,0,0,0,4.142.855V.518a.517.517,0,1,0-1.035,0V.855a2.555,2.555,0,0,0-2.07,2.51,3.01,3.01,0,0,1-.9,2.5A.506.506,0,0,0,0,6.213a.518.518,0,0,0,.519.518h6.21a.518.518,0,0,0,.519-.518.505.505,0,0,0-.139-.351Z",
              transform: "translate(496.879 1142.288)",
              fill: "#fff"
            }
          )
        ] })
      ]
    }
  );
}
function ZM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 14 15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.7517 12.6416H1.46897V2.35886H6.61035V0.889893H1.46897C0.65369 0.889893 0 1.55093 0 2.35886V12.6416C0 13.4496 0.65369 14.1106 1.46897 14.1106H11.7517C12.5597 14.1106 13.2207 13.4496 13.2207 12.6416V7.50025H11.7517V12.6416ZM8.07932 0.889893V2.35886H10.7161L3.49615 9.57883L4.53177 10.6145L11.7517 3.39448V6.03128H13.2207V0.889903L8.07932 0.889893Z"
        }
      )
    }
  );
}
function YM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "24",
      height: "23",
      viewBox: "0 0 24 23",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#00A0FF",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M23.375 8.56255C23.375 8.4382 23.3464 8.31551 23.2914 8.20394C23.2365 8.09238 23.1567 7.99491 23.0581 7.91905L13.4861 0.556178C13.06 0.228463 12.5375 0.0507812 12 0.0507812C11.4625 0.0507812 10.94 0.228463 10.5139 0.556178L0.941875 7.91905C0.843334 7.99491 0.76352 8.09238 0.708582 8.20394C0.653645 8.31551 0.62505 8.4382 0.625 8.56255V19.9376C0.630307 20.5824 0.888819 21.1993 1.34479 21.6553C1.80077 22.1112 2.41768 22.3697 3.0625 22.3751H20.9375C21.5363 22.3798 22.1144 22.1564 22.5544 21.7502L22.5625 21.7405L22.5747 21.7316C22.5796 21.7267 22.5804 21.721 22.5853 21.7161C22.8334 21.4909 23.0318 21.2164 23.1678 20.9102C23.3038 20.6039 23.3743 20.2726 23.375 19.9376V8.56255ZM21.75 19.9091L15.4458 15.0626L21.75 10.2127V19.9091ZM12.4948 1.84318L21.23 8.56255L14.1125 14.0372L13.4861 13.5562C13.06 13.2285 12.5375 13.0508 12 13.0508C11.4625 13.0508 10.94 13.2285 10.5139 13.5562L9.8875 14.0372L2.77 8.56255L11.5044 1.84318C11.6464 1.73401 11.8205 1.67482 11.9996 1.67482C12.1787 1.67482 12.3528 1.73401 12.4948 1.84318ZM8.55419 15.0626L2.25 19.9091V10.2127L8.55419 15.0626ZM3.82219 20.7501L11.5044 14.8432C11.6464 14.734 11.8205 14.6748 11.9996 14.6748C12.1787 14.6748 12.3528 14.734 12.4948 14.8432L20.1778 20.7501H3.82219Z" })
    }
  );
}
function WM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "512",
      height: "512",
      fill: "#CBD5E1",
      x: "0",
      y: "0",
      viewBox: "0 0 511.626 511.626",
      ...e,
      children: /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M505.918 236.117c-26.651-43.587-62.485-78.609-107.497-105.065-45.015-26.457-92.549-39.687-142.608-39.687s-97.595 13.225-142.61 39.687C68.187 157.508 32.355 192.53 5.708 236.117 1.903 242.778 0 249.345 0 255.818c0 6.473 1.903 13.04 5.708 19.699 26.647 43.589 62.479 78.614 107.495 105.064 45.015 26.46 92.551 39.68 142.61 39.68 50.06 0 97.594-13.176 142.608-39.536 45.012-26.361 80.852-61.432 107.497-105.208 3.806-6.659 5.708-13.223 5.708-19.699 0-6.473-1.902-13.04-5.708-19.701zm-311.35-78.087c17.034-17.034 37.447-25.554 61.242-25.554 3.805 0 7.043 1.336 9.709 3.999 2.662 2.664 4 5.901 4 9.707 0 3.809-1.338 7.044-3.994 9.704-2.662 2.667-5.902 3.999-9.708 3.999-16.368 0-30.362 5.808-41.971 17.416-11.613 11.615-17.416 25.603-17.416 41.971 0 3.811-1.336 7.044-3.999 9.71-2.667 2.668-5.901 3.999-9.707 3.999-3.809 0-7.044-1.334-9.71-3.999-2.667-2.666-3.999-5.903-3.999-9.71 0-23.79 8.52-44.207 25.553-61.242zm185.299 191.01c-38.164 23.12-79.514 34.687-124.054 34.687-44.539 0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222c28.931-44.921 65.19-78.518 108.777-100.783-11.61 19.792-17.417 41.207-17.417 64.236 0 35.216 12.517 65.329 37.544 90.362s55.151 37.544 90.362 37.544c35.214 0 65.329-12.518 90.362-37.544s37.545-55.146 37.545-90.362c0-23.029-5.808-44.447-17.419-64.236 43.585 22.265 79.846 55.865 108.776 100.783-25.31 39.022-57.046 70.095-95.21 93.222z",
          "data-original": "#000000"
        }
      ) })
    }
  );
}
function uh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "18",
      height: "21",
      viewBox: "0 0 18 21",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.67824 19.4354L9.29538 15.5267L9.3387 15.3101C9.37119 15.1261 9.46863 14.9528 9.6094 14.8229C9.75013 14.7038 9.94504 14.628 10.1291 14.628H10.6163C11.4284 14.628 12.1863 14.5414 12.8468 14.3682C13.5506 14.1841 14.1786 13.9026 14.7199 13.5236C15.283 13.123 15.7594 12.6033 16.1275 11.9753C16.5173 11.3148 16.8096 10.5244 16.9829 9.62575C17.1345 8.82452 17.167 8.10991 17.0695 7.50357C16.9612 6.85392 16.7122 6.31255 16.3333 5.86862C16.095 5.59794 15.8027 5.37056 15.4454 5.17567H15.4346V5.16485C15.5645 4.36362 15.5537 3.70314 15.4237 3.12928C15.2938 2.55543 15.0123 2.03572 14.59 1.54847C13.7022 0.54152 12.0889 0.0218048 9.8043 0.0218048H3.51355C3.30784 0.0218048 3.10211 0.0975972 2.9397 0.23835C2.7773 0.379114 2.66902 0.563184 2.63654 0.768897L0.00546765 17.3998C-0.016197 17.5514 0.0271323 17.703 0.124567 17.8221C0.222013 17.9412 0.373609 18.0062 0.525194 18.0062H4.43389V18.0278L4.1632 19.7278C4.14154 19.8577 4.18486 19.9984 4.27149 20.0959C4.35809 20.1933 4.48802 20.2583 4.61796 20.2583H7.89866C8.08273 20.2583 8.25597 20.1933 8.39673 20.0742C8.53748 19.9551 8.62411 19.7927 8.65659 19.6087L8.67825 19.4354"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.4549 5.16492C15.4333 5.28402 15.4116 5.40313 15.3899 5.53305C14.5562 9.79905 11.7194 11.2716 8.09223 11.2716H6.24074C5.79683 11.2716 5.42869 11.5964 5.35291 12.0295L4.14023 19.7278C4.09691 20.0093 4.31346 20.2692 4.60582 20.2692H7.88651C8.27631 20.2692 8.60113 19.9877 8.66609 19.6087L8.69858 19.4463L9.31576 15.5376L9.35907 15.3211C9.42403 14.9421 9.74884 14.6606 10.1386 14.6606H10.6259C13.7983 14.6606 16.2886 13.3721 17.0141 9.64748C17.3172 8.08833 17.1656 6.78904 16.3536 5.87953C16.1046 5.57636 15.8014 5.34899 15.4549 5.16493"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5792 4.81794C14.4492 4.78546 14.3193 4.75298 14.1894 4.7205C14.0595 4.68801 13.9187 4.66636 13.7779 4.6447C13.2799 4.56891 12.7385 4.5256 12.1538 4.5256H7.21651C7.0974 4.5256 6.9783 4.55809 6.88086 4.6014C6.65348 4.70967 6.48024 4.92622 6.44776 5.18607L5.3975 11.8341L5.36501 12.029C5.42997 11.5959 5.80894 11.2711 6.25286 11.2711H8.10436C11.7316 11.2711 14.5683 9.79856 15.402 5.53255C15.4237 5.40262 15.4454 5.28352 15.467 5.16442C15.2613 5.05614 15.0339 4.95869 14.7849 4.87208C14.7091 4.85043 14.6441 4.8396 14.5792 4.81794",
            fill: "#B3BCC7",
            className: "group-aria-checked:ui-fill-blue-300 group-aria-checked:ui-transition-colors group-aria-checked:ui-easy-out group-aria-checked:ui-duration-75"
          }
        )
      ]
    }
  );
}
function $M(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "124",
      height: "31",
      viewBox: "0 0 124 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M46.2113 6.75H39.3723C38.9043 6.75 38.5063 7.09 38.4333 7.552L35.6673 25.089C35.6123 25.435 35.8803 25.747 36.2313 25.747H39.4963C39.9643 25.747 40.3623 25.407 40.4353 24.944L41.1813 20.214C41.2533 19.751 41.6523 19.411 42.1193 19.411H44.2843C48.7893 19.411 51.3893 17.231 52.0683 12.911C52.3743 11.021 52.0813 9.536 51.1963 8.496C50.2243 7.354 48.5003 6.75 46.2113 6.75ZM47.0002 13.1569C46.6263 15.6109 44.7513 15.6109 42.9383 15.6109H41.9062L42.6302 11.0279C42.6733 10.7509 42.9132 10.5469 43.1933 10.5469H43.6663C44.9012 10.5469 46.0662 10.5469 46.6683 11.2509C47.0273 11.6709 47.1373 12.2949 47.0002 13.1569Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.654 13.0736H63.379C63.1 13.0736 62.859 13.2776 62.816 13.5546L62.671 14.4706L62.442 14.1386C61.733 13.1096 60.152 12.7656 58.574 12.7656C54.955 12.7656 51.864 15.5066 51.262 19.3516C50.949 21.2696 51.394 23.1036 52.482 24.3826C53.48 25.5586 54.908 26.0486 56.607 26.0486C59.523 26.0486 61.14 24.1736 61.14 24.1736L60.994 25.0836C60.939 25.4316 61.207 25.7436 61.556 25.7436H64.506C64.975 25.7436 65.371 25.4036 65.445 24.9406L67.215 13.7316C67.271 13.3866 67.004 13.0736 66.654 13.0736ZM62.09 19.4473C61.774 21.3183 60.289 22.5743 58.395 22.5743C57.444 22.5743 56.684 22.2693 56.196 21.6913C55.712 21.1173 55.528 20.3003 55.682 19.3903C55.977 17.5353 57.487 16.2383 59.352 16.2383C60.282 16.2383 61.038 16.5473 61.536 17.1303C62.035 17.7193 62.233 18.5413 62.09 19.4473Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M84.0946 13.0742H80.8036C80.4896 13.0742 80.1946 13.2302 80.0166 13.4912L75.4776 20.1772L73.5536 13.7522C73.4326 13.3502 73.0616 13.0742 72.6416 13.0742H69.4076C69.0146 13.0742 68.7416 13.4582 68.8666 13.8282L72.4916 24.4662L69.0836 29.2772C68.8156 29.6562 69.0856 30.1772 69.5486 30.1772H72.8356C73.1476 30.1772 73.4396 30.0252 73.6166 29.7692L84.5626 13.9692C84.8246 13.5912 84.5556 13.0742 84.0946 13.0742L84.0946 13.0742Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M94.9926 6.75H88.1526C87.6856 6.75 87.2876 7.09 87.2146 7.552L84.4486 25.089C84.3936 25.435 84.6616 25.747 85.0106 25.747H88.5206C88.8466 25.747 89.1256 25.509 89.1766 25.185L89.9616 20.214C90.0336 19.751 90.4326 19.411 90.8996 19.411H93.0636C97.5696 19.411 100.169 17.231 100.849 12.911C101.156 11.021 100.861 9.536 99.9756 8.496C99.0046 7.354 97.2816 6.75 94.9926 6.75H94.9926ZM95.7805 13.1569C95.4075 15.6109 93.5325 15.6109 91.7185 15.6109H90.6875L91.4125 11.0279C91.4555 10.7509 91.6935 10.5469 91.9745 10.5469H92.4475C93.6815 10.5469 94.8475 10.5469 95.4495 11.2509C95.8085 11.6709 95.9175 12.2949 95.7805 13.1569Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.435 13.0736H112.162C111.881 13.0736 111.642 13.2776 111.6 13.5546L111.455 14.4706L111.225 14.1386C110.516 13.1096 108.936 12.7656 107.358 12.7656C103.739 12.7656 100.649 15.5066 100.047 19.3516C99.7349 21.2696 100.178 23.1036 101.266 24.3826C102.266 25.5586 103.692 26.0486 105.391 26.0486C108.307 26.0486 109.924 24.1736 109.924 24.1736L109.778 25.0836C109.723 25.4316 109.991 25.7436 110.342 25.7436H113.291C113.758 25.7436 114.156 25.4036 114.229 24.9406L116 13.7316C116.054 13.3866 115.786 13.0736 115.435 13.0736H115.435ZM110.87 19.4473C110.556 21.3183 109.069 22.5743 107.175 22.5743C106.226 22.5743 105.464 22.2693 104.976 21.6913C104.492 21.1173 104.31 20.3003 104.462 19.3903C104.759 17.5353 106.267 16.2383 108.132 16.2383C109.062 16.2383 109.818 16.5473 110.316 17.1303C110.817 17.7193 111.015 18.5413 110.87 19.4473Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M119.295 7.232L116.488 25.09C116.433 25.436 116.701 25.748 117.05 25.748H119.872C120.341 25.748 120.739 25.408 120.811 24.945L123.579 7.409C123.634 7.063 123.366 6.75 123.017 6.75H119.857C119.578 6.751 119.338 6.955 119.295 7.232Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.2675 29.1534L7.7905 25.8314L6.6255 25.8044H1.0625L4.9285 1.29144C4.9405 1.21744 4.9795 1.14844 5.0365 1.09944C5.0935 1.05044 5.1665 1.02344 5.2425 1.02344H14.6225C17.7365 1.02344 19.8855 1.67144 21.0075 2.95044C21.5335 3.55044 21.8685 4.17744 22.0305 4.86744C22.2005 5.59144 22.2035 6.45644 22.0375 7.51144L22.0255 7.58844V8.26444L22.5515 8.56244C22.9945 8.79744 23.3465 9.06644 23.6165 9.37444C24.0665 9.88744 24.3575 10.5394 24.4805 11.3124C24.6075 12.1074 24.5655 13.0534 24.3575 14.1244C24.1175 15.3564 23.7295 16.4294 23.2055 17.3074C22.7235 18.1164 22.1095 18.7874 21.3805 19.3074C20.6845 19.8014 19.8575 20.1764 18.9225 20.4164C18.0165 20.6524 16.9835 20.7714 15.8505 20.7714H15.1205C14.5985 20.7714 14.0915 20.9594 13.6935 21.2964C13.2945 21.6404 13.0305 22.1104 12.9495 22.6244L12.8945 22.9234L11.9705 28.7784L11.9285 28.9934C11.9175 29.0614 11.8985 29.0954 11.8705 29.1184C11.8455 29.1394 11.8095 29.1534 11.7745 29.1534H7.2675Z",
            fill: "#253B80"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M12.0772 16.763C17.4822 16.763 21.7142 14.569 22.9512 8.21797L23.0472 7.66797C23.5722 7.94597 24.0212 8.28697 24.3832 8.69797C25.5792 10.061 25.8132 11.999 25.3612 14.32C24.2792 19.876 20.5772 21.796 15.8482 21.796H15.1182C14.5402 21.796 14.0482 22.216 13.9582 22.788L13.8992 23.108L12.9802 28.94L12.9322 29.188C12.8412 29.758 12.3502 30.178 11.7722 30.178H6.89117C6.45917 30.178 6.12917 29.792 6.19617 29.364L6.59517 26.831L8.00417 17.895C8.10717 17.243 8.66417 16.763 9.32517 16.763H12.0772Z",
            fill: "#179BD7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7529 7.15103C21.5639 7.09603 21.3689 7.04603 21.1689 7.00103C20.9679 6.95703 20.7619 6.91803 20.5499 6.88403C19.8079 6.76403 18.9949 6.70703 18.1239 6.70703H10.7719C10.5909 6.70703 10.4189 6.74803 10.2649 6.82203C9.92591 6.98503 9.67391 7.30603 9.61291 7.69903L8.04891 17.605L8.00391 17.894C8.10691 17.242 8.66391 16.762 9.32491 16.762H12.0769C17.4819 16.762 21.7139 14.567 22.9509 8.21703C22.9879 8.02903 23.0189 7.84603 23.0469 7.66703C22.7339 7.50103 22.3949 7.35903 22.0299 7.23803C21.9399 7.20803 21.8469 7.17903 21.7529 7.15103Z",
            fill: "#222D65"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.61399 7.699C9.67499 7.306 9.92699 6.985 10.266 6.823C10.421 6.749 10.592 6.708 10.773 6.708H18.125C18.996 6.708 19.809 6.765 20.551 6.885C20.763 6.919 20.969 6.958 21.17 7.002C21.37 7.047 21.565 7.097 21.754 7.152C21.848 7.18 21.941 7.209 22.032 7.238C22.397 7.359 22.736 7.502 23.049 7.667C23.417 5.32 23.046 3.722 21.777 2.275C20.378 0.682 17.853 0 14.622 0H5.24199C4.58199 0 4.01899 0.48 3.91699 1.133L0.00998882 25.898C-0.0670112 26.388 0.310989 26.83 0.804989 26.83H6.59599L8.04999 17.605L9.61399 7.699Z",
            fill: "#253B80"
          }
        )
      ]
    }
  );
}
function ch(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 50 50",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M44.5947 49.5015H3.30047C1.91372 49.5015 0.732422 48.3202 0.732422 46.8821L0.732422 42.2082C0.732422 40.7701 1.91372 39.5888 3.30047 39.5888H44.5947C46.0328 39.5888 47.1628 40.7701 47.2141 42.2082V46.8307C47.2141 48.3202 46.0328 49.5015 44.5947 49.5015ZM44.5947 23.5642L3.30047 23.5642C2.63278 23.5642 1.96509 23.3074 1.50284 22.7937C0.989227 22.2801 0.732422 21.6638 0.732422 20.9448L0.732422 16.2709C0.732422 14.8328 1.91372 13.6515 3.30047 13.6515H44.5947C46.0328 13.6515 47.1628 14.7814 47.2141 16.2709V20.9448C47.1628 22.4342 46.0328 23.5642 44.5947 23.5642ZM26.567 10.6212H3.30047C2.63278 10.6212 1.96509 10.3644 1.50284 9.85078C1.04059 9.33717 0.732422 8.72084 0.732422 8.00178L0.732422 3.32793C0.732422 1.88982 1.91372 0.708518 3.30047 0.708518H26.5156C27.9537 0.708518 29.0837 1.88982 29.0837 3.27657V7.95042C29.135 9.49125 28.0051 10.6726 26.567 10.6212ZM47.2141 36.5585H3.30047C2.63278 36.5585 1.96509 36.3017 1.50284 35.7881C1.04059 35.2745 0.732422 34.6581 0.732422 33.9391L0.732422 29.2652C0.732422 27.8271 1.91372 26.6458 3.30047 26.6458L47.1628 26.6458C48.6009 26.6458 49.7308 27.8271 49.7308 29.2652V33.9391C49.7822 35.3772 48.6009 36.5071 47.2141 36.5585Z" })
    }
  );
}
function JM(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "169",
      height: "30",
      viewBox: "0 0 169 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#clip0_210_22)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M24.1964 2.85986H1.65431C0.897301 2.85986 0.252441 3.50472 0.252441 4.28976V6.84117C0.252441 7.62621 0.897301 8.27107 1.65431 8.27107H24.1964C24.9814 8.27107 25.5982 7.62621 25.6263 6.84117V4.3178C25.6263 3.50472 24.9814 2.85986 24.1964 2.85986ZM24.1964 17.0187H1.65431C1.28982 17.0187 0.925339 17.1589 0.673002 17.4393C0.392628 17.7197 0.252441 18.0561 0.252441 18.4486V21C0.252441 21.7851 0.897301 22.43 1.65431 22.43H24.1964C24.9814 22.43 25.5982 21.8131 25.6263 21V18.4486C25.5982 17.6356 24.9814 17.0187 24.1964 17.0187ZM14.3552 24.0842H1.65431C1.28982 24.0842 0.925339 24.2243 0.673002 24.5047C0.420666 24.7851 0.252441 25.1215 0.252441 25.5141V28.0655C0.252441 28.8505 0.897301 29.4954 1.65431 29.4954H14.3272C15.1123 29.4954 15.7291 28.8505 15.7291 28.0935V25.5421C15.7571 24.701 15.1403 24.0842 14.3552 24.0842ZM25.6263 9.92528H1.65431C1.28982 9.92528 0.925339 10.0655 0.673002 10.3458C0.420666 10.6262 0.252441 10.9627 0.252441 11.3552V13.9066C0.252441 14.6916 0.897301 15.3365 1.65431 15.3365H25.5982C26.3833 15.3365 27.0001 14.6916 27.0001 13.9066V11.3552C27.0281 10.5982 26.3833 9.95332 25.6263 9.92528Z",
              fill: "#2DBDEF"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M51.8412 8.57948C51.1402 7.85051 50.3272 7.28976 49.4019 6.89724C48.4767 6.50471 47.4954 6.30845 46.486 6.30845C45.5047 6.28041 44.5515 6.50471 43.6543 6.92527C43.0655 7.20565 42.5328 7.59816 42.0842 8.0748V7.62621C42.0842 7.40191 42.0001 7.17761 41.8599 7.00938C41.7197 6.84116 41.4954 6.72901 41.243 6.72901H38.1309C37.9066 6.72901 37.6823 6.81312 37.5421 7.00938C37.3739 7.17761 37.2898 7.40191 37.3178 7.62621V28.5982C37.3178 28.8225 37.4019 29.0468 37.5421 29.215C37.7103 29.3832 37.9066 29.4673 38.1309 29.4673H41.3272C41.5515 29.4673 41.7477 29.3832 41.9159 29.215C42.0842 29.0748 42.1963 28.8505 42.1683 28.5982V21.4206C42.6169 21.9253 43.2057 22.2898 43.8505 22.5141C44.6916 22.8225 45.5608 22.9907 46.458 22.9907C47.4673 22.9907 48.4767 22.7944 49.4019 22.4019C50.3272 22.0094 51.1683 21.4486 51.8692 20.7197C52.5982 19.9627 53.1589 19.0655 53.5515 18.0841C54.0001 16.9907 54.1963 15.8131 54.1683 14.6356C54.1963 13.458 53.972 12.2804 53.5515 11.1589C53.1309 10.2337 52.5701 9.33649 51.8412 8.57948ZM48.9814 16.1776C48.8131 16.6262 48.5608 17.0187 48.2244 17.3832C47.5795 18.0841 46.6543 18.4767 45.701 18.4767C45.2244 18.4767 44.7477 18.3926 44.2991 18.1683C43.8786 17.972 43.486 17.7197 43.1496 17.3832C42.8131 17.0468 42.5608 16.6262 42.3926 16.1776C42.0281 15.2243 42.0281 14.187 42.3926 13.2337C42.5608 12.7851 42.8412 12.3926 43.1496 12.0561C43.486 11.7197 43.8786 11.4393 44.2991 11.243C44.7477 11.0468 45.2244 10.9346 45.701 10.9346C46.2057 10.9346 46.6543 11.0187 47.1309 11.243C47.5515 11.4393 47.944 11.6916 48.2524 12.0281C48.5888 12.3645 48.8131 12.757 49.0094 13.2056C49.3459 14.187 49.3178 15.2243 48.9814 16.1776ZM71.2991 6.75705H68.1309C67.9066 6.75705 67.6823 6.84116 67.5421 7.00938C67.3739 7.17761 67.2898 7.4019 67.2898 7.65424V8.04677C66.8973 7.57013 66.3926 7.20564 65.8599 6.9533C64.9907 6.53274 64.0374 6.33649 63.0842 6.33649C61.0374 6.33649 59.1029 7.14957 57.6449 8.57948C56.8879 9.33649 56.2991 10.2337 55.9066 11.215C55.458 12.3084 55.2337 13.486 55.2617 14.6916C55.2337 15.8692 55.458 17.0468 55.9066 18.1683C56.3272 19.1496 56.8879 20.0468 57.6449 20.8038C59.0748 22.2617 61.0374 23.0748 63.0561 23.0748C64.0094 23.1028 64.9627 22.8785 65.8318 22.458C66.3645 22.1776 66.8973 21.8131 67.2898 21.3645V21.7851C67.2898 22.0094 67.3739 22.2337 67.5421 22.4019C67.7103 22.5421 67.9066 22.6542 68.1309 22.6542H71.2991C71.5234 22.6542 71.7477 22.5701 71.8879 22.4019C72.0561 22.2337 72.1402 22.0094 72.1402 21.7851V7.68228C72.1402 7.45798 72.0561 7.23369 71.9159 7.06546C71.7477 6.8692 71.5234 6.75705 71.2991 6.75705ZM67.0094 16.1776C66.8412 16.6262 66.5888 17.0187 66.2524 17.3832C65.9159 17.7197 65.5515 18 65.1309 18.1963C64.2337 18.6169 63.1963 18.6169 62.2991 18.1963C61.8786 18 61.486 17.7197 61.1496 17.3832C60.8131 17.0468 60.5608 16.6262 60.3926 16.1776C60.0561 15.2243 60.0561 14.187 60.3926 13.2337C60.5608 12.7851 60.8131 12.4206 61.1496 12.0561C61.486 11.7197 61.8505 11.4393 62.2991 11.243C63.1963 10.8225 64.2337 10.8225 65.1029 11.243C65.5234 11.4393 65.9159 11.6916 66.2244 12.0281C66.5328 12.3645 66.7851 12.757 66.9814 13.2056C67.3739 14.187 67.3739 15.2243 67.0094 16.1776ZM102.869 14.2711C102.421 13.8785 101.888 13.5421 101.327 13.3178C100.738 13.0655 100.094 12.8972 99.4767 12.757L97.0655 12.2804C96.4487 12.1683 96.0001 12 95.7758 11.8038C95.5795 11.6636 95.4393 11.4393 95.4393 11.187C95.4393 10.9346 95.5795 10.7103 95.8879 10.5141C96.3085 10.2898 96.7571 10.1776 97.2337 10.2056C97.8505 10.2056 98.4674 10.3458 99.0281 10.5701C99.5888 10.8225 100.122 11.0748 100.626 11.4113C101.327 11.8599 101.944 11.7757 102.365 11.2711L103.514 9.95331C103.738 9.72901 103.851 9.44864 103.879 9.14023C103.851 8.80378 103.682 8.5234 103.43 8.2991C102.953 7.87854 102.168 7.42994 101.131 6.98134C100.094 6.53275 98.7758 6.30845 97.2337 6.30845C96.2804 6.28041 95.3552 6.4206 94.458 6.70097C93.701 6.95331 92.972 7.31779 92.3272 7.79443C91.7384 8.24302 91.2898 8.80377 90.9533 9.47667C90.6449 10.1215 90.4767 10.8225 90.4767 11.5234C90.4767 12.8412 90.8692 13.9066 91.6543 14.6916C92.4393 15.4767 93.4767 16.0094 94.7664 16.2617L97.2898 16.8225C97.8225 16.9066 98.3832 17.0748 98.8879 17.3271C99.1683 17.4393 99.3365 17.7197 99.3365 18.0281C99.3365 18.3084 99.1963 18.5608 98.8879 18.7851C98.5795 19.0094 98.0748 19.1496 97.4019 19.1496C96.729 19.1496 96.0281 19.0094 95.4113 18.701C94.8225 18.4206 94.2898 18.0561 93.7851 17.6355C93.5608 17.4673 93.3365 17.3271 93.0561 17.215C92.7758 17.1309 92.4113 17.215 92.0468 17.5234L90.673 18.5608C90.2804 18.8412 90.0842 19.3178 90.1963 19.7664C90.2804 20.243 90.6449 20.6916 91.3458 21.2243C93.0842 22.4019 95.1589 23.0187 97.2617 22.9627C98.243 22.9627 99.2244 22.8505 100.15 22.5701C100.963 22.3178 101.72 21.9533 102.393 21.4486C103.009 21 103.514 20.4112 103.851 19.7103C104.187 19.0374 104.355 18.3085 104.355 17.5514C104.383 16.8785 104.243 16.2056 103.963 15.5888C103.682 15.1402 103.318 14.6636 102.869 14.2711ZM116.72 18.1122C116.579 17.8599 116.327 17.6916 116.019 17.6355C115.738 17.6355 115.43 17.7197 115.206 17.8879C114.813 18.1402 114.365 18.2804 113.916 18.3084C113.776 18.3084 113.608 18.2804 113.467 18.2524C113.299 18.2243 113.159 18.1402 113.047 18.0281C112.907 17.8879 112.794 17.7197 112.71 17.5514C112.598 17.2711 112.542 16.9907 112.57 16.7103V10.9627H116.664C116.916 10.9627 117.14 10.8505 117.308 10.6823C117.477 10.5141 117.589 10.3178 117.589 10.0655V7.62621C117.589 7.37387 117.505 7.14957 117.308 7.00938C117.14 6.84116 116.916 6.75705 116.692 6.75705H112.57V2.83181C112.57 2.60752 112.486 2.35518 112.318 2.21499C112.15 2.0748 111.953 1.99069 111.729 1.96265H108.533C108.308 1.96265 108.084 2.04676 107.916 2.21499C107.748 2.38321 107.636 2.60752 107.636 2.83181V6.75705H105.813C105.589 6.75705 105.365 6.84116 105.196 7.03742C105.056 7.20565 104.972 7.42994 104.972 7.65424V10.0935C104.972 10.3178 105.056 10.5421 105.196 10.7103C105.337 10.9066 105.561 10.9907 105.813 10.9907H107.636V17.8318C107.608 18.6449 107.776 19.458 108.112 20.187C108.421 20.8038 108.813 21.3365 109.346 21.7851C109.851 22.2056 110.439 22.5141 111.084 22.6823C111.729 22.8785 112.402 22.9907 113.075 22.9907C113.944 22.9907 114.841 22.8505 115.682 22.5701C116.467 22.3178 117.168 21.8692 117.729 21.2804C118.094 20.9159 118.122 20.3271 117.841 19.9066L116.72 18.1122ZM134.047 6.75705H130.879C130.654 6.75705 130.458 6.84116 130.29 7.00938C130.122 7.17761 130.037 7.4019 130.037 7.65424V8.04677C129.645 7.57013 129.168 7.20564 128.608 6.9533C127.738 6.53274 126.785 6.33649 125.832 6.33649C123.785 6.33649 121.851 7.14957 120.393 8.57948C119.636 9.33649 119.047 10.2337 118.654 11.215C118.206 12.3084 117.981 13.486 118.009 14.6636C117.981 15.8412 118.206 17.0187 118.654 18.1402C119.047 19.1215 119.664 20.0187 120.393 20.7757C121.822 22.2337 123.757 23.0468 125.804 23.0468C126.757 23.0748 127.71 22.8505 128.579 22.458C129.14 22.1776 129.645 21.8131 130.037 21.3645V21.7851C130.037 22.0094 130.122 22.2337 130.29 22.3739C130.458 22.5421 130.654 22.6262 130.879 22.6262H134.047C134.523 22.6262 134.888 22.2617 134.888 21.7851V7.68228C134.888 7.45798 134.804 7.23369 134.664 7.06546C134.523 6.8692 134.299 6.75705 134.047 6.75705ZM129.785 16.2056C129.617 16.6542 129.365 17.0468 129.028 17.4113C128.692 17.7477 128.327 18.0281 127.907 18.2243C127.458 18.4206 126.981 18.5327 126.477 18.5327C125.972 18.5327 125.523 18.4206 125.075 18.2243C124.654 18.0281 124.262 17.7477 123.925 17.4113C123.589 17.0748 123.337 16.6542 123.196 16.2056C122.86 15.2524 122.86 14.215 123.196 13.2617C123.365 12.8131 123.617 12.4206 123.925 12.0842C124.262 11.7477 124.654 11.4673 125.075 11.2711C125.523 11.0748 126 10.9627 126.477 10.9627C126.953 10.9627 127.43 11.0468 127.907 11.2711C128.327 11.4673 128.692 11.7197 129.028 12.0561C129.365 12.3926 129.617 12.7851 129.785 13.2337C130.15 14.1589 130.15 15.2524 129.785 16.2056ZM151.43 17.9159L149.608 16.5141C149.271 16.2337 148.935 16.1496 148.654 16.2617C148.402 16.3739 148.178 16.5421 147.981 16.7384C147.589 17.215 147.112 17.6356 146.608 18C146.047 18.3085 145.458 18.4767 144.841 18.4206C144.112 18.4206 143.439 18.2243 142.851 17.8038C142.262 17.3832 141.813 16.8225 141.589 16.1215C141.421 15.6449 141.337 15.1683 141.337 14.6916C141.337 14.187 141.421 13.7103 141.589 13.2056C141.757 12.757 141.981 12.3645 142.318 12.0281C142.654 11.6916 143.019 11.4113 143.439 11.243C143.888 11.0468 144.365 10.9346 144.869 10.9346C145.486 10.9066 146.103 11.0748 146.636 11.3832C147.168 11.7197 147.617 12.1402 148.009 12.6449C148.178 12.8412 148.402 13.0094 148.654 13.1215C148.935 13.2337 149.271 13.1496 149.608 12.8692L151.43 11.4954C151.654 11.3552 151.822 11.1309 151.907 10.8785C152.019 10.5982 151.991 10.2898 151.822 10.0374C151.122 8.94396 150.168 8.04676 149.019 7.4019C147.813 6.72901 146.383 6.36453 144.785 6.36453C143.664 6.36453 142.542 6.58882 141.477 7.00938C140.467 7.42994 139.57 8.01873 138.813 8.77573C138.056 9.53274 137.439 10.4299 137.019 11.4393C136.15 13.5421 136.15 15.8972 137.019 18C137.439 18.9813 138.028 19.9066 138.813 20.6356C140.411 22.2056 142.542 23.0468 144.785 23.0468C146.383 23.0468 147.813 22.6823 149.019 22.0094C150.168 21.3645 151.15 20.4673 151.851 19.3458C151.991 19.0935 152.019 18.7851 151.935 18.5327C151.822 18.3085 151.654 18.0841 151.43 17.9159ZM168.308 21.1963L163.29 13.8505L167.58 8.18696C167.776 7.93462 167.86 7.57013 167.748 7.26172C167.664 7.03742 167.467 6.81312 166.935 6.81312H163.542C163.346 6.81312 163.15 6.86919 162.981 6.9533C162.757 7.06545 162.589 7.23368 162.477 7.42994L159.056 12.2243H158.243V0.897237C158.243 0.672938 158.159 0.448635 157.991 0.280411C157.822 0.112187 157.626 0.0280762 157.402 0.0280762H154.234C154.009 0.0280762 153.785 0.112187 153.617 0.280411C153.449 0.448635 153.365 0.6449 153.365 0.897237V21.7851C153.365 22.0374 153.449 22.2337 153.617 22.4019C153.785 22.5701 154.009 22.6542 154.234 22.6542H157.402C157.626 22.6542 157.851 22.5701 157.991 22.4019C158.159 22.2337 158.243 22.0094 158.243 21.7851V16.2617H159.14L162.869 21.9813C163.094 22.4019 163.514 22.6542 163.963 22.6542H167.523C168.056 22.6542 168.28 22.4019 168.393 22.1776C168.533 21.8131 168.505 21.4486 168.308 21.1963ZM89.2991 6.78509H85.7384C85.458 6.78509 85.2057 6.8692 85.0094 7.06546C84.8412 7.23369 84.729 7.42994 84.673 7.65424L82.0374 17.4113H81.3926L78.5888 7.65424C78.5328 7.45798 78.4487 7.26172 78.3085 7.06546C78.1402 6.8692 77.9159 6.75705 77.6636 6.75705H74.0468C73.5702 6.75705 73.2898 6.89723 73.1496 7.23368C73.0655 7.51405 73.0655 7.82247 73.1496 8.10284L77.6356 21.8412C77.7197 22.0374 77.8038 22.2617 77.972 22.4019C78.1402 22.5701 78.3926 22.6542 78.6449 22.6542H80.5515L80.3832 23.1028L79.9627 24.3645C79.8225 24.757 79.5982 25.0935 79.2617 25.3458C78.9533 25.5701 78.5888 25.7103 78.1963 25.6823C77.8599 25.6823 77.5515 25.5982 77.243 25.486C76.9346 25.3458 76.6543 25.1776 76.4019 24.9813C76.1776 24.8131 75.8973 24.729 75.5888 24.729H75.5608C75.2244 24.7571 74.9159 24.9253 74.7477 25.2337L73.6262 26.8879C73.1776 27.6169 73.43 28.0655 73.7103 28.3178C74.3272 28.8785 75.0281 29.2991 75.8131 29.5514C76.6823 29.8598 77.5795 30 78.4767 30C80.1029 30 81.4487 29.5514 82.486 28.6823C83.5515 27.729 84.3645 26.4954 84.7571 25.0935L89.972 8.10284C90.0842 7.79443 90.1122 7.48602 90.0001 7.20565C89.972 7.00939 89.7758 6.75705 89.2991 6.78509Z",
              fill: "#131E32"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_210_22", children: /* @__PURE__ */ u.jsx("rect", { width: "168.505", height: "30", fill: "white" }) }) })
      ]
    }
  );
}
function QM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.64524 22.7014C0.46938 22.7433 0.28417 22.6914 0.15575 22.5642C0.0270098 22.4371 -0.0268802 22.2528 0.0128098 22.0764L1.1728 16.8362L5.76534 21.452L0.64524 22.7014ZM7.00918 20.2033L2.41699 15.5866L14.0449 3.89916L18.64 8.51589L7.00918 20.2033ZM22.1262 5.01601L19.8369 7.31635L15.2418 2.69962L17.2043 0.727479C17.5844 0.345429 18.1013 0.130859 18.6402 0.130859C19.1793 0.130859 19.6959 0.345429 20.0764 0.727479L22.1262 2.78642C22.4212 3.0823 22.587 3.48338 22.587 3.90123C22.587 4.3194 22.4212 4.72014 22.1262 5.01602V5.01601Z"
        }
      )
    }
  );
}
function qM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "13",
      height: "15",
      viewBox: "0 0 13 15",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M7.21591 11.5455V10.8551C7.21591 10.3778 7.31392 9.94105 7.50994 9.54474C7.71023 9.14418 8 8.82457 8.37926 8.58594C8.76278 8.34304 9.22727 8.22159 9.77273 8.22159C10.3267 8.22159 10.7912 8.34304 11.1662 8.58594C11.5412 8.82457 11.8246 9.14418 12.0163 9.54474C12.2081 9.94105 12.304 10.3778 12.304 10.8551V11.5455C12.304 12.0227 12.206 12.4616 12.0099 12.8622C11.8182 13.2585 11.5327 13.5781 11.1534 13.821C10.7784 14.0597 10.3182 14.179 9.77273 14.179C9.21875 14.179 8.75213 14.0597 8.37287 13.821C7.99361 13.5781 7.70597 13.2585 7.50994 12.8622C7.31392 12.4616 7.21591 12.0227 7.21591 11.5455ZM8.51989 10.8551V11.5455C8.51989 11.9418 8.61364 12.2976 8.80114 12.6129C8.98864 12.924 9.3125 13.0795 9.77273 13.0795C10.2202 13.0795 10.5355 12.924 10.7188 12.6129C10.9062 12.2976 11 11.9418 11 11.5455V10.8551C11 10.4588 10.9105 10.1051 10.7315 9.79403C10.5526 9.47869 10.233 9.32102 9.77273 9.32102C9.32528 9.32102 9.00355 9.47869 8.80753 9.79403C8.61577 10.1051 8.51989 10.4588 8.51989 10.8551ZM0.696023 4.05398V3.36364C0.696023 2.88636 0.794034 2.44957 0.990057 2.05327C1.19034 1.6527 1.48011 1.3331 1.85938 1.09446C2.2429 0.851562 2.70739 0.730113 3.25284 0.730113C3.80682 0.730113 4.27131 0.851562 4.64631 1.09446C5.02131 1.3331 5.30469 1.6527 5.49645 2.05327C5.68821 2.44957 5.78409 2.88636 5.78409 3.36364V4.05398C5.78409 4.53125 5.68608 4.97017 5.49006 5.37074C5.2983 5.76705 5.01278 6.08665 4.63352 6.32955C4.25852 6.56818 3.7983 6.6875 3.25284 6.6875C2.69886 6.6875 2.23224 6.56818 1.85298 6.32955C1.47372 6.08665 1.18608 5.76705 0.990057 5.37074C0.794034 4.97017 0.696023 4.53125 0.696023 4.05398ZM2 3.36364V4.05398C2 4.45028 2.09375 4.80611 2.28125 5.12145C2.46875 5.43253 2.79261 5.58807 3.25284 5.58807C3.70028 5.58807 4.01563 5.43253 4.19886 5.12145C4.38636 4.80611 4.48011 4.45028 4.48011 4.05398V3.36364C4.48011 2.96733 4.39062 2.61364 4.21165 2.30256C4.03267 1.98722 3.71307 1.82955 3.25284 1.82955C2.8054 1.82955 2.48366 1.98722 2.28764 2.30256C2.09588 2.61364 2 2.96733 2 3.36364ZM1.18182 14L10.1818 0.909091H11.6392L2.6392 14H1.18182Z" })
    }
  );
}
function XM(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "#35E190",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M9.93709 10.61C10.8847 10.5968 11.8073 10.3037 12.5888 9.76761C13.3703 9.23151 13.9758 8.47632 14.3293 7.597C14.6828 6.71768 14.7684 5.75348 14.5754 4.82564C14.3823 3.8978 13.9193 3.04773 13.2445 2.38233C12.5697 1.71692 11.7132 1.26588 10.7827 1.08592C9.85225 0.90596 8.88935 1.00511 8.01508 1.3709C7.14082 1.7367 6.39421 2.35281 5.86915 3.14176C5.34408 3.93072 5.06399 4.8573 5.06409 5.80501C5.06841 6.44052 5.1979 7.06895 5.44515 7.6544C5.69241 8.23986 6.05259 8.77086 6.50512 9.21707C6.95765 9.66329 7.49366 10.016 8.08253 10.255C8.6714 10.494 9.30159 10.6146 9.93709 10.61ZM9.93709 13.01C6.68409 13.013 0.190094 14.622 0.190094 17.818V20.218H19.6831V17.818C19.6831 14.622 13.1901 13.013 9.93709 13.013V13.01Z" })
    }
  );
}
function ek(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M12.39 7.55988C12.0319 3.4405 7.73439 1.41925 7.55252 1.33675C7.38249 1.25683 7.19196 1.23129 7.00689 1.26363C2.04564 2.08675 1.29939 4.97425 1.26939 5.09425C1.22857 5.26148 1.23507 5.43676 1.28814 5.6005C7.20564 23.9605 19.5038 27.3636 23.5463 28.483C23.8575 28.5693 24.1144 28.6386 24.3094 28.7024C24.5319 28.7751 24.7737 28.761 24.9863 28.663C25.11 28.6068 28.0313 27.2305 28.7456 22.7418C28.7773 22.5458 28.7458 22.3448 28.6556 22.168C28.5919 22.0443 27.0638 19.1361 22.8263 18.1086C22.6825 18.0719 22.532 18.0706 22.3876 18.1049C22.2432 18.1392 22.1094 18.208 21.9975 18.3055C20.6606 19.4474 18.8138 20.6643 18.0169 20.7899C12.675 18.178 9.69189 13.1661 9.57939 12.2155C9.51377 11.6811 10.7381 9.80425 12.1463 8.278C12.2348 8.18195 12.3022 8.06842 12.3442 7.94474C12.3861 7.82106 12.4018 7.68996 12.39 7.55988Z", fill: "#142D63" })
    }
  );
}
function tk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "19",
      height: "20",
      viewBox: "0 0 19 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.5527 17.1788V2.74891C18.5527 1.61513 17.6251 0.6875 16.4913 0.6875H2.06141C0.92763 0.6875 0 1.61514 0 2.74891V17.1788C0 18.3126 0.92764 19.2402 2.06141 19.2402H16.4913C17.6251 19.2402 18.5527 18.3126 18.5527 17.1788ZM5.66899 11.5109L8.24576 14.6133L11.8532 9.96484L16.4914 16.1491H2.06152L5.66899 11.5109Z"
        }
      )
    }
  );
}
const nk = (e) => /* @__PURE__ */ u.jsx(
  "svg",
  {
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#CBD5E1",
    ...e,
    children: /* @__PURE__ */ u.jsx(
      "path",
      {
        clipRule: "evenodd",
        d: "m106.7 150.46h73.72c4.57-9.77 11.27-18.17 19.44-24.49-5.53-14.45-18.52-24.25-32.8-24.25h-27.52c-19.64 0-35.62 17.77-35.62 39.62v5.49c0 1.97 1.28 3.63 2.78 3.63zm329.86 258.68c0-42.33-34.44-76.78-76.78-76.78-42.33 0-76.78 34.44-76.78 76.78s34.45 76.78 76.78 76.78c42.34 0 76.78-34.45 76.78-76.78zm-76.78-54.4c3.31 0 6 2.68 6 6v7.52c9.56 2.53 16.6 10.96 16.6 20.94 0 3.32-2.69 6-6 6s-6-2.69-6-6c0-5.37-4.76-9.73-10.6-9.73s-10.6 4.36-10.6 9.73c0 5.63 6.62 8.61 12.17 10.11 18.3 4.97 21.03 15.72 21.03 21.7 0 9.98-7.04 18.41-16.6 20.94v7.52c0 3.31-2.69 6-6 6s-6-2.69-6-6v-7.52c-9.56-2.54-16.6-10.96-16.6-20.94 0-3.32 2.69-6 6-6 3.32 0 6 2.69 6 6 0 5.37 4.76 9.73 10.6 9.73 5.85 0 10.6-4.36 10.6-9.73 0-5.63-6.62-8.61-12.17-10.11-18.3-4.97-21.03-15.72-21.03-21.7 0-9.98 7.04-18.41 16.6-20.94v-7.52c0-3.32 2.69-6 6-6zm75.05-122.39c2.38 0 4.32 1.94 4.32 4.32v38.09c0 1.51-.61 2.67-1.85 3.54l-62.22 43.38c-4.97-.87-10.08-1.32-15.3-1.32-48.95 0-88.78 39.82-88.78 88.78 0 10.78 1.94 21.12 5.48 30.69l-38.76 22.66v-72.84c0-2.09-1.07-3.92-2.69-5l-160.74-106.44c-1.31-.86-1.94-2.04-1.94-3.6v-37.93c0-2.38 1.94-4.32 4.32-4.32h358.16zm-93.14 18c0-3.32-2.69-6-6-6-3.32 0-6 2.69-6 6v36.76l-8.13-8.13c-2.35-2.34-6.14-2.34-8.49 0-2.34 2.34-2.34 6.14 0 8.48l18.37 18.37c1.13 1.13 2.66 1.76 4.25 1.76s3.11-.63 4.24-1.76l18.37-18.37c2.34-2.34 2.34-6.14 0-8.48s-6.14-2.34-8.48 0l-8.13 8.13zm-85.94-1.41c-3.31 0-6 2.69-6 6v66.49l-8.13-8.13c-2.34-2.34-6.14-2.34-8.48 0-2.35 2.34-2.35 6.14 0 8.48l18.37 18.37c1.17 1.17 2.7 1.76 4.24 1.76s3.07-.58 4.24-1.76l18.37-18.37c2.35-2.34 2.35-6.15 0-8.48-2.34-2.34-6.14-2.34-8.48 0l-8.13 8.13v-66.49c0-3.31-2.69-6-6-6zm-79.94-4.59c-3.31 0-6 2.69-6 6v36.76l-8.13-8.13c-2.34-2.34-6.14-2.34-8.48 0s-2.34 6.14 0 8.48l18.37 18.37c1.13 1.13 2.65 1.76 4.24 1.76s3.12-.63 4.25-1.76l18.37-18.37c2.34-2.34 2.34-6.14 0-8.48-2.35-2.34-6.14-2.34-8.49 0l-8.13 8.13v-36.76c0-3.31-2.68-6-6-6zm159.71-171.83c2.76 6.19 8.38 13.58 19.44 13.58 11.05 0 16.67-7.38 19.43-13.57 5.75-12.89 3.54-29.77-2.27-36.25-4.53-5.05-9.66-7.2-17.14-7.2-7.52 0-12.66 2.15-17.19 7.2-5.81 6.47-8.02 23.35-2.27 36.24zm5.67 29.21c-14.28 0-27.27 9.79-32.8 24.25 8.17 6.31 14.87 14.71 19.44 24.49h73.72c1.51 0 2.78-1.66 2.78-3.62v-5.49c0-21.84-15.98-39.62-35.61-39.62h-27.53zm-68.57 23.82c27.52 0 49.91 24.8 49.91 55.28v7.38c0 3.76-2.65 6.93-5.79 6.93h-125.22c-3.14 0-5.79-3.17-5.79-6.93v-7.38c0-30.49 22.39-55.28 49.91-55.28zm-43.09-87.28c-9.29 10.36-10.88 34.16-3.4 50.92 3.96 8.88 12.04 19.46 28 19.46s24.03-10.58 27.99-19.46c7.48-16.77 5.89-40.56-3.4-50.92-6.52-7.26-13.86-10.36-24.56-10.36-10.75 0-18.11 3.1-24.63 10.36zm-95.67 34.25c2.76 6.19 8.38 13.58 19.44 13.58 11.05 0 16.67-7.38 19.43-13.57 5.75-12.89 3.54-29.77-2.27-36.25-4.53-5.05-9.66-7.2-17.14-7.2-7.52 0-12.66 2.15-17.19 7.2-5.81 6.47-8.02 23.35-2.27 36.24z",
        fillRule: "evenodd"
      }
    )
  }
);
function dh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      version: "1.1",
      fill: "#CBD5E1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "20px",
      viewBox: "0 0 298 294",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M244.285446,208.610062
	C242.970535,209.638763 241.936996,211.008606 240.866455,211.038147
	C226.915070,211.423294 213.323441,212.234283 202.526245,199.743088
	C191.444809,186.923065 178.474030,175.756104 166.753845,163.461746
	C157.923599,154.198914 143.357864,154.168411 134.603729,163.190262
	C121.496552,176.698273 108.021919,189.849380 94.731537,203.180161
	C89.298790,208.629440 82.626717,210.348587 75.120163,211.342804
	C60.985691,213.214874 50.329533,208.886612 41.561268,197.525284
	C35.426071,189.575714 27.253853,183.221161 20.883156,175.425507
	C8.642242,160.446579 10.216591,137.694260 24.153507,123.132507
	C33.826618,113.025703 43.814171,103.215714 53.828175,93.444191
	C55.185833,92.119408 57.495472,91.183701 59.401691,91.115700
	C65.546120,90.896507 71.750221,90.741402 77.853561,91.346245
	C87.652054,92.317268 94.438049,98.733185 100.955849,105.375687
	C112.375610,117.013977 123.608986,128.844330 135.293442,140.210785
	C144.487930,149.155029 157.356705,148.646927 166.649048,139.429947
	C179.301895,126.879730 192.115875,114.471695 204.310608,101.486053
	C214.881454,90.229607 227.898621,89.801460 241.426010,92.080154
	C244.539246,92.604576 247.171005,96.638344 249.796814,99.283035
	C257.645477,107.188202 265.340271,115.245918 273.169800,123.170311
	C288.713440,138.902252 288.759369,163.937805 273.159729,179.690308
	C263.665131,189.277969 254.089081,198.784973 244.285446,208.610062
z`
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M99.133804,254.866470
	C89.211319,245.070602 79.538452,235.525192 69.900787,226.014526
	C77.181381,224.578506 84.190994,224.060730 90.499619,221.683029
	C95.720055,219.715469 100.687065,216.152695 104.766792,212.251404
	C117.882652,199.709244 130.526199,186.673599 143.371429,173.847855
	C148.933350,168.294357 151.991394,168.267914 157.623703,173.866959
	C170.023743,186.193771 182.537323,198.413330 194.675293,210.994354
	C202.944809,219.565735 212.734009,224.177948 224.546219,224.728470
	C225.302353,224.763702 226.052200,224.934326 228.588257,225.296951
	C219.519348,234.040939 211.361176,241.787537 203.339722,249.673203
	C194.672058,258.194153 186.151550,266.864594 177.532349,275.435120
	C161.107605,291.767181 136.428574,291.868164 119.855301,275.622467
	C112.958298,268.861816 106.203102,261.956482 99.133804,254.866470
z`
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M93.157654,81.812546
	C85.493309,79.981094 78.150978,78.351784 70.817352,76.724403
	C70.913933,76.604439 71.581711,75.602051 72.415405,74.764885
	C88.518112,58.595020 104.543739,42.346703 120.786789,26.318796
	C135.627319,11.674816 158.966370,10.582329 174.536713,24.857964
	C190.414688,39.415646 205.186234,55.179058 220.474991,70.381584
	C222.722427,72.616348 225.151276,74.668686 227.593521,76.894150
	C220.952347,78.432266 214.797546,79.087257 209.311203,81.357597
	C204.392059,83.393204 199.630020,86.613060 195.805130,90.342636
	C182.501434,103.314796 169.612640,116.713509 156.616074,129.998932
	C152.699371,134.002716 149.133774,134.139923 145.126892,130.125793
	C132.536896,117.513069 120.106400,104.735985 107.298668,92.348724
	C103.197273,88.381973 98.113815,85.430618 93.157654,81.812546
z`
          }
        )
      ]
    }
  );
}
function ak(e) {
  return /* @__PURE__ */ u.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", ...e, children: /* @__PURE__ */ u.jsx("g", { fill: "CurrentColor", children: /* @__PURE__ */ u.jsx("path", { d: "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" }) }) });
}
function rk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 14 14",
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 0.8125C7.14918 0.8125 7.29226 0.871763 7.39775 0.977252C7.50324 1.08274 7.5625 1.22582 7.5625 1.375V6.4375H12.625C12.7742 6.4375 12.9173 6.49676 13.0227 6.60225C13.1282 6.70774 13.1875 6.85082 13.1875 7C13.1875 7.14918 13.1282 7.29226 13.0227 7.39775C12.9173 7.50324 12.7742 7.5625 12.625 7.5625H7.5625V12.625C7.5625 12.7742 7.50324 12.9173 7.39775 13.0227C7.29226 13.1282 7.14918 13.1875 7 13.1875C6.85082 13.1875 6.70774 13.1282 6.60225 13.0227C6.49676 12.9173 6.4375 12.7742 6.4375 12.625V7.5625H1.375C1.22582 7.5625 1.08274 7.50324 0.977252 7.39775C0.871763 7.29226 0.8125 7.14918 0.8125 7C0.8125 6.85082 0.871763 6.70774 0.977252 6.60225C1.08274 6.49676 1.22582 6.4375 1.375 6.4375H6.4375V1.375C6.4375 1.22582 6.49676 1.08274 6.60225 0.977252C6.70774 0.871763 6.85082 0.8125 7 0.8125Z"
        }
      )
    }
  );
}
function ik(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "23",
      height: "28",
      x: "0",
      y: "0",
      viewBox: "0 0 477.869 477.869",
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m192.951 171.027 32.913-54.878L29.598 61.195l-26.24 43.887c-6.642 11.052-3.068 25.396 7.984 32.038a23.373 23.373 0 0 0 5.729 2.471l149.581 41.907a23.339 23.339 0 0 0 26.299-10.471z",
            fill: "#94a3b8",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m40.35 312.322 70.588 19.277v-84.13c0-18.851 15.282-34.133 34.133-34.133h85.333v-71.569l-22.818 38.042c-9.378 15.59-28.009 23.003-45.534 18.116l-127.914-35.79V304.13a8.532 8.532 0 0 0 6.212 8.192zM238.938 102.086l181.931-50.935L243.511.633a16.913 16.913 0 0 0-9.173 0L57.007 51.151zM437.559 312.322a8.533 8.533 0 0 0 6.178-8.192V162.135l-127.915 35.84a39.808 39.808 0 0 1-10.846 1.493 40.48 40.48 0 0 1-34.688-19.627l-22.818-38.076v71.569h85.333c18.851 0 34.133 15.282 34.133 34.133v84.13z",
            fill: "#94a3b8",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M284.924 171.027a23.363 23.363 0 0 0 26.3 10.47l149.581-41.907c12.415-3.483 19.656-16.371 16.173-28.786a23.366 23.366 0 0 0-2.459-5.706l-26.223-43.904-196.267 54.955zM349.871 460.802V247.469c0-9.426-7.641-17.067-17.067-17.067H145.071c-9.426 0-17.067 7.641-17.067 17.067v213.333c0 9.426 7.641 17.067 17.067 17.067h187.733c9.426 0 17.067-7.641 17.067-17.067zm-147.567-36.634-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm0-51.2-25.6 25.6a8.534 8.534 0 0 1-12.066 0l-8.533-8.533a8.534 8.534 0 0 1 12.066-12.066l2.5 2.5 19.567-19.567a8.534 8.534 0 0 1 12.066 12.066zm113.434 173.167h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066zm0-51.2h-85.333a8.533 8.533 0 0 1 0-17.066h85.333a8.533 8.533 0 0 1 0 17.066z",
            fill: "#94a3b8",
            "data-original": "#000000"
          }
        )
      ] })
    }
  );
}
function i0(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.8813 9.18766C10.687 9.54872 10.3116 9.77547 9.90164 9.77949C9.49164 9.7835 9.11193 9.56414 8.91059 9.20696C8.70926 8.84978 8.71819 8.41134 8.93391 8.06266C9.69772 6.73986 11.2548 6.09497 12.7302 6.49031C14.2056 6.88566 15.2316 8.22267 15.2317 9.75016C15.2317 10.9854 14.4745 11.9934 13.5442 12.5627C12.7972 13.0194 13.2629 14.2502 11.8533 14.2502C11.5347 14.25 11.2311 14.1147 11.0179 13.8779C10.8047 13.6411 10.7019 13.325 10.735 13.0082C10.7654 12.413 11.0309 11.9282 11.32 11.5772C11.6249 11.2059 12.0265 10.9022 12.3325 10.7199C14.0392 9.70516 11.9579 7.62953 10.8813 9.18878V9.18766ZM11.8533 15.3752C11.232 15.3752 10.7283 15.8788 10.7283 16.5002C10.7283 17.1215 11.232 17.6252 11.8533 17.6252C12.4746 17.6252 12.9783 17.1215 12.9783 16.5002C12.9783 15.8788 12.4746 15.3752 11.8533 15.3752Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function ok(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "22",
      height: "15",
      viewBox: "0 0 22 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { fill: "CurrentColor", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.5274 3.9381L11.281 0.605099C11.2592 0.597779 11.2353 0.597779 11.2134 0.605099L0.914657 3.88727C0.869307 3.90189 0.838397 3.94375 0.837897 3.99127C0.837397 4.03894 0.867477 4.08131 0.912327 4.09676L3.42849 4.95894V7.94639C3.00603 8.1361 2.7115 8.55956 2.7115 9.05265C2.7115 9.54571 3.00637 9.96951 3.42849 10.1589L2.76696 14.419H4.97214L4.42093 10.1589C4.84339 9.96935 5.13791 9.54572 5.13791 9.05265C5.13791 8.55956 4.84337 8.13611 4.42093 7.94639V5.29882L11.1761 7.61348C11.1876 7.61747 11.1997 7.61946 11.2117 7.61946C11.2237 7.61946 11.2358 7.61763 11.2472 7.61365L21.5285 4.14757C21.5737 4.13229 21.6038 4.08992 21.6034 4.04258C21.6029 3.99473 21.5724 3.95286 21.5273 3.93808L21.5274 3.9381Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2104 8.17106C11.1375 8.17106 11.0658 8.15876 10.9968 8.13517L5.61523 6.29135V10.2296C5.61523 11.3359 8.15747 12.2326 11.2937 12.2326C14.4298 12.2326 16.972 11.3359 16.972 10.2296L16.9719 6.26562L11.4232 8.13621C11.3549 8.15962 11.283 8.1711 11.2104 8.1711L11.2104 8.17106Z"
          }
        )
      ] })
    }
  );
}
function ph(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "19",
      height: "22",
      viewBox: "0 0 19 22",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M11.19 9.44064L7.94 21.8806H0L1.61 15.7606L11.19 9.44064Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M18.3994 0.41037L12.7594 21.8804H8.88938L12.6994 7.34037L6.85938 11.1904L7.89937 7.36037L18.3994 0.41037Z" })
      ]
    }
  );
}
function sk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      viewBox: ".8 .48 1894.74 400.27",
      width: "159",
      height: "42",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "m122.63 105.7-15.75 57.97 90.15-58.3-58.96 219.98 59.88.05 87.1-324.92",
            fill: "#3395ff"
          }
        ),
        /* @__PURE__ */ u.jsx("path", { d: "m25.6 232.92-24.8 92.48h122.73l50.22-188.13zm426.32-81.42c-3 11.15-8.78 19.34-17.4 24.57-8.6 5.22-20.67 7.84-36.25 7.84h-49.5l17.38-64.8h49.5c15.56 0 26.25 2.6 32.05 7.9s7.2 13.4 4.22 24.6m51.25-1.4c6.3-23.4 3.7-41.4-7.82-54-11.5-12.5-31.68-18.8-60.48-18.8h-110.47l-66.5 248.1h53.67l26.8-100h35.2c7.9 0 14.12 1.3 18.66 3.8 4.55 2.6 7.22 7.1 8.04 13.6l9.58 82.6h57.5l-9.32-77c-1.9-17.2-9.77-27.3-23.6-30.3 17.63-5.1 32.4-13.6 44.3-25.4a92.6 92.6 0 0 0 24.44-42.5m130.46 86.4c-4.5 16.8-11.4 29.5-20.73 38.4-9.34 8.9-20.5 13.3-33.52 13.3-13.26 0-22.25-4.3-27-13-4.76-8.7-4.92-21.3-.5-37.8s11.47-29.4 21.17-38.7 21.04-13.95 34.06-13.95c13 0 21.9 4.5 26.4 13.43 4.6 8.97 4.7 21.8.2 38.5zm23.52-87.8-6.72 25.1c-2.9-9-8.53-16.2-16.85-21.6-8.34-5.3-18.66-8-30.97-8-15.1 0-29.6 3.9-43.5 11.7s-26.1 18.8-36.5 33-18 30.3-22.9 48.4c-4.8 18.2-5.8 34.1-2.9 47.9 3 13.9 9.3 24.5 19 31.9 9.8 7.5 22.3 11.2 37.6 11.2a82.4 82.4 0 0 0 35.2-7.7 82.11 82.11 0 0 0 28.4-21.2l-7 26.16h51.9l47.39-176.77h-52zm238.65 0h-150.93l-10.55 39.4h87.82l-116.1 100.3-9.92 37h155.8l10.55-39.4h-94.1l117.88-101.8m142.4 52c-4.67 17.4-11.6 30.48-20.75 39-9.15 8.6-20.23 12.9-33.24 12.9-27.2 0-36.14-17.3-26.86-51.9 4.6-17.2 11.56-30.13 20.86-38.84 9.3-8.74 20.57-13.1 33.82-13.1 13 0 21.78 4.33 26.3 13.05 4.52 8.7 4.48 21.67-.13 38.87m30.38-80.83c-11.95-7.44-27.2-11.16-45.8-11.16-18.83 0-36.26 3.7-52.3 11.1a113.09 113.09 0 0 0 -41 32.06c-11.3 13.9-19.43 30.2-24.42 48.8-4.9 18.53-5.5 34.8-1.7 48.73 3.8 13.9 11.8 24.6 23.8 32 12.1 7.46 27.5 11.17 46.4 11.17 18.6 0 35.9-3.74 51.8-11.18 15.9-7.48 29.5-18.1 40.8-32.1 11.3-13.94 19.4-30.2 24.4-48.8s5.6-34.84 1.8-48.8c-3.8-13.9-11.7-24.6-23.6-32.05m185.1 40.8 13.3-48.1c-4.5-2.3-10.4-3.5-17.8-3.5-11.9 0-23.3 2.94-34.3 8.9-9.46 5.06-17.5 12.2-24.3 21.14l6.9-25.9-15.07.06h-37l-47.7 176.7h52.63l24.75-92.37c3.6-13.43 10.08-24 19.43-31.5 9.3-7.53 20.9-11.3 34.9-11.3 8.6 0 16.6 1.97 24.2 5.9m146.5 41.1c-4.5 16.5-11.3 29.1-20.6 37.8-9.3 8.74-20.5 13.1-33.5 13.1s-21.9-4.4-26.6-13.2c-4.8-8.85-4.9-21.6-.4-38.36 4.5-16.75 11.4-29.6 20.9-38.5 9.5-8.97 20.7-13.45 33.7-13.45 12.8 0 21.4 4.6 26 13.9s4.7 22.2.28 38.7m36.8-81.4c-9.75-7.8-22.2-11.7-37.3-11.7-13.23 0-25.84 3-37.8 9.06-11.95 6.05-21.65 14.3-29.1 24.74l.18-1.2 8.83-28.1h-51.4l-13.1 48.9-.4 1.7-54 201.44h52.7l27.2-101.4c2.7 9.02 8.2 16.1 16.6 21.22 8.4 5.1 18.77 7.63 31.1 7.63 15.3 0 29.9-3.7 43.75-11.1 13.9-7.42 25.9-18.1 36.1-31.9s17.77-29.8 22.6-47.9c4.9-18.13 5.9-34.3 3.1-48.45-2.85-14.17-9.16-25.14-18.9-32.9m174.65 80.65c-4.5 16.7-11.4 29.5-20.7 38.3-9.3 8.86-20.5 13.27-33.5 13.27-13.3 0-22.3-4.3-27-13-4.8-8.7-4.9-21.3-.5-37.8s11.42-29.4 21.12-38.7 21.05-13.94 34.07-13.94c13 0 21.8 4.5 26.4 13.4 4.6 8.93 4.63 21.76.15 38.5zm23.5-87.85-6.73 25.1c-2.9-9.05-8.5-16.25-16.8-21.6-8.4-5.34-18.7-8-31-8-15.1 0-29.68 3.9-43.6 11.7-13.9 7.8-26.1 18.74-36.5 32.9s-18 30.3-22.9 48.4c-4.85 18.17-5.8 34.1-2.9 47.96 2.93 13.8 9.24 24.46 19 31.9 9.74 7.4 22.3 11.14 37.6 11.14 12.3 0 24.05-2.56 35.2-7.7a82.3 82.3 0 0 0 28.33-21.23l-7 26.18h51.9l47.38-176.7h-51.9zm269.87.06.03-.05h-31.9c-1.02 0-1.92.05-2.85.07h-16.55l-8.5 11.8-2.1 2.8-.9 1.4-67.25 93.68-13.9-109.7h-55.08l27.9 166.7-61.6 85.3h54.9l14.9-21.13c.42-.62.8-1.14 1.3-1.8l17.4-24.7.5-.7 77.93-110.5 65.7-93 .1-.06h-.03z" })
      ]
    }
  );
}
function lk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "#CBD5E1",
      stroke: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.5852 11.6602C22.5847 11.5054 22.5811 11.3515 22.5742 11.1983V2.46357L20.1594 4.87836C18.183 2.4592 15.1765 0.914062 11.8088 0.914062C8.30428 0.914062 5.1908 2.58687 3.22266 5.17747L7.18079 9.17724C7.56868 8.45985 8.11974 7.84368 8.78416 7.37831C9.47519 6.83906 10.4543 6.39814 11.8087 6.39814C11.9723 6.39814 12.0986 6.41726 12.1914 6.45329C13.8696 6.58574 15.3242 7.51186 16.1806 8.85605L13.3789 11.6578C16.9277 11.6439 20.9367 11.6357 22.5849 11.6596",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.7462 0.914062C11.5914 0.914583 11.4374 0.918152 11.2842 0.925092H2.54952L4.96431 3.33988C2.54515 5.31625 1 8.32282 1 11.6904C1 15.195 2.67284 18.3085 5.26342 20.2766L9.26318 16.3185C8.54579 15.9306 7.92962 15.3796 7.46425 14.7151C6.92502 14.0241 6.48408 13.045 6.48408 11.6906C6.48408 11.5269 6.5032 11.4006 6.53923 11.3079C6.67168 9.62972 7.5978 8.17511 8.94199 7.31862L11.7438 10.1204C11.7298 6.57161 11.7216 2.5626 11.7456 0.914382",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M11.7462 0.914062C11.5914 0.914583 11.4374 0.918152 11.2842 0.925092H2.54952L4.96431 3.33988C2.54515 5.31625 1 8.32282 1 11.6904C1 15.195 2.67284 18.3085 5.26342 20.2766L9.26318 16.3185C8.54579 15.9306 7.92962 15.3796 7.46425 14.7151C6.92502 14.0241 6.48408 13.045 6.48408 11.6906C6.48408 11.5269 6.5032 11.4006 6.53923 11.3079C6.67168 9.62972 7.5978 8.17511 8.94199 7.31862L11.7438 10.1204C11.7298 6.57161 11.7216 2.5626 11.7456 0.914382",
            fill: "none",
            strokeWidth: "0.5",
            strokeLinecap: "square"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1 11.6914C1.00052 11.8462 1.00409 12.0001 1.01102 12.1533V20.8881L3.42581 18.4733C5.40217 20.8925 8.40874 22.4376 11.7764 22.4376C15.2809 22.4376 18.3944 20.7648 20.3626 18.1742L16.4044 14.1744C16.0165 14.8918 15.4655 15.508 14.8011 15.9733C14.11 16.5126 13.1309 16.9535 11.7765 16.9535C11.6129 16.9535 11.4866 16.9344 11.3938 16.8983C9.71565 16.7659 8.26103 15.8398 7.40455 14.4956L10.2063 11.6938C6.65754 11.7078 2.64851 11.7159 1.00029 11.692",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M1 11.6914C1.00052 11.8462 1.00409 12.0001 1.01102 12.1533V20.8881L3.42581 18.4733C5.40217 20.8925 8.40874 22.4376 11.7764 22.4376C15.2809 22.4376 18.3944 20.7648 20.3626 18.1742L16.4044 14.1744C16.0165 14.8918 15.4655 15.508 14.8011 15.9733C14.11 16.5126 13.1309 16.9535 11.7765 16.9535C11.6129 16.9535 11.4866 16.9344 11.3938 16.8983C9.71565 16.7659 8.26103 15.8398 7.40455 14.4956L10.2063 11.6938C6.65754 11.7078 2.64851 11.7159 1.00029 11.692",
            fill: "none",
            strokeWidth: "0.5",
            strokeLinecap: "square"
          }
        )
      ]
    }
  );
}
function uk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "21",
      height: "23",
      viewBox: "0 0 21 23",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.79268 22.0883C8.03229 22.6214 9.37152 22.8844 10.7207 22.8596C12.0699 22.835 13.3984 22.5231 14.6178 21.945C16.83 20.9346 18.5971 19.1514 19.5878 16.9303C21.4336 12.5935 19.7999 6.41694 14.4297 4.13209C12.3462 3.2583 10.024 3.13392 7.85891 3.77978L8.6235 1.716L6.38345 0.888672L4.25674 6.63495L9.78221 9.32292L10.8216 7.17245L8.56964 6.08224L8.56944 6.08245C10.1945 5.60744 11.9327 5.70014 13.4977 6.34516C16.3411 7.53976 19.2738 11.5839 17.3805 16.0073C16.6159 17.6744 15.2798 19.0126 13.6142 19.7796C11.7631 20.6697 9.61634 20.7101 7.73293 19.8901C6.48079 19.3556 5.40349 18.4806 4.62368 17.3644C3.84386 16.2483 3.39281 14.9358 3.32156 13.5762L0.932129 13.7524C1.21588 17.5454 3.40531 20.6486 6.79254 22.0881L6.79268 22.0883Z"
        }
      )
    }
  );
}
function ck(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "43",
      height: "36",
      viewBox: "0 0 43 36",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.8215 35.0926L1.23971 16.2129C0.965302 15.8379 0.820312 15.3926 0.820312 14.9249V2.66362C0.820312 2.08549 1.04176 1.5421 1.44386 1.13356C1.84682 0.725 2.38163 0.5 2.94977 0.5H15.0176C15.6891 0.50088 16.3284 0.82857 16.7276 1.37656L27.2326 12.0505C25.0306 13.9778 23.7678 16.7746 23.7678 19.7251C23.7678 23.7767 26.1355 27.4293 29.8 29.0305C29.6392 29.2038 29.494 29.3552 29.3566 29.4948C26.7197 32.1732 23.4226 34.1089 19.822 35.0925L19.8215 35.0926ZM10.6579 6.44148C9.59225 6.44236 8.59058 6.86431 7.83736 7.6296C7.08415 8.3949 6.66886 9.41263 6.66799 10.4953C6.66799 11.5776 7.08267 12.596 7.83565 13.3628C8.57766 14.1175 9.60538 14.5509 10.6553 14.5518C11.7235 14.5518 12.7273 14.1302 13.4818 13.3645C14.2361 12.5971 14.6511 11.5773 14.6503 10.4927C14.6494 9.42597 14.2229 8.38176 13.48 7.62787C12.7262 6.86282 11.7239 6.44149 10.6578 6.44149L10.6579 6.44148Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            stroke: "none",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M34.3106 11.0938C29.5693 11.0938 25.8008 14.8622 25.8008 19.6036C25.8008 24.345 29.5693 28.1135 34.3106 28.1135C39.0521 28.1135 42.8205 24.345 42.8205 19.6036C42.8205 14.8622 39.0521 11.0938 34.3106 11.0938ZM39.1734 20.8193H35.5264H33.0949H29.4479V18.388H33.0949H35.5264H39.1734V20.8193Z"
          }
        )
      ]
    }
  );
}
function dk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      height: "15",
      viewBox: "0 0 24 24",
      width: "15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#11AD84",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "m18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4h-12c-2.206 0-4-1.794-4-4v-12c0-2.206 1.794-4 4-4zm0-2h-12c-3.314 0-6 2.686-6 6v12c0 3.314 2.686 6 6 6h12c3.314 0 6-2.686 6-6v-12c0-3.314-2.686-6-6-6z" }),
        /* @__PURE__ */ u.jsx("path", { d: "m9.957 17c-.253 0-.505-.096-.7-.286l-2.857-2.8c-.394-.386-.4-1.019-.014-1.414.387-.395 1.021-.4 1.414-.015l2.157 2.115 6.442-6.314c.395-.386 1.028-.382 1.414.014.387.394.381 1.028-.013 1.414l-7.143 7c-.195.19-.447.286-.7.286z" })
      ]
    }
  );
}
function pk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "14",
      height: "15",
      viewBox: "0 0 14 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.94569 14.5339C10.7817 14.5339 13.8914 11.4243 13.8914 7.58826C13.8914 3.75227 10.7817 0.642578 6.94569 0.642578C3.10969 0.642578 0 3.75227 0 7.58826C0 11.4243 3.10969 14.5339 6.94569 14.5339Z",
            fill: "#11AD84"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M9.95478 5.61133L5.83468 9.73143L3.96191 7.85866",
            stroke: "#F1F4F8",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function fk({
  checkmarkClassName: e,
  ...t
}) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ u.jsxs("g", { stroke: "CurrentColor", children: [
        /* @__PURE__ */ u.jsx("path", { d: "M14.032 7.58875C14.032 11.0105 11.2581 13.7844 7.83631 13.7844C4.41453 13.7844 1.64062 11.0105 1.64062 7.58875C1.64062 4.16697 4.41453 1.39307 7.83631 1.39307C11.2581 1.39307 14.032 4.16697 14.032 7.58875Z" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M10.95576 5.43359L6.83566 9.55369L4.96289 7.68092",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: e
          }
        )
      ] })
    }
  );
}
function hk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100",
      height: "98",
      viewBox: "0 0 100 98",
      fill: "#CBD5E1",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsxs(
          "linearGradient",
          {
            id: "linear-gradient",
            x1: "4.606",
            y1: "-1.004",
            x2: "4.606",
            y2: "8.832",
            gradientUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ u.jsx("stop", { offset: "0", stopColor: "#64748b" }),
              /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#003c68" })
            ]
          }
        ) }),
        /* @__PURE__ */ u.jsxs("g", { id: "cancel", transform: "translate(-10 -12)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22885",
              "data-name": "Tracé 22885",
              d: "M101,12H19a5,5,0,0,0-5,5v1h92V17A5,5,0,0,0,101,12Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22886",
              "data-name": "Tracé 22886",
              d: "M54.122,41.294H58v6.5H54.122a2.908,2.908,0,0,1-2.33-.951,3.735,3.735,0,0,1,0-4.6A2.908,2.908,0,0,1,54.122,41.294Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22887",
              "data-name": "Tracé 22887",
              d: "M60,58a25.985,25.985,0,1,0,10.851,2.366A26.038,26.038,0,0,0,60,58ZM51.586,75.586a2,2,0,0,1,2.828,0L60,81.172l5.586-5.586a2,2,0,0,1,2.828,2.828L62.828,84l5.586,5.586a2,2,0,0,1-2.828,2.828L60,86.828l-5.586,5.586a2,2,0,0,1-2.828-2.828L57.172,84l-5.586-5.586A2,2,0,0,1,51.586,75.586Z",
              fillRule: "evenodd"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22888",
              "data-name": "Tracé 22888",
              d: "M72.792,56.856A7.987,7.987,0,0,0,73,55.044a7.517,7.517,0,0,0-1.77-4.92,6.9,6.9,0,0,0-5.353-2.33H62v-6.5h6.8a2,2,0,0,0,0-4H62v-2a2,2,0,0,0-4,0v2H54.122a6.9,6.9,0,0,0-5.352,2.33,7.724,7.724,0,0,0,0,9.839,6.9,6.9,0,0,0,5.352,2.33H58v2.272A30.02,30.02,0,0,0,31.079,76h-6.11C24.475,68.132,18.174,62.455,10,62.026V35.972A15.513,15.513,0,0,0,24.888,22H95.112A15.513,15.513,0,0,0,110,35.972V62.026c-8.174.429-14.475,6.106-14.969,13.974h-6.11A30.074,30.074,0,0,0,72.792,56.856Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22889",
              "data-name": "Tracé 22889",
              d: "M62,54.066V51.794h3.878a2.909,2.909,0,0,1,2.33.951,3.59,3.59,0,0,1,.779,2.625A29.9,29.9,0,0,0,62,54.066Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22890",
              "data-name": "Tracé 22890",
              d: "M105,76H99.043c.472-5.44,4.791-9.565,10.957-9.968V71A5,5,0,0,1,105,76Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22891",
              "data-name": "Tracé 22891",
              d: "M10,66.032c6.166.4,10.485,4.528,10.957,9.968H15a5,5,0,0,1-5-5Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22892",
              "data-name": "Tracé 22892",
              d: "M20.854,22A11.489,11.489,0,0,1,10,31.964V27a5,5,0,0,1,5-5Z"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_22893",
              "data-name": "Tracé 22893",
              d: "M110,31.964A11.488,11.488,0,0,1,99.146,22H105a5,5,0,0,1,5,5Z"
            }
          )
        ] })
      ]
    }
  );
}
function mk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "23",
      height: "28",
      viewBox: "0 0 23 18",
      fill: "#ACB8D1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.596903 0.917895H22.0412V17.965H0.596903V0.917895Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.4904 11.5919C14.4889 12.8741 13.51 13.7907 11.9891 14.0086V15.2422H10.4494V13.9815C9.56536 13.8131 8.7314 13.3834 8.1574 12.7757L9.27598 11.7165C9.72924 12.1961 10.5288 12.5187 11.2642 12.5187C12.0426 12.5187 12.9512 12.2747 12.9512 11.5884L12.9512 11.5824C12.9574 10.7646 12.4136 10.5177 11.0744 10.1125C10.4491 9.92271 9.80186 9.72672 9.27112 9.36168C8.57333 8.88354 8.21849 8.20563 8.21849 7.35083C8.21849 6.13028 9.08072 5.23477 10.4494 4.93337V3.64022H11.9892V4.84862C12.7328 4.92422 13.4859 5.1678 14.0361 5.52488L13.2014 6.81895C12.7804 6.54715 12.1025 6.36375 11.5132 6.36375C10.7041 6.36375 9.75897 6.62279 9.75897 7.35084C9.75897 8.00445 10.155 8.22269 11.5203 8.63705C12.1757 8.83489 12.8534 9.04079 13.4118 9.43549C14.1347 9.94814 14.4972 10.6741 14.4904 11.5919L14.4904 11.5919Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function gk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "white",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5606 3.06065L10.9393 0.43934C10.658 0.15804 10.2765 0 9.87869 0H1.5C0.67156 0 0 0.67156 0 1.5V12.5C0 13.3284 0.67156 14 1.5 14H12.5C13.3284 14 14 13.3284 14 12.5V4.12132C14 3.7235 13.842 3.34197 13.5607 3.06067L13.5606 3.06065ZM7 12C5.89544 12 5 11.1046 5 9.99999C5 8.89543 5.89544 7.99999 7 7.99999C8.10456 7.99999 9 8.89543 9 9.99999C9 11.1046 8.10456 12 7 12ZM10 2.48374V5.62499C10 5.83208 9.83209 5.99999 9.625 5.99999H2.375C2.16791 5.99999 2 5.83208 2 5.62499V2.37499C2 2.1679 2.16791 1.99999 2.375 1.99999H9.51625C9.61572 1.99999 9.71109 2.03949 9.78141 2.10983L9.89016 2.21858C9.9605 2.28889 10 2.38428 10 2.48374Z"
        }
      )
    }
  );
}
function fh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 17 16",
      fill: "none",
      stroke: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2107 7.17079C14.2107 10.5788 11.448 13.3416 8.03993 13.3416C4.6319 13.3416 1.86914 10.5788 1.86914 7.17079C1.86914 3.76276 4.6319 1 8.03993 1C11.448 1 14.2107 3.76276 14.2107 7.17079Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M15.7538 14.8847L12.3984 11.5293",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
const Ck = (e) => /* @__PURE__ */ u.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "318", height: "114", viewBox: "0 0 318 114", ...e, children: /* @__PURE__ */ u.jsx(
  "image",
  {
    width: "318",
    height: "114",
    xlinkHref: "data:img/png;base64,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"
  }
) });
function vk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "37",
      height: "37",
      viewBox: "0 0 37 37",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.0855 14.5284C26.3503 14.1908 26.317 13.7074 26.0075 13.41C25.6981 13.1126 25.2138 13.0981 24.8871 13.3762L9.90817 26.1196L1.99827 23.0607C1.53692 22.8838 1.16117 22.537 0.949013 22.091C0.736423 21.6453 0.703483 21.1345 0.856983 20.6652C1.01048 20.1958 1.33884 19.8036 1.77364 19.5694L34.612 1.17392C34.9576 0.987858 35.3595 0.933618 35.742 1.02161C36.125 1.10921 36.4625 1.33345 36.6924 1.65173C36.9223 1.97041 37.0284 2.36142 36.9914 2.75241L34.1108 32.7791C34.0522 33.4036 33.7025 33.9639 33.1672 34.2905C32.6316 34.6172 31.9737 34.6722 31.3914 34.4384L21.7648 30.7111L15.7212 36.3742C15.4222 36.6535 15.0255 36.8046 14.6165 36.7941C14.207 36.7841 13.8184 36.6133 13.5339 36.3195C13.249 36.0254 13.0914 35.6312 13.0942 35.2221V30.7747L26.0855 14.5284Z"
        }
      )
    }
  );
}
function bk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2081 19.565C12.6186 19.565 12.0637 19.2471 11.7598 18.7358L11.6494 18.5464C11.2143 17.7871 10.6315 17.3692 10.0083 17.3692C9.38512 17.3692 8.79943 17.7871 8.35924 18.5464L8.24999 18.7358C7.94591 19.2471 7.39074 19.565 6.80102 19.565C6.50817 19.565 6.22045 19.4858 5.96923 19.3364L4.23962 18.3467C3.33422 17.8252 3.02002 16.6631 3.5393 15.7559C3.97936 14.9971 4.05065 14.2817 3.73986 13.7427C3.42907 13.2031 2.77563 12.9062 1.90002 12.9062C0.85229 12.9062 0 12.0542 0 11.0063V9.2461C0 8.19923 0.85229 7.34717 1.90002 7.34717C2.77539 7.34717 3.42883 7.0503 3.73974 6.51074C4.05053 5.9707 3.97936 5.25537 3.5393 4.49658C3.2871 4.05957 3.22143 3.54834 3.35424 3.05615C3.48693 2.56494 3.80138 2.15625 4.23962 1.90576L5.96923 0.9165C6.22094 0.7666 6.50841 0.6875 6.80077 0.6875C7.39025 0.6875 7.94555 1.00537 8.24999 1.5166L8.35924 1.70703C8.79442 2.46631 9.37743 2.88428 10.0008 2.88428C10.6243 2.88428 11.2097 2.46631 11.6494 1.70703L11.7598 1.5166C12.0642 1.00537 12.6194 0.6875 13.2086 0.6875C13.5008 0.6875 13.7881 0.7666 14.0394 0.9165L15.7701 1.90576C16.2085 2.15625 16.5229 2.56543 16.6555 3.05664C16.7881 3.54834 16.7219 4.05957 16.4693 4.49658C16.0295 5.25586 15.9587 5.9707 16.27 6.51074C16.5809 7.05029 17.2344 7.34717 18.1097 7.34717C19.1574 7.34717 20.0097 8.19922 20.0097 9.2461V11.0063C20.0097 12.0542 19.1574 12.9062 18.1097 12.9062C17.2341 12.9062 16.5807 13.2031 16.2699 13.7427C15.9588 14.2817 16.0298 14.9971 16.4693 15.7559C16.9896 16.666 16.676 17.8281 15.7701 18.3467L14.0394 19.3364C13.7878 19.4858 13.5003 19.565 13.2081 19.565ZM9.99914 6.875C8.20703 6.875 6.74902 8.33301 6.74902 10.125C6.74902 11.9175 8.20703 13.3755 9.99914 13.3755C11.7913 13.3755 13.2493 11.9175 13.2493 10.125C13.2493 8.33301 11.7913 6.875 9.99914 6.875Z"
        }
      )
    }
  );
}
function yk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "139",
      height: "35",
      viewBox: "0 0 139 35",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("g", { clipPath: "url(#clip0_301_2165)", children: /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.94672 23.1983C7.69748 23.2473 8.44994 23.1376 9.16032 22.8754C9.37642 22.7621 9.55445 22.5811 9.67033 22.357C9.78621 22.1329 9.83435 21.8764 9.80823 21.6224C9.78817 21.35 9.69982 21.0883 9.55233 20.8642C9.40483 20.6402 9.20355 20.462 8.96928 20.348C8.15282 19.8581 7.2972 19.4454 6.41236 19.1148C5.58834 18.794 4.78 18.4296 3.99036 18.0231C3.30917 17.6792 2.68413 17.2222 2.13879 16.6695C1.62573 16.1371 1.22306 15.4972 0.956509 14.7906C0.658156 13.952 0.515714 13.0601 0.537035 12.1641C0.504253 11.2555 0.677761 10.3519 1.04297 9.52923C1.40818 8.70653 1.95441 7.98879 2.63575 7.43636C4.31731 6.1869 6.34723 5.57482 8.39751 5.69904C9.57539 5.69459 10.751 5.80932 11.9083 6.04169C12.8172 6.21072 13.7109 6.46081 14.5801 6.78929L13.5875 11.4774C12.8802 11.2216 12.1604 11.0061 11.4314 10.8317C10.5727 10.6337 9.69571 10.5387 8.81699 10.5485C7.03578 10.5485 6.14517 11.0738 6.14517 12.1244C6.14159 12.3456 6.18022 12.5652 6.25873 12.7701C6.36279 12.9923 6.52098 13.181 6.71694 13.3166C7.01292 13.5332 7.32576 13.7227 7.65208 13.883C8.04662 14.085 8.54936 14.3073 9.16032 14.5499C10.2218 14.9485 11.2545 15.4283 12.2503 15.9856C12.9691 16.3798 13.6206 16.8985 14.178 17.5205C14.6345 18.0475 14.9733 18.6766 15.1692 19.3612C15.3709 20.124 15.4672 20.9138 15.4551 21.7059C15.5039 22.6376 15.3241 23.5668 14.9334 24.403C14.5427 25.2392 13.9543 25.9539 13.2255 26.4775C11.3192 27.6705 9.12051 28.2335 6.91065 28.0945C4.54874 28.1505 2.19982 27.7092 0 26.7961L0.953839 21.9056C1.91938 22.3092 2.91495 22.627 3.93024 22.8556C4.92077 23.0813 5.9309 23.1961 6.94405 23.1983H6.94672ZM35.825 6.26399C34.6806 10.3597 33.485 14.1992 32.2381 17.7824C30.9913 21.3656 29.6304 24.8417 28.1556 28.2106C27.6942 29.2816 27.1584 30.3148 26.5525 31.3015C26.0687 32.0901 25.4771 32.7982 24.7971 33.4027C24.1617 33.9548 23.4286 34.3669 22.641 34.6148C21.7284 34.8865 20.7833 35.0158 19.8356 34.9985C19.0088 35.0054 18.1838 34.9176 17.3748 34.7365C16.7429 34.5995 16.1238 34.4034 15.5246 34.1503L16.5172 29.3362C17.0259 29.5307 17.5492 29.6794 18.0815 29.7808C18.5607 29.863 19.0455 29.9033 19.531 29.9012C19.9572 29.9312 20.3847 29.8698 20.788 29.7207C21.1913 29.5715 21.5621 29.3377 21.8782 29.0332C22.4916 28.3395 22.9653 27.5205 23.2702 26.6262C21.9726 23.9369 20.6727 20.9139 19.3707 17.5573C17.9626 13.863 16.7399 10.0923 15.7076 6.26116H21.7366C21.9913 7.31176 22.2901 8.45015 22.6329 9.67633C22.9758 10.9025 23.3383 12.1419 23.7204 13.3945C24.1016 14.6481 24.4894 15.8672 24.8839 17.0518C25.2785 18.2365 25.6534 19.314 26.0088 20.2843C26.3401 19.3158 26.6839 18.2383 27.0401 17.0518C27.3963 15.8653 27.7459 14.6462 28.0888 13.3945C28.4317 12.141 28.7625 10.9016 29.0814 9.67633C29.4002 8.4511 29.6865 7.3127 29.9404 6.26116L35.825 6.26399ZM42.9534 23.1983C43.7042 23.2474 44.4567 23.1377 45.167 22.8754C45.3831 22.7621 45.5612 22.5811 45.677 22.357C45.7929 22.1329 45.8411 21.8764 45.8149 21.6224C45.7947 21.35 45.7063 21.0884 45.5589 20.8644C45.4114 20.6404 45.2102 20.4621 44.976 20.348C44.1595 19.8585 43.3039 19.4463 42.4191 19.1162C41.595 18.7956 40.7866 18.4313 39.9971 18.0245C39.316 17.6804 38.691 17.2235 38.1455 16.6709C37.6324 16.1386 37.2297 15.4987 36.9632 14.792C36.6644 13.9535 36.5215 13.0616 36.5424 12.1655C36.5096 11.257 36.6831 10.3533 37.0484 9.53065C37.4136 8.70795 37.9598 7.99021 38.6411 7.43778C40.3227 6.18821 42.3526 5.57613 44.4029 5.70046C45.5808 5.69596 46.7564 5.8107 47.9137 6.0431C48.8225 6.2121 49.7163 6.46219 50.5855 6.79071L49.5929 11.4788C48.8855 11.2231 48.1658 11.0076 47.4367 10.8331C46.5781 10.6352 45.7011 10.5402 44.8224 10.5499C43.0412 10.5499 42.1506 11.0752 42.1506 12.1259C42.147 12.347 42.1856 12.5666 42.2641 12.7715C42.3679 12.9939 42.5262 13.1827 42.7223 13.3181C43.0183 13.5347 43.3311 13.7241 43.6575 13.8844C44.052 14.0864 44.5543 14.3087 45.1644 14.5513C46.2262 14.95 47.2594 15.4298 48.2557 15.987C48.9745 16.3811 49.626 16.8999 50.1834 17.5219C50.6401 18.0489 50.9793 18.678 51.1759 19.3626C51.3776 20.1254 51.4739 20.9152 51.4618 21.7073C51.5098 22.6392 51.3293 23.5683 50.9378 24.4042C50.5464 25.2402 49.9574 25.9545 49.2282 26.4775C47.3219 27.6703 45.1232 28.2333 42.9134 28.0945C40.5532 28.1515 38.2057 27.7121 36.0067 26.8018L36.9619 21.9112C37.9274 22.315 38.923 22.6328 39.9383 22.8613C40.9288 23.0868 41.939 23.2017 42.9521 23.2039L42.9534 23.1983ZM53.821 0.968483L59.504 0V6.26399H66.3345V11.2763H59.504V18.7537C59.4571 19.805 59.6742 20.8506 60.1332 21.7838C60.4216 22.1964 60.8094 22.5193 61.256 22.7185C61.7025 22.9178 62.1914 22.9862 62.6714 22.9165C63.3045 22.9145 63.9361 22.8533 64.5591 22.7339C65.1641 22.6257 65.7582 22.4569 66.3332 22.2298L67.1347 26.9179C66.3903 27.233 65.625 27.4895 64.845 27.6853C63.8299 27.9198 62.7924 28.0282 61.7537 28.0081C60.4404 28.0512 59.1317 27.8248 57.8996 27.3412C56.9519 26.95 56.1125 26.3121 55.4589 25.4864C54.8261 24.6418 54.3883 23.6522 54.1804 22.5965C53.9282 21.3616 53.8063 20.1008 53.817 18.8373L53.821 0.968483ZM68.3116 17.0561C68.278 15.3633 68.5566 13.6799 69.1319 12.1004C69.6207 10.7798 70.3538 9.5763 71.288 8.56059C72.162 7.63008 73.2081 6.9012 74.3606 6.41974C75.4956 5.93907 76.7066 5.69207 77.9288 5.69196C79.1748 5.62397 80.4203 5.83538 81.584 6.31237C82.7476 6.78936 83.8032 7.52119 84.6818 8.46006C86.475 10.73 87.3647 13.6502 87.1626 16.603C87.1626 16.9541 87.1497 17.3383 87.1239 17.7555C87.0985 18.1732 87.0731 18.5428 87.0477 18.867H74.1509C74.2011 19.4569 74.3743 20.0277 74.658 20.538C74.9417 21.0483 75.3288 21.4854 75.7914 21.8178C76.9497 22.6022 78.3101 22.9839 79.6829 22.9094C80.7138 22.9108 81.7425 22.8094 82.7555 22.6064C83.5996 22.454 84.4253 22.2033 85.2175 21.8588L85.9817 26.748C85.5877 26.9453 85.1788 27.1073 84.7593 27.2322C84.2011 27.4066 83.6343 27.5484 83.0614 27.657C82.4375 27.7773 81.7722 27.8793 81.0575 27.96C80.3476 28.0408 79.6341 28.0814 78.9201 28.0818C77.3128 28.1186 75.7137 27.8303 74.2083 27.2322C72.9556 26.728 71.8224 25.9387 70.8886 24.92C70.0031 23.9222 69.3382 22.7281 68.9422 21.4241C68.5139 20.014 68.3015 18.5402 68.313 17.0589L68.3116 17.0561ZM81.6707 14.7524C81.6462 14.2456 81.5632 13.744 81.4236 13.2586C81.29 12.786 81.0693 12.3461 80.7743 11.9644C80.4704 11.5765 80.0937 11.2597 79.6682 11.0342C79.1502 10.775 78.5815 10.6502 78.009 10.6703C77.4449 10.6552 76.8847 10.7727 76.3685 11.0144C75.9302 11.2275 75.5398 11.5374 75.2236 11.9234C74.913 12.3102 74.6737 12.7554 74.5183 13.2359C74.3545 13.7283 74.2333 14.2354 74.1562 14.751L81.6707 14.7524ZM100.896 16.249C100.997 14.8336 100.753 13.4145 100.189 12.1273C99.9262 11.7123 99.5622 11.3804 99.1358 11.1668C98.7095 10.9531 98.2365 10.8657 97.7671 10.9138C97.3972 10.9145 97.0276 10.9348 96.6596 10.9747C96.2789 11.0158 95.9101 11.0611 95.5535 11.1163V27.5225H89.8678V6.99176C90.3528 6.85017 90.9165 6.71566 91.5658 6.56699C92.215 6.41832 92.9017 6.28381 93.6257 6.16346C94.3498 6.0431 95.0952 5.94824 95.8594 5.88028C96.6235 5.81231 97.373 5.77975 98.1117 5.77975C99.3127 5.73594 100.51 5.93488 101.641 6.36593C102.452 6.6989 103.206 7.16999 103.873 7.7606C105.561 6.52895 107.549 5.84058 109.598 5.77833C110.946 5.73054 112.29 5.97132 113.548 6.48629C114.521 6.91143 115.37 7.60168 116.009 8.48697C116.639 9.39858 117.07 10.4478 117.269 11.5581C117.508 12.8641 117.622 14.1923 117.611 15.5226V27.5253H111.924V16.2476C112.025 14.8325 111.783 13.4134 111.22 12.1259C110.956 11.7111 110.592 11.3794 110.165 11.1658C109.739 10.9522 109.266 10.8647 108.796 10.9124C108.362 10.9351 107.932 11.0165 107.517 11.1545C107.04 11.2848 106.584 11.489 106.163 11.7606C106.344 12.3991 106.459 13.0567 106.507 13.7216C106.556 14.4088 106.582 15.1432 106.583 15.9247V27.5239H100.897L100.896 16.249ZM120.119 17.0575C120.086 15.3647 120.365 13.6814 120.94 12.1018C121.429 10.781 122.162 9.57733 123.097 8.56201C123.971 7.63099 125.017 6.90203 126.17 6.42115C127.305 5.94028 128.516 5.69327 129.738 5.69338C130.984 5.62512 132.23 5.8364 133.393 6.3134C134.557 6.79041 135.613 7.52239 136.491 8.46148C138.284 10.7314 139.174 13.6516 138.972 16.6044C138.972 16.9555 138.959 17.3397 138.934 17.7569C138.908 18.1746 138.884 18.5442 138.857 18.8684H125.959C126.009 19.4585 126.182 20.0293 126.466 20.5397C126.75 21.05 127.138 21.487 127.601 21.8192C128.759 22.6038 130.119 22.9855 131.492 22.9108C132.523 22.9122 133.552 22.8108 134.565 22.6078C135.409 22.4553 136.234 22.2045 137.027 21.8602L137.791 26.7494C137.397 26.9467 136.988 27.1087 136.569 27.2336C136.01 27.4077 135.443 27.5495 134.871 27.6584C134.247 27.7792 133.579 27.8802 132.867 27.9614C132.157 28.0422 131.443 28.0828 130.729 28.0832C129.122 28.1202 127.522 27.8319 126.016 27.2336C124.763 26.7259 123.629 25.9327 122.696 24.9101C121.81 23.9129 121.146 22.7185 120.751 21.4142C120.322 20.0043 120.109 18.5304 120.121 17.049L120.119 17.0575ZM133.479 14.7538C133.454 14.247 133.37 13.7453 133.23 13.26C133.098 12.7872 132.877 12.3472 132.582 11.9659C132.277 11.5782 131.9 11.2615 131.475 11.0356C130.957 10.776 130.388 10.6513 129.815 10.6717C129.251 10.6563 128.691 10.7738 128.175 11.0158C127.737 11.2288 127.346 11.5388 127.03 11.9248C126.719 12.3116 126.48 12.7569 126.325 13.2373C126.16 13.7296 126.039 14.2367 125.961 14.7524L133.479 14.7538Z",
            fill: "#00A0FF"
          }
        ) }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_301_2165", children: /* @__PURE__ */ u.jsx("rect", { width: "139", height: "35", fill: "white" }) }) })
      ]
    }
  );
}
function wk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "13",
      height: "18",
      viewBox: "0 0 13 18",
      fill: "#5C5F62",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M10.5 14C11.6046 14 12.5 14.8954 12.5 16C12.5 17.1046 11.6046 18 10.5 18C9.3954 18 8.5 17.1046 8.5 16C8.5 14.8954 9.3954 14 10.5 14ZM2.5 14C3.60457 14 4.5 14.8954 4.5 16C4.5 17.1046 3.60457 18 2.5 18C1.39543 18 0.5 17.1046 0.5 16C0.5 14.8954 1.39543 14 2.5 14ZM10.5 7C11.6046 7 12.5 7.8954 12.5 9C12.5 10.1046 11.6046 11 10.5 11C9.3954 11 8.5 10.1046 8.5 9C8.5 7.8954 9.3954 7 10.5 7ZM2.5 7C3.60457 7 4.5 7.8954 4.5 9C4.5 10.1046 3.60457 11 2.5 11C1.39543 11 0.5 10.1046 0.5 9C0.5 7.8954 1.39543 7 2.5 7ZM10.5 0C11.6046 0 12.5 0.89543 12.5 2C12.5 3.10457 11.6046 4 10.5 4C9.3954 4 8.5 3.10457 8.5 2C8.5 0.89543 9.3954 0 10.5 0ZM2.5 0C3.60457 0 4.5 0.89543 4.5 2C4.5 3.10457 3.60457 4 2.5 4C1.39543 4 0.5 3.10457 0.5 2C0.5 0.89543 1.39543 0 2.5 0Z" })
    }
  );
}
function Sk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15.238095238095237",
      height: "16",
      viewBox: "0 0 20 21",
      fill: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.571349 20.5938C0.415649 20.6309 0.251629 20.5849 0.137909 20.4724C0.0239292 20.3598 -0.0238008 20.1967 0.0113392 20.0404L1.0385 15.4004L5.10503 19.4875L0.571349 20.5938ZM6.20639 18.3818L2.14017 14.2939L12.4363 3.94508L16.5051 8.03305L6.20639 18.3818ZM19.592 4.93402L17.5649 6.97089L13.4961 2.88292L15.2338 1.13669C15.5704 0.798368 16.0281 0.608398 16.5052 0.608398C16.9826 0.608398 17.4401 0.798368 17.7769 1.13669L19.592 2.95979C19.8532 3.22178 20 3.57693 20 3.94691C20 4.3172 19.8532 4.67202 19.592 4.93403V4.93402Z"
        }
      )
    }
  );
}
function _k(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "45",
      height: "26",
      viewBox: "0 0 45 26",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M40.2636 10.1633C40.2636 12.6577 38.2417 14.6796 35.7472 14.6796C33.2528 14.6796 31.2305 12.6577 31.2305 10.1633C31.2305 7.66881 33.2528 5.64648 35.7472 5.64648C38.2417 5.64648 40.2636 7.66882 40.2636 10.1633Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.2136 25.4062C44.21 22.5006 42.7174 19.7998 40.2588 18.2508C37.8005 16.7019 34.7197 16.5215 32.0977 17.773C33.3721 19.7024 34.0514 21.9641 34.051 24.2771V25.4061L44.2136 25.4062Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.9863 10.1633C12.9863 12.6577 10.9639 14.6796 8.46948 14.6796C5.97503 14.6796 3.95312 12.6577 3.95312 10.1633C3.95312 7.66881 5.97503 5.64648 8.46948 5.64648C10.9639 5.64648 12.9863 7.66882 12.9863 10.1633Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.00401625 25.4062H10.1665V24.2771C10.1661 21.9642 10.8455 19.7024 12.1199 17.7731C9.49777 16.5215 6.41697 16.7019 3.95872 18.2508C1.50006 19.7996 0.00753625 22.5004 0.00390625 25.4062H0.00401625Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.3197 6.21022C28.3197 9.64037 25.5389 12.4208 22.1091 12.4208C18.6792 12.4208 15.8984 9.64046 15.8984 6.21022C15.8984 2.78036 18.6792 0 22.1091 0C25.5389 0 28.3197 2.78036 28.3197 6.21022Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.2388 14.6787H20.9806C18.435 14.6787 15.9936 15.69 14.1939 17.4902C12.3938 19.29 11.3828 21.7313 11.3828 24.2769V25.406H32.837V24.2769C32.837 21.7313 31.826 19.2899 30.0258 17.4902C28.226 15.6901 25.7848 14.6787 23.2392 14.6787H23.2388Z"
          }
        )
      ]
    }
  );
}
function xk(e) {
  return /* @__PURE__ */ u.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ u.jsx("path", { d: "M18,2a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2Zm0-2H6A6,6,0,0,0,0,6V18a6,6,0,0,0,6,6H18a6,6,0,0,0,6-6V6A6,6,0,0,0,18,0Z" }) });
}
function Mk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0994 0H6.71524C3.07343 0 0.902344 2.17 0.902344 5.81V14.18C0.902344 17.83 3.07342 20 6.71524 20H15.0894C18.7312 20 20.9023 17.83 20.9023 14.19V5.81C20.9123 2.17 18.7412 0 15.0994 0Z",
            className: "ui-fill-white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3312 5.8099V14.1899C15.3312 14.8299 14.8109 15.3499 14.1706 15.3499C13.5203 15.3499 13 14.8299 13 14.1899V5.8099C13 5.1699 13.5203 4.6499 14.1706 4.6499C14.8109 4.6499 15.3312 5.1699 15.3312 5.8099Z",
            className: "ui-fill-blue"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.81554 10.93V14.19C8.81554 14.83 8.29527 15.35 7.64496 15.35C7.00464 15.35 6.48438 14.83 6.48438 14.19V10.93C6.48438 10.29 7.00464 9.77002 7.64496 9.77002C8.29528 9.77002 8.81554 10.29 8.81554 10.93Z",
            className: "ui-fill-blue"
          }
        )
      ]
    }
  );
}
function kk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21.5",
      height: "21.5",
      viewBox: "0 0 21.5 21.5",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { id: "Layer_2", "data-name": "Layer 2", transform: "translate(-1.25 -1.25)", children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Tracé_43",
            "data-name": "Tracé 43",
            d: "M12,22.75A10.762,10.762,0,0,1,1.25,12a.75.75,0,0,1,1.5,0A9.25,9.25,0,1,0,12,2.75a.75.75,0,1,1,0-1.5,10.75,10.75,0,0,1,0,21.5Z",
            fill: "#ffc107"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "Tracé_44",
            "data-name": "Tracé 44",
            d: "M12,22.75a10.744,10.744,0,0,1-3.176-.477.75.75,0,1,1,.443-1.433A9.257,9.257,0,0,0,12,21.25a.75.75,0,1,1,0,1.5ZM5.56,20.4a.742.742,0,0,1-.483-.176A10.74,10.74,0,0,1,2.42,16.882.75.75,0,0,1,3.756,16.2a9.236,9.236,0,0,0,2.287,2.877A.749.749,0,0,1,5.56,20.4ZM2.144,14.456a.751.751,0,0,1-.738-.623,10.839,10.839,0,0,1,.121-4.267A.75.75,0,0,1,2.988,9.9a9.358,9.358,0,0,0-.1,3.675.75.75,0,0,1-.612.866.8.8,0,0,1-.132.015ZM3.909,6.872A.749.749,0,0,1,3.3,5.681,10.808,10.808,0,0,1,5.557,3.4a.75.75,0,0,1,.9,1.2A9.3,9.3,0,0,0,4.516,6.563a.75.75,0,0,1-.607.309ZM9.6,3.041a.75.75,0,0,1-.18-1.478A10.758,10.758,0,0,1,12,1.25a.75.75,0,1,1,0,1.5,9.255,9.255,0,0,0-2.224.27.8.8,0,0,1-.176.021Z",
            fill: "#ffc107"
          }
        ),
        /* @__PURE__ */ u.jsxs("g", { id: "Groupe_40", "data-name": "Groupe 40", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_45",
              "data-name": "Tracé 45",
              d: "M9.171,15.578a.75.75,0,0,1-.53-1.28L14.3,8.642A.75.75,0,0,1,15.359,9.7L9.7,15.358a.748.748,0,0,1-.529.22Z",
              fill: "#ffc107"
            }
          ),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              id: "Tracé_46",
              "data-name": "Tracé 46",
              d: "M14.829,15.578a.748.748,0,0,1-.531-.22L8.641,9.7A.75.75,0,0,1,9.7,8.642L15.359,14.3a.75.75,0,0,1-.53,1.28Z",
              fill: "#ffc107"
            }
          )
        ] })
      ] })
    }
  );
}
function Pk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.0102539 8.9901C0.0102539 4.0248 4.03505 0 9.00035 0C13.9657 0 17.9905 4.0248 17.9905 8.9901C17.9905 13.9554 13.9657 17.9802 9.00035 17.9802C4.03505 17.9802 0.0102539 13.9554 0.0102539 8.9901ZM2.31065 8.9901C2.31065 12.6792 5.31125 15.6798 9.00035 15.6798C12.6895 15.6798 15.6901 12.6792 15.6901 8.9901C15.6901 5.301 12.6895 2.3004 9.00035 2.3004C5.31125 2.3004 2.31065 5.301 2.31065 8.9901ZM6.01055 11.9997V6.0003H12.01V11.9997H6.01055Z"
        }
      )
    }
  );
}
function Tk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "35",
      height: "26",
      viewBox: "0 0 35 26",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.9182 9.49287C34.9132 9.38267 34.8897 9.27367 34.8485 9.1701C34.8391 9.14645 34.8333 9.12257 34.8224 9.09987C34.8164 9.0871 34.8146 9.07315 34.8078 9.06038L30.28 0.58549H30.2798C30.1858 0.40956 30.0413 0.26153 29.8624 0.1582C29.6837 0.05463 29.4776 0 29.2673 0H6.62845C6.41824 0 6.21206 0.05462 6.03343 0.1582C5.85455 0.26153 5.71002 0.40956 5.61603 0.58549L1.08826 9.06038C1.08144 9.07315 1.07967 9.0871 1.0736 9.09987C1.06223 9.12257 1.05667 9.14646 1.04758 9.1701H1.04732C1.00613 9.27367 0.98264 9.38268 0.97758 9.49287C0.97708 9.50753 0.96875 9.51959 0.96875 9.53425V11.653C0.96975 12.4955 1.32778 13.3035 1.96453 13.8991C2.601 14.495 3.46439 14.8301 4.36457 14.8311C4.75116 14.8275 5.13398 14.7615 5.49652 14.6357V25.4249H30.3993V14.6357C30.7619 14.7613 31.1446 14.8275 31.5312 14.8311C32.4315 14.8301 33.2949 14.495 33.9313 13.8991C34.568 13.3035 34.926 12.4954 34.9271 11.653V9.53425C34.9271 9.51959 34.9187 9.50753 34.9182 9.49287ZM28.1356 21.187H7.76062V14.6353C8.33342 14.8361 8.95473 14.8831 9.55453 14.7718C10.1544 14.6601 10.7093 14.3944 11.1565 14.0039C11.7735 14.5355 12.5817 14.8306 13.4204 14.8306C14.259 14.8306 15.0672 14.5355 15.6842 14.0039C16.3013 14.5355 17.1095 14.8306 17.9481 14.8306C18.7867 14.8306 19.595 14.5355 20.212 14.0039C20.829 14.5355 21.6373 14.8306 22.4759 14.8306C23.3145 14.8306 24.1228 14.5355 24.7398 14.0039C25.187 14.3943 25.7419 14.6601 26.3417 14.7718C26.9416 14.8831 27.5629 14.8361 28.1356 14.6353L28.1356 21.187ZM23.6078 10.5934V11.6528C23.6078 12.0313 23.3921 12.381 23.0419 12.5702C22.6917 12.7594 22.2601 12.7594 21.9099 12.5702C21.5597 12.3811 21.344 12.0313 21.344 11.6528V10.5934H23.6078ZM19.0801 10.5934V11.6528C19.0801 12.0313 18.8643 12.381 18.5141 12.5702C18.1639 12.7594 17.7323 12.7594 17.3821 12.5702C17.0319 12.3811 16.8162 12.0313 16.8162 11.6528V10.5934H19.0801ZM14.5523 10.5934V11.6528C14.5523 12.0313 14.3365 12.381 13.9863 12.5702C13.6361 12.7594 13.2046 12.7594 12.8544 12.5702C12.5042 12.3811 12.2884 12.0313 12.2884 11.6528V10.5934H14.5523ZM10.0245 10.5934V11.6528C10.0245 12.0313 9.80874 12.381 9.45855 12.5702C9.10834 12.7594 8.67678 12.7594 8.3266 12.5702C7.9764 12.3811 7.76062 12.0313 7.76062 11.6528V10.5934H10.0245ZM28.1356 11.6528C28.1356 12.0313 27.9198 12.3811 27.5697 12.5702C27.2194 12.7594 26.7879 12.7594 26.4377 12.5702C26.0875 12.3811 25.8717 12.0313 25.8717 11.6528V10.5934H28.1356V11.6528ZM4.36479 12.7121C4.06463 12.7119 3.77685 12.6003 3.5646 12.4016C3.35237 12.203 3.2331 11.9337 3.23286 11.6528V10.5934H5.49675V11.6528C5.49648 11.9337 5.37723 12.203 5.16499 12.4016C4.95276 12.6003 4.66497 12.7119 4.3648 12.7121H4.36479ZM32.6634 11.6528C32.6634 12.0313 32.4476 12.3811 32.0974 12.5702C31.7472 12.7594 31.3157 12.7594 30.9655 12.5702C30.6153 12.3811 30.3995 12.0313 30.3995 11.6528V10.5934H32.6634V11.6528Z"
        }
      )
    }
  );
}
function Ek(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "96",
      height: "40",
      viewBox: "0 0 96 40",
      fill: "#635BFF",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M95.194 20.4663C95.194 13.6969 91.9151 8.35547 85.6481 8.35547C79.3547 8.35547 75.5469 13.6969 75.5469 20.4134C75.5469 28.3728 80.0422 32.3921 86.4943 32.3921C89.641 32.3921 92.0208 31.6781 93.819 30.6733V25.3847C92.0208 26.2838 89.9583 26.8391 87.3404 26.8391C84.7755 26.8391 82.5014 25.94 82.2105 22.8197H95.1411C95.1411 22.476 95.194 21.1009 95.194 20.4663V20.4663ZM82.1328 17.9535C82.1328 14.9655 83.9574 13.7227 85.6233 13.7227C87.2363 13.7227 88.9551 14.9655 88.9551 17.9535H82.1328Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M65.3401 8.35547C62.7487 8.35547 61.0828 9.57185 60.1573 10.418L59.8135 8.77855H53.9961V39.611L60.6068 38.2095L60.6333 30.7262C61.5852 31.4137 62.9867 32.3921 65.3137 32.3921C70.047 32.3921 74.3572 28.5843 74.3572 20.2019C74.3307 12.5334 69.9676 8.35547 65.3401 8.35547H65.3401ZM63.7522 26.5754C62.1921 26.5754 61.2665 26.0201 60.6319 25.3326L60.6055 15.5223C61.293 14.7554 62.2449 14.2266 63.7522 14.2266C66.1585 14.2266 67.8244 16.9237 67.8244 20.3878C67.8244 23.9311 66.1849 26.5754 63.7522 26.5754Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 6.79584L51.5356 5.36792V0L44.8984 1.40147V6.79584Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.8984 8.80469H51.5356V31.9423H44.8984V8.80469Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M37.7871 10.7614L37.364 8.80458H31.6523V31.9421H38.2631V16.2615C39.8232 14.2254 42.4675 14.5956 43.2872 14.8865V8.80458C42.4411 8.48727 39.3472 7.90552 37.7871 10.7614H37.7871Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.5644 3.06641L18.1124 4.44144L18.0859 25.6222C18.0859 29.5358 21.0211 32.4181 24.9347 32.4181C27.103 32.4181 28.6896 32.0214 29.5622 31.5455V26.1775C28.716 26.5213 24.538 27.7377 24.538 23.8241V14.4369H29.5622V8.80453H24.538L24.5644 3.06641Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.69006 15.5215C6.69006 14.4902 7.53624 14.0936 8.93771 14.0936C10.9474 14.0936 13.4859 14.7018 15.4956 15.7859V9.57185C13.3008 8.69923 11.1325 8.35547 8.93771 8.35547C3.56979 8.35547 0 11.1584 0 15.8388C0 23.1371 10.0483 21.9736 10.0483 25.1203C10.0483 26.3367 8.9906 26.7333 7.5098 26.7333C5.31503 26.7333 2.51208 25.8342 0.29087 24.6179V30.9113C2.75006 31.969 5.2357 32.4185 7.5098 32.4185C13.0099 32.4185 16.7913 29.6949 16.7913 24.9616C16.7648 17.0816 6.69007 18.4831 6.69007 15.5215L6.69006 15.5215Z"
          }
        )
      ]
    }
  );
}
function Dk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 19 19",
      fill: "#5C5F62",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3608 9.44301L13.5162 10.0029C12.3305 10.3653 11.1118 10.53 9.89287 10.53C8.67418 10.53 7.45532 10.3653 6.26946 10.0029L4.39184 9.44301C4.35899 9.44301 4.29304 9.41016 4.26019 9.41016C3.79905 10.2665 3.56836 11.2218 3.56836 12.2758C3.56836 15.7344 6.36829 18.5342 9.82674 18.5342C13.2854 18.5342 16.0851 15.7342 16.0851 12.2758C16.0856 11.2547 15.8551 10.2665 15.3609 9.44305C15.394 9.44305 15.394 9.44305 15.3609 9.44305L15.3608 9.44301Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.23129 3.89036L4.06404 4.74671V7.31594C4.06404 7.84301 4.39352 8.30416 4.92039 8.46892L6.76492 9.02885C8.80706 9.62163 10.9811 9.62163 13.0233 9.02885L14.8678 8.46892C15.3618 8.30418 15.7242 7.84302 15.7242 7.31594V4.71389L17.404 4.2199V6.82195H17.3052C17.1735 6.82195 17.0745 6.92075 17.0745 7.05263V8.27131C17.0745 8.40296 17.1733 8.50199 17.3052 8.50199H17.3381L16.9429 9.25952C16.8769 9.42426 16.9757 9.589 17.1405 9.589H18.3263C18.491 9.589 18.6226 9.3914 18.5238 9.25952L18.1287 8.50199H18.1615C18.2932 8.50199 18.3922 8.40319 18.3922 8.27131V7.05263C18.3922 6.92097 18.2934 6.82195 18.1615 6.82195H18.0627V3.98921L18.3591 3.89041C18.8862 3.72567 18.8862 3.001 18.3591 2.83625L10.9814 0.629584C10.5862 0.530784 10.2238 0.464844 9.82841 0.464844C9.43321 0.464844 9.07087 0.530784 8.67544 0.629584L1.23124 2.83649C0.70417 3.00123 0.70417 3.7259 1.23124 3.89042L1.23129 3.89036Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function Ik(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "160",
      height: "163",
      viewBox: "0 0 160 163",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M159.973 72.3533C159.973 71.1226 159.81 69.8439 159.459 68.665C157.996 63.7386 153.761 60.8337 148.162 60.8337C134.739 60.8337 121.32 60.83 107.897 60.8337C106.91 62.1716 105.82 63.4466 104.63 64.6477C103.31 65.9819 101.902 67.1978 100.413 68.2806C111.445 68.2769 122.48 68.2695 133.512 68.2622C135.145 68.2622 136.394 68.7426 137.507 69.9474C142.097 74.9218 146.79 79.8002 151.31 84.8375C152.127 85.7466 152.715 87.2249 152.726 88.4445C152.829 101.047 152.777 113.649 152.8 126.252C152.803 127.756 152.279 128.942 151.251 130.021C146.646 134.841 142.056 139.671 137.514 144.549C136.283 145.869 134.905 146.43 133.105 146.427C115.406 146.39 97.7038 146.405 80.0013 146.405C62.2988 146.405 44.6998 146.39 27.049 146.43C25.1346 146.434 23.6859 145.846 22.3776 144.435C17.8836 139.582 13.3231 134.796 8.74778 130.021C7.66493 128.894 7.18819 127.66 7.19189 126.1C7.22145 113.605 7.22145 101.106 7.18819 88.6071C7.18449 86.9884 7.69819 85.7171 8.8143 84.5529C13.4229 79.7411 18.0056 74.8997 22.5476 70.025C23.697 68.7906 24.9757 68.2585 26.672 68.2622C37.6557 68.2695 48.6394 68.2769 59.6231 68.2806C58.167 67.2273 56.7885 66.0521 55.4913 64.7586C54.2532 63.5242 53.1223 62.2123 52.0986 60.8301H11.7672C11.3496 60.8301 10.932 60.819 10.518 60.8559C6.10534 61.2366 2.88267 63.3801 0.975676 67.3974C0.55806 68.2806 0.321528 69.2526 0 70.1839V144.568C0.332615 145.492 0.580233 146.453 1.00894 147.325C3.32246 152.011 7.23254 153.833 12.3289 153.829C57.4278 153.796 102.53 153.811 147.629 153.807C148.202 153.807 148.775 153.796 149.344 153.755C155.719 153.293 159.988 148.755 159.992 142.358C160.006 119.023 160.003 95.6881 159.973 72.3533Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M145.379 90.5547C145.371 89.7306 144.95 88.7364 144.396 88.1155C140.944 84.2868 137.377 80.5615 133.9 76.7512C133.105 75.8827 132.3 75.5057 131.091 75.5057C114.113 75.5501 97.1347 75.5353 80.1528 75.5353V75.576C63.0712 75.576 45.9896 75.5612 28.908 75.6166C28.0986 75.6203 27.0823 76.0601 26.5131 76.6403C22.762 80.4728 19.0847 84.3829 15.4481 88.3225C14.9751 88.8325 14.6166 89.6641 14.6129 90.3515C14.5612 101.653 14.5612 112.958 14.6129 124.263C14.6129 124.951 14.9492 125.797 15.4149 126.303C19.0552 130.243 22.7398 134.146 26.4872 137.986C27.0231 138.533 27.9692 138.98 28.7268 138.98C62.8938 139.028 97.0571 139.028 131.224 138.98C131.989 138.98 132.946 138.57 133.482 138.023C137.23 134.183 140.914 130.284 144.547 126.34C145.046 125.801 145.382 124.892 145.382 124.153C145.438 112.955 145.441 101.753 145.379 90.5547ZM85.0866 129.112C83.9668 129.559 83.5086 130.062 83.6564 131.234C83.734 131.843 83.6786 132.486 83.5825 133.096C83.2683 135.044 81.8048 136.289 79.9274 136.26C78.1165 136.234 76.3056 134.97 76.4497 133.159C76.6715 130.321 75.2375 129.312 73.0164 128.096C68.8513 125.819 66.8556 121.931 66.56 117.855C66.5193 114.806 67.9348 113.128 70.0561 113.043C72.0888 112.958 73.5634 114.418 73.8295 116.776C74.2027 120.043 76.0876 122.264 78.8704 122.708C81.694 123.162 84.2773 121.858 85.4821 119.374C87.4962 115.224 84.5988 110.756 79.6983 110.563C75.7328 110.404 72.4251 108.904 69.8307 105.929C63.8473 99.0586 66.2865 88.3188 74.6943 84.8337C76.1171 84.2424 76.3352 83.4996 76.3204 82.1987C76.3019 80.2843 77.3737 78.928 79.0294 78.4512C80.4485 78.041 82.1264 78.503 82.8618 79.826C83.3607 80.7315 83.5603 81.8698 83.6305 82.9231C83.6934 83.8248 83.9373 84.2424 84.8021 84.6046C90.1054 86.8073 92.9881 90.8319 93.4057 96.5492C93.5794 98.9255 92.1011 100.64 89.9946 100.781C87.9471 100.921 86.4319 99.4984 86.1251 97.1479C85.6004 93.1787 83.2794 90.9428 79.7796 91.0389C76.6678 91.1239 74.2138 93.4411 73.8775 96.6157C73.5708 99.4984 75.5591 102.355 78.4676 103.009C79.8794 103.327 81.3687 103.294 82.7842 103.59C88.5976 104.794 92.9068 109.699 93.3946 115.575C93.8825 121.392 90.5304 126.958 85.0866 129.112Z" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M80 68C98.7777 68 114 52.7777 114 34C114 15.2223 98.7777 0 80 0C61.2223 0 46 15.2223 46 34C46 52.7777 61.2223 68 80 68ZM74.9312 54.3574V47.6427C74.9312 47.1231 75.0984 46.6734 75.4328 46.2937C75.7672 45.914 76.1632 45.7242 76.6208 45.7242H83.3791C83.8367 45.7242 84.2327 45.914 84.5671 46.2937C84.9015 46.6734 85.0687 47.1231 85.0687 47.6427V54.3574C85.0687 54.877 84.9015 55.3266 84.5671 55.7063C84.2327 56.086 83.8367 56.2759 83.3791 56.2759H76.6208C76.1632 56.2759 75.7672 56.086 75.4328 55.7063C75.0984 55.3266 74.9312 54.877 74.9312 54.3574ZM74.8784 39.0094L74.1392 15.9875C74.1216 15.4679 74.2756 15.0182 74.6012 14.6385C74.9268 14.2588 75.3184 14.069 75.776 14.069H84.2239C84.6815 14.069 85.0731 14.2588 85.3987 14.6385C85.7243 15.0182 85.8783 15.4679 85.8607 15.9875L85.1215 39.0094C85.1039 39.529 84.9235 39.9787 84.5803 40.3584C84.2371 40.7381 83.8367 40.9279 83.3791 40.9279H76.6208C76.1632 40.9279 75.7628 40.7381 75.4196 40.3584C75.0764 39.9787 74.896 39.529 74.8784 39.0094Z"
          }
        )
      ]
    }
  );
}
function Lk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "35",
      height: "35",
      viewBox: "0 0 50 40",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32.8398 18.3711C32.8398 25.5586 27.0133 31.3847 19.8261 31.3847C12.6386 31.3847 6.8125 25.5583 6.8125 18.3711C6.8125 11.1839 12.6389 5.35742 19.8261 5.35742C27.0133 5.35742 32.8398 11.1839 32.8398 18.3711Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.86618 16.7521C5.03597 8.64575 11.6785 2.10082 19.8261 2.10082C27.9425 2.10082 34.5652 8.5952 34.7837 16.6595C34.7506 16.8242 34.7312 24.1857 34.7312 24.1857C34.7312 24.4961 34.7871 24.7923 34.8858 25.0626C33.3255 30.5284 28.7347 34.7225 23.0533 35.7069C22.5339 35.268 21.779 34.9901 20.9365 34.9901C19.3709 34.9901 18.1013 35.946 18.1013 37.1248C18.1013 38.3052 19.371 39.2607 20.9365 39.2607C22.2228 39.2607 23.3072 38.6162 23.6547 37.7326C29.7192 36.592 34.659 32.2346 36.6325 26.5058C36.6951 26.5125 36.7561 26.5168 36.8206 26.5168C37.9748 26.5168 38.9116 25.4741 38.9116 24.1856L38.9112 17.1727C38.9112 15.8846 37.9751 14.8409 36.8203 14.8409C36.7944 14.8409 36.7698 14.8442 36.7449 14.8448C35.6512 6.48194 28.4831 0 19.8263 0C11.1686 0 4.00087 6.48155 2.90758 14.8464C2.87934 14.8452 2.85139 14.8412 2.82192 14.8412C1.67288 14.8412 0.742188 15.8849 0.742188 17.1731V24.1859C0.742188 25.4744 1.67288 26.5171 2.82192 26.5171C3.97158 26.5171 4.90289 25.4744 4.90289 24.1859"
          }
        )
      ]
    }
  );
}
function Ak(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      width: "512",
      height: "512",
      x: "0",
      y: "0",
      viewBox: "0 0 64 64",
      className: "",
      fill: "#CBD5E1",
      ...e,
      children: /* @__PURE__ */ u.jsxs("g", { children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M44.987 46.887a21.208 21.208 0 0 0 2.669-9.456v-9.75a3.878 3.878 0 0 0-5.908-3.305 3.979 3.979 0 0 0-6.12-2.173 3.98 3.98 0 0 0-5.652-1.914v-7.965a4.183 4.183 0 0 0-8.365 0v14.009a8.414 8.414 0 0 0-4.94 5.277c-1.354 4.67 1.737 10.36 4.57 14.312a11.57 11.57 0 0 1 2.18 6.572h-1.417a1 1 0 0 0-1 1V59a1 1 0 0 0 1 1h23.237a1 1 0 0 0 1-1v-5.506c-.056-1.353-1.645-.94-2.526-1a11.511 11.511 0 0 1 1.272-5.607zM44.241 58H23.004v-3.506h21.237zm-18.813-5.506a13.568 13.568 0 0 0-2.562-7.738c-2.107-2.94-5.464-8.485-4.274-12.588a6.032 6.032 0 0 1 3.019-3.59v6.528a1 1 0 0 0 2 0V12.324a2.182 2.182 0 0 1 4.365 0v18.439a1 1 0 0 0 2 0V23.74a1.98 1.98 0 1 1 3.96 0v7.527a1 1 0 0 0 2 0v-5.81a1.98 1.98 0 1 1 3.961 0v6.112a1 1 0 0 0 2 0v-3.89a1.88 1.88 0 0 1 3.759 0v9.75c.067 6.076-4.235 9.383-3.94 15.064z",
            "data-original": "#000000"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M19.075 13.274a1 1 0 0 0 1-1v-.606c.238-7.491 11.099-7.488 11.336 0v.41a1 1 0 0 0 2 0v-.41c-.386-10.16-14.953-10.155-15.336 0v.606a1 1 0 0 0 1 1z",
            "data-original": "#000000"
          }
        )
      ] })
    }
  );
}
function Nk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "Layer",
      height: "512",
      viewBox: "0 0 24 24",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          id: "test-tube-alt",
          d: "m21.53 9.47-7-7a.75.75 0 0 0 -1.06 1.06l.47.47-10.435 10.435a4.285 4.285 0 0 0 6.06 6.06l10.435-10.434.47.47a.75.75 0 1 0 1.06-1.061zm-6.59 3.53h-7.879l7.939-7.939 3.94 3.939z"
        }
      )
    }
  );
}
function Rk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#clip0_3840_14182)", children: [
          /* @__PURE__ */ u.jsx("path", { d: "M3.125 10H16.875", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
          /* @__PURE__ */ u.jsx(
            "path",
            {
              d: "M11.25 4.375L16.875 10L11.25 15.625",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_3840_14182", children: /* @__PURE__ */ u.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function Ok(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#CBD5E1",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("circle", { cx: "10.1884", cy: "10.1875", r: "10.04" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M10.1895 6.79727V10.1875L12.4496 11.3176M15.8398 10.1875C15.8398 13.3081 13.3101 15.8379 10.1895 15.8379C7.06883 15.8379 4.53906 13.3081 4.53906 10.1875C4.53906 7.06688 7.06883 4.53711 10.1895 4.53711C13.3101 4.53711 15.8398 7.06688 15.8398 10.1875Z",
            stroke: "white",
            strokeWidth: "1.2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function Bk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      fill: "#CBD5E1",
      viewBox: "0 0 22 22",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z" })
    }
  );
}
function jk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "18",
      height: "16",
      viewBox: "0 0 18 16",
      fill: "#142D63",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("g", { clipPath: "url(#clip0_18606_11175)", children: /* @__PURE__ */ u.jsx("path", { d: "M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.3375C8.925 15.0031 8 13.3594 8 11.5C8 8.675 10.1313 6.34688 12.8719 6.03438L13 4ZM18 11.5C18 9.01562 15.9844 7 13.5 7C11.0156 7 9 9.01562 9 11.5C9 13.9844 11.0156 16 13.5 16C15.9844 16 18 13.9844 18 11.5ZM13.5 9C13.775 9 14 9.225 14 9.5V11H15C15.275 11 15.5 11.225 15.5 11.5C15.5 11.775 15.275 12 15 12H13.5C13.225 12 13 11.775 13 11.5V9.5C13 9.225 13.225 9 13.5 9Z" }) }),
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "clip0_18606_11175", children: /* @__PURE__ */ u.jsx("rect", { width: "18", height: "16" }) }) })
      ]
    }
  );
}
function Hk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "17",
      height: "16",
      viewBox: "0 0 14 15",
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "#CBD5E1",
      fill: "white",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9242 1.00738H9.4459L9.17343 0.465349C9.0557 0.228979 8.8143 0.0796491 8.55024 0.0798391H5.23717C4.9736 0.0788291 4.73266 0.228569 4.61687 0.465349L4.3444 1.00738H0.866114C0.609984 1.00738 0.402344 1.21502 0.402344 1.47115V2.39869C0.402344 2.65482 0.609984 2.86246 0.866114 2.86246H12.9242C13.1803 2.86246 13.388 2.65482 13.388 2.39869V1.47115C13.388 1.21502 13.1803 1.00738 12.9242 1.00738H12.9242ZM1.94439 13.6162C1.9903 14.3493 2.59824 14.9204 3.33281 14.9205H10.4575C11.1919 14.9205 11.7999 14.3495 11.8459 13.6163L12.4604 3.79H1.32989L1.94439 13.6162Z"
        }
      )
    }
  );
}
function Fk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M19.7227 4.75098C20.582 4.10645 21.3555 3.33301 21.957 2.43066C21.1836 2.77441 20.2812 3.03223 19.3789 3.11816C20.3242 2.55957 21.0117 1.7002 21.3555 0.625977C20.4961 1.1416 19.5078 1.52832 18.5195 1.74316C17.6602 0.84082 16.5 0.325195 15.2109 0.325195C12.7188 0.325195 10.6992 2.34473 10.6992 4.83691C10.6992 5.18066 10.7422 5.52441 10.8281 5.86816C7.08984 5.65332 3.73828 3.84863 1.50391 1.1416C1.11719 1.78613 0.902344 2.55957 0.902344 3.41895C0.902344 4.96582 1.67578 6.34082 2.92188 7.15723C2.19141 7.11426 1.46094 6.94238 0.859375 6.59863V6.6416C0.859375 8.83301 2.40625 10.6377 4.46875 11.0674C4.125 11.1533 3.69531 11.2393 3.30859 11.2393C3.00781 11.2393 2.75 11.1963 2.44922 11.1533C3.00781 12.958 4.68359 14.2471 6.66016 14.29C5.11328 15.4932 3.17969 16.2236 1.07422 16.2236C0.6875 16.2236 0.34375 16.1807 0 16.1377C1.97656 17.4268 4.33984 18.1572 6.91797 18.1572C15.2109 18.1572 19.7227 11.3252 19.7227 5.35254C19.7227 5.1377 19.7227 4.96582 19.7227 4.75098Z" })
    }
  );
}
function Gk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      version: "1.1",
      id: "Capa_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "475.078px",
      height: "475.078px",
      viewBox: "0 0 475.078 475.078",
      fill: "#CBD5E1",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("g", { children: /* @__PURE__ */ u.jsx(
          "path",
          {
            d: `M437.537,74.086c-25.029-25.031-55.151-37.544-90.365-37.544c-35.207,0-65.329,12.513-90.359,37.544
		c-25.031,25.028-37.544,55.15-37.544,90.362v54.821H27.408c-7.612,0-14.083,2.663-19.414,7.993C2.664,232.589,0,239.062,0,246.677
		v164.455c0,7.611,2.664,14.089,7.994,19.417c5.33,5.325,11.801,7.987,19.414,7.987h274.084c7.618,0,14.086-2.662,19.418-7.987
		c5.325-5.331,7.994-11.806,7.994-19.417V246.677c0-7.611-2.669-14.084-7.994-19.414c-5.332-5.33-11.8-7.993-19.418-7.993h-27.404
		v-54.821c0-20.175,7.132-37.402,21.409-51.675c14.277-14.275,31.505-21.411,51.675-21.411c20.177,0,37.404,7.135,51.682,21.411
		c14.27,14.272,21.408,31.5,21.408,51.675v73.089c0,4.95,1.808,9.235,5.428,12.848c3.614,3.614,7.898,5.421,12.847,5.421h18.274
		c4.949,0,9.227-1.807,12.848-5.421c3.613-3.613,5.42-7.898,5.42-12.848v-73.089C475.078,129.236,462.563,99.118,437.537,74.086z`
          }
        ) }),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {}),
        /* @__PURE__ */ u.jsx("g", {})
      ]
    }
  );
}
function Vk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      width: "17px",
      height: "15px",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M109.7 160H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32v51.2L81.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L109.7 160z" })
    }
  );
}
function Kk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      id: "图层_1",
      height: "24",
      viewBox: "0 0 44 44",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "#ACB7D1",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "m33.73 19.88h-6.64a1.85 1.85 0 0 0 -1.6.92 9.05 9.05 0 0 1 -1.71 2.2.73.73 0 0 0 .48 1.27h9.47a1.1 1.1 0 0 0 1.1-1.1v-2.17a1.1 1.1 0 0 0 -1.1-1.12zm3.67-8.06h-14.35a.73.73 0 0 0 -.67.45.72.72 0 0 0 .16.8l2.62 2.61a1.82 1.82 0 0 0 1.3.54h10.94a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 0 -1.1-1.1zm-7.33 16.18h-9.57a.74.74 0 0 0 -.74.73v2.94a.74.74 0 0 0 .74.73h9.57a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 0 -1.1-1.1zm-8.86-7.78h-4.89v13.51a1.1 1.1 0 0 1 -1.1 1.1h-2.94a1.1 1.1 0 0 1 -1.1-1.1v-13.56h-4.89a1.48 1.48 0 0 1 -1-2.51l7-6.95a2.17 2.17 0 0 1 1.56-.65 2.2 2.2 0 0 1 1.56.65l7 7a1.47 1.47 0 0 1 -1.06 2.51z" })
    }
  );
}
function zk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "18",
      viewBox: "0 0 20 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          d: "M6.6665 12.3333L9.99984 9M9.99984 9L13.3332 12.3333M9.99984 9V16.5M16.6665 12.9524C17.6844 12.1117 18.3332 10.8399 18.3332 9.41667C18.3332 6.88536 16.2811 4.83333 13.7498 4.83333C13.5677 4.83333 13.3974 4.73833 13.3049 4.58145C12.2182 2.73736 10.2119 1.5 7.9165 1.5C4.46472 1.5 1.6665 4.29822 1.6665 7.75C1.6665 9.47175 2.36271 11.0309 3.48896 12.1613",
          stroke: "#00A0FF",
          strokeWidth: "1.66667",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function Uk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M19 2.5C19 2.10218 18.842 1.72064 18.5607 1.43934C18.2794 1.15804 17.8978 1 17.5 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V17.5C1 17.8978 1.15804 18.2794 1.43934 18.5607C1.72064 18.842 2.10218 19 2.5 19H10V17H3.497C3.087 17 2.857 16.54 3.097 16.21L6.65 12.159C6.84 11.949 7.17 11.949 7.37 12.149L9 14L12.06 9.219C12.107 9.14987 12.1705 9.09363 12.2449 9.0554C12.3192 9.01717 12.4019 8.99818 12.4854 9.00017C12.569 9.00216 12.6507 9.02507 12.7231 9.06679C12.7956 9.10851 12.8564 9.16772 12.9 9.239L13.62 10.49C14.3714 10.1655 15.1815 9.99873 16 10H19V2.5ZM7.5 4.5C8.6 4.5 9.5 5.4 9.5 6.5C9.5 7.6 8.6 8.5 7.5 8.5C6.4 8.5 5.5 7.6 5.5 6.5C5.5 5.4 6.4 4.5 7.5 4.5ZM19.707 15.293C19.5195 15.1055 19.2652 15.0001 19 15H17V13C17 12.7348 16.8946 12.4804 16.7071 12.2929C16.5196 12.1054 16.2652 12 16 12C15.7348 12 15.4804 12.1054 15.2929 12.2929C15.1054 12.4804 15 12.7348 15 13V15H13C12.7348 15 12.4804 15.1054 12.2929 15.2929C12.1054 15.4804 12 15.7348 12 16C12 16.2652 12.1054 16.5196 12.2929 16.7071C12.4804 16.8946 12.7348 17 13 17H15V19C15 19.2652 15.1054 19.5196 15.2929 19.7071C15.4804 19.8946 15.7348 20 16 20C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V17H19C19.1978 17 19.391 16.9413 19.5555 16.8314C19.7199 16.7215 19.848 16.5654 19.9237 16.3827C19.9993 16.2 20.0192 15.9989 19.9806 15.805C19.942 15.611 19.8468 15.4329 19.707 15.293V15.293Z" })
    }
  );
}
function Zk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "260",
      height: "230",
      viewBox: "0 0 260 230",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M119.197 229.75C182.289 229.75 233.434 178.375 233.434 115C233.434 51.6253 182.289 0.25 119.197 0.25C56.1053 0.25 4.95941 51.6253 4.95941 115C4.95941 178.375 56.1053 229.75 119.197 229.75Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M9.01956 47.7823C12.0377 46.797 13.6891 43.5405 12.7081 40.5089C11.7272 37.4772 8.48528 35.8184 5.46716 36.8037C2.44905 37.7891 0.797612 41.0455 1.77858 44.0772C2.75955 47.1088 6.00144 48.7677 9.01956 47.7823Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M21.5559 28.9495C23.6083 28.2794 24.7312 26.065 24.0642 24.0035C23.3971 21.942 21.1926 20.814 19.1403 21.484C17.088 22.1541 15.965 24.3685 16.6321 26.43C17.2991 28.4915 19.5036 29.6195 21.5559 28.9495Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M247.594 78.2378C251.155 74.969 251.404 69.4194 248.15 65.8424C244.895 62.2655 239.371 62.0156 235.81 65.2844C232.249 68.5532 232 74.1028 235.254 77.6798C238.508 81.2568 244.033 81.5066 247.594 78.2378Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M256.41 55.0753C257.909 53.6989 258.014 51.3623 256.644 49.8562C255.273 48.3501 252.947 48.2449 251.448 49.6212C249.948 50.9975 249.844 53.3342 251.214 54.8403C252.584 56.3464 254.91 56.4516 256.41 55.0753Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M219.633 179.65H18.7406V51.9704C18.7406 47.8144 21.9586 44.582 26.096 44.582H212.278C216.415 44.582 219.633 47.8144 219.633 51.9704V179.65Z",
            fill: "#142D63"
          }
        ),
        /* @__PURE__ */ u.jsx("path", { d: "M169.524 186.346H24.9457V51.9707H212.507V186.346H190.441", fill: "white" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M231.122 179.646V185.419C231.122 190.729 226.525 192.114 221.009 192.114H17.3581C11.8416 192.114 7.24457 190.96 7.24457 185.419V179.646H99.4161C100.106 181.724 102.404 183.341 104.933 183.341H133.434C135.963 183.341 138.032 181.724 138.951 179.646H231.122Z",
            fill: "#142D63"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M231.122 179.646C231.122 184.957 226.525 186.111 221.009 186.111H17.3581C11.8416 186.111 7.24457 184.957 7.24457 179.646H99.4161C100.106 181.724 102.404 183.341 104.933 183.341H133.434C135.963 183.341 138.032 181.724 138.951 179.646H231.122Z",
            fill: "#1F3C7A"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M32.0784 60.9751C33.3478 60.9751 34.3769 59.9414 34.3769 58.6663C34.3769 57.3911 33.3478 56.3574 32.0784 56.3574C30.8089 56.3574 29.7798 57.3911 29.7798 58.6663C29.7798 59.9414 30.8089 60.9751 32.0784 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M38.2834 60.9751C39.5529 60.9751 40.582 59.9414 40.582 58.6663C40.582 57.3911 39.5529 56.3574 38.2834 56.3574C37.014 56.3574 35.9849 57.3911 35.9849 58.6663C35.9849 59.9414 37.014 60.9751 38.2834 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            opacity: "0.6",
            d: "M44.26 60.9751C45.5294 60.9751 46.5585 59.9414 46.5585 58.6663C46.5585 57.3911 45.5294 56.3574 44.26 56.3574C42.9905 56.3574 41.9614 57.3911 41.9614 58.6663C41.9614 59.9414 42.9905 60.9751 44.26 60.9751Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M197.803 96.5316H137.581C136.432 96.5316 135.512 95.608 135.512 94.4536V72.9813C135.512 71.8269 136.432 70.9033 137.581 70.9033H197.803C198.952 70.9033 199.871 71.8269 199.871 72.9813V94.4536C200.101 95.608 199.182 96.5316 197.803 96.5316Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M200.101 127.471C200.101 128.626 199.182 129.549 198.032 129.549H137.581C136.432 129.549 135.512 128.626 135.512 127.471V105.999C135.512 104.844 136.432 103.921 137.581 103.921H197.803C198.952 103.921 199.871 104.844 199.871 105.999V127.471H200.101Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M187.916 80.3723H147.462C146.773 80.3723 146.313 79.9106 146.313 79.2179C146.313 78.5252 146.773 78.0635 147.462 78.0635H187.916C188.606 78.0635 189.066 78.5252 189.066 79.2179C188.836 79.9106 188.376 80.3723 187.916 80.3723Z",
            fill: "url(#paint0_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M173.665 88.9153H147.462C146.773 88.9153 146.313 88.4535 146.313 87.7609C146.313 87.0682 146.773 86.6064 147.462 86.6064H173.895C174.585 86.6064 175.045 87.0682 175.045 87.7609C174.815 88.2226 174.355 88.9153 173.665 88.9153Z",
            fill: "url(#paint1_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M187.916 113.39H147.462C146.773 113.39 146.313 112.928 146.313 112.235C146.313 111.543 146.773 111.081 147.462 111.081H187.916C188.606 111.081 189.066 111.543 189.066 112.235C188.836 112.928 188.376 113.39 187.916 113.39Z",
            fill: "url(#paint2_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M173.665 121.933H147.462C146.773 121.933 146.313 121.471 146.313 120.778C146.313 120.086 146.773 119.624 147.462 119.624H173.895C174.585 119.624 175.045 120.086 175.045 120.778C174.815 121.471 174.355 121.933 173.665 121.933Z",
            fill: "url(#paint3_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M200.103 160.72C200.103 161.875 199.184 162.798 198.034 162.798H137.583C136.433 162.798 135.514 161.875 135.514 160.72V139.248C135.514 138.094 136.433 137.17 137.583 137.17H197.804C198.954 137.17 199.873 138.094 199.873 139.248V160.72H200.103Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M187.916 146.865H147.462C146.773 146.865 146.313 146.403 146.313 145.71C146.313 145.017 146.773 144.556 147.462 144.556H187.916C188.606 144.556 189.066 145.017 189.066 145.71C188.836 146.403 188.376 146.865 187.916 146.865Z",
            fill: "url(#paint4_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M173.665 155.407H147.462C146.773 155.407 146.313 154.946 146.313 154.253C146.313 153.56 146.773 153.099 147.462 153.099H173.895C174.585 153.099 175.045 153.56 175.045 154.253C174.815 154.715 174.355 155.407 173.665 155.407Z",
            fill: "url(#paint5_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M118.744 134.631H37.6059C35.5372 134.631 33.9283 133.015 33.9283 130.937V74.8319C33.9283 72.7539 35.5372 71.1377 37.6059 71.1377H118.974C121.043 71.1377 122.652 72.7539 122.652 74.8319V130.937C122.422 133.015 120.813 134.631 118.744 134.631Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx("path", { d: "M79.8964 120.779H50.4751L65.1858 104.155L79.8964 120.779Z", fill: "#CED7E2" }),
        /* @__PURE__ */ u.jsx("path", { d: "M104.03 120.779H61.7368L82.8834 96.7666L104.03 120.779Z", fill: "white" }),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M61.5111 98.1518C64.5578 98.1518 67.0276 95.6709 67.0276 92.6106C67.0276 89.5502 64.5578 87.0693 61.5111 87.0693C58.4645 87.0693 55.9946 89.5502 55.9946 92.6106C55.9946 95.6709 58.4645 98.1518 61.5111 98.1518Z",
            fill: "#CED7E2"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M121.031 156.794H35.5255C34.6061 156.794 33.9165 156.101 33.9165 155.178C33.9165 154.254 34.6061 153.562 35.5255 153.562H121.031C121.951 153.562 122.64 154.254 122.64 155.178C122.41 156.101 121.721 156.794 121.031 156.794Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M121.031 147.094H35.5255C34.6061 147.094 33.9165 146.401 33.9165 145.478C33.9165 144.554 34.6061 143.861 35.5255 143.861H121.031C121.951 143.861 122.64 144.554 122.64 145.478C122.41 146.401 121.721 147.094 121.031 147.094Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M64.2573 166.257H35.5255C34.6061 166.257 33.9165 165.564 33.9165 164.641C33.9165 163.717 34.6061 163.024 35.5255 163.024H64.2573C65.1767 163.024 65.8663 163.717 65.8663 164.641C65.6364 165.564 64.9468 166.257 64.2573 166.257Z",
            fill: "#E5EDF7"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M164.251 35.5773C161.952 35.5773 156.436 33.4993 154.597 32.8066C144.943 28.4198 129.083 15.4902 120.349 15.4902C111.614 15.4902 95.7543 28.1889 86.1004 32.8066C84.4915 33.4993 78.7451 35.5773 76.4466 35.5773C72.7689 35.8081 70.0106 39.0405 70.4704 42.5038C71.3898 51.0466 73.6883 66.285 79.6645 85.9102C87.4796 110.153 109.086 124.699 117.361 129.548C119.429 130.702 121.728 130.702 123.797 129.548C132.071 124.699 153.678 110.153 161.033 85.9102C167.009 66.285 169.308 51.0466 170.227 42.5038C170.687 39.0405 167.929 35.8081 164.251 35.5773Z",
            fill: "url(#paint6_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M161.265 44.1213C160.345 51.0479 158.506 62.8231 154.369 77.5997C153.909 79.4468 153.22 81.5248 152.53 83.3718C146.324 103.459 128.855 116.158 120.351 121.237C119.431 120.775 118.512 120.083 117.592 119.39C108.628 113.387 93.9173 101.381 88.4008 83.3718C83.1141 66.0555 80.8156 51.9714 79.6663 44.1213C83.8037 43.1978 88.8605 41.3507 89.7799 40.889C93.6874 39.0419 98.0547 36.5021 102.652 33.5006C107.709 30.2682 117.133 24.4961 120.351 24.4961C123.568 24.4961 132.992 30.4991 138.049 33.5006C142.646 36.2712 147.014 39.0419 150.921 40.889C152.07 41.1198 157.127 43.1978 161.265 44.1213Z",
            fill: "url(#paint7_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M129.531 61.7356V53.5884C129.531 49.6919 126.333 45.7954 122.78 45.087C119.938 44.7328 117.095 45.4412 115.319 47.5666C113.898 48.9835 112.832 51.1088 112.832 53.5884V62.0899C110.7 63.5068 108.568 65.6321 107.147 67.7575C105.726 69.8829 105.015 72.3624 105.015 75.1963C104.66 84.0519 111.766 91.4907 120.648 91.8449C129.886 92.1992 137.348 84.7604 137.348 75.9047C137.348 69.8829 134.15 64.5695 129.531 61.7356ZM123.136 77.3216V81.5724C123.136 82.2808 122.78 82.635 122.07 82.635H120.293C119.583 82.635 119.227 82.2808 119.227 81.5724V78.7385V76.9674C117.451 76.6132 116.74 74.842 117.095 73.0709C117.451 71.654 118.517 70.2371 120.293 69.8829C122.78 69.1744 125.267 71.2998 125.267 73.7794C124.912 75.1963 124.201 76.6132 123.136 77.3216ZM125.978 60.3187C124.557 59.9645 122.78 59.6103 121.004 59.6103C119.583 59.6103 117.806 59.9645 116.385 60.3187V53.9427C116.385 52.5257 117.095 51.4631 117.806 50.7546C118.872 49.6919 121.004 48.9835 123.136 49.6919C124.912 50.4004 125.978 52.1715 125.978 54.2969V60.3187Z",
            fill: "url(#paint8_linear_0_9)"
          }
        ),
        /* @__PURE__ */ u.jsxs("defs", { children: [
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint0_linear_0_9",
              x1: "146.265",
              y1: "79.2798",
              x2: "188.926",
              y2: "79.2798",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint1_linear_0_9",
              x1: "146.265",
              y1: "87.7073",
              x2: "174.889",
              y2: "87.7073",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint2_linear_0_9",
              x1: "146.265",
              y1: "112.335",
              x2: "188.926",
              y2: "112.335",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint3_linear_0_9",
              x1: "146.265",
              y1: "120.762",
              x2: "174.889",
              y2: "120.762",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint4_linear_0_9",
              x1: "146.265",
              y1: "145.736",
              x2: "188.926",
              y2: "145.736",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint5_linear_0_9",
              x1: "146.265",
              y1: "154.164",
              x2: "174.889",
              y2: "154.164",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#CED7E2" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#E6ECF5" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint6_linear_0_9",
              x1: "71.3802",
              y1: "72.1147",
              x2: "170.872",
              y2: "72.1147",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#46BAFF" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#00A0FF" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint7_linear_0_9",
              x1: "80.4508",
              y1: "72.1619",
              x2: "161.751",
              y2: "72.1619",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { stopColor: "#00A0FF" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#46BAFF" })
              ]
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "linearGradient",
            {
              id: "paint8_linear_0_9",
              x1: "137.004",
              y1: "85.7724",
              x2: "106.945",
              y2: "55.6217",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ u.jsx("stop", { offset: "0.0113208", stopColor: "#C2EDFF" }),
                /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "white" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Yk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      id: "Glyph",
      height: "512",
      viewBox: "0 0 32 32",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            id: "XMLID_436_",
            d: "m30 24v2.5c0 1.379-1.122 2.5-2.5 2.5h-21.5c-2.206 0-4-1.794-4-4 0 0 0-16.985 0-17 0-2.206 1.794-4 4-4h18.5c.829 0 1.5.672 1.5 1.5s-.671 1.5-1.5 1.5h-18.5c-.551 0-1 .448-1 1s.449 1 1 1h21.5c1.378 0 2.5 1.121 2.5 2.5v2.5h-5c-2.757 0-5 2.243-5 5s2.243 5 5 5z"
          }
        ),
        /* @__PURE__ */ u.jsx("path", { id: "XMLID_438_", d: "m30 16v6h-5c-1.657 0-3-1.343-3-3s1.343-3 3-3z" })
      ]
    }
  );
}
function Wk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "23",
      height: "20",
      viewBox: "0 0 23 20",
      fill: "#F04438",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.76619 3.01532C10.5352 1.67791 12.4648 1.67792 13.2338 3.01533L21.2768 17.0031C22.0434 18.3364 21.081 20 19.5429 20H3.45705C1.91902 20 0.956577 18.3364 1.72324 17.0031L9.76619 3.01532Z"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.7031 8.24512L12.471 14.5307H10.4353L10.2032 8.24512H12.7031ZM11.4531 17.5306C11.1079 17.5306 10.8125 17.4093 10.567 17.1668C10.3215 16.9242 10.2002 16.6289 10.2032 16.2807C10.2002 15.9414 10.3215 15.6512 10.567 15.4101C10.8125 15.1691 11.1079 15.0485 11.4531 15.0485C11.7805 15.0485 12.0699 15.1691 12.3214 15.4101C12.5729 15.6512 12.7001 15.9414 12.7031 16.2807C12.7001 16.6289 12.5729 16.9242 12.3214 17.1668C12.0699 17.4093 11.7805 17.5306 11.4531 17.5306Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function $k(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "45",
      height: "38",
      viewBox: "0 0 45 38",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          stroke: "none",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.8475 37.4094C30.4303 37.4094 30.0551 37.1763 29.8683 36.801L28.4211 33.8877H15.7716L14.3235 36.801C14.1367 37.1763 13.7612 37.4094 13.3434 37.4094C13.1745 37.4094 13.0058 37.3693 12.8556 37.2933C12.3162 37.0223 12.0966 36.3597 12.366 35.8164L15.075 30.3669H1.0935C0.49054 30.3669 0 29.8735 0 29.2671C0 28.6602 0.49054 28.1664 1.0935 28.1664H1.7496V2.2005H1.0935C0.49054 2.2005 0 1.70673 0 1.0998C0 0.49337 0.49054 0 1.0935 0H43.0983C43.7013 0 44.1918 0.49337 44.1918 1.0998C44.1918 1.70673 43.7013 2.2005 43.0983 2.2005H42.4422V28.1664H43.0983C43.7018 28.1664 44.1927 28.6602 44.1927 29.2671C44.1927 29.8735 43.7018 30.3669 43.0983 30.3669H29.1168L31.8249 35.8164C32.0951 36.3596 31.8759 37.0221 31.3362 37.2933C31.1843 37.3693 31.0153 37.4094 30.8475 37.4094ZM17.5212 30.3678V30.3678L16.8651 31.6881H27.3267L26.6697 30.3678L17.5212 30.3678L17.5212 30.3678ZM22.5441 6.759C18.4018 6.759 15.0318 10.1484 15.0318 14.3145C15.0318 18.4811 18.4018 21.8709 22.5441 21.8709C26.6859 21.8709 30.0555 18.4811 30.0555 14.3145C30.0555 10.1484 26.6859 6.759 22.5441 6.759ZM20.3662 18.216C19.9637 18.2159 19.6362 17.8873 19.6362 17.4834V11.1465C19.6362 10.7425 19.9636 10.4139 20.3661 10.4139C20.4866 10.4139 20.6079 10.446 20.7171 10.5066L26.0487 13.7664C26.2826 13.8982 26.4219 14.1383 26.4213 14.4089C26.4207 14.6781 26.2815 14.9163 26.0487 15.0462L20.7171 18.1233C20.6075 18.1848 20.4895 18.216 20.3662 18.216Z"
        }
      )
    }
  );
}
function Jk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.83563 0.644531C3.99918 0.644531 0.890625 3.75308 0.890625 7.58953C0.890625 11.426 3.99918 14.5345 7.83563 14.5345C11.6721 14.5345 14.7806 11.426 14.7806 7.58953C14.7806 3.75308 11.6721 0.644531 7.83563 0.644531ZM9.59525 10.1038L7.83562 8.34413L6.076 10.1038C5.86899 10.3108 5.52841 10.3108 5.3214 10.1038C5.2179 10.0002 5.16447 9.86335 5.16447 9.72645C5.16447 9.58955 5.2179 9.45266 5.3214 9.34915L7.08103 7.58953L5.3214 5.82991C5.2179 5.7264 5.16447 5.5895 5.16447 5.45261C5.16447 5.31571 5.2179 5.17882 5.3214 5.07531C5.52841 4.86829 5.869 4.86829 6.076 5.07531L7.83562 6.83493L9.59525 5.07531C9.80225 4.86829 10.1428 4.86829 10.3498 5.07531C10.5569 5.28233 10.5569 5.6229 10.3498 5.82991L8.59023 7.58953L10.3498 9.34915C10.5569 9.55617 10.5569 9.89674 10.3498 10.1038C10.1428 10.3141 9.80227 10.3141 9.59525 10.1038Z",
          fill: "#F04438"
        }
      )
    }
  );
}
function hh(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 49 47",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      fill: "#CBD5E1",
      children: [
        /* @__PURE__ */ u.jsx("path", { d: "M26.5134 0.399902H13.6093L0.300049 23.4596L13.6093 46.5193L16.2422 41.9768L5.56587 23.4596L16.2422 4.97133H23.8805L26.5134 0.399902Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M17.4285 16.0526L20.0325 11.539L16.2423 4.97119L13.6094 9.48476L17.4285 16.0526Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M32.358 4.97119L34.9909 9.51369L16.2423 41.9766L13.6094 37.4341L32.358 4.97119Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M22.1155 46.5193L24.7195 41.9768H32.3578L43.0341 23.4596L32.3578 4.97133L34.9907 0.399902L48.2999 23.4596L34.9907 46.5193H22.1155Z" }),
        /* @__PURE__ */ u.jsx("path", { d: "M31.1139 30.7798L28.481 35.3223L32.358 41.9769L34.9909 37.4633L31.1139 30.7798Z" })
      ]
    }
  );
}
function Qk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      width: "146",
      height: "43",
      viewBox: "0 0 146 43",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M64.5063 13.8643L60.0798 20.2934L55.6268 13.8643H52.0961L58.2617 22.5067L51.7799 31.5707H55.3106L60.0798 24.7463L64.7962 31.5707H68.3269L61.8451 22.5067L68.0107 13.8643H64.5063Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M77.8916 16.183C79.1826 16.183 80.1839 16.6046 80.869 17.4214C81.5277 18.2118 81.8966 19.3712 81.9229 20.8467H73.3596C73.5176 19.4239 73.9919 18.2909 74.7297 17.4741C75.5202 16.6046 76.5741 16.183 77.8916 16.183ZM77.9179 13.5481C75.5465 13.5481 73.623 14.3913 72.2266 16.0776C70.8301 17.7376 70.1187 20.0299 70.1187 22.8492C70.1187 25.6685 70.8828 27.8818 72.3847 29.4628C73.8865 31.0437 75.9944 31.8605 78.603 31.8605C79.7887 31.8605 80.7899 31.7815 81.6331 31.597C82.4762 31.4126 83.3721 31.1228 84.2943 30.7275L84.4261 30.6748V27.8555L84.1099 27.9872C82.3182 28.7514 80.5001 29.1466 78.682 29.1466C76.9957 29.1466 75.6519 28.646 74.7297 27.6447C73.8338 26.6698 73.3332 25.247 73.2542 23.4026H85.1638V21.5318C85.1638 19.1604 84.5051 17.2106 83.214 15.7614C81.9229 14.2859 80.1312 13.5481 77.9179 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M97.5741 13.5481C96.3621 13.5481 95.2291 13.7852 94.2542 14.2595C93.3847 14.6811 92.6469 15.2608 92.1199 15.9985L91.7247 13.8379H89.1952V31.5443H92.2516V22.2696C92.2516 20.0826 92.6469 18.5017 93.4637 17.5795C94.2542 16.6573 95.5453 16.183 97.2579 16.183C98.549 16.183 99.4976 16.4992 100.104 17.1579C100.71 17.8166 100.999 18.8179 100.999 20.1616V31.5443H104.056V20.0563C104.056 17.7903 103.503 16.1303 102.422 15.0763C101.342 14.0751 99.7084 13.5481 97.5741 13.5481Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M115.755 29.2256C114.253 29.2256 113.146 28.6986 112.382 27.6446C111.618 26.5643 111.223 24.9307 111.223 22.7965C111.223 20.6886 111.618 19.0286 112.408 17.8692C113.173 16.7362 114.279 16.1829 115.755 16.1829C117.467 16.1829 118.706 16.6835 119.47 17.6584C120.26 18.6597 120.656 20.3724 120.656 22.7438V23.2971C120.656 25.405 120.26 26.9332 119.496 27.8554C118.706 28.7776 117.467 29.2256 115.755 29.2256ZM120.603 13.8642L120.656 15.0763L120.735 15.8667C119.47 14.3121 117.678 13.5217 115.412 13.5217C113.094 13.5217 111.275 14.3385 109.984 15.9721C108.693 17.5794 108.035 19.8454 108.035 22.7438C108.035 25.6158 108.693 27.8818 109.958 29.4627C111.249 31.0436 113.094 31.8604 115.412 31.8604C117.757 31.8604 119.575 31.0436 120.814 29.41L121.13 31.5443H123.686V6.61829H120.629L120.603 13.8642Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M130.326 7.43518C129.825 7.43518 129.403 7.59327 129.061 7.90946C128.718 8.22564 128.56 8.72627 128.56 9.38499C128.56 10.0437 128.718 10.518 129.061 10.8605C129.403 11.2031 129.825 11.3612 130.326 11.3612C130.8 11.3612 131.222 11.2031 131.564 10.8605C131.907 10.518 132.091 10.0437 132.091 9.38499C132.091 8.72627 131.907 8.25199 131.564 7.90946C131.222 7.59327 130.8 7.43518 130.326 7.43518Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M128.771 31.5707H131.854V13.8643H128.771V31.5707Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M145.055 28.9621C144.818 29.0412 144.475 29.0939 144.053 29.1729C143.632 29.2256 143.21 29.2783 142.736 29.2783C141.946 29.2783 141.313 29.0412 140.865 28.5142C140.417 28.0136 140.18 27.2495 140.18 26.2746V16.3411H145.186V13.8643H140.18V9.85925H138.283L137.15 13.6008L134.647 14.7074V16.3411H137.124V26.38C137.124 30.0161 138.889 31.8869 142.367 31.8869C142.815 31.8869 143.316 31.8342 143.895 31.7551C144.475 31.6497 144.897 31.5443 145.213 31.3862L145.344 31.3335V28.8831L145.055 28.9621Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M24.172 0.400024H12.4204L0.299988 21.4L12.4204 42.4L14.8182 38.2633L5.09547 21.4L14.8182 4.56313H21.7743L24.172 0.400024Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M15.8985 14.6547L18.2699 10.5443L14.8182 4.56311L12.4204 8.67353L15.8985 14.6547Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M29.4945 4.56311L31.8922 8.69987L14.8182 38.2632L12.4204 34.1265L29.4945 4.56311Z",
            fill: "#D24D57"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M20.167 42.4L22.5384 38.2633H29.4945L39.2172 21.4L29.4945 4.56313L31.8922 0.400024L44.0127 21.4L31.8922 42.4H20.167Z",
            fill: "#446CB3"
          }
        ),
        /* @__PURE__ */ u.jsx(
          "path",
          {
            d: "M28.3615 28.0663L25.9637 32.2031L29.4945 38.2633L31.8922 34.1529L28.3615 28.0663Z",
            fill: "#D24D57"
          }
        )
      ]
    }
  );
}
function qk(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      fill: "#CDD1D6",
      xmlns: "http://www.w3.org/2000/svg",
      id: "body_1",
      width: "31",
      height: "22",
      ...e,
      children: [
        /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsx("clipPath", { id: "1", children: /* @__PURE__ */ u.jsx("path", { clipRule: "evenodd", d: "M0 0L122.88 0L122.88 86.43L0 86.43z" }) }) }),
        /* @__PURE__ */ u.jsx("g", { transform: "matrix(0.25227866 0 0 0.25227866 -0 0.09777742)", children: /* @__PURE__ */ u.jsx("g", { clipPath: "url(#1)", children: /* @__PURE__ */ u.jsx(
          "path",
          {
            transform: "matrix(1 0 0 1 -12198 8410)",
            d: "M12259.441 -8323.52C 12258.131 -8323.531 12227.25 -8323.825 12217.662 -8324.741C 12217.186 -8324.831 12216.62 -8324.899 12215.962 -8324.979C 12212.776 -8325.363 12207.962 -8325.944 12204.088 -8330.001C 12202.1875 -8331.949 12200.969 -8335.173 12200.276 -8337.534C 12199.823 -8339.078 12199.47 -8340.649 12199.218 -8342.239C 12198.463 -8348.847 12198.057 -8355.489 12198 -8362.14L12198 -8362.14L12198 -8371.45C 12198.053 -8378.101 12198.46 -8384.743 12199.218 -8391.351C 12199.466 -8392.939 12199.819 -8394.51 12200.273 -8396.051C 12200.967 -8398.407 12202.197 -8401.62 12204.119 -8403.542C 12205.872 -8405.405 12208.049 -8406.818 12210.465 -8407.661C 12212.138 -8408.206 12213.872 -8408.544 12215.629 -8408.668L12215.629 -8408.668L12215.684 -8408.674C 12215.951 -8408.699 12216.205 -8408.725 12216.429 -8408.752C 12233.436 -8409.987 12259.17 -8410.002 12259.429 -8410.002C 12259.6875 -8410.002 12285.429 -8409.987 12302.419 -8408.752C 12302.625 -8408.728 12302.869 -8408.702 12303.21 -8408.669C 12304.969 -8408.544 12306.705 -8408.205 12308.382 -8407.66C 12310.799 -8406.818 12312.977 -8405.406 12314.731 -8403.542C 12316.642 -8401.62 12317.872 -8398.407 12318.567 -8396.051C 12319.023 -8394.51 12319.379 -8392.939 12319.631 -8391.351L12319.631 -8391.351L12319.621 -8391.363C 12320.384 -8384.756 12320.802 -8378.114 12320.871 -8371.463L12320.871 -8371.463L12320.871 -8362.104C 12320.816 -8355.453 12320.409 -8348.811 12319.652 -8342.203C 12319.399 -8340.616 12319.045 -8339.046 12318.591 -8337.503C 12317.896 -8335.145 12316.668 -8331.93 12314.761 -8330.009C 12313.005 -8328.1455 12310.826 -8326.732 12308.408 -8325.89C 12306.732 -8325.344 12304.996 -8325.006 12303.238 -8324.882C 12302.901 -8324.85 12302.649 -8324.823 12302.438 -8324.799C 12285.466 -8323.534 12259.7 -8323.52 12259.441 -8323.52zM12246.711 -8385.369L12246.711 -8350.839L12279.899 -8368.05L12246.711 -8385.369z",
            stroke: "none",
            fillRule: "nonzero"
          }
        ) }) })
      ]
    }
  );
}
function Xk(e) {
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ u.jsx("path", { d: "M0 7.67967V18.6666C0.00996094 21.151 2.03906 23.1502 4.51348 23.1402H20.5277C20.983 23.1402 21.3492 22.774 21.3492 22.3287V11.3424C21.3393 8.85799 19.3107 6.85818 16.8357 6.86814H0.821484C0.366211 6.86814 0 7.23435 0 7.67967ZM22.3688 11.9658L28.9805 7.13533C29.5547 6.66072 30 6.77908 30 7.64041V22.3679C30 23.3482 29.4557 23.2293 28.9805 22.873L22.3688 18.0525V11.9658Z", fill: "#142D63" })
    }
  );
}
const ya = ({
  description: e,
  descriptionClassName: t,
  error: r,
  errorClassName: a,
  className: n
}) => r || e ? /* @__PURE__ */ u.jsxs("div", { className: n, children: [
  e ? /* @__PURE__ */ u.jsx(
    "span",
    {
      className: z("ui-text-sm ui-opacity-70 [&>a]:ui-text-blue", t),
      children: e
    }
  ) : null,
  r ? /* @__PURE__ */ u.jsx(
    "p",
    {
      className: z("ui-text-sm ui-text-danger [&>a]:ui-text-blue", a),
      dangerouslySetInnerHTML: { __html: r }
    }
  ) : null
] }) : null, eP = ({
  inputRef: e,
  error: t,
  description: r,
  value: a,
  onChange: n,
  label: i,
  disabled: o,
  isFetching: s,
  labelClassName: l,
  className: c,
  errorClassName: d,
  descriptionClassName: p,
  checkboxIconClassName: f,
  inputClassName: h,
  inputWrapperClassName: m
}) => /* @__PURE__ */ u.jsxs(
  "label",
  {
    className: z(
      "ui-flex ui-gap-3 ui-items-center ui-w-fit ui-group",
      o ? "ui-cursor-default" : "ui-cursor-pointer",
      c
    ),
    "aria-checked": a,
    children: [
      /* @__PURE__ */ u.jsxs(
        "div",
        {
          className: z(
            "ui-flex ui-justify-center ui-items-center ui-relative",
            m
          ),
          children: [
            /* @__PURE__ */ u.jsx(
              "input",
              {
                ref: e,
                disabled: o,
                checked: a,
                className: z(
                  "ui-peer/checkbox ui-main-transition-colors",
                  o ? "ui-bg-gray-600/40 ui-border-darkgray/20 checked:ui-bg-darkblue/60 checked:ui-border-darkblue/75 ui-cursor-default" : "ui-border-darkgray ui-bg-white checked:ui-border-darkblue checked:ui-bg-darkblue",
                  s && "ui-animate-pulse",
                  "ui-focus-ring ui-appearance-none ui-cursor-pointer ui-border ui-h-[20px] ui-w-[20px] ui-rounded-md",
                  h
                ),
                type: "checkbox",
                onChange: (C) => n(C.target.checked)
              }
            ),
            /* @__PURE__ */ u.jsx(
              qf,
              {
                className: z(
                  "ui-absolute",
                  o ? a ? "ui-opacity-100 ui-fill-white/70" : "ui-opacity-0" : "ui-opacity-100 ui-fill-white",
                  f
                )
              }
            )
          ]
        }
      ),
      i && /* @__PURE__ */ u.jsx(
        "span",
        {
          className: z(
            "ui-main-transition-colors",
            a ? "ui-text-darkblue" : "ui-text-darkblue/50",
            "ui-leading-5",
            l,
            "ui-text-left"
          ),
          children: i
        }
      ),
      /* @__PURE__ */ u.jsx(
        ya,
        {
          description: r,
          error: t,
          errorClassName: d,
          descriptionClassName: p
        }
      )
    ]
  }
);
function wa({
  wrapperAs: e = "div",
  wrapperProps: t = { className: "ui-flex ui-justify-between ui-gap-2" },
  label: r,
  required: a,
  labelClassName: n,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return r || a || i ? /* @__PURE__ */ u.jsxs(e, { ...t, children: [
    (r || a) && /* @__PURE__ */ u.jsxs("span", { className: z("ui-flex", n), children: [
      r,
      " ",
      a && /* @__PURE__ */ u.jsx("i", { className: z("ui-text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
const o0 = Xa(function(e, t) {
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      ref: t,
      ...e,
      onClick: (r) => {
        var a;
        r.preventDefault = () => {
        }, (a = e.onClick) == null || a.call(e, r);
      }
    }
  );
}), mh = Xa(function(e, t) {
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      ref: t,
      ...e,
      onClick: (r) => {
        var a;
        r.preventDefault = () => {
        }, r.stopPropagation = () => {
        }, (a = e.onClick) == null || a.call(e, r);
      }
    }
  );
});
function s0() {
  const [e, t] = w.useState({
    width: 1200,
    height: 800,
    isWindowSizeSetFromBrowser: !1
  });
  function r() {
    t({
      width: window.innerWidth,
      height: window.innerHeight,
      isWindowSizeSetFromBrowser: !0
    });
  }
  return w.useEffect(() => (t({
    width: window.innerWidth,
    height: window.innerHeight,
    isWindowSizeSetFromBrowser: !0
  }), window.addEventListener("resize", r), () => {
    window.removeEventListener("resize", r);
  }), []), e;
}
const l0 = ({ hoverOpenDelay: e = 100 } = {}) => {
  const [t, r] = te(!1), a = Q(null), n = () => {
    a.current !== null && (clearTimeout(a.current), a.current = null);
  }, i = () => {
    n(), r(!0);
  }, o = () => {
    n(), a.current = setTimeout(() => {
      r(!0);
    }, e);
  }, s = () => {
    n(), r(!1);
  }, l = () => {
    n(), a.current = setTimeout(() => {
      r(!1);
    }, 100);
  };
  return he(() => () => n(), []), { show: t, open: i, close: s, delayClose: l, delayOpen: o };
}, u0 = (e) => {
  var t;
  return e.hasChildNodes() ? ((t = e.childNodes[0]) == null ? void 0 : t.nodeType) === 3 ? e : u0(e.childNodes[0]) : e;
}, gh = (e, t) => {
  const [r, a] = Y.useState(void 0), { width: n } = s0();
  return Y.useLayoutEffect(() => {
    const { current: i } = e;
    i && (() => {
      const s = u0(i);
      if (!s) return;
      const l = s.scrollWidth > i.clientWidth;
      a(l), t && t(l);
    })();
  }, [t, e, n]), r;
}, xl = ({
  mode: e = "hover",
  label: t,
  position: r = "top",
  anchor: a,
  className: n,
  wrapperClassName: i,
  popoverClassName: o,
  labelClassName: s,
  disabled: l,
  stayOnHover: c,
  children: d,
  hoverOpenDelay: p
}) => {
  const f = Q(null), h = Q(null), m = gh(f), { width: C } = s0(), { show: g, delayOpen: v, delayClose: b } = l0({ hoverOpenDelay: p });
  return /* @__PURE__ */ u.jsx(hl, { className: z("ui-flex ui-items-center", i), children: ({ open: y }) => {
    const x = l ? !1 : e === "click" || C < 1024 ? y : e === "hover" || e === "overflow" && m ? g : !1;
    return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        eo,
        {
          ref: f,
          as: e === "click" ? o0 : mh,
          className: z(
            "ui-relative ui-truncate ui-outline-none",
            e === "click" && !l && "ui-cursor-pointer",
            "ui-w-full ui-max-w-fit ui-h-full",
            n
          ),
          disabled: l,
          onMouseEnter: v,
          onMouseLeave: b,
          children: typeof d == "function" ? d(x) : d
        }
      ),
      /* @__PURE__ */ u.jsx(
        Kn,
        {
          as: $e,
          show: x,
          enter: "ui-transition ui-duration-100 ui-ease-out",
          enterFrom: "ui-opacity-0",
          enterTo: "ui-opacity-100",
          leave: "ui-transition ui-duration-75 ui-ease-in",
          leaveFrom: "ui-opacity-100",
          leaveTo: "ui-opacity-0",
          children: /* @__PURE__ */ u.jsx(
            to,
            {
              ref: h,
              anchor: a ?? r.replace("-", " "),
              className: z(
                "ui-relative ui-whitespace-normal ui-w-fit ui-px-5 ui-py-3",
                "ui-bg-white ui-rounded-lg ui-shadow-3xl",
                "[--anchor-gap:8px]",
                "ui-z-30",
                o
              ),
              onMouseEnter: c ? v : void 0,
              onMouseLeave: c ? b : void 0,
              children: /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: z(
                    "ui-w-full ui-text-center ui-text-gray-300 ui-font-medium ui-text-sm ui-font-averta ui-break-normal",
                    s
                  ),
                  children: t
                }
              )
            }
          )
        }
      )
    ] });
  } });
}, tP = (e) => /* @__PURE__ */ u.jsx(xl, { ...e, mode: "click" }), nP = ({
  selected: e,
  onChange: t,
  label: r,
  labelClassName: a,
  wrapperClassName: n,
  switcherClassName: i,
  disabled: o
}) => /* @__PURE__ */ u.jsxs(
  "div",
  {
    className: z(
      "ui-relative ui-flex md:ui-flex-row ui-flex-col ui-gap-2",
      n
    ),
    children: [
      /* @__PURE__ */ u.jsx(
        U3,
        {
          checked: e,
          onChange: t,
          disabled: o,
          className: z(
            "ui-relative ui-inline-flex ui-w-10 ui-h-5 ui-shrink-0 ui-cursor-pointer ui-rounded-full ui-border-2 ui-border-transparent ui-main-transition-colors ui-focus-ring",
            e && !o ? "ui-bg-blue" : "ui-bg-gray-100",
            i
          ),
          children: /* @__PURE__ */ u.jsx(
            "span",
            {
              "aria-hidden": "true",
              className: z(
                "ui-pointer-events-none ui-inline-block ui-h-4 ui-w-4 ui-transform ui-rounded-full ui-bg-white ui-shadow-lg ui-ring-0 ui-transition-transform ui-duration-200 ui-ease-linear",
                e ? "ui-translate-x-5" : "ui-translate-x-0"
              )
            }
          )
        }
      ),
      r && /* @__PURE__ */ u.jsx("div", { className: z(a), children: r })
    ]
  }
);
function cr() {
  return (cr = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }).apply(this, arguments);
}
function no(e, t) {
  if (e == null) return {};
  var r, a, n = {}, i = Object.keys(e);
  for (a = 0; a < i.length; a++) t.indexOf(r = i[a]) >= 0 || (n[r] = e[r]);
  return n;
}
function Wr(e) {
  var t = Q(e), r = Q(function(a) {
    t.current && t.current(a);
  });
  return t.current = e, r.current;
}
var Ka = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 1), e > r ? r : e < t ? t : e;
}, Ar = function(e) {
  return "touches" in e;
}, us = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, V2 = function(e, t, r) {
  var a = e.getBoundingClientRect(), n = Ar(t) ? function(i, o) {
    for (var s = 0; s < i.length; s++) if (i[s].identifier === o) return i[s];
    return i[0];
  }(t.touches, r) : t;
  return { left: Ka((n.pageX - (a.left + us(e).pageXOffset)) / a.width), top: Ka((n.pageY - (a.top + us(e).pageYOffset)) / a.height) };
}, K2 = function(e) {
  !Ar(e) && e.preventDefault();
}, Ml = w.memo(function(e) {
  var t = e.onMove, r = e.onKey, a = no(e, ["onMove", "onKey"]), n = Q(null), i = Wr(t), o = Wr(r), s = Q(null), l = Q(!1), c = q(function() {
    var h = function(g) {
      K2(g), (Ar(g) ? g.touches.length > 0 : g.buttons > 0) && n.current ? i(V2(n.current, g, s.current)) : C(!1);
    }, m = function() {
      return C(!1);
    };
    function C(g) {
      var v = l.current, b = us(n.current), y = g ? b.addEventListener : b.removeEventListener;
      y(v ? "touchmove" : "mousemove", h), y(v ? "touchend" : "mouseup", m);
    }
    return [function(g) {
      var v = g.nativeEvent, b = n.current;
      if (b && (K2(v), !function(x, S) {
        return S && !Ar(x);
      }(v, l.current) && b)) {
        if (Ar(v)) {
          l.current = !0;
          var y = v.changedTouches || [];
          y.length && (s.current = y[0].identifier);
        }
        b.focus(), i(V2(b, v, s.current)), C(!0);
      }
    }, function(g) {
      var v = g.which || g.keyCode;
      v < 37 || v > 40 || (g.preventDefault(), o({ left: v === 39 ? 0.05 : v === 37 ? -0.05 : 0, top: v === 40 ? 0.05 : v === 38 ? -0.05 : 0 }));
    }, C];
  }, [o, i]), d = c[0], p = c[1], f = c[2];
  return he(function() {
    return f;
  }, [f]), w.createElement("div", cr({}, a, { onTouchStart: d, onMouseDown: d, className: "react-colorful__interactive", ref: n, onKeyDown: p, tabIndex: 0, role: "slider" }));
}), ao = function(e) {
  return e.filter(Boolean).join(" ");
}, kl = function(e) {
  var t = e.color, r = e.left, a = e.top, n = a === void 0 ? 0.5 : a, i = ao(["react-colorful__pointer", e.className]);
  return w.createElement("div", { className: i, style: { top: 100 * n + "%", left: 100 * r + "%" } }, w.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, dt = function(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = Math.pow(10, t)), Math.round(r * e) / r;
}, Ch = function(e) {
  return wh(cs(e));
}, cs = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? dt(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? dt(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, vh = function(e) {
  return yh(bh(e));
}, c0 = function(e) {
  var t = e.s, r = e.v, a = e.a, n = (200 - t) * r / 100;
  return { h: dt(e.h), s: dt(n > 0 && n < 200 ? t * r / 100 / (n <= 100 ? n : 200 - n) * 100 : 0), l: dt(n / 2), a: dt(a, 2) };
}, ds = function(e) {
  var t = c0(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, Ao = function(e) {
  var t = c0(e);
  return "hsla(" + t.h + ", " + t.s + "%, " + t.l + "%, " + t.a + ")";
}, bh = function(e) {
  var t = e.h, r = e.s, a = e.v, n = e.a;
  t = t / 360 * 6, r /= 100, a /= 100;
  var i = Math.floor(t), o = a * (1 - r), s = a * (1 - (t - i) * r), l = a * (1 - (1 - t + i) * r), c = i % 6;
  return { r: dt(255 * [a, s, o, o, l, a][c]), g: dt(255 * [l, a, a, s, o, o][c]), b: dt(255 * [o, o, l, a, a, s][c]), a: dt(n, 2) };
}, Ii = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, yh = function(e) {
  var t = e.r, r = e.g, a = e.b, n = e.a, i = n < 1 ? Ii(dt(255 * n)) : "";
  return "#" + Ii(t) + Ii(r) + Ii(a) + i;
}, wh = function(e) {
  var t = e.r, r = e.g, a = e.b, n = e.a, i = Math.max(t, r, a), o = i - Math.min(t, r, a), s = o ? i === t ? (r - a) / o : i === r ? 2 + (a - t) / o : 4 + (t - r) / o : 0;
  return { h: dt(60 * (s < 0 ? s + 6 : s)), s: dt(i ? o / i * 100 : 0), v: dt(i / 255 * 100), a: n };
}, Sh = w.memo(function(e) {
  var t = e.hue, r = e.onChange, a = ao(["react-colorful__hue", e.className]);
  return w.createElement("div", { className: a }, w.createElement(Ml, { onMove: function(n) {
    r({ h: 360 * n.left });
  }, onKey: function(n) {
    r({ h: Ka(t + 360 * n.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": dt(t), "aria-valuemax": "360", "aria-valuemin": "0" }, w.createElement(kl, { className: "react-colorful__hue-pointer", left: t / 360, color: ds({ h: t, s: 100, v: 100, a: 1 }) })));
}), _h = w.memo(function(e) {
  var t = e.hsva, r = e.onChange, a = { backgroundColor: ds({ h: t.h, s: 100, v: 100, a: 1 }) };
  return w.createElement("div", { className: "react-colorful__saturation", style: a }, w.createElement(Ml, { onMove: function(n) {
    r({ s: 100 * n.left, v: 100 - 100 * n.top });
  }, onKey: function(n) {
    r({ s: Ka(t.s + 100 * n.left, 0, 100), v: Ka(t.v - 100 * n.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + dt(t.s) + "%, Brightness " + dt(t.v) + "%" }, w.createElement(kl, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: ds(t) })));
}), d0 = function(e, t) {
  if (e === t) return !0;
  for (var r in e) if (e[r] !== t[r]) return !1;
  return !0;
}, xh = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || d0(cs(e), cs(t));
};
function Mh(e, t, r) {
  var a = Wr(r), n = te(function() {
    return e.toHsva(t);
  }), i = n[0], o = n[1], s = Q({ color: t, hsva: i });
  he(function() {
    if (!e.equal(t, s.current.color)) {
      var c = e.toHsva(t);
      s.current = { hsva: c, color: t }, o(c);
    }
  }, [t, e]), he(function() {
    var c;
    d0(i, s.current.hsva) || e.equal(c = e.fromHsva(i), s.current.color) || (s.current = { hsva: i, color: c }, a(c));
  }, [i, e, a]);
  var l = _e(function(c) {
    o(function(d) {
      return Object.assign({}, d, c);
    });
  }, []);
  return [i, l];
}
var kh = typeof window < "u" ? ai : he, Ph = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, z2 = /* @__PURE__ */ new Map(), Th = function(e) {
  kh(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !z2.has(t)) {
      var r = t.createElement("style");
      r.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, z2.set(t, r);
      var a = Ph();
      a && r.setAttribute("nonce", a), t.head.appendChild(r);
    }
  }, []);
}, Eh = function(e) {
  var t = e.className, r = e.hsva, a = e.onChange, n = { backgroundImage: "linear-gradient(90deg, " + Ao(Object.assign({}, r, { a: 0 })) + ", " + Ao(Object.assign({}, r, { a: 1 })) + ")" }, i = ao(["react-colorful__alpha", t]), o = dt(100 * r.a);
  return w.createElement("div", { className: i }, w.createElement("div", { className: "react-colorful__alpha-gradient", style: n }), w.createElement(Ml, { onMove: function(s) {
    a({ a: s.left });
  }, onKey: function(s) {
    a({ a: Ka(r.a + s.left) });
  }, "aria-label": "Alpha", "aria-valuetext": o + "%", "aria-valuenow": o, "aria-valuemin": "0", "aria-valuemax": "100" }, w.createElement(kl, { className: "react-colorful__alpha-pointer", left: r.a, color: Ao(r) })));
}, Dh = function(e) {
  var t = e.className, r = e.colorModel, a = e.color, n = a === void 0 ? r.defaultColor : a, i = e.onChange, o = no(e, ["className", "colorModel", "color", "onChange"]), s = Q(null);
  Th(s);
  var l = Mh(r, n, i), c = l[0], d = l[1], p = ao(["react-colorful", t]);
  return w.createElement("div", cr({}, o, { ref: s, className: p }), w.createElement(_h, { hsva: c, onChange: d }), w.createElement(Sh, { hue: c.h, onChange: d }), w.createElement(Eh, { hsva: c, onChange: d, className: "react-colorful__last-control" }));
}, Ih = { defaultColor: "0001", toHsva: Ch, fromHsva: vh, equal: xh }, Lh = function(e) {
  return w.createElement(Dh, cr({}, e, { colorModel: Ih }));
}, Ah = /^#?([0-9A-F]{3,8})$/i, Nh = function(e) {
  var t = e.color, r = t === void 0 ? "" : t, a = e.onChange, n = e.onBlur, i = e.escape, o = e.validate, s = e.format, l = e.process, c = no(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), d = te(function() {
    return i(r);
  }), p = d[0], f = d[1], h = Wr(a), m = Wr(n), C = _e(function(v) {
    var b = i(v.target.value);
    f(b), o(b) && h(l ? l(b) : b);
  }, [i, l, o, h]), g = _e(function(v) {
    o(v.target.value) || f(i(r)), m(v);
  }, [r, i, o, m]);
  return he(function() {
    f(i(r));
  }, [r, i]), w.createElement("input", cr({}, c, { value: s ? s(p) : p, spellCheck: "false", onChange: C, onBlur: g }));
}, U2 = function(e) {
  return "#" + e;
}, Rh = function(e) {
  var t = e.prefixed, r = e.alpha, a = no(e, ["prefixed", "alpha"]), n = _e(function(o) {
    return o.replace(/([^0-9A-F]+)/gi, "").substring(0, r ? 8 : 6);
  }, [r]), i = _e(function(o) {
    return function(s, l) {
      var c = Ah.exec(s), d = c ? c[1].length : 0;
      return d === 3 || d === 6 || !!l && d === 4 || !!l && d === 8;
    }(o, r);
  }, [r]);
  return w.createElement(Nh, cr({}, a, { escape: n, format: t ? U2 : void 0, process: U2, validate: i }));
};
const aP = ({
  color: e,
  labelClassName: t,
  popoverClassName: r,
  popoverButtonClassName: a,
  hexColorInput: n,
  wrapperClassName: i,
  children: o,
  additionalPopoverChildren: s,
  focusTrapFeatures: l = kn.None,
  stayWhenUnfocused: c = !1,
  pickerRef: d,
  ...p
}) => {
  const [f, h] = te(!1), m = Q(null);
  return he(() => {
    const C = (b) => {
      var y;
      (y = m.current) != null && y.contains(b.target) && h(!0);
    }, g = (b) => {
      m.current && !m.current.contains(b.target) && h(!1);
    }, v = (b) => {
      b.key === "Escape" && h(!1);
    };
    return document.addEventListener("focusin", C), document.addEventListener("touchstart", g, !0), document.addEventListener("mousedown", g, !0), document.addEventListener("keydown", v), () => {
      document.removeEventListener("focusin", C), document.removeEventListener("touchstart", g, !0), document.removeEventListener("mousedown", g, !0), document.removeEventListener("keydown", v);
    };
  }, []), d && (d.current = {
    allowToHideWhenUnfocused: (C) => {
      h(!C);
    }
  }), /* @__PURE__ */ u.jsx(hl, { className: "ui-flex ui-items-center", children: ({ open: C, close: g }) => {
    const v = c && f || C;
    return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        eo,
        {
          as: o0,
          className: z(
            "ui-relative ui-truncate ui-outline-none",
            "ui-cursor-pointer",
            "ui-w-full ui-max-w-fit ui-h-full",
            "ui-focus-ring ui-rounded-lg",
            a
          ),
          children: (o == null ? void 0 : o(v)) ?? /* @__PURE__ */ u.jsx(
            "div",
            {
              style: { backgroundColor: e },
              className: "ui-w-10 ui-h-10 ui-rounded-lg ui-border ui-border-gray/30"
            }
          )
        }
      ),
      /* @__PURE__ */ u.jsx(
        Kn,
        {
          as: $e,
          show: v,
          enter: "ui-transition ui-duration-100 ui-ease-out",
          enterFrom: "ui-opacity-0",
          enterTo: "ui-opacity-100",
          leave: "ui-transition ui-duration-75 ui-ease-in",
          leaveFrom: "ui-opacity-100",
          leaveTo: "ui-opacity-0",
          children: /* @__PURE__ */ u.jsx(
            to,
            {
              ref: m,
              anchor: "top",
              className: z(
                "ui-relative ui-whitespace-normal ui-w-fit ui-px-5 ui-py-3 ui-pt-5",
                "ui-bg-white ui-rounded-lg ui-shadow-3xl",
                "[--anchor-gap:8px]",
                "ui-z-30",
                r
              ),
              children: /* @__PURE__ */ u.jsx(qs, { features: l, children: /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: z(
                    "ui-w-full ui-text-center ui-text-gray-300 ui-font-medium ui-text-sm ui-font-averta ui-break-normal",
                    t
                  ),
                  children: /* @__PURE__ */ u.jsxs("div", { className: z("ui-flex ui-flex-col ui-gap-3", i), children: [
                    /* @__PURE__ */ u.jsx(Lh, { color: e, ...p }),
                    /* @__PURE__ */ u.jsxs("div", { className: "ui-flex", children: [
                      /* @__PURE__ */ u.jsx("div", { className: "ui-p-2 ui-bg-gray-200 ui-rounded-l-lg", children: "#" }),
                      /* @__PURE__ */ u.jsx(
                        Rh,
                        {
                          alpha: !0,
                          className: z(
                            "ui-outline-none ui-w-full ui-border ui-main-transition-colors ui-rounded-r-lg ui-border-gray/30 focus:ui-border-blue ui-p-2",
                            n
                          ),
                          color: e,
                          onChange: p.onChange
                        }
                      )
                    ] }),
                    s == null ? void 0 : s(g)
                  ] })
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
}, ps = (e, t) => ({
  ...e ? {
    "data-test-id": `${t}`
  } : {}
}), Oh = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Bh = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, jh = (e) => Bh[e], Hh = (e) => e.replace(Oh, jh);
let Z2 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Hh
};
const Fh = (e = {}) => {
  Z2 = {
    ...Z2,
    ...e
  };
}, Gh = {
  type: "3rdParty",
  init(e) {
    Fh(e.options.react);
  }
}, be = (e) => typeof e == "string", Sr = () => {
  let e, t;
  const r = new Promise((a, n) => {
    e = a, t = n;
  });
  return r.resolve = e, r.reject = t, r;
}, Y2 = (e) => e == null ? "" : "" + e, Vh = (e, t, r) => {
  e.forEach((a) => {
    t[a] && (r[a] = t[a]);
  });
}, Kh = /###/g, W2 = (e) => e && e.indexOf("###") > -1 ? e.replace(Kh, ".") : e, $2 = (e) => !e || be(e), Nr = (e, t, r) => {
  const a = be(t) ? t.split(".") : t;
  let n = 0;
  for (; n < a.length - 1; ) {
    if ($2(e)) return {};
    const i = W2(a[n]);
    !e[i] && r && (e[i] = new r()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++n;
  }
  return $2(e) ? {} : {
    obj: e,
    k: W2(a[n])
  };
}, J2 = (e, t, r) => {
  const {
    obj: a,
    k: n
  } = Nr(e, t, Object);
  if (a !== void 0 || t.length === 1) {
    a[n] = r;
    return;
  }
  let i = t[t.length - 1], o = t.slice(0, t.length - 1), s = Nr(e, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = Nr(e, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = r;
}, zh = (e, t, r, a) => {
  const {
    obj: n,
    k: i
  } = Nr(e, t, Object);
  n[i] = n[i] || [], n[i].push(r);
}, r1 = (e, t) => {
  const {
    obj: r,
    k: a
  } = Nr(e, t);
  if (r)
    return r[a];
}, Uh = (e, t, r) => {
  const a = r1(e, r);
  return a !== void 0 ? a : r1(t, r);
}, p0 = (e, t, r) => {
  for (const a in t)
    a !== "__proto__" && a !== "constructor" && (a in e ? be(e[a]) || e[a] instanceof String || be(t[a]) || t[a] instanceof String ? r && (e[a] = t[a]) : p0(e[a], t[a], r) : e[a] = t[a]);
  return e;
}, Ia = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Zh = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Yh = (e) => be(e) ? e.replace(/[&<>"'\/]/g, (t) => Zh[t]) : e;
class Wh {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const r = this.regExpMap.get(t);
    if (r !== void 0)
      return r;
    const a = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, a), this.regExpQueue.push(t), a;
  }
}
const $h = [" ", ",", "?", "!", ";"], Jh = new Wh(20), Qh = (e, t, r) => {
  t = t || "", r = r || "";
  const a = $h.filter((o) => t.indexOf(o) < 0 && r.indexOf(o) < 0);
  if (a.length === 0) return !0;
  const n = Jh.getRegExp(`(${a.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !n.test(e);
  if (!i) {
    const o = e.indexOf(r);
    o > 0 && !n.test(e.substring(0, o)) && (i = !0);
  }
  return i;
}, fs = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e) return;
  if (e[t]) return e[t];
  const a = t.split(r);
  let n = e;
  for (let i = 0; i < a.length; ) {
    if (!n || typeof n != "object")
      return;
    let o, s = "";
    for (let l = i; l < a.length; ++l)
      if (l !== i && (s += r), s += a[l], o = n[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < a.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    n = o;
  }
  return n;
}, i1 = (e) => e && e.replace("_", "-"), qh = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class o1 {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, r);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = t || qh, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, r = new Array(t), a = 0; a < t; a++)
      r[a] = arguments[a];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, r, a, n) {
    return n && !this.debug ? null : (be(t[0]) && (t[0] = `${a}${this.prefix} ${t[0]}`), this.logger[r](t));
  }
  create(t) {
    return new o1(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new o1(this.logger, t);
  }
}
var un = new o1();
class ro {
  constructor() {
    this.observers = {};
  }
  on(t, r) {
    return t.split(" ").forEach((a) => {
      this.observers[a] || (this.observers[a] = /* @__PURE__ */ new Map());
      const n = this.observers[a].get(r) || 0;
      this.observers[a].set(r, n + 1);
    }), this;
  }
  off(t, r) {
    if (this.observers[t]) {
      if (!r) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(r);
    }
  }
  emit(t) {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s.apply(s, [t, ...a]);
    });
  }
}
class Q2 extends ro {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const r = this.options.ns.indexOf(t);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, o = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, r], a && (Array.isArray(a) ? s.push(...a) : be(a) && i ? s.push(...a.split(i)) : s.push(a)));
    const l = r1(this.data, s);
    return !l && !r && !a && t.indexOf(".") > -1 && (t = s[0], r = s[1], a = s.slice(2).join(".")), l || !o || !be(a) ? l : fs(this.data && this.data[t] && this.data[t][r], a, i);
  }
  addResource(t, r, a, n) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, r];
    a && (s = s.concat(o ? a.split(o) : a)), t.indexOf(".") > -1 && (s = t.split("."), n = r, r = s[1]), this.addNamespaces(r), J2(this.data, s, n), i.silent || this.emit("added", t, r, a, n);
  }
  addResources(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in a)
      (be(a[i]) || Array.isArray(a[i])) && this.addResource(t, r, i, a[i], {
        silent: !0
      });
    n.silent || this.emit("added", t, r, a);
  }
  addResourceBundle(t, r, a, n, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, r];
    t.indexOf(".") > -1 && (s = t.split("."), n = a, a = r, r = s[1]), this.addNamespaces(r);
    let l = r1(this.data, s) || {};
    o.skipCopy || (a = JSON.parse(JSON.stringify(a))), n ? p0(l, a, i) : l = {
      ...l,
      ...a
    }, J2(this.data, s, l), o.silent || this.emit("added", t, r, a);
  }
  removeResourceBundle(t, r) {
    this.hasResourceBundle(t, r) && delete this.data[t][r], this.removeNamespaces(r), this.emit("removed", t, r);
  }
  hasResourceBundle(t, r) {
    return this.getResource(t, r) !== void 0;
  }
  getResourceBundle(t, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, r)
    } : this.getResource(t, r);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const r = this.getDataByLanguage(t);
    return !!(r && Object.keys(r) || []).find((n) => r[n] && Object.keys(r[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var f0 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, r, a, n) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, r, a, n));
    }), t;
  }
};
const q2 = {};
class s1 extends ro {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Vh(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = un.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const a = this.resolve(t, r);
    return a && a.res !== void 0;
  }
  extractFromKey(t, r) {
    let a = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    a === void 0 && (a = ":");
    const n = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const o = a && t.indexOf(a) > -1, s = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !Qh(t, a, n);
    if (o && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: be(i) ? [i] : i
        };
      const c = t.split(a);
      (a !== n || a === n && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: be(i) ? [i] : i
    };
  }
  translate(t, r, a) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), t == null) return "";
    Array.isArray(t) || (t = [String(t)]);
    const n = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], r), l = s[s.length - 1], c = r.lng || this.language, d = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (d) {
        const x = r.nsSeparator || this.options.nsSeparator;
        return n ? {
          res: `${l}${x}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${x}${o}`;
      }
      return n ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : o;
    }
    const p = this.resolve(t, r);
    let f = p && p.res;
    const h = p && p.usedKey || o, m = p && p.exactUsedKey || o, C = Object.prototype.toString.apply(f), g = ["[object Number]", "[object Function]", "[object RegExp]"], v = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, b = !this.i18nFormat || this.i18nFormat.handleAsObject, y = !be(f) && typeof f != "boolean" && typeof f != "number";
    if (b && f && y && g.indexOf(C) < 0 && !(be(v) && Array.isArray(f))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, f, {
          ...r,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return n ? (p.res = x, p.usedParams = this.getUsedParamsDetails(r), p) : x;
      }
      if (i) {
        const x = Array.isArray(f), S = x ? [] : {}, _ = x ? m : h;
        for (const M in f)
          if (Object.prototype.hasOwnProperty.call(f, M)) {
            const I = `${_}${i}${M}`;
            S[M] = this.translate(I, {
              ...r,
              joinArrays: !1,
              ns: s
            }), S[M] === I && (S[M] = f[M]);
          }
        f = S;
      }
    } else if (b && be(v) && Array.isArray(f))
      f = f.join(v), f && (f = this.extendTranslation(f, t, r, a));
    else {
      let x = !1, S = !1;
      const _ = r.count !== void 0 && !be(r.count), M = s1.hasDefaultValue(r), I = _ ? this.pluralResolver.getSuffix(c, r.count, r) : "", L = r.ordinal && _ ? this.pluralResolver.getSuffix(c, r.count, {
        ordinal: !1
      }) : "", D = _ && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), A = D && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${I}`] || r[`defaultValue${L}`] || r.defaultValue;
      !this.isValidLookup(f) && M && (x = !0, f = A), this.isValidLookup(f) || (S = !0, f = o);
      const U = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && S ? void 0 : f, H = M && A !== f && this.options.updateMissing;
      if (S || x || H) {
        if (this.logger.log(H ? "updateKey" : "missingKey", c, l, o, H ? A : f), i) {
          const O = this.resolve(o, {
            ...r,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const Z = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && Z && Z[0])
          for (let O = 0; O < Z.length; O++)
            K.push(Z[O]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(r.lng || this.language) : K.push(r.lng || this.language);
        const V = (O, j, N) => {
          const E = M && N !== f ? N : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, l, j, E, H, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(O, l, j, E, H, r), this.emit("missingKey", O, l, j, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && _ ? K.forEach((O) => {
          const j = this.pluralResolver.getSuffixes(O, r);
          D && r[`defaultValue${this.options.pluralSeparator}zero`] && j.indexOf(`${this.options.pluralSeparator}zero`) < 0 && j.push(`${this.options.pluralSeparator}zero`), j.forEach((N) => {
            V([O], o + N, r[`defaultValue${N}`] || A);
          });
        }) : V(K, o, A));
      }
      f = this.extendTranslation(f, t, r, p, a), S && f === o && this.options.appendNamespaceToMissingKey && (f = `${l}:${o}`), (S || x) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, x ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return n ? (p.res = f, p.usedParams = this.getUsedParamsDetails(r), p) : f;
  }
  extendTranslation(t, r, a, n, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...a
      }, a.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!a.skipInterpolation) {
      a.interpolation && this.interpolator.init({
        ...a,
        interpolation: {
          ...this.options.interpolation,
          ...a.interpolation
        }
      });
      const c = be(t) && (a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let d;
      if (c) {
        const f = t.match(this.interpolator.nestingRegexp);
        d = f && f.length;
      }
      let p = a.replace && !be(a.replace) ? a.replace : a;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), t = this.interpolator.interpolate(t, p, a.lng || this.language || n.usedLng, a), c) {
        const f = t.match(this.interpolator.nestingRegexp), h = f && f.length;
        d < h && (a.nest = !1);
      }
      !a.lng && this.options.compatibilityAPI !== "v1" && n && n.res && (a.lng = this.language || n.usedLng), a.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var f = arguments.length, h = new Array(f), m = 0; m < f; m++)
          h[m] = arguments[m];
        return i && i[0] === h[0] && !a.context ? (o.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${r[0]}`), null) : o.translate(...h, r);
      }, a)), a.interpolation && this.interpolator.reset();
    }
    const s = a.postProcess || this.options.postProcess, l = be(s) ? [s] : s;
    return t != null && l && l.length && a.applyPostProcessor !== !1 && (t = f0.handle(l, t, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(a)
      },
      ...a
    } : a, this)), t;
  }
  resolve(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a, n, i, o, s;
    return be(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(a)) return;
      const c = this.extractFromKey(l, r), d = c.key;
      n = d;
      let p = c.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const f = r.count !== void 0 && !be(r.count), h = f && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = r.context !== void 0 && (be(r.context) || typeof r.context == "number") && r.context !== "", C = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      p.forEach((g) => {
        this.isValidLookup(a) || (s = g, !q2[`${C[0]}-${g}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (q2[`${C[0]}-${g}`] = !0, this.logger.warn(`key "${n}" for languages "${C.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), C.forEach((v) => {
          if (this.isValidLookup(a)) return;
          o = v;
          const b = [d];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(b, d, v, g, r);
          else {
            let x;
            f && (x = this.pluralResolver.getSuffix(v, r.count, r));
            const S = `${this.options.pluralSeparator}zero`, _ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (b.push(d + x), r.ordinal && x.indexOf(_) === 0 && b.push(d + x.replace(_, this.options.pluralSeparator)), h && b.push(d + S)), m) {
              const M = `${d}${this.options.contextSeparator}${r.context}`;
              b.push(M), f && (b.push(M + x), r.ordinal && x.indexOf(_) === 0 && b.push(M + x.replace(_, this.options.pluralSeparator)), h && b.push(M + S));
            }
          }
          let y;
          for (; y = b.pop(); )
            this.isValidLookup(a) || (i = y, a = this.getResource(v, g, y, r));
        }));
      });
    }), {
      res: a,
      usedKey: n,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, r, a, n) : this.resourceStore.getResource(t, r, a, n);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], a = t.replace && !be(t.replace);
    let n = a ? t.replace : t;
    if (a && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !a) {
      n = {
        ...n
      };
      for (const i of r)
        delete n[i];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const r = "defaultValue";
    for (const a in t)
      if (Object.prototype.hasOwnProperty.call(t, a) && r === a.substring(0, r.length) && t[a] !== void 0)
        return !0;
    return !1;
  }
}
const No = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class X2 {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = un.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = i1(t), !t || t.indexOf("-") < 0) return null;
    const r = t.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = i1(t), !t || t.indexOf("-") < 0) return t;
    const r = t.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(t) {
    if (be(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let n = Intl.getCanonicalLocales(t)[0];
          if (n && this.options.lowerCaseLng && (n = n.toLowerCase()), n) return n;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let a = t.split("-");
      return this.options.lowerCaseLng ? a = a.map((n) => n.toLowerCase()) : a.length === 2 ? (a[0] = a[0].toLowerCase(), a[1] = a[1].toUpperCase(), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = No(a[1].toLowerCase()))) : a.length === 3 && (a[0] = a[0].toLowerCase(), a[1].length === 2 && (a[1] = a[1].toUpperCase()), a[0] !== "sgn" && a[2].length === 2 && (a[2] = a[2].toUpperCase()), r.indexOf(a[1].toLowerCase()) > -1 && (a[1] = No(a[1].toLowerCase())), r.indexOf(a[2].toLowerCase()) > -1 && (a[2] = No(a[2].toLowerCase()))), a.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let r;
    return t.forEach((a) => {
      if (r) return;
      const n = this.formatLanguageCode(a);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (r = n);
    }), !r && this.options.supportedLngs && t.forEach((a) => {
      if (r) return;
      const n = this.getLanguagePartFromCode(a);
      if (this.isSupportedCode(n)) return r = n;
      r = this.options.supportedLngs.find((i) => {
        if (i === n) return i;
        if (!(i.indexOf("-") < 0 && n.indexOf("-") < 0) && (i.indexOf("-") > 0 && n.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === n || i.indexOf(n) === 0 && n.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(t, r) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(r)), be(t) && (t = [t]), Array.isArray(t)) return t;
    if (!r) return t.default || [];
    let a = t[r];
    return a || (a = t[this.getScriptPartFromCode(r)]), a || (a = t[this.formatLanguageCode(r)]), a || (a = t[this.getLanguagePartFromCode(r)]), a || (a = t.default), a || [];
  }
  toResolveHierarchy(t, r) {
    const a = this.getFallbackCodes(r || this.options.fallbackLng || [], t), n = [], i = (o) => {
      o && (this.isSupportedCode(o) ? n.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return be(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : be(t) && i(this.formatLanguageCode(t)), a.forEach((o) => {
      n.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), n;
  }
}
let Xh = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], em = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const tm = ["v1", "v2", "v3"], nm = ["v4"], eu = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, am = () => {
  const e = {};
  return Xh.forEach((t) => {
    t.lngs.forEach((r) => {
      e[r] = {
        numbers: t.nr,
        plurals: em[t.fc]
      };
    });
  }), e;
};
class rm {
  constructor(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = r, this.logger = un.create("pluralResolver"), (!this.options.compatibilityJSON || nm.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = am(), this.pluralRulesCache = {};
  }
  addRule(t, r) {
    this.rules[t] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const a = i1(t === "dev" ? "en" : t), n = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: a,
        type: n
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(a, {
          type: n
        });
      } catch {
        if (!t.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(t);
        o = this.getRule(l, r);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = this.getRule(t, r);
    return this.shouldUseIntlApi() ? a && a.resolvedOptions().pluralCategories.length > 1 : a && a.numbers.length > 1;
  }
  getPluralFormsOfKey(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, a).map((n) => `${r}${n}`);
  }
  getSuffixes(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? a.resolvedOptions().pluralCategories.sort((n, i) => eu[n] - eu[i]).map((n) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : a.numbers.map((n) => this.getSuffix(t, n, r)) : [];
  }
  getSuffix(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const n = this.getRule(t, a);
    return n ? this.shouldUseIntlApi() ? `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(r)}` : this.getSuffixRetroCompatible(n, r) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, r) {
    const a = t.noAbs ? t.plurals(r) : t.plurals(Math.abs(r));
    let n = t.numbers[a];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (n === 2 ? n = "plural" : n === 1 && (n = ""));
    const i = () => this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
    return this.options.compatibilityJSON === "v1" ? n === 1 ? "" : typeof n == "number" ? `_plural_${n.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
  }
  shouldUseIntlApi() {
    return !tm.includes(this.options.compatibilityJSON);
  }
}
const tu = function(e, t, r) {
  let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Uh(e, t, r);
  return !i && n && be(r) && (i = fs(e, r, a), i === void 0 && (i = fs(t, r, a))), i;
}, Ro = (e) => e.replace(/\$/g, "$$$$");
class im {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = un.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((r) => r), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: a,
      useRawValueToEscape: n,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: d,
      unescapePrefix: p,
      nestingPrefix: f,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: C,
      nestingOptionsSeparator: g,
      maxReplaces: v,
      alwaysFormat: b
    } = t.interpolation;
    this.escape = r !== void 0 ? r : Yh, this.escapeValue = a !== void 0 ? a : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = i ? Ia(i) : o || "{{", this.suffix = s ? Ia(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = d ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : d || "", this.nestingPrefix = f ? Ia(f) : h || Ia("$t("), this.nestingSuffix = m ? Ia(m) : C || Ia(")"), this.nestingOptionsSeparator = g || ",", this.maxReplaces = v || 1e3, this.alwaysFormat = b !== void 0 ? b : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (r, a) => r && r.source === a ? (r.lastIndex = 0, r) : new RegExp(a, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, r, a, n) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const v = tu(r, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(v, void 0, a, {
          ...n,
          ...r,
          interpolationkey: h
        }) : v;
      }
      const m = h.split(this.formatSeparator), C = m.shift().trim(), g = m.join(this.formatSeparator).trim();
      return this.format(tu(r, l, C, this.options.keySeparator, this.options.ignoreJSONStructure), g, a, {
        ...n,
        ...r,
        interpolationkey: C
      });
    };
    this.resetRegExp();
    const d = n && n.missingInterpolationHandler || this.options.missingInterpolationHandler, p = n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => Ro(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? Ro(this.escape(h)) : Ro(h)
    }].forEach((h) => {
      for (s = 0; i = h.regex.exec(t); ) {
        const m = i[1].trim();
        if (o = c(m), o === void 0)
          if (typeof d == "function") {
            const g = d(t, i, n);
            o = be(g) ? g : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, m))
            o = "";
          else if (p) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), o = "";
        else !be(o) && !this.useRawValueToEscape && (o = Y2(o));
        const C = h.safeValue(o);
        if (t = t.replace(i[0], C), p ? (h.regex.lastIndex += o.length, h.regex.lastIndex -= i[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n, i, o;
    const s = (l, c) => {
      const d = this.nestingOptionsSeparator;
      if (l.indexOf(d) < 0) return l;
      const p = l.split(new RegExp(`${d}[ ]*{`));
      let f = `{${p[1]}`;
      l = p[0], f = this.interpolate(f, o);
      const h = f.match(/'/g), m = f.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        o = JSON.parse(f), c && (o = {
          ...c,
          ...o
        });
      } catch (C) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, C), `${l}${d}${f}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      o = {
        ...a
      }, o = o.replace && !be(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (n[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(n[1])) {
        const d = n[1].split(this.formatSeparator).map((p) => p.trim());
        n[1] = d.shift(), l = d, c = !0;
      }
      if (i = r(s.call(this, n[1].trim(), o), o), i && n[0] === t && !be(i)) return i;
      be(i) || (i = Y2(i)), i || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), i = ""), c && (i = l.reduce((d, p) => this.format(d, p, a.lng, {
        ...a,
        interpolationkey: n[1].trim()
      }), i.trim())), t = t.replace(n[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const om = (e) => {
  let t = e.toLowerCase().trim();
  const r = {};
  if (e.indexOf("(") > -1) {
    const a = e.split("(");
    t = a[0].toLowerCase().trim();
    const n = a[1].substring(0, a[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? r.currency || (r.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? r.range || (r.range = n.trim()) : n.split(";").forEach((o) => {
      if (o) {
        const [s, ...l] = o.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), d = s.trim();
        r[d] || (r[d] = c), c === "false" && (r[d] = !1), c === "true" && (r[d] = !0), isNaN(c) || (r[d] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: r
  };
}, La = (e) => {
  const t = {};
  return (r, a, n) => {
    let i = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (i = {
      ...i,
      [n.interpolationkey]: void 0
    });
    const o = a + JSON.stringify(i);
    let s = t[o];
    return s || (s = e(i1(a), n), t[o] = s), s(r);
  };
};
class sm {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = un.create("formatter"), this.options = t, this.formats = {
      number: La((r, a) => {
        const n = new Intl.NumberFormat(r, {
          ...a
        });
        return (i) => n.format(i);
      }),
      currency: La((r, a) => {
        const n = new Intl.NumberFormat(r, {
          ...a,
          style: "currency"
        });
        return (i) => n.format(i);
      }),
      datetime: La((r, a) => {
        const n = new Intl.DateTimeFormat(r, {
          ...a
        });
        return (i) => n.format(i);
      }),
      relativetime: La((r, a) => {
        const n = new Intl.RelativeTimeFormat(r, {
          ...a
        });
        return (i) => n.format(i, a.range || "day");
      }),
      list: La((r, a) => {
        const n = new Intl.ListFormat(r, {
          ...a
        });
        return (i) => n.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(t, r) {
    this.formats[t.toLowerCase().trim()] = r;
  }
  addCached(t, r) {
    this.formats[t.toLowerCase().trim()] = La(r);
  }
  format(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: d
      } = om(l);
      if (this.formats[c]) {
        let p = s;
        try {
          const f = n && n.formatParams && n.formatParams[n.interpolationkey] || {}, h = f.locale || f.lng || n.locale || n.lng || a;
          p = this.formats[c](s, h, {
            ...d,
            ...n,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return p;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const lm = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class um extends ro {
  constructor(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = r, this.services = a, this.languageUtils = a.languageUtils, this.options = n, this.logger = un.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(a, n.backend, n);
  }
  queueLoad(t, r, a, n) {
    const i = {}, o = {}, s = {}, l = {};
    return t.forEach((c) => {
      let d = !0;
      r.forEach((p) => {
        const f = `${c}|${p}`;
        !a.reload && this.store.hasResourceBundle(c, p) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? o[f] === void 0 && (o[f] = !0) : (this.state[f] = 1, d = !1, o[f] === void 0 && (o[f] = !0), i[f] === void 0 && (i[f] = !0), l[p] === void 0 && (l[p] = !0)));
      }), d || (s[c] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, r, a) {
    const n = t.split("|"), i = n[0], o = n[1];
    r && this.emit("failedLoading", i, o, r), !r && a && this.store.addResourceBundle(i, o, a, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = r ? -1 : 2, r && a && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      zh(l.loaded, [i], o), lm(l, t), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const d = l.loaded[c];
        d.length && d.forEach((p) => {
          s[c][p] === void 0 && (s[c][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, r, a) {
    let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length) return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: r,
        fcName: a,
        tried: n,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (c, d) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (c && d && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, r, a, n + 1, i * 2, o);
        }, i);
        return;
      }
      o(c, d);
    }, l = this.backend[a].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, r);
        c && typeof c.then == "function" ? c.then((d) => s(null, d)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, r, s);
  }
  prepareLoading(t, r) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    be(t) && (t = this.languageUtils.toResolveHierarchy(t)), be(r) && (r = [r]);
    const i = this.queueLoad(t, r, a, n);
    if (!i.toLoad.length)
      return i.pending.length || n(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, r, a) {
    this.prepareLoading(t, r, {}, a);
  }
  reload(t, r, a) {
    this.prepareLoading(t, r, {
      reload: !0
    }, a);
  }
  loadOne(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const a = t.split("|"), n = a[0], i = a[1];
    this.read(n, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${r}loading namespace ${i} for language ${n} failed`, o), !o && s && this.logger.log(`${r}loaded namespace ${i} for language ${n}`, s), this.loaded(t, o, s);
    });
  }
  saveMissing(t, r, a, n, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${a}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(a == null || a === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let d;
            c.length === 5 ? d = c(t, r, a, n, l) : d = c(t, r, a, n), d && typeof d.then == "function" ? d.then((p) => s(null, p)).catch(s) : s(null, d);
          } catch (d) {
            s(d);
          }
        else
          c(t, r, a, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], r, a, n);
    }
  }
}
const nu = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), be(e[1]) && (t.defaultValue = e[1]), be(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const r = e[3] || e[2];
      Object.keys(r).forEach((a) => {
        t[a] = r[a];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), au = (e) => (be(e.ns) && (e.ns = [e.ns]), be(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), be(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), Li = () => {
}, cm = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((r) => {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
};
class $r extends ro {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = au(t), this.services = {}, this.logger = un, this.modules = {
      external: []
    }, cm(this), r && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, r), this;
      setTimeout(() => {
        this.init(t, r);
      }, 0);
    }
  }
  init() {
    var t = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (a = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (be(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const n = nu();
    this.options = {
      ...n,
      ...this.options,
      ...au(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (d) => d ? typeof d == "function" ? new d() : d : null;
    if (!this.options.isClone) {
      this.modules.logger ? un.init(i(this.modules.logger), this.options) : un.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : typeof Intl < "u" && (d = sm);
      const p = new X2(this.options);
      this.store = new Q2(this.options.resources, this.options);
      const f = this.services;
      f.logger = un, f.resourceStore = this.store, f.languageUtils = p, f.pluralResolver = new rm(p, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), d && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (f.formatter = i(d), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new im(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new um(i(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(h) {
        for (var m = arguments.length, C = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
          C[g - 1] = arguments[g];
        t.emit(h, ...C);
      }), this.modules.languageDetector && (f.languageDetector = i(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = i(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new s1(this.services, this.options), this.translator.on("*", function(h) {
        for (var m = arguments.length, C = new Array(m > 1 ? m - 1 : 0), g = 1; g < m; g++)
          C[g - 1] = arguments[g];
        t.emit(h, ...C);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Li), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = function() {
        return t.store[d](...arguments), t;
      };
    });
    const l = Sr(), c = () => {
      const d = (p, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), a(p, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(t) {
    let a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Li;
    const n = be(t) ? t : this.language;
    if (typeof t == "function" && (a = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n && n.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return a();
      const i = [], o = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      n ? o(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), a(s);
      });
    } else
      a(null);
  }
  reloadResources(t, r, a) {
    const n = Sr();
    return typeof t == "function" && (a = t, t = void 0), typeof r == "function" && (a = r, r = void 0), t || (t = this.languages), r || (r = this.options.ns), a || (a = Li), this.services.backendConnector.reload(t, r, (i) => {
      n.resolve(), a(i);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && f0.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const a = this.languages[r];
        if (!(["cimode", "dev"].indexOf(a) > -1) && this.store.hasLanguageSomeTranslations(a)) {
          this.resolvedLanguage = a;
          break;
        }
      }
  }
  changeLanguage(t, r) {
    var a = this;
    this.isLanguageChangingTo = t;
    const n = Sr();
    this.emit("languageChanging", t);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, n.resolve(function() {
        return a.t(...arguments);
      }), r && r(l, function() {
        return a.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = be(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (d) => {
        o(d, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), n;
  }
  getFixedT(t, r, a) {
    var n = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, d = new Array(c > 2 ? c - 2 : 0), p = 2; p < c; p++)
          d[p - 2] = arguments[p];
        l = n.options.overloadTranslationOptionHandler([o, s].concat(d));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || a || i.keyPrefix);
      const f = n.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(o) ? h = o.map((m) => `${l.keyPrefix}${f}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${f}${o}` : o, n.t(h, l);
    };
    return be(t) ? i.lng = t : i.lngs = t, i.ns = r, i.keyPrefix = a, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const a = r.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (a.toLowerCase() === "cimode") return !0;
    const o = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (r.precheck) {
      const s = r.precheck(this, o);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(a, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(a, t) && (!n || o(i, t)));
  }
  loadNamespaces(t, r) {
    const a = Sr();
    return this.options.ns ? (be(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      a.resolve(), r && r(n);
    }), a) : (r && r(), Promise.resolve());
  }
  loadLanguages(t, r) {
    const a = Sr();
    be(t) && (t = [t]);
    const n = this.options.preload || [], i = t.filter((o) => n.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = n.concat(i), this.loadResources((o) => {
      a.resolve(), r && r(o);
    }), a) : (r && r(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], a = this.services && this.services.languageUtils || new X2(nu());
    return r.indexOf(a.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new $r(t, r);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Li;
    const a = t.forkResourceStore;
    a && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new $r(n);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, a && (i.store = new Q2(this.store.data, n), i.services.resourceStore = i.store), i.translator = new s1(i.services, n), i.translator.on("*", function(s) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
        c[d - 1] = arguments[d];
      i.emit(s, ...c);
    }), i.init(n, r), i.translator.options = n, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ue = $r.createInstance();
ue.createInstance = $r.createInstance;
ue.createInstance;
ue.dir;
ue.init;
ue.loadResources;
ue.reloadResources;
ue.use;
ue.changeLanguage;
ue.getFixedT;
ue.t;
ue.exists;
ue.setDefaultNamespace;
ue.hasLoadedNamespace;
ue.loadNamespaces;
ue.loadLanguages;
var Pn = /* @__PURE__ */ ((e) => (e.FRENCH = "fr", e.ENGLISH = "en", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "ja", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "da", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "uk", e.ALBANIA = "sq", e.HINDI = "hi", e))(Pn || {});
const dm = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقات الائتمان (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "مسح",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  }
}, pm = {
  public_pages_purchase: dm
}, fm = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní karty (Stripe)",
    stripe_ideal: "iDeal (proužek)",
    stripe_bancotact: "Bancontact (proužek)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "španělština",
    japanese: "Japonský",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "čínština",
    swedish: "švédský",
    romanian: "Rumunština",
    czech: "čeština",
    hungarian: "Maďarský",
    slovak: "Slovák",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "řecký",
    serbian: "Srbština",
    hindi: "Ani náhodou",
    norwegian: "Norský",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánský"
  }
}, hm = {
  public_pages_purchase: fm
}, mm = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  }
}, gm = {
  public_pages_purchase: mm
}, Cm = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditkarten (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  }
}, vm = {
  public_pages_purchase: Cm
}, bm = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Σχέδιο",
    stripe_card: "Πιστωτικές κάρτες (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Πιστωτικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Πιστωτικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Παραγορά πληρωμών)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Μόλι",
    gocardless: "Χωρίς Gocard",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Πιστωτικές κάρτες (Xendit)",
    paystack_card: "Πιστωτικές κάρτες (Paystack)",
    paypal_connect: "Συνδέστε το PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Ασφαλίστε και πληρώστε",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} στη συνέχεια",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλέξτε"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Αριθμός τηλεφώνου",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Όνομα εταιρείας",
    tax_number: "Αριθμός φορολογικού μητρώου",
    state_province: "Πολιτεία/Επαρχία",
    street_number: "Αριθμός δρόμου",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Εφαρμογή",
    clear: "Καθαρισμός",
    time: "Χρόνος",
    all_time: "Όλος ο χρόνος",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης πισίνας",
    last_month: "Τελευταίος μήνας",
    this_month: "Αυτός ο μήνας",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Αντιγράφηκε στο πρόχειρο",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Ο CVC είναι μη έγκυρος",
    empty_cvc: "Εισάγετε έναν CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Αριθμός τηλεφώνου",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "καταχωρημένο πάνω από",
  locale: {
    french: "γαλλική γλώσσα",
    german: "Γερμανός",
    italian: "ιταλικός",
    dutch: "Ολλανδός",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσική",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "αραβικός",
    turkish: "τούρκικος",
    chinese: "κινέζικα",
    swedish: "Σουηδικά",
    romanian: "ρουμανικός",
    czech: "Τσέχος",
    hungarian: "ουγγρικός",
    slovak: "Σλοβάκος",
    danish: "δανικός",
    indonesian: "Ινδονησιακά",
    polish: "Στίλβωση",
    greek: "Ελληνικά",
    serbian: "Σέρβος",
    hindi: "Όχι",
    norwegian: "Νορβηγός",
    thai: "Ταϊλανδός",
    slovenian: "Σλοβενική",
    ukrainian: "Ουκρανός",
    albania: "Αλβανός"
  }
}, ym = {
  public_pages_purchase: bm
}, wm = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit cards (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  }
}, Sm = {
  public_pages_purchase: wm
}, _m = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjetas de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  }
}, xm = {
  public_pages_purchase: _m
}, Mm = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Cartes de crédit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  }
}, km = {
  public_pages_purchase: Mm
}, Pm = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट कार्ड्स (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  }
}, Tm = {
  public_pages_purchase: Pm
}, Em = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitelkártyák (Stripe)",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  }
}, Dm = {
  public_pages_purchase: Em
}, Im = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit (Garis)",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  }
}, Lm = {
  public_pages_purchase: Im
}, Am = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carte di credito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Codice fiscale",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Tempo",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  }
}, Nm = {
  public_pages_purchase: Am
}, Rm = {
  "required-field": "フィールドは必須項目です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカード（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "苗字",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "納税者番号",
    state_province: "州/都道府県",
    street_number: "番地",
    neighborhood: "近隣地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "最後の評価期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  }
}, Om = {
  public_pages_purchase: Rm
}, Bm = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcard betalingen toestaan",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact betalingen toestaan",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  }
}, jm = {
  public_pages_purchase: Bm
}, Hm = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredittkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  }
}, Fm = {
  public_pages_purchase: Hm
}, Gm = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karty kredytowe (pasek)",
    stripe_ideal: "idealny (pasek)",
    stripe_bancotact: "Bancontact (pasek)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (lokalnie)",
    dlocal_pix: "Pix (lokalnie)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (rynek płatności)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Molly",
    gocardless: "Bez karty",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (stosunek wypłat)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Bezpiecznie i płać",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} wtedy",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Sąsiedztwo"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Wszystkie czasy",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Język angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Język japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czech",
    hungarian: "Język węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Nie",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  }
}, Vm = {
  public_pages_purchase: Gm
}, Km = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Para"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  }
}, zm = {
  public_pages_purchase: Km
}, Um = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carduri de credit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  }
}, Zm = {
  public_pages_purchase: Um
}, Ym = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Разрешить оплату кредитной картой",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "Из",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  }
}, Wm = {
  public_pages_purchase: Ym
}, $m = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditné karty (Stripe)",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  }
}, Jm = {
  public_pages_purchase: $m
}, Qm = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditne kartice (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  }
}, qm = {
  public_pages_purchase: Qm
}, Xm = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartat e kreditit (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  }
}, eg = {
  public_pages_purchase: Xm
}, tg = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитне картице (Стрипе)",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  }
}, ng = {
  public_pages_purchase: tg
}, ag = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kreditkort (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  }
}, rg = {
  public_pages_purchase: ag
}, ig = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิต (ลายทาง)",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  }
}, og = {
  public_pages_purchase: ig
}, sg = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi kartları (Şeritli)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Den",
    to: "E"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  }
}, lg = {
  public_pages_purchase: sg
}, ug = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитні картки (Stripe)",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "українська",
    albania: "албанець"
  }
}, cg = {
  public_pages_purchase: ug
}, dg = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡（Stripe）",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  }
}, pg = {
  public_pages_purchase: dg
}, h0 = ["common"], fg = h0[0], hg = Object.values(Pn), mg = {
  ar: { common: pm },
  cs: { common: hm },
  da: { common: gm },
  de: { common: vm },
  el: { common: ym },
  en: { common: Sm },
  es: { common: xm },
  fr: { common: km },
  hi: { common: Tm },
  hu: { common: Dm },
  id: { common: Lm },
  it: { common: Nm },
  ja: { common: Om },
  nl: { common: jm },
  no: { common: Fm },
  pl: { common: Vm },
  pt: { common: zm },
  ro: { common: Zm },
  ru: { common: Wm },
  sk: { common: Jm },
  sl: { common: qm },
  sq: { common: eg },
  sr: { common: ng },
  sv: { common: rg },
  th: { common: og },
  tr: { common: lg },
  uk: { common: cg },
  zh: { common: pg }
}, gg = {
  supportedLngs: hg,
  load: "languageOnly",
  debug: !1,
  defaultNS: fg,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: h0,
  compatibilityJSON: "v3",
  fallbackLng: Pn.ENGLISH,
  lng: Pn.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: mg
};
ue.use(Gh).init(gg);
const rP = (e) => {
  switch (e) {
    case qe.Stripe:
      return "Stripe";
    case qe.PaypalSoap:
    case qe.PaypalRest:
      return "Paypal";
    case qe.Dlocal:
      return "dLocal";
    case qe.MercadoPagoBR:
    case qe.MercadoPagoCO:
    case qe.MercadoPagoMX:
    case qe.MercadoPagoAR:
    case qe.MercadoPagoCL:
      return "MercadoPago";
    case qe.Razorpay:
      return "Razorpay";
    case qe.Flutterwave:
      return "Flutterwave";
    case qe.Mollie:
      return "Mollie";
    case qe.Gocardless:
      return "GoCardless";
    case qe.XenditID:
    case qe.XenditPH:
      return "Xendit";
    case qe.PaystackGH:
    case qe.PaystackKE:
    case qe.PaystackNG:
    case qe.PaystackZA:
    case qe.PaystackEG:
    case qe.PaystackCI:
      return "Paystack";
    case qe.CashOnDelivery:
      return ue.t("public_pages_purchase.payment.cash_on_delivery");
    case qe.SecureAndPay:
      return "Secure and Pay";
  }
};
var qe = /* @__PURE__ */ ((e) => (e.Stripe = "stripe", e.PaypalSoap = "paypal-soap", e.Dlocal = "dlocal", e.MercadoPagoBR = "mercadopago-br", e.MercadoPagoCO = "mercadopago-co", e.MercadoPagoMX = "mercadopago-mx", e.MercadoPagoAR = "mercadopago-ar", e.MercadoPagoCL = "mercadopago-cl", e.Razorpay = "razorpay", e.Flutterwave = "flutterwave", e.Mollie = "mollie", e.Gocardless = "gocardless", e.XenditID = "xendit-id", e.XenditPH = "xendit-ph", e.PaystackGH = "paystack-gh", e.PaystackKE = "paystack-ke", e.PaystackNG = "paystack-ng", e.PaystackZA = "paystack-za", e.PaystackEG = "paystack-eg", e.PaystackCI = "paystack-ci", e.CashOnDelivery = "cash-on-delivery", e.PaypalRest = "paypal-rest", e.SecureAndPay = "secure-and-pay", e))(qe || {});
const iP = (e) => {
  switch (e) {
    case ce.stripe_card:
      return ue.t("public_pages_purchase.payment.stripe_card");
    case ce.stripe_ideal:
      return ue.t("public_pages_purchase.payment.stripe_ideal");
    case ce.stripe_bancontact:
      return ue.t("public_pages_purchase.payment.stripe_bancotact");
    case ce.stripe_applepay:
      return ue.t("public_pages_purchase.payment.stripe_applepay");
    case ce.dlocal_card:
      return ue.t("public_pages_purchase.payment.dlocal_card");
    case ce.dlocal_boleto:
      return ue.t("public_pages_purchase.payment.dlocal_boleto");
    case ce.dlocal_pix:
      return ue.t("public_pages_purchase.payment.dlocal_pix");
    case ce.paypal_soap:
    case ce.paypal_rest:
      return ue.t("public_pages_purchase.payment.paypal_soap");
    case ce.mercadopago_br_card:
      return ue.t("public_pages_purchase.payment.mercadopago_card");
    case ce.mercadopago_br_pix:
      return ue.t("public_pages_purchase.payment.mercadopago_pix");
    case ce.mercadopago_br_boleto:
      return ue.t("public_pages_purchase.payment.mercadopago_boleto");
    case ce.mercadopago_co_card:
    case ce.mercadopago_ar_card:
    case ce.mercadopago_mx_card:
    case ce.mercadopago_cl_card:
      return ue.t("public_pages_purchase.payment.mercadopago_card");
    case ce.razorpay:
      return ue.t("public_pages_purchase.payment.razorpay");
    case ce.flutterwave:
      return ue.t("public_pages_purchase.payment.flutterwave");
    case ce.mollie:
      return ue.t("public_pages_purchase.payment.mollie");
    case ce.gocardless:
      return ue.t("public_pages_purchase.payment.gocardless");
    case ce.cash_on_delivery:
      return ue.t("public_pages_purchase.payment.cash_on_delivery");
    case ce.xendit_id_card:
    case ce.xendit_ph_card:
      return ue.t("public_pages_purchase.payment.xendit_card");
    case ce.paystack_gh_card:
    case ce.paystack_ke_card:
    case ce.paystack_ng_card:
    case ce.paystack_za_card:
    case ce.paystack_eg_card:
    case ce.paystack_ci_card:
      return ue.t("public_pages_purchase.payment.paystack_card");
    case ce.secure_and_pay:
      return ue.t("public_pages_purchase.payment.secure_and_pay");
  }
}, oP = (e, t) => {
  switch (e) {
    case ce.stripe_card:
    case ce.dlocal_card:
    case ce.mercadopago_br_card:
    case ce.mercadopago_ar_card:
    case ce.mercadopago_co_card:
    case ce.mercadopago_mx_card:
    case ce.mercadopago_cl_card:
    case ce.secure_and_pay:
      return /* @__PURE__ */ u.jsx(nh, { ...t });
    case ce.stripe_applepay:
      return /* @__PURE__ */ u.jsx(Zf, { ...t });
    case ce.stripe_ideal:
      return /* @__PURE__ */ u.jsx(oh, { ...t });
    case ce.stripe_bancontact:
      return /* @__PURE__ */ u.jsx(Wf, { ...t });
    case ce.dlocal_boleto:
    case ce.mercadopago_br_boleto:
      return /* @__PURE__ */ u.jsx($f, { ...t });
    case ce.dlocal_pix:
    case ce.mercadopago_br_pix:
      return /* @__PURE__ */ u.jsx(dh, { ...t });
    case ce.paypal_soap:
    case ce.paypal_rest:
      return /* @__PURE__ */ u.jsx(uh, { ...t });
    case ce.razorpay:
      return /* @__PURE__ */ u.jsx(ph, { ...t });
    case ce.flutterwave:
      return /* @__PURE__ */ u.jsx(rh, { ...t });
    case ce.mollie:
      return /* @__PURE__ */ u.jsx(lh, { ...t });
    case ce.gocardless:
      return /* @__PURE__ */ u.jsx(ih, { ...t });
    case ce.cash_on_delivery:
      return /* @__PURE__ */ u.jsx(Qf, { ...t });
    case ce.xendit_id_card:
    case ce.xendit_ph_card:
      return /* @__PURE__ */ u.jsx(hh, { ...t });
    case ce.paystack_gh_card:
    case ce.paystack_ke_card:
    case ce.paystack_ng_card:
    case ce.paystack_za_card:
    case ce.paystack_eg_card:
    case ce.paystack_ci_card:
      return /* @__PURE__ */ u.jsx(ch, { ...t });
  }
};
var ce = /* @__PURE__ */ ((e) => (e.stripe_card = "stripe:card", e.stripe_ideal = "stripe:ideal", e.stripe_bancontact = "stripe:bancontact", e.stripe_applepay = "stripe:applepay", e.dlocal_card = "dlocal:card", e.dlocal_boleto = "dlocal:boleto", e.dlocal_pix = "dlocal:pix", e.paypal_soap = "paypal-soap", e.paypal_rest = "paypal-rest", e.mercadopago_br_card = "mercadopago-br:card", e.mercadopago_br_pix = "mercadopago-br:pix", e.mercadopago_br_boleto = "mercadopago-br:boleto", e.mercadopago_co_card = "mercadopago-co:card", e.mercadopago_ar_card = "mercadopago-ar:card", e.mercadopago_mx_card = "mercadopago-mx:card", e.mercadopago_cl_card = "mercadopago-cl:card", e.razorpay = "razorpay", e.flutterwave = "flutterwave", e.mollie = "mollie", e.gocardless = "gocardless", e.cash_on_delivery = "cash-on-delivery", e.xendit_id_card = "xendit-id:card", e.xendit_ph_card = "xendit-ph:card", e.paystack_gh_card = "paystack-gh:card", e.paystack_ke_card = "paystack-ke:card", e.paystack_ng_card = "paystack-ng:card", e.paystack_za_card = "paystack-za:card", e.paystack_eg_card = "paystack-eg:card", e.paystack_ci_card = "paystack-ci:card", e.secure_and_pay = "secure-and-pay", e))(ce || {}), hs = /* @__PURE__ */ ((e) => (e.dateFirst = "d/m/Y", e.monthFirst = "m/d/Y", e))(hs || {}), Cg = /* @__PURE__ */ ((e) => (e.hourMinute = "H:i", e.hourMinuteAmPm = "h:i A", e.hourMinuteSecond = "H:i:s", e.hourMinuteSecondAmPm = "h:i:s A", e))(Cg || {});
function m0(e) {
  const t = Object.keys(ha).find(
    (r) => ha[r] === e
  );
  return t ? Pn[t] : Pn.ENGLISH;
}
function sP(e) {
  const t = Object.keys(Pn).find(
    (r) => Pn[r] === e
  );
  return t ? ha[t] : ha.ENGLISH;
}
function lP(e) {
  return ue.t(vg[e]);
}
var ha = /* @__PURE__ */ ((e) => (e.ENGLISH = "en", e.FRENCH = "fr", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "jp", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "dk", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "ua", e.ALBANIA = "sq", e.HINDI = "hi", e))(ha || {});
const uP = {
  en: "EN",
  fr: "FR",
  es: "ES",
  it: "IT",
  pt: "PT",
  de: "DE",
  nl: "NL",
  ru: "RU",
  jp: "JP",
  ar: "AR",
  tr: "TR",
  zh: "CH",
  sv: "SV",
  ro: "RO",
  cs: "CS",
  hu: "HU",
  sk: "SK",
  dk: "DK",
  id: "ID",
  pl: "PL",
  el: "EL",
  sr: "SR",
  hi: "HI",
  no: "NO",
  th: "TH",
  sl: "SL",
  ua: "UA",
  sq: "SQ"
}, cP = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  pt: "Português",
  de: "Deutsch",
  nl: "Nederlands",
  ru: "Русский",
  jp: "日本語",
  ar: "عربي",
  tr: "Türkçe",
  zh: "中文(简体)",
  sv: "Svenska",
  ro: "Română",
  cs: "Čeština",
  hu: "Magyar",
  sk: "Slovenský",
  dk: "Dansk",
  id: "Indonesian",
  pl: "Polski",
  el: "Ελληνικά",
  sr: "Srpski",
  hi: "Hindi",
  no: "Norsk",
  th: "ไทย",
  sl: "Slovenski",
  ua: "Український",
  sq: "Shqiptare"
}, vg = {
  en: "public_pages_purchase.locale.english",
  fr: "public_pages_purchase.locale.french",
  es: "public_pages_purchase.locale.spanish",
  it: "public_pages_purchase.locale.italian",
  pt: "public_pages_purchase.locale.portuguese",
  de: "public_pages_purchase.locale.german",
  nl: "public_pages_purchase.locale.dutch",
  ru: "public_pages_purchase.locale.russian",
  jp: "public_pages_purchase.locale.japanese",
  zh: "public_pages_purchase.locale.chinese",
  tr: "public_pages_purchase.locale.turkish",
  ar: "public_pages_purchase.locale.arabic",
  sv: "public_pages_purchase.locale.swedish",
  ro: "public_pages_purchase.locale.romanian",
  cs: "public_pages_purchase.locale.czech",
  hu: "public_pages_purchase.locale.hungarian",
  sk: "public_pages_purchase.locale.slovak",
  dk: "public_pages_purchase.locale.danish",
  id: "public_pages_purchase.locale.indonesian",
  pl: "public_pages_purchase.locale.polish",
  el: "public_pages_purchase.locale.greek",
  sr: "public_pages_purchase.locale.serbian",
  hi: "public_pages_purchase.locale.hindi",
  no: "public_pages_purchase.locale.norwegian",
  th: "public_pages_purchase.locale.thai",
  sl: "public_pages_purchase.locale.slovenian",
  ua: "public_pages_purchase.locale.ukrainian",
  sq: "public_pages_purchase.locale.albania"
}, bg = Le(null), dP = ({
  children: e,
  locale: t
}) => (he(() => {
  if (!ue.isInitialized) return;
  const r = m0(t);
  ue.language !== r && ue.changeLanguage(r);
}, [t]), /* @__PURE__ */ u.jsx(bg.Provider, { value: { locale: t }, children: e }));
var Pl = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.AlandIslands = "AX", e.Albania = "AL", e.Algeria = "DZ", e.AmericanSamoa = "AS", e.Andorra = "AD", e.Angola = "AO", e.Anguilla = "AI", e.Antarctica = "AQ", e.AntiguaAndBarbuda = "AG", e.Argentina = "AR", e.Armenia = "AM", e.Aruba = "AW", e.Australia = "AU", e.Austria = "AT", e.Azerbaijan = "AZ", e.Bahamas = "BS", e.Bahrain = "BH", e.Bangladesh = "BD", e.Barbados = "BB", e.Belarus = "BY", e.Belgium = "BE", e.Belize = "BZ", e.Benin = "BJ", e.Bermuda = "BM", e.Bhutan = "BT", e.Bolivia = "BO", e.BonaireSintEustatiusSaba = "BQ", e.BosniaAndHerzegovina = "BA", e.Botswana = "BW", e.BouvetIsland = "BV", e.Brazil = "BR", e.BritishIndianOceanTerritory = "IO", e.BruneiDarussalam = "BN", e.Bulgaria = "BG", e.BurkinaFaso = "BF", e.Burundi = "BI", e.Cambodia = "KH", e.Cameroon = "CM", e.Canada = "CA", e.CapeVerde = "CV", e.CaymanIslands = "KY", e.CentralAfricanRepublic = "CF", e.Chad = "TD", e.Chile = "CL", e.China = "CN", e.ChristmasIsland = "CX", e.CocosKeelingIslands = "CC", e.Colombia = "CO", e.Comoros = "KM", e.Congo = "CG", e.CongoDemocraticRepublic = "CD", e.CookIslands = "CK", e.CostaRica = "CR", e.CoteDIvoire = "CI", e.Croatia = "HR", e.Cuba = "CU", e.Curaçao = "CW", e.Cyprus = "CY", e.CzechRepublic = "CZ", e.Denmark = "DK", e.Djibouti = "DJ", e.Dominica = "DM", e.DominicanRepublic = "DO", e.Ecuador = "EC", e.Egypt = "EG", e.ElSalvador = "SV", e.EquatorialGuinea = "GQ", e.Eritrea = "ER", e.Estonia = "EE", e.Ethiopia = "ET", e.FalklandIslands = "FK", e.FaroeIslands = "FO", e.Fiji = "FJ", e.Finland = "FI", e.France = "FR", e.FrenchGuiana = "GF", e.FrenchPolynesia = "PF", e.FrenchSouthernTerritories = "TF", e.Gabon = "GA", e.Gambia = "GM", e.Georgia = "GE", e.Germany = "DE", e.Ghana = "GH", e.Gibraltar = "GI", e.Greece = "GR", e.Greenland = "GL", e.Grenada = "GD", e.Guadeloupe = "GP", e.Guam = "GU", e.Guatemala = "GT", e.Guernsey = "GG", e.Guinea = "GN", e.GuineaBissau = "GW", e.Guyana = "GY", e.Haiti = "HT", e.HeardIslandMcdonaldIslands = "HM", e.HolySeeVaticanCityState = "VA", e.Honduras = "HN", e.HongKong = "HK", e.Hungary = "HU", e.Iceland = "IS", e.India = "IN", e.Indonesia = "ID", e.Iran = "IR", e.Iraq = "IQ", e.Ireland = "IE", e.IsleOfMan = "IM", e.Israel = "IL", e.Italy = "IT", e.Jamaica = "JM", e.Japan = "JP", e.Jersey = "JE", e.Jordan = "JO", e.Kazakhstan = "KZ", e.Kenya = "KE", e.Kiribati = "KI", e.Korea = "KR", e.KoreaDemocraticPeoplesRepublic = "KP", e.Kuwait = "KW", e.Kyrgyzstan = "KG", e.LaoPeoplesDemocraticRepublic = "LA", e.Latvia = "LV", e.Lebanon = "LB", e.Lesotho = "LS", e.Liberia = "LR", e.LibyanArabJamahiriya = "LY", e.Liechtenstein = "LI", e.Lithuania = "LT", e.Luxembourg = "LU", e.Macao = "MO", e.Macedonia = "MK", e.Madagascar = "MG", e.Malawi = "MW", e.Malaysia = "MY", e.Maldives = "MV", e.Mali = "ML", e.Malta = "MT", e.MarshallIslands = "MH", e.Martinique = "MQ", e.Mauritania = "MR", e.Mauritius = "MU", e.Mayotte = "YT", e.Mexico = "MX", e.Micronesia = "FM", e.Moldova = "MD", e.Monaco = "MC", e.Mongolia = "MN", e.Montenegro = "ME", e.Montserrat = "MS", e.Morocco = "MA", e.Mozambique = "MZ", e.Myanmar = "MM", e.Namibia = "NA", e.Nauru = "NR", e.Nepal = "NP", e.Netherlands = "NL", e.NewCaledonia = "NC", e.NewZealand = "NZ", e.Nicaragua = "NI", e.Niger = "NE", e.Nigeria = "NG", e.Niue = "NU", e.NorfolkIsland = "NF", e.NorthernMarianaIslands = "MP", e.Norway = "NO", e.Oman = "OM", e.Pakistan = "PK", e.Palau = "PW", e.PalestinianTerritory = "PS", e.Panama = "PA", e.PapuaNewGuinea = "PG", e.Paraguay = "PY", e.Peru = "PE", e.Philippines = "PH", e.Pitcairn = "PN", e.Poland = "PL", e.Portugal = "PT", e.PuertoRico = "PR", e.Qatar = "QA", e.Reunion = "RE", e.Romania = "RO", e.RussianFederation = "RU", e.Rwanda = "RW", e.SaintBarthelemy = "BL", e.SaintHelena = "SH", e.SaintKittsAndNevis = "KN", e.SaintLucia = "LC", e.SaintMartin = "MF", e.SaintPierreAndMiquelon = "PM", e.SaintVincentAndGrenadines = "VC", e.Samoa = "WS", e.SanMarino = "SM", e.SaoTomeAndPrincipe = "ST", e.SaudiArabia = "SA", e.Senegal = "SN", e.Serbia = "RS", e.Seychelles = "SC", e.SierraLeone = "SL", e.Singapore = "SG", e.SintMaarten = "SX", e.Slovakia = "SK", e.Slovenia = "SI", e.SolomonIslands = "SB", e.Somalia = "SO", e.SouthAfrica = "ZA", e.SouthGeorgiaAndSandwichIsl = "GS", e.SouthSudan = "SS", e.Spain = "ES", e.SriLanka = "LK", e.Sudan = "SD", e.Suriname = "SR", e.SvalbardAndJanMayen = "SJ", e.Swaziland = "SZ", e.Sweden = "SE", e.Switzerland = "CH", e.SyrianArabRepublic = "SY", e.Taiwan = "TW", e.Tajikistan = "TJ", e.Tanzania = "TZ", e.Thailand = "TH", e.TimorLeste = "TL", e.Togo = "TG", e.Tokelau = "TK", e.Tonga = "TO", e.TrinidadAndTobago = "TT", e.Tunisia = "TN", e.Turkey = "TR", e.Turkmenistan = "TM", e.TurksAndCaicosIslands = "TC", e.Tuvalu = "TV", e.Uganda = "UG", e.Ukraine = "UA", e.UnitedArabEmirates = "AE", e.UnitedKingdom = "GB", e.UnitedStates = "US", e.UnitedStatesOutlyingIslands = "UM", e.Uruguay = "UY", e.Uzbekistan = "UZ", e.Vanuatu = "VU", e.Venezuela = "VE", e.Vietnam = "VN", e.VirginIslandsBritish = "VG", e.VirginIslandsUS = "VI", e.WallisAndFutuna = "WF", e.WesternSahara = "EH", e.Yemen = "YE", e.Zambia = "ZM", e.Zimbabwe = "ZW", e))(Pl || {}), g0 = {};
const yg = [
  [
    "AF",
    "AFG",
    "004",
    "ISO 3166-2:AF"
  ],
  [
    "AL",
    "ALB",
    "008",
    "ISO 3166-2:AL"
  ],
  [
    "DZ",
    "DZA",
    "012",
    "ISO 3166-2:DZ"
  ],
  [
    "AS",
    "ASM",
    "016",
    "ISO 3166-2:AS"
  ],
  [
    "AD",
    "AND",
    "020",
    "ISO 3166-2:AD"
  ],
  [
    "AO",
    "AGO",
    "024",
    "ISO 3166-2:AO"
  ],
  [
    "AI",
    "AIA",
    "660",
    "ISO 3166-2:AI"
  ],
  [
    "AQ",
    "ATA",
    "010",
    "ISO 3166-2:AQ"
  ],
  [
    "AG",
    "ATG",
    "028",
    "ISO 3166-2:AG"
  ],
  [
    "AR",
    "ARG",
    "032",
    "ISO 3166-2:AR"
  ],
  [
    "AM",
    "ARM",
    "051",
    "ISO 3166-2:AM"
  ],
  [
    "AW",
    "ABW",
    "533",
    "ISO 3166-2:AW"
  ],
  [
    "AU",
    "AUS",
    "036",
    "ISO 3166-2:AU"
  ],
  [
    "AT",
    "AUT",
    "040",
    "ISO 3166-2:AT"
  ],
  [
    "AZ",
    "AZE",
    "031",
    "ISO 3166-2:AZ"
  ],
  [
    "BS",
    "BHS",
    "044",
    "ISO 3166-2:BS"
  ],
  [
    "BH",
    "BHR",
    "048",
    "ISO 3166-2:BH"
  ],
  [
    "BD",
    "BGD",
    "050",
    "ISO 3166-2:BD"
  ],
  [
    "BB",
    "BRB",
    "052",
    "ISO 3166-2:BB"
  ],
  [
    "BY",
    "BLR",
    "112",
    "ISO 3166-2:BY"
  ],
  [
    "BE",
    "BEL",
    "056",
    "ISO 3166-2:BE"
  ],
  [
    "BZ",
    "BLZ",
    "084",
    "ISO 3166-2:BZ"
  ],
  [
    "BJ",
    "BEN",
    "204",
    "ISO 3166-2:BJ"
  ],
  [
    "BM",
    "BMU",
    "060",
    "ISO 3166-2:BM"
  ],
  [
    "BT",
    "BTN",
    "064",
    "ISO 3166-2:BT"
  ],
  [
    "BO",
    "BOL",
    "068",
    "ISO 3166-2:BO"
  ],
  [
    "BA",
    "BIH",
    "070",
    "ISO 3166-2:BA"
  ],
  [
    "BW",
    "BWA",
    "072",
    "ISO 3166-2:BW"
  ],
  [
    "BV",
    "BVT",
    "074",
    "ISO 3166-2:BV"
  ],
  [
    "BR",
    "BRA",
    "076",
    "ISO 3166-2:BR"
  ],
  [
    "IO",
    "IOT",
    "086",
    "ISO 3166-2:IO"
  ],
  [
    "BN",
    "BRN",
    "096",
    "ISO 3166-2:BN"
  ],
  [
    "BG",
    "BGR",
    "100",
    "ISO 3166-2:BG"
  ],
  [
    "BF",
    "BFA",
    "854",
    "ISO 3166-2:BF"
  ],
  [
    "BI",
    "BDI",
    "108",
    "ISO 3166-2:BI"
  ],
  [
    "KH",
    "KHM",
    "116",
    "ISO 3166-2:KH"
  ],
  [
    "CM",
    "CMR",
    "120",
    "ISO 3166-2:CM"
  ],
  [
    "CA",
    "CAN",
    "124",
    "ISO 3166-2:CA"
  ],
  [
    "CV",
    "CPV",
    "132",
    "ISO 3166-2:CV"
  ],
  [
    "KY",
    "CYM",
    "136",
    "ISO 3166-2:KY"
  ],
  [
    "CF",
    "CAF",
    "140",
    "ISO 3166-2:CF"
  ],
  [
    "TD",
    "TCD",
    "148",
    "ISO 3166-2:TD"
  ],
  [
    "CL",
    "CHL",
    "152",
    "ISO 3166-2:CL"
  ],
  [
    "CN",
    "CHN",
    "156",
    "ISO 3166-2:CN"
  ],
  [
    "CX",
    "CXR",
    "162",
    "ISO 3166-2:CX"
  ],
  [
    "CC",
    "CCK",
    "166",
    "ISO 3166-2:CC"
  ],
  [
    "CO",
    "COL",
    "170",
    "ISO 3166-2:CO"
  ],
  [
    "KM",
    "COM",
    "174",
    "ISO 3166-2:KM"
  ],
  [
    "CG",
    "COG",
    "178",
    "ISO 3166-2:CG"
  ],
  [
    "CD",
    "COD",
    "180",
    "ISO 3166-2:CD"
  ],
  [
    "CK",
    "COK",
    "184",
    "ISO 3166-2:CK"
  ],
  [
    "CR",
    "CRI",
    "188",
    "ISO 3166-2:CR"
  ],
  [
    "CI",
    "CIV",
    "384",
    "ISO 3166-2:CI"
  ],
  [
    "HR",
    "HRV",
    "191",
    "ISO 3166-2:HR"
  ],
  [
    "CU",
    "CUB",
    "192",
    "ISO 3166-2:CU"
  ],
  [
    "CY",
    "CYP",
    "196",
    "ISO 3166-2:CY"
  ],
  [
    "CZ",
    "CZE",
    "203",
    "ISO 3166-2:CZ"
  ],
  [
    "DK",
    "DNK",
    "208",
    "ISO 3166-2:DK"
  ],
  [
    "DJ",
    "DJI",
    "262",
    "ISO 3166-2:DJ"
  ],
  [
    "DM",
    "DMA",
    "212",
    "ISO 3166-2:DM"
  ],
  [
    "DO",
    "DOM",
    "214",
    "ISO 3166-2:DO"
  ],
  [
    "EC",
    "ECU",
    "218",
    "ISO 3166-2:EC"
  ],
  [
    "EG",
    "EGY",
    "818",
    "ISO 3166-2:EG"
  ],
  [
    "SV",
    "SLV",
    "222",
    "ISO 3166-2:SV"
  ],
  [
    "GQ",
    "GNQ",
    "226",
    "ISO 3166-2:GQ"
  ],
  [
    "ER",
    "ERI",
    "232",
    "ISO 3166-2:ER"
  ],
  [
    "EE",
    "EST",
    "233",
    "ISO 3166-2:EE"
  ],
  [
    "ET",
    "ETH",
    "231",
    "ISO 3166-2:ET"
  ],
  [
    "FK",
    "FLK",
    "238",
    "ISO 3166-2:FK"
  ],
  [
    "FO",
    "FRO",
    "234",
    "ISO 3166-2:FO"
  ],
  [
    "FJ",
    "FJI",
    "242",
    "ISO 3166-2:FJ"
  ],
  [
    "FI",
    "FIN",
    "246",
    "ISO 3166-2:FI"
  ],
  [
    "FR",
    "FRA",
    "250",
    "ISO 3166-2:FR"
  ],
  [
    "GF",
    "GUF",
    "254",
    "ISO 3166-2:GF"
  ],
  [
    "PF",
    "PYF",
    "258",
    "ISO 3166-2:PF"
  ],
  [
    "TF",
    "ATF",
    "260",
    "ISO 3166-2:TF"
  ],
  [
    "GA",
    "GAB",
    "266",
    "ISO 3166-2:GA"
  ],
  [
    "GM",
    "GMB",
    "270",
    "ISO 3166-2:GM"
  ],
  [
    "GE",
    "GEO",
    "268",
    "ISO 3166-2:GE"
  ],
  [
    "DE",
    "DEU",
    "276",
    "ISO 3166-2:DE"
  ],
  [
    "GH",
    "GHA",
    "288",
    "ISO 3166-2:GH"
  ],
  [
    "GI",
    "GIB",
    "292",
    "ISO 3166-2:GI"
  ],
  [
    "GR",
    "GRC",
    "300",
    "ISO 3166-2:GR"
  ],
  [
    "GL",
    "GRL",
    "304",
    "ISO 3166-2:GL"
  ],
  [
    "GD",
    "GRD",
    "308",
    "ISO 3166-2:GD"
  ],
  [
    "GP",
    "GLP",
    "312",
    "ISO 3166-2:GP"
  ],
  [
    "GU",
    "GUM",
    "316",
    "ISO 3166-2:GU"
  ],
  [
    "GT",
    "GTM",
    "320",
    "ISO 3166-2:GT"
  ],
  [
    "GN",
    "GIN",
    "324",
    "ISO 3166-2:GN"
  ],
  [
    "GW",
    "GNB",
    "624",
    "ISO 3166-2:GW"
  ],
  [
    "GY",
    "GUY",
    "328",
    "ISO 3166-2:GY"
  ],
  [
    "HT",
    "HTI",
    "332",
    "ISO 3166-2:HT"
  ],
  [
    "HM",
    "HMD",
    "334",
    "ISO 3166-2:HM"
  ],
  [
    "VA",
    "VAT",
    "336",
    "ISO 3166-2:VA"
  ],
  [
    "HN",
    "HND",
    "340",
    "ISO 3166-2:HN"
  ],
  [
    "HK",
    "HKG",
    "344",
    "ISO 3166-2:HK"
  ],
  [
    "HU",
    "HUN",
    "348",
    "ISO 3166-2:HU"
  ],
  [
    "IS",
    "ISL",
    "352",
    "ISO 3166-2:IS"
  ],
  [
    "IN",
    "IND",
    "356",
    "ISO 3166-2:IN"
  ],
  [
    "ID",
    "IDN",
    "360",
    "ISO 3166-2:ID"
  ],
  [
    "IR",
    "IRN",
    "364",
    "ISO 3166-2:IR"
  ],
  [
    "IQ",
    "IRQ",
    "368",
    "ISO 3166-2:IQ"
  ],
  [
    "IE",
    "IRL",
    "372",
    "ISO 3166-2:IE"
  ],
  [
    "IL",
    "ISR",
    "376",
    "ISO 3166-2:IL"
  ],
  [
    "IT",
    "ITA",
    "380",
    "ISO 3166-2:IT"
  ],
  [
    "JM",
    "JAM",
    "388",
    "ISO 3166-2:JM"
  ],
  [
    "JP",
    "JPN",
    "392",
    "ISO 3166-2:JP"
  ],
  [
    "JO",
    "JOR",
    "400",
    "ISO 3166-2:JO"
  ],
  [
    "KZ",
    "KAZ",
    "398",
    "ISO 3166-2:KZ"
  ],
  [
    "KE",
    "KEN",
    "404",
    "ISO 3166-2:KE"
  ],
  [
    "KI",
    "KIR",
    "296",
    "ISO 3166-2:KI"
  ],
  [
    "KP",
    "PRK",
    "408",
    "ISO 3166-2:KP"
  ],
  [
    "KR",
    "KOR",
    "410",
    "ISO 3166-2:KR"
  ],
  [
    "KW",
    "KWT",
    "414",
    "ISO 3166-2:KW"
  ],
  [
    "KG",
    "KGZ",
    "417",
    "ISO 3166-2:KG"
  ],
  [
    "LA",
    "LAO",
    "418",
    "ISO 3166-2:LA"
  ],
  [
    "LV",
    "LVA",
    "428",
    "ISO 3166-2:LV"
  ],
  [
    "LB",
    "LBN",
    "422",
    "ISO 3166-2:LB"
  ],
  [
    "LS",
    "LSO",
    "426",
    "ISO 3166-2:LS"
  ],
  [
    "LR",
    "LBR",
    "430",
    "ISO 3166-2:LR"
  ],
  [
    "LY",
    "LBY",
    "434",
    "ISO 3166-2:LY"
  ],
  [
    "LI",
    "LIE",
    "438",
    "ISO 3166-2:LI"
  ],
  [
    "LT",
    "LTU",
    "440",
    "ISO 3166-2:LT"
  ],
  [
    "LU",
    "LUX",
    "442",
    "ISO 3166-2:LU"
  ],
  [
    "MO",
    "MAC",
    "446",
    "ISO 3166-2:MO"
  ],
  [
    "MG",
    "MDG",
    "450",
    "ISO 3166-2:MG"
  ],
  [
    "MW",
    "MWI",
    "454",
    "ISO 3166-2:MW"
  ],
  [
    "MY",
    "MYS",
    "458",
    "ISO 3166-2:MY"
  ],
  [
    "MV",
    "MDV",
    "462",
    "ISO 3166-2:MV"
  ],
  [
    "ML",
    "MLI",
    "466",
    "ISO 3166-2:ML"
  ],
  [
    "MT",
    "MLT",
    "470",
    "ISO 3166-2:MT"
  ],
  [
    "MH",
    "MHL",
    "584",
    "ISO 3166-2:MH"
  ],
  [
    "MQ",
    "MTQ",
    "474",
    "ISO 3166-2:MQ"
  ],
  [
    "MR",
    "MRT",
    "478",
    "ISO 3166-2:MR"
  ],
  [
    "MU",
    "MUS",
    "480",
    "ISO 3166-2:MU"
  ],
  [
    "YT",
    "MYT",
    "175",
    "ISO 3166-2:YT"
  ],
  [
    "MX",
    "MEX",
    "484",
    "ISO 3166-2:MX"
  ],
  [
    "FM",
    "FSM",
    "583",
    "ISO 3166-2:FM"
  ],
  [
    "MD",
    "MDA",
    "498",
    "ISO 3166-2:MD"
  ],
  [
    "MC",
    "MCO",
    "492",
    "ISO 3166-2:MC"
  ],
  [
    "MN",
    "MNG",
    "496",
    "ISO 3166-2:MN"
  ],
  [
    "MS",
    "MSR",
    "500",
    "ISO 3166-2:MS"
  ],
  [
    "MA",
    "MAR",
    "504",
    "ISO 3166-2:MA"
  ],
  [
    "MZ",
    "MOZ",
    "508",
    "ISO 3166-2:MZ"
  ],
  [
    "MM",
    "MMR",
    "104",
    "ISO 3166-2:MM"
  ],
  [
    "NA",
    "NAM",
    "516",
    "ISO 3166-2:NA"
  ],
  [
    "NR",
    "NRU",
    "520",
    "ISO 3166-2:NR"
  ],
  [
    "NP",
    "NPL",
    "524",
    "ISO 3166-2:NP"
  ],
  [
    "NL",
    "NLD",
    "528",
    "ISO 3166-2:NL"
  ],
  [
    "NC",
    "NCL",
    "540",
    "ISO 3166-2:NC"
  ],
  [
    "NZ",
    "NZL",
    "554",
    "ISO 3166-2:NZ"
  ],
  [
    "NI",
    "NIC",
    "558",
    "ISO 3166-2:NI"
  ],
  [
    "NE",
    "NER",
    "562",
    "ISO 3166-2:NE"
  ],
  [
    "NG",
    "NGA",
    "566",
    "ISO 3166-2:NG"
  ],
  [
    "NU",
    "NIU",
    "570",
    "ISO 3166-2:NU"
  ],
  [
    "NF",
    "NFK",
    "574",
    "ISO 3166-2:NF"
  ],
  [
    "MP",
    "MNP",
    "580",
    "ISO 3166-2:MP"
  ],
  [
    "MK",
    "MKD",
    "807",
    "ISO 3166-2:MK"
  ],
  [
    "NO",
    "NOR",
    "578",
    "ISO 3166-2:NO"
  ],
  [
    "OM",
    "OMN",
    "512",
    "ISO 3166-2:OM"
  ],
  [
    "PK",
    "PAK",
    "586",
    "ISO 3166-2:PK"
  ],
  [
    "PW",
    "PLW",
    "585",
    "ISO 3166-2:PW"
  ],
  [
    "PS",
    "PSE",
    "275",
    "ISO 3166-2:PS"
  ],
  [
    "PA",
    "PAN",
    "591",
    "ISO 3166-2:PA"
  ],
  [
    "PG",
    "PNG",
    "598",
    "ISO 3166-2:PG"
  ],
  [
    "PY",
    "PRY",
    "600",
    "ISO 3166-2:PY"
  ],
  [
    "PE",
    "PER",
    "604",
    "ISO 3166-2:PE"
  ],
  [
    "PH",
    "PHL",
    "608",
    "ISO 3166-2:PH"
  ],
  [
    "PN",
    "PCN",
    "612",
    "ISO 3166-2:PN"
  ],
  [
    "PL",
    "POL",
    "616",
    "ISO 3166-2:PL"
  ],
  [
    "PT",
    "PRT",
    "620",
    "ISO 3166-2:PT"
  ],
  [
    "PR",
    "PRI",
    "630",
    "ISO 3166-2:PR"
  ],
  [
    "QA",
    "QAT",
    "634",
    "ISO 3166-2:QA"
  ],
  [
    "RE",
    "REU",
    "638",
    "ISO 3166-2:RE"
  ],
  [
    "RO",
    "ROU",
    "642",
    "ISO 3166-2:RO"
  ],
  [
    "RU",
    "RUS",
    "643",
    "ISO 3166-2:RU"
  ],
  [
    "RW",
    "RWA",
    "646",
    "ISO 3166-2:RW"
  ],
  [
    "SH",
    "SHN",
    "654",
    "ISO 3166-2:SH"
  ],
  [
    "KN",
    "KNA",
    "659",
    "ISO 3166-2:KN"
  ],
  [
    "LC",
    "LCA",
    "662",
    "ISO 3166-2:LC"
  ],
  [
    "PM",
    "SPM",
    "666",
    "ISO 3166-2:PM"
  ],
  [
    "VC",
    "VCT",
    "670",
    "ISO 3166-2:VC"
  ],
  [
    "WS",
    "WSM",
    "882",
    "ISO 3166-2:WS"
  ],
  [
    "SM",
    "SMR",
    "674",
    "ISO 3166-2:SM"
  ],
  [
    "ST",
    "STP",
    "678",
    "ISO 3166-2:ST"
  ],
  [
    "SA",
    "SAU",
    "682",
    "ISO 3166-2:SA"
  ],
  [
    "SN",
    "SEN",
    "686",
    "ISO 3166-2:SN"
  ],
  [
    "SC",
    "SYC",
    "690",
    "ISO 3166-2:SC"
  ],
  [
    "SL",
    "SLE",
    "694",
    "ISO 3166-2:SL"
  ],
  [
    "SG",
    "SGP",
    "702",
    "ISO 3166-2:SG"
  ],
  [
    "SK",
    "SVK",
    "703",
    "ISO 3166-2:SK"
  ],
  [
    "SI",
    "SVN",
    "705",
    "ISO 3166-2:SI"
  ],
  [
    "SB",
    "SLB",
    "090",
    "ISO 3166-2:SB"
  ],
  [
    "SO",
    "SOM",
    "706",
    "ISO 3166-2:SO"
  ],
  [
    "ZA",
    "ZAF",
    "710",
    "ISO 3166-2:ZA"
  ],
  [
    "GS",
    "SGS",
    "239",
    "ISO 3166-2:GS"
  ],
  [
    "ES",
    "ESP",
    "724",
    "ISO 3166-2:ES"
  ],
  [
    "LK",
    "LKA",
    "144",
    "ISO 3166-2:LK"
  ],
  [
    "SD",
    "SDN",
    "729",
    "ISO 3166-2:SD"
  ],
  [
    "SR",
    "SUR",
    "740",
    "ISO 3166-2:SR"
  ],
  [
    "SJ",
    "SJM",
    "744",
    "ISO 3166-2:SJ"
  ],
  [
    "SZ",
    "SWZ",
    "748",
    "ISO 3166-2:SZ"
  ],
  [
    "SE",
    "SWE",
    "752",
    "ISO 3166-2:SE"
  ],
  [
    "CH",
    "CHE",
    "756",
    "ISO 3166-2:CH"
  ],
  [
    "SY",
    "SYR",
    "760",
    "ISO 3166-2:SY"
  ],
  [
    "TW",
    "TWN",
    "158",
    "ISO 3166-2:TW"
  ],
  [
    "TJ",
    "TJK",
    "762",
    "ISO 3166-2:TJ"
  ],
  [
    "TZ",
    "TZA",
    "834",
    "ISO 3166-2:TZ"
  ],
  [
    "TH",
    "THA",
    "764",
    "ISO 3166-2:TH"
  ],
  [
    "TL",
    "TLS",
    "626",
    "ISO 3166-2:TL"
  ],
  [
    "TG",
    "TGO",
    "768",
    "ISO 3166-2:TG"
  ],
  [
    "TK",
    "TKL",
    "772",
    "ISO 3166-2:TK"
  ],
  [
    "TO",
    "TON",
    "776",
    "ISO 3166-2:TO"
  ],
  [
    "TT",
    "TTO",
    "780",
    "ISO 3166-2:TT"
  ],
  [
    "TN",
    "TUN",
    "788",
    "ISO 3166-2:TN"
  ],
  [
    "TR",
    "TUR",
    "792",
    "ISO 3166-2:TR"
  ],
  [
    "TM",
    "TKM",
    "795",
    "ISO 3166-2:TM"
  ],
  [
    "TC",
    "TCA",
    "796",
    "ISO 3166-2:TC"
  ],
  [
    "TV",
    "TUV",
    "798",
    "ISO 3166-2:TV"
  ],
  [
    "UG",
    "UGA",
    "800",
    "ISO 3166-2:UG"
  ],
  [
    "UA",
    "UKR",
    "804",
    "ISO 3166-2:UA"
  ],
  [
    "AE",
    "ARE",
    "784",
    "ISO 3166-2:AE"
  ],
  [
    "GB",
    "GBR",
    "826",
    "ISO 3166-2:GB"
  ],
  [
    "US",
    "USA",
    "840",
    "ISO 3166-2:US"
  ],
  [
    "UM",
    "UMI",
    "581",
    "ISO 3166-2:UM"
  ],
  [
    "UY",
    "URY",
    "858",
    "ISO 3166-2:UY"
  ],
  [
    "UZ",
    "UZB",
    "860",
    "ISO 3166-2:UZ"
  ],
  [
    "VU",
    "VUT",
    "548",
    "ISO 3166-2:VU"
  ],
  [
    "VE",
    "VEN",
    "862",
    "ISO 3166-2:VE"
  ],
  [
    "VN",
    "VNM",
    "704",
    "ISO 3166-2:VN"
  ],
  [
    "VG",
    "VGB",
    "092",
    "ISO 3166-2:VG"
  ],
  [
    "VI",
    "VIR",
    "850",
    "ISO 3166-2:VI"
  ],
  [
    "WF",
    "WLF",
    "876",
    "ISO 3166-2:WF"
  ],
  [
    "EH",
    "ESH",
    "732",
    "ISO 3166-2:EH"
  ],
  [
    "YE",
    "YEM",
    "887",
    "ISO 3166-2:YE"
  ],
  [
    "ZM",
    "ZMB",
    "894",
    "ISO 3166-2:ZM"
  ],
  [
    "ZW",
    "ZWE",
    "716",
    "ISO 3166-2:ZW"
  ],
  [
    "AX",
    "ALA",
    "248",
    "ISO 3166-2:AX"
  ],
  [
    "BQ",
    "BES",
    "535",
    "ISO 3166-2:BQ"
  ],
  [
    "CW",
    "CUW",
    "531",
    "ISO 3166-2:CW"
  ],
  [
    "GG",
    "GGY",
    "831",
    "ISO 3166-2:GG"
  ],
  [
    "IM",
    "IMN",
    "833",
    "ISO 3166-2:IM"
  ],
  [
    "JE",
    "JEY",
    "832",
    "ISO 3166-2:JE"
  ],
  [
    "ME",
    "MNE",
    "499",
    "ISO 3166-2:ME"
  ],
  [
    "BL",
    "BLM",
    "652",
    "ISO 3166-2:BL"
  ],
  [
    "MF",
    "MAF",
    "663",
    "ISO 3166-2:MF"
  ],
  [
    "RS",
    "SRB",
    "688",
    "ISO 3166-2:RS"
  ],
  [
    "SX",
    "SXM",
    "534",
    "ISO 3166-2:SX"
  ],
  [
    "SS",
    "SSD",
    "728",
    "ISO 3166-2:SS"
  ],
  [
    "XK",
    "XKK",
    "983",
    "ISO 3166-2:XK"
  ]
], wg = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var io = {};
io.remove = Sg;
var Hi = [
  {
    base: " ",
    chars: " "
  },
  {
    base: "0",
    chars: "߀"
  },
  {
    base: "A",
    chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  },
  {
    base: "AA",
    chars: "Ꜳ"
  },
  {
    base: "AE",
    chars: "ÆǼǢ"
  },
  {
    base: "AO",
    chars: "Ꜵ"
  },
  {
    base: "AU",
    chars: "Ꜷ"
  },
  {
    base: "AV",
    chars: "ꜸꜺ"
  },
  {
    base: "AY",
    chars: "Ꜽ"
  },
  {
    base: "B",
    chars: "ⒷＢḂḄḆɃƁ"
  },
  {
    base: "C",
    chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
  },
  {
    base: "D",
    chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
  },
  {
    base: "Dh",
    chars: "Ð"
  },
  {
    base: "DZ",
    chars: "ǱǄ"
  },
  {
    base: "Dz",
    chars: "ǲǅ"
  },
  {
    base: "E",
    chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
  },
  {
    base: "F",
    chars: "ꝼⒻＦḞƑꝻ"
  },
  {
    base: "G",
    chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
  },
  {
    base: "H",
    chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  },
  {
    base: "I",
    chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  },
  {
    base: "J",
    chars: "ⒿＪĴɈȷ"
  },
  {
    base: "K",
    chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  },
  {
    base: "L",
    chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  },
  {
    base: "LJ",
    chars: "Ǉ"
  },
  {
    base: "Lj",
    chars: "ǈ"
  },
  {
    base: "M",
    chars: "ⓂＭḾṀṂⱮƜϻ"
  },
  {
    base: "N",
    chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
  },
  {
    base: "NJ",
    chars: "Ǌ"
  },
  {
    base: "Nj",
    chars: "ǋ"
  },
  {
    base: "O",
    chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  },
  {
    base: "OE",
    chars: "Œ"
  },
  {
    base: "OI",
    chars: "Ƣ"
  },
  {
    base: "OO",
    chars: "Ꝏ"
  },
  {
    base: "OU",
    chars: "Ȣ"
  },
  {
    base: "P",
    chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
  },
  {
    base: "Q",
    chars: "ⓆＱꝖꝘɊ"
  },
  {
    base: "R",
    chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  },
  {
    base: "S",
    chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  },
  {
    base: "T",
    chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  },
  {
    base: "Th",
    chars: "Þ"
  },
  {
    base: "TZ",
    chars: "Ꜩ"
  },
  {
    base: "U",
    chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  },
  {
    base: "V",
    chars: "ⓋＶṼṾƲꝞɅ"
  },
  {
    base: "VY",
    chars: "Ꝡ"
  },
  {
    base: "W",
    chars: "ⓌＷẀẂŴẆẄẈⱲ"
  },
  {
    base: "X",
    chars: "ⓍＸẊẌ"
  },
  {
    base: "Y",
    chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  },
  {
    base: "Z",
    chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  },
  {
    base: "a",
    chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
  },
  {
    base: "aa",
    chars: "ꜳ"
  },
  {
    base: "ae",
    chars: "æǽǣ"
  },
  {
    base: "ao",
    chars: "ꜵ"
  },
  {
    base: "au",
    chars: "ꜷ"
  },
  {
    base: "av",
    chars: "ꜹꜻ"
  },
  {
    base: "ay",
    chars: "ꜽ"
  },
  {
    base: "b",
    chars: "ⓑｂḃḅḇƀƃɓƂ"
  },
  {
    base: "c",
    chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
  },
  {
    base: "d",
    chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
  },
  {
    base: "dh",
    chars: "ð"
  },
  {
    base: "dz",
    chars: "ǳǆ"
  },
  {
    base: "e",
    chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
  },
  {
    base: "f",
    chars: "ⓕｆḟƒ"
  },
  {
    base: "ff",
    chars: "ﬀ"
  },
  {
    base: "fi",
    chars: "ﬁ"
  },
  {
    base: "fl",
    chars: "ﬂ"
  },
  {
    base: "ffi",
    chars: "ﬃ"
  },
  {
    base: "ffl",
    chars: "ﬄ"
  },
  {
    base: "g",
    chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
  },
  {
    base: "h",
    chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  },
  {
    base: "hv",
    chars: "ƕ"
  },
  {
    base: "i",
    chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  },
  {
    base: "j",
    chars: "ⓙｊĵǰɉ"
  },
  {
    base: "k",
    chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  },
  {
    base: "l",
    chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
  },
  {
    base: "lj",
    chars: "ǉ"
  },
  {
    base: "m",
    chars: "ⓜｍḿṁṃɱɯ"
  },
  {
    base: "n",
    chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
  },
  {
    base: "nj",
    chars: "ǌ"
  },
  {
    base: "o",
    chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
  },
  {
    base: "oe",
    chars: "œ"
  },
  {
    base: "oi",
    chars: "ƣ"
  },
  {
    base: "oo",
    chars: "ꝏ"
  },
  {
    base: "ou",
    chars: "ȣ"
  },
  {
    base: "p",
    chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
  },
  {
    base: "q",
    chars: "ⓠｑɋꝗꝙ"
  },
  {
    base: "r",
    chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  },
  {
    base: "s",
    chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
  },
  {
    base: "ss",
    chars: "ß"
  },
  {
    base: "t",
    chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  },
  {
    base: "th",
    chars: "þ"
  },
  {
    base: "tz",
    chars: "ꜩ"
  },
  {
    base: "u",
    chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  },
  {
    base: "v",
    chars: "ⓥｖṽṿʋꝟʌ"
  },
  {
    base: "vy",
    chars: "ꝡ"
  },
  {
    base: "w",
    chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
  },
  {
    base: "x",
    chars: "ⓧｘẋẍ"
  },
  {
    base: "y",
    chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  },
  {
    base: "z",
    chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }
], Tl = {};
for (var Ai = 0; Ai < Hi.length; Ai += 1)
  for (var ru = Hi[Ai].chars, Oo = 0; Oo < ru.length; Oo += 1)
    Tl[ru[Oo]] = Hi[Ai].base;
function Sg(e) {
  return e.replace(/[^\u0000-\u007e]/g, function(t) {
    return Tl[t] || t;
  });
}
io.replacementList = Hi;
io.diacriticsMap = Tl;
(function(e) {
  const t = yg, r = wg, a = io.remove, n = {}, i = {}, o = {}, s = {}, l = {};
  t.forEach(function(S) {
    const _ = S;
    i[_[0]] = _[1], o[_[1]] = _[0], s[_[2]] = _[0], l[_[0]] = _[2];
  });
  function c(S) {
    return ("000" + (S || "")).slice(-3);
  }
  function d(S, _) {
    return Object.prototype.hasOwnProperty.call(S, _);
  }
  function p(S, _) {
    return Object.keys(S).reduce(function(M, I) {
      const L = S[I];
      return M[I] = _(L, I), M;
    }, {});
  }
  function f(S, _) {
    switch (S) {
      case "official":
        return Array.isArray(_) ? _[0] : _;
      case "all":
        return typeof _ == "string" ? [_] : _;
      case "alias":
        return Array.isArray(_) ? _[1] || _[0] : _;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  e.registerLocale = function(S) {
    if (!S.locale)
      throw new TypeError("Missing localeData.locale");
    if (!S.countries)
      throw new TypeError("Missing localeData.countries");
    n[S.locale] = S.countries;
  };
  function h(S) {
    return o[S];
  }
  e.alpha3ToAlpha2 = h;
  function m(S) {
    return i[S];
  }
  e.alpha2ToAlpha3 = m;
  function C(S) {
    return l[h(S)];
  }
  e.alpha3ToNumeric = C;
  function g(S) {
    return l[S];
  }
  e.alpha2ToNumeric = g;
  function v(S) {
    const _ = c(S);
    return m(s[_]);
  }
  e.numericToAlpha3 = v;
  function b(S) {
    const _ = c(S);
    return s[_];
  }
  e.numericToAlpha2 = b;
  function y(S) {
    if (typeof S == "string") {
      if (/^[0-9]*$/.test(S))
        return v(S);
      if (S.length === 2)
        return m(S.toUpperCase());
      if (S.length === 3)
        return S.toUpperCase();
    }
    if (typeof S == "number")
      return v(S);
  }
  e.toAlpha3 = y;
  function x(S) {
    if (typeof S == "string") {
      if (/^[0-9]*$/.test(S))
        return b(S);
      if (S.length === 2)
        return S.toUpperCase();
      if (S.length === 3)
        return h(S.toUpperCase());
    }
    if (typeof S == "number")
      return b(S);
  }
  e.toAlpha2 = x, e.getName = function(S, _, M = {}) {
    "select" in M || (M.select = "official");
    try {
      const L = n[_.toLowerCase()][x(S)];
      return f(M.select, L);
    } catch {
      return;
    }
  }, e.getNames = function(S, _ = {}) {
    "select" in _ || (_.select = "official");
    const M = n[S.toLowerCase()];
    return M === void 0 ? {} : p(M, function(I) {
      return f(_.select, I);
    });
  }, e.getAlpha2Code = function(S, _) {
    const M = (L) => L.toLowerCase(), I = (L, D) => M(L) === M(D);
    try {
      const L = n[_.toLowerCase()];
      for (const D in L)
        if (d(L, D)) {
          if (typeof L[D] == "string" && I(L[D], S))
            return D;
          if (Array.isArray(L[D])) {
            for (const A of L[D])
              if (I(A, S))
                return D;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getSimpleAlpha2Code = function(S, _) {
    const M = (L) => a(L.toLowerCase()), I = (L, D) => M(L) === M(D);
    try {
      const L = n[_.toLowerCase()];
      for (const D in L)
        if (d(L, D)) {
          if (typeof L[D] == "string" && I(L[D], S))
            return D;
          if (Array.isArray(L[D])) {
            for (const A of L[D])
              if (I(A, S))
                return D;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getAlpha2Codes = function() {
    return i;
  }, e.getAlpha3Code = function(S, _) {
    const M = e.getAlpha2Code(S, _);
    if (M)
      return e.toAlpha3(M);
  }, e.getSimpleAlpha3Code = function(S, _) {
    const M = e.getSimpleAlpha2Code(S, _);
    if (M)
      return e.toAlpha3(M);
  }, e.getAlpha3Codes = function() {
    return o;
  }, e.getNumericCodes = function() {
    return s;
  }, e.langs = function() {
    return Object.keys(n);
  }, e.getSupportedLanguages = function() {
    return r;
  }, e.isValid = function(S) {
    if (!S)
      return !1;
    const _ = S.toString().toUpperCase();
    return d(o, _) || d(i, _) || d(s, _);
  };
})(g0);
const ms = /* @__PURE__ */ S1(g0), C0 = "ar", v0 = {
  AF: "أفغانستان",
  AL: "ألبانيا",
  DZ: "الجزائر",
  AS: "ساموا الأمريكية",
  AD: "أندورا",
  AO: "أنغولا",
  AI: "أنغويلا",
  AQ: "القارة القطبية الجنوبية",
  AG: "أنتيغوا وباربودا",
  AR: "الأرجنتين",
  AM: "أرمينيا",
  AW: "أروبا",
  AU: "أستراليا",
  AT: "النمسا",
  AZ: "أذربيجان",
  BS: "باهاماس",
  BH: "البحرين",
  BD: "بنغلاديش",
  BB: "باربادوس",
  BY: "روسيا البيضاء",
  BE: "بلجيكا",
  BZ: "بليز",
  BJ: "بنين",
  BM: "برمودا",
  BT: "بوتان",
  BO: "بوليفيا",
  BA: "البوسنة والهرسك",
  BW: "بوتسوانا",
  BV: "جزيرة بوفيه",
  BR: "البرازيل",
  IO: "إقليم المحيط الهندي البريطاني",
  BN: "بروناي",
  BG: "بلغاريا",
  BF: "بوركينا فاسو",
  BI: "بوروندي",
  KH: "كمبوديا",
  CM: "الكاميرون",
  CA: "كندا",
  CV: "الرأس الأخضر",
  KY: "جزر كايمان",
  CF: "جمهورية أفريقيا الوسطى",
  TD: "تشاد",
  CL: "تشيلي",
  CN: "الصين",
  CX: "جزيرة عيد الميلاد",
  CC: "جزر كوكوس",
  CO: "كولومبيا",
  KM: "جزر القمر",
  CG: "جمهورية الكونغو",
  CD: "جمهورية الكونغو الديمقراطية",
  CK: "جزر كوك",
  CR: "كوستاريكا",
  CI: "ساحل العاج",
  HR: "كرواتيا",
  CU: "كوبا",
  CY: "قبرص",
  CZ: "جمهورية التشيك",
  DK: "الدنمارك",
  DJ: "جيبوتي",
  DM: "دومينيكا",
  DO: "جمهورية الدومينيكان",
  EC: "الإكوادور",
  EG: "مصر",
  SV: "السلفادور",
  GQ: "غينيا الاستوائية",
  ER: "إريتريا",
  EE: "إستونيا",
  ET: "إثيوبيا",
  FK: "جزر فوكلاند",
  FO: "جزر فارو",
  FJ: "فيجي",
  FI: "فنلندا",
  FR: "فرنسا",
  GF: "غويانا الفرنسية",
  PF: "بولينزيا الفرنسية",
  TF: "أراض فرنسية جنوبية وأنتارتيكية",
  GA: "الغابون",
  GM: "غامبيا",
  GE: "جورجيا",
  DE: "ألمانيا",
  GH: "غانا",
  GI: "جبل طارق",
  GR: "اليونان",
  GL: "جرينلاند",
  GD: "غرينادا",
  GP: "غوادلوب",
  GU: "غوام",
  GT: "غواتيمالا",
  GN: "غينيا",
  GW: "غينيا بيساو",
  GY: "غيانا",
  HT: "هايتي",
  HM: "جزيرة هيرد وجزر ماكدونالد",
  VA: "الفاتيكان",
  HN: "هندوراس",
  HK: "هونغ كونغ",
  HU: "المجر",
  IS: "آيسلندا",
  IN: "الهند",
  ID: "إندونيسيا",
  IR: "إيران",
  IQ: "العراق",
  IE: "أيرلندا",
  IL: "إسرائيل",
  IT: "إيطاليا",
  JM: "جامايكا",
  JP: "اليابان",
  JO: "الأردن",
  KZ: "كازاخستان",
  KE: "كينيا",
  KI: "كيريباتي",
  KP: "كوريا الشمالية",
  KR: "كوريا الجنوبية",
  KW: "الكويت",
  KG: "قيرغيزستان",
  LA: "لاوس",
  LV: "لاتفيا",
  LB: "لبنان",
  LS: "ليسوتو",
  LR: "ليبيريا",
  LY: "ليبيا",
  LI: "ليختنشتاين",
  LT: "ليتوانيا",
  LU: "لوكسمبورغ",
  MO: "ماكاو",
  MK: "مقدونيا الشمالية",
  MG: "مدغشقر",
  MW: "مالاوي",
  MY: "ماليزيا",
  MV: "جزر المالديف",
  ML: "مالي",
  MT: "مالطا",
  MH: "جزر مارشال",
  MQ: "مارتينيك",
  MR: "موريتانيا",
  MU: "موريشيوس",
  YT: "مايوت",
  MX: "المكسيك",
  FM: "ولايات ميكرونيسيا المتحدة",
  MD: "مولدوفا",
  MC: "موناكو",
  MN: "منغوليا",
  MS: "مونتسرات",
  MA: "المغرب",
  MZ: "موزمبيق",
  MM: "بورما",
  NA: "ناميبيا",
  NR: "ناورو",
  NP: "نيبال",
  NL: "هولندا",
  NC: "كاليدونيا الجديدة",
  NZ: "نيوزيلندا",
  NI: "نيكاراغوا",
  NE: "النيجر",
  NG: "نيجيريا",
  NU: "نييوي",
  NF: "جزيرة نورفولك",
  MP: "جزر ماريانا الشمالية",
  NO: "النرويج",
  OM: "عمان",
  PK: "باكستان",
  PW: "بالاو",
  PS: "فلسطين",
  PA: "بنما",
  PG: "بابوا غينيا الجديدة",
  PY: "باراغواي",
  PE: "بيرو",
  PH: "الفلبين",
  PN: "جزر بيتكيرن",
  PL: "بولندا",
  PT: "البرتغال",
  PR: "بورتوريكو",
  QA: "قطر",
  RE: "لا ريونيون",
  RO: "رومانيا",
  RU: "روسيا",
  RW: "رواندا",
  SH: "سانت هيلينا وأسينشين وتريستان دا كونا",
  KN: "سانت كيتس ونيفيس",
  LC: "سانت لوسيا",
  PM: "سان بيير وميكلون",
  VC: "سانت فينسنت والغرينادين",
  WS: "ساموا",
  SM: "سان مارينو",
  ST: "ساو تومي وبرينسيب",
  SA: "السعودية",
  SN: "السنغال",
  SC: "سيشل",
  SL: "سيراليون",
  SG: "سنغافورة",
  SK: "سلوفاكيا",
  SI: "سلوفينيا",
  SB: "جزر سليمان",
  SO: "الصومال",
  ZA: "جنوب أفريقيا",
  GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  ES: "إسبانيا",
  LK: "سريلانكا",
  SD: "السودان",
  SR: "سورينام",
  SJ: "سفالبارد ويان ماين",
  SZ: "سوازيلاند",
  SE: "السويد",
  CH: "سويسرا",
  SY: "سوريا",
  TW: "تايوان",
  TJ: "طاجيكستان",
  TZ: "تانزانيا",
  TH: "تايلاند",
  TL: "تيمور الشرقية",
  TG: "توغو",
  TK: "توكيلاو",
  TO: "تونغا",
  TT: "ترينيداد وتوباغو",
  TN: "تونس",
  TR: "تركيا",
  TM: "تركمانستان",
  TC: "جزر توركس وكايكوس",
  TV: "توفالو",
  UG: "أوغندا",
  UA: "أوكرانيا",
  AE: "الإمارات العربية المتحدة",
  GB: "المملكة المتحدة",
  US: "الولايات المتحدة",
  UM: "جزر الولايات المتحدة",
  UY: "الأوروغواي",
  UZ: "أوزبكستان",
  VU: "فانواتو",
  VE: "فنزويلا",
  VN: "فيتنام",
  VG: "جزر العذراء البريطانية",
  VI: "جزر العذراء الأمريكية",
  WF: "والس وفوتونا",
  EH: "الصحراء الغربية",
  YE: "اليمن",
  ZM: "زامبيا",
  ZW: "زيمبابوي",
  AX: "جزر أولاند",
  BQ: "الجزر الكاريبية الهولندية",
  CW: "كوراساو",
  GG: "غيرنزي",
  IM: "جزيرة مان",
  JE: "جيرزي",
  ME: "الجبل الأسود",
  BL: "سان بارتيلمي",
  MF: "سانت مارتن (الجزء الفرنسي)",
  RS: "صربيا",
  SX: "سانت مارتن (الجزء الهولندي)",
  SS: "جنوب السودان",
  XK: "كوسوفو"
}, _g = {
  locale: C0,
  countries: v0
}, xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: v0,
  default: _g,
  locale: C0
}, Symbol.toStringTag, { value: "Module" })), b0 = "cs", y0 = {
  AF: "Afghánistán",
  AX: "Ålandy",
  AL: "Albánie",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  VI: "Americké Panenské ostrovy",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktida",
  AG: "Antigua a Barbuda",
  AR: "Argentina",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Austrálie",
  AZ: "Ázerbájdžán",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BE: "Belgie",
  BZ: "Belize",
  BY: "Bělorusko",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhútán",
  BO: "Bolívie",
  BQ: "Bonaire, Svatý Eustach a Saba",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BV: "Bouvetův ostrov",
  BR: "Brazílie",
  IO: "Britské indickooceánské území",
  VG: "Britské Panenské ostrovy",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  CK: "Cookovy ostrovy",
  CW: "Curaçao",
  TD: "Čad",
  ME: "Černá Hora",
  CZ: "Česká republika",
  CN: "Čína",
  DK: "Dánsko",
  CD: "Demokratická republika Kongo",
  DM: "Dominika",
  DO: "Dominikánská republika",
  DJ: "Džibutsko",
  EG: "Egypt",
  EC: "Ekvádor",
  ER: "Eritrea",
  EE: "Estonsko",
  ET: "Etiopie",
  FO: "Faerské ostrovy",
  FK: "Falklandy (Malvíny)",
  FJ: "Fidži",
  PH: "Filipíny",
  FI: "Finsko",
  FR: "Francie",
  GF: "Francouzská Guyana",
  TF: "Francouzská jižní a antarktická území",
  PF: "Francouzská Polynésie",
  GA: "Gabon",
  GM: "Gambie",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GL: "Grónsko",
  GE: "Gruzie",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GG: "Guernsey",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heardův ostrov a McDonaldovy ostrovy",
  HN: "Honduras",
  HK: "Hongkong",
  CL: "Chile",
  HR: "Chorvatsko",
  IN: "Indie",
  ID: "Indonésie",
  IQ: "Irák",
  IR: "Írán",
  IE: "Irsko",
  IS: "Island",
  IT: "Itálie",
  IL: "Izrael",
  JM: "Jamajka",
  JP: "Japonsko",
  YE: "Jemen",
  JE: "Jersey",
  ZA: "Jihoafrická republika",
  GS: "Jižní Georgie a Jižní Sandwichovy ostrovy",
  KR: "Jižní Korea",
  SS: "Jižní Súdán",
  JO: "Jordánsko",
  KY: "Kajmanské ostrovy",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  QA: "Katar",
  KZ: "Kazachstán",
  KE: "Keňa",
  KI: "Kiribati",
  CC: "Kokosové ostrovy",
  CO: "Kolumbie",
  KM: "Komory",
  CG: "Kongo",
  CR: "Kostarika",
  CU: "Kuba",
  KW: "Kuvajt",
  CY: "Kypr",
  KG: "Kyrgyzstán",
  LA: "Laos",
  LS: "Lesotho",
  LB: "Libanon",
  LR: "Libérie",
  LY: "Libye",
  LI: "Lichtenštejnsko",
  LT: "Litva",
  LV: "Lotyšsko",
  LU: "Lucembursko",
  MO: "Macao",
  MG: "Madagaskar",
  HU: "Maďarsko",
  MY: "Malajsie",
  MW: "Malawi",
  MV: "Maledivy",
  ML: "Mali",
  MT: "Malta",
  IM: "Ostrov Man",
  MA: "Maroko",
  MH: "Marshallovy ostrovy",
  MQ: "Martinik",
  MU: "Mauricius",
  MR: "Mauritánie",
  YT: "Mayotte",
  UM: "Menší odlehlé ostrovy USA",
  MX: "Mexiko",
  FM: "Mikronésie",
  MD: "Moldavsko",
  MC: "Monako",
  MN: "Mongolsko",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  DE: "Německo",
  NP: "Nepál",
  NE: "Niger",
  NG: "Nigérie",
  NI: "Nikaragua",
  NU: "Niue",
  NL: "Nizozemsko",
  NF: "Norfolk",
  NO: "Norsko",
  NC: "Nová Kaledonie",
  NZ: "Nový Zéland",
  OM: "Omán",
  PK: "Pákistán",
  PW: "Palau",
  PS: "Palestinská autonomie",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairnovy ostrovy",
  CI: "Pobřeží slonoviny",
  PL: "Polsko",
  PR: "Portoriko",
  PT: "Portugalsko",
  AT: "Rakousko",
  RE: "Réunion",
  GQ: "Rovníková Guinea",
  RO: "Rumunsko",
  RU: "Rusko",
  RW: "Rwanda",
  GR: "Řecko",
  PM: "Saint-Pierre a Miquelon",
  SV: "Salvador",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saúdská Arábie",
  SN: "Senegal",
  KP: "Severní Korea",
  MK: "Severní Makedonie",
  MP: "Severní Mariany",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Slovensko",
  SI: "Slovinsko",
  SO: "Somálsko",
  AE: "Spojené arabské emiráty",
  GB: "Spojené království",
  US: "Spojené státy americké",
  RS: "Srbsko",
  CF: "Středoafrická republika",
  SD: "Súdán",
  SR: "Surinam",
  SH: "Svatá Helena, Ascension a Tristan da Cunha",
  LC: "Svatá Lucie",
  BL: "Svatý Bartoloměj",
  KN: "Svatý Kryštof a Nevis",
  MF: "Svatý Martin (francouzská část)",
  SX: "Svatý Martin (nizozemská část)",
  ST: "Svatý Tomáš a Princův ostrov",
  VC: "Svatý Vincenc a Grenadiny",
  SZ: "Svazijsko",
  SY: "Sýrie",
  SB: "Šalamounovy ostrovy",
  ES: "Španělsko",
  SJ: "Špicberky a Jan Mayen",
  LK: "Šrí Lanka",
  SE: "Švédsko",
  CH: "Švýcarsko",
  TJ: "Tádžikistán",
  TZ: "Tanzanie",
  TH: "Thajsko",
  TW: "Tchaj-wan",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkmenistán",
  TC: "Turks a Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajina",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  CX: "Vánoční ostrov",
  VU: "Vanuatu",
  VA: "Vatikán",
  VE: "Venezuela",
  VN: "Vietnam",
  TL: "Východní Timor",
  WF: "Wallis a Futuna",
  ZM: "Zambie",
  EH: "Západní Sahara",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, Mg = {
  locale: b0,
  countries: y0
}, kg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: y0,
  default: Mg,
  locale: b0
}, Symbol.toStringTag, { value: "Module" })), w0 = "da", S0 = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviderusland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brasilien",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Juløen",
  CC: "Cocosøerne",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo",
  CD: "Demokratiske Republik Congo",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CU: "Cuba",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsøerne",
  FO: "Færøerne",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GF: "Fransk Guiana",
  PF: "Fransk Polynesien",
  TF: "Franske Sydterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-øen og McDonald-øerne",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløerne",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesien",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongoliet",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holland",
  NC: "Ny Kaledonien",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Nordmarianerne",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palæstina",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumænien",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sankt Helena",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinerne",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "South Georgia og South Sandwich Islands",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Norge Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  SY: "Syrien",
  TW: "Republikken Kina Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Østtimor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Forenede Arabiske Emirater",
  GB: "Storbritannien",
  US: "USA",
  UM: "USA's ydre småøer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britiske Jomfruøer",
  VI: "Amerikanske Jomfruøer",
  WF: "Wallis og Futuna",
  EH: "Vestsahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Ålandsøerne",
  BQ: "Nederlandske Antiller",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint Martin (fransk side)",
  RS: "Serbien",
  SX: "Saint Martin (hollandsk side)",
  SS: "Sydsudan",
  XK: "Kosovo"
}, Pg = {
  locale: w0,
  countries: S0
}, Tg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: S0,
  default: Pg,
  locale: w0
}, Symbol.toStringTag, { value: "Module" })), _0 = "de", x0 = {
  AF: "Afghanistan",
  EG: "Ägypten",
  AX: "Åland",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  VI: "Amerikanische Jungferninseln",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  GQ: "Äquatorialguinea",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AZ: "Aserbaidschan",
  ET: "Äthiopien",
  AU: "Australien",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien",
  BQ: "Bonaire",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  VG: "Britische Jungferninseln",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  CL: "Chile",
  CN: "China",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Elfenbeinküste",
  CW: "Curaçao",
  DK: "Dänemark",
  DE: "Deutschland",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  DJ: "Dschibuti",
  EC: "Ecuador",
  SV: "El Salvador",
  ER: "Eritrea",
  EE: "Estland",
  FK: "Falklandinseln",
  FO: "Färöer",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Süd- und Antarktisgebiete",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GR: "Griechenland",
  GL: "Grönland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard und McDonaldinseln",
  HN: "Honduras",
  HK: [
    "Hongkong",
    "Hong Kong"
  ],
  IN: "Indien",
  ID: "Indonesien",
  IM: "Insel Man",
  IQ: "Irak",
  IR: "Iran",
  IE: "Irland",
  IS: "Island",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  YE: "Jemen",
  JE: "Jersey",
  JO: "Jordanien",
  KY: "Kaimaninseln",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KZ: "Kasachstan",
  QA: "Katar",
  KE: "Kenia",
  KG: "Kirgisistan",
  KI: "Kiribati",
  CC: "Kokosinseln",
  CO: "Kolumbien",
  KM: "Komoren",
  CD: "Kongo",
  KP: "Nordkorea",
  KR: "Südkorea",
  HR: "Kroatien",
  CU: "Kuba",
  KW: "Kuwait",
  LA: "Laos",
  LS: "Lesotho",
  LV: "Lettland",
  LB: "Libanon",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MA: "Marokko",
  MH: "Marshallinseln",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  FM: "Mikronesien",
  MD: "Moldawien",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NL: "Niederlande",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  MK: "Nordmazedonien",
  MP: "Nördliche Marianen",
  NF: "Norfolkinsel",
  NO: "Norwegen",
  OM: "Oman",
  AT: "Österreich",
  TL: "Osttimor",
  PK: "Pakistan",
  PS: "Staat Palästina",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairninseln",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  TW: "Taiwan",
  CG: "Republik Kongo",
  RE: "Réunion",
  RW: "Ruanda",
  RO: "Rumänien",
  RU: [
    "Russische Föderation",
    "Russland"
  ],
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  SB: "Salomonen",
  ZM: "Sambia",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SE: "Schweden",
  CH: "Schweiz",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  ZW: "Simbabwe",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slowakei",
  SI: "Slowenien",
  SO: "Somalia",
  ES: "Spanien",
  LK: "Sri Lanka",
  SH: "St. Helena",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  ZA: "Südafrika",
  SD: "Sudan",
  GS: "Südgeorgien und die Südlichen Sandwichinseln",
  SS: "Südsudan",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SZ: "Eswatini",
  SY: "Syrien, Arabische Republik",
  TJ: "Tadschikistan",
  TZ: [
    "Tansania, Vereinigte Republik",
    "Tansania"
  ],
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TD: "Tschad",
  CZ: [
    "Tschechische Republik",
    "Tschechien"
  ],
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  HU: "Ungarn",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VA: "Vatikanstadt",
  VE: "Venezuela",
  AE: "Vereinigte Arabische Emirate",
  US: [
    "Vereinigte Staaten von Amerika",
    "Vereinigte Staaten",
    "USA"
  ],
  GB: [
    "Vereinigtes Königreich",
    "Großbritannien"
  ],
  VN: "Vietnam",
  WF: "Wallis und Futuna",
  CX: "Weihnachtsinsel",
  EH: "Westsahara",
  CF: "Zentralafrikanische Republik",
  CY: "Zypern",
  XK: "Kosovo"
}, Eg = {
  locale: _0,
  countries: x0
}, Dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: x0,
  default: Eg,
  locale: _0
}, Symbol.toStringTag, { value: "Module" })), M0 = "el", k0 = {
  AF: "Αφγανιστάν",
  AL: "Αλβανία",
  DZ: "Αλγερία",
  AS: "Αμερικανική Σαμόα",
  AD: "Ανδόρρα",
  AO: "Ανγκόλα",
  AI: "Ανγκουίλα",
  AQ: "Ανταρκτική",
  AG: "Αντίγκουα και Μπαρμπούντα",
  AR: "Αργεντινή",
  AM: "Αρμενία",
  AW: "Αρούμπα",
  AU: "Αυστραλία",
  AT: "Αυστρία",
  AZ: "Αζερμπαϊτζάν",
  BS: "Μπαχάμες",
  BH: "Μπαχρέιν",
  BD: "Μπανγκλαντές",
  BB: "Μπαρμπάντος",
  BY: "Λευκορωσία",
  BE: "Βέλγιο",
  BZ: "Μπελίζ",
  BJ: "Μπενίν",
  BM: "Βερμούδες",
  BT: "Μπουτάν",
  BO: "Βολιβία",
  BA: "Βοσνία και Ερζεγοβίνη",
  BW: "Μποτσουάνα",
  BV: "Μπουβέ",
  BR: "Βραζιλία",
  IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού",
  BN: "Σουλτανάτο του Μπρουνέι",
  BG: "Βουλγαρία",
  BF: "Μπουρκίνα Φάσο",
  BI: "Μπουρουντί",
  KH: "Καμπότζη",
  CM: "Καμερούν",
  CA: "Καναδάς",
  CV: [
    "Δημοκρατία του Πράσινου Ακρωτηρίου",
    "Πράσινο Ακρωτήριο"
  ],
  KY: "Κέιμαν Νήσοι",
  CF: "Κεντροαφρικανική Δημοκρατία",
  TD: "Τσάντ",
  CL: "Χιλή",
  CN: "Κίνα",
  CX: "Νήσος των Χριστουγέννων",
  CC: "Νησιά Κόκος",
  CO: "Κολομβία",
  KM: "Ένωση των Κομορών",
  CG: [
    "Δημοκρατία του Κονγκό",
    "Κονγκό"
  ],
  CD: "Λαϊκή Δημοκρατία του Κονγκό",
  CK: "Νήσοι Κουκ",
  CR: "Κόστα Ρίκα",
  CI: "Ακτή Ελεφαντοστού",
  HR: "Κροατία",
  CU: "Κούβα",
  CY: "Κύπρος",
  CZ: [
    "Τσεχική Δημοκρατία",
    "Τσεχία"
  ],
  DK: "Δανία",
  DJ: "Τζιμπουτί",
  DM: [
    "Κοινοπολιτεία της Δομινίκας",
    "Ντομίνικα"
  ],
  DO: "Δομινικανή Δημοκρατία",
  EC: "Εκουαδόρ",
  EG: "Αίγυπτος",
  SV: "Ελ Σαλβαδόρ",
  GQ: "Ισημερινή-Γουινέα",
  ER: [
    "Κράτος της Ερυθραίας",
    "Ερυθραία"
  ],
  EE: "Εσθονία",
  ET: "Αιθιοπία",
  FK: "Νήσοι Φώκλαντ (Μαλβίνας)",
  FO: "Νήσοι Φερόες",
  FJ: "Δημοκρατία των Φίτζι",
  FI: "Φινλανδία",
  FR: "Γαλλία",
  GF: "Γαλλική Γουιάνα",
  PF: "Γαλλική Πολυνησία",
  TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη",
  GA: "Γκαμπόν",
  GM: "Γκάμπια",
  GE: "Γεωργία",
  DE: "Γερμανία",
  GH: "Γκάνα",
  GI: "Γιβραλτάρ",
  GR: "Ελλάδα",
  GL: "Γροιλανδία",
  GD: "Γρενάδα",
  GP: "Γουαδελούπη",
  GU: "Γκουάμ",
  GT: "Γουατεμάλα",
  GN: "Γουινέα",
  GW: "Γουινέα-Μπισσάου",
  GY: "Γουιάνα",
  HT: "Αϊτη",
  HM: "Νήσοι Χερντ και Μακντόναλντ",
  VA: [
    "Κράτος της Πόλης του Βατικανού",
    "Βατικανό"
  ],
  HN: "Ονδούρα",
  HK: "Χονγκ Κόνγκ",
  HU: "Ουγγαρία",
  IS: "Ισλανδία",
  IN: "Ινδία",
  ID: "Ινδονησία",
  IR: [
    "Ισλαμική Δημοκρατία του Ιράν",
    "Ιράν"
  ],
  IQ: "Ιράκ",
  IE: "Ιρλανδία",
  IL: "Ισραήλ",
  IT: "Ιταλία",
  JM: "Τζαμάικα",
  JP: "Ιαπωνία",
  JO: "Ιορδανία",
  KZ: "Καζακστάν",
  KE: "Κένυα",
  KI: "Κιριμπάτι",
  KP: [
    "Λαοκρατική Δημοκρατία της Κορέας",
    "Βόρεια Κορέα"
  ],
  KR: [
    "Δημοκρατία της Κορέας",
    "Νότια Κορέα"
  ],
  KW: "Κουβέιτ",
  KG: "Κιργιζία",
  LA: [
    "Λαϊκή Δημοκρατία του Λάος",
    "Λάος"
  ],
  LV: "Λετονία",
  LB: "Λίβανο",
  LS: [
    "Βασίλειο του Λεσότο",
    "Λεσότο"
  ],
  LR: "Λιβερία",
  LY: [
    "Κράτος της Λιβύης",
    "Λιβύη"
  ],
  LI: [
    "Πριγκιπάτο του Λίχτενσταϊν",
    "Λίχτενσταϊν"
  ],
  LT: "Λιθουανία",
  LU: "Λουξεμβούργο",
  MO: "Μακάου",
  MK: [
    "Δημοκρατία της Βόρειας Μακεδονίας",
    "Βόρεια Μακεδονία"
  ],
  MG: "Μαδαγασκάρη",
  MW: "Μαλάουι",
  MY: "Μαλαισία",
  MV: "Μαλβίδες",
  ML: "Μαλί",
  MT: "Μάλτα",
  MH: "Νήσοι Μάρσαλ",
  MQ: "Μαρτινίκα",
  MR: "Μαυριτανία",
  MU: "Μαυρίκιος",
  YT: "Μαγιότ",
  MX: "Μεξικό",
  FM: [
    "Ομόσπονδες Πολιτείες της Μικρονησίας",
    "Μικρονησία"
  ],
  MD: [
    "Δημοκρατία της Μολδαβίας",
    "Μολδαβία"
  ],
  MC: [
    "Πριγκιπάτο του Μονακό",
    "Μονακό"
  ],
  MN: "Μογγολία",
  MS: "Μοντσερράτ",
  MA: "Μαρόκο",
  MZ: "Μοζαμβίκη",
  MM: "Μιανμάρ",
  NA: "Ναμίμπια",
  NR: "Ναουρού",
  NP: "Νεπάλ",
  NL: "Ολλανδία",
  NC: "Νέα Καληδονία",
  NZ: "Νέα Ζηλανδία",
  NI: "Νικαράγουα",
  NE: "Νίγηρας",
  NG: "Νιγηρία",
  NU: "Νιούε",
  NF: "Νησί Νόρφολκ",
  MP: "Βόρειες Μαριάνες Νήσοι",
  NO: "Νορβηγία",
  OM: "Ομάν",
  PK: "Πακιστάν",
  PW: "Παλάου",
  PS: [
    "Κράτος της Παλαιστίνης",
    "Παλαιστίνη"
  ],
  PA: "Παναμάς",
  PG: "Παπούα Νέα Γουινέα",
  PY: "Παραγουάη",
  PE: "Περού",
  PH: "Φιλιππίνες",
  PN: "Νήσοι Πίτκαιρν",
  PL: "Πολωνία",
  PT: "Πορτογαλία",
  PR: "Πουέρτο Ρίκο",
  QA: "Κατάρ",
  RE: "Ρεϋνιόν",
  RO: "Ρουμανία",
  RU: [
    "Ρωσική Ομοσπονδία",
    "Ρωσία"
  ],
  RW: "Ρουάντα",
  SH: "Νήσος Αγίας Ελένης",
  KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις",
  LC: "Αγία Λουκία",
  PM: "Σαιν Πιερ και Μικελόν",
  VC: "Άγιος Βικέντιος και Γρεναδίνες",
  WS: "Σαμόα",
  SM: "Άγιος Μαρίνος",
  ST: "Σάο Τομέ και Πρίνσιπε",
  SA: "Σαουδική Αραβία",
  SN: "Σενεγάλη",
  SC: "Σεϋχέλλες",
  SL: "Σιέρα Λεόνε",
  SG: "Σιγκαπούρη",
  SK: "Σλοβακία",
  SI: "Σλοβενία",
  SB: "Νήσοι Σολομώντα",
  SO: "Σομαλία",
  ZA: "Νότια Αφρική",
  GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι",
  ES: "Ισπανία",
  LK: "Σρι Λάνκα",
  SD: "Σουδάν",
  SR: "Σουρινάμ",
  SJ: "Σβάλμπαρντ και Γιαν Μαγιέν",
  SZ: "Σουαζιλάνδη",
  SE: "Σουηδία",
  CH: "Ελβετία",
  SY: [
    "Αραβική Δημοκρατία της Συρίας",
    "Συρία"
  ],
  TW: "Δημοκρατία της Κίνας",
  TJ: "Τατζικιστάν",
  TZ: [
    "Ενωμένη Δημοκρατία της Τανζανίας",
    "Τανζανία"
  ],
  TH: "Ταϊλάνδη",
  TL: "Ανατολικό Τιμόρ",
  TG: "Τογκό",
  TK: "Τοκελάου",
  TO: "Τόνγκα",
  TT: "Τρινιντάντ και Τομπάγκο",
  TN: "Τυνησία",
  TR: "Τουρκία",
  TM: "Τουρκμενιστάν",
  TC: "Τερκς και Κέικος",
  TV: "Τουβαλού",
  UG: "Ουγκάντα",
  UA: "Ουκρανια",
  AE: "Ηνωμένα Αραβικά Εμιράτα",
  GB: "Ηνωμένο Βασίλειο",
  US: [
    "Ηνωμένες Πολιτείες Αμερικής",
    "Αμερική",
    "ΗΠΑ"
  ],
  UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών",
  UY: "Ουρουγουάη",
  UZ: "Ουζμπεκιστάν",
  VU: "Βανουάτου",
  VE: "Βενεζουέλα",
  VN: "Βιετνάμ",
  VG: "Βρετανικές Παρθένοι Νήσοι",
  VI: "Αμερικανικές Παρθένοι Νήσοι",
  WF: "Ουαλίς και Φουτουνά",
  EH: "Δυτική Σαχάρα",
  YE: "Υεμένη",
  ZM: "Ζάμπια",
  ZW: "Ζιμπάμπουε",
  AX: "Νήσοι Ώλαντ",
  BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα",
  CW: "Κουρασάο",
  GG: "Γκουέρνσεϊ",
  IM: "Νήσος του Μαν",
  JE: "Βαϊλάτο του Τζέρσεϊ",
  ME: "Μαυροβούνιο",
  BL: "Άγιος Βαρθολομαίος",
  MF: "Άγιος Μαρτίνος (Γαλλία)",
  RS: "Σερβία",
  SX: "Άγιος Μαρτίνος (Ολλανδία)",
  SS: "Νότιο Σουδάν",
  XK: "Κόσοβο"
}, Ig = {
  locale: M0,
  countries: k0
}, Lg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: k0,
  default: Ig,
  locale: M0
}, Symbol.toStringTag, { value: "Module" })), P0 = "en", T0 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: [
    "People's Republic of China",
    "China"
  ],
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: [
    "Republic of the Congo",
    "Congo"
  ],
  CD: [
    "Democratic Republic of the Congo",
    "Congo"
  ],
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: [
    "Cote d'Ivoire",
    "Côte d'Ivoire",
    "Ivory Coast"
  ],
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: [
    "Czech Republic",
    "Czechia"
  ],
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: [
    "Republic of The Gambia",
    "The Gambia",
    "Gambia"
  ],
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Islamic Republic of Iran",
    "Iran"
  ],
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: [
    "South Korea",
    "Korea, Republic of",
    "Republic of Korea"
  ],
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Netherlands",
    "The Netherlands",
    "Netherlands (Kingdom of the)"
  ],
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: [
    "The Republic of North Macedonia",
    "North Macedonia"
  ],
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: [
    "State of Palestine",
    "Palestine"
  ],
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: [
    "Pitcairn",
    "Pitcairn Islands"
  ],
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: [
    "Russian Federation",
    "Russia"
  ],
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: [
    "Taiwan, Province of China",
    "Taiwan"
  ],
  TJ: "Tajikistan",
  TZ: [
    "United Republic of Tanzania",
    "Tanzania"
  ],
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: [
    "Türkiye",
    "Turkey"
  ],
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: [
    "United Arab Emirates",
    "UAE"
  ],
  GB: [
    "United Kingdom",
    "UK",
    "Great Britain"
  ],
  US: [
    "United States of America",
    "United States",
    "USA",
    "U.S.A.",
    "US",
    "U.S."
  ],
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: [
    "Åland Islands",
    "Aland Islands"
  ],
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "South Sudan",
  XK: "Kosovo"
}, Ag = {
  locale: P0,
  countries: T0
}, Ng = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: T0,
  default: Ag,
  locale: P0
}, Symbol.toStringTag, { value: "Module" })), E0 = "es", D0 = {
  AF: "Afganistán",
  AL: "Albania",
  DZ: "Argelia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benin",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BA: "Bosnia y Herzegovina",
  BW: "Botswana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Isla de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "Congo (República Democrática del)",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil",
  HR: "Croacia",
  CU: "Cuba",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Malvinas",
  FO: "Islas Feroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guayana Francesa",
  PF: "Polinesia Francesa",
  TF: "Tierras Australes Francesas",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haití",
  HM: "Heard e Islas McDonald",
  VA: "Santa Sede",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Irán",
    "República Islámica de Irán"
  ],
  IQ: "Iraq",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "República Popular Democrática de Corea",
  KR: "República de Corea",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular de Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Macedonia del Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Malí",
  MT: "Malta",
  MH: "Islas Marshall",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  FM: "Micronesia",
  MD: "Moldavia",
  MC: "Mónaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  MP: "Islas Marianas del Norte",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papua Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Catar",
  RE: "Reunión",
  RO: "Rumanía",
  RU: "Rusia",
  RW: "Ruanda",
  SH: "Santa Helena, Ascensión y Tristán de Acuña",
  KN: "Saint Kitts y Nevis",
  LC: "Santa Lucía",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Georgia del Sur y las Islas Sandwich del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SD: "Sudán",
  SR: "Suriname",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  SY: "República Árabe Siria",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania",
  TH: "Tailandia",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UM: "Islas Ultramarinas Menores de los Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Islas Vírgenes británicas",
  VI: "Islas Vírgenes de los Estados Unidos",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
  AX: "Islas Åland",
  BQ: "Bonaire, San Eustaquio y Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isla de Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (francesa)",
  RS: "Serbia",
  SX: "Sint Maarten (neerlandesa)",
  SS: "Sudán del Sur",
  XK: "Kosovo"
}, Rg = {
  locale: E0,
  countries: D0
}, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: D0,
  default: Rg,
  locale: E0
}, Symbol.toStringTag, { value: "Module" })), I0 = "fr", L0 = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Océan Indien Britannique",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République Centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos",
  CO: "Colombie",
  KM: "Comores",
  CG: "République du Congo",
  CD: "République démocratique du Congo",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte-d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CY: "Chypre",
  CZ: "République Tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (Vatican)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée du Nord",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie",
  MD: "Moldavie",
  MC: "Monaco",
  MN: "Mongolie",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niué",
  NF: "Île Norfolk",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Îles Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Russie",
  RW: "Rwanda",
  SH: "Sainte-Hélène",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "São Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Île Jan Mayen",
  SZ: "Royaume d'Eswatini",
  SE: "Suède",
  CH: "Suisse",
  SY: "Syrie",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "République unie de Tanzanie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Îles vierges britanniques",
  VI: "Îles vierges américaines",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Saint-Eustache et Saba",
  CW: "Curaçao",
  GG: "Guernesey",
  IM: "Île de Man",
  JE: "Jersey",
  ME: "Monténégro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin (partie française)",
  RS: "Serbie",
  SX: "Saint-Martin (partie néerlandaise)",
  SS: "Soudan du Sud",
  XK: "Kosovo"
}, Bg = {
  locale: I0,
  countries: L0
}, jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: L0,
  default: Bg,
  locale: I0
}, Symbol.toStringTag, { value: "Module" })), A0 = "hi", N0 = {
  AD: "अंडोरा",
  AE: "संयुक्त अरब अमीरात",
  AF: "अफगानिस्तान",
  AG: "एंटीगुआ और बारबूडा",
  AI: "अंग्विला",
  AL: "अल्बानिया",
  AM: "अर्मेनिया",
  AO: "अंगोला",
  AQ: "अंटार्टिका",
  AR: "अर्जेंटिना",
  AS: "अमेरिकान सामोआ",
  AT: "आस्ट्रिया",
  AU: "आस्ट्रेलिया",
  AW: "अरुबा",
  AX: "ऑलैण्ड द्वीपसमूह",
  AZ: "अजरबेजान",
  BA: "बोस्निया हर्जेगोविना",
  BB: "बार्बाडोस",
  BD: "बांग्लादेश",
  BE: "बेल्जियम",
  BF: "बुर्किना फासो",
  BG: "बल्गारिया",
  BH: "बहरीन",
  BI: "बुरुंडी",
  BJ: "बानिन",
  BL: "सेंट_बार्थेलेमी",
  BM: "बर्मूडा",
  BN: "ब्रुनेई",
  BO: "बोलिविया",
  BQ: "कैरिबियन नीदरलैंड",
  BR: "ब्राजील",
  BS: "बहामास",
  BT: "भूटान",
  BV: "बाउवेट",
  BW: "बोत्सवाना",
  BY: "बेलारुस",
  BZ: "बेलिजे",
  CA: "कनाडा",
  CC: "कोकोस (कीलिंग) द्वीप",
  CD: "कांगो लोकतान्त्रिक गणराज्य",
  CF: "सेंट्रल अफ्रीका गणतंत्र",
  CG: "कांगो",
  CH: "स्विट्जरलैंड",
  CI: "आइवरी कोस्ट",
  CK: "कुक द्वीप",
  CL: "चिली",
  CM: "कैमरून",
  CN: "चीन",
  CO: "कोलंबिया",
  CR: "कोस्टा रिका",
  CU: "क्यूबा",
  CV: "केप वर्दे",
  CW: "कुराकाओ",
  CX: "क्रिसमस द्वीप",
  CY: "साइप्रस",
  CZ: "चेक",
  DE: "जर्मनी",
  DJ: "जिबॉती",
  DK: "डैनमार्क",
  DM: "डोमिनिक",
  DO: "डोमिनिक गणतंत्र",
  DZ: "अल्जीरिया",
  EC: "इक्वाडोर",
  EE: "एस्तोनिया",
  EG: "मिस्र",
  EH: "पश्चिमी सहारा",
  ER: "एरिट्रेया",
  ES: "स्पेन",
  ET: "इथियोपिया",
  FI: "फिनलैंड",
  FJ: "फिजी",
  FK: "फाकलैंड द्वीप समूह (मालविनास)",
  FM: "माइक्रोनेशिया",
  FO: "फराओ द्वीप समूह",
  FR: "फ्रांस",
  GA: "गैबोन",
  GB: "ग्रेट ब्रिटेन",
  GD: "ग्रेनेडा",
  GE: "जॉर्जिया",
  GF: "फ्रेंच गुआना",
  GG: "ग्वेर्नसे",
  GH: "घाना",
  GI: "जिब्राल्टर",
  GL: "ग्रीनलैंड",
  GM: "गाम्बिया",
  GN: "गिनी",
  GP: "ग्वाडेलोप",
  GQ: "एक्वेटोरियल गिनी",
  GR: "यूनान",
  GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह",
  GT: "ग्वाटेमाला",
  GU: "ग्वाम",
  GW: "गिनी-बिसाउ",
  GY: "गुआना",
  HK: "हांग कांग",
  HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह",
  HN: "होंडुरास",
  HR: "क्रोएशिया",
  HT: "हैती",
  HU: "हंगरी",
  ID: "इंडोनेशिया",
  IE: "आयरलैंड",
  IL: "इजराइल",
  IM: "आइसल ऑफ मैन",
  IN: "भारत",
  IO: "ब्रितानी हिंद महासागरीय क्षेत्र",
  IQ: "इराक",
  IR: "ईरान",
  IS: "आइसलैंड",
  IT: "इटली",
  JE: "जर्सी",
  JM: "जमैका",
  JO: "जॉर्डन",
  JP: "जापान",
  KE: "केन्या",
  KG: "किर्जिस्तान",
  KH: "कंबोडिया",
  KI: "किरिबिती",
  KM: "कोमोरोस",
  KN: "सेंट किट्स एंड नेविस",
  KP: "उत्तर कोरिया",
  KR: "दक्षिण कोरिया",
  KW: "कुवैत",
  KY: "केमैन आइसलैंड्स",
  KZ: "कज़ाखिस्तान",
  LA: "लाओस",
  LB: "लेबनान",
  LC: "सेंट लुसिया",
  LI: "लिक्टेनिस्टीन",
  LK: "श्री लंका",
  LR: "लाइबेरिया",
  LS: "लेसोथो",
  LT: "लिथुआनिया",
  LU: "लक्जमबर्ग",
  LV: "लात्विया",
  LY: "लीबिया",
  MA: "मोरक्को",
  MC: "मोनाको",
  MD: "मोलदोवा",
  ME: "मोंटेनेग्रो",
  MF: "सेंट मार्टिन की सामूहिकता",
  MG: "मैडागास्कर",
  MH: "मार्शल द्वीपसमूह",
  MK: "मकदूनिया",
  ML: "माली",
  MM: "म्यामांर (बर्मा)",
  MN: "मंगोलिया",
  MO: "मकाओ",
  MP: "उत्तर मैरिना द्वीपसमूह",
  MQ: "मार्टिनिक",
  MR: "मॉरितानिया",
  MS: "मोंटसेराट",
  MT: "माल्टा",
  MU: "मारीशस",
  MV: "मालदीव",
  MW: "मालावी",
  MX: "मेक्सिको",
  MY: "मलयेशिया",
  MZ: "मोजांबिक",
  NA: "नामीबिया",
  NC: "न्यू कैलेडोनिया",
  NE: "नाइजर",
  NF: "नोरफॉक द्वीप",
  NG: "नाइजीरिया",
  NI: "निकारागुआ",
  NL: "नीदरलैंड्स",
  NO: "नॉर्वे",
  NP: "नेपाल",
  NR: "नाउरू",
  NU: "नियू",
  NZ: "न्यूजीलैंड",
  OM: "ओमान",
  PA: "पनामा",
  PE: "पेरू",
  PF: "फ्रैंच गुआना",
  PG: "पापुआ न्यू गिनी",
  PH: "फिलीपींस",
  PK: "पाकिस्तान",
  PL: "पोलैंड",
  PM: "सेंट पिएरे एंड मिक्वेलॉन",
  PN: "पिटकैर्न द्वीपसमूह",
  PR: "पुएर्तो रिको",
  PS: "फिलिस्तीन राज्य",
  PT: "पुर्तगाल",
  PW: "पलाउ",
  PY: "पराग्वे",
  QA: "क़तार",
  RE: "रीयूनियन",
  RO: "रोमानिया",
  RS: "सर्बिया",
  RU: "रूस",
  RW: "रवांडा",
  SA: "सऊदी अरब",
  SB: "सोलोमन द्वीपसमूह",
  SC: "सेशेल्स",
  SD: "सूडान",
  SE: "स्वीडन",
  SG: "सिंगापुर",
  SH: "सेंट हेलेना",
  SI: "स्लोवानिया",
  SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)",
  SK: "स्लोवाकिया",
  SL: "सियारा लिओन",
  SM: "सैन मारिनो",
  SN: "सेनेगल",
  SO: "सोमालिया",
  SR: "सूरीनाम",
  SS: "दक्षिण सूडान",
  ST: "साओ टॉम एंड प्रिंसिपी",
  SV: "सल्वाडोर",
  SX: "सिण्ट मार्टेन",
  SY: "सीरिया",
  SZ: "स्वाजीलैंड",
  TC: "तुर्क एंड कैकोस द्वीपसमूह",
  TD: "चाड",
  TF: "फ्रांसीसी दक्षिणी क्षेत्र",
  TG: "टोगो",
  TH: "थाईलैंड",
  TJ: "तज़ाकिस्तान",
  TK: "टोकेलू",
  TL: "पूर्वी तिमोर",
  TM: "तुर्कमेनिस्तान",
  TN: "ट्यूनीशिया",
  TO: "टोंगा",
  TR: "तुर्की",
  TT: "ट्रिनिडाड एंड टोबैगो",
  TV: "तुवालू",
  TW: "ताइवान",
  TZ: "तंजानिया",
  UA: "उक्रेन",
  UG: "उगांडा",
  UM: "यूएस माइनर आउटलाइंग द्वीपसमूह",
  US: "यूएसए (संयुक्त राज्य अमेरिका)",
  UY: "उरुग्वे",
  UZ: "उजबेकिस्तान",
  VA: "वेटिकन",
  VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स",
  VE: "वेनेजुएला",
  VG: "ब्रितानी वर्जिन द्वीपसमूह",
  VI: "अमेरिकी वर्जिन द्वीपसमूह",
  VN: "विएतनाम",
  VU: "वनातू",
  WF: "वालीज एंड फुटुना",
  WS: "पश्चिमी सामोआ",
  XK: "कोसोवो",
  YE: "यमन",
  YT: "मायोते",
  ZA: "दक्षिण अफ्रीका",
  ZM: "जाम्बिया",
  ZW: "जिंबावे"
}, Hg = {
  locale: A0,
  countries: N0
}, Fg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: N0,
  default: Hg,
  locale: A0
}, Symbol.toStringTag, { value: "Module" })), R0 = "hu", O0 = {
  AF: "Afganisztán",
  AL: "Albánia",
  DZ: "Algéria",
  AS: "Amerikai Szamoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktisz",
  AG: "Antigua és Barbuda",
  AR: "Argentína",
  AM: "Örményország",
  AW: "Aruba",
  AU: "Ausztrália",
  AT: "Ausztria",
  AZ: "Azerbajdzsán",
  BS: "Bahama-szigetek",
  BH: "Bahrein",
  BD: "Banglades",
  BB: "Barbados",
  BY: "Fehéroroszország",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhután",
  BO: "Bolívia",
  BA: "Bosznia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet-sziget",
  BR: "Brazília",
  IO: "Brit Indiai-óceáni Terület",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodzsa",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zöld-foki Köztársaság",
  KY: "Kajmán-szigetek",
  CF: "Közép-afrikai Köztársaság",
  TD: "Csád",
  CL: "Chile",
  CN: "Kína",
  CX: "Karácsony-sziget",
  CC: "Kókusz (Keeling)-szigetek",
  CO: "Kolumbia",
  KM: "Comore-szigetek",
  CG: "Kongói Köztársaság",
  CD: "Kongói Demokratikus Köztársaság",
  CK: "Cook-szigetek",
  CR: "Costa Rica",
  CI: "Elefántcsontpart",
  HR: "Horvátország",
  CU: "Kuba",
  CY: "Ciprus",
  CZ: "Csehország",
  DK: "Dánia",
  DJ: "Dzsibuti",
  DM: "Dominikai Közösség",
  DO: "Dominikai Köztársaság",
  EC: "Ecuador",
  EG: "Egyiptom",
  SV: "Salvador",
  GQ: "Egyenlítői-Guinea",
  ER: "Eritrea",
  EE: "Észtország",
  ET: "Etiópia",
  FK: "Falkland-szigetek",
  FO: "Feröer",
  FJ: "Fidzsi-szigetek",
  FI: "Finnország",
  FR: "Franciaország",
  GF: "Francia Guyana",
  PF: "Francia Polinézia",
  TF: "Francia déli területek",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Grúzia",
  DE: "Németország",
  GH: "Ghána",
  GI: "Gibraltár",
  GR: "Görögország",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Bissau-Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-sziget és McDonald-szigetek",
  VA: "Vatikán",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Magyarország",
  IS: "Izland",
  IN: "India",
  ID: "Indonézia",
  IR: "Irán",
  IQ: "Irak",
  IE: "Írország",
  IL: "Izrael",
  IT: "Olaszország",
  JM: "Jamaica",
  JP: "Japán",
  JO: "Jordánia",
  KZ: "Kazahsztán",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Észak-Korea",
  KR: "Dél-Korea",
  KW: "Kuvait",
  KG: "Kirgizisztán",
  LA: "Laosz",
  LV: "Lettország",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Litvánia",
  LU: "Luxemburg",
  MO: "Makao",
  MK: "Észak-Macedónia",
  MG: "Madagaszkár",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldív-szigetek",
  ML: "Mali",
  MT: "Málta",
  MH: "Marshall-szigetek",
  MQ: "Martinique",
  MR: "Mauritánia",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexikó",
  FM: "Mikronéziai Szövetségi Államok",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongólia",
  MS: "Montserrat",
  MA: "Marokkó",
  MZ: "Mozambik",
  MM: "Mianmar",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepál",
  NL: "Hollandia",
  NC: "Új-Kaledónia",
  NZ: "Új-Zéland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niue",
  NF: "Norfolk-sziget",
  MP: "Északi-Mariana-szigetek",
  NO: "Norvégia",
  OM: "Omán",
  PK: "Pakisztán",
  PW: "Palau",
  PS: "Palesztina",
  PA: "Panama",
  PG: "Pápua Új-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Fülöp-szigetek",
  PN: "Pitcairn-szigetek",
  PL: "Lengyelország",
  PT: "Portugália",
  PR: "Puerto Rico",
  QA: "Katar",
  RE: "Réunion",
  RO: "Románia",
  RU: "Oroszország",
  RW: "Ruanda",
  SH: "Saint Helena",
  KN: "Saint Kitts és Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent és a Grenadine-szigetek",
  WS: "Szamoa",
  SM: "San Marino",
  ST: "São Tomé és Príncipe",
  SA: "Szaudi-Arábia",
  SN: "Szenegál",
  SC: "Seychelle-szigetek",
  SL: "Sierra Leone",
  SG: "Szingapúr",
  SK: "Szlovákia",
  SI: "Szlovénia",
  SB: "Salamon-szigetek",
  SO: "Szomália",
  ZA: "Dél-Afrika",
  GS: "Déli-Georgia és Déli-Sandwich-szigetek",
  ES: "Spanyolország",
  LK: "Sri Lanka",
  SD: "Szudán",
  SR: "Suriname",
  SJ: "Spitzbergák és Jan Mayen",
  SZ: "Szváziföld",
  SE: "Svédország",
  CH: "Svájc",
  SY: "Szíria",
  TW: "Tajvan",
  TJ: "Tádzsikisztán",
  TZ: "Tanzánia",
  TH: "Thaiföld",
  TL: "Kelet-Timor",
  TG: "Togo",
  TK: "Tokelau-szigetek",
  TO: "Tonga",
  TT: "Trinidad és Tobago",
  TN: "Tunézia",
  TR: "Törökország",
  TM: "Türkmenisztán",
  TC: "Turks- és Caicos-szigetek",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajna",
  AE: "Egyesült Arab Emírségek",
  GB: "Egyesült Királyság",
  US: "Amerikai Egyesült Államok",
  UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai",
  UY: "Uruguay",
  UZ: "Üzbegisztán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Brit Virgin-szigetek",
  VI: "Amerikai Virgin-szigetek",
  WF: "Wallis és Futuna",
  EH: "Nyugat-Szahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibi Hollandia",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man-sziget",
  JE: "Jersey",
  ME: "Montenegró",
  BL: "Saint Barthélemy",
  MF: "Szent Márton-sziget (francia rész)",
  RS: "Szerbia",
  SX: "Szent Márton-sziget (holland rész)",
  SS: "Dél-Szudán",
  XK: "Koszovó"
}, Gg = {
  locale: R0,
  countries: O0
}, Vg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: O0,
  default: Gg,
  locale: R0
}, Symbol.toStringTag, { value: "Module" })), B0 = "id", j0 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarusia",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BV: "Kepulauan Bouvet",
  BR: "Brasil",
  IO: "Teritori Samudra Hindia Britania",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Tanjung Verde",
  KY: "Kepulauan Cayman",
  CF: "Afrika Tengah",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Pulau Natal",
  CC: "Kepulauan Cocos (Keeling)",
  CO: "Kolombia",
  KM: "Komoro",
  CG: "Kongo",
  CD: "Republik Demokratik Kongo",
  CK: "Kepulauan Cook",
  CR: "Kosta Rika",
  CI: "Pantai Gading",
  HR: "Kroasia",
  CU: "Kuba",
  CY: "Siprus",
  CZ: "Republik Ceko",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominika",
  DO: "Republik Dominika",
  EC: "Ekuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Khatulistiwa",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Kepulauan Falkland(Malvinas)",
  FO: "Kepulauan Faroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Perancis",
  GF: "Guyana Perancis",
  PF: "Polinesia Perancis",
  TF: "Antartika Perancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Yunani",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatamala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Pulau Heard dan Kepulauan McDonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungaria",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Jepang",
  JO: "Yordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea Utara",
  KR: "Korea Selatan",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxemburg",
  MO: "Makau",
  MK: "Makedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MQ: "Martinik",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  FM: "Federasi Mikronesia",
  MD: "Moldova",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Moroko",
  MZ: "Mozambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Belanda",
  NC: "Kaledonia Baru",
  NZ: "Selandia Baru",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Kepulauan Norfolk",
  MP: "Kepulauan Mariana Utara",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nugini",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PN: "Pitcairn",
  PL: "Polandia",
  PT: "Portugal",
  PR: "Puerto Riko",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Rumania",
  RU: "Rusia",
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre dan Miquelon",
  VC: "Saint Vincent dan the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome dan Principe",
  SA: "Arab Saudi",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  GS: "Georgia Selatan dan Kepulauan Sandwich Selatan",
  ES: "Spanyol",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard dan Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Swiss",
  SY: "Suriah",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Turks dan Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Uni Emirat Arab",
  GB: "Britania Raya",
  US: "Amerika Serikat",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Sahara Barat",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland Islands",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "Sudan Selatan",
  XK: "Kosovo"
}, Kg = {
  locale: B0,
  countries: j0
}, zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: j0,
  default: Kg,
  locale: B0
}, Symbol.toStringTag, { value: "Module" })), H0 = "it", F0 = {
  AD: "Andorra",
  AE: "Emirati Arabi Uniti",
  AF: "Afghanistan",
  AG: "Antigua e Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antartide",
  AR: "Argentina",
  AS: "Samoa Americane",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Isole Åland",
  AZ: "Azerbaigian",
  BA: "Bosnia ed Erzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgio",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Isole BES",
  BR: "Brasile",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Isola Bouvet",
  BW: "Botswana",
  BY: "Bielorussia",
  BZ: "Belize",
  CA: "Canada",
  CC: "Isole Cocos e Keeling",
  CD: "Repubblica Democratica del Congo",
  CF: "Repubblica Centrafricana",
  CG: "Repubblica del Congo",
  CH: "Svizzera",
  CI: "Costa d'Avorio",
  CK: "Isole Cook",
  CL: "Cile",
  CM: "Camerun",
  CN: "Cina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capo Verde",
  CW: "Curaçao",
  CX: "Isola del Natale",
  CY: "Cipro",
  CZ: "Repubblica Ceca",
  DE: "Germania",
  DJ: "Gibuti",
  DK: "Danimarca",
  DM: "Dominica",
  DO: "Repubblica Dominicana",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egitto",
  EH: "Sahara Occidentale",
  ER: "Eritrea",
  ES: "Spagna",
  ET: "Etiopia",
  FI: "Finlandia",
  FJ: "Figi",
  FK: "Isole Falkland",
  FM: "Stati Federati di Micronesia",
  FO: "Isole Fær Øer",
  FR: "Francia",
  GA: "Gabon",
  GB: "Regno Unito",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Francese",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibilterra",
  GL: "Groenlandia",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadalupa",
  GQ: "Guinea Equatoriale",
  GR: "Grecia",
  GS: "Georgia del Sud e isole Sandwich meridionali",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Isole Heard e McDonald",
  HN: "Honduras",
  HR: "Croazia",
  HT: "Haiti",
  HU: "Ungheria",
  ID: "Indonesia",
  IE: "Irlanda",
  IL: "Israele",
  IM: "Isola di Man",
  IN: "India",
  IO: "Territori Britannici dell'Oceano Indiano",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Giamaica",
  JO: "Giordania",
  JP: "Giappone",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambogia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts e Nevis",
  KP: "Corea del Nord",
  KR: "Corea del Sud",
  KW: "Kuwait",
  KY: "Isole Cayman",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Libano",
  LC: "Santa Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Lussemburgo",
  LV: "Lettonia",
  LY: "Libia",
  MA: "Marocco",
  MC: "Monaco",
  MD: "Moldavia",
  ME: "Montenegro",
  MF: "Saint-Martin",
  MG: "Madagascar",
  MH: "Isole Marshall",
  MK: "Macedonia del Nord",
  ML: "Mali",
  MM: "Birmania  Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Isole Marianne Settentrionali",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Messico",
  MY: "Malesia",
  MZ: "Mozambico",
  NA: "Namibia",
  NC: "Nuova Caledonia",
  NE: "Niger",
  NF: "Isola Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Paesi Bassi",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nuova Zelanda",
  OM: "Oman",
  PA: "Panamá",
  PE: "Perù",
  PF: "Polinesia Francese",
  PG: "Papua Nuova Guinea",
  PH: "Filippine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint Pierre e Miquelon",
  PN: "Isole Pitcairn",
  PR: "Porto Rico",
  PS: "Stato di Palestina",
  PT: "Portogallo",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Ruanda",
  SA: "Arabia Saudita",
  SB: "Isole Salomone",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Svezia",
  SG: "Singapore",
  SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
  SI: "Slovenia",
  SJ: "Svalbard e Jan Mayen",
  SK: "Slovacchia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudan del Sud",
  ST: "São Tomé e Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Isole Turks e Caicos",
  TD: "Ciad",
  TF: "Territori Francesi del Sud",
  TG: "Togo",
  TH: "Thailandia",
  TJ: "Tagikistan",
  TK: "Tokelau",
  TL: "Timor Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turchia",
  TT: "Trinidad e Tobago",
  TV: "Tuvalu",
  TW: [
    "Repubblica di Cina",
    "Taiwan"
  ],
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Isole minori esterne degli Stati Uniti",
  US: "Stati Uniti d'America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Città del Vaticano",
  VC: "Saint Vincent e Grenadine",
  VE: "Venezuela",
  VG: "Isole Vergini Britanniche",
  VI: "Isole Vergini Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis e Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Sudafrica",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, Ug = {
  locale: H0,
  countries: F0
}, Zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: F0,
  default: Ug,
  locale: H0
}, Symbol.toStringTag, { value: "Module" })), G0 = "ja", V0 = {
  AF: "アフガニスタン",
  AL: "アルバニア",
  DZ: "アルジェリア",
  AS: "アメリカ領サモア",
  AD: "アンドラ",
  AO: "アンゴラ",
  AI: "アンギラ",
  AQ: "南極",
  AG: "アンティグア・バーブーダ",
  AR: "アルゼンチン",
  AM: "アルメニア",
  AW: "アルバ",
  AU: "オーストラリア",
  AT: "オーストリア",
  AZ: "アゼルバイジャン",
  BS: "バハマ",
  BH: "バーレーン",
  BD: "バングラデシュ",
  BB: "バルバドス",
  BY: "ベラルーシ",
  BE: "ベルギー",
  BZ: "ベリーズ",
  BJ: "ベナン",
  BM: "バミューダ",
  BT: "ブータン",
  BO: "ボリビア多民族国",
  BA: "ボスニア・ヘルツェゴビナ",
  BW: "ボツワナ",
  BV: "ブーベ島",
  BR: "ブラジル",
  IO: "イギリス領インド洋地域",
  BN: "ブルネイ・ダルサラーム",
  BG: "ブルガリア",
  BF: "ブルキナファソ",
  BI: "ブルンジ",
  KH: "カンボジア",
  CM: "カメルーン",
  CA: "カナダ",
  CV: "カーボベルデ",
  KY: "ケイマン諸島",
  CF: "中央アフリカ共和国",
  TD: "チャド",
  CL: "チリ",
  CN: "中華人民共和国",
  CX: "クリスマス島",
  CC: "ココス（キーリング）諸島",
  CO: "コロンビア",
  KM: "コモロ",
  CG: "コンゴ共和国",
  CD: "コンゴ民主共和国",
  CK: "クック諸島",
  CR: "コスタリカ",
  CI: "コートジボワール",
  HR: "クロアチア",
  CU: "キューバ",
  CY: "キプロス",
  CZ: "チェコ",
  DK: "デンマーク",
  DJ: "ジブチ",
  DM: "ドミニカ国",
  DO: "ドミニカ共和国",
  EC: "エクアドル",
  EG: "エジプト",
  SV: "エルサルバドル",
  GQ: "赤道ギニア",
  ER: "エリトリア",
  EE: "エストニア",
  ET: "エチオピア",
  FK: "フォークランド（マルビナス）諸島",
  FO: "フェロー諸島",
  FJ: "フィジー",
  FI: "フィンランド",
  FR: "フランス",
  GF: "フランス領ギアナ",
  PF: "フランス領ポリネシア",
  TF: "フランス領南方・南極地域",
  GA: "ガボン",
  GM: "ガンビア",
  GE: "ジョージア",
  DE: "ドイツ",
  GH: "ガーナ",
  GI: "ジブラルタル",
  GR: "ギリシャ",
  GL: "グリーンランド",
  GD: "グレナダ",
  GP: "グアドループ",
  GU: "グアム",
  GT: "グアテマラ",
  GN: "ギニア",
  GW: "ギニアビサウ",
  GY: "ガイアナ",
  HT: "ハイチ",
  HM: "ハード島とマクドナルド諸島",
  VA: "バチカン市国",
  HN: "ホンジュラス",
  HK: "香港",
  HU: "ハンガリー",
  IS: "アイスランド",
  IN: "インド",
  ID: "インドネシア",
  IR: "イラン・イスラム共和国",
  IQ: "イラク",
  IE: "アイルランド",
  IL: "イスラエル",
  IT: "イタリア",
  JM: "ジャマイカ",
  JP: "日本",
  JO: "ヨルダン",
  KZ: "カザフスタン",
  KE: "ケニア",
  KI: "キリバス",
  KP: "朝鮮民主主義人民共和国",
  KR: "大韓民国",
  KW: "クウェート",
  KG: "キルギス",
  LA: "ラオス人民民主共和国",
  LV: "ラトビア",
  LB: "レバノン",
  LS: "レソト",
  LR: "リベリア",
  LY: "リビア",
  LI: "リヒテンシュタイン",
  LT: "リトアニア",
  LU: "ルクセンブルク",
  MO: "マカオ",
  MG: "マダガスカル",
  MW: "マラウイ",
  MY: "マレーシア",
  MV: "モルディブ",
  ML: "マリ",
  MT: "マルタ",
  MH: "マーシャル諸島",
  MQ: "マルティニーク",
  MR: "モーリタニア",
  MU: "モーリシャス",
  YT: "マヨット",
  MX: "メキシコ",
  FM: "ミクロネシア連邦",
  MD: "モルドバ共和国",
  MC: "モナコ",
  MN: "モンゴル",
  MS: "モントセラト",
  MA: "モロッコ",
  MZ: "モザンビーク",
  MM: "ミャンマー",
  NA: "ナミビア",
  NR: "ナウル",
  NP: "ネパール",
  NL: "オランダ",
  NC: "ニューカレドニア",
  NZ: "ニュージーランド",
  NI: "ニカラグア",
  NE: "ニジェール",
  NG: "ナイジェリア",
  NU: "ニウエ",
  NF: "ノーフォーク島",
  MK: "北マケドニア",
  MP: "北マリアナ諸島",
  NO: "ノルウェー",
  OM: "オマーン",
  PK: "パキスタン",
  PW: "パラオ",
  PS: "パレスチナ",
  PA: "パナマ",
  PG: "パプアニューギニア",
  PY: "パラグアイ",
  PE: "ペルー",
  PH: "フィリピン",
  PN: "ピトケアン",
  PL: "ポーランド",
  PT: "ポルトガル",
  PR: "プエルトリコ",
  QA: "カタール",
  RE: "レユニオン",
  RO: "ルーマニア",
  RU: "ロシア連邦",
  RW: "ルワンダ",
  SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
  KN: "セントクリストファー・ネイビス",
  LC: "セントルシア",
  PM: "サンピエール島・ミクロン島",
  VC: "セントビンセントおよびグレナディーン諸島",
  WS: "サモア",
  SM: "サンマリノ",
  ST: "サントメ・プリンシペ",
  SA: "サウジアラビア",
  SN: "セネガル",
  SC: "セーシェル",
  SL: "シエラレオネ",
  SG: "シンガポール",
  SK: "スロバキア",
  SI: "スロベニア",
  SB: "ソロモン諸島",
  SO: "ソマリア",
  ZA: "南アフリカ",
  GS: "サウスジョージア・サウスサンドウィッチ諸島",
  ES: "スペイン",
  LK: "スリランカ",
  SD: "スーダン",
  SR: "スリナム",
  SJ: "スヴァールバル諸島およびヤンマイエン島",
  SZ: "スワジランド",
  SE: "スウェーデン",
  CH: "スイス",
  SY: "シリア・アラブ共和国",
  TW: "台湾",
  TJ: "タジキスタン",
  TZ: "タンザニア",
  TH: "タイ",
  TL: "東ティモール",
  TG: "トーゴ",
  TK: "トケラウ",
  TO: "トンガ",
  TT: "トリニダード・トバゴ",
  TN: "チュニジア",
  TR: "トルコ",
  TM: "トルクメニスタン",
  TC: "タークス・カイコス諸島",
  TV: "ツバル",
  UG: "ウガンダ",
  UA: "ウクライナ",
  AE: "アラブ首長国連邦",
  GB: "イギリス",
  US: "アメリカ合衆国",
  UM: "合衆国領有小離島",
  UY: "ウルグアイ",
  UZ: "ウズベキスタン",
  VU: "バヌアツ",
  VE: "ベネズエラ・ボリバル共和国",
  VN: "ベトナム",
  VG: "イギリス領ヴァージン諸島",
  VI: "アメリカ領ヴァージン諸島",
  WF: "ウォリス・フツナ",
  EH: "西サハラ",
  YE: "イエメン",
  ZM: "ザンビア",
  ZW: "ジンバブエ",
  AX: "オーランド諸島",
  BQ: "ボネール、シント・ユースタティウスおよびサバ",
  CW: "キュラソー",
  GG: "ガーンジー",
  IM: "マン島",
  JE: "ジャージー",
  ME: "モンテネグロ",
  BL: "サン・バルテルミー",
  MF: "サン・マルタン（フランス領）",
  RS: "セルビア",
  SX: "シント・マールテン（オランダ領）",
  SS: "南スーダン",
  XK: "コソボ"
}, Yg = {
  locale: G0,
  countries: V0
}, Wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: V0,
  default: Yg,
  locale: G0
}, Symbol.toStringTag, { value: "Module" })), K0 = "nl", z0 = {
  AF: "Afghanistan",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: [
    "België",
    "Koninkrijk België"
  ],
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivië",
  BA: "Bosnië-Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Eiland",
  BR: "Brazilië",
  IO: "Brits Indische oceaan",
  BN: "Brunei Darussalam",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo, Volksrepubliek",
  CD: "Congo, Democratische Republiek",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Ethiopië",
  FK: "Falklandeilanden",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Heilige Stoel",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran",
  IQ: "Irak",
  IE: "Ierland",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Noord-Korea",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: [
    "Maldiven",
    "Malediven"
  ],
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië, Federale Staten",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Nederland",
    "Koninkrijk der Nederlanden"
  ],
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Noordelijke Marianen",
  MK: "Noord-Macedonië",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sint-Helena",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé en Principe",
  SA: "Saudi-Arabië",
  SN: "Senegal",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SZ: "Ngwane, Koninkrijk Eswatini",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrië",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: [
    "Tanzania",
    "Tanzania, Verenigde Republiek"
  ],
  TH: "Thailand",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: [
    "Groot-Brittannië",
    "Verenigd Koninkrijk"
  ],
  US: [
    "Verenigde Staten van Amerika",
    "Verenigde Staten"
  ],
  UM: "Ver afgelegen eilandjes van de Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Maagdeneilanden, Britse",
  VI: "Maagdeneilanden, Amerikaanse",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Sint Eustatius en Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man Eiland",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: [
    "Sint-Maarten (Frans deel)",
    "Sint-Maarten (Franse Antillen)",
    "Collectiviteit van Sint-Maarten"
  ],
  RS: "Servië",
  SX: [
    "Sint Maarten",
    "Sint-Maarten",
    "Sint Maarten (Nederlands deel)",
    "Land Sint Maarten"
  ],
  SS: "Zuid-Soedan",
  XK: "Kosovo"
}, $g = {
  locale: K0,
  countries: z0
}, Jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: z0,
  default: $g,
  locale: K0
}, Symbol.toStringTag, { value: "Module" })), U0 = "no", Z0 = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviterussland",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvetøya",
  BR: "Brasil",
  IO: "Det britiske territoriet i Indiahavet",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Caymanøyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Tsjad",
  CL: "Chile",
  CN: "Kina",
  CX: "Christmasøya",
  CC: "Kokosøyene",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo-Brazzaville",
  CD: "Kongo",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CU: "Cuba",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopia",
  FK: "Falklandsøyene",
  FO: "Færøyene",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesia",
  TF: "De franske sørterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- og McDonaldøyene",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hongkong SAR Kina",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nord-Korea",
  KR: "Sør-Korea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR Kina",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløyene",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesiaføderasjonen",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Ny-Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkøya",
  MK: "Nord-Makedonia",
  MP: "Nord-Marianene",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Det palestinske området",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PN: "Pitcairnøyene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  SH: "St. Helena",
  KN: "Saint Kitts og Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "St. Vincent og Grenadinene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonøyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  ES: "Spania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Sveits",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Øst-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "De forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UM: "USAs ytre øyer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "De britiske jomfruøyene",
  VI: "De amerikanske jomfruøyene",
  WF: "Wallis og Futuna",
  EH: "Vest-Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibisk Nederland",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sør-Sudan",
  XK: "Kosovo"
}, Qg = {
  locale: U0,
  countries: Z0
}, qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Z0,
  default: Qg,
  locale: U0
}, Symbol.toStringTag, { value: "Module" })), Y0 = "pl", W0 = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algieria",
  AS: "Samoa Amerykańskie",
  AD: "Andora",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktyka",
  AG: "Antigua i Barbuda",
  AR: "Argentyna",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbejdżan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladesz",
  BB: "Barbados",
  BY: "Białoruś",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhutan",
  BO: "Boliwia",
  BA: "Bośnia i Hercegowina",
  BW: "Botswana",
  BV: "Wyspa Bouveta",
  BR: "Brazylia",
  IO: "Brytyjskie Terytorium Oceanu Indyjskiego",
  BN: "Brunei",
  BG: "Bułgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodża",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Republika Zielonego Przylądka",
  KY: "Kajmany",
  CF: "Republika Środkowoafrykańska",
  TD: "Czad",
  CL: "Chile",
  CN: "Chiny",
  CX: "Wyspa Bożego Narodzenia",
  CC: "Wyspy Kokosowe",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Kongo",
  CD: "Demokratyczna Republika Konga",
  CK: "Wyspy Cooka",
  CR: "Kostaryka",
  CI: "Wybrzeże Kości Słoniowej",
  HR: "Chorwacja",
  CU: "Kuba",
  CY: "Cypr",
  CZ: "Czechy",
  DK: "Dania",
  DJ: "Dżibuti",
  DM: "Dominika",
  DO: "Dominikana",
  EC: "Ekwador",
  EG: "Egipt",
  SV: "Salwador",
  GQ: "Gwinea Równikowa",
  ER: "Erytrea",
  EE: "Estonia",
  ET: "Etiopia",
  FK: "Falklandy",
  FO: "Wyspy Owcze",
  FJ: "Fidżi",
  FI: "Finlandia",
  FR: "Francja",
  GF: "Gujana Francuska",
  PF: "Polinezja Francuska",
  TF: "Francuskie Terytoria Południowe i Antarktyczne",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzja",
  DE: "Niemcy",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecja",
  GL: "Grenlandia",
  GD: "Grenada",
  GP: "Gwadelupa",
  GU: "Guam",
  GT: "Gwatemala",
  GN: "Gwinea",
  GW: "Gwinea Bissau",
  GY: "Gujana",
  HT: "Haiti",
  HM: "Wyspy Heard i McDonalda",
  VA: "Watykan",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Węgry",
  IS: "Islandia",
  IN: "Indie",
  ID: "Indonezja",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Izrael",
  IT: "Włochy",
  JM: "Jamajka",
  JP: "Japonia",
  JO: "Jordania",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea Północna",
  KR: "Korea Południowa",
  KW: "Kuwejt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Łotwa",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Litwa",
  LU: "Luksemburg",
  MO: "Makau",
  MK: "Macedonia Północna",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malezja",
  MV: "Malediwy",
  ML: "Mali",
  MT: "Malta",
  MH: "Wyspy Marshalla",
  MQ: "Martynika",
  MR: "Mauretania",
  MU: "Mauritius",
  YT: "Majotta",
  MX: "Meksyk",
  FM: "Mikronezja",
  MD: "Mołdawia",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanma",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandia",
  NC: "Nowa Kaledonia",
  NZ: "Nowa Zelandia",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Mariany Północne",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestyna",
  PA: "Panama",
  PG: "Papua-Nowa Gwinea",
  PY: "Paragwaj",
  PE: "Peru",
  PH: "Filipiny",
  PN: "Pitcairn",
  PL: "Polska",
  PT: "Portugalia",
  PR: "Portoryko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumunia",
  RU: "Rosja",
  RW: "Rwanda",
  SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
  KN: "Saint Kitts i Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre i Miquelon",
  VC: "Saint Vincent i Grenadyny",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Wyspy Świętego Tomasza i Książęca",
  SA: "Arabia Saudyjska",
  SN: "Senegal",
  SC: "Seszele",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Słowacja",
  SI: "Słowenia",
  SB: "Wyspy Salomona",
  SO: "Somalia",
  ZA: "Południowa Afryka",
  GS: "Georgia Południowa i Sandwich Południowy",
  ES: "Hiszpania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard i Jan Mayen",
  SZ: "Eswatini",
  SE: "Szwecja",
  CH: "Szwajcaria",
  SY: "Syria",
  TW: "Tajwan",
  TJ: "Tadżykistan",
  TZ: "Tanzania",
  TH: "Tajlandia",
  TL: "Timor Wschodni",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trynidad i Tobago",
  TN: "Tunezja",
  TR: "Turcja",
  TM: "Turkmenistan",
  TC: "Turks i Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Zjednoczone Emiraty Arabskie",
  GB: "Wielka Brytania",
  US: "Stany Zjednoczone",
  UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  UY: "Urugwaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Wenezuela",
  VN: "Wietnam",
  VG: "Brytyjskie Wyspy Dziewicze",
  VI: "Wyspy Dziewicze Stanów Zjednoczonych",
  WF: "Wallis i Futuna",
  EH: "Sahara Zachodnia",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Wyspy Alandzkie",
  BQ: "Bonaire, Sint Eustatius i Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Wyspa Man",
  JE: "Jersey",
  ME: "Czarnogóra",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sudan Południowy",
  XK: "Kosowo"
}, Xg = {
  locale: Y0,
  countries: W0
}, eC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: W0,
  default: Xg,
  locale: Y0
}, Symbol.toStringTag, { value: "Module" })), $0 = "pt", J0 = {
  AF: "Afeganistão",
  ZA: "África do Sul",
  AL: "Albânia",
  DE: "Alemanha",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antígua e Barbuda",
  SA: "Arábia Saudita",
  DZ: "Argélia",
  AR: "Argentina",
  AM: "Arménia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benim",
  BM: "Bermudas",
  BY: "Bielorrússia",
  BO: "Bolívia",
  BA: "Bósnia-Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  BT: "Butão",
  CV: "Cabo Verde",
  KH: "Camboja",
  CA: "Canadá",
  QA: "Qatar",
  KZ: "Cazaquistão",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CY: "Chipre",
  VA: "Santa Sé",
  SG: "Singapura",
  CO: "Colômbia",
  KM: "Comores",
  CG: "República Democrática do Congo",
  CD: "República Popular do Congo",
  KP: "Coreia do Norte",
  KR: "Coreia do Sul",
  CI: "Costa do Marfim",
  CR: "Costa Rica",
  HR: "Croácia",
  CU: "Cuba",
  CW: "Curaçao",
  DK: "Dinamarca",
  DJ: "Djibouti",
  DM: "Dominica",
  EG: "Egito",
  SV: "El Salvador",
  AE: "Emirados Árabes Unidos",
  EC: "Equador",
  ER: "Eritreia",
  SK: "Eslováquia",
  SI: "Eslovénia",
  ES: "Espanha",
  US: [
    "Estados Unidos",
    "Estados Unidos da América"
  ],
  EE: "Estónia",
  ET: "Etiópia",
  FJ: "Fiji",
  PH: "Filipinas",
  FI: "Finlândia",
  FR: "França",
  GA: "Gabão",
  GM: "Gâmbia",
  GH: "Gana",
  GE: "Geórgia",
  GS: "Geórgia do Sul e Ilhas Sandwich do Sul",
  GI: "Gibraltar",
  GD: "Granada",
  GR: "Grécia",
  GL: "Gronelândia",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GY: "Guiana",
  GF: "Guiana Francesa",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GQ: "Guiné Equatorial",
  HT: "Haiti",
  NL: "Países Baixos",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungria",
  YE: "Iémen",
  BV: "Ilha Bouvet",
  CX: "Ilha de Natal",
  IM: "Ilha de Man",
  NF: "Ilha Norfolk",
  AX: "Ilhas Åland",
  KY: "Ilhas Caimão",
  CC: "Ilhas Cocos (Keeling)",
  CK: "Ilhas Cook",
  UM: "Ilhas Distantes dos EUA",
  HM: "Ilha Heard e Ilhas McDonald",
  FO: "Ilhas Faroé",
  FK: "Ilhas Malvinas",
  MP: "Ilhas Marianas do Norte",
  MH: "Ilhas Marshall",
  PN: "Ilhas Pitcairn",
  SB: "Ilhas Salomão",
  TC: "Ilhas Turcas e Caicos",
  VG: "Ilhas Virgens Britânicas",
  VI: "Ilhas Virgens Americanas",
  IN: "Índia",
  ID: "Indonésia",
  IR: "Irão",
  IQ: "Iraque",
  IE: "Irlanda",
  IS: "Islândia",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KW: "Koweit",
  LA: "Laos",
  LS: "Lesoto",
  LV: "Letónia",
  LB: "Líbano",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau",
  MK: "Macedónia do Norte",
  MG: "Madagáscar",
  MY: "Malásia",
  MW: "Maláui",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MA: "Marrocos",
  MQ: "Martinica",
  MU: "Maurícia",
  MR: "Mauritânia",
  YT: "Mayotte",
  MX: "México",
  MM: "Mianmar (Birmânia)",
  FM: "Micronésia",
  MZ: "Moçambique",
  MD: "Moldávia",
  MC: "Mónaco",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Monserrate",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepal",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NU: "Niue",
  NO: "Noruega",
  NC: "Nova Caledónia",
  NZ: "Nova Zelândia",
  OM: "Omã",
  BQ: "Países Baixos Caribenhos",
  PW: "Palau",
  PA: "Panamá",
  PG: "Papua-Nova Guiné",
  PK: "Paquistão",
  PY: "Paraguai",
  PE: "Peru",
  PF: "Polinésia Francesa",
  PL: "Polónia",
  PR: "Porto Rico",
  PT: "Portugal",
  KE: "Quénia",
  KG: "Quirguistão",
  KI: "Quiribati",
  GB: "Reino Unido",
  CF: "República Centro-Africana",
  DO: "República Dominicana",
  CM: "Camarões",
  CZ: "Chéquia",
  RE: "Reunião",
  RO: "Roménia",
  RW: "Ruanda",
  RU: "Rússia",
  EH: "Saara Ocidental",
  PM: "Saint Pierre e Miquelon",
  WS: "Samoa",
  AS: "Samoa Americana",
  SM: "San Marino",
  SH: "Santa Helena",
  LC: "Santa Lúcia",
  BL: "São Bartolomeu",
  KN: "São Cristóvão e Neves",
  MF: "São Martinho",
  ST: "São Tomé e Príncipe",
  VC: "São Vicente e Granadinas",
  SN: "Senegal",
  SL: "Serra Leoa",
  RS: "Sérvia",
  SC: "Seychelles",
  SX: "São Martinho",
  SY: "Síria",
  SO: "Somália",
  LK: "Sri Lanka",
  SZ: "Essuatíni",
  SD: "Sudão",
  SS: "Sudão do Sul",
  SE: "Suécia",
  CH: "Suíça",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  TH: "Tailândia",
  TW: "Taiwan",
  TJ: "Tajiquistão",
  TZ: "Tanzânia",
  IO: "Território Britânico do Oceano Índico",
  TF: "Terras Austrais e Antárticas Francesas",
  PS: "Territórios palestinos",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trindade e Tobago",
  TN: "Tunísia",
  TM: "Turquemenistão",
  TR: "Turquia",
  TV: "Tuvalu",
  UA: "Ucrânia",
  UG: "Uganda",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietname",
  WF: "Wallis e Futuna",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
  XK: "Kosovo"
}, tC = {
  locale: $0,
  countries: J0
}, nC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: J0,
  default: tC,
  locale: $0
}, Symbol.toStringTag, { value: "Module" })), Q0 = "ro", q0 = {
  AD: "Andorra",
  AE: "Emiratele Arabe Unite",
  AF: "Afganistan",
  AG: "Antigua și Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "Samoa Americană",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Insulele Åland",
  AZ: "Azerbaidjan",
  BA: "Bosnia și Herțegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgia",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Sfântul Bartolomeu",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Insulele Caraibe Olandeze",
  BR: "Brazilia",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Insula Bouvet",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Insulele Cocos (Keeling)",
  CD: "Congo - Kinshasa",
  CF: "Republica Centrafricană",
  CG: "Congo - Brazzaville",
  CH: "Elveția",
  CI: "Côte d’Ivoire",
  CK: "Insulele Cook",
  CL: "Chile",
  CM: "Camerun",
  CN: "China",
  CO: "Columbia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capul Verde",
  CW: "Curaçao",
  CX: "Insula Christmas",
  CY: "Cipru",
  CZ: "Cehia",
  DE: "Germania",
  DJ: "Djibouti",
  DK: "Danemarca",
  DM: "Dominica",
  DO: "Republica Dominicană",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egipt",
  EH: "Sahara Occidentală",
  ER: "Eritreea",
  ES: "Spania",
  ET: "Etiopia",
  FI: "Finlanda",
  FJ: "Fiji",
  FK: "Insulele Falkland",
  FM: "Micronezia",
  FO: "Insulele Feroe",
  FR: "Franța",
  GA: "Gabon",
  GB: "Regatul Unit",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Franceză",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenlanda",
  GM: "Gambia",
  GN: "Guineea",
  GP: "Guadelupa",
  GQ: "Guineea Ecuatorială",
  GR: "Grecia",
  GS: "Georgia de Sud și Insulele Sandwich de Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guineea-Bissau",
  GY: "Guyana",
  HK: "R.A.S. Hong Kong a Chinei",
  HM: "Insula Heard și Insulele McDonald",
  HN: "Honduras",
  HR: "Croația",
  HT: "Haiti",
  HU: "Ungaria",
  ID: "Indonezia",
  IE: "Irlanda",
  IL: "Israel",
  IM: "Insula Man",
  IN: "India",
  IO: "Teritoriul Britanic din Oceanul Indian",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Iordania",
  JP: "Japonia",
  KE: "Kenya",
  KG: "Kârgâzstan",
  KH: "Cambodgia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts și Nevis",
  KP: "Coreea de Nord",
  KR: "Coreea de Sud",
  KW: "Kuweit",
  KY: "Insulele Cayman",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Liban",
  LC: "Sfânta Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Luxemburg",
  LV: "Letonia",
  LY: "Libia",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Republica Moldova",
  ME: "Muntenegru",
  MF: "Sfântul Martin",
  MG: "Madagascar",
  MH: "Insulele Marshall",
  MK: "Macedonia de Nord",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "R.A.S. Macao a Chinei",
  MP: "Insulele Mariane de Nord",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Mexic",
  MY: "Malaysia",
  MZ: "Mozambic",
  NA: "Namibia",
  NC: "Noua Caledonie",
  NE: "Niger",
  NF: "Insula Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Țările de Jos",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Noua Zeelandă",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Polinezia Franceză",
  PG: "Papua-Noua Guinee",
  PH: "Filipine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint-Pierre și Miquelon",
  PN: "Insulele Pitcairn",
  PR: "Puerto Rico",
  PS: "Teritoriile Palestiniene",
  PT: "Portugalia",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "România",
  RS: "Serbia",
  RU: "Rusia",
  RW: "Rwanda",
  SA: "Arabia Saudită",
  SB: "Insulele Solomon",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Suedia",
  SG: "Singapore",
  SH: "Sfânta Elena",
  SI: "Slovenia",
  SJ: "Svalbard și Jan Mayen",
  SK: "Slovacia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudanul de Sud",
  ST: "Sao Tomé și Príncipe",
  SV: "El Salvador",
  SX: "Sint-Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Insulele Turks și Caicos",
  TD: "Ciad",
  TF: "Teritoriile Australe și Antarctice Franceze",
  TG: "Togo",
  TH: "Thailanda",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timorul de Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turcia",
  TT: "Trinidad și Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Insulele Îndepărtate ale S.U.A.",
  US: "Statele Unite ale Americii",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Statul Cetății Vaticanului",
  VC: "Saint Vincent și Grenadinele",
  VE: "Venezuela",
  VG: "Insulele Virgine Britanice",
  VI: "Insulele Virgine Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis și Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Africa de Sud",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, aC = {
  locale: Q0,
  countries: q0
}, rC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: q0,
  default: aC,
  locale: Q0
}, Symbol.toStringTag, { value: "Module" })), X0 = "ru", e5 = {
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  AX: "Аландские острова",
  AL: "Албания",
  DZ: "Алжир",
  VI: "Виргинские Острова (США)",
  AS: "Американское Самоа",
  AI: "Ангилья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктида",
  AG: "Антигуа и Барбуда",
  AR: "Аргентина",
  AM: "Армения",
  AW: "Аруба",
  AF: "Афганистан",
  BS: "Багамы",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Белиз",
  BY: "Беларусь",
  BE: "Бельгия",
  BJ: "Бенин",
  BM: "Бермуды",
  BG: "Болгария",
  BO: "Боливия",
  BQ: "Бонэйр, Синт-Эстатиус и Саба",
  BA: "Босния и Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  IO: "Британская территория в Индийском океане",
  VG: "Виргинские Острова (Великобритания)",
  BN: "Бруней",
  BF: "Буркина-Фасо",
  BI: "Бурунди",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобритания",
  HU: "Венгрия",
  VE: "Венесуэла",
  UM: "Внешние малые острова (США)",
  TL: "Восточный Тимор",
  VN: "Вьетнам",
  GA: "Габон",
  HT: "Гаити",
  GY: "Гайана",
  GM: "Гамбия",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвиана",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  DE: "Германия",
  GG: "Гернси",
  GI: "Гибралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GL: "Гренландия",
  GR: "Греция",
  GE: "Грузия",
  GU: "Гуам",
  DK: "Дания",
  JE: "Джерси",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканская Республика",
  CD: "Демократическая Республика Конго",
  EG: "Египет",
  ZM: "Замбия",
  EH: "САДР",
  ZW: "Зимбабве",
  IL: "Израиль",
  IN: "Индия",
  ID: "Индонезия",
  JO: "Иордания",
  IQ: "Ирак",
  IR: "Иран",
  IE: "Ирландия",
  IS: "Исландия",
  ES: "Испания",
  IT: "Италия",
  YE: "Йемен",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Острова Кайман",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  QA: "Катар",
  KE: "Кения",
  CY: "Кипр",
  KG: "Киргизия",
  KI: "Кирибати",
  TW: [
    "Тайвань",
    "Китайская Республика"
  ],
  KP: "КНДР (Корейская Народно-Демократическая Республика)",
  CN: "КНР (Китайская Народная Республика)",
  CC: "Кокосовые острова",
  CO: "Колумбия",
  KM: "Коморы",
  CR: "Коста-Рика",
  CI: "Кот-д’Ивуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвия",
  LS: "Лесото",
  LR: "Либерия",
  LB: "Ливан",
  LY: "Ливия",
  LT: "Литва",
  LI: "Лихтенштейн",
  LU: "Люксембург",
  MU: "Маврикий",
  MR: "Мавритания",
  MG: "Мадагаскар",
  YT: "Майотта",
  MO: "Макао",
  MW: "Малави",
  MY: "Малайзия",
  ML: "Мали",
  MV: "Мальдивы",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиника",
  MH: "Маршалловы Острова",
  MX: "Мексика",
  FM: "Микронезия",
  MZ: "Мозамбик",
  MD: "Молдавия",
  MC: "Монако",
  MN: "Монголия",
  MS: "Монтсеррат",
  MM: "Мьянма",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NE: "Нигер",
  NG: "Нигерия",
  NL: "Нидерланды",
  NI: "Никарагуа",
  NU: "Ниуэ",
  NZ: "Новая Зеландия",
  NC: "Новая Каледония",
  NO: "Норвегия",
  AE: "ОАЭ",
  OM: "Оман",
  BV: "Остров Буве",
  IM: "Остров Мэн",
  CK: "Острова Кука",
  NF: "Остров Норфолк",
  CX: "Остров Рождества",
  PN: "Острова Питкэрн",
  SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Государство Палестина",
  PA: "Панама",
  PG: "Папуа — Новая Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PL: "Польша",
  PT: "Португалия",
  PR: "Пуэрто-Рико",
  CG: "Республика Конго",
  KR: "Республика Корея",
  RE: "Реюньон",
  RU: [
    "Российская Федерация",
    "Россия"
  ],
  RW: "Руанда",
  RO: "Румыния",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе и Принсипи",
  SA: "Саудовская Аравия",
  SZ: "Эсватини",
  MK: "Северная Македония",
  MP: "Северные Марианские Острова",
  SC: "Сейшельские Острова",
  BL: "Сен-Бартелеми",
  MF: "Сен-Мартен",
  PM: "Сен-Пьер и Микелон",
  SN: "Сенегал",
  VC: "Сент-Винсент и Гренадины",
  KN: "Сент-Китс и Невис",
  LC: "Сент-Люсия",
  RS: "Сербия",
  SG: "Сингапур",
  SX: "Синт-Мартен",
  SY: "Сирия",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломоновы Острова",
  SO: "Сомали",
  SD: "Судан",
  SR: "Суринам",
  US: "США",
  SL: "Сьерра-Леоне",
  TJ: "Таджикистан",
  TH: "Таиланд",
  TZ: "Танзания",
  TC: "Теркс и Кайкос",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TN: "Тунис",
  TM: "Туркмения",
  TR: "Турция",
  UG: "Уганда",
  UZ: "Узбекистан",
  UA: "Украина",
  WF: "Уоллис и Футуна",
  UY: "Уругвай",
  FO: "Фареры",
  FJ: "Фиджи",
  PH: "Филиппины",
  FI: "Финляндия",
  FK: "Фолклендские острова",
  FR: "Франция",
  PF: "Французская Полинезия",
  TF: "Французские Южные и Антарктические Территории",
  HM: "Херд и Макдональд",
  HR: "Хорватия",
  CF: "ЦАР",
  TD: "Чад",
  ME: "Черногория",
  CZ: "Чехия",
  CL: "Чили",
  CH: "Швейцария",
  SE: "Швеция",
  SJ: "Шпицберген и Ян-Майен",
  LK: "Шри-Ланка",
  EC: "Эквадор",
  GQ: "Экваториальная Гвинея",
  ER: "Эритрея",
  EE: "Эстония",
  ET: "Эфиопия",
  ZA: "ЮАР",
  GS: "Южная Георгия и Южные Сандвичевы Острова",
  SS: "Южный Судан",
  JM: "Ямайка",
  JP: "Япония",
  XK: "Косово"
}, iC = {
  locale: X0,
  countries: e5
}, oC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: e5,
  default: iC,
  locale: X0
}, Symbol.toStringTag, { value: "Module" })), t5 = "sk", n5 = {
  AD: "Andorra",
  AE: "Spojené arabské emiráty",
  AF: "Afganistan",
  AG: "Antigua a Barbuda",
  AI: "Anguilla",
  AL: "Albánsko",
  AM: "Arménsko",
  AO: "Angola",
  AQ: "Antarktída",
  AR: "Argentína",
  AS: "Americká Samoa",
  AT: "Rakúsko",
  AU: "Austrália",
  AW: "Aruba",
  AX: "Alandy",
  AZ: "Azerbajdžan",
  BA: "Bosna a Hercegovina",
  BB: "Barbados",
  BD: "Bangladéš",
  BE: "Belgicko",
  BF: "Burkina Faso",
  BG: "Bulharsko",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Svätý Bartolomej",
  BM: "Bermudy",
  BN: "Brunej",
  BO: "Bolívia",
  BQ: "Karibské Holandsko",
  BR: "Brazília",
  BS: "Bahamy",
  BT: "Bhután",
  BV: "Bouvetov ostrov",
  BW: "Botswana",
  BY: "Bielorusko",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosové ostrovy",
  CD: "Konžská demokratická republika",
  CF: "Stredoafrická republika",
  CG: "Konžská republika",
  CH: "Švajčiarsko",
  CI: "Pobrežie Slonoviny",
  CK: "Cookove ostrovy",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Čína",
  CO: "Kolumbia",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Kapverdy",
  CW: "Curaçao",
  CX: "Vianočný ostrov",
  CY: "Cyprus",
  CZ: "Česko",
  DE: "Nemecko",
  DJ: "Džibutsko",
  DK: "Dánsko",
  DM: "Dominika",
  DO: "Dominikánska republika",
  DZ: "Alžírsko",
  EC: "Ekvádor",
  EE: "Estónsko",
  EG: "Egypt",
  EH: "Západná Sahara",
  ER: "Eritrea",
  ES: "Španielsko",
  ET: "Etiópia",
  FI: "Fínsko",
  FJ: "Fidži",
  FK: "Falklandy",
  FM: "Mikronézia",
  FO: "Faerské ostrovy",
  FR: "Francúzsko",
  GA: "Gabon",
  GB: "Spojené kráľovstvo",
  GD: "Grenada",
  GE: "Gruzínsko",
  GF: "Francúzska Guayana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltár",
  GL: "Grónsko",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Rovníková Guinea",
  GR: "Grécko",
  GS: "Južná Georgia a Južné Sandwichove ostrovy",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guayana",
  HK: "Hongkong – OAO Číny",
  HM: "Heardov ostrov a Macdonaldove ostrovy",
  HN: "Honduras",
  HR: "Chorvátsko",
  HT: "Haiti",
  HU: "Maďarsko",
  ID: "Indonézia",
  IE: "Írsko",
  IL: "Izrael",
  IM: "Ostrov Man",
  IN: "India",
  IO: "Britské indickooceánske územie",
  IQ: "Irak",
  IR: "Irán",
  IS: "Island",
  IT: "Taliansko",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordánsko",
  JP: "Japonsko",
  KE: "Keňa",
  KG: "Kirgizsko",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komory",
  KN: "Svätý Krištof a Nevis",
  KP: "Severná Kórea",
  KR: "Južná Kórea",
  KW: "Kuvajt",
  KY: "Kajmanie ostrovy",
  KZ: "Kazachstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Svätá Lucia",
  LI: "Lichtenštajnsko",
  LK: "Srí Lanka",
  LR: "Libéria",
  LS: "Lesotho",
  LT: "Litva",
  LU: "Luxembursko",
  LV: "Lotyšsko",
  LY: "Líbya",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavsko",
  ME: "Čierna Hora",
  MF: "Svätý Martin (fr.)",
  MG: "Madagaskar",
  MH: "Marshallove ostrovy",
  MK: "Severné Macedónsko",
  ML: "Mali",
  MM: "Mjanmarsko",
  MN: "Mongolsko",
  MO: "Macao – OAO Číny",
  MP: "Severné Mariány",
  MQ: "Martinik",
  MR: "Mauritánia",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Maurícius",
  MV: "Maldivy",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malajzia",
  MZ: "Mozambik",
  NA: "Namíbia",
  NC: "Nová Kaledónia",
  NE: "Niger",
  NF: "Norfolk",
  NG: "Nigéria",
  NI: "Nikaragua",
  NL: "Holandsko",
  NO: "Nórsko",
  NP: "Nepál",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nový Zéland",
  OM: "Omán",
  PA: "Panama",
  PE: "Peru",
  PF: "Francúzska Polynézia",
  PG: "Papua Nová Guinea",
  PH: "Filipíny",
  PK: "Pakistan",
  PL: "Poľsko",
  PM: "Saint Pierre a Miquelon",
  PN: "Pitcairnove ostrovy",
  PR: "Portoriko",
  PS: "Palestínske územia",
  PT: "Portugalsko",
  PW: "Palau",
  PY: "Paraguaj",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumunsko",
  RS: "Srbsko",
  RU: "Rusko",
  RW: "Rwanda",
  SA: "Saudská Arábia",
  SB: "Šalamúnove ostrovy",
  SC: "Seychely",
  SD: "Sudán",
  SE: "Švédsko",
  SG: "Singapur",
  SH: "Svätá Helena",
  SI: "Slovinsko",
  SJ: "Svalbard a Jan Mayen",
  SK: "Slovensko",
  SL: "Sierra Leone",
  SM: "San Maríno",
  SN: "Senegal",
  SO: "Somálsko",
  SR: "Surinam",
  SS: "Južný Sudán",
  ST: "Svätý Tomáš a Princov ostrov",
  SV: "Salvádor",
  SX: "Svätý Martin (hol.)",
  SY: "Sýria",
  SZ: "Svazijsko",
  TC: "Turks a Caicos",
  TD: "Čad",
  TF: "Francúzske južné a antarktické územia",
  TG: "Togo",
  TH: "Thajsko",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Východný Timor",
  TM: "Turkménsko",
  TN: "Tunisko",
  TO: "Tonga",
  TR: "Turecko",
  TT: "Trinidad a Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzánia",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Menšie odľahlé ostrovy USA",
  US: "Spojené štáty",
  UY: "Uruguaj",
  UZ: "Uzbekistan",
  VA: "Vatikán",
  VC: "Svätý Vincent a Grenadíny",
  VE: "Venezuela",
  VG: "Britské Panenské ostrovy",
  VI: "Americké Panenské ostrovy",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis a Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južná Afrika",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, sC = {
  locale: t5,
  countries: n5
}, lC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: n5,
  default: sC,
  locale: t5
}, Symbol.toStringTag, { value: "Module" })), a5 = "sl", r5 = {
  AD: "Andora",
  AE: "Združeni arabski emirati",
  AF: "Afganistan",
  AG: "Antigva in Barbuda",
  AI: "Angvila",
  AL: "Albanija",
  AM: "Armenija",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Argentina",
  AS: "Ameriška Samoa",
  AT: "Avstrija",
  AU: "Avstralija",
  AW: "Aruba",
  AX: "Ålandski otoki",
  AZ: "Azerbajdžan",
  BA: "Bosna in Hercegovina",
  BB: "Barbados",
  BD: "Bangladeš",
  BE: "Belgija",
  BF: "Burkina Faso",
  BG: "Bolgarija",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermudi",
  BN: "Brunej",
  BO: "Bolivija",
  BQ: "Nizozemski Karibi",
  BR: "Brazilija",
  BS: "Bahami",
  BT: "Butan",
  BV: "Bouvetov otok",
  BW: "Bocvana",
  BY: "Belorusija",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosovi otoki",
  CD: "Demokratična republika Kongo",
  CF: "Centralnoafriška republika",
  CG: "Kongo - Brazzaville",
  CH: "Švica",
  CI: "Slonokoščena obala",
  CK: "Cookovi otoki",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Kitajska",
  CO: "Kolumbija",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Zelenortski otoki",
  CW: "Curaçao",
  CX: "Božični otok",
  CY: "Ciper",
  CZ: "Češka",
  DE: "Nemčija",
  DJ: "Džibuti",
  DK: "Danska",
  DM: "Dominika",
  DO: "Dominikanska republika",
  DZ: "Alžirija",
  EC: "Ekvador",
  EE: "Estonija",
  EG: "Egipt",
  EH: "Zahodna Sahara",
  ER: "Eritreja",
  ES: "Španija",
  ET: "Etiopija",
  FI: "Finska",
  FJ: "Fidži",
  FK: "Falklandski otoki",
  FM: "Mikronezija",
  FO: "Ferski otoki",
  FR: "Francija",
  GA: "Gabon",
  GB: "Združeno kraljestvo",
  GD: "Grenada",
  GE: "Gruzija",
  GF: "Francoska Gvajana",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Gibraltar",
  GL: "Grenlandija",
  GM: "Gambija",
  GN: "Gvineja",
  GP: "Gvadalupe",
  GQ: "Ekvatorialna Gvineja",
  GR: "Grčija",
  GS: "Južna Georgia in Južni Sandwichevi otoki",
  GT: "Gvatemala",
  GU: "Guam",
  GW: "Gvineja Bissau",
  GY: "Gvajana",
  HK: "Hongkong",
  HM: "Heardov otok in McDonaldovi otoki",
  HN: "Honduras",
  HR: "Hrvaška",
  HT: "Haiti",
  HU: "Madžarska",
  ID: "Indonezija",
  IE: "Irska",
  IL: "Izrael",
  IM: "Otok Man",
  IN: "Indija",
  IO: "Britansko ozemlje v Indijskem oceanu",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islandija",
  IT: "Italija",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordanija",
  JP: "Japonska",
  KE: "Kenija",
  KG: "Kirgizistan",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komori",
  KN: "Saint Kitts in Nevis",
  KP: "Severna Koreja",
  KR: "Južna Koreja",
  KW: "Kuvajt",
  KY: "Kajmanski otoki",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Lihtenštajn",
  LK: "Šrilanka",
  LR: "Liberija",
  LS: "Lesoto",
  LT: "Litva",
  LU: "Luksemburg",
  LV: "Latvija",
  LY: "Libija",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavija",
  ME: "Črna gora",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshallovi otoki",
  MK: "Severna Makedonija",
  ML: "Mali",
  MM: "Mjanmar (Burma)",
  MN: "Mongolija",
  MO: "Macao",
  MP: "Severni Marianski otoki",
  MQ: "Martinik",
  MR: "Mavretanija",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivi",
  MW: "Malavi",
  MX: "Mehika",
  MY: "Malezija",
  MZ: "Mozambik",
  NA: "Namibija",
  NC: "Nova Kaledonija",
  NE: "Niger",
  NF: "Norfolški otok",
  NG: "Nigerija",
  NI: "Nikaragva",
  NL: "Nizozemska",
  NO: "Norveška",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nova Zelandija",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Francoska Polinezija",
  PG: "Papua Nova Gvineja",
  PH: "Filipini",
  PK: "Pakistan",
  PL: "Poljska",
  PM: "Saint Pierre in Miquelon",
  PN: "Pitcairn",
  PR: "Portoriko",
  PS: "Palestinsko ozemlje",
  PT: "Portugalska",
  PW: "Palau",
  PY: "Paragvaj",
  QA: "Katar",
  RE: "Reunion",
  RO: "Romunija",
  RS: "Srbija",
  RU: "Rusija",
  RW: "Ruanda",
  SA: "Saudova Arabija",
  SB: "Salomonovi otoki",
  SC: "Sejšeli",
  SD: "Sudan",
  SE: "Švedska",
  SG: "Singapur",
  SH: "Sveta Helena",
  SI: "Slovenija",
  SJ: "Svalbard in Jan Mayen",
  SK: "Slovaška",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalija",
  SR: "Surinam",
  SS: "Južni Sudan",
  ST: "Sao Tome in Principe",
  SV: "Salvador",
  SX: "Sint Maarten",
  SY: "Sirija",
  SZ: "Svazi",
  TC: "Otoki Turks in Caicos",
  TD: "Čad",
  TF: "Francosko južno ozemlje",
  TG: "Togo",
  TH: "Tajska",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunizija",
  TO: "Tonga",
  TR: "Turčija",
  TT: "Trinidad in Tobago",
  TV: "Tuvalu",
  TW: "Tajvan",
  TZ: "Tanzanija",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Stranski zunanji otoki Združenih držav",
  US: "Združene države Amerike",
  UY: "Urugvaj",
  UZ: "Uzbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent in Grenadine",
  VE: "Venezuela",
  VG: "Britanski Deviški otoki",
  VI: "Ameriški Deviški otoki",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis in Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južnoafriška republika",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, uC = {
  locale: a5,
  countries: r5
}, cC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: r5,
  default: uC,
  locale: a5
}, Symbol.toStringTag, { value: "Module" })), i5 = "sq", o5 = {
  AF: "Afganistan",
  AL: "Shqipëri",
  DZ: "Algjeri",
  AS: "Samoa Amerikane",
  AD: "Andorrë",
  AO: "Angolë",
  AI: "Anguilë",
  AQ: "Antarktidë",
  AG: "Antigua & Barbuda",
  AR: "Argjentinë",
  AM: "Armeni",
  AW: "Arubë",
  AU: "Australi",
  AT: "Austri",
  AZ: "Azerbajxhan",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bjellorusi",
  BE: "Belgjikë",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Butan",
  BO: "Bolivi",
  BA: "Bosnjë & Hercegovinë",
  BW: "Botsvanë",
  BV: "Ishulli Buve",
  BR: "Brazil",
  IO: "Territori Britanik i Oqeanit Indian",
  BN: "Brunej",
  BG: "Bullgari",
  BF: "Burkina Faso",
  BI: "Burund",
  KH: "Kamboxhia",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kepi i Gjelbër",
  KY: "Ishujt Kajman",
  CF: "Republika Afrikano-Qendrore",
  TD: "Çad",
  CL: "Kili",
  CN: "Kinë",
  CX: "Ishulli i Krishtlindjes",
  CC: "Ishujt Kokos (Kiling)",
  CO: "Kolumbi",
  KM: "Komore",
  CG: "Kongo-Brazavil",
  CD: "Kongo-Kinshasa",
  CK: "Ishulli Kuk",
  CR: "Kosta Rikë",
  CI: "Bregu i Fildishtë",
  HR: "Kroaci",
  CU: "Kubë",
  CY: "Qipro",
  CZ: "Republika Çeke",
  DK: "Danimarkë",
  DJ: "Xhibut",
  DM: "Dominikë",
  DO: "Republika Dominikane",
  EC: "Ekuador",
  EG: "Egjipt",
  SV: "El Salvador",
  GQ: "Guineja Ekuatoriale",
  ER: "Eritre",
  EE: "Estoni",
  ET: "Etiopi",
  FK: "Ishujt Folkland",
  FO: "Ishujt Faroe",
  FJ: "Fixhi",
  FI: "Finlandë",
  FR: "Francë",
  GF: "Guajana Frënge",
  PF: "Polinezia Frënge",
  TF: "Territoret Frënge Jugore",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gjeorgji",
  DE: "Gjermani",
  GH: "Gana",
  GI: "Gjibraltar",
  GR: "Greqi",
  GL: "Groenlandë",
  GD: "Grenadë",
  GP: "Guadalup",
  GU: "Guam",
  GT: "Guatemalë",
  GN: "Guine",
  GW: "Guinea-Bisau",
  GY: "Guajanë",
  HT: "Haiti",
  HM: "Ishujt Hërd & Mekdonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "RVA i Hong Kongut Kinë",
  HU: "Hungari",
  IS: "Islandë",
  IN: "Indi",
  ID: "Indonezi",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandë",
  IL: "Izrael",
  IT: "Itali",
  JM: "Xhamajkë",
  JP: "Japoni",
  JO: "Jordani",
  KZ: "Kazakistan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Koreja e Veriut",
  KR: "Koreja e Jugut",
  KW: "Kuvajt",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letoni",
  LB: "Liban",
  LS: "Lesoto",
  LR: "Liberi",
  LY: "Libi",
  LI: "Lihtenshtein",
  LT: "Lituani",
  LU: "Luksemburg",
  MO: "RVA i Makaos Kinë",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malajzi",
  MV: "Maldive",
  ML: "Mali",
  MT: "Maltë",
  MH: "Ishujt Marshall",
  MQ: "Martinikë",
  MR: "Mauritani",
  MU: "Mauritius",
  YT: "Majote",
  MX: "Meksikë",
  FM: "Mikronezi",
  MD: "Moldavi",
  MC: "Monako",
  MN: "Mongoli",
  MS: "Montserat",
  MA: "Marok",
  MZ: "Mozambik",
  MM: "Mianmar (Burma)",
  NA: "Namibi",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandë",
  NC: "Kaledonia e Re",
  NZ: "Zelandë e Re",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeri",
  NU: "Niue",
  NF: "Ishujt Norfolk",
  MK: "Maqedoni",
  MP: "Ishujt Veriorë Mariana",
  NO: "Norvegji",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Territoret Palestineze",
  PA: "Panama",
  PG: "Papua Guineja e Re",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipine",
  PN: "Ishujt Pitkern",
  PL: "Poloni",
  PT: "Portugali",
  PR: "Porto Riko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumani",
  RU: "Rusi",
  RW: "Ruandë",
  SH: "Shën Helena",
  KN: "Shën Kits e Nevis",
  LC: "Shën Luçia",
  PM: "Shën Pier dhe Mikëlon",
  VC: "Shën Vinsent & Grenadinet",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome & Prinsipe",
  SA: "Arabi Saudite",
  SN: "Senegal",
  SC: "Sejshelle",
  SL: "Sierra Leone",
  SG: "Singapor",
  SK: "Sllovaki",
  SI: "Slloveni",
  SB: "Ishujt Solomon",
  SO: "Somali",
  ZA: "Afrikë e Jugut",
  GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut",
  ES: "Spanjë",
  LK: "Sri Lankë",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard & Zhan Majen",
  SZ: "Svaziland",
  SE: "Suedi",
  CH: "Zvicër",
  SY: "Siri",
  TW: "Tajvan",
  TJ: "Taxhikistan",
  TZ: "Tanzani",
  TH: "Tajlandë",
  TL: "Timori Lindor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad & Tobago",
  TN: "Tunizi",
  TR: "Turqi",
  TM: "Turkmenistan",
  TC: "Ishujt Turk & Kaikos",
  TV: "Tuvalu",
  UG: "Ugandë",
  UA: "Ukrainë",
  AE: "Emiratet e Bashkuara Arabe",
  GB: "Mbretëria e Bashkuar",
  US: "Shtetet e Bashkuara të Amerikës",
  UM: "Ishujt e Përtejmë SHBA-së",
  UY: "Uruguai",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuelë",
  VN: "Vietnam",
  VG: "Ishujt e Virgjër Britanikë",
  VI: "Ishujt e Virgjër Amerikanë",
  WF: "Uollis e Futuna",
  EH: "Sahara Perëndimore",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabve",
  AX: "Ishujt Aland",
  BQ: "Karaibet Holandeze",
  CW: "Kurasao",
  GG: "Gërnsi",
  IM: "Ishulli i Robit",
  JE: "Xhërsi",
  ME: "Mali i Zi",
  BL: "Shën Bartolomeo",
  MF: "Shën Martin",
  RS: "Serbi",
  SX: "Shën Martin",
  SS: "Sudan i Jugut",
  XK: "Kosovë"
}, dC = {
  locale: i5,
  countries: o5
}, pC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: o5,
  default: dC,
  locale: i5
}, Symbol.toStringTag, { value: "Module" })), s5 = "sr", l5 = {
  AD: "Андора",
  AE: "Уједињени Арапски Емирати",
  AF: "Авганистан",
  AG: "Антигва и Барбуда",
  AI: "Ангвила",
  AL: "Албанија",
  AM: "Јерменија",
  AO: "Ангола",
  AQ: "Антарктик",
  AR: "Аргентина",
  AS: "Америчка Самоа",
  AT: "Аустрија",
  AU: "Аустралија",
  AW: "Аруба",
  AX: "Оландска Острва",
  AZ: "Азербејџан",
  BA: "Босна и Херцеговина",
  BB: "Барбадос",
  BD: "Бангладеш",
  BE: "Белгија",
  BF: "Буркина Фасо",
  BG: "Бугарска",
  BH: "Бахреин",
  BI: "Бурунди",
  BJ: "Бенин",
  BL: "Сен Бартелеми",
  BM: "Бермуда",
  BN: "Брунеј",
  BO: "Боливија",
  BQ: "Карипска Холандија",
  BR: "Бразил",
  BS: "Бахами",
  BT: "Бутан",
  BV: "Острво Буве",
  BW: "Боцвана",
  BY: "Белорусија",
  BZ: "Белизе",
  CA: "Канада",
  CC: "Кокосова (Килингова) Острва",
  CD: "Конго - Киншаса",
  CF: "Централноафричка Република",
  CG: "Конго - Бразавил",
  CH: "Швајцарска",
  CI: "Обала Слоноваче",
  CK: "Кукова Острва",
  CL: "Чиле",
  CM: "Камерун",
  CN: "Кина",
  CO: "Колумбија",
  CR: "Костарика",
  CU: "Куба",
  CV: "Зеленортска Острва",
  CW: "Курасао",
  CX: "Божићно Острво",
  CY: "Кипар",
  CZ: "Чешка",
  DE: "Немачка",
  DJ: "Џибути",
  DK: "Данска",
  DM: "Доминика",
  DO: "Доминиканска Република",
  DZ: "Алжир",
  EC: "Еквадор",
  EE: "Естонија",
  EG: "Египат",
  EH: "Западна Сахара",
  ER: "Еритреја",
  ES: "Шпанија",
  ET: "Етиопија",
  FI: "Финска",
  FJ: "Фиџи",
  FK: "Фокландска Острва",
  FM: "Микронезија",
  FO: "Фарска Острва",
  FR: "Француска",
  GA: "Габон",
  GB: "Уједињено Краљевство",
  GD: "Гренада",
  GE: "Грузија",
  GF: "Француска Гвајана",
  GG: "Гернзи",
  GH: "Гана",
  GI: "Гибралтар",
  GL: "Гренланд",
  GM: "Гамбија",
  GN: "Гвинеја",
  GP: "Гваделуп",
  GQ: "Екваторијална Гвинеја",
  GR: "Грчка",
  GS: "Јужна Џорџија и Јужна Сендвичка Острва",
  GT: "Гватемала",
  GU: "Гуам",
  GW: "Гвинеја-Бисао",
  GY: "Гвајана",
  HK: "САР Хонгконг (Кина)",
  HM: "Острво Херд и Мекдоналдова острва",
  HN: "Хондурас",
  HR: "Хрватска",
  HT: "Хаити",
  HU: "Мађарска",
  ID: "Индонезија",
  IE: "Ирска",
  IL: "Израел",
  IM: "Острво Ман",
  IN: "Индија",
  IO: "Британска територија Индијског океана",
  IQ: "Ирак",
  IR: "Иран",
  IS: "Исланд",
  IT: "Италија",
  JE: "Џерзи",
  JM: "Јамајка",
  JO: "Јордан",
  JP: "Јапан",
  KE: "Кенија",
  KG: "Киргистан",
  KH: "Камбоџа",
  KI: "Кирибати",
  KM: "Коморска Острва",
  KN: "Сент Китс и Невис",
  KP: "Северна Кореја",
  KR: "Јужна Кореја",
  KW: "Кувајт",
  KY: "Кајманска Острва",
  KZ: "Казахстан",
  LA: "Лаос",
  LB: "Либан",
  LC: "Света Луција",
  LI: "Лихтенштајн",
  LK: "Шри Ланка",
  LR: "Либерија",
  LS: "Лесото",
  LT: "Литванија",
  LU: "Луксембург",
  LV: "Летонија",
  LY: "Либија",
  MA: "Мароко",
  MC: "Монако",
  MD: "Молдавија",
  ME: "Црна Гора",
  MF: "Свети Мартин (Француска)",
  MG: "Мадагаскар",
  MH: "Маршалска Острва",
  MK: "Северна Македонија",
  ML: "Мали",
  MM: "Мијанмар (Бурма)",
  MN: "Монголија",
  MO: "САР Макао (Кина)",
  MP: "Северна Маријанска Острва",
  MQ: "Мартиник",
  MR: "Мауританија",
  MS: "Монсерат",
  MT: "Малта",
  MU: "Маурицијус",
  MV: "Малдиви",
  MW: "Малави",
  MX: "Мексико",
  MY: "Малезија",
  MZ: "Мозамбик",
  NA: "Намибија",
  NC: "Нова Каледонија",
  NE: "Нигер",
  NF: "Острво Норфок",
  NG: "Нигерија",
  NI: "Никарагва",
  NL: "Холандија",
  NO: "Норвешка",
  NP: "Непал",
  NR: "Науру",
  NU: "Ниуе",
  NZ: "Нови Зеланд",
  OM: "Оман",
  PA: "Панама",
  PE: "Перу",
  PF: "Француска Полинезија",
  PG: "Папуа Нова Гвинеја",
  PH: "Филипини",
  PK: "Пакистан",
  PL: "Пољска",
  PM: "Сен Пјер и Микелон",
  PN: "Питкерн",
  PR: "Порторико",
  PS: "Палестинске територије",
  PT: "Португалија",
  PW: "Палау",
  PY: "Парагвај",
  QA: "Катар",
  RE: "Реинион",
  RO: "Румунија",
  RS: "Србија",
  RU: "Русија",
  RW: "Руанда",
  SA: "Саудијска Арабија",
  SB: "Соломонска Острва",
  SC: "Сејшели",
  SD: "Судан",
  SE: "Шведска",
  SG: "Сингапур",
  SH: "Света Јелена",
  SI: "Словенија",
  SJ: "Свалбард и Јан Мајен",
  SK: "Словачка",
  SL: "Сијера Леоне",
  SM: "Сан Марино",
  SN: "Сенегал",
  SO: "Сомалија",
  SR: "Суринам",
  SS: "Јужни Судан",
  ST: "Сао Томе и Принципе",
  SV: "Салвадор",
  SX: "Свети Мартин (Холандија)",
  SY: "Сирија",
  SZ: "Свазиленд",
  TC: "Острва Туркс и Каикос",
  TD: "Чад",
  TF: "Француске Јужне Територије",
  TG: "Того",
  TH: "Тајланд",
  TJ: "Таџикистан",
  TK: "Токелау",
  TL: "Источни Тимор",
  TM: "Туркменистан",
  TN: "Тунис",
  TO: "Тонга",
  TR: "Турска",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TW: "Тајван",
  TZ: "Танзанија",
  UA: "Украјина",
  UG: "Уганда",
  UM: "Удаљена острва САД",
  US: "Сједињене Државе",
  UY: "Уругвај",
  UZ: "Узбекистан",
  VA: "Ватикан",
  VC: "Сент Винсент и Гренадини",
  VE: "Венецуела",
  VG: "Британска Девичанска Острва",
  VI: "Америчка Девичанска Острва",
  VN: "Вијетнам",
  VU: "Вануату",
  WF: "Валис и Футуна",
  WS: "Самоа",
  XK: "Косово",
  YE: "Јемен",
  YT: "Мајот",
  ZA: "Јужноафричка Република",
  ZM: "Замбија",
  ZW: "Зимбабве"
}, fC = {
  locale: s5,
  countries: l5
}, hC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: l5,
  default: fC,
  locale: s5
}, Symbol.toStringTag, { value: "Module" })), u5 = "sv", c5 = {
  AD: "Andorra",
  AE: "Förenade Arabemiraten",
  AF: "Afghanistan",
  AG: "Antigua och Barbuda",
  AI: "Anguilla",
  AL: "Albanien",
  AM: "Armenien",
  AO: "Angola",
  AQ: "Antarktis",
  AR: "Argentina",
  AS: "Amerikanska Samoa",
  AT: "Österrike",
  AU: "Australien",
  AW: "Aruba",
  AX: "Åland",
  AZ: "Azerbajdzjan",
  BA: "Bosnien och Hercegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgien",
  BF: "Burkina Faso",
  BG: "Bulgarien",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Bonaire, Saint Eustatius och Saba",
  BR: "Brasilien",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvetön",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosöarna",
  CD: "Demokratiska republiken Kongo",
  CF: "Centralafrikanska republiken",
  CG: "Kongo-Brazzaville",
  CH: "Schweiz",
  CI: "Elfenbenskusten",
  CK: "Cooköarna",
  CL: "Chile",
  CM: "Kamerun",
  CN: "Kina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Kuba",
  CV: "Kap Verde",
  CW: "Curacao",
  CX: "Julön",
  CY: "Cypern",
  CZ: "Tjeckien",
  DE: "Tyskland",
  DJ: "Djibouti",
  DK: "Danmark",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  DZ: "Algeriet",
  EC: "Ecuador",
  EE: "Estland",
  EG: "Egypten",
  EH: "Västsahara",
  ER: "Eritrea",
  ES: "Spanien",
  ET: "Etiopien",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falklandsöarna",
  FM: "Mikronesiska federationen",
  FO: "Färöarna",
  FR: "Frankrike",
  GA: "Gabon",
  GB: "Storbritannien",
  GD: "Grenada",
  GE: "Georgien",
  GF: "Franska Guyana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Grönland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Ekvatorialguinea",
  GR: "Grekland",
  GS: "Sydgeorgien och Sydsandwichöarna",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HK: "Hongkong",
  HM: "Heard- och McDonaldsöarna",
  HN: "Honduras",
  HR: "Kroatien",
  HT: "Haiti",
  HU: "Ungern",
  ID: "Indonesien",
  IE: "Irland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "Indien",
  IO: "Brittiska territoriet i Indiska Oceanen",
  IQ: "Irak",
  IR: "Iran",
  IS: "Island",
  IT: "Italien",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordanien",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kirgizistan",
  KH: "Kambodja",
  KI: "Kiribati",
  KM: "Komorerna",
  KN: "Saint Kitts och Nevis",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KY: "Caymanöarna",
  KZ: "Kazakstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Litauen",
  LU: "Luxemburg",
  LV: "Lettland",
  LY: "Libyen",
  MA: "Marocko",
  MC: "Monaco",
  MD: "Moldavien",
  ME: "Montenegro",
  MF: "Saint Martin (franska delen)",
  MG: "Madagaskar",
  MH: "Marshallöarna",
  MK: "Nordmakedonien",
  ML: "Mali",
  MM: "Burma",
  MN: "Mongoliet",
  MO: "Macau",
  MP: "Nordmarianerna",
  MQ: "Martinique",
  MR: "Mauretanien",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldiverna",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malaysia",
  MZ: "Moçambique",
  NA: "Namibia",
  NC: "Nya Kaledonien",
  NE: "Niger",
  NF: "Norfolkön",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Nederländerna",
  NO: "Norge",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nya Zeeland",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Franska Polynesien",
  PG: "Papua Nya Guinea",
  PH: "Filippinerna",
  PK: "Pakistan",
  PL: "Polen",
  PM: "Saint-Pierre och Miquelon",
  PN: "Pitcairnöarna",
  PR: "Puerto Rico",
  PS: "Palestinska territoriet, ockuperade",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumänien",
  RS: "Serbien",
  RU: "Ryssland",
  RW: "Rwanda",
  SA: "Saudiarabien",
  SB: "Salomonöarna",
  SC: "Seychellerna",
  SD: "Sudan",
  SE: "Sverige",
  SG: "Singapore",
  SH: "Sankta Helena",
  SI: "Slovenien",
  SJ: "Svalbard och Jan Mayen",
  SK: "Slovakien",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Surinam",
  SS: "Sydsudan",
  ST: "São Tomé och Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (nederländska delen)",
  SY: "Syrien",
  SZ: "Eswatini",
  TC: "Turks- och Caicosöarna",
  TD: "Tchad",
  TF: "Franska södra territorierna",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tadzjikistan",
  TK: "Tokelauöarna",
  TL: "Östtimor",
  TM: "Turkmenistan",
  TN: "Tunisien",
  TO: "Tonga",
  TR: "Turkiet",
  TT: "Trinidad och Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraina",
  UG: "Uganda",
  UM: "USA:s yttre öar",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatikanstaten",
  VC: "Saint Vincent och Grenadinerna",
  VE: "Venezuela",
  VG: "Brittiska Jungfruöarna",
  VI: "Amerikanska Jungfruöarna",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis- och Futunaöarna",
  WS: "Samoa",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Sydafrika",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, mC = {
  locale: u5,
  countries: c5
}, gC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: c5,
  default: mC,
  locale: u5
}, Symbol.toStringTag, { value: "Module" })), d5 = "th", p5 = {
  BD: "บังกลาเทศ",
  BE: "เบลเยียม",
  BF: "บูร์กินาฟาโซ",
  BG: "บัลแกเรีย",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BB: "บาร์เบโดส",
  WF: "วาลลิสและฟุตูนา",
  BL: "เซนต์บาร์เธเลมี",
  BM: "เบอร์มิวดา",
  BN: "บรูไน",
  BO: "โบลิเวีย",
  BH: "บาห์เรน",
  BI: "บุรุนดี",
  BJ: "เบนิน",
  BT: "ภูฏาน",
  JM: "จาเมกา",
  BV: "เกาะบูเวต",
  BW: "บอตสวานา",
  WS: "ซามัว",
  BR: "บราซิล",
  BS: "บาฮามาส",
  JE: "เจอร์ซีย์",
  BY: "เบลารุส",
  BZ: "เบลีซ",
  RU: "รัสเซีย",
  RW: "รวันดา",
  RS: "เซอร์เบีย",
  TL: "ติมอร์ตะวันออก",
  RE: "เรอูนียง",
  TM: "เติร์กเมนิสถาน",
  TJ: "ทาจิกิสถาน",
  RO: "โรมาเนีย",
  TK: "โตเกเลา",
  GW: "กินี-บิสเซา",
  GU: "กวม",
  GT: "กัวเตมาลา",
  GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  GR: "กรีซ",
  GQ: "อิเควทอเรียลกินี",
  GP: "กวาเดอลูป",
  JP: "ญี่ปุ่น",
  GY: "กายอานา",
  GG: "เกิร์นซีย์",
  GF: "เฟรนช์เกียนา",
  GE: "จอร์เจีย",
  GD: "เกรเนดา",
  GB: "สหราชอาณาจักร",
  GA: "กาบอง",
  SV: "เอลซัลวาดอร์",
  GN: "กินี",
  GM: "แกมเบีย",
  GL: "กรีนแลนด์",
  GI: "ยิบรอลตาร์",
  GH: "กานา",
  OM: "โอมาน",
  TN: "ตูนิเซีย",
  JO: "จอร์แดน",
  HR: "โครเอเชีย",
  HT: "เฮติ",
  HU: "ฮังการี",
  HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน",
  HN: "ฮอนดูรัส",
  HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
  VE: "เวเนซุเอลา",
  PR: "เปอร์โตริโก",
  PS: "ปาเลสไตน์",
  PW: "ปาเลา",
  PT: "โปรตุเกส",
  SJ: "สฟาลบาร์และยานไมเอน",
  PY: "ปารากวัย",
  IQ: "อิรัก",
  PA: "ปานามา",
  PF: "เฟรนช์โปลินีเซีย",
  PG: "ปาปัวนิวกินี",
  PE: "เปรู",
  PK: "ปากีสถาน",
  PH: "ฟิลิปปินส์",
  PN: "พิตแคร์น",
  PL: "โปแลนด์",
  PM: "แซงปีแยร์และมีเกอลง",
  ZM: "แซมเบีย",
  EH: "ซาฮาราตะวันตก",
  EE: "เอสโตเนีย",
  EG: "อียิปต์",
  ZA: "แอฟริกาใต้",
  EC: "เอกวาดอร์",
  IT: "อิตาลี",
  VN: "เวียดนาม",
  SB: "หมู่เกาะโซโลมอน",
  ET: "เอธิโอเปีย",
  SO: "โซมาเลีย",
  ZW: "ซิมบับเว",
  SA: "ซาอุดีอาระเบีย",
  ES: "สเปน",
  ER: "เอริเทรีย",
  ME: "มอนเตเนโกร",
  MD: "มอลโดวา",
  MG: "มาดากัสการ์",
  MF: "เซนต์มาติน",
  MA: "โมร็อกโก",
  MC: "โมนาโก",
  UZ: "อุซเบกิสถาน",
  MM: "เมียนม่าร์ [พม่า]",
  ML: "มาลี",
  MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน",
  MN: "มองโกเลีย",
  MH: "หมู่เกาะมาร์แชลล์",
  MK: "มาซิโดเนีย",
  MU: "มอริเชียส",
  MT: "มอลตา",
  MW: "มาลาวี",
  MV: "มัลดีฟส์",
  MQ: "มาร์ตินีก",
  MP: "หมู่เกาะนอร์เทิร์นมาเรียนา",
  MS: "มอนต์เซอร์รัต",
  MR: "มอริเตเนีย",
  IM: "เกาะแมน",
  UG: "ยูกันดา",
  TZ: "แทนซาเนีย",
  MY: "มาเลเซีย",
  MX: "เม็กซิโก",
  IL: "อิสราเอล",
  FR: "ฝรั่งเศส",
  IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  SH: "เซนต์เฮเลนา",
  FI: "ฟินแลนด์",
  FJ: "ฟิจิ",
  FK: "หมู่เกาะฟอล์กแลนด์",
  FM: "ไมโครนีเซีย",
  FO: "หมู่เกาะแฟโร",
  NI: "นิการากัว",
  NL: "เนเธอร์แลนด์",
  NO: "นอร์เวย์",
  NA: "นามิเบีย",
  VU: "วานูอาตู",
  NC: "นิวแคลิโดเนีย",
  NE: "ไนเจอร์",
  NF: "เกาะนอร์ฟอล์ก",
  NG: "ไนจีเรีย",
  NZ: "นิวซีแลนด์",
  NP: "เนปาล",
  NR: "นาอูรู",
  NU: "นีอูเอ",
  CK: "หมู่เกาะคุก",
  CI: "ไอวอรี่โคสต์",
  CH: "สวิตเซอร์แลนด์",
  CO: "โคลอมเบีย",
  CN: "จีน",
  CM: "แคเมอรูน",
  CL: "ชิลี",
  CC: "หมู่เกาะโคโคส",
  CA: "แคนาดา",
  CG: "คองโก-บราซซาวิล",
  CF: "สาธารณรัฐแอฟริกากลาง",
  CD: "คองโก-กินชาซา",
  CZ: "สาธารณรัฐเช็ก",
  CY: "ไซปรัส",
  CX: "เกาะคริสต์มาส",
  CR: "คอสตาริกา",
  CV: "เคปเวิร์ด",
  CU: "คิวบา",
  SZ: "สวาซิแลนด์",
  SY: "ซีเรีย",
  KG: "คีร์กีซสถาน",
  KE: "เคนยา",
  SR: "ซูรินาเม",
  KI: "คิริบาส",
  KH: "กัมพูชา",
  KN: "เซนต์คิตส์และเนวิส",
  KM: "คอโมโรส",
  ST: "เซาตูเมและปรินซิปี",
  SK: "สโลวะเกีย",
  KR: "เกาหลีใต้",
  SI: "สโลวีเนีย",
  KP: "เกาหลีเหนือ",
  KW: "คูเวต",
  SN: "เซเนกัล",
  SM: "ซานมารีโน",
  SL: "เซียร์ราลีโอน",
  SC: "เซเชลส์",
  KZ: "คาซัคสถาน",
  KY: "หมู่เกาะเคย์แมน",
  SG: "สิงคโปร์",
  SE: "สวีเดน",
  SD: "ซูดาน",
  DO: "สาธารณรัฐโดมินิกัน",
  DM: "โดมินิกา",
  DJ: "จิบูตี",
  DK: "เดนมาร์ก",
  VG: "หมู่เกาะบริติชเวอร์จิน",
  DE: "เยอรมนี",
  YE: "เยเมน",
  DZ: "แอลจีเรีย",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  YT: "มายอต",
  UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง",
  LB: "เลบานอน",
  LC: "เซนต์ลูเซีย",
  LA: "ลาว",
  TV: "ตูวาลู",
  TW: "ไต้หวัน",
  TT: "ตรินิแดดและโตเบโก",
  TR: "ตุรกี",
  LK: "ศรีลังกา",
  LI: "ลิกเตนสไตน์",
  LV: "ลัตเวีย",
  TO: "ตองกา",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  LR: "ไลบีเรีย",
  LS: "เลโซโท",
  TH: "ไทย",
  TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  TG: "โตโก",
  TD: "ชาด",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  LY: "ลิเบีย",
  VA: "วาติกัน",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  AD: "อันดอร์รา",
  AG: "แอนติกาและบาร์บูดา",
  AF: "อัฟกานิสถาน",
  AI: "แองกวิลลา",
  VI: "หมู่เกาะยูเอสเวอร์จิน",
  IS: "ไอซ์แลนด์",
  IR: "อิหร่าน",
  AM: "อาร์เมเนีย",
  AL: "แอลเบเนีย",
  AO: "แองโกลา",
  AQ: "แอนตาร์กติกา",
  AS: "อเมริกันซามัว",
  AR: "อาร์เจนตินา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AW: "อารูบา",
  IN: "อินเดีย",
  AX: "หมู่เกาะโอลันด์",
  AZ: "อาเซอร์ไบจาน",
  IE: "ไอร์แลนด์",
  ID: "อินโดนีเซีย",
  UA: "ยูเครน",
  QA: "กาตาร์",
  MZ: "โมซัมบิก",
  BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา",
  CW: "คูราเซา",
  SX: "Sint Maarten (ส่วนดัตช์)",
  SS: "ซูดานใต้",
  XK: "โคโซโว"
}, CC = {
  locale: d5,
  countries: p5
}, vC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: p5,
  default: CC,
  locale: d5
}, Symbol.toStringTag, { value: "Module" })), f5 = "tr", h5 = {
  AD: "Andorra",
  AE: "Birleşik Arap Emirlikleri",
  AF: "Afganistan",
  AG: "Antigua ve Barbuda",
  AI: "Anguilla",
  AL: "Arnavutluk",
  AM: "Ermenistan",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Arjantin",
  AS: "Amerikan Samoası",
  AT: "Avusturya",
  AU: "Avustralya",
  AW: "Aruba",
  AX: "Åland Adaları",
  AZ: "Azerbaycan",
  BA: "Bosna Hersek",
  BB: "Barbados",
  BD: "Bangladeş",
  BE: "Belçika",
  BF: "Burkina Faso",
  BG: "Bulgaristan",
  BH: "Bahreyn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivya",
  BQ: "Karayip Hollanda",
  BR: "Brezilya",
  BS: "Bahamalar",
  BT: "Butan",
  BV: "Bouvet Adası",
  BW: "Botsvana",
  BY: "Beyaz Rusya",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Cocos (Keeling) Adaları",
  CD: "Kongo - Kinşasa",
  CF: "Orta Afrika Cumhuriyeti",
  CG: "Kongo - Brazavil",
  CH: "İsviçre",
  CI: "Fildişi Sahili",
  CK: "Cook Adaları",
  CL: "Şili",
  CM: "Kamerun",
  CN: "Çin",
  CO: "Kolombiya",
  CR: "Kosta Rika",
  CU: "Küba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Adası",
  CY: "Güney Kıbrıs Rum Kesimi",
  CZ: "Çek Cumhuriyeti",
  DE: "Almanya",
  DJ: "Cibuti",
  DK: "Danimarka",
  DM: "Dominika",
  DO: "Dominik Cumhuriyeti",
  DZ: "Cezayir",
  EC: "Ekvador",
  EE: "Estonya",
  EG: "Mısır",
  EH: "Batı Sahara",
  ER: "Eritre",
  ES: "İspanya",
  ET: "Etiyopya",
  FI: "Finlandiya",
  FJ: "Fiji",
  FK: "Falkland Adaları",
  FM: "Mikronezya",
  FO: "Faroe Adaları",
  FR: "Fransa",
  GA: "Gabon",
  GB: "Birleşik Krallık",
  GD: "Grenada",
  GE: "Gürcistan",
  GF: "Fransız Guyanası",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Cebelitarık",
  GL: "Grönland",
  GM: "Gambiya",
  GN: "Gine",
  GP: "Guadalupe",
  GQ: "Ekvator Ginesi",
  GR: "Yunanistan",
  GS: "Güney Georgia ve Güney Sandwich Adaları",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Gine-Bissau",
  GY: "Guyana",
  HK: "Çin Hong Kong ÖYB",
  HM: "Heard Adası ve McDonald Adaları",
  HN: "Honduras",
  HR: "Hırvatistan",
  HT: "Haiti",
  HU: "Macaristan",
  ID: "Endonezya",
  IE: "İrlanda",
  IL: "İsrail",
  IM: "Man Adası",
  IN: "Hindistan",
  IO: "Britanya Hint Okyanusu Toprakları",
  IQ: "Irak",
  IR: "İran",
  IS: "İzlanda",
  IT: "İtalya",
  JE: "Jersey",
  JM: "Jamaika",
  JO: "Ürdün",
  JP: "Japonya",
  KE: "Kenya",
  KG: "Kırgızistan",
  KH: "Kamboçya",
  KI: "Kiribati",
  KM: "Komorlar",
  KN: "Saint Kitts ve Nevis",
  KP: "Kuzey Kore",
  KR: "Güney Kore",
  KW: "Kuveyt",
  KY: "Cayman Adaları",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Lübnan",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberya",
  LS: "Lesoto",
  LT: "Litvanya",
  LU: "Lüksemburg",
  LV: "Letonya",
  LY: "Libya",
  MA: "Fas",
  MC: "Monako",
  MD: "Moldova",
  ME: "Karadağ",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshall Adaları",
  MK: "Kuzey Makedonya",
  ML: "Mali",
  MM: "Myanmar (Burma)",
  MN: "Moğolistan",
  MO: "Çin Makao ÖYB",
  MP: "Kuzey Mariana Adaları",
  MQ: "Martinik",
  MR: "Moritanya",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivler",
  MW: "Malavi",
  MX: "Meksika",
  MY: "Malezya",
  MZ: "Mozambik",
  NA: "Namibya",
  NC: "Yeni Kaledonya",
  NE: "Nijer",
  NF: "Norfolk Adası",
  NG: "Nijerya",
  NI: "Nikaragua",
  NL: "Hollanda",
  NO: "Norveç",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Yeni Zelanda",
  OM: "Umman",
  PA: "Panama",
  PE: "Peru",
  PF: "Fransız Polinezyası",
  PG: "Papua Yeni Gine",
  PH: "Filipinler",
  PK: "Pakistan",
  PL: "Polonya",
  PM: "Saint Pierre ve Miquelon",
  PN: "Pitcairn Adaları",
  PR: "Porto Riko",
  PS: "Filistin Bölgeleri",
  PT: "Portekiz",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Katar",
  RE: "Réunion",
  RO: "Romanya",
  RS: "Sırbistan",
  RU: "Rusya",
  RW: "Ruanda",
  SA: "Suudi Arabistan",
  SB: "Solomon Adaları",
  SC: "Seyşeller",
  SD: "Sudan",
  SE: "İsveç",
  SG: "Singapur",
  SH: "Saint Helena",
  SI: "Slovenya",
  SJ: "Svalbard ve Jan Mayen Adaları",
  SK: "Slovakya",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somali",
  SR: "Surinam",
  SS: "Güney Sudan",
  ST: "São Tomé ve Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Suriye",
  SZ: "Svaziland",
  TC: "Turks ve Caicos Adaları",
  TD: "Çad",
  TF: "Fransız Güney Toprakları",
  TG: "Togo",
  TH: "Tayland",
  TJ: "Tacikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Türkmenistan",
  TN: "Tunus",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinidad ve Tobago",
  TV: "Tuvalu",
  TW: "Tayvan",
  TZ: "Tanzanya",
  UA: "Ukrayna",
  UG: "Uganda",
  UM: "ABD Uzak Adaları",
  US: [
    "ABD",
    "A.B.D.",
    "Amerika Birleşik Devletleri",
    "Birleşik Devletler",
    "Amerika"
  ],
  UY: "Uruguay",
  UZ: "Özbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent ve Grenadinler",
  VE: "Venezuela",
  VG: "Britanya Virjin Adaları",
  VI: "ABD Virjin Adaları",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis ve Futuna Adaları",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Güney Afrika",
  ZM: "Zambiya",
  ZW: "Zimbabve",
  XK: "Kosova"
}, bC = {
  locale: f5,
  countries: h5
}, yC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: h5,
  default: bC,
  locale: f5
}, Symbol.toStringTag, { value: "Module" })), m5 = "uk", g5 = {
  AU: "Австралія",
  AT: "Австрія",
  AZ: "Азербайджан",
  AX: "Аландські Острови",
  AL: "Албанія",
  DZ: "Алжир",
  AS: "Американське Самоа",
  AI: "Ангілья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктика",
  AG: "Антигуа і Барбуда",
  MO: "Макао",
  AR: "Аргентина",
  AM: "Вірменія",
  AW: "Аруба",
  AF: "Афганістан",
  BS: "Багамські Острови",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Беліз",
  BE: "Бельгія",
  BJ: "Бенін",
  BM: "Бермудські Острови",
  BY: "Білорусь",
  BG: "Болгарія",
  BO: "Болівія",
  BA: "Боснія і Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилія",
  IO: "Британська Територія в Індійському Океані",
  VG: "Британські Віргінські Острови",
  BN: "Бруней-Даруссалам",
  BF: "Буркіна-Фасо",
  BI: "Бурунді",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобританія",
  VE: "Венесуела",
  VI: "Віргінські Острови (США)",
  WF: "Волліс і Футуна",
  VN: "В'єтнам",
  UM: "Зовнішні Віддалені Острови (США)",
  GA: "Габон",
  HT: "Гаїті",
  GY: "Гаяна",
  GM: "Гамбія",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвіана",
  GN: "Гвінея",
  GW: "Гвінея-Бісау",
  GG: "Гернсі",
  GI: "Гібралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GR: "Греція",
  GE: "Грузія",
  GU: "Гуам",
  GL: "Гренландія",
  DK: "Данія",
  JE: "Джерсі",
  DJ: "Джибуті",
  DM: "Домініка",
  DO: "Домініканська Республіка",
  CD: "Демократична Республіка Конго",
  EC: "Еквадор",
  GQ: "Екваторіальна Гвінея",
  ER: "Еритрея",
  EE: "Естонія",
  ET: "Ефіопія",
  EG: "Єгипет",
  YE: "Ємен",
  ZM: "Замбія",
  ZW: "Зімбабве",
  IL: "Ізраїль",
  IN: "Індія",
  ID: "Індонезія",
  IQ: "Ірак",
  IR: "Іран",
  IE: "Ірландія",
  IS: "Ісландія",
  ES: "Іспанія",
  IT: "Італія",
  JO: "Йорданія",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Кайманові Острови",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  BQ: "Карибські Нідерланди",
  QA: "Катар",
  KE: "Кенія",
  CY: "Кіпр",
  KI: "Кірибаті",
  KG: "Киргизстан",
  TW: "Тайвань, Провінція Китаю",
  KP: "Корейська Народно-Демократична Республіка",
  CN: "Китай",
  CC: "Кокосові Острови",
  CO: "Колумбія",
  KM: "Комори",
  XK: "Косово",
  CR: "Коста-Рика",
  CI: "Кот-Д'Івуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвія",
  LS: "Лесото",
  LR: "Ліберія",
  LB: "Ліван",
  LY: "Лівія",
  LT: "Литва",
  LI: "Ліхтенштейн",
  LU: "Люксембург",
  MU: "Маврикій",
  MR: "Мавританія",
  MG: "Мадагаскар",
  YT: "Майотта",
  MW: "Малаві",
  MY: "Малайзія",
  ML: "Малі",
  MV: "Мальдіви",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиніка",
  MH: "Маршаллові Острови",
  MX: "Мексика",
  FM: "Мікронезія",
  MZ: "Мозамбік",
  MD: "Молдова",
  MC: "Монако",
  MN: "Монголія",
  MS: "Монтсеррат",
  MM: "М'янма",
  NA: "Намібія",
  NR: "Науру",
  NP: "Непал",
  NE: "Нігер",
  NG: "Нігерія",
  NL: "Нідерланди",
  NI: "Нікарагуа",
  DE: "Німеччина",
  NU: "Ніуе",
  NZ: "Нова Зеландія",
  NC: "Нова Каледонія",
  NO: "Норвегія",
  AE: "Об'єднані Арабські Емірати",
  OM: "Оман",
  BV: "Острів Буве",
  HM: "Острів Герд і Острови Макдоналд",
  IM: "Острів Мен",
  NF: "Острів Норфолк",
  CX: "Острів Різдва",
  CK: "Острови Кука",
  SH: "Острів Святої Єлени",
  TC: "Острови Теркс і Кайкос",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Палестина",
  PA: "Панама",
  PG: "Папуа-Нова Гвінея",
  ZA: "Південна Африка",
  PY: "Парагвай",
  PE: "Перу",
  GS: "Південна Джорджія та Південні Сандвічеві Острови",
  KR: "Республіка Корея",
  SS: "Південний Судан",
  MK: "Північна Македонія",
  MP: "Північні Маріанські Острови",
  PN: "Піткерн",
  PL: "Польща",
  PT: "Португалія",
  PR: "Пуерто-Рико",
  CG: "Конго",
  RE: "Реюньйон",
  RU: "Росія",
  RW: "Руанда",
  RO: "Румунія",
  EH: "Західна Сахара",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе і Принсіпі",
  SA: "Саудівська Аравія",
  SZ: "Есватіні",
  SJ: "Острови Шпіцберген та Ян-Маєн",
  SC: "Сейшельські Острови",
  BL: "Сен-Бартелемі",
  MF: "Сен-Мартен",
  PM: "Сен-П'єр і Мікелон",
  SN: "Сенегал",
  VC: "Сент-Вінсент і Гренадіни",
  KN: "Сент-Кітс і Невіс",
  LC: "Сент-Люсія",
  RS: "Сербія",
  SG: "Сингапур",
  SX: "Сінт-Мартен",
  SY: "Сирія",
  SK: "Словаччина",
  SI: "Словенія",
  SB: "Соломонові Острови",
  SO: "Сомалі",
  SD: "Судан",
  SR: "Суринам",
  TL: "Тимор-Лешті",
  US: "США",
  SL: "Сьєрра-Леоне",
  TJ: "Таджикистан",
  TH: "Таїланд",
  TZ: "Танзанія",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринідад і Тобаго",
  TV: "Тувалу",
  TN: "Туніс",
  TM: "Туркменистан",
  TR: "Туреччина",
  UG: "Уганда",
  HU: "Угорщина",
  UZ: "Узбекистан",
  UA: "Україна",
  UY: "Уругвай",
  FO: "Фарерські Острови",
  FJ: "Фіджі",
  PH: "Філіппіни",
  FI: "Фінляндія",
  FK: "Фолклендські Острови",
  FR: "Франція",
  PF: "Французька Полінезія",
  TF: "Французькі Південні і Антарктичні Території",
  HR: "Хорватія",
  CF: "Центральноафриканська Республіка",
  TD: "Чад",
  ME: "Чорногорія",
  CZ: "Чехія",
  CL: "Чилі",
  CH: "Швейцарія",
  SE: "Швеція",
  LK: "Шри-Ланка",
  JM: "Ямайка",
  JP: "Японія"
}, wC = {
  locale: m5,
  countries: g5
}, SC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: g5,
  default: wC,
  locale: m5
}, Symbol.toStringTag, { value: "Module" })), C5 = "zh", v5 = {
  AD: "安道尔",
  AE: "阿联酋",
  AF: "阿富汗",
  AG: "安提瓜和巴布达",
  AI: "安圭拉",
  AL: "阿尔巴尼亚",
  AM: "亚美尼亚",
  AO: "安哥拉",
  AQ: "南极洲",
  AR: "阿根廷",
  AS: "美属萨摩亚",
  AT: "奥地利",
  AU: "澳大利亚",
  AW: "阿鲁巴",
  AX: "奥兰",
  AZ: "阿塞拜疆",
  BA: "波黑",
  BB: "巴巴多斯",
  BD: "孟加拉国",
  BE: "比利时",
  BF: "布基纳法索",
  BG: "保加利亚",
  BH: "巴林",
  BI: "布隆迪",
  BJ: "贝宁",
  BL: "圣巴泰勒米",
  BM: "百慕大",
  BN: "文莱",
  BO: "玻利维亚",
  BQ: "荷兰加勒比区",
  BR: "巴西",
  BS: "巴哈马",
  BT: "不丹",
  BV: "布韦岛",
  BW: "博茨瓦纳",
  BY: "白俄罗斯",
  BZ: "伯利兹",
  CA: "加拿大",
  CC: "科科斯（基林）群岛",
  CD: "刚果（金）",
  CF: "中非",
  CG: "刚果（布）",
  CH: "瑞士",
  CI: "科特迪瓦",
  CK: "库克群岛",
  CL: "智利",
  CM: "喀麦隆",
  CN: "中国",
  CO: "哥伦比亚",
  CR: "哥斯达黎加",
  CU: "古巴",
  CV: "佛得角",
  CW: "库拉索",
  CX: "圣诞岛",
  CY: "塞浦路斯",
  CZ: "捷克",
  DE: "德国",
  DJ: "吉布提",
  DK: "丹麦",
  DM: "多米尼克",
  DO: "多米尼加",
  DZ: "阿尔及利亚",
  EC: "厄瓜多尔",
  EE: "爱沙尼亚",
  EG: "埃及",
  EH: "阿拉伯撒哈拉民主共和国",
  ER: "厄立特里亚",
  ES: "西班牙",
  ET: "埃塞俄比亚",
  FI: "芬兰",
  FJ: "斐济",
  FK: "福克兰群岛",
  FM: "密克罗尼西亚联邦",
  FO: "法罗群岛",
  FR: "法国",
  GA: "加蓬",
  GB: "英国",
  GD: "格林纳达",
  GE: "格鲁吉亚",
  GF: "法属圭亚那",
  GG: "根西",
  GH: "加纳",
  GI: "直布罗陀",
  GL: "格陵兰",
  GM: "冈比亚",
  GN: "几内亚",
  GP: "瓜德罗普",
  GQ: "赤道几内亚",
  GR: "希腊",
  GS: "南乔治亚和南桑威奇群岛",
  GT: "危地马拉",
  GU: "关岛",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HK: "香港",
  HM: "赫德岛和麦克唐纳群岛",
  HN: "洪都拉斯",
  HR: "克罗地亚",
  HT: "海地",
  HU: "匈牙利",
  ID: "印尼",
  IE: "爱尔兰",
  IL: "以色列",
  IM: "马恩岛",
  IN: "印度",
  IO: "英属印度洋领地",
  IQ: "伊拉克",
  IR: "伊朗",
  IS: "冰岛",
  IT: "意大利",
  JE: "泽西",
  JM: "牙买加",
  JO: "约旦",
  JP: "日本",
  KE: "肯尼亚",
  KG: "吉尔吉斯斯坦",
  KH: "柬埔寨",
  KI: "基里巴斯",
  KM: "科摩罗",
  KN: "圣基茨和尼维斯",
  KP: "朝鲜",
  KR: "韩国",
  KW: "科威特",
  KY: "开曼群岛",
  KZ: "哈萨克斯坦",
  LA: "老挝",
  LB: "黎巴嫩",
  LC: "圣卢西亚",
  LI: "列支敦士登",
  LK: "斯里兰卡",
  LR: "利比里亚",
  LS: "莱索托",
  LT: "立陶宛",
  LU: "卢森堡",
  LV: "拉脱维亚",
  LY: "利比亚",
  MA: "摩洛哥",
  MC: "摩纳哥",
  MD: "摩尔多瓦",
  ME: "黑山",
  MF: "法属圣马丁",
  MG: "马达加斯加",
  MH: "马绍尔群岛",
  MK: "北马其顿",
  ML: "马里",
  MM: "缅甸",
  MN: "蒙古",
  MO: "澳门",
  MP: "北马里亚纳群岛",
  MQ: "马提尼克",
  MR: "毛里塔尼亚",
  MS: "蒙特塞拉特",
  MT: "马耳他",
  MU: "毛里求斯",
  MV: "马尔代夫",
  MW: "马拉维",
  MX: "墨西哥",
  MY: "马来西亚",
  MZ: "莫桑比克",
  NA: "纳米比亚",
  NC: "新喀里多尼亚",
  NE: "尼日尔",
  NF: "诺福克岛",
  NG: "尼日利亚",
  NI: "尼加拉瓜",
  NL: "荷兰",
  NO: "挪威",
  NP: "尼泊尔",
  NR: "瑙鲁",
  NU: "纽埃",
  NZ: "新西兰",
  OM: "阿曼",
  PA: "巴拿马",
  PE: "秘鲁",
  PF: "法属波利尼西亚",
  PG: "巴布亚新几内亚",
  PH: "菲律宾",
  PK: "巴基斯坦",
  PL: "波兰",
  PM: "圣皮埃尔和密克隆",
  PN: "皮特凯恩群岛",
  PR: "波多黎各",
  PS: "巴勒斯坦",
  PT: "葡萄牙",
  PW: "帕劳",
  PY: "巴拉圭",
  QA: "卡塔尔",
  RE: "留尼汪",
  RO: "罗马尼亚",
  RS: "塞尔维亚",
  RU: "俄罗斯",
  RW: "卢旺达",
  SA: "沙特阿拉伯",
  SB: "所罗门群岛",
  SC: "塞舌尔",
  SD: "苏丹",
  SE: "瑞典",
  SG: "新加坡",
  SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
  SI: "斯洛文尼亚",
  SJ: "斯瓦尔巴和扬马延",
  SK: "斯洛伐克",
  SL: "塞拉利昂",
  SM: "圣马力诺",
  SN: "塞内加尔",
  SO: "索马里",
  SR: "苏里南",
  SS: "南苏丹",
  ST: "圣多美和普林西比",
  SV: "萨尔瓦多",
  SX: "荷属圣马丁",
  SY: "叙利亚",
  SZ: "斯威士兰",
  TC: "特克斯和凯科斯群岛",
  TD: "乍得",
  TF: "法属南部领地",
  TG: "多哥",
  TH: "泰国",
  TJ: "塔吉克斯坦",
  TK: "托克劳",
  TL: "东帝汶",
  TM: "土库曼斯坦",
  TN: "突尼斯",
  TO: "汤加",
  TR: "土耳其",
  TT: "特立尼达和多巴哥",
  TV: "图瓦卢",
  TW: "中国台湾省",
  TZ: "坦桑尼亚",
  UA: "乌克兰",
  UG: "乌干达",
  UM: "美国本土外小岛屿",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VA: "梵蒂冈",
  VC: "圣文森特和格林纳丁斯",
  VE: "委内瑞拉",
  VG: "英属维尔京群岛",
  VI: "美属维尔京群岛",
  VN: "越南",
  VU: "瓦努阿图",
  WF: "瓦利斯和富图纳",
  WS: "萨摩亚",
  XK: "科索沃",
  YE: "也门",
  YT: "马约特",
  ZA: "南非",
  ZM: "赞比亚",
  ZW: "津巴布韦"
}, _C = {
  locale: C5,
  countries: v5
}, xC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: v5,
  default: _C,
  locale: C5
}, Symbol.toStringTag, { value: "Module" })), MC = {
  ar: xg,
  cs: kg,
  da: Tg,
  de: Dg,
  el: Lg,
  en: Ng,
  es: Og,
  fr: jg,
  hi: Fg,
  hu: Vg,
  id: zg,
  it: Zg,
  ja: Wg,
  nl: Jg,
  no: qg,
  pl: eC,
  pt: nC,
  ro: rC,
  ru: oC,
  sk: lC,
  sl: cC,
  sq: pC,
  sr: hC,
  sv: gC,
  th: vC,
  tr: yC,
  uk: SC,
  zh: xC
};
Object.values(MC).forEach((e) => {
  ms.registerLocale(e.default);
});
const b5 = (e, t) => {
  const r = m0(t);
  switch (e) {
    case Pl.Taiwan:
      return ms.getName(e, r, { select: "alias" });
    default:
      return ms.getName(e, r, { select: "official" });
  }
}, pP = (e = ha.ENGLISH) => Object.values(Pl).map((t) => ({
  id: t,
  caption: b5(t, e) ?? ""
})), fP = (e, t = ha.ENGLISH) => b5(e, t) ?? "";
var Mt = /* @__PURE__ */ ((e) => (e.Email = "email", e.FirstName = "first_name", e.Surname = "surname", e.Country = "country", e.City = "city", e.Neighborhood = "neighborhood", e.StreetAddress = "street_address", e.StreetNumber = "street_number", e.Postcode = "postcode", e.PhoneNumber = "phone_number", e.CompanyName = "company_name", e.TaxNumber = "tax_number", e.State = "state", e))(Mt || {});
const kC = {
  [Mt.Email]: "public_pages_purchase.contact_slug.email",
  [Mt.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [Mt.Surname]: "public_pages_purchase.contact_slug.last_name",
  [Mt.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [Mt.Country]: "public_pages_purchase.contact_slug.country",
  [Mt.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [Mt.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [Mt.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [Mt.City]: "public_pages_purchase.contact_slug.city",
  [Mt.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [Mt.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [Mt.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [Mt.State]: "public_pages_purchase.contact_slug.state_province"
}, PC = (e) => ue.t(kC[e]), hP = (e) => {
  const { slug: t, fieldName: r } = e;
  return Object.values(Mt).includes(t) ? PC(t) : r;
};
var TC = /* @__PURE__ */ ((e) => (e.ARGENTINE_PESO = "ars", e.AUSTRALIAN_DOLLAR = "aud", e.BULGARIAN_LEV = "bgn", e.BRAZILIAN_REAL = "brl", e.CANADIAN_DOLLAR = "cad", e.CENTRAL_AFRICAN_FRANC = "xaf", e.CHILEAN_PESO = "clp", e.CHINESE_YUAN = "cny", e.COLOMBIAN_PESO = "cop", e.CZECH_CROWN = "czk", e.DANISH_KRONE = "dkk", e.EGYPTIAN_POUND = "egp", e.EURO = "eur", e.GHANAIAN_CEDI = "ghs", e.GUINEAN_FRANC = "gnf", e.HONG_KONG_DOLLAR = "hkd", e.HUNGARIAN_FORINT = "huf", e.ICELANDIC_KRONA = "isk", e.INDIAN_RUPEE = "inr", e.INDONESIAN_RUPIAH = "idr", e.ISRAELI_NEW_SHEKEL = "ils", e.JAPANESE_YEN = "jpy", e.KENYAN_SHILLING = "kes", e.MALAWIAN_KWACHA = "mwk", e.MALAYSIAN_RINGGIT = "myr", e.MEXICAN_PESO = "mxn", e.MOROCCAN_DIRHAM = "mad", e.NEW_ZEALAND_DOLLAR = "nzd", e.NIGERIAN_NAIRA = "ngn", e.NORWEGIAN_KRONE = "nok", e.PHILIPPINE_PESO = "php", e.POLISH_ZLOTY = "pln", e.POUND_STERLING = "gbp", e.ROMANIA_LEI = "ron", e.RUSSIAN_RUBLE = "rub", e.RWANDAN_FRANC = "rwf", e.SAO_TOME_AND_PRINCIPE_DOBRA = "std", e.SAUDI_RIYAL = "sar", e.SIERRA_LEONEAN_LEONE = "sll", e.SINGAPORE_DOLLAR = "sgd", e.SOUTH_AFRICAN_RAND = "zar", e.SRI_LANKAN_RUPEE = "lkr", e.SWEDISH_KRONA = "sek", e.SWISS_FRANC = "chf", e.TANZANIAN_SHILLING = "tzs", e.THAI_BAHT = "thb", e.TURKISH_LIRA = "try", e.UGANDAN_SHILLING = "ugx", e.US_DOLLAR = "usd", e.UNITED_ARAB_EMIRATES_DIRHAM = "aed", e.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", e.ZAMBIAN_KWACHA = "zmw", e.SERBIAN_DINAR = "rsd", e.UKRAINIAN_HRYVNIA = "uah", e.ALBANIAN_LEK = "all", e.VIETNAM_DONG = "vnd", e.PERUVIAN_SOL = "pen", e))(TC || {});
const Bo = (e, t) => new Date(
  new Intl.DateTimeFormat(Pn.ENGLISH, {
    timeZone: t,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(e)
), at = (e, t) => e ? e instanceof Date ? Bo(e, t) : e.match(/([-+]\d+:?\d+)$/) ? Bo(new Date(e), t) : new Date(e) : Bo(/* @__PURE__ */ new Date(), t), ea = (e) => {
  const t = function(r) {
    return (r < 10 ? "0" : "") + r;
  };
  return e.getFullYear() + "-" + t(e.getMonth() + 1) + "-" + t(e.getDate()) + "T" + t(e.getHours()) + ":" + t(e.getMinutes()) + ":" + t(e.getSeconds());
}, EC = (e) => {
  switch (e) {
    case hs.dateFirst:
      return "en-GB";
    case hs.monthFirst:
      return "en-US";
    default:
      return;
  }
}, iu = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(EC(t == null ? void 0 : t.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: t == null ? void 0 : t.timeZone
}), Fi = (e, t) => at(e, t);
let DC = { data: "" }, IC = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || DC, LC = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, AC = /\/\*[^]*?\*\/|  +/g, ou = /\n+/g, jn = (e, t) => {
  let r = "", a = "", n = "";
  for (let i in e) {
    let o = e[i];
    i[0] == "@" ? i[1] == "i" ? r = i + " " + o + ";" : a += i[1] == "f" ? jn(o, i) : i + "{" + jn(o, i[1] == "k" ? "" : t) + "}" : typeof o == "object" ? a += jn(o, t ? t.replace(/([^,])+/g, (s) => i.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : i) : o != null && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), n += jn.p ? jn.p(i, o) : i + ":" + o + ";");
  }
  return r + (t && n ? t + "{" + n + "}" : n) + a;
}, xn = {}, y5 = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let r in e) t += r + y5(e[r]);
    return t;
  }
  return e;
}, NC = (e, t, r, a, n) => {
  let i = y5(e), o = xn[i] || (xn[i] = ((l) => {
    let c = 0, d = 11;
    for (; c < l.length; ) d = 101 * d + l.charCodeAt(c++) >>> 0;
    return "go" + d;
  })(i));
  if (!xn[o]) {
    let l = i !== e ? e : ((c) => {
      let d, p, f = [{}];
      for (; d = LC.exec(c.replace(AC, "")); ) d[4] ? f.shift() : d[3] ? (p = d[3].replace(ou, " ").trim(), f.unshift(f[0][p] = f[0][p] || {})) : f[0][d[1]] = d[2].replace(ou, " ").trim();
      return f[0];
    })(e);
    xn[o] = jn(n ? { ["@keyframes " + o]: l } : l, r ? "" : "." + o);
  }
  let s = r && xn.g ? xn.g : null;
  return r && (xn.g = xn[o]), ((l, c, d, p) => {
    p ? c.data = c.data.replace(p, l) : c.data.indexOf(l) === -1 && (c.data = d ? l + c.data : c.data + l);
  })(xn[o], t, a, s), o;
}, RC = (e, t, r) => e.reduce((a, n, i) => {
  let o = t[i];
  if (o && o.call) {
    let s = o(r), l = s && s.props && s.props.className || /^go/.test(s) && s;
    o = l ? "." + l : s && typeof s == "object" ? s.props ? "" : jn(s, "") : s === !1 ? "" : s;
  }
  return a + n + (o ?? "");
}, "");
function oo(e) {
  let t = this || {}, r = e.call ? e(t.p) : e;
  return NC(r.unshift ? r.raw ? RC(r, [].slice.call(arguments, 1), t.p) : r.reduce((a, n) => Object.assign(a, n && n.call ? n(t.p) : n), {}) : r, IC(t.target), t.g, t.o, t.k);
}
let w5, gs, Cs;
oo.bind({ g: 1 });
let Tn = oo.bind({ k: 1 });
function OC(e, t, r, a) {
  jn.p = t, w5 = e, gs = r, Cs = a;
}
function $n(e, t) {
  let r = this || {};
  return function() {
    let a = arguments;
    function n(i, o) {
      let s = Object.assign({}, i), l = s.className || n.className;
      r.p = Object.assign({ theme: gs && gs() }, s), r.o = / *go\d+/.test(l), s.className = oo.apply(r, a) + (l ? " " + l : "");
      let c = e;
      return e[0] && (c = s.as || e, delete s.as), Cs && c[0] && Cs(s), w5(c, s);
    }
    return n;
  };
}
var BC = (e) => typeof e == "function", l1 = (e, t) => BC(e) ? e(t) : e, jC = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), S5 = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), HC = 20, _5 = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, HC) };
    case 1:
      return { ...e, toasts: e.toasts.map((i) => i.id === t.toast.id ? { ...i, ...t.toast } : i) };
    case 2:
      let { toast: r } = t;
      return _5(e, { type: e.toasts.find((i) => i.id === r.id) ? 1 : 0, toast: r });
    case 3:
      let { toastId: a } = t;
      return { ...e, toasts: e.toasts.map((i) => i.id === a || a === void 0 ? { ...i, dismissed: !0, visible: !1 } : i) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((i) => i.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let n = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((i) => ({ ...i, pauseDuration: i.pauseDuration + n })) };
  }
}, Gi = [], Vi = { toasts: [], pausedAt: void 0 }, Sa = (e) => {
  Vi = _5(Vi, e), Gi.forEach((t) => {
    t(Vi);
  });
}, FC = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, GC = (e = {}) => {
  let [t, r] = te(Vi);
  he(() => (Gi.push(r), () => {
    let n = Gi.indexOf(r);
    n > -1 && Gi.splice(n, 1);
  }), [t]);
  let a = t.toasts.map((n) => {
    var i, o, s;
    return { ...e, ...e[n.type], ...n, removeDelay: n.removeDelay || ((i = e[n.type]) == null ? void 0 : i.removeDelay) || (e == null ? void 0 : e.removeDelay), duration: n.duration || ((o = e[n.type]) == null ? void 0 : o.duration) || (e == null ? void 0 : e.duration) || FC[n.type], style: { ...e.style, ...(s = e[n.type]) == null ? void 0 : s.style, ...n.style } };
  });
  return { ...t, toasts: a };
}, VC = (e, t = "blank", r) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...r, id: (r == null ? void 0 : r.id) || jC() }), xi = (e) => (t, r) => {
  let a = VC(t, e, r);
  return Sa({ type: 2, toast: a }), a.id;
}, We = (e, t) => xi("blank")(e, t);
We.error = xi("error");
We.success = xi("success");
We.loading = xi("loading");
We.custom = xi("custom");
We.dismiss = (e) => {
  Sa({ type: 3, toastId: e });
};
We.remove = (e) => Sa({ type: 4, toastId: e });
We.promise = (e, t, r) => {
  let a = We.loading(t.loading, { ...r, ...r == null ? void 0 : r.loading });
  return typeof e == "function" && (e = e()), e.then((n) => {
    let i = t.success ? l1(t.success, n) : void 0;
    return i ? We.success(i, { id: a, ...r, ...r == null ? void 0 : r.success }) : We.dismiss(a), n;
  }).catch((n) => {
    let i = t.error ? l1(t.error, n) : void 0;
    i ? We.error(i, { id: a, ...r, ...r == null ? void 0 : r.error }) : We.dismiss(a);
  }), e;
};
var KC = (e, t) => {
  Sa({ type: 1, toast: { id: e, height: t } });
}, zC = () => {
  Sa({ type: 5, time: Date.now() });
}, Rr = /* @__PURE__ */ new Map(), UC = 1e3, ZC = (e, t = UC) => {
  if (Rr.has(e)) return;
  let r = setTimeout(() => {
    Rr.delete(e), Sa({ type: 4, toastId: e });
  }, t);
  Rr.set(e, r);
}, YC = (e) => {
  let { toasts: t, pausedAt: r } = GC(e);
  he(() => {
    if (r) return;
    let i = Date.now(), o = t.map((s) => {
      if (s.duration === 1 / 0) return;
      let l = (s.duration || 0) + s.pauseDuration - (i - s.createdAt);
      if (l < 0) {
        s.visible && We.dismiss(s.id);
        return;
      }
      return setTimeout(() => We.dismiss(s.id), l);
    });
    return () => {
      o.forEach((s) => s && clearTimeout(s));
    };
  }, [t, r]);
  let a = _e(() => {
    r && Sa({ type: 6, time: Date.now() });
  }, [r]), n = _e((i, o) => {
    let { reverseOrder: s = !1, gutter: l = 8, defaultPosition: c } = o || {}, d = t.filter((h) => (h.position || c) === (i.position || c) && h.height), p = d.findIndex((h) => h.id === i.id), f = d.filter((h, m) => m < p && h.visible).length;
    return d.filter((h) => h.visible).slice(...s ? [f + 1] : [0, f]).reduce((h, m) => h + (m.height || 0) + l, 0);
  }, [t]);
  return he(() => {
    t.forEach((i) => {
      if (i.dismissed) ZC(i.id, i.removeDelay);
      else {
        let o = Rr.get(i.id);
        o && (clearTimeout(o), Rr.delete(i.id));
      }
    });
  }, [t]), { toasts: t, handlers: { updateHeight: KC, startPause: zC, endPause: a, calculateOffset: n } };
}, WC = Tn`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $C = Tn`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, JC = Tn`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, QC = $n("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${WC} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$C} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${JC} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, qC = Tn`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, XC = $n("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${qC} 1s linear infinite;
`, ev = Tn`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, tv = Tn`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, nv = $n("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ev} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${tv} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, av = $n("div")`
  position: absolute;
`, rv = $n("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, iv = Tn`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ov = $n("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${iv} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, sv = ({ toast: e }) => {
  let { icon: t, type: r, iconTheme: a } = e;
  return t !== void 0 ? typeof t == "string" ? Y.createElement(ov, null, t) : t : r === "blank" ? null : Y.createElement(rv, null, Y.createElement(XC, { ...a }), r !== "loading" && Y.createElement(av, null, r === "error" ? Y.createElement(QC, { ...a }) : Y.createElement(nv, { ...a })));
}, lv = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, uv = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, cv = "0%{opacity:0;} 100%{opacity:1;}", dv = "0%{opacity:1;} 100%{opacity:0;}", pv = $n("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, fv = $n("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, hv = (e, t) => {
  let r = e.includes("top") ? 1 : -1, [a, n] = S5() ? [cv, dv] : [lv(r), uv(r)];
  return { animation: t ? `${Tn(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${Tn(n)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, mv = Y.memo(({ toast: e, position: t, style: r, children: a }) => {
  let n = e.height ? hv(e.position || t || "top-center", e.visible) : { opacity: 0 }, i = Y.createElement(sv, { toast: e }), o = Y.createElement(fv, { ...e.ariaProps }, l1(e.message, e));
  return Y.createElement(pv, { className: e.className, style: { ...n, ...r, ...e.style } }, typeof a == "function" ? a({ icon: i, message: o }) : Y.createElement(Y.Fragment, null, i, o));
});
OC(Y.createElement);
var gv = ({ id: e, className: t, style: r, onHeightUpdate: a, children: n }) => {
  let i = Y.useCallback((o) => {
    if (o) {
      let s = () => {
        let l = o.getBoundingClientRect().height;
        a(e, l);
      };
      s(), new MutationObserver(s).observe(o, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [e, a]);
  return Y.createElement("div", { ref: i, className: t, style: r }, n);
}, Cv = (e, t) => {
  let r = e.includes("top"), a = r ? { top: 0 } : { bottom: 0 }, n = e.includes("center") ? { justifyContent: "center" } : e.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: S5() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t * (r ? 1 : -1)}px)`, ...a, ...n };
}, vv = oo`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, Ni = 16, bv = ({ reverseOrder: e, position: t = "top-center", toastOptions: r, gutter: a, children: n, containerStyle: i, containerClassName: o }) => {
  let { toasts: s, handlers: l } = YC(r);
  return Y.createElement("div", { id: "_rht_toaster", style: { position: "fixed", zIndex: 9999, top: Ni, left: Ni, right: Ni, bottom: Ni, pointerEvents: "none", ...i }, className: o, onMouseEnter: l.startPause, onMouseLeave: l.endPause }, s.map((c) => {
    let d = c.position || t, p = l.calculateOffset(c, { reverseOrder: e, gutter: a, defaultPosition: t }), f = Cv(d, p);
    return Y.createElement(gv, { id: c.id, key: c.id, onHeightUpdate: l.updateHeight, className: c.visible ? vv : "", style: f }, c.type === "custom" ? l1(c.message, c) : n ? n(c) : Y.createElement(mv, { toast: c, position: d }));
  }));
}, yv = We, El = {}, x5 = {}, Dl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.instanceOfHashable = e.guessType = e.guessObjectType = e.TYPE_MAP = void 0, e.TYPE_MAP = {
    Array: "array",
    Int8Array: "typedarray",
    Uint8Array: "typedarray",
    Uint8ClampedArray: "typedarray",
    Int16Array: "typedarray",
    Uint16Array: "typedarray",
    Int32Array: "typedarray",
    Uint32Array: "typedarray",
    Float32Array: "typedarray",
    Float64Array: "typedarray",
    BigUint64Array: "typedarray",
    BigInt64Array: "typedarray",
    Buffer: "typedarray",
    Map: "map",
    Set: "set",
    Date: "date",
    String: "string",
    Number: "number",
    BigInt: "bigint",
    Boolean: "boolean",
    Object: "object"
  };
  const t = (n) => {
    var o;
    if (n === null)
      return "null";
    if ((0, e.instanceOfHashable)(n))
      return "hashable";
    const i = ((o = n == null ? void 0 : n.constructor) == null ? void 0 : o.name) ?? "unknown";
    return e.TYPE_MAP[i] || "unknown";
  };
  e.guessObjectType = t;
  const r = (n) => {
    const i = typeof n;
    return i !== "object" ? i : (0, e.guessObjectType)(n);
  };
  e.guessType = r;
  const a = (n) => typeof n.toHashableString == "function";
  e.instanceOfHashable = a;
})(Dl);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e._mapSort = e._map = e._objectSort = e._object = e._setCoerce = e._set = e._setSort = e._setSortCoerce = e._typedArray = e._typedArraySort = e._array = e._arraySort = e._date = e._dateCoerce = e._functionTrim = e._functionTrimCoerce = e._function = e._functionCoerce = e._null = e._nullCoerce = e._undefined = e._undefinedCoerce = e._symbol = e._symbolCoerce = e._boolean = e._booleanCoerce = e._bigInt = e._bigIntCoerce = e._number = e._numberCoerce = e._stringTrim = e._stringTrimCoerce = e._string = e._stringCoerce = e._hashable = e.PREFIX = void 0;
  const t = Dl;
  e.PREFIX = {
    string: "<:s>",
    number: "<:n>",
    bigint: "<:bi>",
    boolean: "<:b>",
    symbol: "<:smbl>",
    undefined: "<:undf>",
    null: "<:null>",
    function: "<:func>",
    array: "",
    date: "<:date>",
    set: "<:set>",
    map: "<:map>"
  };
  function r(E) {
    return E.toHashableString();
  }
  e._hashable = r;
  function a(E) {
    return E;
  }
  e._stringCoerce = a;
  function n(E) {
    return e.PREFIX.string + ":" + E;
  }
  e._string = n;
  function i(E) {
    return E.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrimCoerce = i;
  function o(E) {
    return e.PREFIX.string + ":" + E.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrim = o;
  function s(E) {
    return E.toString();
  }
  e._numberCoerce = s;
  function l(E) {
    return `${e.PREFIX.number}:${E}`;
  }
  e._number = l;
  function c(E) {
    return E.toString();
  }
  e._bigIntCoerce = c;
  function d(E) {
    return `${e.PREFIX.bigint}:${E.toString()}`;
  }
  e._bigInt = d;
  function p(E) {
    return E ? "1" : "0";
  }
  e._booleanCoerce = p;
  function f(E) {
    return e.PREFIX.boolean + ":" + E.toString();
  }
  e._boolean = f;
  function h() {
    return e.PREFIX.symbol;
  }
  e._symbolCoerce = h;
  function m(E) {
    return e.PREFIX.symbol + ":" + E.toString();
  }
  e._symbol = m;
  function C() {
    return "";
  }
  e._undefinedCoerce = C;
  function g() {
    return e.PREFIX.undefined;
  }
  e._undefined = g;
  function v() {
    return "";
  }
  e._nullCoerce = v;
  function b() {
    return e.PREFIX.null;
  }
  e._null = b;
  function y(E) {
    return E.name + "=>" + E.toString();
  }
  e._functionCoerce = y;
  function x(E) {
    return e.PREFIX.function + ":" + E.name + "=>" + E.toString();
  }
  e._function = x;
  function S(E) {
    return E.name + "=>" + E.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrimCoerce = S;
  function _(E) {
    return e.PREFIX.function + ":" + E.name + "=>" + E.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrim = _;
  function M(E) {
    return E.toISOString();
  }
  e._dateCoerce = M;
  function I(E) {
    return e.PREFIX.date + ":" + E.toISOString();
  }
  e._date = I;
  function L(E) {
    const G = this;
    return "[" + E.map((R) => G[(0, t.guessType)(R)](R)).sort().toString() + "]";
  }
  e._arraySort = L;
  function D(E) {
    const G = this;
    return "[" + E.map((R) => G[(0, t.guessType)(R)](R)).toString() + "]";
  }
  e._array = D;
  function A(E) {
    const G = this;
    return "[" + Array.prototype.slice.call(E).map(($) => G[(0, t.guessType)($)]($)).sort().toString() + "]";
  }
  e._typedArraySort = A;
  function B(E) {
    const G = this;
    return "[" + Array.prototype.slice.call(E).map(($) => G[(0, t.guessType)($)]($)).toString() + "]";
  }
  e._typedArray = B;
  function U(E) {
    return L.call(this, Array.from(E));
  }
  e._setSortCoerce = U;
  function H(E) {
    return `${e.PREFIX.set}:${L.call(this, Array.from(E))}`;
  }
  e._setSort = H;
  function K(E) {
    return `${e.PREFIX.set}:${D.call(this, Array.from(E))}`;
  }
  e._set = K;
  function Z(E) {
    return D.call(this, Array.from(E));
  }
  e._setCoerce = Z;
  function V(E) {
    const G = this, R = Object.keys(E), $ = [];
    for (const W of R) {
      const re = E[W], ae = (0, t.guessType)(re);
      $.push(W + ":" + G[ae](re));
    }
    return "{" + $.toString() + "}";
  }
  e._object = V;
  function O(E) {
    const G = this, R = Object.keys(E).sort(), $ = [];
    for (const W of R) {
      const re = E[W], ae = (0, t.guessType)(re);
      $.push(W + ":" + G[ae](re));
    }
    return "{" + $.toString() + "}";
  }
  e._objectSort = O;
  function j(E) {
    const G = this, R = Array.from(E), $ = [];
    for (const W of R) {
      const [re, ae] = W;
      $.push([G[(0, t.guessType)(re)](re), G[(0, t.guessType)(ae)](ae)]);
    }
    return "[" + $.join(";") + "]";
  }
  e._map = j;
  function N(E) {
    const G = this, R = Array.from(E), $ = [];
    for (const W of R) {
      const [re, ae] = W;
      $.push([G[(0, t.guessType)(re)](re), G[(0, t.guessType)(ae)](ae)]);
    }
    return "[" + $.sort().join(";") + "]";
  }
  e._mapSort = N;
})(x5);
var wv = Fa && Fa.__createBinding || (Object.create ? function(e, t, r, a) {
  a === void 0 && (a = r);
  var n = Object.getOwnPropertyDescriptor(t, r);
  (!n || ("get" in n ? !t.__esModule : n.writable || n.configurable)) && (n = { enumerable: !0, get: function() {
    return t[r];
  } }), Object.defineProperty(e, a, n);
} : function(e, t, r, a) {
  a === void 0 && (a = r), e[a] = t[r];
}), Sv = Fa && Fa.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), _v = Fa && Fa.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var r in e) r !== "default" && Object.prototype.hasOwnProperty.call(e, r) && wv(t, e, r);
  return Sv(t, e), t;
};
Object.defineProperty(El, "__esModule", { value: !0 });
var vs = El.objectSorter = void 0;
const Ae = _v(x5), xv = Dl, Mv = (e) => {
  const { sort: t, coerce: r, trim: a } = {
    sort: !0,
    coerce: !0,
    trim: !1,
    ...e
  }, n = {
    array: typeof t == "boolean" ? t : (t == null ? void 0 : t.array) ?? !1,
    typedArray: typeof t == "boolean" ? !1 : (t == null ? void 0 : t.typedArray) ?? !1,
    object: typeof t == "boolean" ? t : (t == null ? void 0 : t.object) ?? !1,
    set: typeof t == "boolean" ? t : (t == null ? void 0 : t.set) ?? !1,
    map: typeof t == "boolean" ? t : (t == null ? void 0 : t.map) ?? !1
  }, i = {
    boolean: typeof r == "boolean" ? r : (r == null ? void 0 : r.boolean) ?? !1,
    number: typeof r == "boolean" ? r : (r == null ? void 0 : r.number) ?? !1,
    bigint: typeof r == "boolean" ? r : (r == null ? void 0 : r.bigint) ?? !1,
    string: typeof r == "boolean" ? r : (r == null ? void 0 : r.string) ?? !1,
    undefined: typeof r == "boolean" ? r : (r == null ? void 0 : r.undefined) ?? !1,
    null: typeof r == "boolean" ? r : (r == null ? void 0 : r.null) ?? !1,
    symbol: typeof r == "boolean" ? r : (r == null ? void 0 : r.symbol) ?? !1,
    function: typeof r == "boolean" ? r : (r == null ? void 0 : r.function) ?? !1,
    date: typeof r == "boolean" ? r : (r == null ? void 0 : r.date) ?? !1,
    set: typeof r == "boolean" ? r : (r == null ? void 0 : r.set) ?? !1
  }, o = {
    string: typeof a == "boolean" ? a : (a == null ? void 0 : a.string) ?? !1,
    function: typeof a == "boolean" ? a : (a == null ? void 0 : a.function) ?? !1
  }, s = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    unknown: function(d) {
      var h;
      const p = ((h = d.constructor) == null ? void 0 : h.name) ?? "unknonw";
      let f = "unknown";
      return typeof d.toString == "function" ? f = d.toString() : Object.keys(d).length > 0 && (f = JSON.stringify(d)), `<:${p}>:${f}`;
    }
  };
  s.hashable = Ae._hashable.bind(s), o.string ? s.string = i.string ? Ae._stringTrimCoerce.bind(s) : Ae._stringTrim.bind(s) : s.string = i.string ? Ae._stringCoerce.bind(s) : Ae._string.bind(s), s.number = i.number ? Ae._numberCoerce.bind(s) : Ae._number.bind(s), s.bigint = i.bigint ? Ae._bigIntCoerce.bind(s) : Ae._bigInt.bind(s), s.boolean = i.boolean ? Ae._booleanCoerce.bind(s) : Ae._boolean.bind(s), s.symbol = i.symbol ? Ae._symbolCoerce.bind(s) : Ae._symbol.bind(s), s.undefined = i.undefined ? Ae._undefinedCoerce.bind(s) : Ae._undefined.bind(s), s.null = i.null ? Ae._nullCoerce.bind(s) : Ae._null.bind(s), o.function ? s.function = i.function ? Ae._functionTrimCoerce.bind(s) : Ae._functionTrim.bind(s) : s.function = i.function ? Ae._functionCoerce.bind(s) : Ae._function.bind(s), s.date = i.date ? Ae._dateCoerce.bind(s) : Ae._date.bind(s), s.array = n.array ? Ae._arraySort.bind(s) : Ae._array.bind(s), s.typedarray = n.typedArray ? Ae._typedArraySort.bind(s) : Ae._typedArray.bind(s), n.set ? s.set = i.set ? Ae._setSortCoerce.bind(s) : Ae._setSort.bind(s) : s.set = i.set ? Ae._setCoerce.bind(s) : Ae._set.bind(s), s.object = n.object ? Ae._objectSort.bind(s) : Ae._object.bind(s), s.map = n.map ? Ae._mapSort.bind(s) : Ae._map.bind(s);
  function l(c) {
    return s[(0, xv.guessType)(c)](c);
  }
  return l;
};
vs = El.objectSorter = Mv;
const kv = We.error, Pv = We.success, Tv = We.loading, Ev = We.custom, so = (e) => {
  const t = {
    id: "mock-id",
    type: "blank",
    message: e,
    visible: !0,
    ariaProps: { role: "status", "aria-live": "polite" },
    pauseDuration: 0,
    createdAt: 0,
    dismissed: !1
  };
  let r;
  return typeof e == "string" ? r = e : typeof e == "function" ? r = JSON.stringify(vs()(e(t))) : typeof e == "object" && (r = JSON.stringify(vs()(e))), r;
};
We.error = (e, t) => kv(e, {
  id: so(e),
  ...t
});
We.success = (e, t) => Pv(e, {
  id: so(e),
  ...t
});
We.loading = (e, t) => Tv(e, {
  id: so(e),
  ...t
});
We.custom = (e, t) => Ev(e, {
  id: so(e),
  ...t
});
async function Dv(e, t) {
  try {
    if (!document.hasFocus())
      throw new Error();
    await navigator.clipboard.writeText(e), t && We.success(t);
  } catch {
    We.error(ue.t("public_pages_purchase.copy_clipboard_error"));
  }
}
const Iv = "group ui-group ui-min-h-[42px] ui-relative ui-rounded-lg ui-py-2.5 ui-font-medium ui-text-sm ui-main-transition-colors ui-focus-ring ui-whitespace-nowrap [&>*]:ui-font-medium [&>*]:ui-font-inter ui-font-inter", Lv = "ui-flex ui-items-center ui-justify-center ui-gap-2", Av = (e) => "href" in e, Nv = ({
  as: e = "a",
  href: t,
  isFetching: r,
  className: a,
  children: n,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || r ? /* @__PURE__ */ u.jsx("button", { className: a, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ u.jsx(bs, { buttonTextClassName: i, isFetching: r, children: n }) }) : /* @__PURE__ */ u.jsx(e, { className: a, href: t, ...o, children: /* @__PURE__ */ u.jsx(bs, { buttonTextClassName: i, isFetching: r, children: n }) }), bs = ({
  children: e,
  isFetching: t,
  buttonTextClassName: r
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    className: z(
      "ui-flex ui-items-center ui-justify-center ui-gap-2 ui-truncate",
      t && "ui-opacity-0",
      r
    ),
    children: e
  }
), _a = ({
  width: e = "small",
  isFetching: t,
  backgroundColor: r,
  color: a,
  hoverColor: n,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: s,
  loaderType: l,
  testAttributePostfix: c,
  className: d,
  buttonTextClassName: p,
  loaderClassName: f,
  as: h,
  ...m
}) => {
  const C = m, g = z(
    n1(
      Iv,
      Lv,
      r,
      a,
      n,
      i,
      e === "small" ? "ui-px-4" : "ui-px-10",
      o && `ui-border ${o}`,
      s,
      t && "ui-pointer-events-none ui-select-none"
    ),
    d
  ), v = z(
    n1(
      "ui-absolute",
      t ? "ui-visible" : "ui-invisible",
      "-ui-translate-x-1/2 ui-left-1/2"
    ),
    f
  );
  if (Av(C)) {
    const { "aria-disabled": b, ...y } = C;
    return /* @__PURE__ */ u.jsx(
      Nv,
      {
        as: h,
        isFetching: t,
        "aria-disabled": b || t,
        className: z(g, b && "ui-bg-gray/50 ui-pointer-events-none"),
        ...y,
        ...ps(!!c, `${c}`),
        children: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx(a1, { small: !0, type: l, className: v }),
          C.children
        ] })
      }
    );
  } else {
    const { disabled: b, ...y } = C;
    return /* @__PURE__ */ u.jsxs(
      "button",
      {
        disabled: t || b,
        className: z(g, b && "ui-bg-gray/50 ui-pointer-events-none"),
        ...y,
        ...ps(!!c, `${c}`),
        children: [
          /* @__PURE__ */ u.jsx(a1, { small: !0, type: l, className: v }),
          /* @__PURE__ */ u.jsx(bs, { buttonTextClassName: p, isFetching: t, children: C.children })
        ]
      }
    );
  }
}, mP = (e) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-darkblue/50",
    hoverColor: "hover:ui-text-white",
    backgroundColor: "ui-bg-white",
    hoverBackgroundColor: "hover:ui-bg-blue",
    ...e
  }
);
var za = /* @__PURE__ */ ((e) => (e.danger = "danger", e.blue = "blue", e))(za || {});
const Rv = (e) => {
  switch (e) {
    case za.danger:
      return "hover:ui-text-danger";
    case za.blue:
      return "hover:ui-text-blue";
    default:
      return "ui-text-blue";
  }
}, Ov = (e) => {
  switch (e) {
    case za.danger:
      return "hover:ui-border-danger";
    case za.blue:
      return "hover:ui-border-blue";
    default:
      return "ui-border-blue";
  }
}, gP = ({
  neutralType: e = za.blue,
  ...t
}) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-darkblue",
    hoverColor: Rv(e),
    backgroundColor: "ui-bg-white",
    hoverBackgroundColor: "hover:ui-bg-white",
    borderColor: "ui-border-gray/30",
    hoverBorderColor: Ov(e),
    ...t
  }
), CP = (e) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-darkblue",
    hoverColor: "hover:ui-text-white",
    backgroundColor: "ui-bg-transparent",
    hoverBackgroundColor: "hover:ui-bg-darkblue",
    borderColor: "ui-border-darkblue",
    loaderType: "dark",
    ...e
  }
), vP = (e) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-white",
    hoverColor: "hover:ui-text-white",
    backgroundColor: "ui-bg-green",
    hoverBackgroundColor: "hover:ui-bg-green",
    ...e
  }
), su = ({ selected: e, ...t }) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: e ? "ui-text-blue" : "ui-text-darkblue",
    hoverColor: e ? "hover:ui-text-blue" : "hover:ui-text-darkblue",
    backgroundColor: e ? "ui-bg-blue-50" : "ui-bg-white",
    hoverBackgroundColor: "hover:ui-bg-blue-50",
    borderColor: e ? "ui-border-blue" : "ui-border-gray/30",
    hoverBorderColor: "ui-border-blue",
    type: "button",
    ...t
  }
), M5 = (e) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-white",
    hoverColor: "hover:ui-text-white",
    backgroundColor: "ui-bg-blue",
    hoverBackgroundColor: "hover:ui-bg-blue-300",
    ...e
  }
), k5 = (e) => /* @__PURE__ */ u.jsx(
  _a,
  {
    color: "ui-text-white",
    hoverColor: "hover:ui-text-white",
    backgroundColor: "ui-bg-danger",
    hoverBackgroundColor: "hover:ui-bg-danger",
    ...e
  }
);
function Bv({
  active: e,
  isFetching: t,
  iconClassName: r,
  menuButtonClassName: a,
  dataTestAttributes: n,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ u.jsx(
    ll,
    {
      disabled: t,
      className: z(
        !i && "ui-h-[30px] lg:ui-h-[20px] ui-transition-colors hover:ui-bg-blue ui-group ui-focus-ring ui-rounded-lg ui-px-3 ui-py-1",
        !i && (e ? "ui-bg-blue" : "ui-bg-lightgray"),
        t && "ui-animate-pulse ui-pointer-events-none",
        a
      ),
      ...n,
      ...o,
      children: typeof i == "function" ? (s) => i({ ...s, active: e }) : i ?? /* @__PURE__ */ u.jsx(
        ah,
        {
          className: z(
            "group-hover:ui-fill-white",
            e && "ui-fill-white",
            r
          )
        }
      )
    }
  );
}
const bP = ({
  menuItems: e,
  anchor: t = {
    to: "left start",
    gap: 4,
    padding: 4
  },
  menuItemsClassName: r,
  toggleOnHover: a = !0,
  ...n
}) => {
  const { show: i, close: o, delayOpen: s, delayClose: l } = l0();
  return /* @__PURE__ */ u.jsx(L3, { children: ({ open: c, close: d }) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      Bv,
      {
        ...n,
        active: a && i || c,
        onMouseEnter: s,
        onMouseLeave: l
      }
    ),
    /* @__PURE__ */ u.jsx(
      Kn,
      {
        show: a && i || c,
        enter: "transition ease-out duration-100",
        enterFrom: "transform opacity-0",
        enterTo: "transform opacity-100",
        leave: "transition ease-in duration-75",
        leaveFrom: "transform opacity-100",
        leaveTo: "transform opacity-0",
        children: /* @__PURE__ */ u.jsx(
          ul,
          {
            onClick: () => {
              d(), o();
            },
            static: !0,
            anchor: t,
            className: z(
              "ui-bg-white ui-border ui-border-gray-200 ui-rounded-lg ui-shadow-lg ui-overflow-hidden focus:ui-outline-none",
              r
            ),
            portal: !0,
            onMouseEnter: s,
            onMouseLeave: l,
            children: e
          }
        )
      }
    )
  ] }) });
}, jv = "ui-group aria-pressed:ui-text-blue hover:ui-text-blue ui-flex ui-items-center ui-gap-2 ui-w-full ui-px-4 ui-py-3 lg:ui-py-2 ui-text-left ui-text-sm ui-transition-colors ui-border-b ui-border-gray-200 last:ui-border-0", yP = ({
  dataTestAttributes: e,
  onClick: t,
  label: r,
  buttonClassName: a,
  labelClassName: n,
  children: i,
  ...o
}) => /* @__PURE__ */ u.jsx(cl, { ...o, children: i || (({ focus: s }) => /* @__PURE__ */ u.jsx(
  "button",
  {
    onClick: t,
    "aria-pressed": s,
    type: "button",
    className: z(
      jv,
      o.disabled && "hover:ui-text-gray ui-text-gray ui-cursor-not-allowed",
      a
    ),
    ...e,
    children: /* @__PURE__ */ u.jsx("span", { className: n, children: r })
  }
)) }, "action-settings"), Hv = (e) => {
  switch (e) {
    case "success":
      return "ui-border-green";
    case "error":
      return "ui-border-danger";
    default:
      return "ui-border-blue";
  }
}, Fv = (e) => {
  switch (e) {
    case "success":
      return "hover:ui-fill-green group-focus-visible:ui-fill-green";
    case "error":
      return "hover:ui-fill-danger group-focus-visible:ui-fill-danger";
    default:
      return "hover:ui-fill-blue group-focus-visible:ui-fill-blue";
  }
}, P5 = ({
  t: e,
  afterClose: t,
  className: r,
  titleClassName: a,
  buttonClassName: n,
  hideCloseButton: i
}) => {
  const o = Q(null), s = Hv(e.type), l = Fv(e.type);
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: z(
        "ui-shadow-lg ui-flex ui-gap-2.5 ui-items-center ui-bg-white ui-border ui-rounded-lg ui-px-2.5 ui-py-2 ui-text-gray-300 ui-max-w-[350px]",
        e.visible ? "ui-animate-toast-enter" : "ui-animate-toast-leave",
        s,
        r
      ),
      "data-test-id": `toast-${e.type}`,
      children: [
        e.icon,
        /* @__PURE__ */ u.jsx("div", { className: z("ui-break-words", a), children: e.message }),
        !i && /* @__PURE__ */ u.jsx(
          "button",
          {
            ref: o,
            className: z("ui-h-fit ui-outline-none ui-group", n),
            onClick: () => {
              yv.dismiss(e.id), t && t();
            },
            children: /* @__PURE__ */ u.jsx(
              _i,
              {
                className: z("ui-fill-gray-100 ui-main-transition-colors", l)
              }
            )
          }
        )
      ]
    }
  );
}, wP = ({
  className: e,
  titleClassName: t,
  buttonClassName: r,
  afterClose: a
}) => /* @__PURE__ */ u.jsx(
  bv,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:ui-primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ u.jsx(Xf, { className: "ui-flex-shrink-0 ui-fill-green ui-w-[16px] sm:ui-w-[20px] ui-h-[16px] sm:ui-h-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ u.jsx(th, { className: "ui-flex-shrink-0 ui-fill-danger ui-w-[16px] sm:ui-w-[20px] ui-h-[16px] sm:ui-h-[20px]" }),
        duration: 3e3
      }
    },
    children: (n) => /* @__PURE__ */ u.jsx(
      P5,
      {
        t: n,
        className: e,
        titleClassName: t,
        buttonClassName: r,
        afterClose: a
      }
    )
  }
), SP = ({
  className: e,
  titleClassName: t,
  buttonClassName: r
} = {}) => ({ infoToast: _e(
  (n, i, o, s) => We.custom(
    (l) => /* @__PURE__ */ u.jsx(
      P5,
      {
        t: { ...l, message: n },
        className: e,
        titleClassName: t,
        buttonClassName: r,
        afterClose: o,
        hideCloseButton: s
      }
    ),
    {
      duration: 6e5,
      icon: /* @__PURE__ */ u.jsx(i0, { className: "ui-flex-shrink-0 ui-fill-blue ui-w-[16px] sm:ui-w-[20px] ui-h-[16px] sm:ui-h-[20px]" }),
      ...i
    }
  ),
  []
) }), _P = ({
  options: e,
  selected: t,
  onChange: r,
  disabled: a,
  error: n,
  label: i,
  required: o,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: c,
  optionWrapperClassName: d,
  selectedOptionWrapperClassName: p,
  optionClassName: f,
  inputClassName: h
}) => /* @__PURE__ */ u.jsxs("div", { className: z("ui-flex ui-flex-col ui-gap-1", s), children: [
  /* @__PURE__ */ u.jsx(wa, { label: i, labelClassName: l, required: o }),
  /* @__PURE__ */ u.jsx("ul", { className: z("ui-flex ui-gap-5 ui-items-center", c), children: e ? e.map((m) => /* @__PURE__ */ u.jsx(
    xl,
    {
      label: m.tooltipLabel ?? "",
      disabled: !m.showTooltip,
      children: /* @__PURE__ */ u.jsx(
        "li",
        {
          className: z(
            d,
            m.id === t && p
          ),
          children: /* @__PURE__ */ u.jsxs(
            "label",
            {
              className: z(
                "ui-relative ui-r ui-flex ui-gap-2 ui-items-center ui-w-fit",
                !a && "ui-cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ u.jsx(
                  "input",
                  {
                    className: z(
                      "ui-outline-none ui-border-2",
                      a ? "ui-border-gray-100/70" : "ui-border-gray-100",
                      "ui-w-[20px] ui-h-[20px] ui-rounded-full",
                      m.id === t ? "ui-bg-white" : "ui-bg-transparent",
                      "ui-appearance-none main-transition-colors ui-focus-ring ui-flex-shrink-0",
                      h
                    ),
                    disabled: a || m.disabled,
                    checked: m.id === t,
                    value: m.caption,
                    onChange: () => r(m.id),
                    type: "radio"
                  }
                ),
                /* @__PURE__ */ u.jsx(
                  "svg",
                  {
                    width: 20,
                    height: 20,
                    className: z(
                      "ui-absolute main-transition-colors",
                      m.id === t ? "ui-fill-green" : "ui-fill-transparent",
                      a && "ui-opacity-70"
                    ),
                    children: /* @__PURE__ */ u.jsx(
                      "path",
                      {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-items-center ui-gap-3", children: [
                  /* @__PURE__ */ u.jsx(
                    "span",
                    {
                      className: z(
                        "main-transition-colors",
                        m.id === t ? "ui-text-darkblue" : "ui-text-darkblue/50",
                        a && "ui-opacity-70",
                        f,
                        "ui-text-left"
                      ),
                      children: m.caption
                    }
                  ),
                  m.additionalInfo
                ] })
              ]
            }
          )
        }
      )
    },
    m.id
  )) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      "li",
      {
        className: "ui-text-transparent ui-bg-gray-600 ui-animate-pulse ui-rounded-full ui-h-[20px] ui-w-[20px]",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ u.jsx(
      "li",
      {
        className: "ui-text-transparent ui-bg-gray-600 ui-animate-pulse ui-rounded-full ui-h-[20px] ui-w-[20px]",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ u.jsx(ya, { error: n })
] });
function Il({
  arrowButtonClassName: e,
  open: t,
  isDisabled: r,
  As: a = wi
}) {
  return /* @__PURE__ */ u.jsx(
    a,
    {
      as: "div",
      className: z(
        "ui-flex ui-items-center",
        "ui-focus-ring",
        "ui-rounded-md",
        r && "ui-cursor-not-allowed",
        e
      ),
      disabled: r,
      children: /* @__PURE__ */ u.jsx(
        a0,
        {
          className: z("ui-stroke-darkblue ui-main-transition", t && "ui-rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function Ll({ onClick: e, closeButtonClassName: t, isDisabled: r }) {
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      type: "button",
      className: z(
        "ui-flex ui-items-center",
        "ui-focus-ring",
        "ui-rounded-md",
        r && "ui-cursor-not-allowed",
        t
      ),
      onClick: e,
      disabled: r,
      children: /* @__PURE__ */ u.jsx(_i, { className: "ui-h-4 ui-w-4 ui-fill-darkblue" })
    }
  );
}
const T5 = "ui-text-[16px] sm:ui-text-sm", Al = "ui-px-4 ui-py-2.5";
function E5({
  isDisabled: e,
  open: t,
  hasError: r,
  className: a,
  placeholder: n,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: s,
  onChange: l,
  inputRef: c,
  dataTest: d
}) {
  return /* @__PURE__ */ u.jsx(
    Ws,
    {
      ref: c,
      className: z(
        "ui-truncate ui-w-full",
        T5,
        "ui-flex ui-items-center ui-justify-between",
        Al,
        "ui-pr-14 ui-rounded-lg",
        "ui-cursor-default ui-text-darkblue placeholder:ui-text-gray-300/70",
        "ui-border focus:ui-outline-none focus-visible:ui-border-blue",
        "ui-main-transition-colors",
        e ? "ui-bg-gray-600/20" : "ui-bg-white",
        t ? "ui-border-blue" : r ? "ui-border-danger" : "ui-border-gray/30",
        o && [
          "ui-animate-pulse",
          "ui-text-transparent placeholder:ui-text-transparent"
        ],
        a
      ),
      onChange: (p) => l == null ? void 0 : l(p.target.value),
      onKeyDown: (p) => p.stopPropagation(),
      onFocus: s,
      displayValue: i ? () => i : void 0,
      placeholder: n ?? ue.t("public_pages_purchase.form_select.select"),
      ...d
    }
  );
}
const D5 = ({
  item: e,
  optionClassName: t,
  optionIconWrapperClassName: r,
  optionRef: a,
  as: n
}) => {
  const i = (e == null ? void 0 : e.customCaption) ?? (e == null ? void 0 : e.caption), o = ({ disabled: l, selected: c }) => z(
    "ui-bg-white ui-text-darkblue",
    Al,
    "ui-border-b last:ui-border-b-0 ui-border-gray/30",
    "ui-group hover:ui-bg-blue hover:ui-text-white",
    "data-[focus]:ui-bg-blue data-[focus]:ui-text-white",
    "ui-flex ui-justify-between ui-items-center ui-gap-3 ui-w-full ui-break-all",
    c && "ui-bg-blue ui-text-white",
    l && "ui-bg-gray hover:ui-bg-gray data-[focus]:ui-bg-gray ui-text-white hover:ui-text-white data-[focus]:ui-text-white ui-cursor-not-allowed",
    t,
    e == null ? void 0 : e.className
  ), s = ({ selected: l }) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    i,
    /* @__PURE__ */ u.jsxs("div", { className: z("ui-flex ui-gap-3 ui-items-center", r), children: [
      l && /* @__PURE__ */ u.jsx(
        eh,
        {
          className: n1("ui-h-4 ui-w-4 group-hover:ui-stroke-white ui-stroke-white"),
          "aria-hidden": "true"
        }
      ),
      e == null ? void 0 : e.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ u.jsx(
    n,
    {
      disabled: e == null ? void 0 : e.disabled,
      ref: a,
      value: e,
      className: o,
      "data-test-id": e == null ? void 0 : e.dataTestAttribute,
      children: s
    },
    e == null ? void 0 : e.id
  );
};
function I5({ loaderWrapperClassName: e, loaderClassName: t }) {
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: z(
        "ui-flex ui-justify-center ui-items-center ui-h-full",
        "ui-scale-75",
        e
      ),
      children: /* @__PURE__ */ u.jsx(a1, { className: z(t) })
    }
  );
}
const L5 = Xa(
  ({ children: e, style: t, optionsClassName: r, as: a }, n) => /* @__PURE__ */ u.jsx(
    a,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: n,
      style: t,
      className: z(
        "ui-w-[var(--input-width)] ui-min-w-[200px] ui-h-full",
        "ui-bg-white ui-rounded-lg ui-shadow-around-sm",
        "ui-z-20",
        "ui-transition ui-duration-200 ui-ease-out empty:ui-invisible data-[closed]:ui-opacity-0",
        "ui-customScroll",
        T5,
        r
      ),
      children: e
    }
  )
), lu = 240, A5 = () => ({
  id: void 0,
  caption: ue.t("public_pages_purchase.form_select.empty_list"),
  className: "ui-bg-white hover:ui-bg-white ui-cursor-default ui-text-gray-300/70 hover:ui-text-gray-300/70",
  disabled: !0
}), N5 = (e, t) => {
  let r = 0;
  return e && (e.querySelectorAll('[role="option"]').forEach((n) => {
    r += n.getBoundingClientRect().height;
  }), r = t ? Math.min(r, lu) || lu : 42), r;
};
function R5({
  optionsClassName: e,
  data: t,
  loaderWrapperClassName: r,
  loaderClassName: a,
  asOptions: n,
  asOption: i,
  ...o
}) {
  const [s, l] = te(null), c = N5(s, t);
  return /* @__PURE__ */ u.jsx(
    L5,
    {
      as: n,
      ref: l,
      optionsClassName: e,
      style: { height: c },
      children: ({ option: d }) => t ? D5({ ...o, as: i, item: d }) : /* @__PURE__ */ u.jsx(
        I5,
        {
          loaderWrapperClassName: r,
          loaderClassName: a
        }
      )
    }
  );
}
const O5 = (e, t) => (t == null ? void 0 : t.find((r) => r.id === e)) ?? null, B5 = (e) => {
  const [t, r] = te(""), [a, n] = te(e);
  return he(() => {
    const i = t === "" ? e : (e == null ? void 0 : e.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(t.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    n(() => i);
  }, [e, t]), { filteredData: a, setFilteredData: n, query: t, setQuery: r };
};
function Gv({
  children: e,
  selectedData: t,
  virtual: r,
  disabled: a,
  onClose: n,
  onChange: i
}) {
  return /* @__PURE__ */ u.jsx(
    $s,
    {
      immediate: !0,
      value: t,
      virtual: r,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: a,
      onClose: n,
      children: ({ open: o }) => e(o)
    }
  );
}
const j5 = (e = []) => ({
  options: e.length > 0 ? e : [A5()],
  disabled: (t) => (t == null ? void 0 : t.disabled) ?? !1
});
function xP({
  label: e,
  data: t,
  staticData: r,
  onChange: a,
  labelClassName: n,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: c,
  description: d,
  className: p,
  containerClassName: f,
  closeButtonClassName: h,
  arrowButtonClassName: m,
  fieldClassName: C,
  disabled: g,
  withoutCloseIcon: v,
  onOpen: b,
  onClose: y,
  dataTest: x,
  wrapperProps: S,
  loaderClassName: _,
  loaderWrapperClassName: M,
  inputWrapperClassName: I,
  inputRef: L,
  ...D
}) {
  const [A, B] = te(!1);
  he(() => {
    A && b && (b(), B(!1));
  }, [A]);
  const U = O5(i, t ?? r) ?? null, { filteredData: H, setQuery: K } = B5(t), Z = i !== void 0, j = g || o || Z && (!t && !r), N = Z && !v && !j;
  return /* @__PURE__ */ u.jsxs("div", { className: z("ui-relative ui-flex ui-flex-col ui-gap-1", f), children: [
    /* @__PURE__ */ u.jsx(
      Gv,
      {
        selectedData: U,
        virtual: j5(H),
        onChange: a,
        disabled: j,
        onClose: () => {
          K(""), y == null || y();
        },
        children: (E) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsxs(
            Z1,
            {
              className: z("ui-relative ui-flex ui-flex-col ui-gap-1", C),
              children: [
                /* @__PURE__ */ u.jsx(
                  wa,
                  {
                    wrapperAs: "label",
                    wrapperProps: S,
                    label: e,
                    required: c,
                    labelClassName: z("ui-text-sm ui-font-medium", n)
                  }
                ),
                /* @__PURE__ */ u.jsxs(
                  wi,
                  {
                    as: "button",
                    className: z("ui-relative", I),
                    children: [
                      /* @__PURE__ */ u.jsx(
                        E5,
                        {
                          dataTest: x,
                          inputRef: L,
                          isDisabled: j,
                          hasError: !!l,
                          open: E,
                          className: p,
                          placeholder: s,
                          selectedCaption: (U == null ? void 0 : U.caption) ?? "",
                          isPreFetching: o,
                          onFocus: () => B(!0),
                          onChange: (G) => {
                            B(!0), K(G);
                          }
                        }
                      ),
                      /* @__PURE__ */ u.jsx(
                        Il,
                        {
                          isDisabled: j,
                          arrowButtonClassName: z(
                            "ui-absolute ui-inset-y-0 ui-right-4 ui-h-[46px] sm:ui-h-[42px]",
                            m
                          ),
                          open: E
                        }
                      )
                    ]
                  }
                ),
                N && /* @__PURE__ */ u.jsx(
                  Ll,
                  {
                    isDisabled: j,
                    closeButtonClassName: z(
                      "ui-absolute ui-bottom-0 ui-right-10 ui-h-[46px] sm:ui-h-[42px]",
                      h
                    ),
                    onClick: () => a(void 0)
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ u.jsx(
            R5,
            {
              asOptions: j1,
              asOption: H1,
              data: H,
              ...D
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ u.jsx(ya, { error: l, description: d })
  ] });
}
function MP({
  data: e,
  staticData: t,
  onChange: r,
  value: a,
  isPreFetching: n,
  placeholder: i,
  required: o,
  description: s,
  className: l,
  closeButtonClassName: c,
  arrowButtonClassName: d,
  fieldClassName: p,
  disabled: f,
  withoutCloseIcon: h,
  onOpen: m,
  onClose: C,
  dataTest: g,
  wrapperProps: v,
  loaderClassName: b,
  loaderWrapperClassName: y,
  captionClassName: x,
  inputRef: S,
  optionsClassName: _,
  ...M
}) {
  const [I, L] = te(!1);
  he(() => {
    I && m && (m(), L(!1));
  }, [I]);
  const D = O5(a, e ?? t) ?? null, A = a !== void 0, H = f || n || A && (!e && !t), K = A && !h && !H, Z = q(() => {
    if (e)
      return e.length > 0 ? e : [A5()];
  }, [e]), [V, O] = te(null), j = N5(V, e);
  return /* @__PURE__ */ u.jsx(
    ol,
    {
      value: D,
      onChange: (N) => {
        N !== null && r(N == null ? void 0 : N.id);
      },
      disabled: H,
      children: ({ open: N }) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsxs(
          Z1,
          {
            className: z(
              "ui-relative ui-flex ui-flex-col ui-gap-1 ui-w-fit",
              p
            ),
            children: [
              /* @__PURE__ */ u.jsxs(
                Yr,
                {
                  className: z(
                    "ui-w-fit ui-inline-grid",
                    "ui-pr-6",
                    K && "ui-pr-10",
                    "ui-outline-none ui-focus-ring ui-rounded-md",
                    l
                  ),
                  children: [
                    /* @__PURE__ */ u.jsx(
                      "span",
                      {
                        className: z(
                          "ui-underline ui-decoration-dashed ui-truncate ui-text-start",
                          x
                        ),
                        children: (D == null ? void 0 : D.caption) ?? i ?? ue.t("public_pages_purchase.form_select.select")
                      }
                    ),
                    /* @__PURE__ */ u.jsx(
                      Il,
                      {
                        As: Yr,
                        isDisabled: H,
                        arrowButtonClassName: z(
                          "ui-absolute ui-bottom-0 ui-right-0",
                          "ui-h-6 ui-w-4",
                          d
                        ),
                        open: N
                      }
                    )
                  ]
                }
              ),
              K && /* @__PURE__ */ u.jsx(
                Ll,
                {
                  isDisabled: H,
                  closeButtonClassName: z(
                    "ui-absolute ui-bottom-0 ui-right-5 ",
                    "ui-h-6 ui-w-4",
                    c
                  ),
                  onClick: () => r(void 0)
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ u.jsx(
          L5,
          {
            ref: O,
            style: { height: j },
            as: $1,
            optionsClassName: z("ui-h-fit ui-w-fit ui-outline-none", _),
            children: Z ? Z.map(
              (E) => D5({
                item: E,
                as: il,
                optionClassName: M == null ? void 0 : M.optionClassName,
                optionIconWrapperClassName: M == null ? void 0 : M.optionIconWrapperClassName
              })
            ) : /* @__PURE__ */ u.jsx(
              I5,
              {
                loaderWrapperClassName: z("ui-p-2", y),
                loaderClassName: b
              }
            )
          }
        )
      ] })
    }
  );
}
function Vv({
  children: e,
  selectedData: t,
  virtual: r,
  disabled: a,
  onClose: n,
  onChange: i
}) {
  return /* @__PURE__ */ u.jsx(
    $s,
    {
      immediate: !0,
      multiple: !0,
      value: t,
      virtual: r,
      onChange: (o) => i((o == null ? void 0 : o.filter((s) => s.id !== void 0).map((s) => s.id)) ?? []),
      disabled: a,
      onClose: n,
      children: ({ open: o }) => e(o)
    }
  );
}
function kP({
  label: e,
  data: t,
  staticData: r,
  onChange: a,
  labelClassName: n,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: c,
  description: d,
  className: p,
  containerClassName: f,
  closeButtonClassName: h,
  arrowButtonClassName: m,
  fieldClassName: C,
  disabled: g,
  withoutCloseIcon: v,
  onOpen: b,
  onClose: y,
  dataTest: x,
  wrapperProps: S,
  loaderClassName: _,
  loaderWrapperClassName: M,
  hideSelectedValues: I,
  inputWrapperClassName: L,
  inputRef: D,
  ...A
}) {
  const [B, U] = te(!1);
  he(() => {
    B && b && (b(), U(!1));
  }, [B]);
  const H = q(
    () => {
      var G;
      return ((G = t ?? r) == null ? void 0 : G.filter((R) => i == null ? void 0 : i.includes(R.id))) ?? [];
    },
    [t, r, i]
  ), { filteredData: K, setQuery: Z } = B5(t), V = i.length > 0, N = g || o || V && (!t && !r), E = V && !v && !N;
  return /* @__PURE__ */ u.jsxs("div", { className: z("ui-relative ui-flex ui-flex-col ui-gap-1", f), children: [
    /* @__PURE__ */ u.jsx(
      Vv,
      {
        selectedData: H,
        virtual: j5(K),
        onChange: a,
        disabled: N,
        onClose: () => {
          Z(""), y == null || y();
        },
        children: (G) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsxs(Z1, { className: z("ui-flex ui-flex-col ui-gap-1", C), children: [
            /* @__PURE__ */ u.jsx(
              wa,
              {
                wrapperAs: "label",
                wrapperProps: S,
                label: e,
                required: c,
                labelClassName: z("ui-text-sm ui-font-medium", n)
              }
            ),
            /* @__PURE__ */ u.jsxs(wi, { as: "div", className: z("ui-relative", L), children: [
              /* @__PURE__ */ u.jsx(
                E5,
                {
                  dataTest: x,
                  inputRef: D,
                  isDisabled: N,
                  hasError: !!l,
                  open: G,
                  className: p,
                  placeholder: s,
                  isPreFetching: o,
                  selectedCaption: I ? "" : H.map((R) => R.caption).join(", "),
                  onFocus: () => U(!0),
                  onChange: (R) => {
                    U(!0), Z(R);
                  }
                }
              ),
              /* @__PURE__ */ u.jsx(
                Il,
                {
                  isDisabled: N,
                  arrowButtonClassName: z(
                    "ui-absolute ui-inset-y-0 ui-right-4 ui-h-[46px] sm:ui-h-[42px]",
                    m
                  ),
                  open: G
                }
              )
            ] }),
            E && /* @__PURE__ */ u.jsx(
              Ll,
              {
                isDisabled: N,
                closeButtonClassName: z(
                  "ui-absolute ui-bottom-0 ui-right-10 ui-h-[46px] sm:ui-h-[42px]",
                  h
                ),
                onClick: () => a([])
              }
            )
          ] }),
          /* @__PURE__ */ u.jsx(
            R5,
            {
              asOptions: j1,
              asOption: H1,
              data: K,
              ...A
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ u.jsx(ya, { error: l, description: d })
  ] });
}
function PP({ amount: e, className: t }) {
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: z(
        "ui-min-h-6 ui-min-w-6 ui-text-xs ui-text-white ui-rounded-full ui-bg-green ui-p-1 ui-flex ui-justify-center ui-items-center",
        t
      ),
      children: e
    }
  );
}
const TP = ({
  children: e,
  className: t,
  color: r = "blue",
  showHint: a = !0,
  ...n
}) => /* @__PURE__ */ u.jsxs("div", { className: z("ui-flex ui-gap-1.5 ui-items-center", t), children: [
  e,
  a && /* @__PURE__ */ u.jsx(
    xl,
    {
      mode: "click",
      ...n,
      className: z("ui-rounded-full ui-focus-ring"),
      popoverClassName: z(
        "!ui-max-w-[200px] sm:!ui-max-w-[350px]",
        n.popoverClassName
      ),
      children: (i) => /* @__PURE__ */ u.jsx(
        i0,
        {
          className: z(
            `group-focus-visible:ui-fill-${r} ui-w-[16px] ui-h-[16px]`,
            i ? `ui-fill-${r}` : "ui-fill-gray-100"
          )
        }
      )
    }
  )
] });
var H5 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = n(i, a(s)));
      }
      return i;
    }
    function a(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return r.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = n(o, s));
      return o;
    }
    function n(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(H5);
var Kv = H5.exports;
const vt = /* @__PURE__ */ S1(Kv);
function Gt(e) {
  "@babel/helpers - typeof";
  return Gt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gt(e);
}
function ee(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function lo(e) {
  return ee(1, arguments), e instanceof Date || Gt(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function oe(e) {
  ee(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Gt(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Jr(e) {
  if (ee(1, arguments), !lo(e) && typeof e != "number")
    return !1;
  var t = oe(e);
  return !isNaN(Number(t));
}
function Pe(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Nl(e, t) {
  ee(2, arguments);
  var r = oe(e).getTime(), a = Pe(t);
  return new Date(r + a);
}
function F5(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return Nl(e, -r);
}
var zv = 864e5;
function Uv(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var a = t.getTime(), n = r - a;
  return Math.floor(n / zv) + 1;
}
function Ua(e) {
  ee(1, arguments);
  var t = 1, r = oe(e), a = r.getUTCDay(), n = (a < t ? 7 : 0) + a - t;
  return r.setUTCDate(r.getUTCDate() - n), r.setUTCHours(0, 0, 0, 0), r;
}
function G5(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var n = Ua(a), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(r, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Ua(i);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Zv(e) {
  ee(1, arguments);
  var t = G5(e), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Ua(r);
  return a;
}
var Yv = 6048e5;
function V5(e) {
  ee(1, arguments);
  var t = oe(e), r = Ua(t).getTime() - Zv(t).getTime();
  return Math.round(r / Yv) + 1;
}
var Wv = {};
function xa() {
  return Wv;
}
function ma(e, t) {
  var r, a, n, i, o, s, l, c;
  ee(1, arguments);
  var d = xa(), p = Pe((r = (a = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : d.weekStartsOn) !== null && a !== void 0 ? a : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = oe(e), h = f.getUTCDay(), m = (h < p ? 7 : 0) + h - p;
  return f.setUTCDate(f.getUTCDate() - m), f.setUTCHours(0, 0, 0, 0), f;
}
function Rl(e, t) {
  var r, a, n, i, o, s, l, c;
  ee(1, arguments);
  var d = oe(e), p = d.getUTCFullYear(), f = xa(), h = Pe((r = (a = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : f.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(p + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var C = ma(m, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(p, 0, h), g.setUTCHours(0, 0, 0, 0);
  var v = ma(g, t);
  return d.getTime() >= C.getTime() ? p + 1 : d.getTime() >= v.getTime() ? p : p - 1;
}
function $v(e, t) {
  var r, a, n, i, o, s, l, c;
  ee(1, arguments);
  var d = xa(), p = Pe((r = (a = (n = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : d.firstWeekContainsDate) !== null && a !== void 0 ? a : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), f = Rl(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, p), h.setUTCHours(0, 0, 0, 0);
  var m = ma(h, t);
  return m;
}
var Jv = 6048e5;
function K5(e, t) {
  ee(1, arguments);
  var r = oe(e), a = ma(r, t).getTime() - $v(r, t).getTime();
  return Math.round(a / Jv) + 1;
}
function ze(e, t) {
  for (var r = e < 0 ? "-" : "", a = Math.abs(e).toString(); a.length < t; )
    a = "0" + a;
  return r + a;
}
var Rn = {
  // Year
  y: function(t, r) {
    var a = t.getUTCFullYear(), n = a > 0 ? a : 1 - a;
    return ze(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M: function(t, r) {
    var a = t.getUTCMonth();
    return r === "M" ? String(a + 1) : ze(a + 1, 2);
  },
  // Day of the month
  d: function(t, r) {
    return ze(t.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(t, r) {
    var a = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, r) {
    return ze(t.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(t, r) {
    return ze(t.getUTCHours(), r.length);
  },
  // Minute
  m: function(t, r) {
    return ze(t.getUTCMinutes(), r.length);
  },
  // Second
  s: function(t, r) {
    return ze(t.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(t, r) {
    var a = r.length, n = t.getUTCMilliseconds(), i = Math.floor(n * Math.pow(10, a - 3));
    return ze(i, r.length);
  }
}, Aa = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Qv = {
  // Era
  G: function(t, r, a) {
    var n = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(n, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(n, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, r, a) {
    if (r === "yo") {
      var n = t.getUTCFullYear(), i = n > 0 ? n : 1 - n;
      return a.ordinalNumber(i, {
        unit: "year"
      });
    }
    return Rn.y(t, r);
  },
  // Local week-numbering year
  Y: function(t, r, a, n) {
    var i = Rl(t, n), o = i > 0 ? i : 1 - i;
    if (r === "YY") {
      var s = o % 100;
      return ze(s, 2);
    }
    return r === "Yo" ? a.ordinalNumber(o, {
      unit: "year"
    }) : ze(o, r.length);
  },
  // ISO week-numbering year
  R: function(t, r) {
    var a = G5(t);
    return ze(a, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, r) {
    var a = t.getUTCFullYear();
    return ze(a, r.length);
  },
  // Quarter
  Q: function(t, r, a) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return ze(n, 2);
      case "Qo":
        return a.ordinalNumber(n, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, r, a) {
    var n = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return ze(n, 2);
      case "qo":
        return a.ordinalNumber(n, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, r, a) {
    var n = t.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Rn.M(t, r);
      case "Mo":
        return a.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, r, a) {
    var n = t.getUTCMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return ze(n + 1, 2);
      case "Lo":
        return a.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, r, a, n) {
    var i = K5(t, n);
    return r === "wo" ? a.ordinalNumber(i, {
      unit: "week"
    }) : ze(i, r.length);
  },
  // ISO week of year
  I: function(t, r, a) {
    var n = V5(t);
    return r === "Io" ? a.ordinalNumber(n, {
      unit: "week"
    }) : ze(n, r.length);
  },
  // Day of the month
  d: function(t, r, a) {
    return r === "do" ? a.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Rn.d(t, r);
  },
  // Day of year
  D: function(t, r, a) {
    var n = Uv(t);
    return r === "Do" ? a.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : ze(n, r.length);
  },
  // Day of week
  E: function(t, r, a) {
    var n = t.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, r, a, n) {
    var i = t.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return ze(o, 2);
      case "eo":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return a.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, r, a, n) {
    var i = t.getUTCDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return ze(o, r.length);
      case "co":
        return a.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return a.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, r, a) {
    var n = t.getUTCDay(), i = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(i);
      case "ii":
        return ze(i, r.length);
      case "io":
        return a.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return a.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, r, a) {
    var n = t.getUTCHours(), i = n / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, r, a) {
    var n = t.getUTCHours(), i;
    switch (n === 12 ? i = Aa.noon : n === 0 ? i = Aa.midnight : i = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, r, a) {
    var n = t.getUTCHours(), i;
    switch (n >= 17 ? i = Aa.evening : n >= 12 ? i = Aa.afternoon : n >= 4 ? i = Aa.morning : i = Aa.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, r, a) {
    if (r === "ho") {
      var n = t.getUTCHours() % 12;
      return n === 0 && (n = 12), a.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return Rn.h(t, r);
  },
  // Hour [0-23]
  H: function(t, r, a) {
    return r === "Ho" ? a.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Rn.H(t, r);
  },
  // Hour [0-11]
  K: function(t, r, a) {
    var n = t.getUTCHours() % 12;
    return r === "Ko" ? a.ordinalNumber(n, {
      unit: "hour"
    }) : ze(n, r.length);
  },
  // Hour [1-24]
  k: function(t, r, a) {
    var n = t.getUTCHours();
    return n === 0 && (n = 24), r === "ko" ? a.ordinalNumber(n, {
      unit: "hour"
    }) : ze(n, r.length);
  },
  // Minute
  m: function(t, r, a) {
    return r === "mo" ? a.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Rn.m(t, r);
  },
  // Second
  s: function(t, r, a) {
    return r === "so" ? a.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Rn.s(t, r);
  },
  // Fraction of second
  S: function(t, r) {
    return Rn.S(t, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, r, a, n) {
    var i = n._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (r) {
      case "X":
        return cu(o);
      case "XXXX":
      case "XX":
        return Xn(o);
      case "XXXXX":
      case "XXX":
      default:
        return Xn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, r, a, n) {
    var i = n._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "x":
        return cu(o);
      case "xxxx":
      case "xx":
        return Xn(o);
      case "xxxxx":
      case "xxx":
      default:
        return Xn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, r, a, n) {
    var i = n._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + uu(o, ":");
      case "OOOO":
      default:
        return "GMT" + Xn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, r, a, n) {
    var i = n._originalDate || t, o = i.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + uu(o, ":");
      case "zzzz":
      default:
        return "GMT" + Xn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, r, a, n) {
    var i = n._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return ze(o, r.length);
  },
  // Milliseconds timestamp
  T: function(t, r, a, n) {
    var i = n._originalDate || t, o = i.getTime();
    return ze(o, r.length);
  }
};
function uu(e, t) {
  var r = e > 0 ? "-" : "+", a = Math.abs(e), n = Math.floor(a / 60), i = a % 60;
  if (i === 0)
    return r + String(n);
  var o = t;
  return r + String(n) + o + ze(i, 2);
}
function cu(e, t) {
  if (e % 60 === 0) {
    var r = e > 0 ? "-" : "+";
    return r + ze(Math.abs(e) / 60, 2);
  }
  return Xn(e, t);
}
function Xn(e, t) {
  var r = t || "", a = e > 0 ? "-" : "+", n = Math.abs(e), i = ze(Math.floor(n / 60), 2), o = ze(n % 60, 2);
  return a + i + r + o;
}
var du = function(t, r) {
  switch (t) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, z5 = function(t, r) {
  switch (t) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, qv = function(t, r) {
  var a = t.match(/(P+)(p+)?/) || [], n = a[1], i = a[2];
  if (!i)
    return du(t, r);
  var o;
  switch (n) {
    case "P":
      o = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = r.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", du(n, r)).replace("{{time}}", z5(i, r));
}, ys = {
  p: z5,
  P: qv
};
function u1(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var Xv = ["D", "DD"], eb = ["YY", "YYYY"];
function U5(e) {
  return Xv.indexOf(e) !== -1;
}
function Z5(e) {
  return eb.indexOf(e) !== -1;
}
function c1(e, t, r) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var tb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, nb = function(t, r, a) {
  var n, i = tb[t];
  return typeof i == "string" ? n = i : r === 1 ? n = i.one : n = i.other.replace("{{count}}", r.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + n : n + " ago" : n;
};
function jo(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.width ? String(t.width) : e.defaultWidth, a = e.formats[r] || e.formats[e.defaultWidth];
    return a;
  };
}
var ab = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, rb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ib = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ob = {
  date: jo({
    formats: ab,
    defaultWidth: "full"
  }),
  time: jo({
    formats: rb,
    defaultWidth: "full"
  }),
  dateTime: jo({
    formats: ib,
    defaultWidth: "full"
  })
}, sb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, lb = function(t, r, a, n) {
  return sb[t];
};
function _r(e) {
  return function(t, r) {
    var a = r != null && r.context ? String(r.context) : "standalone", n;
    if (a === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = r != null && r.width ? String(r.width) : i;
      n = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, l = r != null && r.width ? String(r.width) : e.defaultWidth;
      n = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return n[c];
  };
}
var ub = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, cb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, db = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, pb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, fb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, hb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, mb = function(t, r) {
  var a = Number(t), n = a % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, gb = {
  ordinalNumber: mb,
  era: _r({
    values: ub,
    defaultWidth: "wide"
  }),
  quarter: _r({
    values: cb,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: _r({
    values: db,
    defaultWidth: "wide"
  }),
  day: _r({
    values: pb,
    defaultWidth: "wide"
  }),
  dayPeriod: _r({
    values: fb,
    defaultWidth: "wide",
    formattingValues: hb,
    defaultFormattingWidth: "wide"
  })
};
function xr(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.width, n = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], i = t.match(n);
    if (!i)
      return null;
    var o = i[0], s = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? vb(s, function(p) {
      return p.test(o);
    }) : Cb(s, function(p) {
      return p.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = r.valueCallback ? r.valueCallback(c) : c;
    var d = t.slice(o.length);
    return {
      value: c,
      rest: d
    };
  };
}
function Cb(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r) && t(e[r]))
      return r;
}
function vb(e, t) {
  for (var r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function bb(e) {
  return function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = t.match(e.matchPattern);
    if (!a) return null;
    var n = a[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    var s = t.slice(n.length);
    return {
      value: o,
      rest: s
    };
  };
}
var yb = /^(\d+)(th|st|nd|rd)?/i, wb = /\d+/i, Sb = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, _b = {
  any: [/^b/i, /^(a|c)/i]
}, xb = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Mb = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kb = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Pb = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Tb = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Eb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Db = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Ib = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Lb = {
  ordinalNumber: bb({
    matchPattern: yb,
    parsePattern: wb,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: xr({
    matchPatterns: Sb,
    defaultMatchWidth: "wide",
    parsePatterns: _b,
    defaultParseWidth: "any"
  }),
  quarter: xr({
    matchPatterns: xb,
    defaultMatchWidth: "wide",
    parsePatterns: Mb,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: xr({
    matchPatterns: kb,
    defaultMatchWidth: "wide",
    parsePatterns: Pb,
    defaultParseWidth: "any"
  }),
  day: xr({
    matchPatterns: Tb,
    defaultMatchWidth: "wide",
    parsePatterns: Eb,
    defaultParseWidth: "any"
  }),
  dayPeriod: xr({
    matchPatterns: Db,
    defaultMatchWidth: "any",
    parsePatterns: Ib,
    defaultParseWidth: "any"
  })
}, dr = {
  code: "en-US",
  formatDistance: nb,
  formatLong: ob,
  formatRelative: lb,
  localize: gb,
  match: Lb,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Ab = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Nb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Rb = /^'([^]*?)'?$/, Ob = /''/g, Bb = /[a-zA-Z]/;
function pu(e, t, r) {
  var a, n, i, o, s, l, c, d, p, f, h, m, C, g, v, b, y, x;
  ee(2, arguments);
  var S = String(t), _ = xa(), M = (a = (n = r == null ? void 0 : r.locale) !== null && n !== void 0 ? n : _.locale) !== null && a !== void 0 ? a : dr, I = Pe((i = (o = (s = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (c = r.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && s !== void 0 ? s : _.firstWeekContainsDate) !== null && o !== void 0 ? o : (p = _.locale) === null || p === void 0 || (f = p.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(I >= 1 && I <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var L = Pe((h = (m = (C = (g = r == null ? void 0 : r.weekStartsOn) !== null && g !== void 0 ? g : r == null || (v = r.locale) === null || v === void 0 || (b = v.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && C !== void 0 ? C : _.weekStartsOn) !== null && m !== void 0 ? m : (y = _.locale) === null || y === void 0 || (x = y.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(L >= 0 && L <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!M.localize)
    throw new RangeError("locale must contain localize property");
  if (!M.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var D = oe(e);
  if (!Jr(D))
    throw new RangeError("Invalid time value");
  var A = u1(D), B = F5(D, A), U = {
    firstWeekContainsDate: I,
    weekStartsOn: L,
    locale: M,
    _originalDate: D
  }, H = S.match(Nb).map(function(K) {
    var Z = K[0];
    if (Z === "p" || Z === "P") {
      var V = ys[Z];
      return V(K, M.formatLong);
    }
    return K;
  }).join("").match(Ab).map(function(K) {
    if (K === "''")
      return "'";
    var Z = K[0];
    if (Z === "'")
      return jb(K);
    var V = Qv[Z];
    if (V)
      return !(r != null && r.useAdditionalWeekYearTokens) && Z5(K) && c1(K, t, String(e)), !(r != null && r.useAdditionalDayOfYearTokens) && U5(K) && c1(K, t, String(e)), V(B, K, M.localize, U);
    if (Z.match(Bb))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Z + "`");
    return K;
  }).join("");
  return H;
}
function jb(e) {
  var t = e.match(Rb);
  return t ? t[1].replace(Ob, "'") : e;
}
var Hb = 6e4;
function ws(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return Nl(e, r * Hb);
}
var Fb = 36e5;
function Gb(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return Nl(e, r * Fb);
}
function pr(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && r.setDate(r.getDate() + a), r);
}
function d1(e, t) {
  ee(2, arguments);
  var r = Pe(t), a = r * 7;
  return pr(e, a);
}
function qt(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return r;
  var n = r.getDate(), i = new Date(r.getTime());
  i.setMonth(r.getMonth() + a + 1, 0);
  var o = i.getDate();
  return n >= o ? i : (r.setFullYear(i.getFullYear(), i.getMonth(), n), r);
}
function Y5(e, t) {
  ee(2, arguments);
  var r = Pe(t), a = r * 3;
  return qt(e, a);
}
function Za(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return qt(e, r * 12);
}
function Vb(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return pr(e, -r);
}
function fu(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return d1(e, -r);
}
function Ya(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return qt(e, -r);
}
function Kb(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return Y5(e, -r);
}
function Qr(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  return Za(e, -r);
}
function hu(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getSeconds();
  return r;
}
function pn(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getMinutes();
  return r;
}
function fn(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getHours();
  return r;
}
function zb(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getDay();
  return r;
}
function mu(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getDate();
  return r;
}
function W5(e, t) {
  var r, a, n, i, o, s, l, c;
  ee(1, arguments);
  var d = xa(), p = Pe((r = (a = (n = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : d.weekStartsOn) !== null && a !== void 0 ? a : (l = d.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = oe(e), h = f.getDay(), m = (h < p ? 7 : 0) + h - p;
  return f.setDate(f.getDate() - m), f.setHours(0, 0, 0, 0), f;
}
function p1(e) {
  return ee(1, arguments), W5(e, {
    weekStartsOn: 1
  });
}
function Ub(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  var n = p1(a), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  var o = p1(i);
  return t.getTime() >= n.getTime() ? r + 1 : t.getTime() >= o.getTime() ? r : r - 1;
}
function Zb(e) {
  ee(1, arguments);
  var t = Ub(e), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0);
  var a = p1(r);
  return a;
}
var Yb = 6048e5;
function Wb(e) {
  ee(1, arguments);
  var t = oe(e), r = p1(t).getTime() - Zb(t).getTime();
  return Math.round(r / Yb) + 1;
}
function wt(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getMonth();
  return r;
}
function Ra(e) {
  ee(1, arguments);
  var t = oe(e), r = Math.floor(t.getMonth() / 3) + 1;
  return r;
}
function Te(e) {
  return ee(1, arguments), oe(e).getFullYear();
}
function Ss(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getTime();
  return r;
}
function $b(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  return r.setSeconds(a), r;
}
function Ki(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  return r.setMinutes(a), r;
}
function zi(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  return r.setHours(a), r;
}
function Jb(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getFullYear(), a = t.getMonth(), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(r, a + 1, 0), n.setHours(0, 0, 0, 0), n.getDate();
}
function kt(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t), n = r.getFullYear(), i = r.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(n, a, 15), o.setHours(0, 0, 0, 0);
  var s = Jb(o);
  return r.setMonth(a, Math.min(i, s)), r;
}
function Na(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t), n = Math.floor(r.getMonth() / 3) + 1, i = a - n;
  return kt(r, r.getMonth() + i * 3);
}
function Mn(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(a), r);
}
function gu(e) {
  ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Gt(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(a) {
    var n = oe(a);
    (r === void 0 || r > n || isNaN(n.getDate())) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Cu(e) {
  ee(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Gt(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var r;
  return t.forEach(function(a) {
    var n = oe(a);
    (r === void 0 || r < n || isNaN(Number(n))) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function hn(e) {
  ee(1, arguments);
  var t = oe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Qb = 864e5;
function qr(e, t) {
  ee(2, arguments);
  var r = hn(e), a = hn(t), n = r.getTime() - u1(r), i = a.getTime() - u1(a);
  return Math.round((n - i) / Qb);
}
function f1(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t), n = r.getFullYear() - a.getFullYear(), i = r.getMonth() - a.getMonth();
  return n * 12 + i;
}
function h1(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getFullYear() - a.getFullYear();
}
function $5(e) {
  ee(1, arguments);
  var t = oe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function _s(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getMonth(), a = r - r % 3;
  return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
}
function J5(e) {
  ee(1, arguments);
  var t = oe(e), r = /* @__PURE__ */ new Date(0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function xs(e) {
  ee(1, arguments);
  var t = oe(e);
  return t.setHours(23, 59, 59, 999), t;
}
function qb(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Xb(e) {
  ee(1, arguments);
  var t = oe(e), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function ey(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getTime() === a.getTime();
}
function ty(e, t) {
  ee(2, arguments);
  var r = hn(e), a = hn(t);
  return r.getTime() === a.getTime();
}
function ny(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getFullYear() === a.getFullYear() && r.getMonth() === a.getMonth();
}
function ay(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getFullYear() === a.getFullYear();
}
function ry(e, t) {
  ee(2, arguments);
  var r = _s(e), a = _s(t);
  return r.getTime() === a.getTime();
}
function Yn(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getTime() > a.getTime();
}
function Fn(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t);
  return r.getTime() < a.getTime();
}
function Xr(e, t) {
  ee(2, arguments);
  var r = oe(e).getTime(), a = oe(t.start).getTime(), n = oe(t.end).getTime();
  if (!(a <= n))
    throw new RangeError("Invalid interval");
  return r >= a && r <= n;
}
function vu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, a = Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function iy(e, t) {
  if (e) {
    if (typeof e == "string") return vu(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? vu(e, t) : void 0;
  }
}
function bu(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = iy(e)) || t) {
      r && (e = r);
      var a = 0, n = function() {
      };
      return {
        s: n,
        n: function() {
          return a >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[a++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: n
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      r = r.call(e);
    },
    n: function() {
      var c = r.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, i = c;
    },
    f: function() {
      try {
        o || r.return == null || r.return();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function oy(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  return e;
}
function se(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ms(e, t) {
  return Ms = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Ms(e, t);
}
function Fe(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ms(e, t);
}
function m1(e) {
  return m1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, m1(e);
}
function Q5() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Q5 = function() {
    return !!e;
  })();
}
function sy(e, t) {
  if (t && (Gt(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return se(e);
}
function Ge(e) {
  var t = Q5();
  return function() {
    var r, a = m1(e);
    if (t) {
      var n = m1(this).constructor;
      r = Reflect.construct(a, arguments, n);
    } else r = a.apply(this, arguments);
    return sy(this, r);
  };
}
function Re(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ly(e, t) {
  if (Gt(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(e, t || "default");
    if (Gt(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function q5(e) {
  var t = ly(e, "string");
  return Gt(t) == "symbol" ? t : t + "";
}
function uy(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, q5(a.key), a);
  }
}
function Oe(e, t, r) {
  return t && uy(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ne(e, t, r) {
  return (t = q5(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var cy = 10, X5 = /* @__PURE__ */ function() {
  function e() {
    Re(this, e), ne(this, "priority", void 0), ne(this, "subPriority", 0);
  }
  return Oe(e, [{
    key: "validate",
    value: function(r, a) {
      return !0;
    }
  }]), e;
}(), dy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r(a, n, i, o, s) {
    var l;
    return Re(this, r), l = t.call(this), l.value = a, l.validateValue = n, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return Oe(r, [{
    key: "validate",
    value: function(n, i) {
      return this.validateValue(n, this.value, i);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return this.setValue(n, i, this.value, o);
    }
  }]), r;
}(X5), py = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", cy), ne(se(a), "subPriority", -1), a;
  }
  return Oe(r, [{
    key: "set",
    value: function(n, i) {
      if (i.timestampIsSet)
        return n;
      var o = /* @__PURE__ */ new Date(0);
      return o.setFullYear(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()), o.setHours(n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds(), n.getUTCMilliseconds()), o;
    }
  }]), r;
}(X5), Ve = /* @__PURE__ */ function() {
  function e() {
    Re(this, e), ne(this, "incompatibleTokens", void 0), ne(this, "priority", void 0), ne(this, "subPriority", void 0);
  }
  return Oe(e, [{
    key: "run",
    value: function(r, a, n, i) {
      var o = this.parse(r, a, n, i);
      return o ? {
        setter: new dy(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(r, a, n) {
      return !0;
    }
  }]), e;
}(), fy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 140), ne(se(a), "incompatibleTokens", ["R", "u", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(n, {
            width: "abbreviated"
          }) || o.era(n, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(n, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(n, {
            width: "wide"
          }) || o.era(n, {
            width: "abbreviated"
          }) || o.era(n, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.era = o, n.setUTCFullYear(o, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Ol = 6e4, Bl = 36e5, hy = 1e3, st = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, on = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function lt(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function tt(e, t) {
  var r = t.match(e);
  return r ? {
    value: parseInt(r[0], 10),
    rest: t.slice(r[0].length)
  } : null;
}
function sn(e, t) {
  var r = t.match(e);
  if (!r)
    return null;
  if (r[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var a = r[1] === "+" ? 1 : -1, n = r[2] ? parseInt(r[2], 10) : 0, i = r[3] ? parseInt(r[3], 10) : 0, o = r[5] ? parseInt(r[5], 10) : 0;
  return {
    value: a * (n * Bl + i * Ol + o * hy),
    rest: t.slice(r[0].length)
  };
}
function e4(e) {
  return tt(st.anyDigitsSigned, e);
}
function rt(e, t) {
  switch (e) {
    case 1:
      return tt(st.singleDigit, t);
    case 2:
      return tt(st.twoDigits, t);
    case 3:
      return tt(st.threeDigits, t);
    case 4:
      return tt(st.fourDigits, t);
    default:
      return tt(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function g1(e, t) {
  switch (e) {
    case 1:
      return tt(st.singleDigitSigned, t);
    case 2:
      return tt(st.twoDigitsSigned, t);
    case 3:
      return tt(st.threeDigitsSigned, t);
    case 4:
      return tt(st.fourDigitsSigned, t);
    default:
      return tt(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function jl(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function t4(e, t) {
  var r = t > 0, a = r ? t : 1 - t, n;
  if (a <= 50)
    n = e || 100;
  else {
    var i = a + 50, o = Math.floor(i / 100) * 100, s = e >= i % 100;
    n = e + o - (s ? 100 : 0);
  }
  return r ? n : 1 - n;
}
function n4(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var my = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 130), ne(se(a), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return lt(rt(4, n), s);
        case "yo":
          return lt(o.ordinalNumber(n, {
            unit: "year"
          }), s);
        default:
          return lt(rt(i.length, n), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var l = t4(o.year, s);
        return n.setUTCFullYear(l, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return n.setUTCFullYear(c, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), gy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 130), ne(se(a), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return lt(rt(4, n), s);
        case "Yo":
          return lt(o.ordinalNumber(n, {
            unit: "year"
          }), s);
        default:
          return lt(rt(i.length, n), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      var l = Rl(n, s);
      if (o.isTwoDigitYear) {
        var c = t4(o.year, l);
        return n.setUTCFullYear(c, 0, s.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), ma(n, s);
      }
      var d = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return n.setUTCFullYear(d, 0, s.firstWeekContainsDate), n.setUTCHours(0, 0, 0, 0), ma(n, s);
    }
  }]), r;
}(Ve), Cy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 130), ne(se(a), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i) {
      return g1(i === "R" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = /* @__PURE__ */ new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Ua(s);
    }
  }]), r;
}(Ve), vy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 130), ne(se(a), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i) {
      return g1(i === "u" ? 4 : i.length, n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCFullYear(o, 0, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), by = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 120), ne(se(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return rt(i.length, n);
        case "Qo":
          return o.ordinalNumber(n, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(n, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth((o - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), yy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 120), ne(se(a), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return rt(i.length, n);
        case "qo":
          return o.ordinalNumber(n, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(n, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth((o - 1) * 3, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), wy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), ne(se(a), "priority", 110), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return lt(tt(st.month, n), s);
        case "MM":
          return lt(rt(2, n), s);
        case "Mo":
          return lt(o.ordinalNumber(n, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(n, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(n, {
            width: "wide",
            context: "formatting"
          }) || o.month(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(o, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Sy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 110), ne(se(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return lt(tt(st.month, n), s);
        case "LL":
          return lt(rt(2, n), s);
        case "Lo":
          return lt(o.ordinalNumber(n, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(n, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(n, {
            width: "wide",
            context: "standalone"
          }) || o.month(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(o, 1), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve);
function _y(e, t, r) {
  ee(2, arguments);
  var a = oe(e), n = Pe(t), i = K5(a, r) - n;
  return a.setUTCDate(a.getUTCDate() - i * 7), a;
}
var xy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 100), ne(se(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "w":
          return tt(st.week, n);
        case "wo":
          return o.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return ma(_y(n, o, s), s);
    }
  }]), r;
}(Ve);
function My(e, t) {
  ee(2, arguments);
  var r = oe(e), a = Pe(t), n = V5(r) - a;
  return r.setUTCDate(r.getUTCDate() - n * 7), r;
}
var ky = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 100), ne(se(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "I":
          return tt(st.week, n);
        case "Io":
          return o.ordinalNumber(n, {
            unit: "week"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return Ua(My(n, o));
    }
  }]), r;
}(Ve), Py = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ty = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ey = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "subPriority", 1), ne(se(a), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "d":
          return tt(st.date, n);
        case "do":
          return o.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var o = n.getUTCFullYear(), s = n4(o), l = n.getUTCMonth();
      return s ? i >= 1 && i <= Ty[l] : i >= 1 && i <= Py[l];
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCDate(o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Dy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "subpriority", 1), ne(se(a), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return tt(st.dayOfYear, n);
        case "Do":
          return o.ordinalNumber(n, {
            unit: "date"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      var o = n.getUTCFullYear(), s = n4(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMonth(0, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve);
function Hl(e, t, r) {
  var a, n, i, o, s, l, c, d;
  ee(2, arguments);
  var p = xa(), f = Pe((a = (n = (i = (o = r == null ? void 0 : r.weekStartsOn) !== null && o !== void 0 ? o : r == null || (s = r.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : p.weekStartsOn) !== null && n !== void 0 ? n : (c = p.locale) === null || c === void 0 || (d = c.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = oe(e), m = Pe(t), C = h.getUTCDay(), g = m % 7, v = (g + 7) % 7, b = (v < f ? 7 : 0) + m - C;
  return h.setUTCDate(h.getUTCDate() + b), h;
}
var Iy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = Hl(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Ly = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o, s) {
      var l = function(d) {
        var p = Math.floor((d - 1) / 7) * 7;
        return (d + s.weekStartsOn + 6) % 7 + p;
      };
      switch (i) {
        case "e":
        case "ee":
          return lt(rt(i.length, n), l);
        case "eo":
          return lt(o.ordinalNumber(n, {
            unit: "day"
          }), l);
        case "eee":
          return o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = Hl(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Ay = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o, s) {
      var l = function(d) {
        var p = Math.floor((d - 1) / 7) * 7;
        return (d + s.weekStartsOn + 6) % 7 + p;
      };
      switch (i) {
        case "c":
        case "cc":
          return lt(rt(i.length, n), l);
        case "co":
          return lt(o.ordinalNumber(n, {
            unit: "day"
          }), l);
        case "ccc":
          return o.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(n, {
            width: "wide",
            context: "standalone"
          }) || o.day(n, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(n, {
            width: "short",
            context: "standalone"
          }) || o.day(n, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(n, i, o, s) {
      return n = Hl(n, o, s), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve);
function Ny(e, t) {
  ee(2, arguments);
  var r = Pe(t);
  r % 7 === 0 && (r = r - 7);
  var a = 1, n = oe(e), i = n.getUTCDay(), o = r % 7, s = (o + 7) % 7, l = (s < a ? 7 : 0) + r - i;
  return n.setUTCDate(n.getUTCDate() + l), n;
}
var Ry = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 90), ne(se(a), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      var s = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return rt(i.length, n);
        case "io":
          return o.ordinalNumber(n, {
            unit: "day"
          });
        case "iii":
          return lt(o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return lt(o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return lt(o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return lt(o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n = Ny(n, o), n.setUTCHours(0, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Oy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 80), ne(se(a), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(jl(o), 0, 0, 0), n;
    }
  }]), r;
}(Ve), By = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 80), ne(se(a), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(jl(o), 0, 0, 0), n;
    }
  }]), r;
}(Ve), jy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 80), ne(se(a), "incompatibleTokens", ["a", "b", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(n, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(n, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(jl(o), 0, 0, 0), n;
    }
  }]), r;
}(Ve), Hy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 70), ne(se(a), "incompatibleTokens", ["H", "K", "k", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "h":
          return tt(st.hour12h, n);
        case "ho":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCHours() >= 12;
      return s && o < 12 ? n.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? n.setUTCHours(0, 0, 0, 0) : n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Fy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 70), ne(se(a), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "H":
          return tt(st.hour23h, n);
        case "Ho":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Gy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 70), ne(se(a), "incompatibleTokens", ["h", "H", "k", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "K":
          return tt(st.hour11h, n);
        case "Ko":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = n.getUTCHours() >= 12;
      return s && o < 12 ? n.setUTCHours(o + 12, 0, 0, 0) : n.setUTCHours(o, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Vy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 70), ne(se(a), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "k":
          return tt(st.hour24h, n);
        case "ko":
          return o.ordinalNumber(n, {
            unit: "hour"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return n.setUTCHours(s, 0, 0, 0), n;
    }
  }]), r;
}(Ve), Ky = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 60), ne(se(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "m":
          return tt(st.minute, n);
        case "mo":
          return o.ordinalNumber(n, {
            unit: "minute"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMinutes(o, 0, 0), n;
    }
  }]), r;
}(Ve), zy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 50), ne(se(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i, o) {
      switch (i) {
        case "s":
          return tt(st.second, n);
        case "so":
          return o.ordinalNumber(n, {
            unit: "second"
          });
        default:
          return rt(i.length, n);
      }
    }
  }, {
    key: "validate",
    value: function(n, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCSeconds(o, 0), n;
    }
  }]), r;
}(Ve), Uy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 30), ne(se(a), "incompatibleTokens", ["t", "T"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i) {
      var o = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return lt(rt(i.length, n), o);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return n.setUTCMilliseconds(o), n;
    }
  }]), r;
}(Ve), Zy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 10), ne(se(a), "incompatibleTokens", ["t", "T", "x"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "X":
          return sn(on.basicOptionalMinutes, n);
        case "XX":
          return sn(on.basic, n);
        case "XXXX":
          return sn(on.basicOptionalSeconds, n);
        case "XXXXX":
          return sn(on.extendedOptionalSeconds, n);
        case "XXX":
        default:
          return sn(on.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.timestampIsSet ? n : new Date(n.getTime() - o);
    }
  }]), r;
}(Ve), Yy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 10), ne(se(a), "incompatibleTokens", ["t", "T", "X"]), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n, i) {
      switch (i) {
        case "x":
          return sn(on.basicOptionalMinutes, n);
        case "xx":
          return sn(on.basic, n);
        case "xxxx":
          return sn(on.basicOptionalSeconds, n);
        case "xxxxx":
          return sn(on.extendedOptionalSeconds, n);
        case "xxx":
        default:
          return sn(on.extended, n);
      }
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return i.timestampIsSet ? n : new Date(n.getTime() - o);
    }
  }]), r;
}(Ve), Wy = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 40), ne(se(a), "incompatibleTokens", "*"), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n) {
      return e4(n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ve), $y = /* @__PURE__ */ function(e) {
  Fe(r, e);
  var t = Ge(r);
  function r() {
    var a;
    Re(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
      i[o] = arguments[o];
    return a = t.call.apply(t, [this].concat(i)), ne(se(a), "priority", 20), ne(se(a), "incompatibleTokens", "*"), a;
  }
  return Oe(r, [{
    key: "parse",
    value: function(n) {
      return e4(n);
    }
  }, {
    key: "set",
    value: function(n, i, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), r;
}(Ve), Jy = {
  G: new fy(),
  y: new my(),
  Y: new gy(),
  R: new Cy(),
  u: new vy(),
  Q: new by(),
  q: new yy(),
  M: new wy(),
  L: new Sy(),
  w: new xy(),
  I: new ky(),
  d: new Ey(),
  D: new Dy(),
  E: new Iy(),
  e: new Ly(),
  c: new Ay(),
  i: new Ry(),
  a: new Oy(),
  b: new By(),
  B: new jy(),
  h: new Hy(),
  H: new Fy(),
  K: new Gy(),
  k: new Vy(),
  m: new Ky(),
  s: new zy(),
  S: new Uy(),
  X: new Zy(),
  x: new Yy(),
  t: new Wy(),
  T: new $y()
}, Qy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, qy = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Xy = /^'([^]*?)'?$/, ew = /''/g, tw = /\S/, nw = /[a-zA-Z]/;
function Ho(e, t, r, a) {
  var n, i, o, s, l, c, d, p, f, h, m, C, g, v, b, y, x, S;
  ee(3, arguments);
  var _ = String(e), M = String(t), I = xa(), L = (n = (i = a == null ? void 0 : a.locale) !== null && i !== void 0 ? i : I.locale) !== null && n !== void 0 ? n : dr;
  if (!L.match)
    throw new RangeError("locale must contain match property");
  var D = Pe((o = (s = (l = (c = a == null ? void 0 : a.firstWeekContainsDate) !== null && c !== void 0 ? c : a == null || (d = a.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && l !== void 0 ? l : I.firstWeekContainsDate) !== null && s !== void 0 ? s : (f = I.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = Pe((m = (C = (g = (v = a == null ? void 0 : a.weekStartsOn) !== null && v !== void 0 ? v : a == null || (b = a.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && g !== void 0 ? g : I.weekStartsOn) !== null && C !== void 0 ? C : (x = I.locale) === null || x === void 0 || (S = x.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(A >= 0 && A <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (M === "")
    return _ === "" ? oe(r) : /* @__PURE__ */ new Date(NaN);
  var B = {
    firstWeekContainsDate: D,
    weekStartsOn: A,
    locale: L
  }, U = [new py()], H = M.match(qy).map(function(de) {
    var ge = de[0];
    if (ge in ys) {
      var Je = ys[ge];
      return Je(de, L.formatLong);
    }
    return de;
  }).join("").match(Qy), K = [], Z = bu(H), V;
  try {
    var O = function() {
      var ge = V.value;
      !(a != null && a.useAdditionalWeekYearTokens) && Z5(ge) && c1(ge, M, e), !(a != null && a.useAdditionalDayOfYearTokens) && U5(ge) && c1(ge, M, e);
      var Je = ge[0], Se = Jy[Je];
      if (Se) {
        var fe = Se.incompatibleTokens;
        if (Array.isArray(fe)) {
          var De = K.find(function(ke) {
            return fe.includes(ke.token) || ke.token === Je;
          });
          if (De)
            throw new RangeError("The format string mustn't contain `".concat(De.fullToken, "` and `").concat(ge, "` at the same time"));
        } else if (Se.incompatibleTokens === "*" && K.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(ge, "` and any other token at the same time"));
        K.push({
          token: Je,
          fullToken: ge
        });
        var le = Se.run(_, ge, L.match, B);
        if (!le)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        U.push(le.setter), _ = le.rest;
      } else {
        if (Je.match(nw))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + Je + "`");
        if (ge === "''" ? ge = "'" : Je === "'" && (ge = aw(ge)), _.indexOf(ge) === 0)
          _ = _.slice(ge.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Z.s(); !(V = Z.n()).done; ) {
      var j = O();
      if (Gt(j) === "object") return j.v;
    }
  } catch (de) {
    Z.e(de);
  } finally {
    Z.f();
  }
  if (_.length > 0 && tw.test(_))
    return /* @__PURE__ */ new Date(NaN);
  var N = U.map(function(de) {
    return de.priority;
  }).sort(function(de, ge) {
    return ge - de;
  }).filter(function(de, ge, Je) {
    return Je.indexOf(de) === ge;
  }).map(function(de) {
    return U.filter(function(ge) {
      return ge.priority === de;
    }).sort(function(ge, Je) {
      return Je.subPriority - ge.subPriority;
    });
  }).map(function(de) {
    return de[0];
  }), E = oe(r);
  if (isNaN(E.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var G = F5(E, u1(E)), R = {}, $ = bu(N), W;
  try {
    for ($.s(); !(W = $.n()).done; ) {
      var re = W.value;
      if (!re.validate(G, B))
        return /* @__PURE__ */ new Date(NaN);
      var ae = re.set(G, R, B);
      Array.isArray(ae) ? (G = ae[0], oy(R, ae[1])) : G = ae;
    }
  } catch (de) {
    $.e(de);
  } finally {
    $.f();
  }
  return G;
}
function aw(e) {
  return e.match(Xy)[1].replace(ew, "'");
}
function rw(e, t) {
  var r;
  ee(1, arguments);
  var a = Pe((r = void 0) !== null && r !== void 0 ? r : 2);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = lw(e), i;
  if (n.date) {
    var o = uw(n.date, a);
    i = cw(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), l = 0, c;
  if (n.time && (l = dw(n.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (c = pw(n.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var d = new Date(s + l), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), p.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), p;
  }
  return new Date(s + l + c);
}
var Ri = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, iw = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, ow = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, sw = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function lw(e) {
  var t = {}, r = e.split(Ri.dateTimeDelimiter), a;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? a = r[0] : (t.date = r[0], a = r[1], Ri.timeZoneDelimiter.test(t.date) && (t.date = e.split(Ri.timeZoneDelimiter)[0], a = e.substr(t.date.length, e.length))), a) {
    var n = Ri.timezone.exec(a);
    n ? (t.time = a.replace(n[1], ""), t.timezone = n[1]) : t.time = a;
  }
  return t;
}
function uw(e, t) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), a = e.match(r);
  if (!a) return {
    year: NaN,
    restDateString: ""
  };
  var n = a[1] ? parseInt(a[1]) : null, i = a[2] ? parseInt(a[2]) : null;
  return {
    year: i === null ? n : i * 100,
    restDateString: e.slice((a[1] || a[2]).length)
  };
}
function cw(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var r = e.match(iw);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  var a = !!r[4], n = Mr(r[1]), i = Mr(r[2]) - 1, o = Mr(r[3]), s = Mr(r[4]), l = Mr(r[5]) - 1;
  if (a)
    return Cw(t, s, l) ? fw(t, s, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !mw(t, i, o) || !gw(t, n) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, i, Math.max(n, o)), c);
}
function Mr(e) {
  return e ? parseInt(e) : 1;
}
function dw(e) {
  var t = e.match(ow);
  if (!t) return NaN;
  var r = Fo(t[1]), a = Fo(t[2]), n = Fo(t[3]);
  return vw(r, a, n) ? r * Bl + a * Ol + n * 1e3 : NaN;
}
function Fo(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function pw(e) {
  if (e === "Z") return 0;
  var t = e.match(sw);
  if (!t) return 0;
  var r = t[1] === "+" ? -1 : 1, a = parseInt(t[2]), n = t[3] && parseInt(t[3]) || 0;
  return bw(a, n) ? r * (a * Bl + n * Ol) : NaN;
}
function fw(e, t, r) {
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  var n = a.getUTCDay() || 7, i = (t - 1) * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + i), a;
}
var hw = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function a4(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function mw(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (hw[t] || (a4(e) ? 29 : 28));
}
function gw(e, t) {
  return t >= 1 && t <= (a4(e) ? 366 : 365);
}
function Cw(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function vw(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function bw(e, t) {
  return t >= 0 && t <= 59;
}
function yw(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ks(e, t);
}
function ks(e, t) {
  return ks = Object.setPrototypeOf || function(a, n) {
    return a.__proto__ = n, a;
  }, ks(e, t);
}
function ww(e, t) {
  if (e == null) return {};
  var r = {}, a = Object.keys(e), n, i;
  for (i = 0; i < a.length; i++)
    n = a[i], !(t.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
function yu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Sw(e, t, r) {
  return e === t ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(r) : e.classList.contains(r);
}
function _w(e, t, r) {
  if (e === t)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && Sw(e, t, r))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function xw(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var Mw = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var t = !1, r = Object.defineProperty({}, "passive", {
      get: function() {
        t = !0;
      }
    }), a = function() {
    };
    return window.addEventListener("testPassiveEventSupport", a, r), window.removeEventListener("testPassiveEventSupport", a, r), t;
  }
};
function kw(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var Pw = kw(), Ps, Oi = {}, Go = {}, Tw = ["touchstart", "touchmove"], Ew = "ignore-react-onclickoutside";
function wu(e, t) {
  var r = {}, a = Tw.indexOf(t) !== -1;
  return a && Ps && (r.passive = !e.props.preventDefault), r;
}
function uo(e, t) {
  var r, a, n = e.displayName || e.name || "Component";
  return a = r = /* @__PURE__ */ function(i) {
    yw(o, i);
    function o(l) {
      var c;
      return c = i.call(this, l) || this, c.__outsideClickHandler = function(d) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(d);
          return;
        }
        var p = c.getInstance();
        if (typeof p.props.handleClickOutside == "function") {
          p.props.handleClickOutside(d);
          return;
        }
        if (typeof p.handleClickOutside == "function") {
          p.handleClickOutside(d);
          return;
        }
        throw new Error("WrappedComponent: " + n + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var d = c.getInstance();
        return typeof d.setClickOutsideRef == "function" ? d.setClickOutsideRef() : nd(d);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document > "u" || Go[c._uid])) {
          typeof Ps > "u" && (Ps = Mw()), Go[c._uid] = !0;
          var d = c.props.eventTypes;
          d.forEach || (d = [d]), Oi[c._uid] = function(p) {
            if (c.componentNode !== null && !(c.initTimeStamp > p.timeStamp) && (c.props.preventDefault && p.preventDefault(), c.props.stopPropagation && p.stopPropagation(), !(c.props.excludeScrollbar && xw(p)))) {
              var f = p.composed && p.composedPath && p.composedPath().shift() || p.target;
              _w(f, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(p);
            }
          }, d.forEach(function(p) {
            document.addEventListener(p, Oi[c._uid], wu(yu(c), p));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete Go[c._uid];
        var d = Oi[c._uid];
        if (d && typeof document < "u") {
          var p = c.props.eventTypes;
          p.forEach || (p = [p]), p.forEach(function(f) {
            return document.removeEventListener(f, d, wu(yu(c), f));
          }), delete Oi[c._uid];
        }
      }, c.getRef = function(d) {
        return c.instanceRef = d;
      }, c._uid = Pw(), c.initTimeStamp = performance.now(), c;
    }
    var s = o.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var c = this.instanceRef;
      return c.getInstance ? c.getInstance() : c;
    }, s.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var c = this.props;
      c.excludeScrollbar;
      var d = ww(c, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? d.ref = this.getRef : d.wrappedRef = this.getRef, d.disableOnClickOutside = this.disableOnClickOutside, d.enableOnClickOutside = this.enableOnClickOutside, oc(e, d);
    }, o;
  }(ed), r.displayName = "OnClickOutside(" + n + ")", r.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: Ew,
    preventDefault: !1,
    stopPropagation: !1
  }, r.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, a;
}
var r4 = Y.createContext(), i4 = Y.createContext();
function Dw(e) {
  var t = e.children, r = Y.useState(null), a = r[0], n = r[1], i = Y.useRef(!1);
  Y.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = Y.useCallback(function(s) {
    i.current || n(s);
  }, []);
  return /* @__PURE__ */ Y.createElement(r4.Provider, {
    value: a
  }, /* @__PURE__ */ Y.createElement(i4.Provider, {
    value: o
  }, t));
}
var o4 = function(t) {
  return Array.isArray(t) ? t[0] : t;
}, s4 = function(t) {
  if (typeof t == "function") {
    for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
      a[n - 1] = arguments[n];
    return t.apply(void 0, a);
  }
}, Ts = function(t, r) {
  if (typeof t == "function")
    return s4(t, r);
  t != null && (t.current = r);
}, Su = function(t) {
  return t.reduce(function(r, a) {
    var n = a[0], i = a[1];
    return r[n] = i, r;
  }, {});
}, _u = typeof window < "u" && window.document && window.document.createElement ? Y.useLayoutEffect : Y.useEffect, Dt = "top", Vt = "bottom", Kt = "right", It = "left", Fl = "auto", Mi = [Dt, Vt, Kt, It], Wa = "start", ei = "end", Iw = "clippingParents", l4 = "viewport", kr = "popper", Lw = "reference", xu = /* @__PURE__ */ Mi.reduce(function(e, t) {
  return e.concat([t + "-" + Wa, t + "-" + ei]);
}, []), u4 = /* @__PURE__ */ [].concat(Mi, [Fl]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Wa, t + "-" + ei]);
}, []), Aw = "beforeRead", Nw = "read", Rw = "afterRead", Ow = "beforeMain", Bw = "main", jw = "afterMain", Hw = "beforeWrite", Fw = "write", Gw = "afterWrite", Vw = [Aw, Nw, Rw, Ow, Bw, jw, Hw, Fw, Gw];
function vn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ot(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ga(e) {
  var t = Ot(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ft(e) {
  var t = Ot(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Gl(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ot(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Kw(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var a = t.styles[r] || {}, n = t.attributes[r] || {}, i = t.elements[r];
    !Ft(i) || !vn(i) || (Object.assign(i.style, a), Object.keys(n).forEach(function(o) {
      var s = n[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function zw(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var n = t.elements[a], i = t.attributes[a] || {}, o = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : r[a]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Ft(n) || !vn(n) || (Object.assign(n.style, s), Object.keys(i).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
const Uw = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Kw,
  effect: zw,
  requires: ["computeStyles"]
};
function mn(e) {
  return e.split("-")[0];
}
var oa = Math.max, C1 = Math.min, $a = Math.round;
function Es() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function c4() {
  return !/^((?!chrome|android).)*safari/i.test(Es());
}
function Ja(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var a = e.getBoundingClientRect(), n = 1, i = 1;
  t && Ft(e) && (n = e.offsetWidth > 0 && $a(a.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && $a(a.height) / e.offsetHeight || 1);
  var o = ga(e) ? Ot(e) : window, s = o.visualViewport, l = !c4() && r, c = (a.left + (l && s ? s.offsetLeft : 0)) / n, d = (a.top + (l && s ? s.offsetTop : 0)) / i, p = a.width / n, f = a.height / i;
  return {
    width: p,
    height: f,
    top: d,
    right: c + p,
    bottom: d + f,
    left: c,
    x: c,
    y: d
  };
}
function Vl(e) {
  var t = Ja(e), r = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: a
  };
}
function d4(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Gl(r)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function En(e) {
  return Ot(e).getComputedStyle(e);
}
function Zw(e) {
  return ["table", "td", "th"].indexOf(vn(e)) >= 0;
}
function Jn(e) {
  return ((ga(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function co(e) {
  return vn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Gl(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Jn(e)
  );
}
function Mu(e) {
  return !Ft(e) || // https://github.com/popperjs/popper-core/issues/837
  En(e).position === "fixed" ? null : e.offsetParent;
}
function Yw(e) {
  var t = /firefox/i.test(Es()), r = /Trident/i.test(Es());
  if (r && Ft(e)) {
    var a = En(e);
    if (a.position === "fixed")
      return null;
  }
  var n = co(e);
  for (Gl(n) && (n = n.host); Ft(n) && ["html", "body"].indexOf(vn(n)) < 0; ) {
    var i = En(n);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function ki(e) {
  for (var t = Ot(e), r = Mu(e); r && Zw(r) && En(r).position === "static"; )
    r = Mu(r);
  return r && (vn(r) === "html" || vn(r) === "body" && En(r).position === "static") ? t : r || Yw(e) || t;
}
function Kl(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Or(e, t, r) {
  return oa(e, C1(t, r));
}
function Ww(e, t, r) {
  var a = Or(e, t, r);
  return a > r ? r : a;
}
function p4() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function f4(e) {
  return Object.assign({}, p4(), e);
}
function h4(e, t) {
  return t.reduce(function(r, a) {
    return r[a] = e, r;
  }, {});
}
var $w = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, f4(typeof t != "number" ? t : h4(t, Mi));
};
function Jw(e) {
  var t, r = e.state, a = e.name, n = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = mn(r.placement), l = Kl(s), c = [It, Kt].indexOf(s) >= 0, d = c ? "height" : "width";
  if (!(!i || !o)) {
    var p = $w(n.padding, r), f = Vl(i), h = l === "y" ? Dt : It, m = l === "y" ? Vt : Kt, C = r.rects.reference[d] + r.rects.reference[l] - o[l] - r.rects.popper[d], g = o[l] - r.rects.reference[l], v = ki(i), b = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, y = C / 2 - g / 2, x = p[h], S = b - f[d] - p[m], _ = b / 2 - f[d] / 2 + y, M = Or(x, _, S), I = l;
    r.modifiersData[a] = (t = {}, t[I] = M, t.centerOffset = M - _, t);
  }
}
function Qw(e) {
  var t = e.state, r = e.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || d4(t.elements.popper, n) && (t.elements.arrow = n));
}
const qw = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Jw,
  effect: Qw,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Qa(e) {
  return e.split("-")[1];
}
var Xw = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function eS(e, t) {
  var r = e.x, a = e.y, n = t.devicePixelRatio || 1;
  return {
    x: $a(r * n) / n || 0,
    y: $a(a * n) / n || 0
  };
}
function ku(e) {
  var t, r = e.popper, a = e.popperRect, n = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, p = e.isFixed, f = o.x, h = f === void 0 ? 0 : f, m = o.y, C = m === void 0 ? 0 : m, g = typeof d == "function" ? d({
    x: h,
    y: C
  }) : {
    x: h,
    y: C
  };
  h = g.x, C = g.y;
  var v = o.hasOwnProperty("x"), b = o.hasOwnProperty("y"), y = It, x = Dt, S = window;
  if (c) {
    var _ = ki(r), M = "clientHeight", I = "clientWidth";
    if (_ === Ot(r) && (_ = Jn(r), En(_).position !== "static" && s === "absolute" && (M = "scrollHeight", I = "scrollWidth")), _ = _, n === Dt || (n === It || n === Kt) && i === ei) {
      x = Vt;
      var L = p && _ === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[M]
      );
      C -= L - a.height, C *= l ? 1 : -1;
    }
    if (n === It || (n === Dt || n === Vt) && i === ei) {
      y = Kt;
      var D = p && _ === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[I]
      );
      h -= D - a.width, h *= l ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: s
  }, c && Xw), B = d === !0 ? eS({
    x: h,
    y: C
  }, Ot(r)) : {
    x: h,
    y: C
  };
  if (h = B.x, C = B.y, l) {
    var U;
    return Object.assign({}, A, (U = {}, U[x] = b ? "0" : "", U[y] = v ? "0" : "", U.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + C + "px)" : "translate3d(" + h + "px, " + C + "px, 0)", U));
  }
  return Object.assign({}, A, (t = {}, t[x] = b ? C + "px" : "", t[y] = v ? h + "px" : "", t.transform = "", t));
}
function tS(e) {
  var t = e.state, r = e.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: mn(t.placement),
    variation: Qa(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, ku(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, ku(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const nS = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: tS,
  data: {}
};
var Bi = {
  passive: !0
};
function aS(e) {
  var t = e.state, r = e.instance, a = e.options, n = a.scroll, i = n === void 0 ? !0 : n, o = a.resize, s = o === void 0 ? !0 : o, l = Ot(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(d) {
    d.addEventListener("scroll", r.update, Bi);
  }), s && l.addEventListener("resize", r.update, Bi), function() {
    i && c.forEach(function(d) {
      d.removeEventListener("scroll", r.update, Bi);
    }), s && l.removeEventListener("resize", r.update, Bi);
  };
}
const rS = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: aS,
  data: {}
};
var iS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ui(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return iS[t];
  });
}
var oS = {
  start: "end",
  end: "start"
};
function Pu(e) {
  return e.replace(/start|end/g, function(t) {
    return oS[t];
  });
}
function zl(e) {
  var t = Ot(e), r = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Ul(e) {
  return Ja(Jn(e)).left + zl(e).scrollLeft;
}
function sS(e, t) {
  var r = Ot(e), a = Jn(e), n = r.visualViewport, i = a.clientWidth, o = a.clientHeight, s = 0, l = 0;
  if (n) {
    i = n.width, o = n.height;
    var c = c4();
    (c || !c && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Ul(e),
    y: l
  };
}
function lS(e) {
  var t, r = Jn(e), a = zl(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, i = oa(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), o = oa(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), s = -a.scrollLeft + Ul(e), l = -a.scrollTop;
  return En(n || r).direction === "rtl" && (s += oa(r.clientWidth, n ? n.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Zl(e) {
  var t = En(e), r = t.overflow, a = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function m4(e) {
  return ["html", "body", "#document"].indexOf(vn(e)) >= 0 ? e.ownerDocument.body : Ft(e) && Zl(e) ? e : m4(co(e));
}
function Br(e, t) {
  var r;
  t === void 0 && (t = []);
  var a = m4(e), n = a === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Ot(a), o = n ? [i].concat(i.visualViewport || [], Zl(a) ? a : []) : a, s = t.concat(o);
  return n ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Br(co(o)))
  );
}
function Ds(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function uS(e, t) {
  var r = Ja(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Tu(e, t, r) {
  return t === l4 ? Ds(sS(e, r)) : ga(t) ? uS(t, r) : Ds(lS(Jn(e)));
}
function cS(e) {
  var t = Br(co(e)), r = ["absolute", "fixed"].indexOf(En(e).position) >= 0, a = r && Ft(e) ? ki(e) : e;
  return ga(a) ? t.filter(function(n) {
    return ga(n) && d4(n, a) && vn(n) !== "body";
  }) : [];
}
function dS(e, t, r, a) {
  var n = t === "clippingParents" ? cS(e) : [].concat(t), i = [].concat(n, [r]), o = i[0], s = i.reduce(function(l, c) {
    var d = Tu(e, c, a);
    return l.top = oa(d.top, l.top), l.right = C1(d.right, l.right), l.bottom = C1(d.bottom, l.bottom), l.left = oa(d.left, l.left), l;
  }, Tu(e, o, a));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function g4(e) {
  var t = e.reference, r = e.element, a = e.placement, n = a ? mn(a) : null, i = a ? Qa(a) : null, o = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (n) {
    case Dt:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case Vt:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Kt:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case It:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = n ? Kl(n) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (i) {
      case Wa:
        l[c] = l[c] - (t[d] / 2 - r[d] / 2);
        break;
      case ei:
        l[c] = l[c] + (t[d] / 2 - r[d] / 2);
        break;
    }
  }
  return l;
}
function ti(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = a === void 0 ? e.placement : a, i = r.strategy, o = i === void 0 ? e.strategy : i, s = r.boundary, l = s === void 0 ? Iw : s, c = r.rootBoundary, d = c === void 0 ? l4 : c, p = r.elementContext, f = p === void 0 ? kr : p, h = r.altBoundary, m = h === void 0 ? !1 : h, C = r.padding, g = C === void 0 ? 0 : C, v = f4(typeof g != "number" ? g : h4(g, Mi)), b = f === kr ? Lw : kr, y = e.rects.popper, x = e.elements[m ? b : f], S = dS(ga(x) ? x : x.contextElement || Jn(e.elements.popper), l, d, o), _ = Ja(e.elements.reference), M = g4({
    reference: _,
    element: y,
    strategy: "absolute",
    placement: n
  }), I = Ds(Object.assign({}, y, M)), L = f === kr ? I : _, D = {
    top: S.top - L.top + v.top,
    bottom: L.bottom - S.bottom + v.bottom,
    left: S.left - L.left + v.left,
    right: L.right - S.right + v.right
  }, A = e.modifiersData.offset;
  if (f === kr && A) {
    var B = A[n];
    Object.keys(D).forEach(function(U) {
      var H = [Kt, Vt].indexOf(U) >= 0 ? 1 : -1, K = [Dt, Vt].indexOf(U) >= 0 ? "y" : "x";
      D[U] += B[K] * H;
    });
  }
  return D;
}
function pS(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, c = l === void 0 ? u4 : l, d = Qa(a), p = d ? s ? xu : xu.filter(function(m) {
    return Qa(m) === d;
  }) : Mi, f = p.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  f.length === 0 && (f = p);
  var h = f.reduce(function(m, C) {
    return m[C] = ti(e, {
      placement: C,
      boundary: n,
      rootBoundary: i,
      padding: o
    })[mn(C)], m;
  }, {});
  return Object.keys(h).sort(function(m, C) {
    return h[m] - h[C];
  });
}
function fS(e) {
  if (mn(e) === Fl)
    return [];
  var t = Ui(e);
  return [Pu(e), t, Pu(t)];
}
function hS(e) {
  var t = e.state, r = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var n = r.mainAxis, i = n === void 0 ? !0 : n, o = r.altAxis, s = o === void 0 ? !0 : o, l = r.fallbackPlacements, c = r.padding, d = r.boundary, p = r.rootBoundary, f = r.altBoundary, h = r.flipVariations, m = h === void 0 ? !0 : h, C = r.allowedAutoPlacements, g = t.options.placement, v = mn(g), b = v === g, y = l || (b || !m ? [Ui(g)] : fS(g)), x = [g].concat(y).reduce(function($, W) {
      return $.concat(mn(W) === Fl ? pS(t, {
        placement: W,
        boundary: d,
        rootBoundary: p,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: C
      }) : W);
    }, []), S = t.rects.reference, _ = t.rects.popper, M = /* @__PURE__ */ new Map(), I = !0, L = x[0], D = 0; D < x.length; D++) {
      var A = x[D], B = mn(A), U = Qa(A) === Wa, H = [Dt, Vt].indexOf(B) >= 0, K = H ? "width" : "height", Z = ti(t, {
        placement: A,
        boundary: d,
        rootBoundary: p,
        altBoundary: f,
        padding: c
      }), V = H ? U ? Kt : It : U ? Vt : Dt;
      S[K] > _[K] && (V = Ui(V));
      var O = Ui(V), j = [];
      if (i && j.push(Z[B] <= 0), s && j.push(Z[V] <= 0, Z[O] <= 0), j.every(function($) {
        return $;
      })) {
        L = A, I = !1;
        break;
      }
      M.set(A, j);
    }
    if (I)
      for (var N = m ? 3 : 1, E = function(W) {
        var re = x.find(function(ae) {
          var de = M.get(ae);
          if (de)
            return de.slice(0, W).every(function(ge) {
              return ge;
            });
        });
        if (re)
          return L = re, "break";
      }, G = N; G > 0; G--) {
        var R = E(G);
        if (R === "break") break;
      }
    t.placement !== L && (t.modifiersData[a]._skip = !0, t.placement = L, t.reset = !0);
  }
}
const mS = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: hS,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Eu(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Du(e) {
  return [Dt, Kt, Vt, It].some(function(t) {
    return e[t] >= 0;
  });
}
function gS(e) {
  var t = e.state, r = e.name, a = t.rects.reference, n = t.rects.popper, i = t.modifiersData.preventOverflow, o = ti(t, {
    elementContext: "reference"
  }), s = ti(t, {
    altBoundary: !0
  }), l = Eu(o, a), c = Eu(s, n, i), d = Du(l), p = Du(c);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const CS = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: gS
};
function vS(e, t, r) {
  var a = mn(e), n = [It, Dt].indexOf(a) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * n, [It, Kt].indexOf(a) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function bS(e) {
  var t = e.state, r = e.options, a = e.name, n = r.offset, i = n === void 0 ? [0, 0] : n, o = u4.reduce(function(d, p) {
    return d[p] = vS(p, t.rects, i), d;
  }, {}), s = o[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[a] = o;
}
const yS = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: bS
};
function wS(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = g4({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const SS = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: wS,
  data: {}
};
function _S(e) {
  return e === "x" ? "y" : "x";
}
function xS(e) {
  var t = e.state, r = e.options, a = e.name, n = r.mainAxis, i = n === void 0 ? !0 : n, o = r.altAxis, s = o === void 0 ? !1 : o, l = r.boundary, c = r.rootBoundary, d = r.altBoundary, p = r.padding, f = r.tether, h = f === void 0 ? !0 : f, m = r.tetherOffset, C = m === void 0 ? 0 : m, g = ti(t, {
    boundary: l,
    rootBoundary: c,
    padding: p,
    altBoundary: d
  }), v = mn(t.placement), b = Qa(t.placement), y = !b, x = Kl(v), S = _S(x), _ = t.modifiersData.popperOffsets, M = t.rects.reference, I = t.rects.popper, L = typeof C == "function" ? C(Object.assign({}, t.rects, {
    placement: t.placement
  })) : C, D = typeof L == "number" ? {
    mainAxis: L,
    altAxis: L
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, L), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var U, H = x === "y" ? Dt : It, K = x === "y" ? Vt : Kt, Z = x === "y" ? "height" : "width", V = _[x], O = V + g[H], j = V - g[K], N = h ? -I[Z] / 2 : 0, E = b === Wa ? M[Z] : I[Z], G = b === Wa ? -I[Z] : -M[Z], R = t.elements.arrow, $ = h && R ? Vl(R) : {
        width: 0,
        height: 0
      }, W = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : p4(), re = W[H], ae = W[K], de = Or(0, M[Z], $[Z]), ge = y ? M[Z] / 2 - N - de - re - D.mainAxis : E - de - re - D.mainAxis, Je = y ? -M[Z] / 2 + N + de + ae + D.mainAxis : G + de + ae + D.mainAxis, Se = t.elements.arrow && ki(t.elements.arrow), fe = Se ? x === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, De = (U = A == null ? void 0 : A[x]) != null ? U : 0, le = V + ge - De - fe, ke = V + Je - De, nt = Or(h ? C1(O, le) : O, V, h ? oa(j, ke) : j);
      _[x] = nt, B[x] = nt - V;
    }
    if (s) {
      var tn, Qn = x === "x" ? Dt : It, Ma = x === "x" ? Vt : Kt, Sn = _[S], ka = S === "y" ? "height" : "width", Pa = Sn + g[Qn], Pi = Sn - g[Ma], fr = [Dt, It].indexOf(v) !== -1, hr = (tn = A == null ? void 0 : A[S]) != null ? tn : 0, mr = fr ? Pa : Sn - M[ka] - I[ka] - hr + D.altAxis, gr = fr ? Sn + M[ka] + I[ka] - hr - D.altAxis : Pi, Ti = h && fr ? Ww(mr, Sn, gr) : Or(h ? mr : Pa, Sn, h ? gr : Pi);
      _[S] = Ti, B[S] = Ti - Sn;
    }
    t.modifiersData[a] = B;
  }
}
const MS = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: xS,
  requiresIfExists: ["offset"]
};
function kS(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function PS(e) {
  return e === Ot(e) || !Ft(e) ? zl(e) : kS(e);
}
function TS(e) {
  var t = e.getBoundingClientRect(), r = $a(t.width) / e.offsetWidth || 1, a = $a(t.height) / e.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function ES(e, t, r) {
  r === void 0 && (r = !1);
  var a = Ft(t), n = Ft(t) && TS(t), i = Jn(t), o = Ja(e, n, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((vn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Zl(i)) && (s = PS(t)), Ft(t) ? (l = Ja(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Ul(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function DS(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function n(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && n(l);
      }
    }), a.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || n(i);
  }), a;
}
function IS(e) {
  var t = DS(e);
  return Vw.reduce(function(r, a) {
    return r.concat(t.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function LS(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function AS(e) {
  var t = e.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Iu = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Lu() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function NS(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, a = r === void 0 ? [] : r, n = t.defaultOptions, i = n === void 0 ? Iu : n;
  return function(s, l, c) {
    c === void 0 && (c = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Iu, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, h = {
      state: d,
      setOptions: function(v) {
        var b = typeof v == "function" ? v(d.options) : v;
        C(), d.options = Object.assign({}, i, d.options, b), d.scrollParents = {
          reference: ga(s) ? Br(s) : s.contextElement ? Br(s.contextElement) : [],
          popper: Br(l)
        };
        var y = IS(AS([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = y.filter(function(x) {
          return x.enabled;
        }), m(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = d.elements, b = v.reference, y = v.popper;
          if (Lu(b, y)) {
            d.rects = {
              reference: ES(b, ki(y), d.options.strategy === "fixed"),
              popper: Vl(y)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(D) {
              return d.modifiersData[D.name] = Object.assign({}, D.data);
            });
            for (var x = 0; x < d.orderedModifiers.length; x++) {
              if (d.reset === !0) {
                d.reset = !1, x = -1;
                continue;
              }
              var S = d.orderedModifiers[x], _ = S.fn, M = S.options, I = M === void 0 ? {} : M, L = S.name;
              typeof _ == "function" && (d = _({
                state: d,
                options: I,
                name: L,
                instance: h
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: LS(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        C(), f = !0;
      }
    };
    if (!Lu(s, l))
      return h;
    h.setOptions(c).then(function(g) {
      !f && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function m() {
      d.orderedModifiers.forEach(function(g) {
        var v = g.name, b = g.options, y = b === void 0 ? {} : b, x = g.effect;
        if (typeof x == "function") {
          var S = x({
            state: d,
            name: v,
            instance: h,
            options: y
          }), _ = function() {
          };
          p.push(S || _);
        }
      });
    }
    function C() {
      p.forEach(function(g) {
        return g();
      }), p = [];
    }
    return h;
  };
}
var RS = [rS, SS, nS, Uw, yS, mS, MS, qw, CS], OS = /* @__PURE__ */ NS({
  defaultModifiers: RS
}), BS = typeof Element < "u", jS = typeof Map == "function", HS = typeof Set == "function", FS = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Zi(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var r, a, n;
    if (Array.isArray(e)) {
      if (r = e.length, r != t.length) return !1;
      for (a = r; a-- !== 0; )
        if (!Zi(e[a], t[a])) return !1;
      return !0;
    }
    var i;
    if (jS && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(a = i.next()).done; )
        if (!t.has(a.value[0])) return !1;
      for (i = e.entries(); !(a = i.next()).done; )
        if (!Zi(a.value[1], t.get(a.value[0]))) return !1;
      return !0;
    }
    if (HS && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(a = i.next()).done; )
        if (!t.has(a.value[0])) return !1;
      return !0;
    }
    if (FS && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (r = e.length, r != t.length) return !1;
      for (a = r; a-- !== 0; )
        if (e[a] !== t[a]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() === t.toString();
    if (n = Object.keys(e), r = n.length, r !== Object.keys(t).length) return !1;
    for (a = r; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, n[a])) return !1;
    if (BS && e instanceof Element) return !1;
    for (a = r; a-- !== 0; )
      if (!((n[a] === "_owner" || n[a] === "__v" || n[a] === "__o") && e.$$typeof) && !Zi(e[n[a]], t[n[a]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var GS = function(t, r) {
  try {
    return Zi(t, r);
  } catch (a) {
    if ((a.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw a;
  }
};
const VS = /* @__PURE__ */ S1(GS);
var KS = [], zS = function(t, r, a) {
  a === void 0 && (a = {});
  var n = Y.useRef(null), i = {
    onFirstUpdate: a.onFirstUpdate,
    placement: a.placement || "bottom",
    strategy: a.strategy || "absolute",
    modifiers: a.modifiers || KS
  }, o = Y.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), s = o[0], l = o[1], c = Y.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(h) {
        var m = h.state, C = Object.keys(m.elements);
        Fr.flushSync(function() {
          l({
            styles: Su(C.map(function(g) {
              return [g, m.styles[g] || {}];
            })),
            attributes: Su(C.map(function(g) {
              return [g, m.attributes[g]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), d = Y.useMemo(function() {
    var f = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return VS(n.current, f) ? n.current || f : (n.current = f, f);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, c]), p = Y.useRef();
  return _u(function() {
    p.current && p.current.setOptions(d);
  }, [d]), _u(function() {
    if (!(t == null || r == null)) {
      var f = a.createPopper || OS, h = f(t, r, d);
      return p.current = h, function() {
        h.destroy(), p.current = null;
      };
    }
  }, [t, r, a.createPopper]), {
    state: p.current ? p.current.state : null,
    styles: s.styles,
    attributes: s.attributes,
    update: p.current ? p.current.update : null,
    forceUpdate: p.current ? p.current.forceUpdate : null
  };
}, US = function() {
}, ZS = function() {
  return Promise.resolve(null);
}, YS = [];
function WS(e) {
  var t = e.placement, r = t === void 0 ? "bottom" : t, a = e.strategy, n = a === void 0 ? "absolute" : a, i = e.modifiers, o = i === void 0 ? YS : i, s = e.referenceElement, l = e.onFirstUpdate, c = e.innerRef, d = e.children, p = Y.useContext(r4), f = Y.useState(null), h = f[0], m = f[1], C = Y.useState(null), g = C[0], v = C[1];
  Y.useEffect(function() {
    Ts(c, h);
  }, [c, h]);
  var b = Y.useMemo(function() {
    return {
      placement: r,
      strategy: n,
      onFirstUpdate: l,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: g != null,
        options: {
          element: g
        }
      }])
    };
  }, [r, n, l, o, g]), y = zS(s || p, h, b), x = y.state, S = y.styles, _ = y.forceUpdate, M = y.update, I = Y.useMemo(function() {
    return {
      ref: m,
      style: S.popper,
      placement: x ? x.placement : r,
      hasPopperEscaped: x && x.modifiersData.hide ? x.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: x && x.modifiersData.hide ? x.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: S.arrow,
        ref: v
      },
      forceUpdate: _ || US,
      update: M || ZS
    };
  }, [m, v, r, x, S, M, _]);
  return o4(d)(I);
}
var $S = process.env.NODE_ENV !== "production", C4 = function() {
};
if ($S) {
  var JS = function(t, r) {
    var a = arguments.length;
    r = new Array(a > 1 ? a - 1 : 0);
    for (var n = 1; n < a; n++)
      r[n - 1] = arguments[n];
    var i = 0, o = "Warning: " + t.replace(/%s/g, function() {
      return r[i++];
    });
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  };
  C4 = function(e, t, r) {
    var a = arguments.length;
    r = new Array(a > 2 ? a - 2 : 0);
    for (var n = 2; n < a; n++)
      r[n - 2] = arguments[n];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || JS.apply(null, [t].concat(r));
  };
}
var QS = C4;
const qS = /* @__PURE__ */ S1(QS);
function XS(e) {
  var t = e.children, r = e.innerRef, a = Y.useContext(i4), n = Y.useCallback(function(i) {
    Ts(r, i), s4(a, i);
  }, [r, a]);
  return Y.useEffect(function() {
    return function() {
      return Ts(r, null);
    };
  }, []), Y.useEffect(function() {
    qS(!!a, "`Reference` should not be used outside of a `Manager` component.");
  }, [a]), o4(t)({
    ref: n
  });
}
function e_(e, t) {
  if (ee(2, arguments), Gt(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var r = oe(e);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = kt(r, t.month)), t.date != null && r.setDate(Pe(t.date)), t.hours != null && r.setHours(Pe(t.hours)), t.minutes != null && r.setMinutes(Pe(t.minutes)), t.seconds != null && r.setSeconds(Pe(t.seconds)), t.milliseconds != null && r.setMilliseconds(Pe(t.milliseconds)), r);
}
function Au(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function v1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Au(Object(r), !0).forEach(function(a) {
      k(e, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Au(Object(r)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return e;
}
function Is(e) {
  return Is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Is(e);
}
function ft(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Nu(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, v4(a.key), a);
  }
}
function ht(e, t, r) {
  return t && Nu(e.prototype, t), r && Nu(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function k(e, t, r) {
  return (t = v4(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qa() {
  return qa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, qa.apply(this, arguments);
}
function mt(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ls(e, t);
}
function b1(e) {
  return b1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, b1(e);
}
function Ls(e, t) {
  return Ls = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, Ls(e, t);
}
function P(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gt(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var r, a = b1(e);
    if (t) {
      var n = b1(this).constructor;
      r = Reflect.construct(a, arguments, n);
    } else r = a.apply(this, arguments);
    return function(i, o) {
      if (o && (typeof o == "object" || typeof o == "function")) return o;
      if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return P(i);
    }(this, r);
  };
}
function ni(e) {
  return function(t) {
    if (Array.isArray(t)) return Vo(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
  }(e) || function(t, r) {
    if (t) {
      if (typeof t == "string") return Vo(t, r);
      var a = Object.prototype.toString.call(t).slice(8, -1);
      if (a === "Object" && t.constructor && (a = t.constructor.name), a === "Map" || a === "Set") return Array.from(t);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return Vo(t, r);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Vo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, a = new Array(t); r < t; r++) a[r] = e[r];
  return a;
}
function v4(e) {
  var t = function(r, a) {
    if (typeof r != "object" || r === null) return r;
    var n = r[Symbol.toPrimitive];
    if (n !== void 0) {
      var i = n.call(r, a || "default");
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (a === "string" ? String : Number)(r);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Ru = function(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, Ou = function(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, t_ = { p: Ou, P: function(e, t) {
  var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], i = a[2];
  if (!i) return Ru(e, t);
  switch (n) {
    case "P":
      r = t.dateTime({ width: "short" });
      break;
    case "PP":
      r = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = t.dateTime({ width: "long" });
      break;
    default:
      r = t.dateTime({ width: "full" });
  }
  return r.replace("{{date}}", Ru(n, t)).replace("{{time}}", Ou(i, t));
} }, jr = 12, n_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ze(e) {
  var t = e ? typeof e == "string" || e instanceof String ? rw(e) : oe(e) : /* @__PURE__ */ new Date();
  return Bn(t) ? t : null;
}
function Bn(e, t) {
  return t = t || /* @__PURE__ */ new Date("1/1/1000"), Jr(e) && !Fn(e, t);
}
function Xe(e, t, r) {
  if (r === "en") return pu(e, t, { awareOfUnicodeTokens: !0 });
  var a = la(r);
  return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && sa() && la(sa()) && (a = la(sa())), pu(e, t, { locale: a || null, awareOfUnicodeTokens: !0 });
}
function nn(e, t) {
  var r = t.dateFormat, a = t.locale;
  return e && Xe(e, Array.isArray(r) ? r[0] : r, a) || "";
}
function Bu(e, t) {
  var r = t.hour, a = r === void 0 ? 0 : r, n = t.minute, i = n === void 0 ? 0 : n, o = t.second;
  return zi(Ki($b(e, o === void 0 ? 0 : o), i), a);
}
function gn(e, t, r) {
  var a = la(t || sa());
  return W5(e, { locale: a, weekStartsOn: r });
}
function zn(e) {
  return $5(e);
}
function Dr(e) {
  return J5(e);
}
function ju(e) {
  return _s(e);
}
function Hu() {
  return hn(Ze());
}
function Gn(e, t) {
  return e && t ? ay(e, t) : !e && !t;
}
function Yt(e, t) {
  return e && t ? ny(e, t) : !e && !t;
}
function y1(e, t) {
  return e && t ? ry(e, t) : !e && !t;
}
function Ye(e, t) {
  return e && t ? ty(e, t) : !e && !t;
}
function aa(e, t) {
  return e && t ? ey(e, t) : !e && !t;
}
function Yi(e, t, r) {
  var a, n = hn(t), i = xs(r);
  try {
    a = Xr(e, { start: n, end: i });
  } catch {
    a = !1;
  }
  return a;
}
function sa() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function la(e) {
  if (typeof e == "string") {
    var t = typeof window < "u" ? window : globalThis;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function Yl(e, t) {
  return Xe(kt(Ze(), e), "LLLL", t);
}
function b4(e, t) {
  return Xe(kt(Ze(), e), "LLL", t);
}
function po(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, i = t.excludeDateIntervals, o = t.includeDates, s = t.includeDateIntervals, l = t.filterDate;
  return fo(e, { minDate: r, maxDate: a }) || n && n.some(function(c) {
    return Ye(e, c);
  }) || i && i.some(function(c) {
    var d = c.start, p = c.end;
    return Xr(e, { start: d, end: p });
  }) || o && !o.some(function(c) {
    return Ye(e, c);
  }) || s && !s.some(function(c) {
    var d = c.start, p = c.end;
    return Xr(e, { start: d, end: p });
  }) || l && !l(Ze(e)) || !1;
}
function Wl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function(n) {
    var i = n.start, o = n.end;
    return Xr(e, { start: i, end: o });
  }) : r && r.some(function(n) {
    return Ye(e, n);
  }) || !1;
}
function y4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return fo(e, { minDate: $5(r), maxDate: qb(a) }) || n && n.some(function(s) {
    return Yt(e, s);
  }) || i && !i.some(function(s) {
    return Yt(e, s);
  }) || o && !o(Ze(e)) || !1;
}
function Ko(e, t, r, a) {
  var n = Te(e), i = wt(e), o = Te(t), s = wt(t), l = Te(a);
  return n === o && n === l ? i <= r && r <= s : n < o ? l === n && i <= r || l === o && s >= r || l < o && l > n : void 0;
}
function a_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return fo(e, { minDate: r, maxDate: a }) || n && n.some(function(s) {
    return y1(e, s);
  }) || i && !i.some(function(s) {
    return y1(e, s);
  }) || o && !o(Ze(e)) || !1;
}
function zo(e, t, r) {
  if (!Jr(t) || !Jr(r)) return !1;
  var a = Te(t), n = Te(r);
  return a <= e && n >= e;
}
function w4(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, i = t.includeDates, o = t.filterDate, s = new Date(e, 0, 1);
  return fo(s, { minDate: J5(r), maxDate: Xb(a) }) || n && n.some(function(l) {
    return Gn(s, l);
  }) || i && !i.some(function(l) {
    return Gn(s, l);
  }) || o && !o(Ze(s)) || !1;
}
function Uo(e, t, r, a) {
  var n = Te(e), i = Ra(e), o = Te(t), s = Ra(t), l = Te(a);
  return n === o && n === l ? i <= r && r <= s : n < o ? l === n && i <= r || l === o && s >= r || l < o && l > n : void 0;
}
function fo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
  return r && qr(e, r) < 0 || a && qr(e, a) > 0;
}
function Fu(e, t) {
  return t.some(function(r) {
    return fn(r) === fn(e) && pn(r) === pn(e);
  });
}
function Gu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
  return r && Fu(e, r) || a && !Fu(e, a) || n && !n(e) || !1;
}
function Vu(e, t) {
  var r = t.minTime, a = t.maxTime;
  if (!r || !a) throw new Error("Both minTime and maxTime props required");
  var n, i = Ze(), o = zi(Ki(i, pn(e)), fn(e)), s = zi(Ki(i, pn(r)), fn(r)), l = zi(Ki(i, pn(a)), fn(a));
  try {
    n = !Xr(o, { start: s, end: l });
  } catch {
    n = !1;
  }
  return n;
}
function Ku(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ya(e, 1);
  return r && f1(r, n) > 0 || a && a.every(function(i) {
    return f1(i, n) > 0;
  }) || !1;
}
function zu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = qt(e, 1);
  return r && f1(n, r) > 0 || a && a.every(function(i) {
    return f1(n, i) > 0;
  }) || !1;
}
function Uu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Qr(e, 1);
  return r && h1(r, n) > 0 || a && a.every(function(i) {
    return h1(i, n) > 0;
  }) || !1;
}
function Zu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = Za(e, 1);
  return r && h1(n, r) > 0 || a && a.every(function(i) {
    return h1(n, i) > 0;
  }) || !1;
}
function S4(e) {
  var t = e.minDate, r = e.includeDates;
  if (r && t) {
    var a = r.filter(function(n) {
      return qr(n, t) >= 0;
    });
    return gu(a);
  }
  return r ? gu(r) : t;
}
function _4(e) {
  var t = e.maxDate, r = e.includeDates;
  if (r && t) {
    var a = r.filter(function(n) {
      return qr(n, t) <= 0;
    });
    return Cu(a);
  }
  return r ? Cu(r) : t;
}
function Yu() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", r = /* @__PURE__ */ new Map(), a = 0, n = e.length; a < n; a++) {
    var i = e[a];
    if (lo(i)) {
      var o = Xe(i, "MM.dd.yyyy"), s = r.get(o) || [];
      s.includes(t) || (s.push(t), r.set(o, s));
    } else if (Is(i) === "object") {
      var l = Object.keys(i), c = l[0], d = i[l[0]];
      if (typeof c == "string" && d.constructor === Array) for (var p = 0, f = d.length; p < f; p++) {
        var h = Xe(d[p], "MM.dd.yyyy"), m = r.get(h) || [];
        m.includes(c) || (m.push(c), r.set(h, m));
      }
    }
  }
  return r;
}
function r_() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", r = /* @__PURE__ */ new Map();
  return e.forEach(function(a) {
    var n = a.date, i = a.holidayName;
    if (lo(n)) {
      var o = Xe(n, "MM.dd.yyyy"), s = r.get(o) || {};
      if (!("className" in s) || s.className !== t || (l = s.holidayNames, c = [i], l.length !== c.length || !l.every(function(p, f) {
        return p === c[f];
      }))) {
        var l, c;
        s.className = t;
        var d = s.holidayNames;
        s.holidayNames = d ? [].concat(ni(d), [i]) : [i], r.set(o, s);
      }
    }
  }), r;
}
function i_(e, t, r, a, n) {
  for (var i = n.length, o = [], s = 0; s < i; s++) {
    var l = ws(Gb(e, fn(n[s])), pn(n[s])), c = ws(e, (r + 1) * a);
    Yn(l, t) && Fn(l, c) && o.push(n[s]);
  }
  return o;
}
function Wu(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Oa(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : jr, r = Math.ceil(Te(e) / t) * t;
  return { startPeriod: r - (t - 1), endPeriod: r };
}
function $u(e) {
  var t = e.getSeconds(), r = e.getMilliseconds();
  return oe(e.getTime() - 1e3 * t - r);
}
function o_(e, t, r, a) {
  for (var n = [], i = 0; i < 2 * t + 1; i++) {
    var o = e + t - i, s = !0;
    r && (s = Te(r) <= o), a && s && (s = Te(a) >= o), s && n.push(o);
  }
  return n;
}
var s_ = uo(function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    ft(this, r), k(P(n = t.call(this, a)), "renderOptions", function() {
      var l = n.props.year, c = n.state.yearsList.map(function(f) {
        return w.createElement("div", { className: l === f ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: f, onClick: n.onChange.bind(P(n), f), "aria-selected": l === f ? "true" : void 0 }, l === f ? w.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", f);
      }), d = n.props.minDate ? Te(n.props.minDate) : null, p = n.props.maxDate ? Te(n.props.maxDate) : null;
      return p && n.state.yearsList.find(function(f) {
        return f === p;
      }) || c.unshift(w.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears }, w.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), d && n.state.yearsList.find(function(f) {
        return f === d;
      }) || c.push(w.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears }, w.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), c;
    }), k(P(n), "onChange", function(l) {
      n.props.onChange(l);
    }), k(P(n), "handleClickOutside", function() {
      n.props.onCancel();
    }), k(P(n), "shiftYears", function(l) {
      var c = n.state.yearsList.map(function(d) {
        return d + l;
      });
      n.setState({ yearsList: c });
    }), k(P(n), "incrementYears", function() {
      return n.shiftYears(1);
    }), k(P(n), "decrementYears", function() {
      return n.shiftYears(-1);
    });
    var i = a.yearDropdownItemNumber, o = a.scrollableYearDropdown, s = i || (o ? 10 : 5);
    return n.state = { yearsList: o_(n.props.year, s, n.props.minDate, n.props.maxDate) }, n.dropdownRef = ra(), n;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    var a = this.dropdownRef.current;
    if (a) {
      var n = a.children ? Array.from(a.children) : null, i = n ? n.find(function(o) {
        return o.ariaSelected;
      }) : null;
      a.scrollTop = i ? i.offsetTop + (i.clientHeight - a.clientHeight) / 2 : (a.scrollHeight - a.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var a = vt({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return w.createElement("div", { className: a, ref: this.dropdownRef }, this.renderOptions());
  } }]), r;
}()), l_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(P(a), "renderSelectOptions", function() {
      for (var s = a.props.minDate ? Te(a.props.minDate) : 1900, l = a.props.maxDate ? Te(a.props.maxDate) : 2100, c = [], d = s; d <= l; d++) c.push(w.createElement("option", { key: d, value: d }, d));
      return c;
    }), k(P(a), "onSelectChange", function(s) {
      a.onChange(s.target.value);
    }), k(P(a), "renderSelectMode", function() {
      return w.createElement("select", { value: a.props.year, className: "react-datepicker__year-select", onChange: a.onSelectChange }, a.renderSelectOptions());
    }), k(P(a), "renderReadView", function(s) {
      return w.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(l) {
        return a.toggleDropdown(l);
      } }, w.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), w.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, a.props.year));
    }), k(P(a), "renderDropdown", function() {
      return w.createElement(s_, { key: "dropdown", year: a.props.year, onChange: a.onChange, onCancel: a.toggleDropdown, minDate: a.props.minDate, maxDate: a.props.maxDate, scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), k(P(a), "renderScrollMode", function() {
      var s = a.state.dropdownVisible, l = [a.renderReadView(!s)];
      return s && l.unshift(a.renderDropdown()), l;
    }), k(P(a), "onChange", function(s) {
      a.toggleDropdown(), s !== a.props.year && a.props.onChange(s);
    }), k(P(a), "toggleDropdown", function(s) {
      a.setState({ dropdownVisible: !a.state.dropdownVisible }, function() {
        a.props.adjustDateOnChange && a.handleYearChange(a.props.date, s);
      });
    }), k(P(a), "handleYearChange", function(s, l) {
      a.onSelect(s, l), a.setOpen();
    }), k(P(a), "onSelect", function(s, l) {
      a.props.onSelect && a.props.onSelect(s, l);
    }), k(P(a), "setOpen", function() {
      a.props.setOpen && a.props.setOpen(!0);
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    var a;
    switch (this.props.dropdownMode) {
      case "scroll":
        a = this.renderScrollMode();
        break;
      case "select":
        a = this.renderSelectMode();
    }
    return w.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, a);
  } }]), r;
}(), u_ = uo(function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "isSelectedMonth", function(s) {
      return a.props.month === s;
    }), k(P(a), "renderOptions", function() {
      return a.props.monthNames.map(function(s, l) {
        return w.createElement("div", { className: a.isSelectedMonth(l) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: a.onChange.bind(P(a), l), "aria-selected": a.isSelectedMonth(l) ? "true" : void 0 }, a.isSelectedMonth(l) ? w.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), k(P(a), "onChange", function(s) {
      return a.props.onChange(s);
    }), k(P(a), "handleClickOutside", function() {
      return a.props.onCancel();
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    return w.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), r;
}()), c_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(P(a), "renderSelectOptions", function(s) {
      return s.map(function(l, c) {
        return w.createElement("option", { key: c, value: c }, l);
      });
    }), k(P(a), "renderSelectMode", function(s) {
      return w.createElement("select", { value: a.props.month, className: "react-datepicker__month-select", onChange: function(l) {
        return a.onChange(l.target.value);
      } }, a.renderSelectOptions(s));
    }), k(P(a), "renderReadView", function(s, l) {
      return w.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: a.toggleDropdown }, w.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), w.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, l[a.props.month]));
    }), k(P(a), "renderDropdown", function(s) {
      return w.createElement(u_, { key: "dropdown", month: a.props.month, monthNames: s, onChange: a.onChange, onCancel: a.toggleDropdown });
    }), k(P(a), "renderScrollMode", function(s) {
      var l = a.state.dropdownVisible, c = [a.renderReadView(!l, s)];
      return l && c.unshift(a.renderDropdown(s)), c;
    }), k(P(a), "onChange", function(s) {
      a.toggleDropdown(), s !== a.props.month && a.props.onChange(s);
    }), k(P(a), "toggleDropdown", function() {
      return a.setState({ dropdownVisible: !a.state.dropdownVisible });
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    var a, n = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return b4(o, n.props.locale);
    } : function(o) {
      return Yl(o, n.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        a = this.renderScrollMode(i);
        break;
      case "select":
        a = this.renderSelectMode(i);
    }
    return w.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, a);
  } }]), r;
}();
function d_(e, t) {
  for (var r = [], a = zn(e), n = zn(t); !Yn(a, n); ) r.push(Ze(a)), a = qt(a, 1);
  return r;
}
var p_ = uo(function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "renderOptions", function() {
      return n.state.monthYearsList.map(function(i) {
        var o = Ss(i), s = Gn(n.props.date, i) && Yt(n.props.date, i);
        return w.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: n.onChange.bind(P(n), o), "aria-selected": s ? "true" : void 0 }, s ? w.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", Xe(i, n.props.dateFormat, n.props.locale));
      });
    }), k(P(n), "onChange", function(i) {
      return n.props.onChange(i);
    }), k(P(n), "handleClickOutside", function() {
      n.props.onCancel();
    }), n.state = { monthYearsList: d_(n.props.minDate, n.props.maxDate) }, n;
  }
  return ht(r, [{ key: "render", value: function() {
    var a = vt({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return w.createElement("div", { className: a }, this.renderOptions());
  } }]), r;
}()), f_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), k(P(a), "renderSelectOptions", function() {
      for (var s = zn(a.props.minDate), l = zn(a.props.maxDate), c = []; !Yn(s, l); ) {
        var d = Ss(s);
        c.push(w.createElement("option", { key: d, value: d }, Xe(s, a.props.dateFormat, a.props.locale))), s = qt(s, 1);
      }
      return c;
    }), k(P(a), "onSelectChange", function(s) {
      a.onChange(s.target.value);
    }), k(P(a), "renderSelectMode", function() {
      return w.createElement("select", { value: Ss(zn(a.props.date)), className: "react-datepicker__month-year-select", onChange: a.onSelectChange }, a.renderSelectOptions());
    }), k(P(a), "renderReadView", function(s) {
      var l = Xe(a.props.date, a.props.dateFormat, a.props.locale);
      return w.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(c) {
        return a.toggleDropdown(c);
      } }, w.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), w.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, l));
    }), k(P(a), "renderDropdown", function() {
      return w.createElement(p_, { key: "dropdown", date: a.props.date, dateFormat: a.props.dateFormat, onChange: a.onChange, onCancel: a.toggleDropdown, minDate: a.props.minDate, maxDate: a.props.maxDate, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, locale: a.props.locale });
    }), k(P(a), "renderScrollMode", function() {
      var s = a.state.dropdownVisible, l = [a.renderReadView(!s)];
      return s && l.unshift(a.renderDropdown()), l;
    }), k(P(a), "onChange", function(s) {
      a.toggleDropdown();
      var l = Ze(parseInt(s));
      Gn(a.props.date, l) && Yt(a.props.date, l) || a.props.onChange(l);
    }), k(P(a), "toggleDropdown", function() {
      return a.setState({ dropdownVisible: !a.state.dropdownVisible });
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    var a;
    switch (this.props.dropdownMode) {
      case "scroll":
        a = this.renderScrollMode();
        break;
      case "select":
        a = this.renderSelectMode();
    }
    return w.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, a);
  } }]), r;
}(), h_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "dayEl", w.createRef()), k(P(a), "handleClick", function(s) {
      !a.isDisabled() && a.props.onClick && a.props.onClick(s);
    }), k(P(a), "handleMouseEnter", function(s) {
      !a.isDisabled() && a.props.onMouseEnter && a.props.onMouseEnter(s);
    }), k(P(a), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), a.props.handleOnKeyDown(s);
    }), k(P(a), "isSameDay", function(s) {
      return Ye(a.props.day, s);
    }), k(P(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !(a.isSameDay(a.props.selected) || a.isSameWeek(a.props.selected)) && (a.isSameDay(a.props.preSelection) || a.isSameWeek(a.props.preSelection));
    }), k(P(a), "isDisabled", function() {
      return po(a.props.day, a.props);
    }), k(P(a), "isExcluded", function() {
      return Wl(a.props.day, a.props);
    }), k(P(a), "isStartOfWeek", function() {
      return Ye(a.props.day, gn(a.props.day, a.props.locale, a.props.calendarStartDay));
    }), k(P(a), "isSameWeek", function(s) {
      return a.props.showWeekPicker && Ye(s, gn(a.props.day, a.props.locale, a.props.calendarStartDay));
    }), k(P(a), "getHighLightedClass", function() {
      var s = a.props, l = s.day, c = s.highlightDates;
      if (!c) return !1;
      var d = Xe(l, "MM.dd.yyyy");
      return c.get(d);
    }), k(P(a), "getHolidaysClass", function() {
      var s = a.props, l = s.day, c = s.holidays;
      if (!c) return !1;
      var d = Xe(l, "MM.dd.yyyy");
      return c.has(d) ? [c.get(d).className] : void 0;
    }), k(P(a), "isInRange", function() {
      var s = a.props, l = s.day, c = s.startDate, d = s.endDate;
      return !(!c || !d) && Yi(l, c, d);
    }), k(P(a), "isInSelectingRange", function() {
      var s, l = a.props, c = l.day, d = l.selectsStart, p = l.selectsEnd, f = l.selectsRange, h = l.selectsDisabledDaysInRange, m = l.startDate, C = l.endDate, g = (s = a.props.selectingDate) !== null && s !== void 0 ? s : a.props.preSelection;
      return !(!(d || p || f) || !g || !h && a.isDisabled()) && (d && C && (Fn(g, C) || aa(g, C)) ? Yi(c, g, C) : (p && m && (Yn(g, m) || aa(g, m)) || !(!f || !m || C || !Yn(g, m) && !aa(g, m))) && Yi(c, m, g));
    }), k(P(a), "isSelectingRangeStart", function() {
      var s;
      if (!a.isInSelectingRange()) return !1;
      var l = a.props, c = l.day, d = l.startDate, p = l.selectsStart, f = (s = a.props.selectingDate) !== null && s !== void 0 ? s : a.props.preSelection;
      return Ye(c, p ? f : d);
    }), k(P(a), "isSelectingRangeEnd", function() {
      var s;
      if (!a.isInSelectingRange()) return !1;
      var l = a.props, c = l.day, d = l.endDate, p = l.selectsEnd, f = l.selectsRange, h = (s = a.props.selectingDate) !== null && s !== void 0 ? s : a.props.preSelection;
      return Ye(c, p || f ? h : d);
    }), k(P(a), "isRangeStart", function() {
      var s = a.props, l = s.day, c = s.startDate, d = s.endDate;
      return !(!c || !d) && Ye(c, l);
    }), k(P(a), "isRangeEnd", function() {
      var s = a.props, l = s.day, c = s.startDate, d = s.endDate;
      return !(!c || !d) && Ye(d, l);
    }), k(P(a), "isWeekend", function() {
      var s = zb(a.props.day);
      return s === 0 || s === 6;
    }), k(P(a), "isAfterMonth", function() {
      return a.props.month !== void 0 && (a.props.month + 1) % 12 === wt(a.props.day);
    }), k(P(a), "isBeforeMonth", function() {
      return a.props.month !== void 0 && (wt(a.props.day) + 1) % 12 === a.props.month;
    }), k(P(a), "isCurrentDay", function() {
      return a.isSameDay(Ze());
    }), k(P(a), "isSelected", function() {
      return a.isSameDay(a.props.selected) || a.isSameWeek(a.props.selected);
    }), k(P(a), "getClassNames", function(s) {
      var l, c = a.props.dayClassName ? a.props.dayClassName(s) : void 0;
      return vt("react-datepicker__day", c, "react-datepicker__day--" + Xe(a.props.day, "ddd", l), { "react-datepicker__day--disabled": a.isDisabled(), "react-datepicker__day--excluded": a.isExcluded(), "react-datepicker__day--selected": a.isSelected(), "react-datepicker__day--keyboard-selected": a.isKeyboardSelected(), "react-datepicker__day--range-start": a.isRangeStart(), "react-datepicker__day--range-end": a.isRangeEnd(), "react-datepicker__day--in-range": a.isInRange(), "react-datepicker__day--in-selecting-range": a.isInSelectingRange(), "react-datepicker__day--selecting-range-start": a.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": a.isSelectingRangeEnd(), "react-datepicker__day--today": a.isCurrentDay(), "react-datepicker__day--weekend": a.isWeekend(), "react-datepicker__day--outside-month": a.isAfterMonth() || a.isBeforeMonth() }, a.getHighLightedClass("react-datepicker__day--highlighted"), a.getHolidaysClass());
    }), k(P(a), "getAriaLabel", function() {
      var s = a.props, l = s.day, c = s.ariaLabelPrefixWhenEnabled, d = c === void 0 ? "Choose" : c, p = s.ariaLabelPrefixWhenDisabled, f = p === void 0 ? "Not available" : p, h = a.isDisabled() || a.isExcluded() ? f : d;
      return "".concat(h, " ").concat(Xe(l, "PPPP", a.props.locale));
    }), k(P(a), "getTitle", function() {
      var s = a.props, l = s.day, c = s.holidays, d = c === void 0 ? /* @__PURE__ */ new Map() : c, p = Xe(l, "MM.dd.yyyy");
      return d.has(p) && d.get(p).holidayNames.length > 0 ? d.get(p).holidayNames.join(", ") : "";
    }), k(P(a), "getTabIndex", function(s, l) {
      var c = s || a.props.selected, d = l || a.props.preSelection;
      return (!a.props.showWeekPicker || !a.props.showWeekNumber && a.isStartOfWeek()) && (a.isKeyboardSelected() || a.isSameDay(c) && Ye(d, c)) ? 0 : -1;
    }), k(P(a), "handleFocusDay", function() {
      var s, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      a.getTabIndex() === 0 && !l.isInputFocused && a.isSameDay(a.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (c = !0), a.props.inline && !a.props.shouldFocusDayInline && (c = !1), a.props.containerRef && a.props.containerRef.current && a.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (c = !0), a.props.monthShowsDuplicateDaysEnd && a.isAfterMonth() && (c = !1), a.props.monthShowsDuplicateDaysStart && a.isBeforeMonth() && (c = !1)), c && ((s = a.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    }), k(P(a), "renderDayContents", function() {
      return a.props.monthShowsDuplicateDaysEnd && a.isAfterMonth() || a.props.monthShowsDuplicateDaysStart && a.isBeforeMonth() ? null : a.props.renderDayContents ? a.props.renderDayContents(mu(a.props.day), a.props.day) : mu(a.props.day);
    }), k(P(a), "render", function() {
      return w.createElement("div", { ref: a.dayEl, className: a.getClassNames(a.props.day), onKeyDown: a.handleOnKeyDown, onClick: a.handleClick, onMouseEnter: a.handleMouseEnter, tabIndex: a.getTabIndex(), "aria-label": a.getAriaLabel(), role: "option", title: a.getTitle(), "aria-disabled": a.isDisabled(), "aria-current": a.isCurrentDay() ? "date" : void 0, "aria-selected": a.isSelected() || a.isInRange() }, a.renderDayContents(), a.getTitle() !== "" && w.createElement("span", { className: "holiday-overlay" }, a.getTitle()));
    }), a;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(a) {
    this.handleFocusDay(a);
  } }]), r;
}(), m_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "weekNumberEl", w.createRef()), k(P(a), "handleClick", function(s) {
      a.props.onClick && a.props.onClick(s);
    }), k(P(a), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), a.props.handleOnKeyDown(s);
    }), k(P(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !Ye(a.props.date, a.props.selected) && Ye(a.props.date, a.props.preSelection);
    }), k(P(a), "getTabIndex", function() {
      return a.props.showWeekPicker && a.props.showWeekNumber && (a.isKeyboardSelected() || Ye(a.props.date, a.props.selected) && Ye(a.props.preSelection, a.props.selected)) ? 0 : -1;
    }), k(P(a), "handleFocusWeekNumber", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      a.getTabIndex() === 0 && !s.isInputFocused && Ye(a.props.date, a.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), a.props.inline && !a.props.shouldFocusDayInline && (l = !1), a.props.containerRef && a.props.containerRef.current && a.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (l = !0)), l && a.weekNumberEl.current && a.weekNumberEl.current.focus({ preventScroll: !0 });
    }), a;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(a) {
    this.handleFocusWeekNumber(a);
  } }, { key: "render", value: function() {
    var a = this.props, n = a.weekNumber, i = a.ariaLabelPrefix, o = i === void 0 ? "week " : i, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!a.onClick, "react-datepicker__week-number--selected": Ye(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return w.createElement("div", { ref: this.weekNumberEl, className: vt(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), r;
}(), g_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "handleDayClick", function(s, l) {
      a.props.onDayClick && a.props.onDayClick(s, l);
    }), k(P(a), "handleDayMouseEnter", function(s) {
      a.props.onDayMouseEnter && a.props.onDayMouseEnter(s);
    }), k(P(a), "handleWeekClick", function(s, l, c) {
      if (typeof a.props.onWeekSelect == "function" && a.props.onWeekSelect(s, l, c), a.props.showWeekPicker) {
        var d = gn(s, a.props.locale, a.props.calendarStartDay);
        a.handleDayClick(d, c);
      }
      a.props.shouldCloseOnSelect && a.props.setOpen(!1);
    }), k(P(a), "formatWeekNumber", function(s) {
      return a.props.formatWeekNumber ? a.props.formatWeekNumber(s) : function(l, c) {
        var d = sa() && la(sa());
        return Wb(l, d ? { locale: d } : null);
      }(s);
    }), k(P(a), "renderDays", function() {
      var s = gn(a.props.day, a.props.locale, a.props.calendarStartDay), l = [], c = a.formatWeekNumber(s);
      if (a.props.showWeekNumber) {
        var d = a.props.onWeekSelect || a.props.showWeekPicker ? a.handleWeekClick.bind(P(a), s, c) : void 0;
        l.push(w.createElement(m_, { key: "W", weekNumber: c, date: s, onClick: d, selected: a.props.selected, preSelection: a.props.preSelection, ariaLabelPrefix: a.props.ariaLabelPrefix, showWeekPicker: a.props.showWeekPicker, showWeekNumber: a.props.showWeekNumber, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, handleOnKeyDown: a.props.handleOnKeyDown, isInputFocused: a.props.isInputFocused, containerRef: a.props.containerRef }));
      }
      return l.concat([0, 1, 2, 3, 4, 5, 6].map(function(p) {
        var f = pr(s, p);
        return w.createElement(h_, { ariaLabelPrefixWhenEnabled: a.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: a.props.disabledDayAriaLabelPrefix, key: f.valueOf(), day: f, month: a.props.month, onClick: a.handleDayClick.bind(P(a), f), onMouseEnter: a.handleDayMouseEnter.bind(P(a), f), minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.props.selectingDate, filterDate: a.props.filterDate, preSelection: a.props.preSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, showWeekPicker: a.props.showWeekPicker, showWeekNumber: a.props.showWeekNumber, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, startDate: a.props.startDate, endDate: a.props.endDate, dayClassName: a.props.dayClassName, renderDayContents: a.props.renderDayContents, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, handleOnKeyDown: a.props.handleOnKeyDown, isInputFocused: a.props.isInputFocused, containerRef: a.props.containerRef, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: a.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: a.props.monthShowsDuplicateDaysStart, locale: a.props.locale });
      }));
    }), k(P(a), "startOfWeek", function() {
      return gn(a.props.day, a.props.locale, a.props.calendarStartDay);
    }), k(P(a), "isKeyboardSelected", function() {
      return !a.props.disabledKeyboardNavigation && !Ye(a.startOfWeek(), a.props.selected) && Ye(a.startOfWeek(), a.props.preSelection);
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    var a = { "react-datepicker__week": !0, "react-datepicker__week--selected": Ye(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return w.createElement("div", { className: vt(a) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), r;
}(), x4 = "two_columns", M4 = "three_columns", k4 = "four_columns", Zo = k(k(k({}, x4, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), M4, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), k4, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function Ju(e, t) {
  return e ? k4 : t ? x4 : M4;
}
var C_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "MONTH_REFS", ni(Array(12)).map(function() {
      return w.createRef();
    })), k(P(a), "QUARTER_REFS", ni(Array(4)).map(function() {
      return w.createRef();
    })), k(P(a), "isDisabled", function(s) {
      return po(s, a.props);
    }), k(P(a), "isExcluded", function(s) {
      return Wl(s, a.props);
    }), k(P(a), "handleDayClick", function(s, l) {
      a.props.onDayClick && a.props.onDayClick(s, l, a.props.orderInDisplay);
    }), k(P(a), "handleDayMouseEnter", function(s) {
      a.props.onDayMouseEnter && a.props.onDayMouseEnter(s);
    }), k(P(a), "handleMouseLeave", function() {
      a.props.onMouseLeave && a.props.onMouseLeave();
    }), k(P(a), "isRangeStartMonth", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate;
      return !(!d || !p) && Yt(kt(c, s), d);
    }), k(P(a), "isRangeStartQuarter", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate;
      return !(!d || !p) && y1(Na(c, s), d);
    }), k(P(a), "isRangeEndMonth", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate;
      return !(!d || !p) && Yt(kt(c, s), p);
    }), k(P(a), "isRangeEndQuarter", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate;
      return !(!d || !p) && y1(Na(c, s), p);
    }), k(P(a), "isInSelectingRangeMonth", function(s) {
      var l, c = a.props, d = c.day, p = c.selectsStart, f = c.selectsEnd, h = c.selectsRange, m = c.startDate, C = c.endDate, g = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return !(!(p || f || h) || !g) && (p && C ? Ko(g, C, s, d) : (f && m || !(!h || !m || C)) && Ko(m, g, s, d));
    }), k(P(a), "isSelectingMonthRangeStart", function(s) {
      var l;
      if (!a.isInSelectingRangeMonth(s)) return !1;
      var c = a.props, d = c.day, p = c.startDate, f = c.selectsStart, h = kt(d, s), m = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return Yt(h, f ? m : p);
    }), k(P(a), "isSelectingMonthRangeEnd", function(s) {
      var l;
      if (!a.isInSelectingRangeMonth(s)) return !1;
      var c = a.props, d = c.day, p = c.endDate, f = c.selectsEnd, h = c.selectsRange, m = kt(d, s), C = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return Yt(m, f || h ? C : p);
    }), k(P(a), "isInSelectingRangeQuarter", function(s) {
      var l, c = a.props, d = c.day, p = c.selectsStart, f = c.selectsEnd, h = c.selectsRange, m = c.startDate, C = c.endDate, g = (l = a.props.selectingDate) !== null && l !== void 0 ? l : a.props.preSelection;
      return !(!(p || f || h) || !g) && (p && C ? Uo(g, C, s, d) : (f && m || !(!h || !m || C)) && Uo(m, g, s, d));
    }), k(P(a), "isWeekInMonth", function(s) {
      var l = a.props.day, c = pr(s, 6);
      return Yt(s, l) || Yt(c, l);
    }), k(P(a), "isCurrentMonth", function(s, l) {
      return Te(s) === Te(Ze()) && l === wt(Ze());
    }), k(P(a), "isCurrentQuarter", function(s, l) {
      return Te(s) === Te(Ze()) && l === Ra(Ze());
    }), k(P(a), "isSelectedMonth", function(s, l, c) {
      return wt(c) === l && Te(s) === Te(c);
    }), k(P(a), "isSelectedQuarter", function(s, l, c) {
      return Ra(s) === l && Te(s) === Te(c);
    }), k(P(a), "renderWeeks", function() {
      for (var s = [], l = a.props.fixedHeight, c = 0, d = !1, p = gn(zn(a.props.day), a.props.locale, a.props.calendarStartDay); s.push(w.createElement(g_, { ariaLabelPrefix: a.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, key: c, day: p, month: wt(a.props.day), onDayClick: a.handleDayClick, onDayMouseEnter: a.handleDayMouseEnter, onWeekSelect: a.props.onWeekSelect, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.props.selectingDate, filterDate: a.props.filterDate, preSelection: a.props.preSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumber: a.props.showWeekNumbers, showWeekPicker: a.props.showWeekPicker, startDate: a.props.startDate, endDate: a.props.endDate, dayClassName: a.props.dayClassName, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderDayContents: a.props.renderDayContents, handleOnKeyDown: a.props.handleOnKeyDown, isInputFocused: a.props.isInputFocused, containerRef: a.props.containerRef, calendarStartDay: a.props.calendarStartDay, monthShowsDuplicateDaysEnd: a.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: a.props.monthShowsDuplicateDaysStart })), !d; ) {
        c++, p = d1(p, 1);
        var f = l && c >= 6, h = !l && !a.isWeekInMonth(p);
        if (f || h) {
          if (!a.props.peekNextMonth) break;
          d = !0;
        }
      }
      return s;
    }), k(P(a), "onMonthClick", function(s, l) {
      a.handleDayClick(zn(kt(a.props.day, l)), s);
    }), k(P(a), "onMonthMouseEnter", function(s) {
      a.handleDayMouseEnter(zn(kt(a.props.day, s)));
    }), k(P(a), "handleMonthNavigation", function(s, l) {
      a.isDisabled(l) || a.isExcluded(l) || (a.props.setPreSelection(l), a.MONTH_REFS[s].current && a.MONTH_REFS[s].current.focus());
    }), k(P(a), "onMonthKeyDown", function(s, l) {
      var c = a.props, d = c.selected, p = c.preSelection, f = c.disabledKeyboardNavigation, h = c.showTwoColumnMonthYearPicker, m = c.showFourColumnMonthYearPicker, C = c.setPreSelection, g = s.key;
      if (g !== "Tab" && s.preventDefault(), !f) {
        var v = Ju(m, h), b = Zo[v].verticalNavigationOffset, y = Zo[v].grid;
        switch (g) {
          case "Enter":
            a.onMonthClick(s, l), C(d);
            break;
          case "ArrowRight":
            a.handleMonthNavigation(l === 11 ? 0 : l + 1, qt(p, 1));
            break;
          case "ArrowLeft":
            a.handleMonthNavigation(l === 0 ? 11 : l - 1, Ya(p, 1));
            break;
          case "ArrowUp":
            a.handleMonthNavigation(y[0].includes(l) ? l + 12 - b : l - b, Ya(p, b));
            break;
          case "ArrowDown":
            a.handleMonthNavigation(y[y.length - 1].includes(l) ? l - 12 + b : l + b, qt(p, b));
        }
      }
    }), k(P(a), "onQuarterClick", function(s, l) {
      a.handleDayClick(ju(Na(a.props.day, l)), s);
    }), k(P(a), "onQuarterMouseEnter", function(s) {
      a.handleDayMouseEnter(ju(Na(a.props.day, s)));
    }), k(P(a), "handleQuarterNavigation", function(s, l) {
      a.isDisabled(l) || a.isExcluded(l) || (a.props.setPreSelection(l), a.QUARTER_REFS[s - 1].current && a.QUARTER_REFS[s - 1].current.focus());
    }), k(P(a), "onQuarterKeyDown", function(s, l) {
      var c = s.key;
      if (!a.props.disabledKeyboardNavigation) switch (c) {
        case "Enter":
          a.onQuarterClick(s, l), a.props.setPreSelection(a.props.selected);
          break;
        case "ArrowRight":
          a.handleQuarterNavigation(l === 4 ? 1 : l + 1, Y5(a.props.preSelection, 1));
          break;
        case "ArrowLeft":
          a.handleQuarterNavigation(l === 1 ? 4 : l - 1, Kb(a.props.preSelection, 1));
      }
    }), k(P(a), "getMonthClassNames", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate, f = l.selected, h = l.minDate, m = l.maxDate, C = l.preSelection, g = l.monthClassName, v = l.excludeDates, b = l.includeDates, y = g ? g(kt(c, s)) : void 0, x = kt(c, s);
      return vt("react-datepicker__month-text", "react-datepicker__month-".concat(s), y, { "react-datepicker__month-text--disabled": (h || m || v || b) && y4(x, a.props), "react-datepicker__month-text--selected": a.isSelectedMonth(c, s, f), "react-datepicker__month-text--keyboard-selected": !a.props.disabledKeyboardNavigation && wt(C) === s, "react-datepicker__month-text--in-selecting-range": a.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": Ko(d, p, s, c), "react-datepicker__month-text--range-start": a.isRangeStartMonth(s), "react-datepicker__month-text--range-end": a.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": a.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": a.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": a.isCurrentMonth(c, s) });
    }), k(P(a), "getTabIndex", function(s) {
      var l = wt(a.props.preSelection);
      return a.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), k(P(a), "getQuarterTabIndex", function(s) {
      var l = Ra(a.props.preSelection);
      return a.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), k(P(a), "getAriaLabel", function(s) {
      var l = a.props, c = l.chooseDayAriaLabelPrefix, d = c === void 0 ? "Choose" : c, p = l.disabledDayAriaLabelPrefix, f = p === void 0 ? "Not available" : p, h = l.day, m = kt(h, s), C = a.isDisabled(m) || a.isExcluded(m) ? f : d;
      return "".concat(C, " ").concat(Xe(m, "MMMM yyyy"));
    }), k(P(a), "getQuarterClassNames", function(s) {
      var l = a.props, c = l.day, d = l.startDate, p = l.endDate, f = l.selected, h = l.minDate, m = l.maxDate, C = l.preSelection, g = l.disabledKeyboardNavigation;
      return vt("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (h || m) && a_(Na(c, s), a.props), "react-datepicker__quarter-text--selected": a.isSelectedQuarter(c, s, f), "react-datepicker__quarter-text--keyboard-selected": !g && Ra(C) === s, "react-datepicker__quarter-text--in-selecting-range": a.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": Uo(d, p, s, c), "react-datepicker__quarter-text--range-start": a.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": a.isRangeEndQuarter(s) });
    }), k(P(a), "getMonthContent", function(s) {
      var l = a.props, c = l.showFullMonthYearPicker, d = l.renderMonthContent, p = l.locale, f = l.day, h = b4(s, p), m = Yl(s, p);
      return d ? d(s, h, m, f) : c ? m : h;
    }), k(P(a), "getQuarterContent", function(s) {
      var l = a.props, c = l.renderQuarterContent, d = function(p, f) {
        return Xe(Na(Ze(), p), "QQQ", f);
      }(s, l.locale);
      return c ? c(s, d) : d;
    }), k(P(a), "renderMonths", function() {
      var s = a.props, l = s.showTwoColumnMonthYearPicker, c = s.showFourColumnMonthYearPicker, d = s.day, p = s.selected;
      return Zo[Ju(c, l)].grid.map(function(f, h) {
        return w.createElement("div", { className: "react-datepicker__month-wrapper", key: h }, f.map(function(m, C) {
          return w.createElement("div", { ref: a.MONTH_REFS[m], key: C, onClick: function(g) {
            a.onMonthClick(g, m);
          }, onKeyDown: function(g) {
            a.onMonthKeyDown(g, m);
          }, onMouseEnter: function() {
            return a.onMonthMouseEnter(m);
          }, tabIndex: a.getTabIndex(m), className: a.getMonthClassNames(m), role: "option", "aria-label": a.getAriaLabel(m), "aria-current": a.isCurrentMonth(d, m) ? "date" : void 0, "aria-selected": a.isSelectedMonth(d, m, p) }, a.getMonthContent(m));
        }));
      });
    }), k(P(a), "renderQuarters", function() {
      var s = a.props, l = s.day, c = s.selected;
      return w.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(d, p) {
        return w.createElement("div", { key: p, ref: a.QUARTER_REFS[p], role: "option", onClick: function(f) {
          a.onQuarterClick(f, d);
        }, onKeyDown: function(f) {
          a.onQuarterKeyDown(f, d);
        }, onMouseEnter: function() {
          return a.onQuarterMouseEnter(d);
        }, className: a.getQuarterClassNames(d), "aria-selected": a.isSelectedQuarter(l, d, c), tabIndex: a.getQuarterTabIndex(d), "aria-current": a.isCurrentQuarter(l, d) ? "date" : void 0 }, a.getQuarterContent(d));
      }));
    }), k(P(a), "getClassNames", function() {
      var s = a.props, l = s.selectingDate, c = s.selectsStart, d = s.selectsEnd, p = s.showMonthYearPicker, f = s.showQuarterYearPicker, h = s.showWeekPicker;
      return vt("react-datepicker__month", { "react-datepicker__month--selecting-range": l && (c || d) }, { "react-datepicker__monthPicker": p }, { "react-datepicker__quarterPicker": f }, { "react-datepicker__weekPicker": h });
    }), a;
  }
  return ht(r, [{ key: "render", value: function() {
    var a = this.props, n = a.showMonthYearPicker, i = a.showQuarterYearPicker, o = a.day, s = a.ariaLabelPrefix, l = s === void 0 ? "month " : s;
    return w.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(l, " ").concat(Xe(o, "yyyy-MM")), role: "listbox" }, n ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), r;
}(), P4 = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    var a;
    ft(this, r);
    for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++) i[o] = arguments[o];
    return k(P(a = t.call.apply(t, [this].concat(i))), "state", { height: null }), k(P(a), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        a.list && (a.list.scrollTop = a.centerLi && r.calcCenterPosition(a.props.monthRef ? a.props.monthRef.clientHeight - a.header.clientHeight : a.list.clientHeight, a.centerLi));
      });
    }), k(P(a), "handleClick", function(s) {
      (a.props.minTime || a.props.maxTime) && Vu(s, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && Gu(s, a.props) || a.props.onChange(s);
    }), k(P(a), "isSelectedTime", function(s) {
      return a.props.selected && (l = a.props.selected, c = s, $u(l).getTime() === $u(c).getTime());
      var l, c;
    }), k(P(a), "isDisabledTime", function(s) {
      return (a.props.minTime || a.props.maxTime) && Vu(s, a.props) || (a.props.excludeTimes || a.props.includeTimes || a.props.filterTime) && Gu(s, a.props);
    }), k(P(a), "liClasses", function(s) {
      var l = ["react-datepicker__time-list-item", a.props.timeClassName ? a.props.timeClassName(s) : void 0];
      return a.isSelectedTime(s) && l.push("react-datepicker__time-list-item--selected"), a.isDisabledTime(s) && l.push("react-datepicker__time-list-item--disabled"), a.props.injectTimes && (60 * fn(s) + pn(s)) % a.props.intervals != 0 && l.push("react-datepicker__time-list-item--injected"), l.join(" ");
    }), k(P(a), "handleOnKeyDown", function(s, l) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && a.handleClick(l), a.props.handleOnKeyDown(s);
    }), k(P(a), "renderTimes", function() {
      for (var s = [], l = a.props.format ? a.props.format : "p", c = a.props.intervals, d = a.props.selected || a.props.openToDate || Ze(), p = hn(d), f = a.props.injectTimes && a.props.injectTimes.sort(function(y, x) {
        return y - x;
      }), h = 60 * function(y) {
        var x = new Date(y.getFullYear(), y.getMonth(), y.getDate()), S = new Date(y.getFullYear(), y.getMonth(), y.getDate(), 24);
        return Math.round((+S - +x) / 36e5);
      }(d), m = h / c, C = 0; C < m; C++) {
        var g = ws(p, C * c);
        if (s.push(g), f) {
          var v = i_(p, g, C, c, f);
          s = s.concat(v);
        }
      }
      var b = s.reduce(function(y, x) {
        return x.getTime() <= d.getTime() ? x : y;
      }, s[0]);
      return s.map(function(y, x) {
        return w.createElement("li", { key: x, onClick: a.handleClick.bind(P(a), y), className: a.liClasses(y), ref: function(S) {
          y === b && (a.centerLi = S);
        }, onKeyDown: function(S) {
          a.handleOnKeyDown(S, y);
        }, tabIndex: y === b ? 0 : -1, role: "option", "aria-selected": a.isSelectedTime(y) ? "true" : void 0, "aria-disabled": a.isDisabledTime(y) ? "true" : void 0 }, Xe(y, l, a.props.locale));
      });
    }), a;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var a = this, n = this.state.height;
    return w.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, w.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      a.header = i;
    } }, w.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), w.createElement("div", { className: "react-datepicker__time" }, w.createElement("div", { className: "react-datepicker__time-box" }, w.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      a.list = i;
    }, style: n ? { height: n } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), r;
}();
k(P4, "calcCenterPosition", function(e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var v_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "YEAR_REFS", ni(Array(n.props.yearItemNumber)).map(function() {
      return w.createRef();
    })), k(P(n), "isDisabled", function(i) {
      return po(i, n.props);
    }), k(P(n), "isExcluded", function(i) {
      return Wl(i, n.props);
    }), k(P(n), "selectingDate", function() {
      var i;
      return (i = n.props.selectingDate) !== null && i !== void 0 ? i : n.props.preSelection;
    }), k(P(n), "updateFocusOnPaginate", function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(P(n));
      window.requestAnimationFrame(o);
    }), k(P(n), "handleYearClick", function(i, o) {
      n.props.onDayClick && n.props.onDayClick(i, o);
    }), k(P(n), "handleYearNavigation", function(i, o) {
      var s = n.props, l = s.date, c = s.yearItemNumber, d = Oa(l, c).startPeriod;
      n.isDisabled(o) || n.isExcluded(o) || (n.props.setPreSelection(o), i - d == -1 ? n.updateFocusOnPaginate(c - 1) : i - d === c ? n.updateFocusOnPaginate(0) : n.YEAR_REFS[i - d].current.focus());
    }), k(P(n), "isSameDay", function(i, o) {
      return Ye(i, o);
    }), k(P(n), "isCurrentYear", function(i) {
      return i === Te(Ze());
    }), k(P(n), "isRangeStart", function(i) {
      return n.props.startDate && n.props.endDate && Gn(Mn(Ze(), i), n.props.startDate);
    }), k(P(n), "isRangeEnd", function(i) {
      return n.props.startDate && n.props.endDate && Gn(Mn(Ze(), i), n.props.endDate);
    }), k(P(n), "isInRange", function(i) {
      return zo(i, n.props.startDate, n.props.endDate);
    }), k(P(n), "isInSelectingRange", function(i) {
      var o = n.props, s = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, d = o.startDate, p = o.endDate;
      return !(!(s || l || c) || !n.selectingDate()) && (s && p ? zo(i, n.selectingDate(), p) : (l && d || !(!c || !d || p)) && zo(i, d, n.selectingDate()));
    }), k(P(n), "isSelectingRangeStart", function(i) {
      if (!n.isInSelectingRange(i)) return !1;
      var o = n.props, s = o.startDate, l = o.selectsStart, c = Mn(Ze(), i);
      return Gn(c, l ? n.selectingDate() : s);
    }), k(P(n), "isSelectingRangeEnd", function(i) {
      if (!n.isInSelectingRange(i)) return !1;
      var o = n.props, s = o.endDate, l = o.selectsEnd, c = o.selectsRange, d = Mn(Ze(), i);
      return Gn(d, l || c ? n.selectingDate() : s);
    }), k(P(n), "isKeyboardSelected", function(i) {
      var o = Dr(Mn(n.props.date, i));
      return !n.props.disabledKeyboardNavigation && !n.props.inline && !Ye(o, Dr(n.props.selected)) && Ye(o, Dr(n.props.preSelection));
    }), k(P(n), "onYearClick", function(i, o) {
      var s = n.props.date;
      n.handleYearClick(Dr(Mn(s, o)), i);
    }), k(P(n), "onYearKeyDown", function(i, o) {
      var s = i.key;
      if (!n.props.disabledKeyboardNavigation) switch (s) {
        case "Enter":
          n.onYearClick(i, o), n.props.setPreSelection(n.props.selected);
          break;
        case "ArrowRight":
          n.handleYearNavigation(o + 1, Za(n.props.preSelection, 1));
          break;
        case "ArrowLeft":
          n.handleYearNavigation(o - 1, Qr(n.props.preSelection, 1));
      }
    }), k(P(n), "getYearClassNames", function(i) {
      var o = n.props, s = o.minDate, l = o.maxDate, c = o.selected, d = o.excludeDates, p = o.includeDates, f = o.filterDate;
      return vt("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === Te(c), "react-datepicker__year-text--disabled": (s || l || d || p || f) && w4(i, n.props), "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(i), "react-datepicker__year-text--range-start": n.isRangeStart(i), "react-datepicker__year-text--range-end": n.isRangeEnd(i), "react-datepicker__year-text--in-range": n.isInRange(i), "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(i), "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(i), "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(i), "react-datepicker__year-text--today": n.isCurrentYear(i) });
    }), k(P(n), "getYearTabIndex", function(i) {
      return n.props.disabledKeyboardNavigation ? "-1" : i === Te(n.props.preSelection) ? "0" : "-1";
    }), k(P(n), "getYearContainerClassNames", function() {
      var i = n.props, o = i.selectingDate, s = i.selectsStart, l = i.selectsEnd, c = i.selectsRange;
      return vt("react-datepicker__year", { "react-datepicker__year--selecting-range": o && (s || l || c) });
    }), k(P(n), "getYearContent", function(i) {
      return n.props.renderYearContent ? n.props.renderYearContent(i) : i;
    }), n;
  }
  return ht(r, [{ key: "render", value: function() {
    for (var a = this, n = [], i = this.props, o = i.date, s = i.yearItemNumber, l = i.onYearMouseEnter, c = i.onYearMouseLeave, d = Oa(o, s), p = d.startPeriod, f = d.endPeriod, h = function(C) {
      n.push(w.createElement("div", { ref: a.YEAR_REFS[C - p], onClick: function(g) {
        a.onYearClick(g, C);
      }, onKeyDown: function(g) {
        a.onYearKeyDown(g, C);
      }, tabIndex: a.getYearTabIndex(C), className: a.getYearClassNames(C), onMouseEnter: function(g) {
        return l(g, C);
      }, onMouseLeave: function(g) {
        return c(g, C);
      }, key: C, "aria-current": a.isCurrentYear(C) ? "date" : void 0 }, a.getYearContent(C)));
    }, m = p; m <= f; m++) h(m);
    return w.createElement("div", { className: this.getYearContainerClassNames() }, w.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, n));
  } }]), r;
}(), b_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "onTimeChange", function(i) {
      n.setState({ time: i });
      var o = n.props.date, s = o instanceof Date && !isNaN(o) ? o : /* @__PURE__ */ new Date();
      s.setHours(i.split(":")[0]), s.setMinutes(i.split(":")[1]), n.props.onChange(s);
    }), k(P(n), "renderTimeInput", function() {
      var i = n.state.time, o = n.props, s = o.date, l = o.timeString, c = o.customTimeInput;
      return c ? w.cloneElement(c, { date: s, value: i, onChange: n.onTimeChange }) : w.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(d) {
        n.onTimeChange(d.target.value || l);
      } });
    }), n.state = { time: n.props.timeString }, n;
  }
  return ht(r, [{ key: "render", value: function() {
    return w.createElement("div", { className: "react-datepicker__input-time-container" }, w.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), w.createElement("div", { className: "react-datepicker-time__input-container" }, w.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(a, n) {
    return a.timeString !== n.time ? { time: a.timeString } : null;
  } }]), r;
}();
function y_(e) {
  var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, i = n === void 0 ? {} : n;
  return w.createElement("div", { className: t }, a && w.createElement("div", qa({ className: "react-datepicker__triangle" }, i)), r);
}
var w_ = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], S_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "handleClickOutside", function(i) {
      n.props.onClickOutside(i);
    }), k(P(n), "setClickOutsideRef", function() {
      return n.containerRef.current;
    }), k(P(n), "handleDropdownFocus", function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return w_.some(function(s) {
          return o.indexOf(s) >= 0;
        });
      })(i.target) && n.props.onDropdownFocus();
    }), k(P(n), "getDateInView", function() {
      var i = n.props, o = i.preSelection, s = i.selected, l = i.openToDate, c = S4(n.props), d = _4(n.props), p = Ze(), f = l || s || o;
      return f || (c && Fn(p, c) ? c : d && Yn(p, d) ? d : p);
    }), k(P(n), "increaseMonth", function() {
      n.setState(function(i) {
        var o = i.date;
        return { date: qt(o, 1) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), k(P(n), "decreaseMonth", function() {
      n.setState(function(i) {
        var o = i.date;
        return { date: Ya(o, 1) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), k(P(n), "handleDayClick", function(i, o, s) {
      n.props.onSelect(i, o, s), n.props.setPreSelection && n.props.setPreSelection(i);
    }), k(P(n), "handleDayMouseEnter", function(i) {
      n.setState({ selectingDate: i }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(i);
    }), k(P(n), "handleMonthMouseLeave", function() {
      n.setState({ selectingDate: null }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
    }), k(P(n), "handleYearMouseEnter", function(i, o) {
      n.setState({ selectingDate: Mn(Ze(), o) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(i, o);
    }), k(P(n), "handleYearMouseLeave", function(i, o) {
      n.props.onYearMouseLeave && n.props.onYearMouseLeave(i, o);
    }), k(P(n), "handleYearChange", function(i) {
      n.props.onYearChange && (n.props.onYearChange(i), n.setState({ isRenderAriaLiveMessage: !0 })), n.props.adjustDateOnChange && (n.props.onSelect && n.props.onSelect(i), n.props.setOpen && n.props.setOpen(!0)), n.props.setPreSelection && n.props.setPreSelection(i);
    }), k(P(n), "handleMonthChange", function(i) {
      n.handleCustomMonthChange(i), n.props.adjustDateOnChange && (n.props.onSelect && n.props.onSelect(i), n.props.setOpen && n.props.setOpen(!0)), n.props.setPreSelection && n.props.setPreSelection(i);
    }), k(P(n), "handleCustomMonthChange", function(i) {
      n.props.onMonthChange && (n.props.onMonthChange(i), n.setState({ isRenderAriaLiveMessage: !0 }));
    }), k(P(n), "handleMonthYearChange", function(i) {
      n.handleYearChange(i), n.handleMonthChange(i);
    }), k(P(n), "changeYear", function(i) {
      n.setState(function(o) {
        var s = o.date;
        return { date: Mn(s, i) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), k(P(n), "changeMonth", function(i) {
      n.setState(function(o) {
        var s = o.date;
        return { date: kt(s, i) };
      }, function() {
        return n.handleMonthChange(n.state.date);
      });
    }), k(P(n), "changeMonthYear", function(i) {
      n.setState(function(o) {
        var s = o.date;
        return { date: Mn(kt(s, wt(i)), Te(i)) };
      }, function() {
        return n.handleMonthYearChange(n.state.date);
      });
    }), k(P(n), "header", function() {
      var i = gn(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.state.date, n.props.locale, n.props.calendarStartDay), o = [];
      return n.props.showWeekNumbers && o.push(w.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
        var l = pr(i, s), c = n.formatWeekday(l, n.props.locale), d = n.props.weekDayClassName ? n.props.weekDayClassName(l) : void 0;
        return w.createElement("div", { key: s, className: vt("react-datepicker__day-name", d) }, c);
      }));
    }), k(P(n), "formatWeekday", function(i, o) {
      return n.props.formatWeekDay ? function(s, l, c) {
        return l(Xe(s, "EEEE", c));
      }(i, n.props.formatWeekDay, o) : n.props.useWeekdaysShort ? function(s, l) {
        return Xe(s, "EEE", l);
      }(i, o) : function(s, l) {
        return Xe(s, "EEEEEE", l);
      }(i, o);
    }), k(P(n), "decreaseYear", function() {
      n.setState(function(i) {
        var o = i.date;
        return { date: Qr(o, n.props.showYearPicker ? n.props.yearItemNumber : 1) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), k(P(n), "clearSelectingDate", function() {
      n.setState({ selectingDate: null });
    }), k(P(n), "renderPreviousButton", function() {
      if (!n.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case n.props.showMonthYearPicker:
            i = Uu(n.state.date, n.props);
            break;
          case n.props.showYearPicker:
            i = function(v) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = b.minDate, x = b.yearItemNumber, S = x === void 0 ? jr : x, _ = Oa(Dr(Qr(v, S)), S).endPeriod, M = y && Te(y);
              return M && M > _ || !1;
            }(n.state.date, n.props);
            break;
          default:
            i = Ku(n.state.date, n.props);
        }
        if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !i) && !n.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = n.decreaseMonth;
          (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (s = n.decreaseYear), i && n.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), s = null);
          var l = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.previousMonthButtonLabel, p = c.previousYearButtonLabel, f = n.props, h = f.previousMonthAriaLabel, m = h === void 0 ? typeof d == "string" ? d : "Previous Month" : h, C = f.previousYearAriaLabel, g = C === void 0 ? typeof p == "string" ? p : "Previous Year" : C;
          return w.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: n.props.handleOnKeyDown, "aria-label": l ? g : m }, w.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, l ? n.props.previousYearButtonLabel : n.props.previousMonthButtonLabel));
        }
      }
    }), k(P(n), "increaseYear", function() {
      n.setState(function(i) {
        var o = i.date;
        return { date: Za(o, n.props.showYearPicker ? n.props.yearItemNumber : 1) };
      }, function() {
        return n.handleYearChange(n.state.date);
      });
    }), k(P(n), "renderNextButton", function() {
      if (!n.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case n.props.showMonthYearPicker:
            i = Zu(n.state.date, n.props);
            break;
          case n.props.showYearPicker:
            i = function(v) {
              var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = b.maxDate, x = b.yearItemNumber, S = x === void 0 ? jr : x, _ = Oa(Za(v, S), S).startPeriod, M = y && Te(y);
              return M && M < _ || !1;
            }(n.state.date, n.props);
            break;
          default:
            i = zu(n.state.date, n.props);
        }
        if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !i) && !n.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          n.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var s = n.increaseMonth;
          (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (s = n.increaseYear), i && n.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), s = null);
          var l = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.nextMonthButtonLabel, p = c.nextYearButtonLabel, f = n.props, h = f.nextMonthAriaLabel, m = h === void 0 ? typeof d == "string" ? d : "Next Month" : h, C = f.nextYearAriaLabel, g = C === void 0 ? typeof p == "string" ? p : "Next Year" : C;
          return w.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: n.props.handleOnKeyDown, "aria-label": l ? g : m }, w.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, l ? n.props.nextYearButtonLabel : n.props.nextMonthButtonLabel));
        }
      }
    }), k(P(n), "renderCurrentMonth", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.state.date, o = ["react-datepicker__current-month"];
      return n.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), w.createElement("div", { className: o.join(" ") }, Xe(i, n.props.dateFormat, n.props.locale));
    }), k(P(n), "renderYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showYearDropdown && !i) return w.createElement(l_, { adjustDateOnChange: n.props.adjustDateOnChange, date: n.state.date, onSelect: n.props.onSelect, setOpen: n.props.setOpen, dropdownMode: n.props.dropdownMode, onChange: n.changeYear, minDate: n.props.minDate, maxDate: n.props.maxDate, year: Te(n.state.date), scrollableYearDropdown: n.props.scrollableYearDropdown, yearDropdownItemNumber: n.props.yearDropdownItemNumber });
    }), k(P(n), "renderMonthDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showMonthDropdown && !i) return w.createElement(c_, { dropdownMode: n.props.dropdownMode, locale: n.props.locale, onChange: n.changeMonth, month: wt(n.state.date), useShortMonthInDropdown: n.props.useShortMonthInDropdown });
    }), k(P(n), "renderMonthYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (n.props.showMonthYearDropdown && !i) return w.createElement(f_, { dropdownMode: n.props.dropdownMode, locale: n.props.locale, dateFormat: n.props.dateFormat, onChange: n.changeMonthYear, minDate: n.props.minDate, maxDate: n.props.maxDate, date: n.state.date, scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown });
    }), k(P(n), "handleTodayButtonClick", function(i) {
      n.props.onSelect(Hu(), i), n.props.setPreSelection && n.props.setPreSelection(Hu());
    }), k(P(n), "renderTodayButton", function() {
      if (n.props.todayButton && !n.props.showTimeSelectOnly) return w.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
        return n.handleTodayButtonClick(i);
      } }, n.props.todayButton);
    }), k(P(n), "renderDefaultHeader", function(i) {
      var o = i.monthDate, s = i.i;
      return w.createElement("div", { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, n.renderCurrentMonth(o), w.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus }, n.renderMonthDropdown(s !== 0), n.renderMonthYearDropdown(s !== 0), n.renderYearDropdown(s !== 0)), w.createElement("div", { className: "react-datepicker__day-names" }, n.header(o)));
    }), k(P(n), "renderCustomHeader", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, s = i.i;
      if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly) return null;
      var l = Ku(n.state.date, n.props), c = zu(n.state.date, n.props), d = Uu(n.state.date, n.props), p = Zu(n.state.date, n.props), f = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
      return w.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus }, n.props.renderCustomHeader(v1(v1({}, n.state), {}, { customHeaderCount: s, monthDate: o, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: c, prevYearButtonDisabled: d, nextYearButtonDisabled: p })), f && w.createElement("div", { className: "react-datepicker__day-names" }, n.header(o)));
    }), k(P(n), "renderYearHeader", function() {
      var i = n.state.date, o = n.props, s = o.showYearPicker, l = Oa(i, o.yearItemNumber), c = l.startPeriod, d = l.endPeriod;
      return w.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(c, " - ").concat(d) : Te(i));
    }), k(P(n), "renderHeader", function(i) {
      switch (!0) {
        case n.props.renderCustomHeader !== void 0:
          return n.renderCustomHeader(i);
        case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
          return n.renderYearHeader(i);
        default:
          return n.renderDefaultHeader(i);
      }
    }), k(P(n), "renderMonths", function() {
      var i;
      if (!n.props.showTimeSelectOnly && !n.props.showYearPicker) {
        for (var o = [], s = n.props.showPreviousMonths ? n.props.monthsShown - 1 : 0, l = Ya(n.state.date, s), c = (i = n.props.monthSelectedIn) !== null && i !== void 0 ? i : s, d = 0; d < n.props.monthsShown; ++d) {
          var p = qt(l, d - c + s), f = "month-".concat(d), h = d < n.props.monthsShown - 1, m = d > 0;
          o.push(w.createElement("div", { key: f, ref: function(C) {
            n.monthContainer = C;
          }, className: "react-datepicker__month-container" }, n.renderHeader({ monthDate: p, i: d }), w.createElement(C_, { chooseDayAriaLabelPrefix: n.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: n.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: n.props.weekAriaLabelPrefix, ariaLabelPrefix: n.props.monthAriaLabelPrefix, onChange: n.changeMonthYear, day: p, dayClassName: n.props.dayClassName, calendarStartDay: n.props.calendarStartDay, monthClassName: n.props.monthClassName, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, onWeekSelect: n.props.onWeekSelect, orderInDisplay: d, formatWeekNumber: n.props.formatWeekNumber, locale: n.props.locale, minDate: n.props.minDate, maxDate: n.props.maxDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, highlightDates: n.props.highlightDates, holidays: n.props.holidays, selectingDate: n.state.selectingDate, includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, inline: n.props.inline, shouldFocusDayInline: n.props.shouldFocusDayInline, fixedHeight: n.props.fixedHeight, filterDate: n.props.filterDate, preSelection: n.props.preSelection, setPreSelection: n.props.setPreSelection, selected: n.props.selected, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, showWeekNumbers: n.props.showWeekNumbers, startDate: n.props.startDate, endDate: n.props.endDate, peekNextMonth: n.props.peekNextMonth, setOpen: n.props.setOpen, shouldCloseOnSelect: n.props.shouldCloseOnSelect, renderDayContents: n.props.renderDayContents, renderMonthContent: n.props.renderMonthContent, renderQuarterContent: n.props.renderQuarterContent, renderYearContent: n.props.renderYearContent, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, showMonthYearPicker: n.props.showMonthYearPicker, showFullMonthYearPicker: n.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: n.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: n.props.showFourColumnMonthYearPicker, showYearPicker: n.props.showYearPicker, showQuarterYearPicker: n.props.showQuarterYearPicker, showWeekPicker: n.props.showWeekPicker, isInputFocused: n.props.isInputFocused, containerRef: n.containerRef, monthShowsDuplicateDaysEnd: h, monthShowsDuplicateDaysStart: m })));
        }
        return o;
      }
    }), k(P(n), "renderYears", function() {
      if (!n.props.showTimeSelectOnly) return n.props.showYearPicker ? w.createElement("div", { className: "react-datepicker__year--container" }, n.renderHeader(), w.createElement(v_, qa({ onDayClick: n.handleDayClick, selectingDate: n.state.selectingDate, clearSelectingDate: n.clearSelectingDate, date: n.state.date }, n.props, { onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))) : void 0;
    }), k(P(n), "renderTimeSection", function() {
      if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly)) return w.createElement(P4, { selected: n.props.selected, openToDate: n.props.openToDate, onChange: n.props.onTimeChange, timeClassName: n.props.timeClassName, format: n.props.timeFormat, includeTimes: n.props.includeTimes, intervals: n.props.timeIntervals, minTime: n.props.minTime, maxTime: n.props.maxTime, excludeTimes: n.props.excludeTimes, filterTime: n.props.filterTime, timeCaption: n.props.timeCaption, todayButton: n.props.todayButton, showMonthDropdown: n.props.showMonthDropdown, showMonthYearDropdown: n.props.showMonthYearDropdown, showYearDropdown: n.props.showYearDropdown, withPortal: n.props.withPortal, monthRef: n.state.monthContainer, injectTimes: n.props.injectTimes, locale: n.props.locale, handleOnKeyDown: n.props.handleOnKeyDown, showTimeSelectOnly: n.props.showTimeSelectOnly });
    }), k(P(n), "renderInputTimeSection", function() {
      var i = new Date(n.props.selected), o = Bn(i) && n.props.selected ? "".concat(Wu(i.getHours()), ":").concat(Wu(i.getMinutes())) : "";
      if (n.props.showTimeInput) return w.createElement(b_, { date: i, timeString: o, timeInputLabel: n.props.timeInputLabel, onChange: n.props.onTimeChange, customTimeInput: n.props.customTimeInput });
    }), k(P(n), "renderAriaLiveRegion", function() {
      var i, o = Oa(n.state.date, n.props.yearItemNumber), s = o.startPeriod, l = o.endPeriod;
      return i = n.props.showYearPicker ? "".concat(s, " - ").concat(l) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? Te(n.state.date) : "".concat(Yl(wt(n.state.date), n.props.locale), " ").concat(Te(n.state.date)), w.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && i);
    }), k(P(n), "renderChildren", function() {
      if (n.props.children) return w.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
    }), n.containerRef = w.createRef(), n.state = { date: n.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, n;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    var a = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void a.setState({ monthContainer: a.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(a) {
    var n = this;
    if (!this.props.preSelection || Ye(this.props.preSelection, a.preSelection) && this.props.monthSelectedIn === a.monthSelectedIn) this.props.openToDate && !Ye(this.props.openToDate, a.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var i = !Yt(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return i && n.handleCustomMonthChange(n.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var a = this.props.container || y_;
    return w.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, w.createElement(a, { className: vt("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: jr };
  } }]), r;
}(), __ = function(e) {
  var t = e.icon, r = e.className, a = r === void 0 ? "" : r, n = e.onClick, i = "react-datepicker__calendar-icon";
  return w.isValidElement(t) ? w.cloneElement(t, { className: "".concat(t.props.className || "", " ").concat(i, " ").concat(a), onClick: function(o) {
    typeof t.props.onClick == "function" && t.props.onClick(o), typeof n == "function" && n(o);
  } }) : typeof t == "string" ? w.createElement("i", { className: "".concat(i, " ").concat(t, " ").concat(a), "aria-hidden": "true", onClick: n }) : w.createElement("svg", { className: "".concat(i, " ").concat(a), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: n }, w.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, T4 = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), (n = t.call(this, a)).el = document.createElement("div"), n;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return td.createPortal(this.props.children, this.el);
  } }]), r;
}(), x_ = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, E4 = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "getTabChildren", function() {
      return Array.prototype.slice.call(n.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(x_);
    }), k(P(n), "handleFocusStart", function() {
      var i = n.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    }), k(P(n), "handleFocusEnd", function() {
      var i = n.getTabChildren();
      i && i.length > 1 && i[0].focus();
    }), n.tabLoopRef = w.createRef(), n;
  }
  return ht(r, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? w.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, w.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, w.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), r;
}(), M_ = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r() {
    return ft(this, r), t.apply(this, arguments);
  }
  return ht(r, [{ key: "render", value: function() {
    var a, n = this.props, i = n.className, o = n.wrapperClassName, s = n.hidePopper, l = n.popperComponent, c = n.popperModifiers, d = n.popperPlacement, p = n.popperProps, f = n.targetComponent, h = n.enableTabLoop, m = n.popperOnKeyDown, C = n.portalId, g = n.portalHost;
    if (!s) {
      var v = vt("react-datepicker-popper", i);
      a = w.createElement(WS, qa({ modifiers: c, placement: d }, p), function(y) {
        var x = y.ref, S = y.style, _ = y.placement, M = y.arrowProps;
        return w.createElement(E4, { enableTabLoop: h }, w.createElement("div", { ref: x, style: S, className: v, "data-placement": _, onKeyDown: m }, w.cloneElement(l, { arrowProps: M })));
      });
    }
    this.props.popperContainer && (a = w.createElement(this.props.popperContainer, {}, a)), C && !s && (a = w.createElement(T4, { portalId: C, portalHost: g }, a));
    var b = vt("react-datepicker-wrapper", o);
    return w.createElement(Dw, { className: "react-datepicker-manager" }, w.createElement(XS, null, function(y) {
      var x = y.ref;
      return w.createElement("div", { ref: x, className: b }, f);
    }), a);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), r;
}(), Qu = "react-datepicker-ignore-onclickoutside", k_ = uo(S_), Yo = "Date input not valid.", ho = function(e) {
  mt(r, w.Component);
  var t = gt(r);
  function r(a) {
    var n;
    return ft(this, r), k(P(n = t.call(this, a)), "getPreSelection", function() {
      return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : Ze();
    }), k(P(n), "modifyHolidays", function() {
      var i;
      return (i = n.props.holidays) === null || i === void 0 ? void 0 : i.reduce(function(o, s) {
        var l = new Date(s.date);
        return Jr(l) ? [].concat(ni(o), [v1(v1({}, s), {}, { date: l })]) : o;
      }, []);
    }), k(P(n), "calcInitialState", function() {
      var i, o = n.getPreSelection(), s = S4(n.props), l = _4(n.props), c = s && Fn(o, hn(s)) ? s : l && Yn(o, xs(l)) ? l : o;
      return { open: n.props.startOpen || !1, preventFocus: !1, preSelection: (i = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && i !== void 0 ? i : c, highlightDates: Yu(n.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), k(P(n), "clearPreventFocusTimeout", function() {
      n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
    }), k(P(n), "setFocus", function() {
      n.input && n.input.focus && n.input.focus({ preventScroll: !0 });
    }), k(P(n), "setBlur", function() {
      n.input && n.input.blur && n.input.blur(), n.cancelFocusInput();
    }), k(P(n), "setOpen", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      n.setState({ open: i, preSelection: i && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection, lastPreSelectChange: Wo }, function() {
        i || n.setState(function(s) {
          return { focused: !!o && s.focused };
        }, function() {
          !o && n.setBlur(), n.setState({ inputValue: null });
        });
      });
    }), k(P(n), "inputOk", function() {
      return lo(n.state.preSelection);
    }), k(P(n), "isCalendarOpen", function() {
      return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
    }), k(P(n), "handleFocus", function(i) {
      n.state.preventFocus || (n.props.onFocus(i), n.props.preventOpenOnFocus || n.props.readOnly || n.setOpen(!0)), n.setState({ focused: !0 });
    }), k(P(n), "sendFocusBackToInput", function() {
      n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
        n.preventFocusTimeout = setTimeout(function() {
          n.setFocus(), n.setState({ preventFocus: !1 });
        });
      });
    }), k(P(n), "cancelFocusInput", function() {
      clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = null;
    }), k(P(n), "deferFocusInput", function() {
      n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
        return n.setFocus();
      }, 1);
    }), k(P(n), "handleDropdownFocus", function() {
      n.cancelFocusInput();
    }), k(P(n), "handleBlur", function(i) {
      (!n.state.open || n.props.withPortal || n.props.showTimeInput) && n.props.onBlur(i), n.setState({ focused: !1 });
    }), k(P(n), "handleCalendarClickOutside", function(i) {
      n.props.inline || n.setOpen(!1), n.props.onClickOutside(i), n.props.withPortal && i.preventDefault();
    }), k(P(n), "handleChange", function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) o[s] = arguments[s];
      var l = o[0];
      if (!n.props.onChangeRaw || (n.props.onChangeRaw.apply(P(n), o), typeof l.isDefaultPrevented == "function" && !l.isDefaultPrevented())) {
        n.setState({ inputValue: l.target.value, lastPreSelectChange: P_ });
        var c, d, p, f, h, m, C, g, v = (c = l.target.value, d = n.props.dateFormat, p = n.props.locale, f = n.props.strictParsing, h = n.props.minDate, m = null, C = la(p) || la(sa()), g = !0, Array.isArray(d) ? (d.forEach(function(b) {
          var y = Ho(c, b, /* @__PURE__ */ new Date(), { locale: C });
          f && (g = Bn(y, h) && c === Xe(y, b, p)), Bn(y, h) && g && (m = y);
        }), m) : (m = Ho(c, d, /* @__PURE__ */ new Date(), { locale: C }), f ? g = Bn(m) && c === Xe(m, d, p) : Bn(m) || (d = d.match(n_).map(function(b) {
          var y = b[0];
          return y === "p" || y === "P" ? C ? (0, t_[y])(b, C.formatLong) : y : b;
        }).join(""), c.length > 0 && (m = Ho(c, d.slice(0, c.length), /* @__PURE__ */ new Date())), Bn(m) || (m = new Date(c))), Bn(m) && g ? m : null));
        n.props.showTimeSelectOnly && n.props.selected && v && !Ye(v, n.props.selected) && (v = e_(n.props.selected, { hours: fn(v), minutes: pn(v), seconds: hu(v) })), !v && l.target.value || (n.props.showWeekPicker && (v = gn(v, n.props.locale, n.props.calendarStartDay)), n.setSelected(v, l, !0));
      }
    }), k(P(n), "handleSelect", function(i, o, s) {
      if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(o), n.props.showWeekPicker && (i = gn(i, n.props.locale, n.props.calendarStartDay)), n.setSelected(i, o, !1, s), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect) n.setPreSelection(i);
      else if (!n.props.inline) {
        n.props.selectsRange || n.setOpen(!1);
        var l = n.props, c = l.startDate, d = l.endDate;
        !c || d || Fn(i, c) || n.setOpen(!1);
      }
    }), k(P(n), "setSelected", function(i, o, s, l) {
      var c = i;
      if (n.props.showYearPicker) {
        if (c !== null && w4(Te(c), n.props)) return;
      } else if (n.props.showMonthYearPicker) {
        if (c !== null && y4(c, n.props)) return;
      } else if (c !== null && po(c, n.props)) return;
      var d = n.props, p = d.onChange, f = d.selectsRange, h = d.startDate, m = d.endDate;
      if (!aa(n.props.selected, c) || n.props.allowSameDay || f) if (c !== null && (!n.props.selected || s && (n.props.showTimeSelect || n.props.showTimeSelectOnly || n.props.showTimeInput) || (c = Bu(c, { hour: fn(n.props.selected), minute: pn(n.props.selected), second: hu(n.props.selected) })), n.props.inline || n.setState({ preSelection: c }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: l })), f) {
        var C = h && !m, g = h && m;
        !h && !m ? p([c, null], o) : C && (Fn(c, h) ? p([c, null], o) : p([h, c], o)), g && p([c, null], o);
      } else p(c, o);
      s || (n.props.onSelect(c, o), n.setState({ inputValue: null }));
    }), k(P(n), "setPreSelection", function(i) {
      var o = n.props.minDate !== void 0, s = n.props.maxDate !== void 0, l = !0;
      if (i) {
        n.props.showWeekPicker && (i = gn(i, n.props.locale, n.props.calendarStartDay));
        var c = hn(i);
        if (o && s) l = Yi(i, n.props.minDate, n.props.maxDate);
        else if (o) {
          var d = hn(n.props.minDate);
          l = Yn(i, d) || aa(c, d);
        } else if (s) {
          var p = xs(n.props.maxDate);
          l = Fn(i, p) || aa(c, p);
        }
      }
      l && n.setState({ preSelection: i });
    }), k(P(n), "toggleCalendar", function() {
      n.setOpen(!n.state.open);
    }), k(P(n), "handleTimeChange", function(i) {
      var o = n.props.selected ? n.props.selected : n.getPreSelection(), s = n.props.selected ? i : Bu(o, { hour: fn(i), minute: pn(i) });
      n.setState({ preSelection: s }), n.props.onChange(s), n.props.shouldCloseOnSelect && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
    }), k(P(n), "onInputClick", function() {
      n.props.disabled || n.props.readOnly || n.setOpen(!0), n.props.onInputClick();
    }), k(P(n), "onInputKeyDown", function(i) {
      n.props.onKeyDown(i);
      var o = i.key;
      if (n.state.open || n.props.inline || n.props.preventOpenOnFocus) {
        if (n.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var s = n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', l = n.calendar.componentNode && n.calendar.componentNode.querySelector(s);
            return void (l && l.focus({ preventScroll: !0 }));
          }
          var c = Ze(n.state.preSelection);
          o === "Enter" ? (i.preventDefault(), n.inputOk() && n.state.lastPreSelectChange === Wo ? (n.handleSelect(c, i), !n.props.shouldCloseOnSelect && n.setPreSelection(c)) : n.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), n.sendFocusBackToInput(), n.setOpen(!1)) : o === "Tab" && n.setOpen(!1), n.inputOk() || n.props.onInputError({ code: 1, msg: Yo });
        }
      } else o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || n.onInputClick();
    }), k(P(n), "onPortalKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), n.setState({ preventFocus: !0 }, function() {
        n.setOpen(!1), setTimeout(function() {
          n.setFocus(), n.setState({ preventFocus: !1 });
        });
      }));
    }), k(P(n), "onDayKeyDown", function(i) {
      n.props.onKeyDown(i);
      var o = i.key, s = Ze(n.state.preSelection);
      if (o === "Enter") i.preventDefault(), n.handleSelect(s, i), !n.props.shouldCloseOnSelect && n.setPreSelection(s);
      else if (o === "Escape") i.preventDefault(), n.setOpen(!1), n.inputOk() || n.props.onInputError({ code: 1, msg: Yo });
      else if (!n.props.disabledKeyboardNavigation) {
        var l;
        switch (o) {
          case "ArrowLeft":
            l = n.props.showWeekPicker ? fu(s, 1) : Vb(s, 1);
            break;
          case "ArrowRight":
            l = n.props.showWeekPicker ? d1(s, 1) : pr(s, 1);
            break;
          case "ArrowUp":
            l = fu(s, 1);
            break;
          case "ArrowDown":
            l = d1(s, 1);
            break;
          case "PageUp":
            l = Ya(s, 1);
            break;
          case "PageDown":
            l = qt(s, 1);
            break;
          case "Home":
            l = Qr(s, 1);
            break;
          case "End":
            l = Za(s, 1);
            break;
          default:
            l = null;
        }
        if (!l) return void (n.props.onInputError && n.props.onInputError({ code: 1, msg: Yo }));
        if (i.preventDefault(), n.setState({ lastPreSelectChange: Wo }), n.props.adjustDateOnChange && n.setSelected(l), n.setPreSelection(l), n.props.inline) {
          var c = wt(s), d = wt(l), p = Te(s), f = Te(l);
          c !== d || p !== f ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), k(P(n), "onPopperKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), n.sendFocusBackToInput());
    }), k(P(n), "onClearClick", function(i) {
      i && i.preventDefault && i.preventDefault(), n.sendFocusBackToInput(), n.props.selectsRange ? n.props.onChange([null, null], i) : n.props.onChange(null, i), n.setState({ inputValue: null });
    }), k(P(n), "clear", function() {
      n.onClearClick();
    }), k(P(n), "onScroll", function(i) {
      typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(i) && n.setOpen(!1);
    }), k(P(n), "renderCalendar", function() {
      return n.props.inline || n.isCalendarOpen() ? w.createElement(k_, { ref: function(i) {
        n.calendar = i;
      }, locale: n.props.locale, calendarStartDay: n.props.calendarStartDay, chooseDayAriaLabelPrefix: n.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: n.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: n.props.weekAriaLabelPrefix, monthAriaLabelPrefix: n.props.monthAriaLabelPrefix, adjustDateOnChange: n.props.adjustDateOnChange, setOpen: n.setOpen, shouldCloseOnSelect: n.props.shouldCloseOnSelect, dateFormat: n.props.dateFormatCalendar, useWeekdaysShort: n.props.useWeekdaysShort, formatWeekDay: n.props.formatWeekDay, dropdownMode: n.props.dropdownMode, selected: n.props.selected, preSelection: n.state.preSelection, onSelect: n.handleSelect, onWeekSelect: n.props.onWeekSelect, openToDate: n.props.openToDate, minDate: n.props.minDate, maxDate: n.props.maxDate, selectsStart: n.props.selectsStart, selectsEnd: n.props.selectsEnd, selectsRange: n.props.selectsRange, startDate: n.props.startDate, endDate: n.props.endDate, excludeDates: n.props.excludeDates, excludeDateIntervals: n.props.excludeDateIntervals, filterDate: n.props.filterDate, onClickOutside: n.handleCalendarClickOutside, formatWeekNumber: n.props.formatWeekNumber, highlightDates: n.state.highlightDates, holidays: r_(n.modifyHolidays()), includeDates: n.props.includeDates, includeDateIntervals: n.props.includeDateIntervals, includeTimes: n.props.includeTimes, injectTimes: n.props.injectTimes, inline: n.props.inline, shouldFocusDayInline: n.state.shouldFocusDayInline, peekNextMonth: n.props.peekNextMonth, showMonthDropdown: n.props.showMonthDropdown, showPreviousMonths: n.props.showPreviousMonths, useShortMonthInDropdown: n.props.useShortMonthInDropdown, showMonthYearDropdown: n.props.showMonthYearDropdown, showWeekNumbers: n.props.showWeekNumbers, showYearDropdown: n.props.showYearDropdown, withPortal: n.props.withPortal, forceShowMonthNavigation: n.props.forceShowMonthNavigation, showDisabledMonthNavigation: n.props.showDisabledMonthNavigation, scrollableYearDropdown: n.props.scrollableYearDropdown, scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown, todayButton: n.props.todayButton, weekLabel: n.props.weekLabel, outsideClickIgnoreClass: Qu, fixedHeight: n.props.fixedHeight, monthsShown: n.props.monthsShown, monthSelectedIn: n.state.monthSelectedIn, onDropdownFocus: n.handleDropdownFocus, onMonthChange: n.props.onMonthChange, onYearChange: n.props.onYearChange, dayClassName: n.props.dayClassName, weekDayClassName: n.props.weekDayClassName, monthClassName: n.props.monthClassName, timeClassName: n.props.timeClassName, showDateSelect: n.props.showDateSelect, showTimeSelect: n.props.showTimeSelect, showTimeSelectOnly: n.props.showTimeSelectOnly, onTimeChange: n.handleTimeChange, timeFormat: n.props.timeFormat, timeIntervals: n.props.timeIntervals, minTime: n.props.minTime, maxTime: n.props.maxTime, excludeTimes: n.props.excludeTimes, filterTime: n.props.filterTime, timeCaption: n.props.timeCaption, className: n.props.calendarClassName, container: n.props.calendarContainer, yearItemNumber: n.props.yearItemNumber, yearDropdownItemNumber: n.props.yearDropdownItemNumber, previousMonthAriaLabel: n.props.previousMonthAriaLabel, previousMonthButtonLabel: n.props.previousMonthButtonLabel, nextMonthAriaLabel: n.props.nextMonthAriaLabel, nextMonthButtonLabel: n.props.nextMonthButtonLabel, previousYearAriaLabel: n.props.previousYearAriaLabel, previousYearButtonLabel: n.props.previousYearButtonLabel, nextYearAriaLabel: n.props.nextYearAriaLabel, nextYearButtonLabel: n.props.nextYearButtonLabel, timeInputLabel: n.props.timeInputLabel, disabledKeyboardNavigation: n.props.disabledKeyboardNavigation, renderCustomHeader: n.props.renderCustomHeader, popperProps: n.props.popperProps, renderDayContents: n.props.renderDayContents, renderMonthContent: n.props.renderMonthContent, renderQuarterContent: n.props.renderQuarterContent, renderYearContent: n.props.renderYearContent, onDayMouseEnter: n.props.onDayMouseEnter, onMonthMouseLeave: n.props.onMonthMouseLeave, onYearMouseEnter: n.props.onYearMouseEnter, onYearMouseLeave: n.props.onYearMouseLeave, selectsDisabledDaysInRange: n.props.selectsDisabledDaysInRange, showTimeInput: n.props.showTimeInput, showMonthYearPicker: n.props.showMonthYearPicker, showFullMonthYearPicker: n.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: n.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: n.props.showFourColumnMonthYearPicker, showYearPicker: n.props.showYearPicker, showQuarterYearPicker: n.props.showQuarterYearPicker, showWeekPicker: n.props.showWeekPicker, showPopperArrow: n.props.showPopperArrow, excludeScrollbar: n.props.excludeScrollbar, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, isInputFocused: n.state.focused, customTimeInput: n.props.customTimeInput, setPreSelection: n.setPreSelection }, n.props.children) : null;
    }), k(P(n), "renderAriaLiveRegion", function() {
      var i, o = n.props, s = o.dateFormat, l = o.locale, c = n.props.showTimeInput || n.props.showTimeSelect ? "PPPPp" : "PPPP";
      return i = n.props.selectsRange ? "Selected start date: ".concat(nn(n.props.startDate, { dateFormat: c, locale: l }), ". ").concat(n.props.endDate ? "End date: " + nn(n.props.endDate, { dateFormat: c, locale: l }) : "") : n.props.showTimeSelectOnly ? "Selected time: ".concat(nn(n.props.selected, { dateFormat: s, locale: l })) : n.props.showYearPicker ? "Selected year: ".concat(nn(n.props.selected, { dateFormat: "yyyy", locale: l })) : n.props.showMonthYearPicker ? "Selected month: ".concat(nn(n.props.selected, { dateFormat: "MMMM yyyy", locale: l })) : n.props.showQuarterYearPicker ? "Selected quarter: ".concat(nn(n.props.selected, { dateFormat: "yyyy, QQQ", locale: l })) : "Selected date: ".concat(nn(n.props.selected, { dateFormat: c, locale: l })), w.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, i);
    }), k(P(n), "renderDateInput", function() {
      var i, o = vt(n.props.className, k({}, Qu, n.state.open)), s = n.props.customInput || w.createElement("input", { type: "text" }), l = n.props.customInputRef || "ref", c = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? function(d, p, f) {
        if (!d) return "";
        var h = nn(d, f), m = p ? nn(p, f) : "";
        return "".concat(h, " - ").concat(m);
      }(n.props.startDate, n.props.endDate, n.props) : nn(n.props.selected, n.props);
      return w.cloneElement(s, (k(k(k(k(k(k(k(k(k(k(i = {}, l, function(d) {
        n.input = d;
      }), "value", c), "onBlur", n.handleBlur), "onChange", n.handleChange), "onClick", n.onInputClick), "onFocus", n.handleFocus), "onKeyDown", n.onInputKeyDown), "id", n.props.id), "name", n.props.name), "form", n.props.form), k(k(k(k(k(k(k(k(k(k(i, "autoFocus", n.props.autoFocus), "placeholder", n.props.placeholderText), "disabled", n.props.disabled), "autoComplete", n.props.autoComplete), "className", vt(s.props.className, o)), "title", n.props.title), "readOnly", n.props.readOnly), "required", n.props.required), "tabIndex", n.props.tabIndex), "aria-describedby", n.props.ariaDescribedBy), k(k(k(i, "aria-invalid", n.props.ariaInvalid), "aria-labelledby", n.props.ariaLabelledBy), "aria-required", n.props.ariaRequired)));
    }), k(P(n), "renderClearButton", function() {
      var i = n.props, o = i.isClearable, s = i.disabled, l = i.selected, c = i.startDate, d = i.endDate, p = i.clearButtonTitle, f = i.clearButtonClassName, h = f === void 0 ? "" : f, m = i.ariaLabelClose, C = m === void 0 ? "Close" : m;
      return !o || l == null && c == null && d == null ? null : w.createElement("button", { type: "button", className: vt("react-datepicker__close-icon", h, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": C, onClick: n.onClearClick, title: p, tabIndex: -1 });
    }), n.state = n.calcInitialState(), n.preventFocusTimeout = null, n;
  }
  return ht(r, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(a, n) {
    var i, o;
    a.inline && (i = a.selected, o = this.props.selected, i && o ? wt(i) !== wt(o) || Te(i) !== Te(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && a.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), a.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: Yu(this.props.highlightDates) }), n.focused || aa(a.selected, this.props.selected) || this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), n.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var a = this.props, n = a.showIcon, i = a.icon, o = a.calendarIconClassname, s = a.toggleCalendarOnIconClick, l = this.state.open;
    return w.createElement("div", { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") }, n && w.createElement(__, qa({ icon: i, className: "".concat(o, " ").concat(l && "react-datepicker-ignore-onclickoutside") }, s ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var a = this.renderCalendar();
    if (this.props.inline) return a;
    if (this.props.withPortal) {
      var n = this.state.open ? w.createElement(E4, { enableTabLoop: this.props.enableTabLoop }, w.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, a)) : null;
      return this.state.open && this.props.portalId && (n = w.createElement(T4, { portalId: this.props.portalId, portalHost: this.props.portalHost }, n)), w.createElement("div", null, this.renderInputContainer(), n);
    }
    return w.createElement(M_, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: a, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: jr, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), r;
}(), P_ = "input", Wo = "navigate";
const T_ = (e) => {
  const t = new Date(0, 0, 0, 0, 0), { hours: r, minutes: a, seconds: n } = D_(e);
  return t.setHours(Number(r)), t.setMinutes(Number(a)), t.setSeconds(Number(n)), t;
}, qu = (e) => {
  const t = e.getHours(), r = e.getMinutes(), a = e.getSeconds();
  return t * 3600 + r * 60 + a;
}, E_ = (e) => {
  const t = Math.floor(e / 3600), r = Math.floor(e % (60 * 60) / 60);
  return {
    hours: t < 10 ? `0${t}` : String(t),
    minutes: r < 10 ? `0${r}` : String(r)
  };
}, D_ = (e) => {
  const { hours: t, minutes: r } = E_(e), a = e % 60;
  return {
    hours: t,
    minutes: r,
    seconds: a < 10 ? `0${a}` : String(a)
  };
}, mo = Xa(function({
  error: t,
  label: r,
  labelClassName: a,
  labelRightElement: n,
  htmlFor: i,
  nativeLabelProps: o,
  value: s,
  onChange: l,
  onFocus: c,
  maxLength: d,
  placeholder: p,
  isPreFetching: f,
  required: h,
  description: m,
  className: C,
  addonBefore: g,
  addonAfter: v,
  inputClassName: b,
  success: y,
  addonAfterClassName: x,
  addonBeforeClassName: S,
  statusIcon: _,
  statusIconClassName: M,
  labelContentWrapperClassName: I,
  errorAndDescriptionClassName: L,
  descriptionClassName: D,
  errorClassName: A,
  ...B
}, U) {
  const H = z(
    "ui-break-words ui-flex ui-justify-center ui-items-center ui-py-2.5 ui-px-2 sm:ui-px-4  ui-border ui-border-y-gray/50",
    f ? "ui-bg-gray-600/40 ui-text-transparent ui-border-0" : "ui-text-gray-700 ui-bg-gray-200"
  ), K = z(Al, _ && "ui-pr-9");
  return /* @__PURE__ */ u.jsxs(
    "label",
    {
      className: z("ui-text-sm ui-font-medium ui-flex ui-flex-col ui-gap-1", C),
      ...o,
      children: [
        /* @__PURE__ */ u.jsx(
          wa,
          {
            label: r,
            labelClassName: a,
            labelRightElement: n,
            required: h
          }
        ),
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            className: z(
              "ui-text-darkblue ui-relative ui-flex ui-shrink-0 ui-w-full ui-rounded-lg ui-main-transition-colors",
              f && "ui-animate-pulse",
              I
            ),
            children: [
              g && /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: z(
                    "ui-border-l-gray/50 ui-border-r-transparent ui-rounded-l-lg",
                    H,
                    S
                  ),
                  children: g
                }
              ),
              /* @__PURE__ */ u.jsx(
                "input",
                {
                  ref: U,
                  className: z(
                    "ui-main-transition-colors ui-basis-full ui-min-w-0 focus:ui-border-blue focus:ui-outline-none placeholder:ui-text-gray-300/70 ui-rounded-lg",
                    K,
                    b,
                    t ? "ui-border-danger" : y ? "ui-border-green" : "ui-border-gray/30",
                    f ? "ui-bg-gray-600/40 ui-text-transparent disabled:ui-bg-gray-600/40 ui-border-0" : "disabled:ui-bg-gray-200/40 ui-border",
                    g && "ui-rounded-l-none",
                    v && "ui-rounded-r-none"
                  ),
                  type: B.type || "text",
                  value: s,
                  onChange: l,
                  onFocus: c,
                  maxLength: d,
                  placeholder: p,
                  spellCheck: !1,
                  disabled: B.disabled || f,
                  ...B
                }
              ),
              v && /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: z(
                    "ui-border-r-gray/50 ui-border-l-transparent ui-rounded-r-lg",
                    H,
                    x
                  ),
                  children: v
                }
              ),
              _ && /* @__PURE__ */ u.jsx(
                "div",
                {
                  className: z(
                    "ui-absolute ui-right-3 ui-w-[21px] ui-h-[21px] ui-translate-y-1/2",
                    M
                  ),
                  children: _
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ u.jsx(
          ya,
          {
            description: m,
            error: t,
            className: L,
            descriptionClassName: D,
            errorClassName: A
          }
        )
      ]
    }
  );
});
function EP({
  inputRef: e,
  label: t,
  labelClassName: r,
  required: a,
  value: n,
  onChange: i,
  onFocus: o,
  maxLength: s,
  error: l,
  placeholder: c,
  onClear: d,
  description: p,
  testAttributePostfix: f,
  isPreFetching: h,
  searchIconClassName: m,
  closeIconClassName: C,
  errorAndDescriptionClassName: g,
  descriptionClassName: v,
  errorClassName: b,
  showSearchIcon: y,
  ...x
}) {
  return /* @__PURE__ */ u.jsxs(
    "label",
    {
      className: `${x.className} ui-relative ui-text-sm ui-font-medium ui-flex ui-flex-col ui-gap-1`,
      children: [
        /* @__PURE__ */ u.jsx(wa, { label: t, labelClassName: r, required: a }),
        (n === "" || y) && /* @__PURE__ */ u.jsx(
          fh,
          {
            className: z(
              "ui-absolute ui-right-4 ui-w-[21px] ui-h-[21px] ui-translate-y-1/2 ui-scale-75 ui-z-1",
              t && "ui-top-[24px]",
              m
            )
          }
        ),
        n !== "" && /* @__PURE__ */ u.jsx(
          _i,
          {
            onClick: d,
            className: z(
              "ui-absolute ui-right-2 ui-w-[21px] ui-h-[21px] ui-translate-y-1/2 ui-z-1 ui-fill-darkblue ui-cursor-pointer ui-scale-75",
              t && "ui-top-[24px]",
              C
            )
          }
        ),
        /* @__PURE__ */ u.jsx(
          "input",
          {
            ref: e,
            className: `ui-relative ui-w-full ui-text-darkblue ui-main-transition-colors ui-rounded-lg ui-border ${l ? "ui-border-danger" : "ui-border-gray/30"} ui-py-2.5 ui-pl-4 ui-pr-8 focus:ui-border-blue focus:ui-outline-none placeholder:ui-text-gray-300/70 ${h ? "ui-animate-pulse ui-bg-gray-600/40 ui-text-transparent disabled:ui-bg-gray-600/40" : "disabled:ui-bg-gray-200/40"} ${x.inputClassName || ""}`,
            onKeyDown: (S) => x.type === "number" && ["e", "E", "+", "-"].includes(S.key) && S.preventDefault(),
            type: x.type || "text",
            disabled: x.disabled || h,
            value: n,
            onChange: i,
            onFocus: o,
            maxLength: s,
            placeholder: c || ue.t("public_pages_purchase.input.search"),
            spellCheck: !1,
            ...ps(!!f, `${f}`)
          }
        ),
        /* @__PURE__ */ u.jsx(
          ya,
          {
            description: p,
            error: l,
            className: g,
            descriptionClassName: v,
            errorClassName: b
          }
        )
      ]
    }
  );
}
const Pr = "https://", DP = ({
  onChange: e,
  value: t = "",
  addonBefore: r,
  withCopyButton: a,
  buttonClassName: n,
  linkIconClassName: i,
  ...o
}) => {
  const s = t.replace(Pr, ""), l = ({ target: { value: c } }) => {
    if (!c || c === Pr) return e("");
    e(Pr + c.replace(Pr, ""));
  };
  return /* @__PURE__ */ u.jsx(
    mo,
    {
      type: "url",
      addonBefore: r || Pr,
      value: s,
      onChange: l,
      addonAfterClassName: "ui-p-0 sm:ui-p-0 lg:ui-p-0 ui-border-0",
      addonAfter: a && /* @__PURE__ */ u.jsx(
        "button",
        {
          type: "button",
          onClick: async (c) => {
            c.preventDefault(), await Dv(t, ue.t("public_pages_purchase.copy_clipboard"));
          },
          className: z(
            "ui-h-full ui-flex ui-justify-center ui-items-center ui-px-2 sm:ui-px-4 ui-py-2.5 ui-rounded-r-lg ui-bg-blue hover:ui-bg-blue-300 ui-focus-ring",
            n
          ),
          children: /* @__PURE__ */ u.jsx(
            sh,
            {
              className: z(
                "ui-fill-white ui-w-[15px] sm:ui-w-[20px] ui-h-[15px] sm:ui-h-[20px]",
                i
              )
            }
          )
        }
      ),
      ...o
    }
  );
}, IP = ({
  value: e,
  onChange: t,
  type: r = "float",
  toFixed: a = 2,
  max: n,
  min: i,
  ...o
}) => {
  const [s, l] = te(e.toString());
  he(() => {
    l(e.toString());
  }, [e]);
  const c = (p) => {
    const f = p.target.value;
    if (r === "integer")
      /^[0-9]*$/.test(f) && l(f);
    else {
      const h = f.replace(",", "."), m = new RegExp(`^-?\\d*(\\.\\d{0,${a}})?$`);
      h.match(m) !== null && l(h);
    }
  }, d = () => {
    let p;
    r === "integer" ? p = parseInt(s, 10) || 0 : p = parseFloat(s) || 0, n !== void 0 && (p = Math.min(p, n)), i !== void 0 && (p = Math.max(p, i)), r === "integer" && (p = Math.max(0, p)), t(p), l(r === "integer" ? p.toString() : p.toFixed(a));
  };
  return /* @__PURE__ */ u.jsx(
    mo,
    {
      value: s,
      onChange: c,
      onBlur: d,
      min: r === "integer" ? "0" : void 0,
      type: "text",
      ...o
    }
  );
}, I_ = "react-international-phone-", D4 = (...e) => e.filter((t) => !!t).join(" ").trim(), L_ = (...e) => D4(...e).split(" ").map((t) => `${I_}${t}`).join(" "), Et = ({ addPrefix: e, rawClassNames: t }) => D4(L_(...e), ...t), an = (e) => e.replace(/\D/g, ""), Xu = 35, A_ = ({
  value: e,
  mask: t,
  maskSymbol: r,
  allowMoreDigitsThanMaskAllows: a,
  offset: n = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (e.length < n) return e;
  const o = e.slice(0, n), s = e.slice(n);
  let l = o, c = 0;
  for (const p of t.split("")) {
    if (c >= s.length) {
      if (!i && p !== r) {
        l += p;
        continue;
      }
      break;
    }
    p === r ? (l += s[c], c += 1) : l += p;
  }
  let d = an(l);
  return a && d.length < e.length && (l += e.slice(d.length), d = an(l)), d.length >= Xu && (l = l.slice(0, -(d.length - Xu) || void 0)), l;
}, N_ = (e, t) => {
  const r = e.style.display;
  r !== "block" && (e.style.display = "block");
  const a = e.getBoundingClientRect(), n = t.getBoundingClientRect(), i = n.top - a.top, o = a.bottom - n.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? e.scrollTop += i : e.scrollTop -= o), e.style.display = r;
}, Wt = (e) => {
  const [t, r, a, n, i, o, s] = e;
  return {
    name: t,
    regions: r,
    iso2: a,
    dialCode: n,
    format: i,
    priority: o,
    areaCodes: s
  };
}, R_ = (e) => `Field "${e}" is not supported`, Ba = ({
  value: e,
  field: t,
  countries: r,
  defaultCountry: a
}) => {
  if (["regions", "priority"].includes(t))
    throw new Error(R_(t));
  const n = r.find((i) => {
    const o = Wt(i);
    return e === o[t];
  }) || r.find((i) => {
    const o = Wt(i);
    return a.toLocaleLowerCase() === o[t];
  });
  if (n)
    return Wt(n);
}, ec = ({
  phone: e,
  countries: t,
  currentCountryIso2: r,
  defaultCountry: a
}) => {
  var l;
  const n = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!e)
    return n;
  const i = an(e);
  if (!i)
    return n;
  let o = n;
  const s = ({
    country: c,
    fullDialCodeMatch: d,
    areaCodeMatch: p
  }) => {
    var m, C;
    const f = c.dialCode === ((m = o.country) == null ? void 0 : m.dialCode), h = (c.priority ?? 0) < (((C = o.country) == null ? void 0 : C.priority) ?? 0);
    (!f || h) && (o = { country: c, fullDialCodeMatch: d, areaCodeMatch: p });
  };
  for (const c of t) {
    const d = Wt(c), { dialCode: p, areaCodes: f } = d;
    if (i.startsWith(p)) {
      const h = o.country ? Number(p) >= Number(o.country.dialCode) : !0;
      if (f) {
        const m = i.substring(p.length);
        for (const C of f)
          if (m.startsWith(C))
            return {
              country: d,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (h || p === i || !o.fullDialCodeMatch) && s({
        country: d,
        fullDialCodeMatch: !0,
        areaCodeMatch: f ? !f : void 0
      });
    }
    o.fullDialCodeMatch || i.length < p.length && p.startsWith(i) && (!o.country || Number(p) <= Number(o.country.dialCode)) && s({ country: d, fullDialCodeMatch: !1 });
  }
  if (r) {
    const c = Ba({
      value: r,
      field: "iso2",
      countries: t,
      defaultCountry: a
    });
    !!o && !!c && // different countries with same dial code
    ((l = o.country) == null ? void 0 : l.dialCode) === c.dialCode && o.country !== c && // full dial code match (without area code)
    o.fullDialCodeMatch && !o.areaCodeMatch && (o = {
      country: c,
      areaCodeMatch: c != null && c.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return o;
}, O_ = ({
  phone: e,
  dialCode: t,
  prefix: r = "+",
  charAfterDialCode: a = " "
}) => {
  if (!e || !t)
    return e;
  let n = e;
  return n.startsWith(r) && (n = n.replace(r, "")), n.startsWith(t) ? (n = n.replace(t, ""), n.startsWith(a) && (n = n.replace(a, "")), n) : e;
}, tc = ({
  phone: e,
  dialCode: t,
  prefix: r = "+",
  charAfterDialCode: a = " "
}) => `${r}${t}${a}${O_({
  phone: e,
  dialCode: t,
  charAfterDialCode: a,
  prefix: r
})}`, B_ = (e, t) => {
  const r = t.disableDialCodeAndPrefix ? !1 : t.forceDialCode, a = t.disableDialCodeAndPrefix ? !1 : t.insertDialCodeOnEmpty;
  let n = e;
  const i = (c) => t.trimNonDigitsEnd ? c.trim() : c;
  if (!n)
    return a && !n.length || r ? i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`) : i(n);
  if (n = an(n), n === t.dialCode && !t.disableDialCodeAndPrefix)
    return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
  if (t.dialCode.startsWith(n) && !t.disableDialCodeAndPrefix)
    return i(r ? `${t.prefix}${t.dialCode}${t.charAfterDialCode}` : `${t.prefix}${n}`);
  if (!n.startsWith(t.dialCode) && !t.disableDialCodeAndPrefix) {
    if (r)
      return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
    if (n.length < t.dialCode.length)
      return i(`${t.prefix}${n}`);
  }
  const o = () => {
    let c = t.dialCode.length;
    t.disableDialCodeAndPrefix && (c = 0);
    const d = n.slice(0, c), p = n.slice(c);
    return {
      phoneLeftSide: d,
      phoneRightSide: p
    };
  };
  let { phoneLeftSide: s, phoneRightSide: l } = o();
  return s = `${t.prefix}${s}${t.charAfterDialCode}`, l = A_({
    value: l,
    mask: t.mask,
    maskSymbol: t.maskChar,
    allowMoreDigitsThanMaskAllows: t.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: t.trimNonDigitsEnd
  }), t.disableDialCodeAndPrefix && (s = ""), i(`${s}${l}`);
}, Tr = (e) => /\d/.test(e), j_ = ({
  phoneBeforeInput: e,
  phoneAfterInput: t,
  phoneAfterFormatted: r,
  cursorPositionAfterInput: a,
  leftOffset: n = 0,
  deletion: i
}) => {
  if (a < n)
    return n;
  if (!e)
    return r.length;
  const o = i === "backward";
  if (a === 0 && t.length > 0 && r.length > 0) {
    if (o) return 0;
    for (let p = 0; p < r.length; p += 1)
      if (Tr(r[p]))
        return p;
    return r.length;
  }
  if (t.length < e.length && t.length === 1)
    return r.length;
  let s = null;
  for (let p = a - 1; p >= 0; p -= 1)
    if (Tr(t[p])) {
      s = p;
      break;
    }
  if (s === null)
    return a !== 0 ? a : r.length;
  let l = 0;
  for (let p = 0; p < s; p += 1)
    Tr(t[p]) && (l += 1);
  o && (l -= 1);
  let c = 0, d = 0;
  for (let p = 0; p < r.length && (c += 1, Tr(r[p]) && (d += 1), d !== l + 1); p += 1)
    ;
  for (; !Tr(r[c]) && c < r.length; )
    c += 1;
  return o && (c += 1), c;
}, $l = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"]
], w1 = "fr", H_ = () => {
  const e = Q(), t = Q(Date.now());
  return {
    check: () => {
      const a = Date.now(), n = e.current ? a - t.current : void 0;
      return e.current = t.current, t.current = a, n;
    }
  };
}, F_ = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function G_(e, t) {
  const { size: r, overrideLastItemDebounceMS: a, onChange: n } = {
    ...F_,
    ...t
  }, [i, o] = te(e), [s, l] = te([i]), [c, d] = te(0), p = H_();
  return [i, (C, g) => {
    if (
      // compare entries if passed value is object
      typeof C == "object" && Object.entries(C).toString() === Object.entries(i).toString() || C === i
    )
      return;
    const v = a > 0, b = p.check(), y = v && b !== void 0 ? b > a : !0;
    if (
      // use value of config.overrideLastItem if passed
      (g == null ? void 0 : g.overrideLastItem) !== void 0 ? g.overrideLastItem : !y
    )
      l((S) => [...S.slice(0, c), C]);
    else {
      const S = s.length >= r;
      l((_) => [..._.slice(S ? 1 : 0, c + 1), C]), S || d((_) => _ + 1);
    }
    o(C), n == null || n(C);
  }, () => {
    if (c <= 0)
      return { success: !1 };
    const C = s[c - 1];
    return o(C), d((g) => g - 1), n == null || n(C), { success: !0, value: C };
  }, () => {
    if (c + 1 >= s.length)
      return { success: !1 };
    const C = s[c + 1];
    return o(C), d((g) => g + 1), n == null || n(C), { success: !0, value: C };
  }];
}
const V_ = ".", Tt = {
  defaultCountry: w1,
  initialCountry: w1,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: $l,
  dontShowDialCodePrefillOnFocus: !1
}, K_ = ({
  defaultCountry: e = Tt.defaultCountry,
  initialCountry: t = Tt.initialCountry,
  value: r = Tt.value,
  countries: a = Tt.countries,
  prefix: n = Tt.prefix,
  defaultMask: i = Tt.defaultMask,
  allowMoreDigitsThanMaskAllows: o = Tt.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = Tt.charAfterDialCode,
  historySaveDebounceMS: l = Tt.historySaveDebounceMS,
  disableCountryGuess: c = Tt.disableCountryGuess,
  disableDialCodePrefill: d = Tt.disableDialCodePrefill,
  forceDialCode: p = Tt.forceDialCode,
  disableDialCodeAndPrefix: f = Tt.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: h = Tt.dontShowDialCodePrefillOnFocus,
  onChange: m
}) => {
  const C = r || "", g = f ? !1 : !c, v = Q(null), b = ({
    value: V,
    country: O,
    trimNonDigitsEnd: j,
    insertDialCodeOnEmpty: N,
    forceDisableCountryGuess: E
  }) => {
    const R = !E && g ? ec({
      phone: V,
      countries: a,
      currentCountryIso2: O.iso2,
      defaultCountry: e
    }) : void 0, $ = (R == null ? void 0 : R.country) ?? O;
    return { phone: $ ? B_(V, {
      prefix: n,
      mask: $.format || i,
      maskChar: V_,
      dialCode: $.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: j,
      charAfterDialCode: s,
      forceDialCode: p,
      insertDialCodeOnEmpty: N,
      disableDialCodeAndPrefix: f
    }) : V, countryGuessResult: R, formatCountry: $ };
  }, y = (V) => {
    typeof document < "u" && document.activeElement === v.current && Promise.resolve().then(() => {
      var O;
      (O = v.current) == null || O.setSelectionRange(V, V);
    });
  }, x = _e(
    ({ phone: V, country: O }) => m == null ? void 0 : m({
      phone: V,
      unformatedPhone: an(V),
      country: O,
      prefix: n
    }),
    [m, n]
  ), [{ phone: S, country: _ }, M, I, L] = G_(
    () => {
      const O = ec({
        phone: C,
        countries: a,
        currentCountryIso2: t,
        defaultCountry: e
      }).country || Ba({
        value: t,
        field: "iso2",
        countries: a,
        defaultCountry: e
      });
      O || console.error(
        `[react-international-phone]: can not find a country with "${e}" iso2 code`
      );
      const j = O || // set "us" if user provided not valid country
      Wt(a.find((E) => Wt(E).iso2 === w1)), N = b({
        value: C,
        country: j,
        insertDialCodeOnEmpty: h ? !d : !1
      }).phone;
      return y(N.length), {
        phone: N,
        country: j.iso2
      };
    },
    {
      overrideLastItemDebounceMS: l,
      onChange: x
    }
  ), D = q(() => Ba({
    value: _,
    field: "iso2",
    countries: a,
    defaultCountry: e
  }), [a, _, e]), A = _e(() => {
    var V;
    h || (V = v == null ? void 0 : v.current) != null && V.value || x == null || x({
      phone: tc({
        phone: S,
        dialCode: D.dialCode,
        charAfterDialCode: s,
        prefix: n
      }),
      country: _
    });
  }, [
    s,
    _,
    D,
    x,
    S,
    n,
    h
  ]), B = (V, {
    deletion: O,
    cursorPosition: j,
    insertDialCodeOnEmpty: N,
    inserted: E
  } = {}) => {
    var de;
    let G = V, R = j;
    p && !f && D && // dial code has been changed
    !an(V).startsWith(D.dialCode) && V && (E && V.startsWith(n) && // cursor position was set to 0 before the input
    V.length - (j ?? 0) === 0 ? G = V : (G = S, R = 0));
    const { phone: $, countryGuessResult: W } = b({
      value: G,
      country: D,
      trimNonDigitsEnd: O === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: N,
      forceDisableCountryGuess: p && !!O && an(G).length < D.dialCode.length
    });
    let re = D;
    g && (W != null && W.country) && W.country.name !== _ && W.fullDialCodeMatch && (re = W.country);
    const ae = j_({
      cursorPositionAfterInput: R ?? 0,
      phoneBeforeInput: S,
      phoneAfterInput: V,
      phoneAfterFormatted: $,
      leftOffset: p ? n.length + (((de = D == null ? void 0 : D.dialCode) == null ? void 0 : de.length) ?? 0) + s.length : 0,
      deletion: O
    });
    return M({
      phone: $,
      country: re.iso2
    }), y(ae), $;
  };
  he(() => {
    const V = v.current;
    if (!V) return;
    const O = (j) => {
      if (!j.key) return;
      const N = j.ctrlKey, E = j.shiftKey, G = j.key.toLowerCase() === "z";
      !N || !G || (E ? L() : I());
    };
    return V.addEventListener("keydown", O), () => {
      V.removeEventListener("keydown", O);
    };
  }, [v, I, L]);
  const U = (V) => {
    V.preventDefault();
    const O = V.nativeEvent.inputType, j = () => {
      if ((O == null ? void 0 : O.toLocaleLowerCase().includes("delete")) ?? !1)
        return O != null && O.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, N = O == null ? void 0 : O.startsWith("insertFrom"), E = B(V.target.value, {
      deletion: j(),
      inserted: N,
      cursorPosition: V.target.selectionStart ?? 0
    });
    return f && D ? tc({
      phone: E,
      dialCode: D.dialCode,
      charAfterDialCode: s,
      prefix: n
    }) : E;
  }, H = (V) => {
    const O = Ba({
      value: V,
      field: "iso2",
      countries: a,
      defaultCountry: e
    });
    if (!O) return;
    const j = f ? "" : `${n}${O.dialCode}${s}`;
    M({
      phone: j,
      country: O.iso2
    }), Promise.resolve().then(() => {
      var N;
      (N = v.current) == null || N.focus();
    });
  }, [K, Z] = te(!1);
  return he(() => {
    if (!K) {
      Z(!0), C !== S && (x == null || x({ phone: S, country: _ }));
      return;
    }
    an(C) !== an(S) && B(an(C));
  }, [C]), he(() => {
    if (!S && t) {
      const V = Ba({
        value: t,
        field: "iso2",
        countries: a,
        defaultCountry: e
      });
      M({
        phone: S,
        country: (V == null ? void 0 : V.iso2) || e
      });
    }
  }, [t]), {
    phone: S,
    // Formatted phone string.
    country: _,
    // Current country iso code.
    setCountry: H,
    // Country setter.
    handlePhoneValueChange: U,
    // Change handler for input component
    onFocus: A,
    inputRef: v
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, z_ = (e, t) => {
  const r = parseInt(e, 16);
  return Number(r + t).toString(16);
}, U_ = "abcdefghijklmnopqrstuvwxyz", Z_ = "1f1e6", nc = U_.split("").reduce((e, t, r) => ({
  ...e,
  // construct alphabet by incrementing A letter codepoint value
  [t]: z_(Z_, r)
}), {}), Y_ = (e) => [nc[e[0]], nc[e[1]]].join("-"), I4 = ({
  iso2: e,
  size: t = "24px",
  protocol: r = "https",
  disableLazyLoading: a,
  className: n,
  ...i
}) => {
  if (!e)
    return /* @__PURE__ */ u.jsx("img", { width: t, height: t, ...i });
  const o = Y_(e), s = `${r}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ u.jsx(
    "img",
    {
      className: Et({
        addPrefix: ["flag-emoji"],
        rawClassNames: [n]
      }),
      src: s,
      width: t,
      height: t,
      draggable: !1,
      "data-country": e,
      loading: a ? void 0 : "lazy",
      ...i
    }
  );
}, L4 = ({
  show: e,
  dialCodePrefix: t = "+",
  selectedCountry: r,
  countries: a = $l,
  onSelect: n,
  onClose: i,
  searchInputPlaceholder: o,
  ...s
}) => {
  const l = Q(null), c = Q(null), d = Q(), [p, f] = te(""), h = q(() => {
    if (p) {
      const _ = p.toLowerCase();
      return a.filter(([M]) => M.toLowerCase().includes(_));
    } else
      return a;
  }, [a, p]), m = _e(
    (_) => h.findIndex((M) => Wt(M).iso2 === _),
    [h]
  ), [C, g] = te(m(r)), v = () => {
    d.current !== r && g(m(r));
  }, b = _e(
    (_) => {
      g(m(_.iso2)), n == null || n(_);
    },
    [n, m]
  ), y = (_) => {
    const M = h.length - 1, I = (L) => _ === "prev" ? L - 1 : _ === "next" ? L + 1 : _ === "last" ? M : 0;
    g((L) => {
      const D = I(L);
      return D < 0 ? 0 : D > M ? M : D;
    });
  }, x = (_) => {
    if (_.stopPropagation(), _.key === "Enter") {
      const M = Wt(h[C]);
      b(M);
      return;
    }
    if (_.key === "Escape") {
      i == null || i();
      return;
    }
    if (_.key === "ArrowUp") {
      _.preventDefault(), y("prev");
      return;
    }
    if (_.key === "ArrowDown") {
      _.preventDefault(), y("next");
      return;
    }
    if (_.key === "PageUp") {
      _.preventDefault(), y("first");
      return;
    }
    if (_.key === "PageDown") {
      _.preventDefault(), y("last");
      return;
    }
    _.key === " " && _.preventDefault();
  }, S = _e(() => {
    if (!c.current || C === void 0 || !h[C])
      return;
    const _ = Wt(h[C]).iso2;
    if (_ === d.current) return;
    const M = c.current.querySelector(`[data-country="${_}"]`);
    M && (N_(c.current, M), d.current = _);
  }, [C, h]);
  return he(() => {
    S();
  }, [C, S]), he(() => {
    l.current && (e ? Promise.resolve().then(() => {
      var _;
      return (_ = l.current) == null ? void 0 : _.focus();
    }) : v());
  }, [e]), he(() => {
    v();
  }, [r]), /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: Et({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: e ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${h[C] && Wt(h[C]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ u.jsx(
          "input",
          {
            ref: l,
            className: Et({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: o || "",
            style: s.searchInputStyle,
            type: "text",
            value: p,
            onChange: (_) => f(_.target.value),
            onKeyDown: x
          }
        ),
        p && /* @__PURE__ */ u.jsx(
          _i,
          {
            onClick: () => f(""),
            className: Et({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ u.jsx(
          "ul",
          {
            ref: c,
            role: "listbox",
            className: Et({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: h.map((_, M) => {
              const I = Wt(_), L = I.iso2 === r, D = M === C;
              return /* @__PURE__ */ u.jsxs(
                "li",
                {
                  "data-country": I.iso2,
                  "data-focused": D,
                  role: "option",
                  "aria-selected": L,
                  "aria-label": `${I.name} ${t}${I.dialCode}`,
                  id: `${I.iso2}-option`,
                  className: Et({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      L && "country-selector-dropdown__list-item--selected",
                      D && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => b(I),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ u.jsx(
                      I4,
                      {
                        iso2: I.iso2,
                        className: Et({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ u.jsx(
                      "span",
                      {
                        className: Et({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: I.name
                      }
                    ),
                    /* @__PURE__ */ u.jsxs(
                      "span",
                      {
                        className: Et({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          t,
                          I.dialCode
                        ]
                      }
                    )
                  ]
                },
                I.iso2
              );
            })
          }
        )
      ]
    }
  );
}, W_ = ({
  selectedCountry: e,
  onSelect: t,
  disabled: r,
  hideDropdown: a,
  defaultCountry: n = w1,
  countries: i = $l,
  renderButtonWrapper: o,
  ...s
}) => {
  const [l, c] = te(!1), d = q(() => {
    if (e)
      return Ba({
        value: e,
        field: "iso2",
        countries: i,
        defaultCountry: n
      });
  }, [i, n, e]), p = Q(null), f = (m) => {
    m.key && ["ArrowUp", "ArrowDown"].includes(m.key) && (m.preventDefault(), c(!0));
  }, h = () => {
    const m = {
      title: d == null ? void 0 : d.name,
      onClick: () => c((g) => !g),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (g) => g.preventDefault(),
      onKeyDown: f,
      disabled: a || r,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": l
    }, C = /* @__PURE__ */ u.jsxs(
      "div",
      {
        className: Et({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ u.jsx(
            I4,
            {
              iso2: e,
              className: Et({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  r && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: e ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !a && /* @__PURE__ */ u.jsx(
            "div",
            {
              className: Et({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  r && "country-selector-button__dropdown-arrow--disabled",
                  l && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: C,
      rootProps: m
    }) : /* @__PURE__ */ u.jsx(
      "button",
      {
        ...m,
        type: "button",
        className: Et({
          addPrefix: [
            "country-selector-button",
            l && "country-selector-button--active",
            r && "country-selector-button--disabled",
            a && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": e,
        style: s.buttonStyle,
        children: C
      }
    );
  };
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      className: Et({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: p,
      children: [
        h(),
        /* @__PURE__ */ u.jsx(
          L4,
          {
            show: l,
            countries: i,
            onSelect: (m) => {
              c(!1), t == null || t(m);
            },
            selectedCountry: e,
            onClose: () => {
              c(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, LP = ({
  label: e,
  labelClassName: t,
  required: r,
  value: a,
  onChange: n,
  error: i,
  wrapperClassName: o,
  inputClassName: s,
  listClassName: l,
  searchInputClassName: c,
  clearSearchInputClassName: d,
  listItemClassName: p,
  listItemCountryNameClassName: f,
  countrySelectorDropdownClassName: h,
  countrySelectorClassName: m,
  buttonClassName: C,
  listboxButtonClassName: g,
  listboxOptionsClassName: v,
  ...b
}) => {
  const y = Q(null), x = Q(null), S = Q(null), { country: _, setCountry: M, phone: I, handlePhoneValueChange: L, onFocus: D, inputRef: A } = K_({
    value: a,
    onChange: ({ unformatedPhone: B }) => n(B)
  });
  return /* @__PURE__ */ u.jsx("div", { className: o, children: /* @__PURE__ */ u.jsx(ol, { children: ({ open: B }) => {
    var U;
    return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-flex-col ui-gap-1", children: [
        /* @__PURE__ */ u.jsx(
          wa,
          {
            label: e,
            required: r,
            labelClassName: z("ui-text-sm ui-font-medium", t)
          }
        ),
        /* @__PURE__ */ u.jsxs(
          "div",
          {
            ref: x,
            className: "ui-relative ui-w-full ui-cursor-default ui-overflow-hidden ui-rounded-lg ui-text-left",
            children: [
              /* @__PURE__ */ u.jsxs(
                Yr,
                {
                  ref: S,
                  as: "div",
                  className: z(
                    "ui-cursor-pointer ui-absolute ui-top-2 ui-left-0 ui-flex ui-gap-1 ui-items-center ui-z-1 ui-pl-3",
                    g
                  ),
                  children: [
                    /* @__PURE__ */ u.jsx(
                      W_,
                      {
                        className: z("ui-flex", m),
                        buttonStyle: { border: "none" },
                        buttonClassName: z("ui-cursor-pointer", C),
                        hideDropdown: !0,
                        disabled: b.disabled,
                        selectedCountry: _
                      }
                    ),
                    /* @__PURE__ */ u.jsx(
                      a0,
                      {
                        className: `ui-transition-transform ui-duration-300 ${B && "ui-rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ u.jsx(
                mo,
                {
                  ref: A,
                  type: "tel",
                  placeholder: ue.t("public_pages_purchase.input.phone_number"),
                  inputClassName: z("ui-pl-16", B && "ui-border-blue", s),
                  value: I,
                  onChange: L,
                  onFocus: D,
                  error: i,
                  ...b
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx(
        $1,
        {
          className: z("focus-visible:ui-outline-none", v),
          children: /* @__PURE__ */ u.jsx(
            "div",
            {
              className: "ui-absolute ui-z-20 ui-bg-white ui-rounded-lg",
              ref: y,
              style: {
                width: `${(U = A.current) == null ? void 0 : U.clientWidth}px`
              },
              children: /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(
                L4,
                {
                  className: z(
                    "ui-rounded-md ui-bg-white ui-text-sm ui-shadow-around-sm",
                    h
                  ),
                  listClassName: z(
                    "ui-max-h-60 ui-w-full ui-overflow-auto focus:ui-outline-none ui-customScroll ui-rounded-md",
                    l
                  ),
                  searchInputClassName: z(
                    `ui-w-full ui-px-4 ui-py-2.5 ui-rounded-t-md ui-border ui-border-t-1 ui-border-b-0 ui-border-gray/30 
                        ui-shadow-around-sm focus:ui-outline-none
                      `,
                    c
                  ),
                  clearSearchInputClassName: z(
                    "ui-absolute ui-top-0 ui-right-2 ui-w-[21px] ui-h-[21px] ui-translate-y-1/2 ui-z-1 ui-fill-darkblue ui-cursor-pointer ui-scale-75",
                    d
                  ),
                  listItemClassName: z(
                    `ui-text-darkblue ui-px-4 ui-py-2.5 ui-border ui-border-t-0 last:ui-rounded-b-md ui-border-gray/30 
                        ui-group hover:ui-bg-blue hover:ui-text-white ui-flex ui-justify-start ui-gap-2 ui-items-center 
                        data-[focused=true]:ui-bg-blue aria-[selected=true]:ui-font-bold`,
                    p
                  ),
                  listItemCountryNameClassName: z(
                    "ui-truncate",
                    f
                  ),
                  searchInputPlaceholder: ue.t("public_pages_purchase.input.phone_search"),
                  show: B,
                  selectedCountry: _,
                  onSelect: (H) => {
                    var K;
                    M(H.iso2), (K = S.current) == null || K.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
}, $_ = (e) => {
  const t = {
    h: "-",
    hh: "--",
    H: "-",
    HH: "--",
    m: "-",
    mm: "--",
    s: "-",
    ss: "--",
    a: "AM/PM"
  };
  return e.split(/([^\w])/g).map((r) => t[r] || r).join("");
}, J_ = (e, t) => {
  const r = {
    d: "dd",
    // Day of the month, 2 digits with leading zero
    m: "MM",
    // Month, 2 digits with leading zero
    Y: "yyyy"
    // Year, 4 digits
  }, a = {
    h: "hh",
    // Hour in 12-hour format, 2 digits with leading zero
    H: "HH",
    // Hour in 24-hour format, 2 digits with leading zero
    i: "mm",
    // Minutes, 2 digits with leading zero
    s: "ss",
    // Seconds, 2 digits with leading zero
    A: "a"
    // AM/PM marker
  }, n = (s, l) => s.split(/([ :/])/).map(
    (c) => c.split("").map((d) => l[d] || d).join("")
  ).join(""), i = n(e, a), o = n(t, r);
  return {
    timeFormat: i,
    dateFormat: o
  };
}, AP = ({
  seconds: e,
  onChangeSeconds: t,
  containerClassName: r,
  userDateFormat: a,
  userTimeFormat: n,
  classNameCustomInput: i,
  wrapperClassName: o,
  showTimeSelect: s = !0,
  showTimeSelectOnly: l = !0,
  timeIntervals: c = 15,
  ...d
}) => {
  const { timeFormat: p } = a && n ? J_(n, a) : { timeFormat: "HH:mm" };
  return (
    // react-datepicker create a popup component as sibling which can cause "jumping" if parent has flex property
    /* @__PURE__ */ u.jsx("div", { className: z("ui-w-min", r), children: /* @__PURE__ */ u.jsx(
      ho,
      {
        disabled: d.disabled || d.isPreFetching,
        selected: typeof e == "number" ? T_(e) : null,
        onChange: (f) => {
          f && t(qu(f));
        },
        showTimeSelect: s,
        showTimeSelectOnly: l,
        timeIntervals: c,
        timeCaption: ue.t("public_pages_purchase.date_picker.time"),
        timeFormat: p,
        dateFormat: p,
        placeholderText: $_(p),
        customInput: /* @__PURE__ */ u.jsx(mo, { className: z("ui-w-32", i), ...d }),
        timeClassName: (f) => e === qu(f) ? "ui-text-blue" : "ui-text-darkblue",
        wrapperClassName: z("time-only", o)
      }
    ) })
  );
};
var As = /* @__PURE__ */ ((e) => (e.DateSince = "dateSince", e.DateTill = "dateTill", e))(As || {}), Hr = /* @__PURE__ */ ((e) => (e.Last30Days = "last_30_days", e.ThisMonth = "this_month", e.LastMonth = "last_month", e))(Hr || {}), ua = /* @__PURE__ */ ((e) => (e.AllTime = "all_time", e.Last3Months = "last_3_months", e.EvaluationPeriod = "evaluation_period", e))(ua || {});
const Jl = Xa(
  ({
    onClick: e,
    error: t,
    label: r,
    labelClassName: a,
    required: n,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: s,
    children: l,
    value: c
  }, d) => /* @__PURE__ */ u.jsxs("div", { className: z("ui-flex ui-flex-col ui-gap-1", i), children: [
    /* @__PURE__ */ u.jsx(wa, { label: r, labelClassName: a, required: n }),
    /* @__PURE__ */ u.jsxs("button", { onClick: e, ref: d, type: "button", className: o, children: [
      l(c),
      /* @__PURE__ */ u.jsx(Jf, { className: "ui-hidden sm:ui-block ui-ml-3 ui-fill-gray-100 ui-h-[20px] ui-w-[20px] group-focus:ui-fill-blue ui-main-transition-colors" })
    ] }),
    /* @__PURE__ */ u.jsx(ya, { error: t, description: s })
  ] })
), Ql = ({
  date: e,
  prevMonthButtonDisabled: t,
  nextMonthButtonDisabled: r,
  increaseMonth: a,
  decreaseMonth: n,
  intlLocale: i
}) => /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-items-center ui-justify-between ui-px-2 ui-py-2", children: [
  /* @__PURE__ */ u.jsx(
    "button",
    {
      onClick: n,
      disabled: t,
      type: "button",
      className: z(
        "ui-rounded-full ui-outline-none ui-group  ",
        t && "ui-cursor-not-allowed ui-opacity-50"
      ),
      children: /* @__PURE__ */ u.jsx(Yf, { className: "ui-fill-gray-900 group-focus-visible:ui-fill-blue group-active:ui-fill-blue" })
    }
  ),
  /* @__PURE__ */ u.jsx("span", { className: "ui-text-base ui-text-gray-900", children: new Intl.DateTimeFormat(i, {
    month: "long",
    year: "numeric"
  }).format(e) }),
  /* @__PURE__ */ u.jsx(
    "button",
    {
      onClick: a,
      disabled: r,
      type: "button",
      className: z(
        "ui-rounded-full ui-outline-none ui-group ",
        r && "ui-cursor-not-allowed ui-opacity-50"
      ),
      children: /* @__PURE__ */ u.jsx(r0, { className: "ui-fill-gray-900 group-focus-visible:ui-fill-blue group-active:ui-fill-blue" })
    }
  )
] }), ql = (e, t) => {
  he(() => {
    (async () => {
      try {
        if (e) {
          let a;
          e === "en" ? a = await import("./index-0D2oqKxe.mjs").then((n) => n.i).then((n) => n.default) : e === "zh" ? a = await import("./index-DaSTCpfX.mjs").then((n) => n.i).then((n) => n.default) : e === "no" ? a = await import("./index-BuNiuRRP.mjs").then((n) => n.i).then((n) => n.default) : a = await import(
            /* @vite-ignore */
            `date-fns/locale/${e}/index.js`
          ).then((n) => n.default), a && t(a);
        } else {
          const a = await import("./index-0D2oqKxe.mjs").then((n) => n.i).then((n) => n.default);
          t(a);
        }
      } catch {
        t(dr);
      }
    })();
  }, [e, t]);
}, NP = ({
  value: e,
  onChange: t,
  error: r,
  label: a,
  required: n,
  placeholder: i,
  description: o,
  customProps: s,
  wrapperButtonInputClassName: l,
  labelClassName: c,
  timezone: d,
  intlLocale: p
}) => {
  const [f, h] = te(
    e && at(e, d) || null
  ), [m, C] = te(
    e && at(e, d) || null
  ), [g, v] = te(dr), b = Q(null);
  return he(() => {
    e && !f && !m && d && (h(at(e, d)), C(at(e, d)));
  }, [e, d, f, m]), ql(p, v), /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(
    ho,
    {
      ref: b,
      selected: f,
      showTimeSelect: !0,
      dayClassName: (y) => f && m && y.toDateString() === m.toDateString() && f.toDateString() !== m.toDateString() ? "ui-text-blue/50" : "",
      timeClassName: (y) => f && m && y.getTime() === m.getTime() && f.getTime() !== m.getTime() ? "ui-text-blue/50" : ".",
      shouldCloseOnSelect: !1,
      onCalendarClose: () => {
        h(m);
      },
      timeFormat: "HH:mm",
      timeIntervals: 15,
      timeCaption: ue.t("public_pages_purchase.date_picker.time"),
      timeInputLabel: ue.t("public_pages_purchase.date_picker.time"),
      onChange: (y) => {
        y && h(y);
      },
      locale: g,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ u.jsx(
        Jl,
        {
          error: r,
          label: a,
          required: n,
          wrapperButtonInputClassName: l,
          buttonInputClassName: `ui-flex ui-group ui-justify-between ui-min-w-[250px] ui-w-full ui-py-2.5 ui-px-4 ui-text-sm ui-font-medium ui-text-darkblue ui-border ${r ? "ui-border-danger" : "ui-border-gray/30"} ui-rounded-lg ui-bg-white focus:ui-outline-none focus:ui-border-blue ui-main-transition-colors`,
          description: o,
          labelClassName: c,
          children: () => /* @__PURE__ */ u.jsx("span", { children: m ? new Intl.DateTimeFormat(p, {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "numeric",
            hourCycle: "h23",
            minute: "2-digit"
          }).format(m) : /* @__PURE__ */ u.jsx("span", { className: "ui-text-gray-300/70", children: i }) })
        }
      ),
      renderCustomHeader: ({
        date: y,
        decreaseMonth: x,
        increaseMonth: S,
        prevMonthButtonDisabled: _,
        nextMonthButtonDisabled: M
      }) => /* @__PURE__ */ u.jsx(
        Ql,
        {
          date: y,
          decreaseMonth: x,
          increaseMonth: S,
          prevMonthButtonDisabled: _,
          nextMonthButtonDisabled: M,
          intlLocale: p
        }
      ),
      ...s,
      children: /* @__PURE__ */ u.jsxs("div", { className: "sm:ui-col-span-2 ui-flex ui-w-full ui-justify-center ui-gap-5", children: [
        /* @__PURE__ */ u.jsx(
          M5,
          {
            disabled: !f,
            onClick: () => {
              var y;
              f && ((y = b.current) == null || y.setOpen(!1), C(f), t(ea(f)));
            },
            width: "large",
            children: ue.t("public_pages_purchase.date_picker.apply")
          }
        ),
        /* @__PURE__ */ u.jsx(
          k5,
          {
            onClick: () => {
              var y;
              (y = b.current) == null || y.setOpen(!1), C(null), t(null);
            },
            width: "large",
            children: ue.t("public_pages_purchase.date_picker.clear")
          }
        )
      ] })
    }
  ) });
}, Q_ = {
  [Hr.Last30Days]: "public_pages_purchase.date_picker.last_30_days",
  [Hr.ThisMonth]: "public_pages_purchase.date_picker.this_month",
  [Hr.LastMonth]: "public_pages_purchase.date_picker.last_month"
}, q_ = {
  [ua.AllTime]: "public_pages_purchase.date_picker.all_time",
  [ua.Last3Months]: "public_pages_purchase.date_picker.last_3_months",
  [ua.EvaluationPeriod]: "public_pages_purchase.date_picker.last_pool_period"
}, X_ = (e) => ue.t(Q_[e]), ex = (e) => ue.t(q_[e]);
function ac(e, t) {
  var r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function tx(e, t) {
  ee(2, arguments);
  var r = oe(e), a = oe(t), n = ac(r, a), i = Math.abs(qr(r, a));
  r.setDate(r.getDate() - n * i);
  var o = +(ac(r, a) === -n), s = n * (i - o);
  return s === 0 ? 0 : s;
}
const nx = (e, t, r) => (e && t && tx(t, e) > r && (e = new Date(t.getTime() - r * 24 * 60 * 60 * 1e3)), [e, t]), ax = (e) => Object.values(ua).includes(
  e
), rx = ({
  activeFilter: e,
  setDateRange: t,
  timezone: r,
  customFilters: a
}) => {
  var i;
  if (ax(e)) {
    const o = (i = a.find((s) => s.slug === e)) == null ? void 0 : i.handler;
    o && t(o());
  } else
    switch (e) {
      case "last_30_days": {
        const o = at("", r);
        o.setHours(23, 59, 59, 999);
        const s = new Date(o);
        s.setDate(s.getDate() - 30), s.setHours(0, 0, 0, 0), t([s, o]);
        break;
      }
      case "this_month": {
        const o = at("", r), s = o.getFullYear(), l = o.getMonth(), c = new Date(s, l, 1), d = new Date(s, l + 1, 0);
        t([c, d]);
        break;
      }
      case "last_month": {
        const o = at("", r), s = o.getFullYear(), l = o.getMonth(), c = new Date(s, l - 1, 1), d = new Date(s, l, 0);
        t([c, d]);
        break;
      }
    }
}, ix = (e, t) => {
  const r = at("", t);
  return r.setHours(23, 59, 59, 999), [at(e, t), r];
}, ox = (e) => {
  const t = at("", e);
  t.setHours(23, 59, 59, 999);
  const r = at("", e);
  return r.setMonth(r.getMonth() - 3), r.setHours(0, 0, 0, 0), [r, t];
}, rc = (e, t) => ({
  slug: ua.AllTime,
  handler: () => ix(e, t)
}), RP = (e) => ({
  slug: ua.Last3Months,
  handler: () => ox(e)
}), sx = (e) => (e.setHours(0, 0, 0, 0), e), A4 = (e) => (e.setHours(23, 59, 59, 999), e), OP = ({
  date: e,
  light: t,
  getDefaultDate: r,
  small: a,
  customFilters: n,
  filtersDisabled: i,
  onChange: o,
  placeholder: s,
  error: l,
  description: c,
  disabled: d,
  label: p,
  required: f,
  maxDate: h,
  minDate: m,
  wrapperButtonInputClassName: C,
  intlLocale: g,
  createdAt: v,
  timezone: b,
  dateFormat: y,
  customProps: x,
  labelClassName: S,
  maxInterval: _,
  showActionsSideBar: M = !0
}) => {
  const I = Q(null), [L, D] = te(dr), A = q(
    () => (m && ea(m)) ?? v,
    [m, v]
  ), B = (Se) => !g || !A || !Se ? Se : Fi(A) > Fi(Se) ? A : Se, [U, H] = e, K = B(e[0]), [Z, V] = te(), [O, j] = te(), [N, E] = te([
    K && at(K, b) || null,
    H && at(H, b) || null
  ]), [G, R] = N, [$, W] = te(
    K && at(K, b) || null
  ), [re, ae] = te(
    H && at(H, b) || null
  );
  he(() => {
    !b || !A || rx({
      activeFilter: O,
      timezone: b,
      setDateRange: E,
      customFilters: n || [rc(A, b)]
    });
  }, [Z, O, n, A]), ql(g, D), he(() => {
    if (K && H && b) {
      const Se = at(K, b), fe = at(H, b);
      E([Se, fe]), W(Se), ae(fe);
    }
  }, [e, K, H, b]);
  const de = /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-flex-col sm:ui-flex-row ui-gap-3 sm:ui-gap-5 ui-w-full ui-px-2", children: [
    /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-w-fit sm:ui-w-full", children: [
      /* @__PURE__ */ u.jsxs("span", { className: "ui-text-gray ui-pr-1", children: [
        ue.t("public_pages_purchase.date_picker.from"),
        ":"
      ] }),
      /* @__PURE__ */ u.jsx("span", { className: "ui-text-gray-900", children: G ? iu(G, { dateFormat: y }) : "-" })
    ] }),
    /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-w-fit sm:ui-w-full sm:ui-pl-2", children: [
      /* @__PURE__ */ u.jsxs("span", { className: "ui-text-gray ui-pr-1", children: [
        ue.t("public_pages_purchase.date_picker.to"),
        ":"
      ] }),
      /* @__PURE__ */ u.jsx("span", { className: "ui-text-gray-900", children: R ? iu(R, { dateFormat: y }) : "-" })
    ] })
  ] }), ge = /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      k5,
      {
        disabled: d,
        onClick: () => {
          var Se;
          if ((Se = I.current) == null || Se.setOpen(!1), r) {
            const [fe, De] = r(), le = B(fe) ?? void 0, ke = at(le, b), nt = at(De, b);
            ae(nt), W(ke), o([
              ea(ke),
              ea(nt)
            ]);
          } else
            ae(null), W(null), o([null, null]);
          V(void 0);
        },
        className: "ui-w-full",
        children: ue.t("public_pages_purchase.date_picker.clear")
      }
    ),
    /* @__PURE__ */ u.jsx(
      M5,
      {
        disabled: !N[0] || !N[1] || d,
        className: "ui-w-full",
        onClick: () => {
          var De;
          const [Se, fe] = N;
          Se && fe ? (W(Se), ae(fe), V(O), sx(Se), A4(fe), o([ea(Se), ea(fe)])) : o([null, null]), (De = I.current) == null || De.setOpen(!1);
        },
        children: ue.t("public_pages_purchase.date_picker.apply")
      }
    )
  ] }), Je = M ? (Se) => /* @__PURE__ */ u.jsxs(
    "div",
    {
      ...Se,
      className: z(
        "ui-flex ui-gap-4 sm:ui-gap-5 ui-flex-col sm:ui-flex-row ui-justify-center",
        Se.className
      ),
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-gap-4 ui-flex-col md:ui-mb-4", children: [
          /* @__PURE__ */ u.jsx("div", { className: "ui-flex ui-gap-5 ui-flex-col sm:ui-flex-row ui-justify-center", children: Se.children }),
          de
        ] }),
        /* @__PURE__ */ u.jsxs("div", { className: "ui-flex ui-justify-center ui-items-center ui-gap-5 ui-flex-col sm:ui-border-t md:ui-border-l md:ui-border-t-0 ui-border-transparent sm:ui-border-gray/30 sm:ui-p-2 ui-w-full md:ui-pl-5 md:ui-w-fit sm:ui-m-auto", children: [
          /* @__PURE__ */ u.jsxs("ul", { className: "ui-hidden sm:ui-flex sm:ui-flex-col ui-gap-5 ui-w-1/2 md:ui-w-full", children: [
            Object.values(Hr).map((fe) => /* @__PURE__ */ u.jsx("li", { children: /* @__PURE__ */ u.jsx(
              su,
              {
                className: "ui-w-full",
                disabled: !b || i || d,
                onClick: () => {
                  j(fe);
                },
                selected: fe === O,
                children: X_(fe)
              }
            ) }, fe)),
            (n || [rc(A, b)]).map(
              (fe) => /* @__PURE__ */ u.jsx("li", { children: /* @__PURE__ */ u.jsx(
                su,
                {
                  className: "ui-w-full",
                  disabled: i || d,
                  onClick: () => {
                    j(fe.slug);
                  },
                  selected: fe.slug === O,
                  children: ex(fe.slug)
                }
              ) }, fe.slug)
            )
          ] }),
          /* @__PURE__ */ u.jsx("div", { className: "ui-flex ui-justify-between ui-gap-3 ui-w-full sm:ui-w-1/2 md:ui-w-full", children: ge })
        ] })
      ]
    }
  ) : (Se) => /* @__PURE__ */ u.jsxs("div", { ...Se, children: [
    /* @__PURE__ */ u.jsx("div", { className: "ui-flex ui-gap-5 ui-flex-col sm:ui-flex-row ui-justify-center", children: Se.children }),
    de,
    /* @__PURE__ */ u.jsx("div", { className: "ui-flex ui-justify-center ui-gap-3 ui-w-full", children: ge })
  ] });
  return /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(
    ho,
    {
      ref: I,
      shouldCloseOnSelect: !1,
      selectsRange: !0,
      monthsShown: 2,
      selected: G,
      startDate: G,
      className: "ui-w-full",
      calendarClassName: "date-range-picker",
      popperClassName: "react-datepicker-bottom",
      onCalendarClose: () => {
        E([$, re]), j(Z);
      },
      calendarContainer: Je,
      endDate: R,
      minDate: Fi(A, b),
      maxDate: h,
      dateFormat: "MMMM d, yyyy",
      onChange: (Se) => {
        if (Se) {
          j(void 0);
          const [fe, De] = Se;
          E(_ ? nx(fe, De, _) : [fe, De]);
        }
      },
      locale: L,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ u.jsx(
        Jl,
        {
          buttonInputClassName: `ui-flex ui-group ui-justify-between ${a ? "" : "ui-min-w-[150px] lg:ui-min-w-[200px]"} ui-w-full ui-py-2.5 ui-px-4 ui-text-sm ui-font-medium ${t ? "ui-text-[#6b7c93]" : "ui-text-darkblue"} ui-border ${l ? "ui-border-danger" : "ui-border-gray/30"} ui-rounded-lg ui-bg-white focus:ui-outline-none focus:ui-border-blue ui-main-transition-colors`,
          wrapperButtonInputClassName: C,
          labelClassName: S,
          error: l,
          label: p,
          required: f,
          description: c,
          children: () => /* @__PURE__ */ u.jsx("span", { className: "ui-text-start ui-whitespace-nowrap", children: $ && re ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx("span", { className: "ui-hidden lg:ui-inline", children: `${new Intl.DateTimeFormat(
              g,
              {
                day: "2-digit",
                month: "long",
                year: "numeric"
              }
            ).format($)} - ${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "long",
              year: "numeric"
            }).format(re)}
              ` }),
            /* @__PURE__ */ u.jsx("span", { className: "ui-inline lg:ui-hidden", children: `${new Intl.DateTimeFormat(
              g,
              {
                day: "2-digit",
                month: "2-digit",
                year: "2-digit"
              }
            ).format($)} - ${new Intl.DateTimeFormat(g, {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit"
            }).format(re)}
              ` })
          ] }) : /* @__PURE__ */ u.jsx("span", { className: "ui-text-gray-300/70", children: s || ue.t("public_pages_purchase.date_picker.title_dates") }) })
        }
      ),
      renderCustomHeader: ({
        monthDate: Se,
        decreaseMonth: fe,
        increaseMonth: De,
        prevMonthButtonDisabled: le,
        nextMonthButtonDisabled: ke
      }) => /* @__PURE__ */ u.jsx(
        Ql,
        {
          date: Se,
          decreaseMonth: fe,
          increaseMonth: De,
          prevMonthButtonDisabled: le,
          nextMonthButtonDisabled: ke,
          intlLocale: g
        }
      ),
      ...x
    }
  ) });
}, BP = ({
  mode: e = As.DateSince,
  value: t,
  onChange: r,
  description: a,
  error: n,
  label: i,
  required: o,
  placeholder: s,
  maxDate: l,
  minDate: c,
  wrapperButtonInputClassName: d,
  disabled: p,
  timezone: f,
  intlLocale: h,
  createdAt: m,
  labelClassName: C,
  customProps: g
}) => {
  const [v, b] = te(
    t && at(t, f) || null
  ), [y, x] = te(), [S, _] = te(dr), M = m && f ? Fi(m, f) : null;
  return ql(h, _), he(() => {
    if (!f) return;
    const I = t ? at(t, f) : null;
    (!v || (I == null ? void 0 : I.toISOString()) !== v.toISOString()) && b(I);
  }, [t, f, v]), /* @__PURE__ */ u.jsx("div", { children: /* @__PURE__ */ u.jsx(
    ho,
    {
      selected: v,
      dateFormat: "MMMM d, yyyy",
      onChange: (I) => {
        I && ((v ? I.toDateString() === v.toDateString() : !1) ? (b(null), r(null)) : (b(I), e === As.DateTill && A4(I), r(ea(I))));
      },
      onChangeRaw: (I) => {
        y === I.target.ariaLabel ? (b(null), r(null)) : x(I.target.ariaLabel);
      },
      locale: S,
      minDate: c || M,
      maxDate: l,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperClassName: "react-datepicker-bottom",
      popperPlacement: "bottom",
      popperModifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10]
          }
        },
        {
          name: "preventOverflow",
          options: {
            rootBoundary: "viewport",
            tether: !1,
            altAxis: !0
          }
        }
      ],
      customInput: /* @__PURE__ */ u.jsx(
        Jl,
        {
          description: a,
          buttonInputClassName: `ui-flex ui-group ui-justify-between ui-min-w-[200px] ui-w-full ui-py-2.5 ui-px-4 ui-text-sm ui-font-medium tui-ext-darkblue ui-border ${p ? "ui-bg-gray-200/40" : "ui-bg-white focus:ui-border-blue"} ${n ? "ui-border-danger" : "ui-border-gray/30"} ui-rounded-lg ui-bg-white focus:ui-outline-none focus:ui-border-blue ui-main-transition-colors`,
          error: n,
          label: i,
          required: o,
          wrapperButtonInputClassName: d,
          labelClassName: C,
          children: (I) => /* @__PURE__ */ u.jsx("span", { className: "text-start", children: I || /* @__PURE__ */ u.jsx("span", { className: "text-gray-300/70", children: s }) })
        }
      ),
      renderCustomHeader: ({
        date: I,
        decreaseMonth: L,
        increaseMonth: D,
        prevMonthButtonDisabled: A,
        nextMonthButtonDisabled: B
      }) => /* @__PURE__ */ u.jsx(
        Ql,
        {
          date: I,
          decreaseMonth: L,
          increaseMonth: D,
          prevMonthButtonDisabled: A,
          nextMonthButtonDisabled: B,
          intlLocale: h
        }
      ),
      disabled: p,
      ...g
    }
  ) });
}, ic = ({ children: e, isLast: t, className: r, isLink: a }) => /* @__PURE__ */ u.jsx(
  "h2",
  {
    className: z(
      "ui-leading-8 ui-text-[18px] md:ui-text-[20px] lg:ui-text-[22px] md:ui-truncate ui-font-semibold ui-text-gray-300  ui-transition-colors",
      r,
      a && "hover:ui-text-darkblue",
      t && "ui-text-darkblue"
    ),
    children: e
  }
), jP = ({
  data: e,
  isFetching: t,
  classnameBreadcrumbsItem: r,
  CustomBreadcrumbLinkItem: a
}) => {
  const n = Q(null), i = Q(null);
  return ai(() => {
    n.current && i.current && n.current.scrollTo(i.current.offsetLeft, 0);
  }, [t]), /* @__PURE__ */ u.jsx(
    "ul",
    {
      ref: n,
      className: `
        ui-whitespace-nowrap md:ui-truncate
        ui-flex ui-gap-3 ui-items-center ui-flex-nowrap md:ui-flex-wrap lg:ui-flex-nowrap ui-gap-y-0
        ui-overflow-scroll md:ui-overflow:hidden
        ui-min-h-[42px] ui-w-full 
        ui-hide-scrollbar
      `,
      children: e.map((o, s) => {
        const l = s === e.length - 1;
        return /* @__PURE__ */ u.jsxs(
          "li",
          {
            className: "ui-flex ui-items-center ui-gap-3 ui-flex-nowrap md:ui-truncate",
            ref: l ? i : void 0,
            children: [
              s !== 0 && /* @__PURE__ */ u.jsx(r0, { height: "14", width: "10", fill: "#6B7C93" }),
              !o.isStatic && t ? /* @__PURE__ */ u.jsx(a1, { small: !0, type: "dark" }) : o.href ? /* @__PURE__ */ u.jsx(ic, { isLast: l, className: z(r), isLink: !0, children: a ? /* @__PURE__ */ u.jsx(a, { href: o.href, children: o.caption }) : /* @__PURE__ */ u.jsx("a", { href: o.href, rel: "noreferrer", className: "ui-outline-none", children: o.caption }) }) : /* @__PURE__ */ u.jsx(ic, { className: z(r), isLast: l, children: o.caption })
            ]
          },
          s
        );
      })
    }
  );
};
export {
  qu as $,
  bP as A,
  Iv as B,
  eP as C,
  k5 as D,
  lu as E,
  wa as F,
  A5 as G,
  Il as H,
  Ll as I,
  E5 as J,
  I5 as K,
  a1 as L,
  fx as M,
  gP as N,
  L5 as O,
  tP as P,
  R5 as Q,
  _P as R,
  CP as S,
  wP as T,
  Gv as U,
  Vv as V,
  PP as W,
  xl as X,
  TP as Y,
  D_ as Z,
  T_ as _,
  Uf as a,
  $f as a$,
  E_ as a0,
  AP as a1,
  As as a2,
  Hr as a3,
  ua as a4,
  NP as a5,
  OP as a6,
  BP as a7,
  RP as a8,
  sx as a9,
  dP as aA,
  Pl as aB,
  pP as aC,
  fP as aD,
  Mt as aE,
  PC as aF,
  hP as aG,
  TC as aH,
  hx as aI,
  mx as aJ,
  Zf as aK,
  a0 as aL,
  gx as aM,
  Yf as aN,
  r0 as aO,
  Cx as aP,
  vx as aQ,
  bx as aR,
  yx as aS,
  wx as aT,
  Sx as aU,
  Wf as aV,
  _x as aW,
  xx as aX,
  Mx as aY,
  kx as aZ,
  Px as a_,
  A4 as aa,
  ic as ab,
  jP as ac,
  mo as ad,
  EP as ae,
  DP as af,
  IP as ag,
  LP as ah,
  s0 as ai,
  l0 as aj,
  gh as ak,
  qe as al,
  rP as am,
  iP as an,
  ce as ao,
  oP as ap,
  hs as aq,
  Cg as ar,
  Pn as as,
  sP as at,
  m0 as au,
  lP as av,
  ha as aw,
  uP as ax,
  vg as ay,
  cP as az,
  ya as b,
  MM as b$,
  Tx as b0,
  Ex as b1,
  Jf as b2,
  Dx as b3,
  Ix as b4,
  Lx as b5,
  Qf as b6,
  Ax as b7,
  qf as b8,
  Xf as b9,
  ah as bA,
  nM as bB,
  aM as bC,
  rM as bD,
  iM as bE,
  oM as bF,
  sM as bG,
  lM as bH,
  uM as bI,
  cM as bJ,
  dM as bK,
  pM as bL,
  fM as bM,
  hM as bN,
  rh as bO,
  mM as bP,
  gM as bQ,
  CM as bR,
  vM as bS,
  ih as bT,
  bM as bU,
  yM as bV,
  wM as bW,
  oh as bX,
  SM as bY,
  _M as bZ,
  xM as b_,
  Nx as ba,
  eh as bb,
  Rx as bc,
  Ox as bd,
  Bx as be,
  th as bf,
  _i as bg,
  jx as bh,
  Hx as bi,
  Fx as bj,
  Gx as bk,
  Vx as bl,
  Kx as bm,
  zx as bn,
  Ux as bo,
  Zx as bp,
  Yx as bq,
  Wx as br,
  $x as bs,
  Jx as bt,
  Qx as bu,
  nh as bv,
  qx as bw,
  Xx as bx,
  eM as by,
  tM as bz,
  nP as c,
  Pk as c$,
  sh as c0,
  kM as c1,
  PM as c2,
  TM as c3,
  EM as c4,
  DM as c5,
  IM as c6,
  LM as c7,
  AM as c8,
  NM as c9,
  ak as cA,
  rk as cB,
  ik as cC,
  i0 as cD,
  ok as cE,
  ph as cF,
  sk as cG,
  lk as cH,
  uk as cI,
  ck as cJ,
  dk as cK,
  pk as cL,
  fk as cM,
  hk as cN,
  mk as cO,
  gk as cP,
  fh as cQ,
  Ck as cR,
  vk as cS,
  bk as cT,
  yk as cU,
  wk as cV,
  Sk as cW,
  _k as cX,
  xk as cY,
  Mk as cZ,
  kk as c_,
  RM as ca,
  OM as cb,
  lh as cc,
  BM as cd,
  jM as ce,
  HM as cf,
  FM as cg,
  GM as ch,
  VM as ci,
  KM as cj,
  zM as ck,
  UM as cl,
  ZM as cm,
  YM as cn,
  WM as co,
  uh as cp,
  $M as cq,
  ch as cr,
  JM as cs,
  QM as ct,
  qM as cu,
  XM as cv,
  ek as cw,
  tk as cx,
  nk as cy,
  dh as cz,
  aP as d,
  Tk as d0,
  Ek as d1,
  Dk as d2,
  Ik as d3,
  Lk as d4,
  Ak as d5,
  Nk as d6,
  Rk as d7,
  Ok as d8,
  Bk as d9,
  T5 as dA,
  jk as da,
  Hk as db,
  Fk as dc,
  Gk as dd,
  Vk as de,
  Kk as df,
  zk as dg,
  Uk as dh,
  Zk as di,
  Yk as dj,
  Wk as dk,
  $k as dl,
  Jk as dm,
  hh as dn,
  Qk as dp,
  qk as dq,
  Xk as dr,
  ps as ds,
  Fi as dt,
  Bo as du,
  at as dv,
  ea as dw,
  iu as dx,
  Dv as dy,
  z as dz,
  mP as e,
  za as f,
  S1 as g,
  px as h,
  vP as i,
  su as j,
  M5 as k,
  Ov as l,
  Rv as m,
  Lv as n,
  yP as o,
  jv as p,
  We as q,
  xP as r,
  MP as s,
  kP as t,
  SP as u,
  O5 as v,
  j5 as w,
  N5 as x,
  D5 as y,
  B5 as z
};
